// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328c76f%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23d8d6de%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23de4827%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23de4827%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 9.5 7.5%27%3E%3Cpolyline points=%270.75 4.35 4.18 6.75 8.75 0.75%27 style=%27fill:none;stroke:%23fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-minus%27%3E%3Cline x1=%275%27 y1=%2712%27 x2=%2719%27 y2=%2712%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2830, 29, 43, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28253, 254, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%23fdfeff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"%3e%3cpolyline points=\"15 18 9 12 15 6\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%23fdfeff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"%3e%3cpolyline points=\"9 18 15 12 9 6\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23d8d6de%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fdfeff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fdfeff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-up%27%3E%3Cpolyline points=%2718 15 12 9 6 15%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fdfeff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fdfeff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e6b7b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e6b7b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-circle%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%2710%27%3E%3C/circle%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e6b7b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e6b7b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-up%27%3E%3Cpolyline points=%2718 15 12 9 6 15%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236e6b7b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b9b9c3%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b9b9c3%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2300a0dd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2300a0dd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23232323%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fdfeff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-x%27%3E%3Cline x1=%2718%27 y1=%276%27 x2=%276%27 y2=%2718%27%3E%3C/line%3E%3Cline x1=%276%27 y1=%276%27 x2=%2718%27 y2=%2718%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2300a0dd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-x%27%3E%3Cline x1=%2718%27 y1=%276%27 x2=%276%27 y2=%2718%27%3E%3C/line%3E%3Cline x1=%276%27 y1=%276%27 x2=%2718%27 y2=%2718%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b4b7bd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%235e5873%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-up%27%3E%3Cpolyline points=%2718 15 12 9 6 15%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%235e5873%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b4b7bd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b4b7bd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-up%27%3E%3Cpolyline points=%2718 15 12 9 6 15%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b4b7bd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23676d7d%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-left%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23676d7d%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b4b7bd%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-circle%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%2710%27%3E%3C/circle%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23676d7d%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v4.5.2 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #00cfe8;
  --indigo: #6610f2;
  --purple: #9b67f0;
  --pink: #e83e8c;
  --red: #de4827;
  --orange: #d56729;
  --yellow: #ffc107;
  --green: #28c76f;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fdfeff;
  --gray: #b8c2cc;
  --gray-dark: #1e1e1e;
  --primary: #00a0dd;
  --secondary: #de4827;
  --success: #28c76f;
  --info: #222d69;
  --warning: #d56729;
  --danger: #de4827;
  --light: #f6f6f6;
  --dark: #232323;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: "Montserrat", Helvetica, Arial, serif;
  --font-family-monospace: "Montserrat", Helvetica, Arial, serif;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(30, 29, 43, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  text-align: left;
  background-color: #f8f8f8;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.4375rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 500;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 600;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #00a0dd;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #008ec4;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  color: #b9b9c3;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.25rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.4375rem;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: #5e5873;
}

h1, .h1 {
  font-size: 1.75rem;
}

h2, .h2 {
  font-size: 1.49975rem;
}

h3, .h3 {
  font-size: 1.3125rem;
}

h4, .h4 {
  font-size: 1.12525rem;
}

h5, .h5 {
  font-size: 0.93625rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

.lead {
  font-size: 0.9975rem;
  font-weight: 400;
}

.display-1 {
  font-size: 6rem;
  font-weight: 400;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 400;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 400;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 400;
  line-height: 1.2;
}

hr {
  margin-top: 0.875rem;
  margin-bottom: 0.875rem;
  border: 0;
  border-top: 1px solid #ebe9f1;
}

small,
.small {
  font-size: 0.75rem;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 0.875rem;
  font-size: 1.09375rem;
}

.blockquote-footer {
  display: block;
  font-size: 0.75rem;
  color: #b9b9c3;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f8f8;
  border: 1px solid #dae1e7;
  border-radius: 0.3125rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.4375rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #b8c2cc;
}

code {
  font-size: 90%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 90%;
  color: #fdfeff;
  background-color: #eee;
  border-radius: 0.21875rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 500;
}

pre {
  display: block;
  font-size: 90%;
  color: #2a2e30;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 0.875rem;
  padding-left: 0.875rem;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.container-xl, .container-lg, .container-md, .container-sm, .container {
  max-width: 1440px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.875rem;
  margin-left: -0.875rem;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 0.875rem;
  padding-left: 0.875rem;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-sm-first {
    order: -1;
  }

  .order-sm-last {
    order: 13;
  }

  .order-sm-0 {
    order: 0;
  }

  .order-sm-1 {
    order: 1;
  }

  .order-sm-2 {
    order: 2;
  }

  .order-sm-3 {
    order: 3;
  }

  .order-sm-4 {
    order: 4;
  }

  .order-sm-5 {
    order: 5;
  }

  .order-sm-6 {
    order: 6;
  }

  .order-sm-7 {
    order: 7;
  }

  .order-sm-8 {
    order: 8;
  }

  .order-sm-9 {
    order: 9;
  }

  .order-sm-10 {
    order: 10;
  }

  .order-sm-11 {
    order: 11;
  }

  .order-sm-12 {
    order: 12;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }

  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }

  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }

  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }

  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-md-first {
    order: -1;
  }

  .order-md-last {
    order: 13;
  }

  .order-md-0 {
    order: 0;
  }

  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }

  .order-md-3 {
    order: 3;
  }

  .order-md-4 {
    order: 4;
  }

  .order-md-5 {
    order: 5;
  }

  .order-md-6 {
    order: 6;
  }

  .order-md-7 {
    order: 7;
  }

  .order-md-8 {
    order: 8;
  }

  .order-md-9 {
    order: 9;
  }

  .order-md-10 {
    order: 10;
  }

  .order-md-11 {
    order: 11;
  }

  .order-md-12 {
    order: 12;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.3333333333%;
  }

  .offset-md-2 {
    margin-left: 16.6666666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.3333333333%;
  }

  .offset-md-5 {
    margin-left: 41.6666666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.3333333333%;
  }

  .offset-md-8 {
    margin-left: 66.6666666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.3333333333%;
  }

  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-lg-first {
    order: -1;
  }

  .order-lg-last {
    order: 13;
  }

  .order-lg-0 {
    order: 0;
  }

  .order-lg-1 {
    order: 1;
  }

  .order-lg-2 {
    order: 2;
  }

  .order-lg-3 {
    order: 3;
  }

  .order-lg-4 {
    order: 4;
  }

  .order-lg-5 {
    order: 5;
  }

  .order-lg-6 {
    order: 6;
  }

  .order-lg-7 {
    order: 7;
  }

  .order-lg-8 {
    order: 8;
  }

  .order-lg-9 {
    order: 9;
  }

  .order-lg-10 {
    order: 10;
  }

  .order-lg-11 {
    order: 11;
  }

  .order-lg-12 {
    order: 12;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }

  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }

  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }

  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }

  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }

  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }

  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }

  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }

  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xl-first {
    order: -1;
  }

  .order-xl-last {
    order: 13;
  }

  .order-xl-0 {
    order: 0;
  }

  .order-xl-1 {
    order: 1;
  }

  .order-xl-2 {
    order: 2;
  }

  .order-xl-3 {
    order: 3;
  }

  .order-xl-4 {
    order: 4;
  }

  .order-xl-5 {
    order: 5;
  }

  .order-xl-6 {
    order: 6;
  }

  .order-xl-7 {
    order: 7;
  }

  .order-xl-8 {
    order: 8;
  }

  .order-xl-9 {
    order: 9;
  }

  .order-xl-10 {
    order: 10;
  }

  .order-xl-11 {
    order: 11;
  }

  .order-xl-12 {
    order: 12;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }

  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }

  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }

  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }

  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 0.875rem;
  color: #6e6b7b;
}
.table th,
.table td {
  padding: 0.625rem;
  vertical-align: top;
  border-top: 1px solid #ebe9f1;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #ebe9f1;
}
.table tbody + tbody {
  border-top: 2px solid #ebe9f1;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #ebe9f1;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #ebe9f1;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fafafc;
}

.table-hover tbody tr:hover {
  color: #6e6b7b;
  background-color: #f6f6f9;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #b6e4f5;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #79cded;
}

.table-hover .table-primary:hover {
  background-color: #a0dcf2;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #a0dcf2;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #f4cbc3;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #ed9f8f;
}

.table-hover .table-secondary:hover {
  background-color: #f0b8ad;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #f0b8ad;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c1efd7;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8ee1b4;
}

.table-hover .table-success:hover {
  background-color: #adeaca;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #adeaca;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #c0c3d5;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #8b91b1;
}

.table-hover .table-info:hover {
  background-color: #b1b4cb;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #b1b4cb;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #f2d4c3;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #e8af90;
}

.table-hover .table-warning:hover {
  background-color: #edc5ae;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #edc5ae;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f4cbc3;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #ed9f8f;
}

.table-hover .table-danger:hover {
  background-color: #f0b8ad;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f0b8ad;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fbfcfc;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #f9fafa;
}

.table-hover .table-light:hover {
  background-color: #ecf1f1;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ecf1f1;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c0c1c1;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #8c8c8d;
}

.table-hover .table-dark:hover {
  background-color: #b3b4b4;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b3b4b4;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #f6f6f9;
}

.table-hover .table-active:hover {
  background-color: #e7e7ef;
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: #e7e7ef;
}

.table .thead-dark th {
  color: #fdfeff;
  background-color: #232323;
  border-color: #404040;
}
.table .thead-light th {
  color: #5e5873;
  background-color: #f3f2f7;
  border-color: #ebe9f1;
}

.table-dark {
  color: #fdfeff;
  background-color: #232323;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #404040;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(253, 254, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fdfeff;
  background-color: rgba(253, 254, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: 2.714rem;
  padding: 0.438rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fdfeff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.3125rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #6e6b7b;
}
.form-control:focus {
  color: #6e6b7b;
  background-color: #fdfeff;
  border-color: #00a0dd;
  outline: 0;
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.form-control::placeholder {
  color: #b9b9c3;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #efefef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:focus::-ms-value {
  color: #6e6b7b;
  background-color: #fdfeff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.438rem + 1px);
  padding-bottom: calc(0.438rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.45;
}

.col-form-label-lg {
  padding-top: calc(0.75rem + 1px);
  padding-bottom: calc(0.75rem + 1px);
  font-size: 1.143rem;
  line-height: 1.25;
}

.col-form-label-sm {
  padding-top: calc(0.188rem + 1px);
  padding-bottom: calc(0.188rem + 1px);
  font-size: 0.857rem;
  line-height: 1;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.438rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: 2.142rem;
  padding: 0.188rem 0.857rem;
  font-size: 0.857rem;
  line-height: 1;
  border-radius: 0.3125rem;
}

.form-control-lg {
  height: 3.2857rem;
  padding: 0.75rem 1.143rem;
  font-size: 1.143rem;
  line-height: 1.25;
  border-radius: 0.3125rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #b9b9c3;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #28c76f;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.35rem 0.678125rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  line-height: 1.45;
  color: #fdfeff;
  background-color: #28c76f;
  border-radius: 0.3125rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28c76f;
  padding-right: calc(1.45em + 0.876rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.3625em + 0.219rem) center;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28c76f;
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.45em + 0.876rem);
  background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28c76f;
  padding-right: calc(0.75em + 2.657rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 1rem center/10px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fdfeff no-repeat center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28c76f;
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28c76f;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28c76f;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28c76f;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #48da89;
  background-color: #48da89;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28c76f;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28c76f;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28c76f;
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #de4827;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.35rem 0.678125rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  line-height: 1.45;
  color: #fdfeff;
  background-color: #de4827;
  border-radius: 0.3125rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #de4827;
  padding-right: calc(1.45em + 0.876rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.3625em + 0.219rem) center;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #de4827;
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.45em + 0.876rem);
  background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #de4827;
  padding-right: calc(0.75em + 2.657rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 1rem center/10px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fdfeff no-repeat center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #de4827;
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #de4827;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #de4827;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #de4827;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e56d53;
  background-color: #e56d53;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #de4827;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #de4827;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #de4827;
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
.form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #6e6b7b;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.6875rem 1.3125rem;
  font-size: 0.875rem;
  line-height: 1;
  border-radius: 0.313rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #6e6b7b;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fdfeff;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.btn-primary:hover {
  color: #fdfeff;
  background-color: #0084b7;
  border-color: #007baa;
}
.btn-primary:focus, .btn-primary.focus {
  color: #fdfeff;
  background-color: #0084b7;
  border-color: #007baa;
  box-shadow: 0 0 0 0.2rem rgba(38, 174, 226, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fdfeff;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fdfeff;
  background-color: #007baa;
  border-color: #00729d;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 174, 226, 0.5);
}

.btn-secondary {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-secondary:hover {
  color: #fdfeff;
  background-color: #c13b1e;
  border-color: #b6381c;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fdfeff;
  background-color: #c13b1e;
  border-color: #b6381c;
  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fdfeff;
  background-color: #b6381c;
  border-color: #ab341a;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);
}

.btn-success {
  color: #fdfeff;
  background-color: #28c76f;
  border-color: #28c76f;
}
.btn-success:hover {
  color: #fdfeff;
  background-color: #22a75d;
  border-color: #1f9d57;
}
.btn-success:focus, .btn-success.focus {
  color: #fdfeff;
  background-color: #22a75d;
  border-color: #1f9d57;
  box-shadow: 0 0 0 0.2rem rgba(72, 207, 133, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fdfeff;
  background-color: #28c76f;
  border-color: #28c76f;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fdfeff;
  background-color: #1f9d57;
  border-color: #1d9251;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 207, 133, 0.5);
}

.btn-info {
  color: #fdfeff;
  background-color: #222d69;
  border-color: #222d69;
}
.btn-info:hover {
  color: #fdfeff;
  background-color: #19214c;
  border-color: #161c42;
}
.btn-info:focus, .btn-info.focus {
  color: #fdfeff;
  background-color: #19214c;
  border-color: #161c42;
  box-shadow: 0 0 0 0.2rem rgba(67, 76, 128, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fdfeff;
  background-color: #222d69;
  border-color: #222d69;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fdfeff;
  background-color: #161c42;
  border-color: #121839;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(67, 76, 128, 0.5);
}

.btn-warning {
  color: #fdfeff;
  background-color: #d56729;
  border-color: #d56729;
}
.btn-warning:hover {
  color: #fdfeff;
  background-color: #b55723;
  border-color: #aa5221;
}
.btn-warning:focus, .btn-warning.focus {
  color: #fdfeff;
  background-color: #b55723;
  border-color: #aa5221;
  box-shadow: 0 0 0 0.2rem rgba(219, 126, 73, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fdfeff;
  background-color: #d56729;
  border-color: #d56729;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fdfeff;
  background-color: #aa5221;
  border-color: #a04d1f;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(219, 126, 73, 0.5);
}

.btn-danger {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-danger:hover {
  color: #fdfeff;
  background-color: #c13b1e;
  border-color: #b6381c;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fdfeff;
  background-color: #c13b1e;
  border-color: #b6381c;
  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fdfeff;
  background-color: #b6381c;
  border-color: #ab341a;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);
}

.btn-light {
  color: #2a2e30;
  background-color: #f6f6f6;
  border-color: #f6f6f6;
}
.btn-light:hover {
  color: #2a2e30;
  background-color: #e3e3e3;
  border-color: #dddddd;
}
.btn-light:focus, .btn-light.focus {
  color: #2a2e30;
  background-color: #e3e3e3;
  border-color: #dddddd;
  box-shadow: 0 0 0 0.2rem rgba(215, 216, 216, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #2a2e30;
  background-color: #f6f6f6;
  border-color: #f6f6f6;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #2a2e30;
  background-color: #dddddd;
  border-color: #d6d6d6;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(215, 216, 216, 0.5);
}

.btn-dark {
  color: #fdfeff;
  background-color: #232323;
  border-color: #232323;
}
.btn-dark:hover {
  color: #fdfeff;
  background-color: #101010;
  border-color: #0a0a0a;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fdfeff;
  background-color: #101010;
  border-color: #0a0a0a;
  box-shadow: 0 0 0 0.2rem rgba(68, 68, 68, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fdfeff;
  background-color: #232323;
  border-color: #232323;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fdfeff;
  background-color: #0a0a0a;
  border-color: #030303;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(68, 68, 68, 0.5);
}

.btn-outline-primary {
  color: #00a0dd;
  border-color: #00a0dd;
}
.btn-outline-primary:hover {
  color: #fdfeff;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #00a0dd;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fdfeff;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);
}

.btn-outline-secondary {
  color: #de4827;
  border-color: #de4827;
}
.btn-outline-secondary:hover {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #de4827;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}

.btn-outline-success {
  color: #28c76f;
  border-color: #28c76f;
}
.btn-outline-success:hover {
  color: #fdfeff;
  background-color: #28c76f;
  border-color: #28c76f;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #28c76f;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fdfeff;
  background-color: #28c76f;
  border-color: #28c76f;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);
}

.btn-outline-info {
  color: #222d69;
  border-color: #222d69;
}
.btn-outline-info:hover {
  color: #fdfeff;
  background-color: #222d69;
  border-color: #222d69;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #222d69;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fdfeff;
  background-color: #222d69;
  border-color: #222d69;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);
}

.btn-outline-warning {
  color: #d56729;
  border-color: #d56729;
}
.btn-outline-warning:hover {
  color: #fdfeff;
  background-color: #d56729;
  border-color: #d56729;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #d56729;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fdfeff;
  background-color: #d56729;
  border-color: #d56729;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);
}

.btn-outline-danger {
  color: #de4827;
  border-color: #de4827;
}
.btn-outline-danger:hover {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #de4827;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fdfeff;
  background-color: #de4827;
  border-color: #de4827;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}

.btn-outline-light {
  color: #f6f6f6;
  border-color: #f6f6f6;
}
.btn-outline-light:hover {
  color: #2a2e30;
  background-color: #f6f6f6;
  border-color: #f6f6f6;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f6f6f6;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #2a2e30;
  background-color: #f6f6f6;
  border-color: #f6f6f6;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);
}

.btn-outline-dark {
  color: #232323;
  border-color: #232323;
}
.btn-outline-dark:hover {
  color: #fdfeff;
  background-color: #232323;
  border-color: #232323;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #232323;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fdfeff;
  background-color: #232323;
  border-color: #232323;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #00a0dd;
  text-decoration: none;
}
.btn-link:hover {
  color: #008ec4;
  text-decoration: none;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #b8c2cc;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.7rem 1.75rem;
  font-size: 1.09375rem;
  line-height: 1.25;
  border-radius: 0.313rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.425rem 0.875rem;
  font-size: 0.7875rem;
  line-height: 1;
  border-radius: 0.313rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0 0 0;
  font-size: 1rem;
  color: #6e6b7b;
  text-align: left;
  list-style: none;
  background-color: #fdfeff;
  background-clip: padding-box;
  border: 1px solid rgba(30, 29, 43, 0.05);
  border-radius: 0.358rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.4375rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(30, 29, 43, 0.08);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.65rem 1.28rem;
  clear: both;
  font-weight: 400;
  color: #6e6b7b;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #00a0dd;
  text-decoration: none;
  background-color: rgba(0, 160, 221, 0.12);
}
.dropdown-item.active, .dropdown-item:active {
  color: #fdfeff;
  text-decoration: none;
  background-color: #00a0dd;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #b9b9c3;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.28rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #5e5873;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.65rem 1.28rem;
  color: #6e6b7b;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.984375rem;
  padding-left: 0.984375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.65625rem;
  padding-left: 0.65625rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.3125rem;
  padding-left: 1.3125rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.438rem 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  text-align: center;
  white-space: nowrap;
  background-color: white;
  border: 1px solid #d8d6de;
  border-radius: 0.3125rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: 3.2857rem;
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.75rem 1.143rem;
  font-size: 1.143rem;
  line-height: 1.25;
  border-radius: 0.3125rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: 2.142rem;
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.188rem 0.857rem;
  font-size: 0.857rem;
  line-height: 1;
  border-radius: 0.3125rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 2rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.26875rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.134375rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fdfeff;
  border-color: #00a0dd;
  background-color: #00a0dd;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #00a0dd;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fdfeff;
  background-color: #91e1ff;
  border-color: #91e1ff;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #b8c2cc;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #efefef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.134375rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fdfeff;
  border: #d8d6de solid 1px;
}
.custom-control-label::after {
  position: absolute;
  top: 0.134375rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 3px;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #00a0dd;
  background-color: #00a0dd;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 160, 221, 0.65);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 160, 221, 0.65);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 160, 221, 0.65);
}

.custom-switch {
  padding-left: 3.125rem;
}
.custom-switch .custom-control-label::before {
  left: -3.125rem;
  width: 2.625rem;
  pointer-events: all;
  border-radius: 0.875rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.134375rem + 2px);
  left: calc(-3.125rem + 2px);
  width: 0.875rem;
  height: 0.875rem;
  background-color: #d8d6de;
  border-radius: 0.875rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fdfeff;
  transform: translateX(1.625rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 160, 221, 0.65);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: 2.714rem;
  padding: 0.438rem 2rem 0.438rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  vertical-align: middle;
  background: #fdfeff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 1rem center/10px 10px;
  border: 1px solid #d8d6de;
  border-radius: 0.3125rem;
  appearance: none;
}
.custom-select:focus {
  border-color: #00a0dd;
  outline: 0;
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-select:focus::-ms-value {
  color: #6e6b7b;
  background-color: #fdfeff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 1rem;
  background-image: none;
}
.custom-select:disabled {
  color: #b8c2cc;
  background-color: #efefef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #6e6b7b;
}

.custom-select-sm {
  height: 2.142rem;
  padding-top: 0.188rem;
  padding-bottom: 0.188rem;
  padding-left: 0.857rem;
  font-size: 0.857rem;
}

.custom-select-lg {
  height: 3.2857rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.143rem;
  font-size: 1.143rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 2.714rem;
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 2.714rem;
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #00a0dd;
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #efefef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: 2.714rem;
  padding: 0.438rem 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fdfeff;
  border: 1px solid #d8d6de;
  border-radius: 0.3125rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: 2.714rem;
  padding: 0.438rem 1rem;
  line-height: 1.45;
  color: #6e6b7b;
  content: "Browse";
  background-color: white;
  border-left: inherit;
  border-radius: 0 0.3125rem 0.3125rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: none;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #00a0dd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #91e1ff;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dae1e7;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #00a0dd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #91e1ff;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dae1e7;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #00a0dd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #91e1ff;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dae1e7;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dae1e7;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
.custom-file-label,
.custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.358rem 0.5rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #b9b9c3;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0 solid #dae1e7;
}
.nav-tabs .nav-item {
  margin-bottom: 0;
}
.nav-tabs .nav-link {
  border: 0 solid transparent;
  border-top-left-radius: 0.25;
  border-top-right-radius: 0.25;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #ededed #ededed #dae1e7;
}
.nav-tabs .nav-link.disabled {
  color: #b9b9c3;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #00a0dd;
  background-color: transparent;
  border-color: #dae1e7 #dae1e7 transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.313rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fdfeff;
  background-color: #00a0dd;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.4375rem 0.875rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl,
.navbar .container-xxl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: -0.457625rem;
  padding-bottom: -0.457625rem;
  margin-right: 0.875rem;
  font-size: 2rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.358rem;
  padding-bottom: 0.358rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 2rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.313rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl,
.navbar-expand-sm > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
.navbar-expand-sm > .container-fluid,
.navbar-expand-sm > .container-sm,
.navbar-expand-sm > .container-md,
.navbar-expand-sm > .container-lg,
.navbar-expand-sm > .container-xl,
.navbar-expand-sm > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl,
.navbar-expand-md > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
.navbar-expand-md > .container-fluid,
.navbar-expand-md > .container-sm,
.navbar-expand-md > .container-md,
.navbar-expand-md > .container-lg,
.navbar-expand-md > .container-xl,
.navbar-expand-md > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl,
.navbar-expand-lg > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
.navbar-expand-lg > .container-fluid,
.navbar-expand-lg > .container-sm,
.navbar-expand-lg > .container-md,
.navbar-expand-lg > .container-lg,
.navbar-expand-lg > .container-xl,
.navbar-expand-lg > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl,
.navbar-expand-xl > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
.navbar-expand-xl > .container-fluid,
.navbar-expand-xl > .container-sm,
.navbar-expand-xl > .container-md,
.navbar-expand-xl > .container-lg,
.navbar-expand-xl > .container-xl,
.navbar-expand-xl > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl,
.navbar-expand > .container-xxl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl,
.navbar-expand > .container-xxl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(30, 29, 43, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(30, 29, 43, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(30, 29, 43, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(30, 29, 43, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(30, 29, 43, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(30, 29, 43, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(30, 29, 43, 0.5);
  border-color: rgba(30, 29, 43, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-light .navbar-text {
  color: rgba(30, 29, 43, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(30, 29, 43, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(30, 29, 43, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fdfeff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fdfeff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(253, 254, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(253, 254, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(253, 254, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fdfeff;
}
.navbar-dark .navbar-toggler {
  color: rgba(253, 254, 255, 0.5);
  border-color: rgba(253, 254, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-dark .navbar-text {
  color: rgba(253, 254, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fdfeff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fdfeff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fdfeff;
  background-clip: border-box;
  border: 1px solid rgba(30, 29, 43, 0.125);
  border-radius: 0.428rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.428rem - 1px);
  border-top-right-radius: calc(0.428rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.428rem - 1px);
  border-bottom-left-radius: calc(0.428rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.5rem;
}

.card-subtitle {
  margin-top: -0.75rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.5rem 1.5rem;
  margin-bottom: 0;
  background-color: rgba(30, 29, 43, 0.03);
  border-bottom: 1px solid rgba(30, 29, 43, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.428rem - 1px) calc(0.428rem - 1px) 0 0;
}

.card-footer {
  padding: 1.5rem 1.5rem;
  background-color: rgba(30, 29, 43, 0.03);
  border-top: 1px solid rgba(30, 29, 43, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.428rem - 1px) calc(0.428rem - 1px);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.5rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.428rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.428rem - 1px);
  border-top-right-radius: calc(0.428rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.428rem - 1px);
  border-bottom-left-radius: calc(0.428rem - 1px);
}

.card-deck .card {
  margin-bottom: 0.875rem;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -0.875rem;
    margin-left: -0.875rem;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 0.875rem;
    margin-bottom: 0;
    margin-left: 0.875rem;
  }
}

.card-group > .card {
  margin-bottom: 0.875rem;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.5rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0;
}

.breadcrumb-item {
  display: flex;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.525rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.525rem;
  color: #6e6b7b;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6e6b7b;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.3125rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.85rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #6e6b7b;
  background-color: #f3f2f7;
  border: 1px solid #dae1e7;
}
.page-link:hover {
  z-index: 2;
  color: #00a0dd;
  text-decoration: none;
  background-color: #f3f2f7;
  border-color: #dae1e7;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #00a0dd;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.page-item.disabled .page-link {
  color: #b9b9c3;
  pointer-events: none;
  cursor: auto;
  background-color: #f3f2f7;
  border-color: #dae1e7;
}

.pagination-lg .page-link {
  padding: 0.5575rem 1rem;
  font-size: 2rem;
  line-height: 1.25;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.525rem;
  border-bottom-left-radius: 0.525rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.525rem;
  border-bottom-right-radius: 0.525rem;
}

.pagination-sm .page-link {
  padding: 0.443rem 0.745rem;
  font-size: 1rem;
  line-height: 1;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.21875rem;
  border-bottom-left-radius: 0.21875rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.21875rem;
  border-bottom-right-radius: 0.21875rem;
}

.badge {
  display: inline-block;
  padding: 0.2625rem 0.4375rem;
  font-size: 85%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.3125rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.4375rem;
  padding-left: 0.4375rem;
  border-radius: 10rem;
}

.badge-primary {
  color: #fdfeff;
  background-color: #00a0dd;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fdfeff;
  background-color: #007baa;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);
}

.badge-secondary {
  color: #fdfeff;
  background-color: #de4827;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fdfeff;
  background-color: #b6381c;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}

.badge-success {
  color: #fdfeff;
  background-color: #28c76f;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fdfeff;
  background-color: #1f9d57;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);
}

.badge-info {
  color: #fdfeff;
  background-color: #222d69;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fdfeff;
  background-color: #161c42;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);
}

.badge-warning {
  color: #fdfeff;
  background-color: #d56729;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #fdfeff;
  background-color: #aa5221;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);
}

.badge-danger {
  color: #fdfeff;
  background-color: #de4827;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fdfeff;
  background-color: #b6381c;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);
}

.badge-light {
  color: #2a2e30;
  background-color: #f6f6f6;
}
a.badge-light:hover, a.badge-light:focus {
  color: #2a2e30;
  background-color: #dddddd;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);
}

.badge-dark {
  color: #fdfeff;
  background-color: #232323;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fdfeff;
  background-color: #0a0a0a;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #ededed;
  border-radius: 0.525rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.71rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.358rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.71rem 1rem;
  color: inherit;
}

.alert-primary {
  color: #0e6188;
  background-color: #caebf8;
  border-color: #b6e4f5;
}
.alert-primary hr {
  border-top-color: #a0dcf2;
}
.alert-primary .alert-link {
  color: #09405a;
}

.alert-secondary {
  color: #823329;
  background-color: #f7dad4;
  border-color: #f4cbc3;
}
.alert-secondary hr {
  border-top-color: #f0b8ad;
}
.alert-secondary .alert-link {
  color: #5b241d;
}

.alert-success {
  color: #23754e;
  background-color: #d2f3e2;
  border-color: #c1efd7;
}
.alert-success hr {
  border-top-color: #adeaca;
}
.alert-success .alert-link {
  color: #174e34;
}

.alert-info {
  color: #20254b;
  background-color: #d1d4e1;
  border-color: #c0c3d5;
}
.alert-info hr {
  border-top-color: #b1b4cb;
}
.alert-info .alert-link {
  color: #111327;
}

.alert-warning {
  color: #7d432a;
  background-color: #f5e0d4;
  border-color: #f2d4c3;
}
.alert-warning hr {
  border-top-color: #edc5ae;
}
.alert-warning .alert-link {
  color: #572f1d;
}

.alert-danger {
  color: #823329;
  background-color: #f7dad4;
  border-color: #f4cbc3;
}
.alert-danger hr {
  border-top-color: #f0b8ad;
}
.alert-danger .alert-link {
  color: #5b241d;
}

.alert-light {
  color: #8e8e95;
  background-color: #fcfcfd;
  border-color: #fbfcfc;
}
.alert-light hr {
  border-top-color: #ecf1f1;
}
.alert-light .alert-link {
  color: #74747c;
}

.alert-dark {
  color: #212027;
  background-color: #d1d2d3;
  border-color: #c0c1c1;
}
.alert-dark hr {
  border-top-color: #b3b4b4;
}
.alert-dark .alert-link {
  color: #09090b;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.75rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 0.75rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.749875rem;
  background-color: rgba(0, 160, 221, 0.12);
  border-radius: 4.375rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fdfeff;
  text-align: center;
  white-space: nowrap;
  background-color: #00a0dd;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(253, 254, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(253, 254, 255, 0.15) 50%, rgba(253, 254, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.75rem 0.75rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.358rem;
}

.list-group-item-action {
  width: 100%;
  color: #4e5154;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #4e5154;
  text-decoration: none;
  background-color: #babfc7;
}
.list-group-item-action:active {
  color: #6e6b7b;
  background-color: #ededed;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fdfeff;
  border: 1px solid rgba(30, 29, 43, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #b9b9c3;
  pointer-events: none;
  background-color: #fdfeff;
}
.list-group-item.active {
  z-index: 2;
  color: #fdfeff;
  background-color: #00a0dd;
  border-color: #00a0dd;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.358rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.358rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.358rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.358rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.358rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.358rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.358rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.358rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.358rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.358rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #0e6188;
  background-color: #b6e4f5;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #0e6188;
  background-color: #a0dcf2;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fdfeff;
  background-color: #0e6188;
  border-color: #0e6188;
}

.list-group-item-secondary {
  color: #823329;
  background-color: #f4cbc3;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #823329;
  background-color: #f0b8ad;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fdfeff;
  background-color: #823329;
  border-color: #823329;
}

.list-group-item-success {
  color: #23754e;
  background-color: #c1efd7;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #23754e;
  background-color: #adeaca;
}
.list-group-item-success.list-group-item-action.active {
  color: #fdfeff;
  background-color: #23754e;
  border-color: #23754e;
}

.list-group-item-info {
  color: #20254b;
  background-color: #c0c3d5;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #20254b;
  background-color: #b1b4cb;
}
.list-group-item-info.list-group-item-action.active {
  color: #fdfeff;
  background-color: #20254b;
  border-color: #20254b;
}

.list-group-item-warning {
  color: #7d432a;
  background-color: #f2d4c3;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #7d432a;
  background-color: #edc5ae;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fdfeff;
  background-color: #7d432a;
  border-color: #7d432a;
}

.list-group-item-danger {
  color: #823329;
  background-color: #f4cbc3;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #823329;
  background-color: #f0b8ad;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fdfeff;
  background-color: #823329;
  border-color: #823329;
}

.list-group-item-light {
  color: #8e8e95;
  background-color: #fbfcfc;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #8e8e95;
  background-color: #ecf1f1;
}
.list-group-item-light.list-group-item-action.active {
  color: #fdfeff;
  background-color: #8e8e95;
  border-color: #8e8e95;
}

.list-group-item-dark {
  color: #212027;
  background-color: #c0c1c1;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #212027;
  background-color: #b3b4b4;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fdfeff;
  background-color: #212027;
  border-color: #212027;
}

.close {
  float: right;
  font-size: 1.75rem;
  font-weight: 400;
  line-height: 1;
  color: #5e5873;
  text-shadow: 0 1px 0 #fdfeff;
  opacity: 0.5;
}
.close:hover {
  color: #5e5873;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 380px;
  max-width: 380px;
  font-size: 0.75rem;
  color: #6e6b7b;
  background-color: rgba(253, 254, 255, 0.85);
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 20px 0 rgba(30, 29, 43, 0.08);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 1rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.125rem 1rem;
  color: #6e6b7b;
  background-color: #fdfeff;
  background-clip: padding-box;
  border-bottom: 0 solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.toast-body {
  padding: 1rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fdfeff;
  background-clip: padding-box;
  border: 1px solid rgba(30, 29, 43, 0.2);
  border-radius: 0.3125rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #1e1d2b;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.7rem 1.225rem;
  border-bottom: 1px solid #ebe9f1;
  border-top-left-radius: calc(0.3125rem - 1px);
  border-top-right-radius: calc(0.3125rem - 1px);
}
.modal-header .close {
  padding: 0.7rem 1.225rem;
  margin: -0.7rem -1.225rem -0.7rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.45;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 0.7rem 1.225rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.7rem 1.225rem-0.25rem;
  border-top: 1px solid rgba(30, 29, 43, 0.05);
  border-bottom-right-radius: calc(0.3125rem - 1px);
  border-bottom-left-radius: calc(0.3125rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }

  .modal-sm {
    max-width: 400px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 94%;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 1;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #323232;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #323232;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #323232;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #323232;
}

.tooltip-inner {
  max-width: 220px;
  padding: 0.35rem 0.678125rem;
  color: #fdfeff;
  text-align: center;
  background-color: #323232;
  border-radius: 0.3125rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.45;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fdfeff;
  background-clip: padding-box;
  border: 0 solid #ebe9f1;
  border-radius: 0.3125rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3125rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: -0.5rem;
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #ebe9f1;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fdfeff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: -0.5rem;
  width: 0.5rem;
  height: 1rem;
  margin: 0.3125rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #ebe9f1;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fdfeff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: -0.5rem;
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #ebe9f1;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fdfeff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 0 solid #00a0dd;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: -0.5rem;
  width: 0.5rem;
  height: 1rem;
  margin: 0.3125rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #ebe9f1;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fdfeff;
}

.popover-header {
  padding: 0.5625rem 1.0625rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #fdfeff;
  background-color: #00a0dd;
  border-bottom: 0 solid #008ec4;
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5625rem 1.0625rem;
  color: #6e6b7b;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fdfeff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fdfeff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50%/100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fdfeff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fdfeff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #00a0dd !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #007baa !important;
}

.bg-secondary {
  background-color: #de4827 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #b6381c !important;
}

.bg-success {
  background-color: #28c76f !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #1f9d57 !important;
}

.bg-info {
  background-color: #222d69 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #161c42 !important;
}

.bg-warning {
  background-color: #d56729 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #aa5221 !important;
}

.bg-danger {
  background-color: #de4827 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #b6381c !important;
}

.bg-light {
  background-color: #f6f6f6 !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dddddd !important;
}

.bg-dark {
  background-color: #232323 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0a0a0a !important;
}

.bg-white {
  background-color: #fdfeff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #ebe9f1 !important;
}

.border-top {
  border-top: 1px solid #ebe9f1 !important;
}

.border-right {
  border-right: 1px solid #ebe9f1 !important;
}

.border-bottom {
  border-bottom: 1px solid #ebe9f1 !important;
}

.border-left {
  border-left: 1px solid #ebe9f1 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #00a0dd !important;
}

.border-secondary {
  border-color: #de4827 !important;
}

.border-success {
  border-color: #28c76f !important;
}

.border-info {
  border-color: #222d69 !important;
}

.border-warning {
  border-color: #d56729 !important;
}

.border-danger {
  border-color: #de4827 !important;
}

.border-light {
  border-color: #f6f6f6 !important;
}

.border-dark {
  border-color: #232323 !important;
}

.border-white {
  border-color: #fdfeff !important;
}

.rounded-sm {
  border-radius: 0.21875rem !important;
}

.rounded {
  border-radius: 0.3125rem !important;
}

.rounded-top {
  border-top-left-radius: 0.3125rem !important;
  border-top-right-radius: 0.3125rem !important;
}

.rounded-right {
  border-top-right-radius: 0.3125rem !important;
  border-bottom-right-radius: 0.3125rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.3125rem !important;
  border-bottom-left-radius: 0.3125rem !important;
}

.rounded-left {
  border-top-left-radius: 0.3125rem !important;
  border-bottom-left-radius: 0.3125rem !important;
}

.rounded-lg {
  border-radius: 0.525rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }

  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(30, 29, 43, 0.075) !important;
}

.shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(30, 29, 43, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.875rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.875rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.875rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.875rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.875rem !important;
}

.m-2 {
  margin: 1.3125rem !important;
}

.mt-2,
.my-2 {
  margin-top: 1.3125rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 1.3125rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 1.3125rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 1.3125rem !important;
}

.m-3 {
  margin: 2.625rem !important;
}

.mt-3,
.my-3 {
  margin-top: 2.625rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 2.625rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 2.625rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 2.625rem !important;
}

.m-4 {
  margin: 3.0625rem !important;
}

.mt-4,
.my-4 {
  margin-top: 3.0625rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 3.0625rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 3.0625rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 3.0625rem !important;
}

.m-5 {
  margin: 3.5rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3.5rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3.5rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3.5rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3.5rem !important;
}

.m-25 {
  margin: 0.21875rem !important;
}

.mt-25,
.my-25 {
  margin-top: 0.21875rem !important;
}

.mr-25,
.mx-25 {
  margin-right: 0.21875rem !important;
}

.mb-25,
.my-25 {
  margin-bottom: 0.21875rem !important;
}

.ml-25,
.mx-25 {
  margin-left: 0.21875rem !important;
}

.m-50 {
  margin: 0.4375rem !important;
}

.mt-50,
.my-50 {
  margin-top: 0.4375rem !important;
}

.mr-50,
.mx-50 {
  margin-right: 0.4375rem !important;
}

.mb-50,
.my-50 {
  margin-bottom: 0.4375rem !important;
}

.ml-50,
.mx-50 {
  margin-left: 0.4375rem !important;
}

.m-75 {
  margin: 0.65625rem !important;
}

.mt-75,
.my-75 {
  margin-top: 0.65625rem !important;
}

.mr-75,
.mx-75 {
  margin-right: 0.65625rem !important;
}

.mb-75,
.my-75 {
  margin-bottom: 0.65625rem !important;
}

.ml-75,
.mx-75 {
  margin-left: 0.65625rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.875rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.875rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.875rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.875rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.875rem !important;
}

.p-2 {
  padding: 1.3125rem !important;
}

.pt-2,
.py-2 {
  padding-top: 1.3125rem !important;
}

.pr-2,
.px-2 {
  padding-right: 1.3125rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 1.3125rem !important;
}

.pl-2,
.px-2 {
  padding-left: 1.3125rem !important;
}

.p-3 {
  padding: 2.625rem !important;
}

.pt-3,
.py-3 {
  padding-top: 2.625rem !important;
}

.pr-3,
.px-3 {
  padding-right: 2.625rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 2.625rem !important;
}

.pl-3,
.px-3 {
  padding-left: 2.625rem !important;
}

.p-4 {
  padding: 3.0625rem !important;
}

.pt-4,
.py-4 {
  padding-top: 3.0625rem !important;
}

.pr-4,
.px-4 {
  padding-right: 3.0625rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 3.0625rem !important;
}

.pl-4,
.px-4 {
  padding-left: 3.0625rem !important;
}

.p-5 {
  padding: 3.5rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3.5rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3.5rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3.5rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3.5rem !important;
}

.p-25 {
  padding: 0.21875rem !important;
}

.pt-25,
.py-25 {
  padding-top: 0.21875rem !important;
}

.pr-25,
.px-25 {
  padding-right: 0.21875rem !important;
}

.pb-25,
.py-25 {
  padding-bottom: 0.21875rem !important;
}

.pl-25,
.px-25 {
  padding-left: 0.21875rem !important;
}

.p-50 {
  padding: 0.4375rem !important;
}

.pt-50,
.py-50 {
  padding-top: 0.4375rem !important;
}

.pr-50,
.px-50 {
  padding-right: 0.4375rem !important;
}

.pb-50,
.py-50 {
  padding-bottom: 0.4375rem !important;
}

.pl-50,
.px-50 {
  padding-left: 0.4375rem !important;
}

.p-75 {
  padding: 0.65625rem !important;
}

.pt-75,
.py-75 {
  padding-top: 0.65625rem !important;
}

.pr-75,
.px-75 {
  padding-right: 0.65625rem !important;
}

.pb-75,
.py-75 {
  padding-bottom: 0.65625rem !important;
}

.pl-75,
.px-75 {
  padding-left: 0.65625rem !important;
}

.m-n1 {
  margin: -0.875rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.875rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.875rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.875rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.875rem !important;
}

.m-n2 {
  margin: -1.3125rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -1.3125rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -1.3125rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -1.3125rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -1.3125rem !important;
}

.m-n3 {
  margin: -2.625rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -2.625rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -2.625rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -2.625rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -2.625rem !important;
}

.m-n4 {
  margin: -3.0625rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -3.0625rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -3.0625rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -3.0625rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -3.0625rem !important;
}

.m-n5 {
  margin: -3.5rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3.5rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3.5rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3.5rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3.5rem !important;
}

.m-n25 {
  margin: -0.21875rem !important;
}

.mt-n25,
.my-n25 {
  margin-top: -0.21875rem !important;
}

.mr-n25,
.mx-n25 {
  margin-right: -0.21875rem !important;
}

.mb-n25,
.my-n25 {
  margin-bottom: -0.21875rem !important;
}

.ml-n25,
.mx-n25 {
  margin-left: -0.21875rem !important;
}

.m-n50 {
  margin: -0.4375rem !important;
}

.mt-n50,
.my-n50 {
  margin-top: -0.4375rem !important;
}

.mr-n50,
.mx-n50 {
  margin-right: -0.4375rem !important;
}

.mb-n50,
.my-n50 {
  margin-bottom: -0.4375rem !important;
}

.ml-n50,
.mx-n50 {
  margin-left: -0.4375rem !important;
}

.m-n75 {
  margin: -0.65625rem !important;
}

.mt-n75,
.my-n75 {
  margin-top: -0.65625rem !important;
}

.mr-n75,
.mx-n75 {
  margin-right: -0.65625rem !important;
}

.mb-n75,
.my-n75 {
  margin-bottom: -0.65625rem !important;
}

.ml-n75,
.mx-n75 {
  margin-left: -0.65625rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
.my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
.mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
.my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
.mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 0.875rem !important;
  }

  .mt-sm-1,
.my-sm-1 {
    margin-top: 0.875rem !important;
  }

  .mr-sm-1,
.mx-sm-1 {
    margin-right: 0.875rem !important;
  }

  .mb-sm-1,
.my-sm-1 {
    margin-bottom: 0.875rem !important;
  }

  .ml-sm-1,
.mx-sm-1 {
    margin-left: 0.875rem !important;
  }

  .m-sm-2 {
    margin: 1.3125rem !important;
  }

  .mt-sm-2,
.my-sm-2 {
    margin-top: 1.3125rem !important;
  }

  .mr-sm-2,
.mx-sm-2 {
    margin-right: 1.3125rem !important;
  }

  .mb-sm-2,
.my-sm-2 {
    margin-bottom: 1.3125rem !important;
  }

  .ml-sm-2,
.mx-sm-2 {
    margin-left: 1.3125rem !important;
  }

  .m-sm-3 {
    margin: 2.625rem !important;
  }

  .mt-sm-3,
.my-sm-3 {
    margin-top: 2.625rem !important;
  }

  .mr-sm-3,
.mx-sm-3 {
    margin-right: 2.625rem !important;
  }

  .mb-sm-3,
.my-sm-3 {
    margin-bottom: 2.625rem !important;
  }

  .ml-sm-3,
.mx-sm-3 {
    margin-left: 2.625rem !important;
  }

  .m-sm-4 {
    margin: 3.0625rem !important;
  }

  .mt-sm-4,
.my-sm-4 {
    margin-top: 3.0625rem !important;
  }

  .mr-sm-4,
.mx-sm-4 {
    margin-right: 3.0625rem !important;
  }

  .mb-sm-4,
.my-sm-4 {
    margin-bottom: 3.0625rem !important;
  }

  .ml-sm-4,
.mx-sm-4 {
    margin-left: 3.0625rem !important;
  }

  .m-sm-5 {
    margin: 3.5rem !important;
  }

  .mt-sm-5,
.my-sm-5 {
    margin-top: 3.5rem !important;
  }

  .mr-sm-5,
.mx-sm-5 {
    margin-right: 3.5rem !important;
  }

  .mb-sm-5,
.my-sm-5 {
    margin-bottom: 3.5rem !important;
  }

  .ml-sm-5,
.mx-sm-5 {
    margin-left: 3.5rem !important;
  }

  .m-sm-25 {
    margin: 0.21875rem !important;
  }

  .mt-sm-25,
.my-sm-25 {
    margin-top: 0.21875rem !important;
  }

  .mr-sm-25,
.mx-sm-25 {
    margin-right: 0.21875rem !important;
  }

  .mb-sm-25,
.my-sm-25 {
    margin-bottom: 0.21875rem !important;
  }

  .ml-sm-25,
.mx-sm-25 {
    margin-left: 0.21875rem !important;
  }

  .m-sm-50 {
    margin: 0.4375rem !important;
  }

  .mt-sm-50,
.my-sm-50 {
    margin-top: 0.4375rem !important;
  }

  .mr-sm-50,
.mx-sm-50 {
    margin-right: 0.4375rem !important;
  }

  .mb-sm-50,
.my-sm-50 {
    margin-bottom: 0.4375rem !important;
  }

  .ml-sm-50,
.mx-sm-50 {
    margin-left: 0.4375rem !important;
  }

  .m-sm-75 {
    margin: 0.65625rem !important;
  }

  .mt-sm-75,
.my-sm-75 {
    margin-top: 0.65625rem !important;
  }

  .mr-sm-75,
.mx-sm-75 {
    margin-right: 0.65625rem !important;
  }

  .mb-sm-75,
.my-sm-75 {
    margin-bottom: 0.65625rem !important;
  }

  .ml-sm-75,
.mx-sm-75 {
    margin-left: 0.65625rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
.py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
.px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
.py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
.px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 0.875rem !important;
  }

  .pt-sm-1,
.py-sm-1 {
    padding-top: 0.875rem !important;
  }

  .pr-sm-1,
.px-sm-1 {
    padding-right: 0.875rem !important;
  }

  .pb-sm-1,
.py-sm-1 {
    padding-bottom: 0.875rem !important;
  }

  .pl-sm-1,
.px-sm-1 {
    padding-left: 0.875rem !important;
  }

  .p-sm-2 {
    padding: 1.3125rem !important;
  }

  .pt-sm-2,
.py-sm-2 {
    padding-top: 1.3125rem !important;
  }

  .pr-sm-2,
.px-sm-2 {
    padding-right: 1.3125rem !important;
  }

  .pb-sm-2,
.py-sm-2 {
    padding-bottom: 1.3125rem !important;
  }

  .pl-sm-2,
.px-sm-2 {
    padding-left: 1.3125rem !important;
  }

  .p-sm-3 {
    padding: 2.625rem !important;
  }

  .pt-sm-3,
.py-sm-3 {
    padding-top: 2.625rem !important;
  }

  .pr-sm-3,
.px-sm-3 {
    padding-right: 2.625rem !important;
  }

  .pb-sm-3,
.py-sm-3 {
    padding-bottom: 2.625rem !important;
  }

  .pl-sm-3,
.px-sm-3 {
    padding-left: 2.625rem !important;
  }

  .p-sm-4 {
    padding: 3.0625rem !important;
  }

  .pt-sm-4,
.py-sm-4 {
    padding-top: 3.0625rem !important;
  }

  .pr-sm-4,
.px-sm-4 {
    padding-right: 3.0625rem !important;
  }

  .pb-sm-4,
.py-sm-4 {
    padding-bottom: 3.0625rem !important;
  }

  .pl-sm-4,
.px-sm-4 {
    padding-left: 3.0625rem !important;
  }

  .p-sm-5 {
    padding: 3.5rem !important;
  }

  .pt-sm-5,
.py-sm-5 {
    padding-top: 3.5rem !important;
  }

  .pr-sm-5,
.px-sm-5 {
    padding-right: 3.5rem !important;
  }

  .pb-sm-5,
.py-sm-5 {
    padding-bottom: 3.5rem !important;
  }

  .pl-sm-5,
.px-sm-5 {
    padding-left: 3.5rem !important;
  }

  .p-sm-25 {
    padding: 0.21875rem !important;
  }

  .pt-sm-25,
.py-sm-25 {
    padding-top: 0.21875rem !important;
  }

  .pr-sm-25,
.px-sm-25 {
    padding-right: 0.21875rem !important;
  }

  .pb-sm-25,
.py-sm-25 {
    padding-bottom: 0.21875rem !important;
  }

  .pl-sm-25,
.px-sm-25 {
    padding-left: 0.21875rem !important;
  }

  .p-sm-50 {
    padding: 0.4375rem !important;
  }

  .pt-sm-50,
.py-sm-50 {
    padding-top: 0.4375rem !important;
  }

  .pr-sm-50,
.px-sm-50 {
    padding-right: 0.4375rem !important;
  }

  .pb-sm-50,
.py-sm-50 {
    padding-bottom: 0.4375rem !important;
  }

  .pl-sm-50,
.px-sm-50 {
    padding-left: 0.4375rem !important;
  }

  .p-sm-75 {
    padding: 0.65625rem !important;
  }

  .pt-sm-75,
.py-sm-75 {
    padding-top: 0.65625rem !important;
  }

  .pr-sm-75,
.px-sm-75 {
    padding-right: 0.65625rem !important;
  }

  .pb-sm-75,
.py-sm-75 {
    padding-bottom: 0.65625rem !important;
  }

  .pl-sm-75,
.px-sm-75 {
    padding-left: 0.65625rem !important;
  }

  .m-sm-n1 {
    margin: -0.875rem !important;
  }

  .mt-sm-n1,
.my-sm-n1 {
    margin-top: -0.875rem !important;
  }

  .mr-sm-n1,
.mx-sm-n1 {
    margin-right: -0.875rem !important;
  }

  .mb-sm-n1,
.my-sm-n1 {
    margin-bottom: -0.875rem !important;
  }

  .ml-sm-n1,
.mx-sm-n1 {
    margin-left: -0.875rem !important;
  }

  .m-sm-n2 {
    margin: -1.3125rem !important;
  }

  .mt-sm-n2,
.my-sm-n2 {
    margin-top: -1.3125rem !important;
  }

  .mr-sm-n2,
.mx-sm-n2 {
    margin-right: -1.3125rem !important;
  }

  .mb-sm-n2,
.my-sm-n2 {
    margin-bottom: -1.3125rem !important;
  }

  .ml-sm-n2,
.mx-sm-n2 {
    margin-left: -1.3125rem !important;
  }

  .m-sm-n3 {
    margin: -2.625rem !important;
  }

  .mt-sm-n3,
.my-sm-n3 {
    margin-top: -2.625rem !important;
  }

  .mr-sm-n3,
.mx-sm-n3 {
    margin-right: -2.625rem !important;
  }

  .mb-sm-n3,
.my-sm-n3 {
    margin-bottom: -2.625rem !important;
  }

  .ml-sm-n3,
.mx-sm-n3 {
    margin-left: -2.625rem !important;
  }

  .m-sm-n4 {
    margin: -3.0625rem !important;
  }

  .mt-sm-n4,
.my-sm-n4 {
    margin-top: -3.0625rem !important;
  }

  .mr-sm-n4,
.mx-sm-n4 {
    margin-right: -3.0625rem !important;
  }

  .mb-sm-n4,
.my-sm-n4 {
    margin-bottom: -3.0625rem !important;
  }

  .ml-sm-n4,
.mx-sm-n4 {
    margin-left: -3.0625rem !important;
  }

  .m-sm-n5 {
    margin: -3.5rem !important;
  }

  .mt-sm-n5,
.my-sm-n5 {
    margin-top: -3.5rem !important;
  }

  .mr-sm-n5,
.mx-sm-n5 {
    margin-right: -3.5rem !important;
  }

  .mb-sm-n5,
.my-sm-n5 {
    margin-bottom: -3.5rem !important;
  }

  .ml-sm-n5,
.mx-sm-n5 {
    margin-left: -3.5rem !important;
  }

  .m-sm-n25 {
    margin: -0.21875rem !important;
  }

  .mt-sm-n25,
.my-sm-n25 {
    margin-top: -0.21875rem !important;
  }

  .mr-sm-n25,
.mx-sm-n25 {
    margin-right: -0.21875rem !important;
  }

  .mb-sm-n25,
.my-sm-n25 {
    margin-bottom: -0.21875rem !important;
  }

  .ml-sm-n25,
.mx-sm-n25 {
    margin-left: -0.21875rem !important;
  }

  .m-sm-n50 {
    margin: -0.4375rem !important;
  }

  .mt-sm-n50,
.my-sm-n50 {
    margin-top: -0.4375rem !important;
  }

  .mr-sm-n50,
.mx-sm-n50 {
    margin-right: -0.4375rem !important;
  }

  .mb-sm-n50,
.my-sm-n50 {
    margin-bottom: -0.4375rem !important;
  }

  .ml-sm-n50,
.mx-sm-n50 {
    margin-left: -0.4375rem !important;
  }

  .m-sm-n75 {
    margin: -0.65625rem !important;
  }

  .mt-sm-n75,
.my-sm-n75 {
    margin-top: -0.65625rem !important;
  }

  .mr-sm-n75,
.mx-sm-n75 {
    margin-right: -0.65625rem !important;
  }

  .mb-sm-n75,
.my-sm-n75 {
    margin-bottom: -0.65625rem !important;
  }

  .ml-sm-n75,
.mx-sm-n75 {
    margin-left: -0.65625rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
.my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
.mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
.my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
.mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
.my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
.mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
.my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
.mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 0.875rem !important;
  }

  .mt-md-1,
.my-md-1 {
    margin-top: 0.875rem !important;
  }

  .mr-md-1,
.mx-md-1 {
    margin-right: 0.875rem !important;
  }

  .mb-md-1,
.my-md-1 {
    margin-bottom: 0.875rem !important;
  }

  .ml-md-1,
.mx-md-1 {
    margin-left: 0.875rem !important;
  }

  .m-md-2 {
    margin: 1.3125rem !important;
  }

  .mt-md-2,
.my-md-2 {
    margin-top: 1.3125rem !important;
  }

  .mr-md-2,
.mx-md-2 {
    margin-right: 1.3125rem !important;
  }

  .mb-md-2,
.my-md-2 {
    margin-bottom: 1.3125rem !important;
  }

  .ml-md-2,
.mx-md-2 {
    margin-left: 1.3125rem !important;
  }

  .m-md-3 {
    margin: 2.625rem !important;
  }

  .mt-md-3,
.my-md-3 {
    margin-top: 2.625rem !important;
  }

  .mr-md-3,
.mx-md-3 {
    margin-right: 2.625rem !important;
  }

  .mb-md-3,
.my-md-3 {
    margin-bottom: 2.625rem !important;
  }

  .ml-md-3,
.mx-md-3 {
    margin-left: 2.625rem !important;
  }

  .m-md-4 {
    margin: 3.0625rem !important;
  }

  .mt-md-4,
.my-md-4 {
    margin-top: 3.0625rem !important;
  }

  .mr-md-4,
.mx-md-4 {
    margin-right: 3.0625rem !important;
  }

  .mb-md-4,
.my-md-4 {
    margin-bottom: 3.0625rem !important;
  }

  .ml-md-4,
.mx-md-4 {
    margin-left: 3.0625rem !important;
  }

  .m-md-5 {
    margin: 3.5rem !important;
  }

  .mt-md-5,
.my-md-5 {
    margin-top: 3.5rem !important;
  }

  .mr-md-5,
.mx-md-5 {
    margin-right: 3.5rem !important;
  }

  .mb-md-5,
.my-md-5 {
    margin-bottom: 3.5rem !important;
  }

  .ml-md-5,
.mx-md-5 {
    margin-left: 3.5rem !important;
  }

  .m-md-25 {
    margin: 0.21875rem !important;
  }

  .mt-md-25,
.my-md-25 {
    margin-top: 0.21875rem !important;
  }

  .mr-md-25,
.mx-md-25 {
    margin-right: 0.21875rem !important;
  }

  .mb-md-25,
.my-md-25 {
    margin-bottom: 0.21875rem !important;
  }

  .ml-md-25,
.mx-md-25 {
    margin-left: 0.21875rem !important;
  }

  .m-md-50 {
    margin: 0.4375rem !important;
  }

  .mt-md-50,
.my-md-50 {
    margin-top: 0.4375rem !important;
  }

  .mr-md-50,
.mx-md-50 {
    margin-right: 0.4375rem !important;
  }

  .mb-md-50,
.my-md-50 {
    margin-bottom: 0.4375rem !important;
  }

  .ml-md-50,
.mx-md-50 {
    margin-left: 0.4375rem !important;
  }

  .m-md-75 {
    margin: 0.65625rem !important;
  }

  .mt-md-75,
.my-md-75 {
    margin-top: 0.65625rem !important;
  }

  .mr-md-75,
.mx-md-75 {
    margin-right: 0.65625rem !important;
  }

  .mb-md-75,
.my-md-75 {
    margin-bottom: 0.65625rem !important;
  }

  .ml-md-75,
.mx-md-75 {
    margin-left: 0.65625rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
.py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
.px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
.py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
.px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 0.875rem !important;
  }

  .pt-md-1,
.py-md-1 {
    padding-top: 0.875rem !important;
  }

  .pr-md-1,
.px-md-1 {
    padding-right: 0.875rem !important;
  }

  .pb-md-1,
.py-md-1 {
    padding-bottom: 0.875rem !important;
  }

  .pl-md-1,
.px-md-1 {
    padding-left: 0.875rem !important;
  }

  .p-md-2 {
    padding: 1.3125rem !important;
  }

  .pt-md-2,
.py-md-2 {
    padding-top: 1.3125rem !important;
  }

  .pr-md-2,
.px-md-2 {
    padding-right: 1.3125rem !important;
  }

  .pb-md-2,
.py-md-2 {
    padding-bottom: 1.3125rem !important;
  }

  .pl-md-2,
.px-md-2 {
    padding-left: 1.3125rem !important;
  }

  .p-md-3 {
    padding: 2.625rem !important;
  }

  .pt-md-3,
.py-md-3 {
    padding-top: 2.625rem !important;
  }

  .pr-md-3,
.px-md-3 {
    padding-right: 2.625rem !important;
  }

  .pb-md-3,
.py-md-3 {
    padding-bottom: 2.625rem !important;
  }

  .pl-md-3,
.px-md-3 {
    padding-left: 2.625rem !important;
  }

  .p-md-4 {
    padding: 3.0625rem !important;
  }

  .pt-md-4,
.py-md-4 {
    padding-top: 3.0625rem !important;
  }

  .pr-md-4,
.px-md-4 {
    padding-right: 3.0625rem !important;
  }

  .pb-md-4,
.py-md-4 {
    padding-bottom: 3.0625rem !important;
  }

  .pl-md-4,
.px-md-4 {
    padding-left: 3.0625rem !important;
  }

  .p-md-5 {
    padding: 3.5rem !important;
  }

  .pt-md-5,
.py-md-5 {
    padding-top: 3.5rem !important;
  }

  .pr-md-5,
.px-md-5 {
    padding-right: 3.5rem !important;
  }

  .pb-md-5,
.py-md-5 {
    padding-bottom: 3.5rem !important;
  }

  .pl-md-5,
.px-md-5 {
    padding-left: 3.5rem !important;
  }

  .p-md-25 {
    padding: 0.21875rem !important;
  }

  .pt-md-25,
.py-md-25 {
    padding-top: 0.21875rem !important;
  }

  .pr-md-25,
.px-md-25 {
    padding-right: 0.21875rem !important;
  }

  .pb-md-25,
.py-md-25 {
    padding-bottom: 0.21875rem !important;
  }

  .pl-md-25,
.px-md-25 {
    padding-left: 0.21875rem !important;
  }

  .p-md-50 {
    padding: 0.4375rem !important;
  }

  .pt-md-50,
.py-md-50 {
    padding-top: 0.4375rem !important;
  }

  .pr-md-50,
.px-md-50 {
    padding-right: 0.4375rem !important;
  }

  .pb-md-50,
.py-md-50 {
    padding-bottom: 0.4375rem !important;
  }

  .pl-md-50,
.px-md-50 {
    padding-left: 0.4375rem !important;
  }

  .p-md-75 {
    padding: 0.65625rem !important;
  }

  .pt-md-75,
.py-md-75 {
    padding-top: 0.65625rem !important;
  }

  .pr-md-75,
.px-md-75 {
    padding-right: 0.65625rem !important;
  }

  .pb-md-75,
.py-md-75 {
    padding-bottom: 0.65625rem !important;
  }

  .pl-md-75,
.px-md-75 {
    padding-left: 0.65625rem !important;
  }

  .m-md-n1 {
    margin: -0.875rem !important;
  }

  .mt-md-n1,
.my-md-n1 {
    margin-top: -0.875rem !important;
  }

  .mr-md-n1,
.mx-md-n1 {
    margin-right: -0.875rem !important;
  }

  .mb-md-n1,
.my-md-n1 {
    margin-bottom: -0.875rem !important;
  }

  .ml-md-n1,
.mx-md-n1 {
    margin-left: -0.875rem !important;
  }

  .m-md-n2 {
    margin: -1.3125rem !important;
  }

  .mt-md-n2,
.my-md-n2 {
    margin-top: -1.3125rem !important;
  }

  .mr-md-n2,
.mx-md-n2 {
    margin-right: -1.3125rem !important;
  }

  .mb-md-n2,
.my-md-n2 {
    margin-bottom: -1.3125rem !important;
  }

  .ml-md-n2,
.mx-md-n2 {
    margin-left: -1.3125rem !important;
  }

  .m-md-n3 {
    margin: -2.625rem !important;
  }

  .mt-md-n3,
.my-md-n3 {
    margin-top: -2.625rem !important;
  }

  .mr-md-n3,
.mx-md-n3 {
    margin-right: -2.625rem !important;
  }

  .mb-md-n3,
.my-md-n3 {
    margin-bottom: -2.625rem !important;
  }

  .ml-md-n3,
.mx-md-n3 {
    margin-left: -2.625rem !important;
  }

  .m-md-n4 {
    margin: -3.0625rem !important;
  }

  .mt-md-n4,
.my-md-n4 {
    margin-top: -3.0625rem !important;
  }

  .mr-md-n4,
.mx-md-n4 {
    margin-right: -3.0625rem !important;
  }

  .mb-md-n4,
.my-md-n4 {
    margin-bottom: -3.0625rem !important;
  }

  .ml-md-n4,
.mx-md-n4 {
    margin-left: -3.0625rem !important;
  }

  .m-md-n5 {
    margin: -3.5rem !important;
  }

  .mt-md-n5,
.my-md-n5 {
    margin-top: -3.5rem !important;
  }

  .mr-md-n5,
.mx-md-n5 {
    margin-right: -3.5rem !important;
  }

  .mb-md-n5,
.my-md-n5 {
    margin-bottom: -3.5rem !important;
  }

  .ml-md-n5,
.mx-md-n5 {
    margin-left: -3.5rem !important;
  }

  .m-md-n25 {
    margin: -0.21875rem !important;
  }

  .mt-md-n25,
.my-md-n25 {
    margin-top: -0.21875rem !important;
  }

  .mr-md-n25,
.mx-md-n25 {
    margin-right: -0.21875rem !important;
  }

  .mb-md-n25,
.my-md-n25 {
    margin-bottom: -0.21875rem !important;
  }

  .ml-md-n25,
.mx-md-n25 {
    margin-left: -0.21875rem !important;
  }

  .m-md-n50 {
    margin: -0.4375rem !important;
  }

  .mt-md-n50,
.my-md-n50 {
    margin-top: -0.4375rem !important;
  }

  .mr-md-n50,
.mx-md-n50 {
    margin-right: -0.4375rem !important;
  }

  .mb-md-n50,
.my-md-n50 {
    margin-bottom: -0.4375rem !important;
  }

  .ml-md-n50,
.mx-md-n50 {
    margin-left: -0.4375rem !important;
  }

  .m-md-n75 {
    margin: -0.65625rem !important;
  }

  .mt-md-n75,
.my-md-n75 {
    margin-top: -0.65625rem !important;
  }

  .mr-md-n75,
.mx-md-n75 {
    margin-right: -0.65625rem !important;
  }

  .mb-md-n75,
.my-md-n75 {
    margin-bottom: -0.65625rem !important;
  }

  .ml-md-n75,
.mx-md-n75 {
    margin-left: -0.65625rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
.my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
.mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
.my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
.mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
.my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
.mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
.my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
.mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 0.875rem !important;
  }

  .mt-lg-1,
.my-lg-1 {
    margin-top: 0.875rem !important;
  }

  .mr-lg-1,
.mx-lg-1 {
    margin-right: 0.875rem !important;
  }

  .mb-lg-1,
.my-lg-1 {
    margin-bottom: 0.875rem !important;
  }

  .ml-lg-1,
.mx-lg-1 {
    margin-left: 0.875rem !important;
  }

  .m-lg-2 {
    margin: 1.3125rem !important;
  }

  .mt-lg-2,
.my-lg-2 {
    margin-top: 1.3125rem !important;
  }

  .mr-lg-2,
.mx-lg-2 {
    margin-right: 1.3125rem !important;
  }

  .mb-lg-2,
.my-lg-2 {
    margin-bottom: 1.3125rem !important;
  }

  .ml-lg-2,
.mx-lg-2 {
    margin-left: 1.3125rem !important;
  }

  .m-lg-3 {
    margin: 2.625rem !important;
  }

  .mt-lg-3,
.my-lg-3 {
    margin-top: 2.625rem !important;
  }

  .mr-lg-3,
.mx-lg-3 {
    margin-right: 2.625rem !important;
  }

  .mb-lg-3,
.my-lg-3 {
    margin-bottom: 2.625rem !important;
  }

  .ml-lg-3,
.mx-lg-3 {
    margin-left: 2.625rem !important;
  }

  .m-lg-4 {
    margin: 3.0625rem !important;
  }

  .mt-lg-4,
.my-lg-4 {
    margin-top: 3.0625rem !important;
  }

  .mr-lg-4,
.mx-lg-4 {
    margin-right: 3.0625rem !important;
  }

  .mb-lg-4,
.my-lg-4 {
    margin-bottom: 3.0625rem !important;
  }

  .ml-lg-4,
.mx-lg-4 {
    margin-left: 3.0625rem !important;
  }

  .m-lg-5 {
    margin: 3.5rem !important;
  }

  .mt-lg-5,
.my-lg-5 {
    margin-top: 3.5rem !important;
  }

  .mr-lg-5,
.mx-lg-5 {
    margin-right: 3.5rem !important;
  }

  .mb-lg-5,
.my-lg-5 {
    margin-bottom: 3.5rem !important;
  }

  .ml-lg-5,
.mx-lg-5 {
    margin-left: 3.5rem !important;
  }

  .m-lg-25 {
    margin: 0.21875rem !important;
  }

  .mt-lg-25,
.my-lg-25 {
    margin-top: 0.21875rem !important;
  }

  .mr-lg-25,
.mx-lg-25 {
    margin-right: 0.21875rem !important;
  }

  .mb-lg-25,
.my-lg-25 {
    margin-bottom: 0.21875rem !important;
  }

  .ml-lg-25,
.mx-lg-25 {
    margin-left: 0.21875rem !important;
  }

  .m-lg-50 {
    margin: 0.4375rem !important;
  }

  .mt-lg-50,
.my-lg-50 {
    margin-top: 0.4375rem !important;
  }

  .mr-lg-50,
.mx-lg-50 {
    margin-right: 0.4375rem !important;
  }

  .mb-lg-50,
.my-lg-50 {
    margin-bottom: 0.4375rem !important;
  }

  .ml-lg-50,
.mx-lg-50 {
    margin-left: 0.4375rem !important;
  }

  .m-lg-75 {
    margin: 0.65625rem !important;
  }

  .mt-lg-75,
.my-lg-75 {
    margin-top: 0.65625rem !important;
  }

  .mr-lg-75,
.mx-lg-75 {
    margin-right: 0.65625rem !important;
  }

  .mb-lg-75,
.my-lg-75 {
    margin-bottom: 0.65625rem !important;
  }

  .ml-lg-75,
.mx-lg-75 {
    margin-left: 0.65625rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
.py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
.px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
.py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
.px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 0.875rem !important;
  }

  .pt-lg-1,
.py-lg-1 {
    padding-top: 0.875rem !important;
  }

  .pr-lg-1,
.px-lg-1 {
    padding-right: 0.875rem !important;
  }

  .pb-lg-1,
.py-lg-1 {
    padding-bottom: 0.875rem !important;
  }

  .pl-lg-1,
.px-lg-1 {
    padding-left: 0.875rem !important;
  }

  .p-lg-2 {
    padding: 1.3125rem !important;
  }

  .pt-lg-2,
.py-lg-2 {
    padding-top: 1.3125rem !important;
  }

  .pr-lg-2,
.px-lg-2 {
    padding-right: 1.3125rem !important;
  }

  .pb-lg-2,
.py-lg-2 {
    padding-bottom: 1.3125rem !important;
  }

  .pl-lg-2,
.px-lg-2 {
    padding-left: 1.3125rem !important;
  }

  .p-lg-3 {
    padding: 2.625rem !important;
  }

  .pt-lg-3,
.py-lg-3 {
    padding-top: 2.625rem !important;
  }

  .pr-lg-3,
.px-lg-3 {
    padding-right: 2.625rem !important;
  }

  .pb-lg-3,
.py-lg-3 {
    padding-bottom: 2.625rem !important;
  }

  .pl-lg-3,
.px-lg-3 {
    padding-left: 2.625rem !important;
  }

  .p-lg-4 {
    padding: 3.0625rem !important;
  }

  .pt-lg-4,
.py-lg-4 {
    padding-top: 3.0625rem !important;
  }

  .pr-lg-4,
.px-lg-4 {
    padding-right: 3.0625rem !important;
  }

  .pb-lg-4,
.py-lg-4 {
    padding-bottom: 3.0625rem !important;
  }

  .pl-lg-4,
.px-lg-4 {
    padding-left: 3.0625rem !important;
  }

  .p-lg-5 {
    padding: 3.5rem !important;
  }

  .pt-lg-5,
.py-lg-5 {
    padding-top: 3.5rem !important;
  }

  .pr-lg-5,
.px-lg-5 {
    padding-right: 3.5rem !important;
  }

  .pb-lg-5,
.py-lg-5 {
    padding-bottom: 3.5rem !important;
  }

  .pl-lg-5,
.px-lg-5 {
    padding-left: 3.5rem !important;
  }

  .p-lg-25 {
    padding: 0.21875rem !important;
  }

  .pt-lg-25,
.py-lg-25 {
    padding-top: 0.21875rem !important;
  }

  .pr-lg-25,
.px-lg-25 {
    padding-right: 0.21875rem !important;
  }

  .pb-lg-25,
.py-lg-25 {
    padding-bottom: 0.21875rem !important;
  }

  .pl-lg-25,
.px-lg-25 {
    padding-left: 0.21875rem !important;
  }

  .p-lg-50 {
    padding: 0.4375rem !important;
  }

  .pt-lg-50,
.py-lg-50 {
    padding-top: 0.4375rem !important;
  }

  .pr-lg-50,
.px-lg-50 {
    padding-right: 0.4375rem !important;
  }

  .pb-lg-50,
.py-lg-50 {
    padding-bottom: 0.4375rem !important;
  }

  .pl-lg-50,
.px-lg-50 {
    padding-left: 0.4375rem !important;
  }

  .p-lg-75 {
    padding: 0.65625rem !important;
  }

  .pt-lg-75,
.py-lg-75 {
    padding-top: 0.65625rem !important;
  }

  .pr-lg-75,
.px-lg-75 {
    padding-right: 0.65625rem !important;
  }

  .pb-lg-75,
.py-lg-75 {
    padding-bottom: 0.65625rem !important;
  }

  .pl-lg-75,
.px-lg-75 {
    padding-left: 0.65625rem !important;
  }

  .m-lg-n1 {
    margin: -0.875rem !important;
  }

  .mt-lg-n1,
.my-lg-n1 {
    margin-top: -0.875rem !important;
  }

  .mr-lg-n1,
.mx-lg-n1 {
    margin-right: -0.875rem !important;
  }

  .mb-lg-n1,
.my-lg-n1 {
    margin-bottom: -0.875rem !important;
  }

  .ml-lg-n1,
.mx-lg-n1 {
    margin-left: -0.875rem !important;
  }

  .m-lg-n2 {
    margin: -1.3125rem !important;
  }

  .mt-lg-n2,
.my-lg-n2 {
    margin-top: -1.3125rem !important;
  }

  .mr-lg-n2,
.mx-lg-n2 {
    margin-right: -1.3125rem !important;
  }

  .mb-lg-n2,
.my-lg-n2 {
    margin-bottom: -1.3125rem !important;
  }

  .ml-lg-n2,
.mx-lg-n2 {
    margin-left: -1.3125rem !important;
  }

  .m-lg-n3 {
    margin: -2.625rem !important;
  }

  .mt-lg-n3,
.my-lg-n3 {
    margin-top: -2.625rem !important;
  }

  .mr-lg-n3,
.mx-lg-n3 {
    margin-right: -2.625rem !important;
  }

  .mb-lg-n3,
.my-lg-n3 {
    margin-bottom: -2.625rem !important;
  }

  .ml-lg-n3,
.mx-lg-n3 {
    margin-left: -2.625rem !important;
  }

  .m-lg-n4 {
    margin: -3.0625rem !important;
  }

  .mt-lg-n4,
.my-lg-n4 {
    margin-top: -3.0625rem !important;
  }

  .mr-lg-n4,
.mx-lg-n4 {
    margin-right: -3.0625rem !important;
  }

  .mb-lg-n4,
.my-lg-n4 {
    margin-bottom: -3.0625rem !important;
  }

  .ml-lg-n4,
.mx-lg-n4 {
    margin-left: -3.0625rem !important;
  }

  .m-lg-n5 {
    margin: -3.5rem !important;
  }

  .mt-lg-n5,
.my-lg-n5 {
    margin-top: -3.5rem !important;
  }

  .mr-lg-n5,
.mx-lg-n5 {
    margin-right: -3.5rem !important;
  }

  .mb-lg-n5,
.my-lg-n5 {
    margin-bottom: -3.5rem !important;
  }

  .ml-lg-n5,
.mx-lg-n5 {
    margin-left: -3.5rem !important;
  }

  .m-lg-n25 {
    margin: -0.21875rem !important;
  }

  .mt-lg-n25,
.my-lg-n25 {
    margin-top: -0.21875rem !important;
  }

  .mr-lg-n25,
.mx-lg-n25 {
    margin-right: -0.21875rem !important;
  }

  .mb-lg-n25,
.my-lg-n25 {
    margin-bottom: -0.21875rem !important;
  }

  .ml-lg-n25,
.mx-lg-n25 {
    margin-left: -0.21875rem !important;
  }

  .m-lg-n50 {
    margin: -0.4375rem !important;
  }

  .mt-lg-n50,
.my-lg-n50 {
    margin-top: -0.4375rem !important;
  }

  .mr-lg-n50,
.mx-lg-n50 {
    margin-right: -0.4375rem !important;
  }

  .mb-lg-n50,
.my-lg-n50 {
    margin-bottom: -0.4375rem !important;
  }

  .ml-lg-n50,
.mx-lg-n50 {
    margin-left: -0.4375rem !important;
  }

  .m-lg-n75 {
    margin: -0.65625rem !important;
  }

  .mt-lg-n75,
.my-lg-n75 {
    margin-top: -0.65625rem !important;
  }

  .mr-lg-n75,
.mx-lg-n75 {
    margin-right: -0.65625rem !important;
  }

  .mb-lg-n75,
.my-lg-n75 {
    margin-bottom: -0.65625rem !important;
  }

  .ml-lg-n75,
.mx-lg-n75 {
    margin-left: -0.65625rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
.my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
.mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
.my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
.mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
.my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
.mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
.my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
.mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 0.875rem !important;
  }

  .mt-xl-1,
.my-xl-1 {
    margin-top: 0.875rem !important;
  }

  .mr-xl-1,
.mx-xl-1 {
    margin-right: 0.875rem !important;
  }

  .mb-xl-1,
.my-xl-1 {
    margin-bottom: 0.875rem !important;
  }

  .ml-xl-1,
.mx-xl-1 {
    margin-left: 0.875rem !important;
  }

  .m-xl-2 {
    margin: 1.3125rem !important;
  }

  .mt-xl-2,
.my-xl-2 {
    margin-top: 1.3125rem !important;
  }

  .mr-xl-2,
.mx-xl-2 {
    margin-right: 1.3125rem !important;
  }

  .mb-xl-2,
.my-xl-2 {
    margin-bottom: 1.3125rem !important;
  }

  .ml-xl-2,
.mx-xl-2 {
    margin-left: 1.3125rem !important;
  }

  .m-xl-3 {
    margin: 2.625rem !important;
  }

  .mt-xl-3,
.my-xl-3 {
    margin-top: 2.625rem !important;
  }

  .mr-xl-3,
.mx-xl-3 {
    margin-right: 2.625rem !important;
  }

  .mb-xl-3,
.my-xl-3 {
    margin-bottom: 2.625rem !important;
  }

  .ml-xl-3,
.mx-xl-3 {
    margin-left: 2.625rem !important;
  }

  .m-xl-4 {
    margin: 3.0625rem !important;
  }

  .mt-xl-4,
.my-xl-4 {
    margin-top: 3.0625rem !important;
  }

  .mr-xl-4,
.mx-xl-4 {
    margin-right: 3.0625rem !important;
  }

  .mb-xl-4,
.my-xl-4 {
    margin-bottom: 3.0625rem !important;
  }

  .ml-xl-4,
.mx-xl-4 {
    margin-left: 3.0625rem !important;
  }

  .m-xl-5 {
    margin: 3.5rem !important;
  }

  .mt-xl-5,
.my-xl-5 {
    margin-top: 3.5rem !important;
  }

  .mr-xl-5,
.mx-xl-5 {
    margin-right: 3.5rem !important;
  }

  .mb-xl-5,
.my-xl-5 {
    margin-bottom: 3.5rem !important;
  }

  .ml-xl-5,
.mx-xl-5 {
    margin-left: 3.5rem !important;
  }

  .m-xl-25 {
    margin: 0.21875rem !important;
  }

  .mt-xl-25,
.my-xl-25 {
    margin-top: 0.21875rem !important;
  }

  .mr-xl-25,
.mx-xl-25 {
    margin-right: 0.21875rem !important;
  }

  .mb-xl-25,
.my-xl-25 {
    margin-bottom: 0.21875rem !important;
  }

  .ml-xl-25,
.mx-xl-25 {
    margin-left: 0.21875rem !important;
  }

  .m-xl-50 {
    margin: 0.4375rem !important;
  }

  .mt-xl-50,
.my-xl-50 {
    margin-top: 0.4375rem !important;
  }

  .mr-xl-50,
.mx-xl-50 {
    margin-right: 0.4375rem !important;
  }

  .mb-xl-50,
.my-xl-50 {
    margin-bottom: 0.4375rem !important;
  }

  .ml-xl-50,
.mx-xl-50 {
    margin-left: 0.4375rem !important;
  }

  .m-xl-75 {
    margin: 0.65625rem !important;
  }

  .mt-xl-75,
.my-xl-75 {
    margin-top: 0.65625rem !important;
  }

  .mr-xl-75,
.mx-xl-75 {
    margin-right: 0.65625rem !important;
  }

  .mb-xl-75,
.my-xl-75 {
    margin-bottom: 0.65625rem !important;
  }

  .ml-xl-75,
.mx-xl-75 {
    margin-left: 0.65625rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
.py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
.px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
.py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
.px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 0.875rem !important;
  }

  .pt-xl-1,
.py-xl-1 {
    padding-top: 0.875rem !important;
  }

  .pr-xl-1,
.px-xl-1 {
    padding-right: 0.875rem !important;
  }

  .pb-xl-1,
.py-xl-1 {
    padding-bottom: 0.875rem !important;
  }

  .pl-xl-1,
.px-xl-1 {
    padding-left: 0.875rem !important;
  }

  .p-xl-2 {
    padding: 1.3125rem !important;
  }

  .pt-xl-2,
.py-xl-2 {
    padding-top: 1.3125rem !important;
  }

  .pr-xl-2,
.px-xl-2 {
    padding-right: 1.3125rem !important;
  }

  .pb-xl-2,
.py-xl-2 {
    padding-bottom: 1.3125rem !important;
  }

  .pl-xl-2,
.px-xl-2 {
    padding-left: 1.3125rem !important;
  }

  .p-xl-3 {
    padding: 2.625rem !important;
  }

  .pt-xl-3,
.py-xl-3 {
    padding-top: 2.625rem !important;
  }

  .pr-xl-3,
.px-xl-3 {
    padding-right: 2.625rem !important;
  }

  .pb-xl-3,
.py-xl-3 {
    padding-bottom: 2.625rem !important;
  }

  .pl-xl-3,
.px-xl-3 {
    padding-left: 2.625rem !important;
  }

  .p-xl-4 {
    padding: 3.0625rem !important;
  }

  .pt-xl-4,
.py-xl-4 {
    padding-top: 3.0625rem !important;
  }

  .pr-xl-4,
.px-xl-4 {
    padding-right: 3.0625rem !important;
  }

  .pb-xl-4,
.py-xl-4 {
    padding-bottom: 3.0625rem !important;
  }

  .pl-xl-4,
.px-xl-4 {
    padding-left: 3.0625rem !important;
  }

  .p-xl-5 {
    padding: 3.5rem !important;
  }

  .pt-xl-5,
.py-xl-5 {
    padding-top: 3.5rem !important;
  }

  .pr-xl-5,
.px-xl-5 {
    padding-right: 3.5rem !important;
  }

  .pb-xl-5,
.py-xl-5 {
    padding-bottom: 3.5rem !important;
  }

  .pl-xl-5,
.px-xl-5 {
    padding-left: 3.5rem !important;
  }

  .p-xl-25 {
    padding: 0.21875rem !important;
  }

  .pt-xl-25,
.py-xl-25 {
    padding-top: 0.21875rem !important;
  }

  .pr-xl-25,
.px-xl-25 {
    padding-right: 0.21875rem !important;
  }

  .pb-xl-25,
.py-xl-25 {
    padding-bottom: 0.21875rem !important;
  }

  .pl-xl-25,
.px-xl-25 {
    padding-left: 0.21875rem !important;
  }

  .p-xl-50 {
    padding: 0.4375rem !important;
  }

  .pt-xl-50,
.py-xl-50 {
    padding-top: 0.4375rem !important;
  }

  .pr-xl-50,
.px-xl-50 {
    padding-right: 0.4375rem !important;
  }

  .pb-xl-50,
.py-xl-50 {
    padding-bottom: 0.4375rem !important;
  }

  .pl-xl-50,
.px-xl-50 {
    padding-left: 0.4375rem !important;
  }

  .p-xl-75 {
    padding: 0.65625rem !important;
  }

  .pt-xl-75,
.py-xl-75 {
    padding-top: 0.65625rem !important;
  }

  .pr-xl-75,
.px-xl-75 {
    padding-right: 0.65625rem !important;
  }

  .pb-xl-75,
.py-xl-75 {
    padding-bottom: 0.65625rem !important;
  }

  .pl-xl-75,
.px-xl-75 {
    padding-left: 0.65625rem !important;
  }

  .m-xl-n1 {
    margin: -0.875rem !important;
  }

  .mt-xl-n1,
.my-xl-n1 {
    margin-top: -0.875rem !important;
  }

  .mr-xl-n1,
.mx-xl-n1 {
    margin-right: -0.875rem !important;
  }

  .mb-xl-n1,
.my-xl-n1 {
    margin-bottom: -0.875rem !important;
  }

  .ml-xl-n1,
.mx-xl-n1 {
    margin-left: -0.875rem !important;
  }

  .m-xl-n2 {
    margin: -1.3125rem !important;
  }

  .mt-xl-n2,
.my-xl-n2 {
    margin-top: -1.3125rem !important;
  }

  .mr-xl-n2,
.mx-xl-n2 {
    margin-right: -1.3125rem !important;
  }

  .mb-xl-n2,
.my-xl-n2 {
    margin-bottom: -1.3125rem !important;
  }

  .ml-xl-n2,
.mx-xl-n2 {
    margin-left: -1.3125rem !important;
  }

  .m-xl-n3 {
    margin: -2.625rem !important;
  }

  .mt-xl-n3,
.my-xl-n3 {
    margin-top: -2.625rem !important;
  }

  .mr-xl-n3,
.mx-xl-n3 {
    margin-right: -2.625rem !important;
  }

  .mb-xl-n3,
.my-xl-n3 {
    margin-bottom: -2.625rem !important;
  }

  .ml-xl-n3,
.mx-xl-n3 {
    margin-left: -2.625rem !important;
  }

  .m-xl-n4 {
    margin: -3.0625rem !important;
  }

  .mt-xl-n4,
.my-xl-n4 {
    margin-top: -3.0625rem !important;
  }

  .mr-xl-n4,
.mx-xl-n4 {
    margin-right: -3.0625rem !important;
  }

  .mb-xl-n4,
.my-xl-n4 {
    margin-bottom: -3.0625rem !important;
  }

  .ml-xl-n4,
.mx-xl-n4 {
    margin-left: -3.0625rem !important;
  }

  .m-xl-n5 {
    margin: -3.5rem !important;
  }

  .mt-xl-n5,
.my-xl-n5 {
    margin-top: -3.5rem !important;
  }

  .mr-xl-n5,
.mx-xl-n5 {
    margin-right: -3.5rem !important;
  }

  .mb-xl-n5,
.my-xl-n5 {
    margin-bottom: -3.5rem !important;
  }

  .ml-xl-n5,
.mx-xl-n5 {
    margin-left: -3.5rem !important;
  }

  .m-xl-n25 {
    margin: -0.21875rem !important;
  }

  .mt-xl-n25,
.my-xl-n25 {
    margin-top: -0.21875rem !important;
  }

  .mr-xl-n25,
.mx-xl-n25 {
    margin-right: -0.21875rem !important;
  }

  .mb-xl-n25,
.my-xl-n25 {
    margin-bottom: -0.21875rem !important;
  }

  .ml-xl-n25,
.mx-xl-n25 {
    margin-left: -0.21875rem !important;
  }

  .m-xl-n50 {
    margin: -0.4375rem !important;
  }

  .mt-xl-n50,
.my-xl-n50 {
    margin-top: -0.4375rem !important;
  }

  .mr-xl-n50,
.mx-xl-n50 {
    margin-right: -0.4375rem !important;
  }

  .mb-xl-n50,
.my-xl-n50 {
    margin-bottom: -0.4375rem !important;
  }

  .ml-xl-n50,
.mx-xl-n50 {
    margin-left: -0.4375rem !important;
  }

  .m-xl-n75 {
    margin: -0.65625rem !important;
  }

  .mt-xl-n75,
.my-xl-n75 {
    margin-top: -0.65625rem !important;
  }

  .mr-xl-n75,
.mx-xl-n75 {
    margin-right: -0.65625rem !important;
  }

  .mb-xl-n75,
.my-xl-n75 {
    margin-bottom: -0.65625rem !important;
  }

  .ml-xl-n75,
.mx-xl-n75 {
    margin-left: -0.65625rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
.my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
.mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
.my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
.mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: "Montserrat", Helvetica, Arial, serif !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }

  .text-sm-right {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }

  .text-md-right {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }

  .text-lg-right {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }

  .text-xl-right {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 500 !important;
}

.font-weight-bolder {
  font-weight: 600 !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fdfeff !important;
}

.text-primary {
  color: #00a0dd !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #006991 !important;
}

.text-secondary {
  color: #de4827 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #a03118 !important;
}

.text-success {
  color: #28c76f !important;
}

a.text-success:hover, a.text-success:focus {
  color: #1b874b !important;
}

.text-info {
  color: #222d69 !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0f142f !important;
}

.text-warning {
  color: #d56729 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #95481d !important;
}

.text-danger {
  color: #de4827 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #a03118 !important;
}

.text-light {
  color: #f6f6f6 !important;
}

a.text-light:hover, a.text-light:focus {
  color: #d0d0d0 !important;
}

.text-dark {
  color: #232323 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-body {
  color: #6e6b7b !important;
}

.text-muted {
  color: #b9b9c3 !important;
}

.text-black-50 {
  color: rgba(30, 29, 43, 0.5) !important;
}

.text-white-50 {
  color: rgba(253, 254, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
*::before,
*::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  a:not(.btn) {
    text-decoration: underline;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  tr,
img {
    page-break-inside: avoid;
  }

  p,
h2,
h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
h3 {
    page-break-after: avoid;
  }

  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }

  .container {
    min-width: 992px !important;
  }

  .navbar {
    display: none;
  }

  .badge {
    border: 1px solid #1e1d2b;
  }

  .table {
    border-collapse: collapse !important;
  }
  .table td,
.table th {
    background-color: #fdfeff !important;
  }

  .table-bordered th,
.table-bordered td {
    border: 1px solid #dae1e7 !important;
  }

  .table-dark {
    color: inherit;
  }
  .table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
    border-color: #ebe9f1;
  }

  .table .thead-dark th {
    color: inherit;
    border-color: #ebe9f1;
  }
}
a:focus {
  outline: none;
}

a:not([href]) {
  color: inherit;
  text-decoration: none;
}

button:focus {
  outline: none;
}

.list-style-icons {
  padding-left: 10px;
  margin-left: 0;
  list-style: none;
}
.list-style-icons > li svg,
.list-style-icons > li i {
  margin-right: 6px;
}

.pull-up {
  transition: all 0.25s ease;
}
.pull-up:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);
  z-index: 30;
}

.spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
}

.settings-spinner {
  display: inline-block;
  animation: spin 3s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-reverse {
  display: inline-block;
  animation: spin-reverse 1s linear infinite;
}

@keyframes spin-reverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.bullet {
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 50%;
  display: inline-block;
}
.bullet.bullet-xs {
  width: 0.4375rem;
  height: 0.4375rem;
}
.bullet.bullet-sm {
  width: 0.62475rem;
  height: 0.62475rem;
}
.bullet.bullet-lg {
  width: 1.09375rem;
  height: 1.09375rem;
}

.section-label {
  font-size: 0.74375rem;
  color: #b9b9c3;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.cell-fit {
  width: 0.1%;
  white-space: nowrap;
}

.match-height > [class*=col] {
  display: flex;
  flex-flow: column;
}
.match-height > [class*=col] > .card {
  flex: 1 1 auto;
}

.text-body-heading {
  color: #5e5873;
}
.text-body-heading:hover {
  color: inherit !important;
}

.text-body[href]:hover {
  color: #008ec4 !important;
}

code {
  padding: 0.0875rem 0.35rem;
  font-size: 90%;
  color: #e83e8c;
  background-color: #eee;
  border-radius: 0.15625rem;
}

pre {
  background-color: #f7f7f9;
}
pre code {
  background-color: transparent !important;
}

.table-white-space th,
.table-white-space td {
  white-space: nowrap;
}

.table thead th,
.table tfoot th {
  vertical-align: top;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}
.table th,
.table td {
  padding: 0.625rem 1.75rem;
  vertical-align: middle;
}
.table.table-sm th:first-child,
.table.table-sm td:first-child {
  padding-left: 0.65625rem;
}

.table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,
.table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  background-color: #f3f2f7;
}

.table-hover tbody tr {
  cursor: pointer;
}

.table-hover-animation {
  background-color: #f8f8f8;
}
.table-hover-animation thead th {
  border-bottom: 0;
}
.table-hover-animation th,
.table-hover-animation td {
  border: 0;
}
.table-hover-animation tbody tr {
  transition: all 0.25s ease;
  background-color: #fdfeff;
}
.table-hover-animation tbody tr:hover {
  transform: translateY(-4px);
}

.card .table {
  margin-bottom: 0;
  border-bottom-left-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}
.card .table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 0.3125rem;
}
.card .table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 0.3125rem;
}

.card table tr[class*=table-]:last-child td:first-child {
  border-bottom-left-radius: 0.3125rem;
}
.card table tr[class*=table-]:last-child td:last-child {
  border-bottom-right-radius: 0.3125rem;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .table-hover-animation tr:hover {
    border-bottom-color: #ebe9f1;
  }
}
label {
  color: #5e5873;
  font-size: 0.75rem;
}

.form-control::placeholder {
  transition: all 0.2s ease;
}
.form-control:focus::placeholder {
  transform: translate(5px);
  transition: all 0.2s ease;
}
.form-control:focus:valid, .form-control:focus.is-valid {
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
}

.form-control-plaintext:focus {
  outline: none;
}

.custom-file-label {
  line-height: 1.75;
}
.custom-file-label:after {
  height: 2.2575rem;
  line-height: 1.75;
}

.valid-tooltip,
.invalid-tooltip {
  top: 102%;
  left: 5px;
}

/***************
* Form Group
***************/
.input-group:not(.bootstrap-touchspin):focus-within {
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);
  border-radius: 0.3125rem;
}
.input-group:not(.bootstrap-touchspin):focus-within .form-control,
.input-group:not(.bootstrap-touchspin):focus-within .input-group-text {
  border-color: #00a0dd;
  box-shadow: none;
}
.input-group:not(.bootstrap-touchspin):focus-within .form-control.is-valid,
.input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-valid {
  border-color: #28c76f;
}
.input-group:not(.bootstrap-touchspin):focus-within .form-control.is-invalid,
.input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-invalid {
  border-color: #de4827;
}
.input-group.is-valid .input-group-text {
  border-color: #28c76f !important;
}
.input-group.is-valid:not(.bootstrap-touchspin):focus-within .input-group-text {
  border-color: #28c76f;
}
.input-group.is-invalid .input-group-text {
  border-color: #de4827 !important;
}
.input-group.is-invalid:not(.bootstrap-touchspin):focus-within .input-group-text {
  border-color: #de4827;
}
.input-group.disabled .input-group-text {
  background-color: #efefef;
}
.input-group.round .form-control,
.input-group.round .input-group-text, .input-group.round:focus-within {
  border-radius: 1.3125rem;
}
.input-group.square .form-control,
.input-group.square .input-group-text, .input-group.square:focus-within {
  border-radius: 0;
}
.input-group.round .input-group-prepend .input-group-text, .input-group.square .input-group-prepend .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.round .input-group-append .input-group-text, .input-group.square .input-group-append .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.round .form-control:not(:first-child), .input-group.square .form-control:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group.round .form-control:not(:last-child), .input-group.square .form-control:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.square .form-control,
.input-group.square .input-group-text {
  border-radius: 0;
}

.input-group-text {
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .input-group-text {
    transition: none;
  }
}

.input-group-prepend .input-group-text {
  border-right: 0;
}

.input-group-append .input-group-text {
  border-left: 0;
}
.input-group-append:not(:last-child) .input-group-text {
  border-right: 0;
}

.input-group-merge .form-control:not(:first-child) {
  padding-left: 0;
  border-left: 0;
}
.input-group-merge .form-control:not(:last-child) {
  padding-right: 0;
  border-right: 0;
}
.input-group-merge .form-control.is-valid ~ .input-group-append .input-group-text {
  border-color: #28c76f;
}
.input-group-text .input-group-merge .input-group-prepend ~ .form-control.is-valid {
  border-color: #28c76f;
}

textarea.form-control {
  line-height: 1.4rem;
  padding: 0.7rem 0.875rem !important;
}
textarea.form-control-sm {
  padding: 0.35rem 0.749875rem !important;
}
textarea.form-control-lg {
  padding: 0.875rem 1.000125rem !important;
}

.form-actions {
  border-top: 1px solid #dfdfdf;
  padding: 20px 0;
  margin-top: 20px;
}
.form-actions.filled {
  background-color: #f8f8f8;
}
.form-actions.center {
  text-align: center;
}
.form-actions.right {
  text-align: right;
}
.form-actions.top {
  border-top: 0;
  border-bottom: 1px solid #dfdfdf;
  margin-top: 0;
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .form-actions .buttons-group {
    float: left !important;
    margin-bottom: 10px;
  }
}

@media (min-width: 576px) {
  .form-horizontal .form-group .label-control {
    text-align: right;
  }
}

select.form-control:not([multiple=multiple]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;
  background-size: 18px 14px, 18px 14px;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 1.3125rem;
}
select.form-control.form-control-lg {
  background-position: calc(100% - 12px) 16px, calc(100% - 20px) 16px, 100% 0;
}
select.form-control.form-control-sm {
  background-position: calc(100% - 12px) 8px, calc(100% - 20px) 8px, 100% 0;
}

.custom-select {
  -moz-appearance: none;
  -webkit-appearance: none;
}

.custom-checkbox .custom-control-label::before,
.custom-checkbox .custom-control-label::after {
  top: 0.06125rem;
}
.custom-checkbox .custom-control-label::after {
  background-size: 57%;
}

.custom-radio .custom-control-label::before {
  top: 0.0875rem;
}

.custom-checkbox.custom-control,
.custom-radio.custom-control {
  padding-left: 1.575rem;
}
.input-group .custom-checkbox.custom-control,
.input-group .custom-radio.custom-control {
  padding-left: 1.1375rem;
}
.custom-checkbox .custom-control-input,
.custom-radio .custom-control-input {
  width: 1.124375rem;
  height: 1.124375rem;
}
.custom-checkbox .custom-control-label,
.custom-radio .custom-control-label {
  font-size: 0.875rem;
  position: static;
}
.custom-checkbox .custom-control-label::before, .custom-checkbox .custom-control-label::after,
.custom-radio .custom-control-label::before,
.custom-radio .custom-control-label::after {
  width: 18px;
  height: 18px;
  left: 0;
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before,
.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
  border: none;
  box-shadow: none !important;
}
.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,
.custom-radio .custom-control-input:focus ~ .custom-control-label::before {
  border-color: none;
  box-shadow: 0 2px 4px 0 rgba(0, 160, 221, 0.4) !important;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  background-color: #00a0dd;
  border-color: #00a0dd;
}

/* Floating label Group */
.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}
.form-label-group .form-control-lg ~ label {
  font-size: 1rem;
  padding: 0.875rem;
}
.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  transition: all 0.25s ease-in-out;
  padding: 0.525rem;
  pointer-events: none;
  cursor: text;
  color: rgba(30, 29, 43, 0.4);
  font-size: 0.6125rem;
  opacity: 0;
}
.form-label-group > input:focus:not(:placeholder-shown) ~ label, .form-label-group > input:not(:active):not(:placeholder-shown) ~ label,
.form-label-group textarea:focus:not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:active):not(:placeholder-shown) ~ label {
  color: #00a0dd !important;
  transition: all 0.25s ease-in-out;
  opacity: 1;
}
.form-label-group > input:not(:focus):not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:focus):not(:placeholder-shown) ~ label {
  color: rgba(30, 29, 43, 0.4) !important;
}
.form-label-group > input:not(:placeholder-shown) ~ label,
.form-label-group textarea:not(:placeholder-shown) ~ label {
  padding: 0.21875rem 0;
  top: -20px;
  left: 3px;
}
.form-label-group > input.form-control-lg:not(:placeholder-shown) ~ label,
.form-label-group textarea.form-control-lg:not(:placeholder-shown) ~ label {
  top: -23px;
}
.form-label-group > input.form-control-sm:not(:placeholder-shown) ~ label,
.form-label-group textarea.form-control-sm:not(:placeholder-shown) ~ label {
  top: -18px;
}

/* Switches */
.custom-switch {
  padding-left: 0;
  line-height: 1.4875rem;
  /*For Switch label*/
  /*For Switch Handle Animation*/
}
.custom-switch .custom-control-label {
  padding-left: 3.0625rem;
  line-height: 1.4875rem;
  /* For bg color of switch*/
  /*For Switch handle*/
  /*For Switch text*/
}
.custom-switch .custom-control-label::before {
  border: none;
  background-color: #e2e2e2;
  height: 1.4875rem;
  box-shadow: none !important;
  transition: opacity 0.25s ease, background-color 0.1s ease;
  cursor: pointer;
  user-select: none;
  top: 0;
  left: 0;
}
.custom-switch .custom-control-label:after {
  position: absolute;
  top: 4px;
  left: 4px;
  box-shadow: -1px 2px 3px 0 rgba(30, 29, 43, 0.2);
  background-color: #fdfeff;
  transition: all 0.15s ease-out;
  cursor: pointer;
  user-select: none;
}
.custom-switch .custom-control-label .switch-text-left,
.custom-switch .custom-control-label .switch-text-right,
.custom-switch .custom-control-label .switch-icon-left,
.custom-switch .custom-control-label .switch-icon-right {
  position: absolute;
  cursor: pointer;
  user-select: none;
  line-height: 1.8;
}
.custom-switch .custom-control-label .switch-text-left i,
.custom-switch .custom-control-label .switch-text-left svg,
.custom-switch .custom-control-label .switch-text-right i,
.custom-switch .custom-control-label .switch-text-right svg,
.custom-switch .custom-control-label .switch-icon-left i,
.custom-switch .custom-control-label .switch-icon-left svg,
.custom-switch .custom-control-label .switch-icon-right i,
.custom-switch .custom-control-label .switch-icon-right svg {
  height: 13px;
  width: 13px;
  font-size: 13px;
}
.custom-switch .custom-control-label .switch-text-left,
.custom-switch .custom-control-label .switch-icon-left {
  left: 6px;
  color: #fdfeff;
  opacity: 0;
  transform: translateX(8px);
  transition: opacity 0.1s ease, transform 0.15s ease;
}
.custom-switch .custom-control-label .switch-icon-right {
  right: 13px;
  opacity: 1;
  transform: translateX(0px);
  transition: opacity 0.08s ease, transform 0.15s ease;
}
.custom-switch .custom-control-label:focus {
  outline: 0;
}
.custom-switch .switch-label {
  padding-left: 0.875rem;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: none;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.225rem);
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left,
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-left {
  transform: translateX(0);
  opacity: 1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right,
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-right {
  transform: translateX(-8px);
  opacity: 0;
}
.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-left {
  opacity: 0;
}
.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-right {
  opacity: 1;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right {
  opacity: 0;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left {
  opacity: 1;
}

/* Textarea with Counter */
.textarea-counter-value {
  background-color: #00a0dd;
  color: #fdfeff;
  padding: 1px 6px;
  font-size: 0.525rem;
  border-radius: 0 0 5px 5px;
  margin-right: 0.875rem;
}

.btn.disabled-max-min {
  background-color: rgba(30, 29, 43, 0.5) !important;
  cursor: default;
}

/* Number Type Input Box Scss for - Remove arrow on hover */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .form-label-group label {
    display: none;
  }

  select.form-control:not([multiple=multiple]) {
    background: none;
  }
}
.picker__input.form-control {
  background-color: #fdfeff;
}

.input-group-append {
  height: 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
}

.stepper-btn {
  height: 50%;
  border: 1px solid #d8d6de;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.stepper-btn:focus, .stepper-btn:hover, .stepper-btn:active {
  border-color: #00a0dd;
}

.stepper-btn.top {
  border-radius: 0 5px 0 0;
}

.stepper-btn.bottom {
  border-radius: 0 0 5px 0;
}

.input-group-append .stepper-btn span {
  display: block;
}

.stepper-arrow {
  display: block;
  line-height: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
}

.btn {
  box-shadow: none;
  font-weight: 500;
}
.btn[class*=bg-gradient-] {
  transition: all 0.2s ease;
}
.btn[class*=bg-gradient-]:hover {
  transform: translateY(-2px);
}
.btn.btn-icon {
  padding: 0.625625rem 0.644rem;
}
.btn.btn-sm.btn-icon, .btn-group-sm > .btn.btn-icon {
  padding: 0.4375rem;
  line-height: 0.5;
}
.btn.btn-lg.btn-icon, .btn-group-lg > .btn.btn-icon {
  padding: 0.875rem;
  line-height: 0.75;
}
.btn:focus, .btn.focus, .btn:active, .btn.active {
  outline: none;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: none !important;
}
.btn .feather {
  vertical-align: bottom;
}

.btn.waves-input-wrapper {
  padding: 0;
}

@media (max-width: 767.98px) {
  .btn-sm-block {
    display: block;
    width: 100%;
  }
}
.waves-effect {
  cursor: inherit;
}

.dropdown-toggle-split {
  padding-right: 0.6907894737rem;
  padding-left: 0.6907894737rem;
}

.btn-lg + .dropdown-toggle-split,
.btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1rem;
  padding-left: 1rem;
}

.btn-sm + .dropdown-toggle-split,
.btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.4605263158rem;
  padding-left: 0.4605263158rem;
}

.btn-group [class*=btn-]:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]) {
  border-left-color: rgba(30, 29, 43, 0.08) !important;
  border-right-color: rgba(30, 29, 43, 0.08) !important;
}

.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-child,
.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-of-type {
  border-left-color: transparent !important;
}

.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-child,
.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-of-type {
  border-right-color: transparent !important;
}

.btn-group-toggle [class*=btn-outline-]:not(:last-child) {
  border-right-width: 0 !important;
}
.btn-group-toggle :not([class*=btn-outline-]).active, .btn-group-toggle :not([class*=btn-outline-]):active {
  box-shadow: inset 0 4px 24px 0 rgba(30, 29, 43, 0.1);
}

.btn-group .button-group-selected {
  background-color: #02A0DD;
  border-color: #02A0DD;
  color: #fff;
}
.btn-group .button-group-selected:hover {
  background-color: #0290bb;
  border-color: #0290bb;
}
.btn-group .button-group-selected:active {
  background-color: #027ab8 !important;
  border-color: #027ab8 !important;
}

.btn-group .button-group-unselected {
  background-color: #D8DEE9;
  border-color: #D8DEE9;
  color: #000;
}
.btn-group .button-group-unselected:hover {
  background-color: #c0c7d1;
  border-color: #c0c7d1;
}
.btn-group .button-group-unselected:active {
  background-color: #b0bccd !important;
  border-color: #b0bccd !important;
}

.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {
  border-left: 0 !important;
}
.dropdown.no-arrow .dropdown-toggle:after {
  display: none;
}
.dropdown.no-arrow .dropdown-toggle i,
.dropdown.no-arrow .dropdown-toggle svg {
  margin-right: 0;
}

.dropdown-menu {
  border-radius: 0.358rem;
  transform: scale(1, 0);
  box-shadow: 0 5px 25px rgba(30, 29, 43, 0.1);
}
.dropdown-menu .dropdown-item {
  width: auto;
  cursor: pointer;
}
.dropdown-menu .dropdown-header {
  font-weight: 500;
  line-height: 1;
}

.show > .dropdown-menu {
  transform: scale(1, 1);
  opacity: 1;
  display: block;
}
.show > .dropdown-content {
  max-height: 500px;
  overflow: scroll;
  overflow-x: hidden;
}
.show .dropdown-toggle:focus {
  box-shadow: none;
}
.show .btn.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown-toggle::after {
  border: none !important;
  content: " ";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  color: #6e6b7b;
  width: 14px;
  height: 11px;
  position: relative;
  top: 1px;
  right: 0px;
  left: 0.62475rem;
  padding: 0;
  margin: 0;
  vertical-align: 0;
}
.dropdown-toggle.btn-lg::after, .btn-group-lg > .dropdown-toggle.btn::after {
  background-size: 18px;
}
.dropdown-toggle.btn-sm::after, .btn-group-sm > .dropdown-toggle.btn::after {
  background-size: 14px;
}
.dropdown-toggle.dropdown-toggle-split:after {
  left: 0;
}
.dropdown-toggle.nav-hide-arrow::after {
  display: none;
}
.dropdown-toggle:focus {
  outline: 0;
}

.dropup {
  position: relative;
}
.dropup .dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  width: 14px;
  height: 11px;
  content: "";
  vertical-align: 0.04375rem;
}
.dropup .dropdown-menu {
  min-width: 7rem;
}

.dropleft .dropdown-toggle::before {
  border: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  width: 14px;
  height: 11px;
  content: "";
  position: relative;
  left: 0;
}
.dropleft .dropdown-menu {
  min-width: 7rem;
}

.dropright .dropdown-toggle::after {
  border: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  width: 14px;
  height: 11px;
  content: "";
}
.dropright .dropdown-menu {
  min-width: 7rem;
}

.dropdown-menu[x-placement=bottom-start], .dropdown-menu[x-placement=bottom-end] {
  margin-top: 0.5rem;
}
.dropdown-menu[x-placement=top-start], .dropdown-menu[x-placement=top-end] {
  margin-bottom: 0.5rem;
}
.dropdown-menu[x-placement=right-start] {
  margin-left: 0.5rem;
}
.dropdown-menu[x-placement=left-start] {
  margin-right: 0.5rem;
}

.dropdown.dropdown-icon-wrapper .dropdown-toggle:after,
.dropup.dropdown-icon-wrapper .dropdown-toggle:after {
  display: none;
}
.dropdown.dropdown-icon-wrapper .dropdown-menu,
.dropup.dropdown-icon-wrapper .dropdown-menu {
  min-width: auto;
}
.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item,
.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item {
  padding: 0.4375rem 0.9625rem;
  cursor: pointer;
}
.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,
.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg,
.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,
.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg {
  height: 1.1375rem;
  width: 1.1375rem;
  font-size: 1.1375rem;
}

.horizontal-menu-wrapper .dropdown-menu,
.header-navbar .dropdown-menu {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: slideIn;
}

.dropdown-toggle.hide-arrow::before, .dropdown-toggle.hide-arrow::after,
.dropdown-toggle-hide-arrow > .dropdown-toggle::before,
.dropdown-toggle-hide-arrow > .dropdown-toggle::after {
  display: none;
}

@keyframes slideIn {
  0% {
    transform: translateY(0.875rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
  0% {
    transform: translateY(0.875rem);
    opacity: 0;
  }
}
/* ===============================================================================================
    File Name: navbar.scss
    Description: Contain header navigation bar, vertical main navigation bar and
    horiznotal main navigation bar related SCSS.
    ----------------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
================================================================================================*/
.header-navbar {
  padding: 0px;
  min-height: 4.375rem;
  font-family: "Montserrat", Helvetica, Arial, serif;
  transition: 300ms ease all, background 0s;
  z-index: 997;
}
.header-navbar.fixed-top {
  left: 260px;
}
.header-navbar.floating-nav {
  position: fixed;
  right: 0;
  margin: 1.1375rem 1.75rem 0;
  width: calc(100vw - (100vw - 100%) - calc(1.75rem * 2) - 260px);
  border-radius: 0.428rem;
  z-index: 12;
}
.header-navbar.navbar-static-top {
  top: 0;
  right: 0;
  left: 260px;
  width: calc(100vw - (100vw - 100%) - 260px);
  background: transparent;
  box-shadow: none !important;
}
.header-navbar.navbar-border {
  border-bottom: 1px solid #ebe9f1;
}
.header-navbar.navbar-shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);
}
.header-navbar.navbar-dark.navbar-border {
  border-bottom: 1px solid #3b4253;
}
.header-navbar .navbar-container {
  padding: 0.7rem 0.875rem;
  flex-basis: 100%;
  transition: 300ms ease all;
  margin-left: 0;
}
@media (min-width: 576px) {
  .header-navbar .navbar-container {
    padding: 0.7rem 1.225rem;
  }
}
.header-navbar .navbar-container .bookmark-wrapper .bookmark-input {
  z-index: 1;
}
.header-navbar .navbar-container .dropdown-language .selected-language {
  font-weight: 500;
}
.header-navbar .navbar-container .dropdown-language .dropdown-menu .dropdown-item .flag-icon {
  margin-right: 0.35rem;
}
.header-navbar .navbar-container .dropdown-menu-media {
  width: 26.25rem;
}
.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header {
  border-bottom: 1px solid #ebe9f1;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media {
  padding: 0.7875rem 1.12rem;
  border: none;
  border-bottom: 1px solid #ebe9f1;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media:hover {
  background: #f8f8f8;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list .media .media-meta {
  color: #6e6b7b;
}
.header-navbar .navbar-container .dropdown-menu-media .media-list a:last-of-type .media {
  border-bottom: none;
}
.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer {
  border-top: 1px solid #ebe9f1;
}

.header-navbar-shadow {
  display: none;
}

.navbar-floating .navbar-container {
  padding: 0.7rem 0.875rem;
}
.navbar-floating .header-navbar-shadow {
  display: block;
  background: linear-gradient(180deg, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0));
  padding-top: 1.925rem;
  background-repeat: repeat;
  width: 100%;
  height: 102px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}

.navbar-light {
  background: #fbfbfe;
}
.navbar-light.navbar-horizontal {
  background: #fbfbfe;
}

.navbar-dark {
  background: #2b2a33;
}
.navbar-dark .navbar-brand {
  color: #fdfeff !important;
}
.navbar-dark.navbar-horizontal {
  background: #2b2a33;
}
.navbar-dark .nav-search .form-control,
.navbar-dark .nav-search .btn-secondary {
  color: #fdfeff;
  background: #b8c2cc;
}

@media (max-width: 767.98px) {
  .header-navbar .navbar-container .show .dropdown-menu {
    right: 0;
    float: none;
    width: auto !important;
    margin-top: 0;
    margin-left: -210px;
    overflow: hidden;
  }
  .header-navbar .navbar-container .dropdown-user .dropdown-menu-right {
    right: 0 !important;
  }
}
.dropdown-menu {
  padding: 11px;
  margin: 10px 0;
}

@media (min-width: 780px) {
  /* Adjust this breakpoint as needed */
  .custom-dropdown-menu {
    width: 300px !important;
    /* Re-enable the transform if needed, otherwise, leave it commented out */
    transform: translate3d(-95px, 9px, 0px) !important;
  }
}
.custom-dropdown-toggle {
  display: inline-flex;
  align-items: center;
  background-color: #f8f9fa;
  color: #000;
  padding: 0.21875rem 0.4375rem;
  border-radius: 0.21875rem;
  text-decoration: none;
  border: 1px solid #d1d3d4;
  font-size: 0.7875rem;
}

.custom-dropdown-toggle-dark {
  display: inline-flex;
  align-items: center;
  background-color: #2b2b32;
  color: #adb0b6;
  padding: 0.21875rem 0.4375rem;
  border-radius: 0.21875rem;
  text-decoration: none;
  border: 1px solid #6a6b6c;
  font-size: 0.7875rem;
}

.header-navbar.floating-nav {
  width: calc(100vw - (100vw - 100%) - calc(1.75rem * 2));
}
.header-navbar.navbar-static-top {
  left: 0;
  width: 100%;
}

@media (max-width: 575.98px) {
  .header-navbar.floating-nav {
    width: calc( 100vw - (100vw - 100%) - calc(1.75rem + 0.35rem) ) !important;
    margin-left: 0.875rem;
    margin-right: 1.05rem;
  }
}
/* ----------- iPhone 5, 5S  iPhone 6----------- */
/* Landscape */
@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .header-navbar .navbar-container .show .dropdown-menu {
    max-height: 180px;
  }
}
/* ----------- iPhone 6+ ----------- */
/* Landscape */
@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .header-navbar .navbar-container .show .dropdown-menu {
    max-height: 280px;
  }
}
@media (max-width: 1201px) {
  .header-navbar.fixed-top {
    left: 0;
  }

  .horizontal-layout .header-navbar .navbar-container {
    padding-left: 0.7rem;
    padding-right: 0.7rem;
  }
}
@media (max-width: 575.98px) {
  .navbar-container .dropdown-menu {
    margin-top: 30px !important;
  }
}
.breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {
  content: " ";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: center;
  color: #6e6b7b;
  margin-right: 0.525rem;
  background-size: 14px;
}
/* Component Specific */
.breadcrumb-slash.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "/";
}

.breadcrumb-dots.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: ".";
  position: relative;
  top: -4px;
}

.breadcrumb-dashes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "-";
}

.breadcrumb-pipes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "|";
}

.breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: " ";
}

@media (max-width: 648px) {
  .content-header .breadcrumb {
    display: none;
  }

  .breadcrumbs-top .content-header-title {
    display: contents !important;
  }
}
.badge {
  color: #fdfeff;
}
.badge[class*=badge-] [class*=icon-] {
  line-height: 1;
}
.badge[class*=badge-] a {
  color: #fdfeff;
}
.badge[class*=badge-] .dropdown-toggle span,
.badge[class*=badge-] .dropdown-toggle i,
.badge[class*=badge-] .dropdown-toggle svg, .badge[class*=badge-].dropdown-toggle span,
.badge[class*=badge-].dropdown-toggle i,
.badge[class*=badge-].dropdown-toggle svg {
  vertical-align: text-top;
}
.badge[class*=badge-] .dropdown-toggle i,
.badge[class*=badge-] .dropdown-toggle svg, .badge[class*=badge-].dropdown-toggle i,
.badge[class*=badge-].dropdown-toggle svg {
  padding-left: 0.175rem;
}
.badge[class*=badge-] .dropdown-toggle::after, .badge[class*=badge-].dropdown-toggle::after {
  position: relative;
  top: 0;
  left: 0;
  font-size: 0.875rem;
}
.badge[class*=badge-] .dropdown-menu a {
  color: #6e6b7b;
}
.badge i,
.badge svg {
  height: 12px;
  width: 11px;
  font-size: 12px;
  stroke-width: 3;
  vertical-align: top;
}
.badge.badge-square {
  border-radius: 0;
}
.badge.badge-up {
  position: absolute;
  top: -11px;
  right: -9px;
  min-width: 1.250375rem;
  min-height: 1.250375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.68775rem;
  line-height: 0.786;
  padding-left: 0.21875rem;
  padding-right: 0.21875rem;
}
.badge.badge-up.badge-sm {
  top: -0.4375rem;
  right: -0.4375rem;
}

.badge-icon i,
.badge-icon svg {
  font-size: 100%;
  margin-right: 5px;
}

.dropup .badge {
  cursor: pointer;
}

.nav-pills {
  margin-bottom: 0.875rem;
}
.nav-pills.dropdown.show .dropdown-item.active:hover {
  color: #00a0dd;
}
.nav-pills.nav-justified {
  width: 100%;
}
.nav-pills.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}

.nav-tabs {
  margin-bottom: 0.875rem;
  position: relative;
}
.nav-tabs.nav-justified {
  width: 100%;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}

.nav-vertical {
  overflow: hidden;
}
.nav-vertical .nav.nav-tabs.nav-left {
  float: left;
  display: table;
  margin-right: 0.875rem;
}
.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {
  display: none;
  overflow-y: auto;
  padding-left: 0.875rem;
}
.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane.active {
  display: block;
}
.nav-vertical .nav.nav-tabs.nav-right {
  float: right;
  display: table;
  margin-left: 0.875rem;
}
.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {
  display: none;
  overflow-y: auto;
  padding-right: 0.875rem;
}
.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane.active {
  display: block;
}

.media-list .media {
  padding: 1.09375rem;
  width: 100%;
  margin-top: 0;
}
.media-list .media .media-left {
  margin-right: 0.875rem;
}
.media-list .media .media-right {
  margin-left: 0.875rem;
}
.media-list a.media {
  color: #b8c2cc !important;
}

.media-bordered .media:not(:first-child) {
  border-top: 1px solid #ebe9f1;
}

/*=========================================================================================
  File Name: progress.scss
  Description: Extended bootstrap progress bar scss.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: PIXINVENT
  Author URL: http://www.themeforest.net/user/pixinvent
  ----------------------------------------------------------------------------------------
==========================================================================================*/
.progress .progress-bar + .progress-bar:not(:last-child) {
  border-radius: 0;
}
.progress .progress-bar:last-child {
  border-top-right-radius: 4.375rem;
  border-bottom-right-radius: 4.375rem;
}

/* ===============================================================================================
  File Name: list-group.scss
  Description: Contain list item, list group related extended SCSS.
  ----------------------------------------------------------------------------------------------
  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: PIXINVENT
  Author URL: http://www.themeforest.net/user/pixinvent
================================================================================================*/
ul.list-inline li {
  display: inline-block;
}
ul.list-inline.list-inline-pipe > li + li:before {
  content: " | ";
  padding-right: 2px;
}

.list-group .list-group-item {
  line-height: 1.5;
}
.list-group .list-group-item.active:hover {
  background-color: #00a0dd;
}
.list-group .list-group-item.active:focus {
  outline: 0;
}
.list-group .list-group-item.active:focus:hover {
  color: #fdfeff;
}
.list-group .list-group-item.active small {
  color: #fdfeff !important;
}
.list-group .list-group-item:hover {
  background-color: #f8f8f8;
}
.list-group .list-group-item i,
.list-group .list-group-item svg {
  position: relative;
}
.list-group .list-group-item:not(.active):focus:active {
  color: inherit;
}
.list-group .list-group-item-action.active {
  background-color: #00a0dd;
  color: #fdfeff;
}
.list-group .list-group-item-action.active:focus {
  background-color: #00a0dd;
}
.list-group .list-group-item-action:focus {
  background-color: #f8f8f8;
  outline: 0;
}
.list-group.list-group-circle {
  border: none;
}
.list-group.list-group-circle .list-group-item {
  border: none;
  position: relative;
  padding-left: 1.3125rem;
}
.list-group.list-group-circle .list-group-item:after {
  content: " ";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-position: center;
  color: #6e6b7b;
  background-size: 10px;
  position: absolute;
  height: 10px;
  width: 10px;
  top: 1.00625rem;
  left: 0;
}
.list-group.list-group-circle .list-group-item:hover {
  background-color: transparent;
}

.list-group-item.gu-mirror {
  border-radius: 0;
}

[class*=collapse-] .collapse-title {
  font-weight: 500;
  font-size: 0.9625rem;
}
[class*=collapse-] .card {
  margin-bottom: 0;
}
[class*=collapse-] .card:last-of-type {
  margin-bottom: 0;
}
[class*=collapse-] .card:not(:last-of-type) {
  border-bottom: 1px solid #ebe9f1;
}
[class*=collapse-] .card .card-header {
  cursor: pointer;
  padding: 0.875rem 2.45rem 0.875rem 0.875rem;
}
[class*=collapse-] .card .card-body {
  padding: 0.875rem;
  line-height: 1.5;
  padding-top: 0.3675rem;
}

.collapse-title {
  color: inherit;
}
.collapse-title:hover {
  color: inherit;
}

.collapse-default .card:first-child {
  border-top: 0;
}
.collapse-default .card:last-child {
  border-bottom: 0;
}
.collapse-default .card {
  border-radius: 0;
}

.collapse-border .card {
  border: 1px solid #ebe9f1;
}
.collapse-border .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.collapse-border .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.collapse-shadow {
  box-shadow: 0 0px 4px 0 rgba(30, 29, 43, 0.1);
  padding: 0.13125rem 0.65625rem;
  border-radius: 0.3125rem;
}
.collapse-shadow .card {
  border-radius: 0;
  transition: border 0.5s ease-in-out, all 0.3s ease-in-out;
}
.collapse-shadow .card.open {
  border-radius: 0.499625rem;
  margin: 10px 0;
  border: 0;
  box-shadow: 0px 0px 8px 0px rgba(30, 29, 43, 0.1) !important;
}
.collapse-shadow .card:first-child {
  border-top-left-radius: 0.499625rem;
  border-top-right-radius: 0.499625rem;
}
.collapse-shadow .card:last-child {
  border-bottom-left-radius: 0.499625rem;
  border-bottom-right-radius: 0.499625rem;
}

.collapse-margin .card {
  margin-top: 0.62125rem;
  margin-bottom: 0.62125rem;
  box-shadow: 0 2px 15px 0 rgba(30, 29, 43, 0.05) !important;
  border-radius: 0.31325rem;
  border-bottom: 0 solid transparent !important;
}
.collapse-margin .card-header {
  border-radius: 0.31325rem;
}

.collapse-icon .card-header {
  position: relative;
}
.collapse-icon [data-toggle=collapse]:after {
  position: absolute;
  top: 58%;
  right: 0.875rem;
  margin-top: -8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  width: 14px;
  height: 11px;
  content: "";
  transition: all 300ms linear 0s;
}
.collapse-icon [data-toggle=collapse]:disabled:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.collapse-icon [aria-expanded=false]:after {
  transform: rotate(-180deg);
}

.page-item {
  border-radius: 4.375rem;
}
.page-item:not(.prev-item) .page-link, .page-item:not(.next-item) .page-link, .page-item:not(.first) .page-link, .page-item:not(.last) .page-link, .page-item:not(.active) .page-link {
  line-height: 1.3;
}
.page-item .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-item.previous .page-link, .page-item.prev .page-link, .page-item.next .page-link, .page-item.first .page-link, .page-item.last .page-link {
  width: auto;
}
.page-item.prev-item .page-link, .page-item.next-item .page-link {
  transition: all 0.2s ease-out;
}
.page-item.prev-item {
  margin-right: 0.3124625rem;
}
.page-item.prev-item .page-link {
  border-radius: 50%;
}
.page-item.prev-item .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  color: #6e6b7b;
  width: 8px;
  height: 18px;
  content: "";
}
.page-item.prev-item .page-link:hover {
  background: #f3f2f7;
  color: #00a0dd;
}
.page-item.prev-item .page-link:active, .page-item.prev-item .page-link:hover {
  background-color: #00a0dd !important;
}
.page-item.prev-item .page-link:active:before, .page-item.prev-item .page-link:hover:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
}
.page-item.prev-item.disabled .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.page-item.prev-item ~ .page-item:nth-child(2) {
  border-top-left-radius: 4.375rem;
  border-bottom-left-radius: 4.375rem;
}
.page-item.prev-item ~ .page-item:nth-child(2) .page-link {
  border-top-left-radius: 4.375rem !important;
  border-bottom-left-radius: 4.375rem !important;
}
.page-item.prev-item ~ .page-item:nth-last-child(2) {
  border-top-right-radius: 4.375rem;
  border-bottom-right-radius: 4.375rem;
}
.page-item.prev-item ~ .page-item:nth-last-child(2) .page-link {
  border-top-right-radius: 4.375rem !important;
  border-bottom-right-radius: 4.375rem !important;
}
.page-item.next-item {
  margin-left: 0.3124625rem;
}
.page-item.next-item .page-link {
  border-radius: 50%;
}
.page-item.next-item .page-link:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  width: 8px;
  height: 18px;
  content: "";
}
.page-item.next-item .page-link:hover {
  background: #f3f2f7;
  color: #00a0dd;
}
.page-item.next-item .page-link:active, .page-item.next-item .page-link:hover {
  background-color: #00a0dd !important;
}
.page-item.next-item .page-link:active:after, .page-item.next-item .page-link:hover:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) !important;
}
.page-item.next-item.disabled .page-link:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.page-item.prev .page-link:before, .page-item.previous .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  color: #6e6b7b;
  width: 12px;
  height: 18px;
  content: "";
}
.page-item.prev .page-link:hover:before, .page-item.previous .page-link:hover:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
}
.page-item.prev.disabled .page-link:before, .page-item.previous.disabled .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.page-item.next .page-link:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px;
  color: #6e6b7b;
  width: 12px;
  height: 18px;
  content: "";
}
.page-item.next .page-link:hover:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) !important;
}
.page-item.next.disabled .page-link:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.page-item.disabled .page-link {
  color: #b9b9c3;
}
.page-item .page-link {
  border: none;
  margin: 0;
  margin-left: 0;
  font-size: 0.875rem;
  min-width: 2.00025rem;
}
.page-item .page-link:focus {
  box-shadow: none;
}
.page-item .page-link:hover {
  color: #00a0dd;
}
.page-item.active {
  background-color: #f3f2f7;
  border-radius: 0;
}
.page-item.active .page-link {
  z-index: 3;
  border-radius: 4.375rem;
  background-color: #00a0dd;
  color: #fdfeff !important;
  font-weight: 600;
}
.page-item:first-child:not(.prev-item).active {
  border-top-left-radius: 1.2495rem;
  border-bottom-left-radius: 1.2495rem;
}
.page-item:first-child:not(.prev-item).active .page-link {
  border-radius: 4.375rem;
}
.page-item:first-child:not(.prev-item) .page-link {
  border-top-left-radius: 1.2495rem;
  border-bottom-left-radius: 1.2495rem;
}
.page-item:last-child:not(.next-item).active {
  border-top-right-radius: 1.2495rem;
  border-bottom-right-radius: 1.2495rem;
}
.page-item:last-child:not(.next-item).active .page-link {
  border-radius: 4.375rem;
}
.page-item:last-child:not(.next-item) .page-link {
  border-top-right-radius: 1.2495rem;
  border-bottom-right-radius: 1.2495rem;
}

.pagination.pagination-lg .page-item .page-link {
  font-size: 1.14rem;
  min-width: 2.275rem;
}
.pagination.pagination-sm .page-item .page-link {
  font-size: 0.857rem;
  min-width: 1.75rem;
}

.modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.modal .modal-header .close {
  padding: 0.175rem 0.5425rem;
  box-shadow: 0 5px 20px 0 rgba(30, 29, 43, 0.1);
  border-radius: 0.3125rem;
  background: #fdfeff;
  opacity: 1;
  transition: all 0.23s ease 0.1s;
  position: relative;
  transform: translate(8px, -2px);
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus, .modal .modal-header .close:active {
  opacity: 1;
  outline: none;
  transform: translate(5px, 3px);
  box-shadow: none;
}
.modal .modal-content {
  border: none;
  overflow: visible;
  box-shadow: 0 5px 20px 0 rgba(30, 29, 43, 0.1);
}
.modal .modal-footer {
  padding: 0.7rem 1.225rem;
}
.modal.modal-sticky {
  bottom: 0;
  right: 0;
  top: auto;
  left: auto;
  height: auto;
  position: fixed;
}
.modal.modal-sticky .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modal.modal-sticky .modal-dialog {
  margin-right: 1.75rem !important;
  box-shadow: 0px 0px 24px 0 rgba(30, 29, 43, 0.25);
  border-radius: 0.3125rem;
}
.modal.modal-sticky .modal-actions {
  background: transparent;
  box-shadow: none;
  line-height: 0;
}

.modal-xs {
  max-width: 300px;
}

@media (min-width: 1200px) {
  .modal-xl {
    margin-left: 3%;
    margin-right: 3%;
  }
}
.modal-slide-in,
.modal-slide-in .modal {
  padding: 0 !important;
  overflow: hidden !important;
}

.modal-slide-in .modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  margin: 0;
  max-width: none;
  width: 16.875rem;
}
.modal-slide-in .modal-dialog .modal-content {
  padding-bottom: 3.2375rem;
  padding-top: 3.2375rem;
  overflow: auto;
  border-radius: 0;
  height: 100%;
}
.modal-slide-in .modal-dialog .modal-body {
  padding-bottom: 0;
  padding-top: 0;
  margin: auto 0;
  flex-grow: 0;
}
@media (min-width: 576px) {
  .modal-slide-in .modal-dialog {
    width: 24.5rem;
  }
}
.modal-slide-in .modal-dialog.sidebar-sm {
  width: 21.875rem;
}
@media (min-width: 576px) {
  .modal-slide-in .modal-dialog.sidebar-lg {
    width: 26.25rem;
  }
}
.modal-slide-in .close {
  top: 0.35rem;
  z-index: 10;
  transform: none;
  position: absolute;
  top: 1.3125rem;
  right: 1.225rem;
  margin: 0;
  padding: 0 !important;
  line-height: 0.5;
  transform: translate(0, -50%);
}

.modal-slide-in.fade .modal-dialog,
.modal-slide-in .modal.fade .modal-dialog {
  transform: translateX(100%);
  transition: transform 0.1s ease-out;
}

.modal-slide-in.show .modal-dialog,
.modal-slide-in .modal.show .modal-dialog {
  transform: translateX(0) !important;
  transition: transform 0.1s ease-out;
}

@media (max-width: 576px) {
  .modal {
    padding-right: 0.875rem;
    padding-left: 0.875rem;
  }
  .modal .modal-xs,
.modal .modal-sm {
    max-width: unset;
  }
  .modal.modal-sticky .modal-dialog {
    margin-right: 0.175rem !important;
    margin-left: 0.175rem;
    margin-bottom: 2.625rem;
  }
}
.popover {
  box-shadow: 0 0 10px 0 rgba(30, 29, 43, 0.1);
  z-index: 2000 !important;
}
.popover .popover-header {
  font-size: 0.93625rem;
  border: 1px solid #00a0dd;
}
.popover .popover-body {
  border: 1px solid #ebe9f1;
  border-top-color: #fdfeff;
  border-bottom-left-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}
.popover.bs-popover-bottom .arrow:after, .popover.bs-popover-auto[x-placement^=bottom] .arrow:after {
  border-bottom-color: #00a0dd;
}

.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
}

.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
}

.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
}

.font-small-1 {
  font-size: 0.6125rem !important;
}
svg.font-small-1 {
  height: 0.6125rem !important;
  width: 0.6125rem !important;
}

.font-small-2 {
  font-size: 0.7rem !important;
}
svg.font-small-2 {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.font-small-3 {
  font-size: 0.7875rem !important;
}
svg.font-small-3 {
  height: 0.7875rem !important;
  width: 0.7875rem !important;
}

.font-small-4 {
  font-size: 0.875rem !important;
}
svg.font-small-4 {
  height: 0.875rem !important;
  width: 0.875rem !important;
}

.font-medium-1 {
  font-size: 0.9625rem !important;
}
svg.font-medium-1 {
  height: 0.9625rem !important;
  width: 0.9625rem !important;
}

.font-medium-2 {
  font-size: 1.05rem !important;
}
svg.font-medium-2 {
  height: 1.05rem !important;
  width: 1.05rem !important;
}

.font-medium-3 {
  font-size: 1.1375rem !important;
}
svg.font-medium-3 {
  height: 1.1375rem !important;
  width: 1.1375rem !important;
}

.font-medium-4 {
  font-size: 1.225rem !important;
}
svg.font-medium-4 {
  height: 1.225rem !important;
  width: 1.225rem !important;
}

.font-medium-5 {
  font-size: 1.3125rem !important;
}
svg.font-medium-5 {
  height: 1.3125rem !important;
  width: 1.3125rem !important;
}

.font-large-1 {
  font-size: 1.75rem !important;
}
svg.font-large-1 {
  height: 1.75rem !important;
  width: 1.75rem !important;
}

.font-large-2 {
  font-size: 2.625rem !important;
}
svg.font-large-2 {
  height: 2.625rem !important;
  width: 2.625rem !important;
}

.font-large-3 {
  font-size: 3.5rem !important;
}
svg.font-large-3 {
  height: 3.5rem !important;
  width: 3.5rem !important;
}

.font-large-4 {
  font-size: 4.375rem !important;
}
svg.font-large-4 {
  height: 4.375rem !important;
  width: 4.375rem !important;
}

.font-large-5 {
  font-size: 5.25rem !important;
}
svg.font-large-5 {
  height: 5.25rem !important;
  width: 5.25rem !important;
}

.line-height-1 {
  line-height: 1 !important;
}

.line-height-condensed {
  line-height: 1.5 !important;
}

.line-height-inherit {
  line-height: inherit !important;
}

.rotate-45 {
  transform: rotate(45deg);
}

.rotate-45-inverse {
  transform: rotate(-45deg);
}

.rotate-90 {
  transform: rotate(90deg);
}

.rotate-90-inverse {
  transform: rotate(-90deg);
}

.rotate-180 {
  transform: rotate(180deg);
}

.rotate-180-inverse {
  transform: rotate(-180deg);
}

.border-2 {
  border-width: 2px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.round {
  border-radius: 1.3125rem;
}

.square {
  border-radius: 0;
}

.fit {
  max-width: 100% !important;
}

.half-width {
  width: 50% !important;
}

.full-width {
  width: 100% !important;
}

.full-height {
  height: 100% !important;
}

.height-50 {
  height: 50px !important;
}

.width-50 {
  width: 50px !important;
}

.height-100 {
  height: 100px !important;
}

.width-100 {
  width: 100px !important;
}

.height-150 {
  height: 150px !important;
}

.width-150 {
  width: 150px !important;
}

.height-200 {
  height: 200px !important;
}

.width-200 {
  width: 200px !important;
}

.height-250 {
  height: 250px !important;
}

.width-250 {
  width: 250px !important;
}

.height-300 {
  height: 300px !important;
}

.width-300 {
  width: 300px !important;
}

.height-350 {
  height: 350px !important;
}

.width-350 {
  width: 350px !important;
}

.height-400 {
  height: 405px !important;
}

.width-400 {
  width: 405px !important;
}

.height-450 {
  height: 455px !important;
}

.width-450 {
  width: 455px !important;
}

.height-500 {
  height: 500px !important;
}

.width-500 {
  width: 500px !important;
}

.height-550 {
  height: 550px !important;
}

.width-550 {
  width: 550px !important;
}

.height-600 {
  height: 600px !important;
}

.width-600 {
  width: 600px !important;
}

.height-650 {
  height: 650px !important;
}

.width-650 {
  width: 650px !important;
}

.height-700 {
  height: 700px !important;
}

.width-700 {
  width: 700px !important;
}

.height-750 {
  height: 750px !important;
}

.width-750 {
  width: 750px !important;
}

.height-800 {
  height: 800px !important;
}

.width-800 {
  width: 800px !important;
}

.height-5-per {
  height: 5% !important;
}

.width-5-per {
  width: 5% !important;
}

.height-10-per {
  height: 10% !important;
}

.width-10-per {
  width: 10% !important;
}

.height-15-per {
  height: 15% !important;
}

.width-15-per {
  width: 15% !important;
}

.height-20-per {
  height: 20% !important;
}

.width-20-per {
  width: 20% !important;
}

.height-25-per {
  height: 25% !important;
}

.width-25-per {
  width: 25% !important;
}

.height-30-per {
  height: 30% !important;
}

.width-30-per {
  width: 30% !important;
}

.height-35-per {
  height: 35% !important;
}

.width-35-per {
  width: 35% !important;
}

.height-40-per {
  height: 40% !important;
}

.width-40-per {
  width: 40% !important;
}

.height-45-per {
  height: 45% !important;
}

.width-45-per {
  width: 45% !important;
}

.height-50-per {
  height: 50% !important;
}

.width-50-per {
  width: 50% !important;
}

.height-55-per {
  height: 55% !important;
}

.width-55-per {
  width: 55% !important;
}

.height-60-per {
  height: 60% !important;
}

.width-60-per {
  width: 60% !important;
}

.height-65-per {
  height: 65% !important;
}

.width-65-per {
  width: 65% !important;
}

.height-70-per {
  height: 70% !important;
}

.width-70-per {
  width: 70% !important;
}

.height-75-per {
  height: 75% !important;
}

.width-75-per {
  width: 75% !important;
}

.height-80-per {
  height: 80% !important;
}

.width-80-per {
  width: 80% !important;
}

.height-85-per {
  height: 85% !important;
}

.width-85-per {
  width: 85% !important;
}

.height-90-per {
  height: 90% !important;
}

.width-90-per {
  width: 90% !important;
}

.height-95-per {
  height: 95% !important;
}

.width-95-per {
  width: 95% !important;
}

.position-top-0 {
  top: 0;
}

.position-right-0 {
  right: 0;
}

.position-bottom-0 {
  bottom: 0;
}

.position-left-0 {
  left: 0;
}

.overflow-visible {
  overflow: visible;
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-x-scroll {
  overflow: scroll;
}

.overflow-y-scroll {
  overflow: scroll;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-move {
  cursor: move;
}

.cursor-default {
  cursor: default;
}

.cursor-progress {
  cursor: progress;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.zindex-1 {
  z-index: 1 !important;
}

.zindex-2 {
  z-index: 2 !important;
}

.zindex-3 {
  z-index: 3 !important;
}

.zindex-4 {
  z-index: 4 !important;
}

.zindex-0 {
  z-index: 0 !important;
}

.zindex-minus-1 {
  z-index: -1 !important;
}

.zindex-minus-2 {
  z-index: -2 !important;
}

.zindex-minus-3 {
  z-index: -3 !important;
}

.zindex-minus-4 {
  z-index: -4 !important;
}

.box-shadow-0 {
  box-shadow: none !important;
}

.box-shadow-1 {
  box-shadow: 0 2px 5px 0 rgba(30, 29, 43, 0.16), 0 2px 10px 0 rgba(30, 29, 43, 0.12);
}

.box-shadow-2 {
  box-shadow: 0 8px 17px 0 rgba(30, 29, 43, 0.2), 0 6px 20px 0 rgba(30, 29, 43, 0.19);
}

.box-shadow-3 {
  box-shadow: 0 12px 15px 0 rgba(30, 29, 43, 0.24), 0 17px 50px 0 rgba(30, 29, 43, 0.19);
}

.box-shadow-4 {
  box-shadow: 0 16px 28px 0 rgba(30, 29, 43, 0.22), 0 25px 55px 0 rgba(30, 29, 43, 0.21);
}

.box-shadow-5 {
  box-shadow: 0 27px 24px 0 rgba(30, 29, 43, 0.2), 0 40px 77px 0 rgba(30, 29, 43, 0.22);
}

.box-shadow-6 {
  box-shadow: 0 4px 8px 0 rgba(30, 29, 43, 0.12), 0 2px 4px 0 rgba(30, 29, 43, 0.08);
}

.outline-none {
  outline: none !important;
}

.list-style-inside {
  list-style: inside;
}

.list-style-circle {
  list-style: circle;
}

.list-style-square {
  list-style: square;
}

.bg-cover {
  background-size: cover !important;
}

.background-repeat {
  background-repeat: repeat !important;
}

.background-no-repeat {
  background-repeat: no-repeat !important;
}

.icon-bg-circle {
  color: #fdfeff;
  padding: 0.4375rem;
  border-radius: 50%;
}

.icon-left {
  margin-right: 0.4375rem;
}

.icon-right {
  margin-right: 0.4375rem;
}

.blockOverlay {
  z-index: 1050 !important;
}

.blockElement,
.blockPage {
  z-index: 1051 !important;
}

.hidden {
  display: none;
  visibility: hidden;
}

a:hover {
  cursor: pointer;
}

.table-middle td {
  vertical-align: middle;
}

.fill-current {
  fill: currentColor;
}

.pointer-events-none {
  pointer-events: none;
}

.bg-white {
  background-color: #ffffff !important;
}
.bg-white .card-header,
.bg-white .card-footer {
  background-color: transparent;
}

.border-white {
  border: 1px solid #ffffff !important;
}

.border-top-white {
  border-top: 1px solid #ffffff;
}

.border-bottom-white {
  border-bottom: 1px solid #ffffff;
}

.border-left-white {
  border-left: 1px solid #ffffff;
}

.border-right-white {
  border-right: 1px solid #ffffff;
}

.bg-white.badge-glow,
.border-white.badge-glow,
.badge-white.badge-glow {
  box-shadow: 0px 0px 10px #ffffff;
}

.overlay-white {
  background: #ffffff;
  /* The Fallback */
}

input:focus ~ .bg-white {
  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #ffffff !important;
}

.bg-black {
  background-color: #000000 !important;
}
.bg-black .card-header,
.bg-black .card-footer {
  background-color: transparent;
}

.border-black {
  border: 1px solid #000000 !important;
}

.border-top-black {
  border-top: 1px solid #000000;
}

.border-bottom-black {
  border-bottom: 1px solid #000000;
}

.border-left-black {
  border-left: 1px solid #000000;
}

.border-right-black {
  border-right: 1px solid #000000;
}

.bg-black.badge-glow,
.border-black.badge-glow,
.badge-black.badge-glow {
  box-shadow: 0px 0px 10px #000000;
}

.overlay-black {
  background: #000000;
  /* The Fallback */
}

input:focus ~ .bg-black {
  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #000000 !important;
}

.bg-dark {
  background-color: #232323 !important;
}
.bg-dark .card-header,
.bg-dark .card-footer {
  background-color: transparent;
}

.alert-dark {
  color: #232323 !important;
}
.alert-dark .close {
  color: #232323 !important;
}

.border-dark {
  border: 1px solid #232323 !important;
}

.border-top-dark {
  border-top: 1px solid #232323;
}

.border-bottom-dark {
  border-bottom: 1px solid #232323;
}

.border-left-dark {
  border-left: 1px solid #232323;
}

.border-right-dark {
  border-right: 1px solid #232323;
}

.bg-dark.badge-glow,
.border-dark.badge-glow,
.badge-dark.badge-glow {
  box-shadow: 0px 0px 10px #232323;
}

.badge.badge-light-dark {
  color: #232323 !important;
}

.overlay-dark {
  background: #232323;
  /* The Fallback */
}

.btn-flat-dark {
  background-color: transparent;
  color: #232323;
}
.btn-flat-dark:hover {
  color: #232323;
}
.btn-flat-dark:active, .btn-flat-dark.active, .btn-flat-dark:focus {
  color: #232323;
}
.btn-flat-dark.dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.btn-relief-dark {
  background-color: #232323;
  box-shadow: inset 0 -3px 0 0 rgba(30, 29, 43, 0.2);
  color: #fdfeff;
  transition: all 0.2s ease;
}
.btn-relief-dark:hover:not(.disabled):not(:disabled) {
  background-color: #626262;
}
.btn-relief-dark:active, .btn-relief-dark.active, .btn-relief-dark:focus {
  background-color: #343434;
}
.btn-relief-dark:hover {
  color: #fdfeff;
}
.btn-relief-dark:active, .btn-relief-dark.active {
  outline: none;
  box-shadow: none;
  transform: translateY(3px);
}

.btn-outline-dark {
  border: 1px solid #232323 !important;
  background-color: transparent;
  color: #232323;
}
.btn-outline-dark:hover:not(.disabled):not(:disabled) {
  color: #232323;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus {
  box-shadow: none;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):focus {
  color: #232323;
}
.btn-outline-dark.dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.show > .btn-outline-dark.dropdown-toggle {
  color: #232323;
}

.bullet.bullet-dark {
  background-color: #232323;
}

.modal.modal-dark .modal-header .modal-title {
  color: #232323;
}
.modal.modal-dark .modal-header .close {
  color: #232323 !important;
}

.progress-bar-dark .progress-bar {
  background-color: #232323;
}

.timeline .timeline-point-dark {
  border-color: #232323 !important;
}
.timeline .timeline-point-dark i,
.timeline .timeline-point-dark svg {
  stroke: #232323 !important;
}
.timeline .timeline-point-dark.timeline-point-indicator {
  background-color: #232323 !important;
}
.divider.divider-dark .divider-text:before, .divider.divider-dark .divider-text:after {
  border-color: #232323 !important;
}

input:focus ~ .bg-dark {
  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #232323 !important;
}

.custom-control-dark .custom-control-input:checked ~ .custom-control-label::before,
.custom-control-dark .custom-control-input:active ~ .custom-control-label::before {
  border-color: #232323;
  background-color: #232323;
}
.custom-control-dark .custom-control-input:disabled:checked ~ .custom-control-label::before {
  border: none;
  box-shadow: none !important;
}
.custom-control-dark .custom-control-input:focus ~ .custom-control-label::before {
  border-color: #232323;
}

.custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #232323 !important;
  color: #fdfeff;
  transition: all 0.2s ease-out;
}

.select2-dark .select2-container--default .select2-selection--multiple .select2-selection__choice {
  background: #232323 !important;
  border-color: #232323 !important;
}

.text-dark.text-darken-1 {
  color: #343434 !important;
}

.bg-dark.bg-darken-1 {
  background-color: #343434 !important;
}

.border-dark.border-darken-1 {
  border: 1px solid #343434 !important;
}

.border-top-dark.border-top-darken-1 {
  border-top: 1px solid #343434 !important;
}

.border-bottom-dark.border-bottom-darken-1 {
  border-bottom: 1px solid #343434 !important;
}

.border-left-dark.border-left-darken-1 {
  border-left: 1px solid #343434 !important;
}

.border-right-dark.border-right-darken-1 {
  border-right: 1px solid #343434 !important;
}

.overlay-dark.overlay-darken-1 {
  background: #343434;
  /* The Fallback */
}

.text-dark.text-darken-2 {
  color: #1e1e1e !important;
}

.bg-dark.bg-darken-2 {
  background-color: #1e1e1e !important;
}

.border-dark.border-darken-2 {
  border: 1px solid #1e1e1e !important;
}

.border-top-dark.border-top-darken-2 {
  border-top: 1px solid #1e1e1e !important;
}

.border-bottom-dark.border-bottom-darken-2 {
  border-bottom: 1px solid #1e1e1e !important;
}

.border-left-dark.border-left-darken-2 {
  border-left: 1px solid #1e1e1e !important;
}

.border-right-dark.border-right-darken-2 {
  border-right: 1px solid #1e1e1e !important;
}

.overlay-dark.overlay-darken-2 {
  background: #1e1e1e;
  /* The Fallback */
}

.text-dark.text-darken-3 {
  color: #626262 !important;
}

.bg-dark.bg-darken-3 {
  background-color: #626262 !important;
}

.border-dark.border-darken-3 {
  border: 1px solid #626262 !important;
}

.border-top-dark.border-top-darken-3 {
  border-top: 1px solid #626262 !important;
}

.border-bottom-dark.border-bottom-darken-3 {
  border-bottom: 1px solid #626262 !important;
}

.border-left-dark.border-left-darken-3 {
  border-left: 1px solid #626262 !important;
}

.border-right-dark.border-right-darken-3 {
  border-right: 1px solid #626262 !important;
}

.overlay-dark.overlay-darken-3 {
  background: #626262;
  /* The Fallback */
}

.bg-light {
  background-color: #f6f6f6 !important;
}
.bg-light .card-header,
.bg-light .card-footer {
  background-color: transparent;
}

.border-light {
  border: 1px solid #f6f6f6 !important;
}

.border-top-light {
  border-top: 1px solid #f6f6f6;
}

.border-bottom-light {
  border-bottom: 1px solid #f6f6f6;
}

.border-left-light {
  border-left: 1px solid #f6f6f6;
}

.border-right-light {
  border-right: 1px solid #f6f6f6;
}

.bg-light.badge-glow,
.border-light.badge-glow,
.badge-light.badge-glow {
  box-shadow: 0px 0px 10px #f6f6f6;
}

.overlay-light {
  background: #f6f6f6;
  /* The Fallback */
}

input:focus ~ .bg-light {
  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #f6f6f6 !important;
}

.text-primary.text-accent-1 {
  color: #bdfdff !important;
}

.bg-primary.bg-accent-1 {
  background-color: #bdfdff !important;
}

.border-primary.border-accent-1 {
  border: 1px solid #bdfdff !important;
}

.border-top-primary.border-top-accent-1 {
  border-top: 1px solid #bdfdff !important;
}

.border-bottom-primary.border-bottom-accent-1 {
  border-bottom: 1px solid #bdfdff !important;
}

.border-left-primary.border-left-accent-1 {
  border-left: 1px solid #bdfdff !important;
}

.border-right-primary.border-right-accent-1 {
  border-right: 1px solid #bdfdff !important;
}

.overlay-primary.overlay-accent-1 {
  background: #bdfdff;
  /* The Fallback */
}

.text-primary.text-accent-2 {
  color: #8afbff !important;
}

.bg-primary.bg-accent-2 {
  background-color: #8afbff !important;
}

.border-primary.border-accent-2 {
  border: 1px solid #8afbff !important;
}

.border-top-primary.border-top-accent-2 {
  border-top: 1px solid #8afbff !important;
}

.border-bottom-primary.border-bottom-accent-2 {
  border-bottom: 1px solid #8afbff !important;
}

.border-left-primary.border-left-accent-2 {
  border-left: 1px solid #8afbff !important;
}

.border-right-primary.border-right-accent-2 {
  border-right: 1px solid #8afbff !important;
}

.overlay-primary.overlay-accent-2 {
  background: #8afbff;
  /* The Fallback */
}

.text-primary.text-accent-3 {
  color: #57faff !important;
}

.bg-primary.bg-accent-3 {
  background-color: #57faff !important;
}

.border-primary.border-accent-3 {
  border: 1px solid #57faff !important;
}

.border-top-primary.border-top-accent-3 {
  border-top: 1px solid #57faff !important;
}

.border-bottom-primary.border-bottom-accent-3 {
  border-bottom: 1px solid #57faff !important;
}

.border-left-primary.border-left-accent-3 {
  border-left: 1px solid #57faff !important;
}

.border-right-primary.border-right-accent-3 {
  border-right: 1px solid #57faff !important;
}

.overlay-primary.overlay-accent-3 {
  background: #57faff;
  /* The Fallback */
}

.text-primary.text-accent-4 {
  color: #3df9ff !important;
}

.bg-primary.bg-accent-4 {
  background-color: #3df9ff !important;
}

.border-primary.border-accent-4 {
  border: 1px solid #3df9ff !important;
}

.border-top-primary.border-top-accent-4 {
  border-top: 1px solid #3df9ff !important;
}

.border-bottom-primary.border-bottom-accent-4 {
  border-bottom: 1px solid #3df9ff !important;
}

.border-left-primary.border-left-accent-4 {
  border-left: 1px solid #3df9ff !important;
}

.border-right-primary.border-right-accent-4 {
  border-right: 1px solid #3df9ff !important;
}

.overlay-primary.overlay-accent-4 {
  background: #3df9ff;
  /* The Fallback */
}

.text-success.text-accent-1 {
  color: #e1fff1 !important;
}

.bg-success.bg-accent-1 {
  background-color: #e1fff1 !important;
}

.border-success.border-accent-1 {
  border: 1px solid #e1fff1 !important;
}

.border-top-success.border-top-accent-1 {
  border-top: 1px solid #e1fff1 !important;
}

.border-bottom-success.border-bottom-accent-1 {
  border-bottom: 1px solid #e1fff1 !important;
}

.border-left-success.border-left-accent-1 {
  border-left: 1px solid #e1fff1 !important;
}

.border-right-success.border-right-accent-1 {
  border-right: 1px solid #e1fff1 !important;
}

.overlay-success.overlay-accent-1 {
  background: #e1fff1;
  /* The Fallback */
}

.text-success.text-accent-2 {
  color: #aeffd9 !important;
}

.bg-success.bg-accent-2 {
  background-color: #aeffd9 !important;
}

.border-success.border-accent-2 {
  border: 1px solid #aeffd9 !important;
}

.border-top-success.border-top-accent-2 {
  border-top: 1px solid #aeffd9 !important;
}

.border-bottom-success.border-bottom-accent-2 {
  border-bottom: 1px solid #aeffd9 !important;
}

.border-left-success.border-left-accent-2 {
  border-left: 1px solid #aeffd9 !important;
}

.border-right-success.border-right-accent-2 {
  border-right: 1px solid #aeffd9 !important;
}

.overlay-success.overlay-accent-2 {
  background: #aeffd9;
  /* The Fallback */
}

.text-success.text-accent-3 {
  color: #7bffc1 !important;
}

.bg-success.bg-accent-3 {
  background-color: #7bffc1 !important;
}

.border-success.border-accent-3 {
  border: 1px solid #7bffc1 !important;
}

.border-top-success.border-top-accent-3 {
  border-top: 1px solid #7bffc1 !important;
}

.border-bottom-success.border-bottom-accent-3 {
  border-bottom: 1px solid #7bffc1 !important;
}

.border-left-success.border-left-accent-3 {
  border-left: 1px solid #7bffc1 !important;
}

.border-right-success.border-right-accent-3 {
  border-right: 1px solid #7bffc1 !important;
}

.overlay-success.overlay-accent-3 {
  background: #7bffc1;
  /* The Fallback */
}

.text-success.text-accent-4 {
  color: #62ffb5 !important;
}

.bg-success.bg-accent-4 {
  background-color: #62ffb5 !important;
}

.border-success.border-accent-4 {
  border: 1px solid #62ffb5 !important;
}

.border-top-success.border-top-accent-4 {
  border-top: 1px solid #62ffb5 !important;
}

.border-bottom-success.border-bottom-accent-4 {
  border-bottom: 1px solid #62ffb5 !important;
}

.border-left-success.border-left-accent-4 {
  border-left: 1px solid #62ffb5 !important;
}

.border-right-success.border-right-accent-4 {
  border-right: 1px solid #62ffb5 !important;
}

.overlay-success.overlay-accent-4 {
  background: #62ffb5;
  /* The Fallback */
}

.text-info.text-accent-1 {
  color: #feffff !important;
}

.bg-info.bg-accent-1 {
  background-color: #feffff !important;
}

.border-info.border-accent-1 {
  border: 1px solid #feffff !important;
}

.border-top-info.border-top-accent-1 {
  border-top: 1px solid #feffff !important;
}

.border-bottom-info.border-bottom-accent-1 {
  border-bottom: 1px solid #feffff !important;
}

.border-left-info.border-left-accent-1 {
  border-left: 1px solid #feffff !important;
}

.border-right-info.border-right-accent-1 {
  border-right: 1px solid #feffff !important;
}

.overlay-info.overlay-accent-1 {
  background: #feffff;
  /* The Fallback */
}

.text-info.text-accent-2 {
  color: #cbf5ff !important;
}

.bg-info.bg-accent-2 {
  background-color: #cbf5ff !important;
}

.border-info.border-accent-2 {
  border: 1px solid #cbf5ff !important;
}

.border-top-info.border-top-accent-2 {
  border-top: 1px solid #cbf5ff !important;
}

.border-bottom-info.border-bottom-accent-2 {
  border-bottom: 1px solid #cbf5ff !important;
}

.border-left-info.border-left-accent-2 {
  border-left: 1px solid #cbf5ff !important;
}

.border-right-info.border-right-accent-2 {
  border-right: 1px solid #cbf5ff !important;
}

.overlay-info.overlay-accent-2 {
  background: #cbf5ff;
  /* The Fallback */
}

.text-info.text-accent-3 {
  color: #98ecff !important;
}

.bg-info.bg-accent-3 {
  background-color: #98ecff !important;
}

.border-info.border-accent-3 {
  border: 1px solid #98ecff !important;
}

.border-top-info.border-top-accent-3 {
  border-top: 1px solid #98ecff !important;
}

.border-bottom-info.border-bottom-accent-3 {
  border-bottom: 1px solid #98ecff !important;
}

.border-left-info.border-left-accent-3 {
  border-left: 1px solid #98ecff !important;
}

.border-right-info.border-right-accent-3 {
  border-right: 1px solid #98ecff !important;
}

.overlay-info.overlay-accent-3 {
  background: #98ecff;
  /* The Fallback */
}

.text-info.text-accent-4 {
  color: #7fe7ff !important;
}

.bg-info.bg-accent-4 {
  background-color: #7fe7ff !important;
}

.border-info.border-accent-4 {
  border: 1px solid #7fe7ff !important;
}

.border-top-info.border-top-accent-4 {
  border-top: 1px solid #7fe7ff !important;
}

.border-bottom-info.border-bottom-accent-4 {
  border-bottom: 1px solid #7fe7ff !important;
}

.border-left-info.border-left-accent-4 {
  border-left: 1px solid #7fe7ff !important;
}

.border-right-info.border-right-accent-4 {
  border-right: 1px solid #7fe7ff !important;
}

.overlay-info.overlay-accent-4 {
  background: #7fe7ff;
  /* The Fallback */
}

.text-warning.text-accent-1 {
  color: #fff5ef !important;
}

.bg-warning.bg-accent-1 {
  background-color: #fff5ef !important;
}

.border-warning.border-accent-1 {
  border: 1px solid #fff5ef !important;
}

.border-top-warning.border-top-accent-1 {
  border-top: 1px solid #fff5ef !important;
}

.border-bottom-warning.border-bottom-accent-1 {
  border-bottom: 1px solid #fff5ef !important;
}

.border-left-warning.border-left-accent-1 {
  border-left: 1px solid #fff5ef !important;
}

.border-right-warning.border-right-accent-1 {
  border-right: 1px solid #fff5ef !important;
}

.overlay-warning.overlay-accent-1 {
  background: #fff5ef;
  /* The Fallback */
}

.text-warning.text-accent-2 {
  color: #ffe5d8 !important;
}

.bg-warning.bg-accent-2 {
  background-color: #ffe5d8 !important;
}

.border-warning.border-accent-2 {
  border: 1px solid #ffe5d8 !important;
}

.border-top-warning.border-top-accent-2 {
  border-top: 1px solid #ffe5d8 !important;
}

.border-bottom-warning.border-bottom-accent-2 {
  border-bottom: 1px solid #ffe5d8 !important;
}

.border-left-warning.border-left-accent-2 {
  border-left: 1px solid #ffe5d8 !important;
}

.border-right-warning.border-right-accent-2 {
  border-right: 1px solid #ffe5d8 !important;
}

.overlay-warning.overlay-accent-2 {
  background: #ffe5d8;
  /* The Fallback */
}

.text-warning.text-accent-3 {
  color: #fff6f3 !important;
}

.bg-warning.bg-accent-3 {
  background-color: #fff6f3 !important;
}

.border-warning.border-accent-3 {
  border: 1px solid #fff6f3 !important;
}

.border-top-warning.border-top-accent-3 {
  border-top: 1px solid #fff6f3 !important;
}

.border-bottom-warning.border-bottom-accent-3 {
  border-bottom: 1px solid #fff6f3 !important;
}

.border-left-warning.border-left-accent-3 {
  border-left: 1px solid #fff6f3 !important;
}

.border-right-warning.border-right-accent-3 {
  border-right: 1px solid #fff6f3 !important;
}

.overlay-warning.overlay-accent-3 {
  background: #fff6f3;
  /* The Fallback */
}

.text-warning.text-accent-4 {
  color: #ffe3da !important;
}

.bg-warning.bg-accent-4 {
  background-color: #ffe3da !important;
}

.border-warning.border-accent-4 {
  border: 1px solid #ffe3da !important;
}

.border-top-warning.border-top-accent-4 {
  border-top: 1px solid #ffe3da !important;
}

.border-bottom-warning.border-bottom-accent-4 {
  border-bottom: 1px solid #ffe3da !important;
}

.border-left-warning.border-left-accent-4 {
  border-left: 1px solid #ffe3da !important;
}

.border-right-warning.border-right-accent-4 {
  border-right: 1px solid #ffe3da !important;
}

.overlay-warning.overlay-accent-4 {
  background: #ffe3da;
  /* The Fallback */
}

.text-danger.text-accent-1 {
  color: #ffeef1 !important;
}

.bg-danger.bg-accent-1 {
  background-color: #ffeef1 !important;
}

.border-danger.border-accent-1 {
  border: 1px solid #ffeef1 !important;
}

.border-top-danger.border-top-accent-1 {
  border-top: 1px solid #ffeef1 !important;
}

.border-bottom-danger.border-bottom-accent-1 {
  border-bottom: 1px solid #ffeef1 !important;
}

.border-left-danger.border-left-accent-1 {
  border-left: 1px solid #ffeef1 !important;
}

.border-right-danger.border-right-accent-1 {
  border-right: 1px solid #ffeef1 !important;
}

.overlay-danger.overlay-accent-1 {
  background: #ffeef1;
  /* The Fallback */
}

.text-danger.text-accent-2 {
  color: #ffd6db !important;
}

.bg-danger.bg-accent-2 {
  background-color: #ffd6db !important;
}

.border-danger.border-accent-2 {
  border: 1px solid #ffd6db !important;
}

.border-top-danger.border-top-accent-2 {
  border-top: 1px solid #ffd6db !important;
}

.border-bottom-danger.border-bottom-accent-2 {
  border-bottom: 1px solid #ffd6db !important;
}

.border-left-danger.border-left-accent-2 {
  border-left: 1px solid #ffd6db !important;
}

.border-right-danger.border-right-accent-2 {
  border-right: 1px solid #ffd6db !important;
}

.overlay-danger.overlay-accent-2 {
  background: #ffd6db;
  /* The Fallback */
}

.text-danger.text-accent-3 {
  color: #ffecee !important;
}

.bg-danger.bg-accent-3 {
  background-color: #ffecee !important;
}

.border-danger.border-accent-3 {
  border: 1px solid #ffecee !important;
}

.border-top-danger.border-top-accent-3 {
  border-top: 1px solid #ffecee !important;
}

.border-bottom-danger.border-bottom-accent-3 {
  border-bottom: 1px solid #ffecee !important;
}

.border-left-danger.border-left-accent-3 {
  border-left: 1px solid #ffecee !important;
}

.border-right-danger.border-right-accent-3 {
  border-right: 1px solid #ffecee !important;
}

.overlay-danger.overlay-accent-3 {
  background: #ffecee;
  /* The Fallback */
}

.text-danger.text-accent-4 {
  color: #ffd3d7 !important;
}

.bg-danger.bg-accent-4 {
  background-color: #ffd3d7 !important;
}

.border-danger.border-accent-4 {
  border: 1px solid #ffd3d7 !important;
}

.border-top-danger.border-top-accent-4 {
  border-top: 1px solid #ffd3d7 !important;
}

.border-bottom-danger.border-bottom-accent-4 {
  border-bottom: 1px solid #ffd3d7 !important;
}

.border-left-danger.border-left-accent-4 {
  border-left: 1px solid #ffd3d7 !important;
}

.border-right-danger.border-right-accent-4 {
  border-right: 1px solid #ffd3d7 !important;
}

.overlay-danger.overlay-accent-4 {
  background: #ffd3d7;
  /* The Fallback */
}

.bg-gradient-dark,
.btn-gradient-dark {
  color: #fdfeff;
  transition: all 0.2s ease;
  background-image: linear-gradient(47deg, #232323, #1e1e1e);
  background-repeat: repeat-x;
  background-repeat: repeat;
}
.dark-layout .bg-gradient-dark,
.dark-layout .btn-gradient-dark {
  background-image: linear-gradient(47deg, #1e1e1e, #232323);
  background-repeat: repeat-x;
  background-repeat: repeat;
}
.bg-gradient-dark:hover, .bg-gradient-dark:active,
.btn-gradient-dark:hover,
.btn-gradient-dark:active {
  color: #fdfeff;
}
.bg-gradient-dark:hover:not(.disabled):not(:disabled),
.btn-gradient-dark:hover:not(.disabled):not(:disabled) {
  transform: translateY(-2px);
}
.bg-gradient-dark:active,
.btn-gradient-dark:active {
  transform: translateY(0);
}
.bg-gradient-dark:active, .bg-gradient-dark:focus,
.btn-gradient-dark:active,
.btn-gradient-dark:focus {
  background-image: linear-gradient(47deg, #1e1e1e, #232323);
  background-repeat: repeat-x;
  background-repeat: repeat;
}

html {
  height: 100%;
  letter-spacing: 0.00875rem;
  /*
    * Blank page
    */
}
html body {
  font-size: 14px;
  height: 100%;
  background-color: #f8f8f8;
  direction: ltr;
}
html body p {
  line-height: 1.3125rem;
}
html .content {
  padding: 0;
  position: relative;
  transition: 300ms ease all;
  backface-visibility: hidden;
  min-height: calc(100% - 2.93125rem);
  margin-left: 260px;
}
html .content.app-content {
  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 0;
}
html .content.app-content.show-overlay .content-overlay {
  z-index: 10;
  opacity: 1;
}
html .content.app-content.show-overlay .content-overlay ~ .header-navbar-shadow {
  display: none;
}
html .content.app-content .content-overlay {
  position: fixed;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 29, 43, 0.5);
  cursor: pointer;
  transition: all 0.7s, z-index 0s;
  z-index: -1;
}
html .content.app-content .content-area-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
}
html .content.app-content .content-area-wrapper .content-wrapper,
html .content.app-content .content-area-wrapper .content-body {
  height: 100%;
}
html .content .body-content-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  display: block;
  z-index: 4;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
}
html .content .body-content-overlay.show {
  visibility: visible;
  transition: all 0.3s ease;
  opacity: 1;
  background-color: rgba(30, 29, 43, 0.2);
  border-radius: 0.15625rem;
}
html .content .content-wrapper .content-header-title {
  font-weight: 500;
  color: #636363;
  padding-right: 0.875rem;
  border-right: 1px solid #d6dce1;
}
html .content .content-wrapper .content-header-right .dropdown-toggle::after {
  display: none;
}
html .content .content-wrapper .content-header-right .dropdown-toggle i,
html .content .content-wrapper .content-header-right .dropdown-toggle svg {
  margin-right: 0;
}
html .content .content-wrapper .content-header-right .btn-icon {
  padding: 0.7rem;
}
html .content .content-wrapper .content-header-right .btn-icon i,
html .content .content-wrapper .content-header-right .btn-icon svg {
  height: 0.875rem;
  width: 0.875rem;
}
html .navbar-floating.footer-static .app-content .content-area-wrapper,
html .navbar-floating.footer-static .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-floating.footer-static .app-content .content-area-wrapper,
html .navbar-floating.footer-static .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
  }
}
html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 1.1375rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 1.1375rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-floating.footer-hidden .app-content .content-area-wrapper,
html .navbar-floating.footer-hidden .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 1.1375rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 1.1375rem + 0rem ) );
  }
}
html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-floating.footer-fixed .app-content .content-area-wrapper,
html .navbar-floating.footer-fixed .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );
  }
}
html .navbar-hidden .app-content {
  padding: 1.75rem 1.75rem 0 1.75rem !important;
}
html .navbar-hidden.footer-static .app-content .content-area-wrapper,
html .navbar-hidden.footer-static .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 1) + 0rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 0rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-hidden.footer-static .app-content .content-area-wrapper,
html .navbar-hidden.footer-static .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 0rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 0rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 0rem + 0rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 0rem + 0rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,
html .navbar-hidden.footer-hidden .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );
  }
}
html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 0rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 0rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,
html .navbar-hidden.footer-fixed .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-static .main-menu {
  top: 0;
}
html .navbar-static .content {
  min-height: calc(100% - calc(4.375rem + 2.93125rem));
}
html .navbar-static .app-content {
  padding: 1.75rem 1.75rem 0 1.75rem;
}
html .navbar-static.footer-static .app-content .content-area-wrapper,
html .navbar-static.footer-static .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-static.footer-static .app-content .content-area-wrapper,
html .navbar-static.footer-static .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-static.footer-hidden .app-content .content-area-wrapper,
html .navbar-static.footer-hidden .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-static.footer-hidden .app-content .content-area-wrapper,
html .navbar-static.footer-hidden .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );
  }
}
html .navbar-static.footer-fixed .app-content .content-area-wrapper,
html .navbar-static.footer-fixed .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-static.footer-fixed .app-content .content-area-wrapper,
html .navbar-static.footer-fixed .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-sticky .app-content {
  padding: calc(1.75rem + 4.375rem) 1.75rem 0 1.75rem;
}
html .navbar-sticky.footer-static .app-content .content-area-wrapper,
html .navbar-sticky.footer-static .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-sticky.footer-static .app-content .content-area-wrapper,
html .navbar-sticky.footer-static .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,
html .navbar-sticky.footer-hidden .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );
  }
}
html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
}
@media (max-width: 575.98px) {
  html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,
html .navbar-sticky.footer-fixed .app-content .kanban-wrapper {
    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );
  }
}
html .navbar-static .nav.header-navbar .navbar-container,
html .navbar-sticky .nav.header-navbar .navbar-container {
  padding-left: 1.4rem;
  padding-right: 1.4rem;
}
html .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show,
html .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {
  width: 98%;
  left: 1%;
}
html .footer-fixed .content.app-content {
  padding-bottom: 2.93125rem !important;
}
html [data-col="1-column"] .header-navbar {
  width: 100%;
  left: 0 !important;
}
html [data-col="1-column"] .header-navbar.floating-nav {
  width: calc( 100vw - (100vw - 100%) - calc(1.75rem * 2) ) !important;
}
html [data-col="1-column"] .content,
html [data-col="1-column"] .footer {
  margin-left: 0px !important;
}
html [data-col="1-column"].horizontal-layout .header-navbar {
  width: 100% !important;
}
html [data-col="1-column"].horizontal-layout .app-content {
  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 0 1.75rem !important;
}
html [data-col="1-column"].horizontal-layout.footer-fixed .app-content {
  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 2.93125rem 1.75rem !important;
}
html .blank-page .content {
  margin-left: 0;
}
html .blank-page .content.app-content {
  overflow: overlay;
  overflow-x: hidden;
  padding: 0 !important;
  transition: none;
}
html .blank-page .content.app-content .header-navbar-shadow {
  display: none;
}
html .blank-page .content-wrapper {
  padding: 0 !important;
}
html .blank-page .content-wrapper .flexbox-container {
  display: flex;
  align-items: center;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  justify-content: center;
}
html .pace .pace-progress {
  background: #00a0dd;
}

.app-content.center-layout {
  overflow: hidden;
}

/*
* Col 3 layout for detached and general type
*/
@media (min-width: 992px) {
  body .content-right {
    width: calc(100vw - (100vw - 100%) - 260px);
    float: right;
  }
  body .content-left {
    width: calc(100vw - (100vw - 100%) - 260px);
    float: left;
  }
  body .content-detached {
    width: 100%;
  }
  body .content-detached.content-right {
    float: right;
    margin-left: -260px;
  }
  body .content-detached.content-right .content-body {
    margin-left: calc(260px + 1.75rem);
  }
  body .content-detached.content-left {
    float: left;
    margin-right: -260px;
  }
  body .content-detached.content-left .content-body {
    margin-right: calc(260px + 1.75rem);
  }

  .sidebar-right.sidebar-sticky {
    float: right !important;
    margin-left: -260px;
    width: 260px !important;
    margin-top: 4.375rem1.25;
  }
}
@media (max-width: 575.98px) {
  html body .app-content {
    padding: calc(1.75rem - 0.7rem + 4.375rem + 1.1375rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;
  }

  html body.navbar-static .app-content {
    padding: calc(1.75rem - 0.7rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;
  }

  html body.navbar-sticky .app-content {
    padding: calc(1.75rem - 0.7rem + 4.375rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;
  }

  html body.navbar-hidden .app-content {
    padding: calc(1.75rem - 0.7rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;
  }
}
@media (max-width: 575.98px) {
  .navbar-static .app-content .header-navbar .navbar-container,
.navbar-sticky .app-content .header-navbar .navbar-container {
    padding-left: 0.875rem;
    padding-right: 0.4375rem;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  html.full-screen {
    width: 100%;
  }
  html.full-screen .content.app-content {
    height: 100%;
    overflow: scroll;
    overflow-x: hidden;
  }
}
/*=========================================================================================
    File Name: sidebar.scss
    Description: content sidebar specific scss.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.sidebar {
  position: relative;
  width: 100%;
  height: 100%;
}
@media (min-width: 992px) {
  .sidebar {
    vertical-align: top;
  }
}

.sidebar-fixed {
  position: fixed;
  height: 100%;
  overflow: scroll;
}

.sidenav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120vh;
  background-color: rgba(30, 29, 43, 0.5);
  z-index: 997;
  display: block;
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s ease;
}
.sidenav-overlay.show {
  opacity: 1;
  visibility: visible;
  transition: all 0.5s ease;
}

.drag-target {
  height: 100%;
  width: 40px;
  position: fixed;
  top: 0;
  left: -10px;
  z-index: 1036;
}

.sidebar-detached .sidebar {
  width: 260px;
}

@media (min-width: 992px) {
  .sidebar-left {
    float: left;
  }

  .sidebar-right {
    float: right;
  }
}
@media (max-width: 991.98px) {
  .sidebar-detached .sidebar {
    width: 100%;
  }
}
footer.footer {
  padding: 0.7rem 1.75rem;
  min-height: 2.93125rem;
  transition: 300ms ease all;
}
footer.footer span i,
footer.footer span svg {
  height: 1.32125rem;
  width: 1.32125rem;
  font-size: 1.32125rem;
  margin-left: 0.4375rem;
  color: #de4827;
}
footer.footer .scroll-top {
  padding: 0.70875rem 0.72625rem;
}
footer.footer-shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);
}
footer.footer-border {
  border-top: 1px solid #ebe9f1;
}

.footer-fixed footer {
  position: fixed !important;
  z-index: 1030;
  right: 0;
  left: 0;
  bottom: 0;
}
.footer-fixed footer.footer-light {
  background: #fdfeff;
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);
}
.footer-fixed footer.footer-dark {
  background: #b8c2cc;
  color: #fdfeff;
}

.footer-hidden .app-content {
  padding-bottom: 0.1px !important;
}

.scroll-top {
  position: fixed;
  bottom: 5%;
  right: 30px;
  display: none;
  z-index: 99;
}

/*=========================================================================================
    File Name: navigation.scss
    Description: Common mixin for menus, contain dark and light version scss.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
@media (min-width: 768px) {
  .drag-target {
    z-index: 0;
  }
}
.mf-avatar {
  position: relative;
  height: 2.1875rem;
  width: 2.1875rem;
  padding: 0.4375rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", sans-serif;
  font-size: 1.3125rem;
  background-color: #7b67f9;
  color: #fdfeff;
  border-radius: 999px;
  overflow: hidden;
}
.mf-avatar img {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  width: auto;
  transform: translate(-50%, -50%);
}

.avatar {
  white-space: nowrap;
  background-color: #c3c3c3;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  color: #fdfeff;
  display: inline-flex;
  font-size: 0.875rem;
  text-align: center;
  vertical-align: middle;
  font-weight: 600;
}
.avatar .avatar-content {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 0.749875rem;
}
.avatar .avatar-content .avatar-icon {
  height: 0.875rem;
  width: 0.875rem;
}
.avatar [class*=avatar-status-] {
  border-radius: 50%;
  width: 11px;
  height: 11px;
  position: absolute;
  right: 0;
  bottom: 0;
  border: 1px solid #fdfeff;
}
.avatar [class*=avatar-status-].avatar-status-lg, .avatar [class*=avatar-status-].avatar-status-xl {
  width: 17px;
  height: 17px;
  border-width: 2px;
}
.avatar .avatar-status-online {
  background-color: #28c76f;
}
.avatar .avatar-status-busy {
  background-color: #de4827;
}
.avatar .avatar-status-away {
  background-color: #d56729;
}
.avatar .avatar-status-offline {
  background-color: #de4827;
}
.avatar.avatar-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  border-radius: 0.3125rem;
}
.avatar img {
  border-radius: 50%;
}
.avatar.avatar-xl {
  font-size: 1.3125rem;
}
.avatar.avatar-xl img {
  width: 70px;
  height: 70px;
}
.avatar.avatar-xl .avatar-content {
  height: 70px;
  width: 70px;
  font-size: 2.24875rem;
}
.avatar.avatar-xl .avatar-content .avatar-icon,
.avatar.avatar-xl .avatar-content i,
.avatar.avatar-xl .avatar-content svg {
  height: 2.625rem;
  width: 2.625rem;
  font-size: 2.625rem;
}
.avatar.avatar-xl [class*=avatar-status-] {
  right: 3px;
  bottom: 0;
}
.avatar.avatar-lg {
  font-size: 1.05rem;
}
.avatar.avatar-lg img {
  width: 50px;
  height: 50px;
}
.avatar.avatar-lg .avatar-content {
  width: 50px;
  height: 50px;
  font-size: 1.49975rem;
}
.avatar.avatar-lg .avatar-content .avatar-icon,
.avatar.avatar-lg .avatar-content i,
.avatar.avatar-lg .avatar-content svg {
  height: 1.75rem;
  width: 1.75rem;
  font-size: 1.75rem;
}
.avatar.avatar-lg [class*=avatar-status-] {
  right: 3px;
  bottom: 1px;
}
.avatar.avatar-sm .avatar-content {
  width: 24px;
  height: 24px;
}
.avatar.avatar-sm .avatar-content .avatar-icon,
.avatar.avatar-sm .avatar-content i,
.avatar.avatar-sm .avatar-content svg {
  height: 0.875rem;
  width: 0.875rem;
  font-size: 0.875rem;
}
.avatar.avatar-sm img {
  width: 24px;
  height: 24px;
}
.avatar.avatar-sm [class*=avatar-status-] {
  right: -3px;
  bottom: -2px;
}

.avatar-group {
  display: flex;
  justify-content: flex-start;
}
.avatar-group .avatar {
  transition: all 0.25s ease;
}
.avatar-group .avatar img,
.avatar-group .avatar .avatar-content {
  box-shadow: 0 0 0 2px #fdfeff, inset 0 0 0 1px rgba(30, 29, 43, 0.07);
}
.avatar-group .avatar:hover {
  transition: all 0.25s ease;
}
.avatar-group .avatar.pull-up:hover {
  transform: translateY(-4px) scale(1.07);
}
.avatar-group .avatar:not(:first-child) {
  margin-left: -0.48125rem;
}
.avatar-group .avatar-sm:not(:first-child) {
  margin-left: -0.35rem;
}
.avatar-group .avatar-lg:not(:first-child) {
  margin-left: -0.875rem;
}
.avatar-group .avatar-xl:not(:first-child) {
  margin-left: -1.3125rem;
}

/*=========================================================================================
	File Name: search.scss
	Description: Search  functionality.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.navbar-container .search-input {
  width: 0;
  float: left;
  display: none;
}
.navbar-container .search-input input {
  width: 0;
  border: none;
  background: none;
  transition: all 0.2s ease-out;
  line-height: 16px;
  padding: 1.4rem 3.15rem;
}
.navbar-container .search-input.open {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  display: block;
  background: #fdfeff;
  border-radius: 0.4375rem;
}
.navbar-container .search-input.open .search-input-close,
.navbar-container .search-input.open .search-input-icon {
  display: block;
}
.navbar-container .search-input.open input {
  width: 100%;
  outline: none;
  background: none;
  height: auto;
  box-shadow: none;
  transition: all 0.3s ease-out;
}
.navbar-container .search-input .search-list {
  max-height: 450px;
  height: auto;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fdfeff;
  width: 100%;
  margin-top: 0.4375rem;
  padding-left: 0;
  border-radius: 0.3125rem;
  display: none;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 875px) and (orientation: landscape) {
  .navbar-container .search-input .search-list {
    max-height: 250px;
  }
}
.navbar-container .search-input .search-list.search-list-bookmark {
  height: auto !important;
}
.navbar-container .search-input .search-list.search-list-bookmark i,
.navbar-container .search-input .search-list.search-list-bookmark svg {
  font-size: 1.05rem;
  height: 1.05rem;
  width: 1.05rem;
}
.navbar-container .search-input .search-list.show {
  display: block;
  min-height: 2.625rem;
}
.navbar-container .search-input .search-list li a {
  padding: 0.7875rem 0.875rem;
  color: #6e6b7b;
}
.navbar-container .search-input .search-list li a i,
.navbar-container .search-input .search-list li a svg[class*="feather feather-"] {
  height: 1.09375rem;
  width: 1.09375rem;
  font-size: 1.09375rem;
}
.navbar-container .search-input .search-list li:first-child {
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}
.navbar-container .search-input .search-list li:last-child {
  border-bottom-left-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}
.navbar-container .search-input .search-list li.auto-suggestion {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.navbar-container .search-input .search-list li.auto-suggestion:hover, .navbar-container .search-input .search-list li.auto-suggestion.current_item {
  background-color: #f8f8f8;
}
.navbar-container .search-input .search-input-icon {
  z-index: 2;
  display: none;
  position: absolute;
  left: 1.3125rem;
  top: 32%;
  cursor: pointer;
}
.navbar-container .search-input .search-input-icon i,
.navbar-container .search-input .search-input-icon svg {
  height: 1.09375rem;
  width: 1.09375rem;
  font-size: 1.09375rem;
}
.navbar-container .search-input .search-input-close {
  z-index: 1;
  display: none;
  position: absolute;
  right: 1.75rem;
  top: 32%;
  cursor: pointer;
}
.navbar-container .search-input .search-input-close i,
.navbar-container .search-input .search-input-close svg {
  height: 1.09375rem;
  width: 1.09375rem;
  font-size: 1.09375rem;
}
.navbar-container .bookmark-input {
  position: absolute;
  top: 102%;
  width: 25%;
  display: none;
  background: #fdfeff;
  border-radius: 0.3125rem;
  box-shadow: 0 15px 30px 0 rgba(30, 29, 43, 0.11), 0 5px 15px 0 rgba(30, 29, 43, 0.08);
}
.navbar-container .bookmark-input.show {
  display: block;
}
.navbar-container .bookmark-input .bookmark-input-icon {
  position: absolute;
  z-index: 1;
  top: 20px;
  left: 24px;
}
.navbar-container .bookmark-input input {
  padding: 0.6125rem 0.6125rem 0.6125rem 2.1875rem;
  margin: 12px;
  width: calc(100% - 24px);
  background: #fdfeff;
  border: 1px solid rgba(30, 29, 43, 0.2);
}
.navbar-container .bookmark-input input:focus {
  border: 1px solid #00a0dd;
}
.navbar-container .bookmark-input .search-list {
  position: relative;
}
.navbar-container .bookmark-icon {
  cursor: pointer;
}
.navbar-container .dropdown.bookmark-dropdown {
  padding: 1.225rem 0.4375rem 1.18125rem;
}
.navbar-container .dropdown.bookmark-dropdown .dropdown-toggle:after {
  display: none;
}
.navbar-container .search-data-title {
  line-height: 1.09375rem;
}

.navbar-dark .search-input .input {
  color: #f5f7fa;
  border-radius: 0.4375rem;
}
.navbar-dark .search-input.open .input {
  color: #f5f7fa;
  border: 1px solid #f5f7fa;
}

.navbar-static .navbar-container .search-input.open {
  border-radius: 0;
}

.btn-social, .btn-social-icon {
  position: relative;
  padding-left: 4.5125rem;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-social > :first-child, .btn-social-icon > :first-child {
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 0;
  width: 2.7625rem;
  line-height: 2.5125rem;
  font-size: 0.875rem;
  text-align: center;
  border-right: 1px solid rgba(30, 29, 43, 0.2);
}

.btn-social-icon {
  height: 2.7625rem;
  width: 2.7625rem;
  padding: 0;
}
.btn-social-icon > :first-child {
  border: none;
  text-align: center;
  width: 100% !important;
}

.btn-adn {
  background-color: #d87a68;
  color: #fdfeff;
  background-color: #d87a68;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-adn:hover {
  color: #fdfeff;
  background-color: #d87a68;
  border-color: #d87a68;
}
.btn-adn:focus, .btn-adn.focus {
  color: #fdfeff;
  background-color: #d87a68;
  border-color: #d87a68;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-adn.disabled, .btn-adn:disabled {
  color: #fdfeff;
  background-color: #d87a68;
  border-color: #fff;
}
.btn-adn:not(:disabled):not(.disabled):active, .btn-adn:not(:disabled):not(.disabled).active, .show > .btn-adn.dropdown-toggle {
  color: #fdfeff;
  background-color: #ce563f;
  border-color: #dfdfdf;
}
.btn-adn:not(:disabled):not(.disabled):active:focus, .btn-adn:not(:disabled):not(.disabled).active:focus, .show > .btn-adn.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-bitbucket {
  background-color: #205081;
  color: #fdfeff;
  background-color: #205081;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-bitbucket:hover {
  color: #fdfeff;
  background-color: #205081;
  border-color: #205081;
}
.btn-bitbucket:focus, .btn-bitbucket.focus {
  color: #fdfeff;
  background-color: #205081;
  border-color: #205081;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-bitbucket.disabled, .btn-bitbucket:disabled {
  color: #fdfeff;
  background-color: #205081;
  border-color: #fff;
}
.btn-bitbucket:not(:disabled):not(.disabled):active, .btn-bitbucket:not(:disabled):not(.disabled).active, .show > .btn-bitbucket.dropdown-toggle {
  color: #fdfeff;
  background-color: #163758;
  border-color: #dfdfdf;
}
.btn-bitbucket:not(:disabled):not(.disabled):active:focus, .btn-bitbucket:not(:disabled):not(.disabled).active:focus, .show > .btn-bitbucket.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-dropbox {
  background-color: #1087dd;
  color: #fdfeff;
  background-color: #1087dd;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-dropbox:hover {
  color: #fdfeff;
  background-color: #1087dd;
  border-color: #1087dd;
}
.btn-dropbox:focus, .btn-dropbox.focus {
  color: #fdfeff;
  background-color: #1087dd;
  border-color: #1087dd;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-dropbox.disabled, .btn-dropbox:disabled {
  color: #fdfeff;
  background-color: #1087dd;
  border-color: #fff;
}
.btn-dropbox:not(:disabled):not(.disabled):active, .btn-dropbox:not(:disabled):not(.disabled).active, .show > .btn-dropbox.dropdown-toggle {
  color: #fdfeff;
  background-color: #0d6aad;
  border-color: #dfdfdf;
}
.btn-dropbox:not(:disabled):not(.disabled):active:focus, .btn-dropbox:not(:disabled):not(.disabled).active:focus, .show > .btn-dropbox.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-facebook {
  background-color: #3b5998;
  color: #fdfeff;
  background-color: #3b5998;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-facebook:hover {
  color: #fdfeff;
  background-color: #3b5998;
  border-color: #3b5998;
}
.btn-facebook:focus, .btn-facebook.focus {
  color: #fdfeff;
  background-color: #3b5998;
  border-color: #3b5998;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-facebook.disabled, .btn-facebook:disabled {
  color: #fdfeff;
  background-color: #3b5998;
  border-color: #fff;
}
.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {
  color: #fdfeff;
  background-color: #2d4373;
  border-color: #dfdfdf;
}
.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-flickr {
  background-color: #ff0084;
  color: #fdfeff;
  background-color: #ff0084;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-flickr:hover {
  color: #fdfeff;
  background-color: #ff0084;
  border-color: #ff0084;
}
.btn-flickr:focus, .btn-flickr.focus {
  color: #fdfeff;
  background-color: #ff0084;
  border-color: #ff0084;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-flickr.disabled, .btn-flickr:disabled {
  color: #fdfeff;
  background-color: #ff0084;
  border-color: #fff;
}
.btn-flickr:not(:disabled):not(.disabled):active, .btn-flickr:not(:disabled):not(.disabled).active, .show > .btn-flickr.dropdown-toggle {
  color: #fdfeff;
  background-color: #cc006a;
  border-color: #dfdfdf;
}
.btn-flickr:not(:disabled):not(.disabled):active:focus, .btn-flickr:not(:disabled):not(.disabled).active:focus, .show > .btn-flickr.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-foursquare {
  background-color: #f94877;
  color: #fdfeff;
  background-color: #f94877;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-foursquare:hover {
  color: #fdfeff;
  background-color: #f94877;
  border-color: #f94877;
}
.btn-foursquare:focus, .btn-foursquare.focus {
  color: #fdfeff;
  background-color: #f94877;
  border-color: #f94877;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-foursquare.disabled, .btn-foursquare:disabled {
  color: #fdfeff;
  background-color: #f94877;
  border-color: #fff;
}
.btn-foursquare:not(:disabled):not(.disabled):active, .btn-foursquare:not(:disabled):not(.disabled).active, .show > .btn-foursquare.dropdown-toggle {
  color: #fdfeff;
  background-color: #f71752;
  border-color: #dfdfdf;
}
.btn-foursquare:not(:disabled):not(.disabled):active:focus, .btn-foursquare:not(:disabled):not(.disabled).active:focus, .show > .btn-foursquare.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-github {
  background-color: #444444;
  color: #fdfeff;
  background-color: #444444;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-github:hover {
  color: #fdfeff;
  background-color: #444444;
  border-color: #444444;
}
.btn-github:focus, .btn-github.focus {
  color: #fdfeff;
  background-color: #444444;
  border-color: #444444;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-github.disabled, .btn-github:disabled {
  color: #fdfeff;
  background-color: #444444;
  border-color: #fff;
}
.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {
  color: #fdfeff;
  background-color: #2b2b2b;
  border-color: #dfdfdf;
}
.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-google {
  background-color: #dd4b39;
  color: #fdfeff;
  background-color: #dd4b39;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-google:hover {
  color: #fdfeff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google:focus, .btn-google.focus {
  color: #fdfeff;
  background-color: #dd4b39;
  border-color: #dd4b39;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-google.disabled, .btn-google:disabled {
  color: #fdfeff;
  background-color: #dd4b39;
  border-color: #fff;
}
.btn-google:not(:disabled):not(.disabled):active, .btn-google:not(:disabled):not(.disabled).active, .show > .btn-google.dropdown-toggle {
  color: #fdfeff;
  background-color: #c23321;
  border-color: #dfdfdf;
}
.btn-google:not(:disabled):not(.disabled):active:focus, .btn-google:not(:disabled):not(.disabled).active:focus, .show > .btn-google.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-instagram {
  background-color: #3f729b;
  color: #fdfeff;
  background-color: #3f729b;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-instagram:hover {
  color: #fdfeff;
  background-color: #3f729b;
  border-color: #3f729b;
}
.btn-instagram:focus, .btn-instagram.focus {
  color: #fdfeff;
  background-color: #3f729b;
  border-color: #3f729b;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-instagram.disabled, .btn-instagram:disabled {
  color: #fdfeff;
  background-color: #3f729b;
  border-color: #fff;
}
.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {
  color: #fdfeff;
  background-color: #305777;
  border-color: #dfdfdf;
}
.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-linkedin {
  background-color: #007bb6;
  color: #fdfeff;
  background-color: #007bb6;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-linkedin:hover {
  color: #fdfeff;
  background-color: #007bb6;
  border-color: #007bb6;
}
.btn-linkedin:focus, .btn-linkedin.focus {
  color: #fdfeff;
  background-color: #007bb6;
  border-color: #007bb6;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-linkedin.disabled, .btn-linkedin:disabled {
  color: #fdfeff;
  background-color: #007bb6;
  border-color: #fff;
}
.btn-linkedin:not(:disabled):not(.disabled):active, .btn-linkedin:not(:disabled):not(.disabled).active, .show > .btn-linkedin.dropdown-toggle {
  color: #fdfeff;
  background-color: #005983;
  border-color: #dfdfdf;
}
.btn-linkedin:not(:disabled):not(.disabled):active:focus, .btn-linkedin:not(:disabled):not(.disabled).active:focus, .show > .btn-linkedin.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-microsoft {
  background-color: #2672ec;
  color: #fdfeff;
  background-color: #2672ec;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-microsoft:hover {
  color: #fdfeff;
  background-color: #2672ec;
  border-color: #2672ec;
}
.btn-microsoft:focus, .btn-microsoft.focus {
  color: #fdfeff;
  background-color: #2672ec;
  border-color: #2672ec;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-microsoft.disabled, .btn-microsoft:disabled {
  color: #fdfeff;
  background-color: #2672ec;
  border-color: #fff;
}
.btn-microsoft:not(:disabled):not(.disabled):active, .btn-microsoft:not(:disabled):not(.disabled).active, .show > .btn-microsoft.dropdown-toggle {
  color: #fdfeff;
  background-color: #125acd;
  border-color: #dfdfdf;
}
.btn-microsoft:not(:disabled):not(.disabled):active:focus, .btn-microsoft:not(:disabled):not(.disabled).active:focus, .show > .btn-microsoft.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-odnoklassniki {
  background-color: #f4731c;
  color: #fdfeff;
  background-color: #f4731c;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-odnoklassniki:hover {
  color: #fdfeff;
  background-color: #f4731c;
  border-color: #f4731c;
}
.btn-odnoklassniki:focus, .btn-odnoklassniki.focus {
  color: #fdfeff;
  background-color: #f4731c;
  border-color: #f4731c;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-odnoklassniki.disabled, .btn-odnoklassniki:disabled {
  color: #fdfeff;
  background-color: #f4731c;
  border-color: #fff;
}
.btn-odnoklassniki:not(:disabled):not(.disabled):active, .btn-odnoklassniki:not(:disabled):not(.disabled).active, .show > .btn-odnoklassniki.dropdown-toggle {
  color: #fdfeff;
  background-color: #d35b0a;
  border-color: #dfdfdf;
}
.btn-odnoklassniki:not(:disabled):not(.disabled):active:focus, .btn-odnoklassniki:not(:disabled):not(.disabled).active:focus, .show > .btn-odnoklassniki.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-openid {
  background-color: #f7931e;
  color: #2a2e30;
  background-color: #f7931e;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-openid:hover {
  color: #2a2e30;
  background-color: #f7931e;
  border-color: #f7931e;
}
.btn-openid:focus, .btn-openid.focus {
  color: #2a2e30;
  background-color: #f7931e;
  border-color: #f7931e;
  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
}
.btn-openid.disabled, .btn-openid:disabled {
  color: #2a2e30;
  background-color: #f7931e;
  border-color: #fff;
}
.btn-openid:not(:disabled):not(.disabled):active, .btn-openid:not(:disabled):not(.disabled).active, .show > .btn-openid.dropdown-toggle {
  color: #fdfeff;
  background-color: #da7908;
  border-color: #dfdfdf;
}
.btn-openid:not(:disabled):not(.disabled):active:focus, .btn-openid:not(:disabled):not(.disabled).active:focus, .show > .btn-openid.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
}

.btn-pinterest {
  background-color: #cb2027;
  color: #fdfeff;
  background-color: #cb2027;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-pinterest:hover {
  color: #fdfeff;
  background-color: #cb2027;
  border-color: #cb2027;
}
.btn-pinterest:focus, .btn-pinterest.focus {
  color: #fdfeff;
  background-color: #cb2027;
  border-color: #cb2027;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-pinterest.disabled, .btn-pinterest:disabled {
  color: #fdfeff;
  background-color: #cb2027;
  border-color: #fff;
}
.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {
  color: #fdfeff;
  background-color: #9f191f;
  border-color: #dfdfdf;
}
.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-reddit {
  background-color: #eff7ff;
  color: #2a2e30;
  background-color: #eff7ff;
  border-color: #000;
  color: #fdfeff !important;
  border: none;
}
.btn-reddit:hover {
  color: #fdfeff;
  background-color: #000;
  border-color: #000;
}
.btn-reddit:focus, .btn-reddit.focus {
  color: #fdfeff;
  background-color: #000;
  border-color: #000;
  box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);
}
.btn-reddit.disabled, .btn-reddit:disabled {
  color: #2a2e30;
  background-color: #eff7ff;
  border-color: #000;
}
.btn-reddit:not(:disabled):not(.disabled):active, .btn-reddit:not(:disabled):not(.disabled).active, .show > .btn-reddit.dropdown-toggle {
  color: #2a2e30;
  background-color: #bcdeff;
  border-color: black;
}
.btn-reddit:not(:disabled):not(.disabled):active:focus, .btn-reddit:not(:disabled):not(.disabled).active:focus, .show > .btn-reddit.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);
}

.btn-soundcloud {
  background-color: #ff5500;
  color: #fdfeff;
  background-color: #ff5500;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-soundcloud:hover {
  color: #fdfeff;
  background-color: #ff5500;
  border-color: #ff5500;
}
.btn-soundcloud:focus, .btn-soundcloud.focus {
  color: #fdfeff;
  background-color: #ff5500;
  border-color: #ff5500;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-soundcloud.disabled, .btn-soundcloud:disabled {
  color: #fdfeff;
  background-color: #ff5500;
  border-color: #fff;
}
.btn-soundcloud:not(:disabled):not(.disabled):active, .btn-soundcloud:not(:disabled):not(.disabled).active, .show > .btn-soundcloud.dropdown-toggle {
  color: #fdfeff;
  background-color: #cc4400;
  border-color: #dfdfdf;
}
.btn-soundcloud:not(:disabled):not(.disabled):active:focus, .btn-soundcloud:not(:disabled):not(.disabled).active:focus, .show > .btn-soundcloud.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-tumblr {
  background-color: #2c4762;
  color: #fdfeff;
  background-color: #2c4762;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-tumblr:hover {
  color: #fdfeff;
  background-color: #2c4762;
  border-color: #2c4762;
}
.btn-tumblr:focus, .btn-tumblr.focus {
  color: #fdfeff;
  background-color: #2c4762;
  border-color: #2c4762;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-tumblr.disabled, .btn-tumblr:disabled {
  color: #fdfeff;
  background-color: #2c4762;
  border-color: #fff;
}
.btn-tumblr:not(:disabled):not(.disabled):active, .btn-tumblr:not(:disabled):not(.disabled).active, .show > .btn-tumblr.dropdown-toggle {
  color: #fdfeff;
  background-color: #1c2e3f;
  border-color: #dfdfdf;
}
.btn-tumblr:not(:disabled):not(.disabled):active:focus, .btn-tumblr:not(:disabled):not(.disabled).active:focus, .show > .btn-tumblr.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-twitter {
  background-color: #55acee;
  color: #2a2e30;
  background-color: #55acee;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-twitter:hover {
  color: #2a2e30;
  background-color: #55acee;
  border-color: #55acee;
}
.btn-twitter:focus, .btn-twitter.focus {
  color: #2a2e30;
  background-color: #55acee;
  border-color: #55acee;
  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
}
.btn-twitter.disabled, .btn-twitter:disabled {
  color: #2a2e30;
  background-color: #55acee;
  border-color: #fff;
}
.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {
  color: #fdfeff;
  background-color: #2795e9;
  border-color: #dfdfdf;
}
.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);
}

.btn-vimeo {
  background-color: #1ab7ea;
  color: #fdfeff;
  background-color: #1ab7ea;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-vimeo:hover {
  color: #fdfeff;
  background-color: #1ab7ea;
  border-color: #1ab7ea;
}
.btn-vimeo:focus, .btn-vimeo.focus {
  color: #fdfeff;
  background-color: #1ab7ea;
  border-color: #1ab7ea;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-vimeo.disabled, .btn-vimeo:disabled {
  color: #fdfeff;
  background-color: #1ab7ea;
  border-color: #fff;
}
.btn-vimeo:not(:disabled):not(.disabled):active, .btn-vimeo:not(:disabled):not(.disabled).active, .show > .btn-vimeo.dropdown-toggle {
  color: #fdfeff;
  background-color: #1295bf;
  border-color: #dfdfdf;
}
.btn-vimeo:not(:disabled):not(.disabled):active:focus, .btn-vimeo:not(:disabled):not(.disabled).active:focus, .show > .btn-vimeo.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-vk {
  background-color: #587ea3;
  color: #fdfeff;
  background-color: #587ea3;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-vk:hover {
  color: #fdfeff;
  background-color: #587ea3;
  border-color: #587ea3;
}
.btn-vk:focus, .btn-vk.focus {
  color: #fdfeff;
  background-color: #587ea3;
  border-color: #587ea3;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-vk.disabled, .btn-vk:disabled {
  color: #fdfeff;
  background-color: #587ea3;
  border-color: #fff;
}
.btn-vk:not(:disabled):not(.disabled):active, .btn-vk:not(:disabled):not(.disabled).active, .show > .btn-vk.dropdown-toggle {
  color: #fdfeff;
  background-color: #466482;
  border-color: #dfdfdf;
}
.btn-vk:not(:disabled):not(.disabled):active:focus, .btn-vk:not(:disabled):not(.disabled).active:focus, .show > .btn-vk.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-yahoo {
  background-color: #720e9e;
  color: #fdfeff;
  background-color: #720e9e;
  border-color: #fff;
  color: #fdfeff !important;
  border: none;
}
.btn-yahoo:hover {
  color: #fdfeff;
  background-color: #720e9e;
  border-color: #720e9e;
}
.btn-yahoo:focus, .btn-yahoo.focus {
  color: #fdfeff;
  background-color: #720e9e;
  border-color: #720e9e;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}
.btn-yahoo.disabled, .btn-yahoo:disabled {
  color: #fdfeff;
  background-color: #720e9e;
  border-color: #fff;
}
.btn-yahoo:not(:disabled):not(.disabled):active, .btn-yahoo:not(:disabled):not(.disabled).active, .show > .btn-yahoo.dropdown-toggle {
  color: #fdfeff;
  background-color: #500a6f;
  border-color: #dfdfdf;
}
.btn-yahoo:not(:disabled):not(.disabled):active:focus, .btn-yahoo:not(:disabled):not(.disabled).active:focus, .show > .btn-yahoo.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);
}

.btn-outline-adn {
  border: 1px solid #d87a68 !important;
  color: #d87a68;
}

.btn-outline-bitbucket {
  border: 1px solid #205081 !important;
  color: #205081;
}

.btn-outline-dropbox {
  border: 1px solid #1087dd !important;
  color: #1087dd;
}

.btn-outline-facebook {
  border: 1px solid #3b5998 !important;
  color: #3b5998;
}

.btn-outline-flickr {
  border: 1px solid #ff0084 !important;
  color: #ff0084;
}

.btn-outline-foursquare {
  border: 1px solid #f94877 !important;
  color: #f94877;
}

.btn-outline-github {
  border: 1px solid #444444 !important;
  color: #444444;
}

.btn-outline-google {
  border: 1px solid #dd4b39 !important;
  color: #dd4b39;
}

.btn-outline-instagram {
  border: 1px solid #3f729b !important;
  color: #3f729b;
}

.btn-outline-linkedin {
  border: 1px solid #007bb6 !important;
  color: #007bb6;
}

.btn-outline-microsoft {
  border: 1px solid #2672ec !important;
  color: #2672ec;
}

.btn-outline-odnoklassniki {
  border: 1px solid #f4731c !important;
  color: #f4731c;
}

.btn-outline-openid {
  border: 1px solid #f7931e !important;
  color: #f7931e;
}

.btn-outline-pinterest {
  border: 1px solid #cb2027 !important;
  color: #cb2027;
}

.btn-outline-reddit {
  border: 1px solid #ff4500 !important;
  color: #ff4500;
}

.btn-outline-soundcloud {
  border: 1px solid #ff5500 !important;
  color: #ff5500;
}

.btn-outline-tumblr {
  border: 1px solid #2c4762 !important;
  color: #2c4762;
}

.btn-outline-twitter {
  border: 1px solid #55acee !important;
  color: #55acee;
}

.btn-outline-vimeo {
  border: 1px solid #1ab7ea !important;
  color: #1ab7ea;
}

.btn-outline-vk {
  border: 1px solid #587ea3 !important;
  color: #587ea3;
}

.btn-outline-yahoo {
  border: 1px solid #720e9e !important;
  color: #720e9e;
}

.btn-outline-adn:hover {
  color: #ad412d;
  border: 1px solid #ad412d !important;
}

.btn-outline-bitbucket:hover {
  color: #0c1d2f;
  border: 1px solid #0c1d2f !important;
}

.btn-outline-dropbox:hover {
  color: #094d7e;
  border: 1px solid #094d7e !important;
}

.btn-outline-facebook:hover {
  color: #1e2e4f;
  border: 1px solid #1e2e4f !important;
}

.btn-outline-flickr:hover {
  color: #99004f;
  border: 1px solid #99004f !important;
}

.btn-outline-foursquare:hover {
  color: #d4073d;
  border: 1px solid #d4073d !important;
}

.btn-outline-github:hover {
  color: #111111;
  border: 1px solid #111111 !important;
}

.btn-outline-google:hover {
  color: #96271a;
  border: 1px solid #96271a !important;
}

.btn-outline-instagram:hover {
  color: #223d52;
  border: 1px solid #223d52 !important;
}

.btn-outline-linkedin:hover {
  color: #003650;
  border: 1px solid #003650 !important;
}

.btn-outline-microsoft:hover {
  color: #0e459e;
  border: 1px solid #0e459e !important;
}

.btn-outline-odnoklassniki:hover {
  color: #a24608;
  border: 1px solid #a24608 !important;
}

.btn-outline-openid:hover {
  color: #a95e06;
  border: 1px solid #a95e06 !important;
}

.btn-outline-pinterest:hover {
  color: #731216;
  border: 1px solid #731216 !important;
}

.btn-outline-reddit:hover {
  color: #992900;
  border: 1px solid #992900 !important;
}

.btn-outline-soundcloud:hover {
  color: #993300;
  border: 1px solid #993300 !important;
}

.btn-outline-tumblr:hover {
  color: #0c141c;
  border: 1px solid #0c141c !important;
}

.btn-outline-twitter:hover {
  color: #147bc9;
  border: 1px solid #147bc9 !important;
}

.btn-outline-vimeo:hover {
  color: #0d7091;
  border: 1px solid #0d7091 !important;
}

.btn-outline-vk:hover {
  color: #344b61;
  border: 1px solid #344b61 !important;
}

.btn-outline-yahoo:hover {
  color: #2e0640;
  border: 1px solid #2e0640 !important;
}

.bg-adn {
  background-color: #d87a68;
}

.bg-bitbucket {
  background-color: #205081;
}

.bg-dropbox {
  background-color: #1087dd;
}

.bg-facebook {
  background-color: #3b5998;
}

.bg-flickr {
  background-color: #ff0084;
}

.bg-foursquare {
  background-color: #f94877;
}

.bg-github {
  background-color: #444444;
}

.bg-google {
  background-color: #dd4b39;
}

.bg-instagram {
  background-color: #3f729b;
}

.bg-linkedin {
  background-color: #007bb6;
}

.bg-microsoft {
  background-color: #2672ec;
}

.bg-odnoklassniki {
  background-color: #f4731c;
}

.bg-openid {
  background-color: #f7931e;
}

.bg-pinterest {
  background-color: #cb2027;
}

.bg-reddit {
  background-color: #ff4500;
}

.bg-soundcloud {
  background-color: #ff5500;
}

.bg-tumblr {
  background-color: #2c4762;
}

.bg-twitter {
  background-color: #55acee;
}

.bg-vimeo {
  background-color: #1ab7ea;
}

.bg-vk {
  background-color: #587ea3;
}

.bg-yahoo {
  background-color: #720e9e;
}

/*=========================================================================================
    File Name: demo.scss
    Description: CSS used for demo purpose only. Remove this css from your project.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: PIXINVENT
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.demo-inline-spacing {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.demo-inline-spacing > * {
  margin-right: 1.3125rem;
  margin-top: 1.3125rem;
}

.demo-vertical-spacing > * {
  margin: 0;
  margin-bottom: 1.3125rem;
}
.demo-vertical-spacing > *:last-child {
  margin: 0;
}

.demo-spacing-0 > *:last-child {
  margin: 0;
}

.icon-wrapper .feather {
  height: 24px;
  width: 24px;
}

.scroll-example {
  padding: 0.4375rem;
  position: relative;
  border: 2px solid #dfdfdf;
  overflow: auto;
}
.scroll-example .horz-scroll-content {
  width: 1200px;
}

.browser {
  background: #e0e0e0;
  border: 4px solid #e0e0e0;
  width: 100%;
  height: 10.5rem;
  padding-top: 20px;
  margin: 0 0 10px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.browser iframe {
  border: 0;
  background: #fff;
  height: 100%;
  width: 100%;
}

.loader-wrapper {
  height: 8em;
}

.maintenance-icon {
  font-size: 3.5rem;
}

.animationIcon {
  right: 30px;
  bottom: 10px;
}

.buy-now {
  position: fixed;
  bottom: 5%;
  right: 79px;
  z-index: 1031;
}
.buy-now .btn {
  box-shadow: 0 1px 20px 1px #de4827 !important;
}
.buy-now .btn:hover {
  box-shadow: none !important;
}

/*=========================================================================================
	File Name: customizer.scss
	Description: CSS used for demo purpose only. Remove this css from your project.
	----------------------------------------------------------------------------------------
	Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
.customizer {
  width: 400px;
  right: -400px;
  padding: 0;
  background-color: #fdfeff;
  z-index: 1051;
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  backface-visibility: hidden;
  border-left: 1px solid rgba(30, 29, 43, 0.05);
}
.customizer.open {
  box-shadow: 0 15px 30px 0 rgba(30, 29, 43, 0.11), 0 5px 15px 0 rgba(30, 29, 43, 0.08);
  right: 0;
}
.customizer .customizer-content {
  position: relative;
  height: 100%;
}
.customizer .customizer-close {
  position: absolute;
  right: 0.525rem;
  top: 0.525rem;
  padding: 7px;
  width: auto;
  z-index: 10;
  color: #5e5873;
}
.customizer .customizer-close i,
.customizer .customizer-close svg {
  font-size: 1.3125rem;
  height: 1.3125rem;
  width: 1.3125rem;
}
.customizer .customizer-toggle {
  background: #00a0dd;
  color: #fdfeff !important;
  display: block;
  box-shadow: -3px 0px 8px rgba(30, 29, 43, 0.1);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 50%;
  width: 38px;
  height: 38px;
  left: -39px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.customizer .color-box {
  height: 24px;
  width: 24px;
  margin: 0.4375rem;
  border-radius: 0.4375rem;
  cursor: pointer;
  position: relative;
}
.customizer .color-box.selected:after {
  content: "";
  border: 1px solid #00a0dd;
  height: 30px;
  width: 30px;
  top: -3px;
  left: -3px;
  position: absolute;
  border-radius: 0.4375rem;
}
.customizer .color-box.selected.border:after {
  top: -4px;
  left: -4px;
}

.divider {
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  margin: 0.875rem 0;
}
.divider .divider-text {
  position: relative;
  display: inline-block;
  font-size: 0.8203125rem;
  padding: 0 0.875rem;
}
.divider .divider-text i,
.divider .divider-text svg {
  height: 0.875rem;
  width: 0.875rem;
  font-size: 0.875rem;
}
.divider .divider-text:before, .divider .divider-text:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 9999px;
  border-top: 1px solid #ebe9f1;
}
.divider .divider-text:before {
  right: 100%;
}
.divider .divider-text:after {
  left: 100%;
}
.divider.divider-left .divider-text {
  float: left;
  padding-left: 0;
}
.divider.divider-left .divider-text:before {
  display: none;
}
.divider.divider-left-center .divider-text {
  left: -25%;
}
.divider.divider-right .divider-text {
  float: right;
  padding-right: 0;
}
.divider.divider-right .divider-text:after {
  display: none;
}
.divider.divider-right-center .divider-text {
  right: -25%;
}
.divider.divider-dotted .divider-text:before, .divider.divider-dotted .divider-text:after {
  border-style: dotted;
  border-width: 1px;
  border-top-width: 0;
  border-color: #ebe9f1;
}
.divider.divider-dashed .divider-text:before, .divider.divider-dashed .divider-text:after {
  border-style: dashed;
  border-width: 1px;
  border-top-width: 0;
  border-color: #ebe9f1;
}

.timeline {
  padding: 0;
  margin-bottom: 0;
  margin-left: 0.875rem;
  list-style: none;
}
.timeline .timeline-item {
  position: relative;
  padding-left: 2.1875rem;
  border-left: 1px solid #ebe9f1;
}
.timeline .timeline-item:not(:last-child) {
  padding-bottom: 1.575rem;
}
.timeline .timeline-item .timeline-point {
  position: absolute;
  left: -0.74375rem;
  top: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.53125rem;
  width: 1.53125rem;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #00a0dd;
  background-color: #fdfeff;
}
.timeline .timeline-item .timeline-point.timeline-point-indicator {
  left: -0.3605rem;
  top: 0.06125rem;
  height: 12px;
  width: 12px;
  border: 0;
  background-color: #00a0dd;
}
.timeline .timeline-item .timeline-point.timeline-point-indicator:before {
  content: "";
  background: rgba(0, 160, 221, 0.12);
  height: 20px;
  width: 20px;
  display: block;
  position: absolute;
  top: -0.249375rem;
  left: -0.249375rem;
  border-radius: 50%;
}
.timeline .timeline-item .timeline-point i,
.timeline .timeline-item .timeline-point svg {
  color: #00a0dd;
  font-size: 0.74375rem;
  vertical-align: baseline;
}
.timeline .timeline-item .timeline-event {
  position: relative;
  width: 100%;
  min-height: 3.5rem;
}
.timeline .timeline-item .timeline-event .timeline-event-time {
  font-size: 0.74375rem;
  color: #b9b9c3;
}
.timeline .timeline-item:last-of-type {
  border-left-color: transparent !important;
}
.timeline .timeline-item:last-of-type:after {
  content: "";
  position: absolute;
  left: -1px;
  bottom: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(#ebe9f1, transparent);
}

.with-border {
  border-bottom: 2px solid #c8ced3;
  margin-bottom: 16px;
  padding-bottom: 16px;
}

.vertical-timeline-element-content {
  box-shadow: 1px 1px 12px #b9b9b9 !important;
  margin-top: 45px;
}

.vertical-timeline-element-icon {
  box-shadow: 1px 1px 12px #b9b9b9 !important;
}

.vertical-timeline::before {
  box-shadow: 1px 1px 12px #b9b9b9 !important;
}

.timeline-card {
  display: flex;
  flex-direction: column;
}

.timeline-content {
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}

.timeline-day-label {
  position: absolute;
  z-index: 2;
}

.timeline-card-header {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.timeline-card-content {
  display: flex;
  justify-content: space-between;
}

.timeline-card-left,
.timeline-card-right {
  flex-basis: 49.5%;
  flex-grow: 1;
  padding: 10px;
}

.timeline-card-divider {
  width: 1px;
  background-color: #ccc;
  flex-shrink: 0;
  margin-right: 10px;
}

.timeline-horizontal-rule {
  border-width: 2px;
  margin-left: 22px;
  margin-bottom: 20px;
}

.timeline-toolbar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  box-shadow: 1px 1px 12px #b9b9b9;
  border-radius: 4px;
  margin-top: 20px;
  justify-content: space-between;
  padding: 0 20px;
}

.search-column {
  flex: 1;
  padding: 0 10px;
}

.search-container {
  position: relative;
  border: 1px solid #e8eaeb;
  height: 36px;
  border-radius: 2px;
  margin: 20px;
}

.search-container:hover {
  border: 1px solid #999;
}

.timeline-search-bar {
  padding: 7px 9px 8px;
  padding-left: 34px;
  border: none;
  box-sizing: border-box;
  width: 100%;
}

.timeline-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
}

.action-type-column {
  flex: 1;
  padding: 0 10px;
}

.action-type-column .control {
  height: 36px !important;
  box-sizing: border-box;
}

.action-type-column [role=button] svg {
  fill: #999 !important;
}

.date-range-column {
  flex: 2;
  padding: 0 0 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  flex-direction: row;
  overflow: visible;
}

.dx-field-label.multiline-label {
  padding: 13px 0px 0px 0px;
  width: 28%;
}

.dx-field-value {
  padding: 13px 0px 0px 0px;
  width: 72%;
}

.button-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 10px;
}

.timeline-clear-filters-button {
  margin-right: 20px;
}

@media (max-width: 1416px) {
  .timeline-toolbar {
    padding: 0 10px;
  }

  .search-column {
    padding: 0;
    flex: 2;
  }

  .action-type-column {
    flex: 2;
    padding: 0 5px;
  }

  .date-range-column {
    flex: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    flex-direction: row;
    overflow: visible;
  }

  .dx-field-label.multiline-label {
    padding: 8px 0px 0px 0px;
    width: 28%;
    flex: 2;
  }

  .dx-field-value {
    padding: 8px 0px 0px 0px;
    width: 72%;
    flex: 2;
  }

  .button-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
}
@media (max-width: 768px) {
  .timeline-toolbar {
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }

  .search-container {
    margin: 20px;
  }

  .action-type-column {
    margin: 20px 14px 20px 14px;
  }

  .dx-field {
    flex-direction: column;
    align-items: flex-start;
    margin: 20px 24px 20px 20px;
  }

  .dx-field-label.multiline-label {
    width: 100%;
  }

  .dx-field-value {
    width: 100%;
  }

  .timeline-clear-filters-button {
    margin: 20px 24px 20px 20px;
  }
}
.timeline-log {
  position: relative;
}

.timeline-sticky-button {
  position: sticky;
  top: 20 px;
  z-index: 2;
}

.timeline-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 35px;
}

.timeline-perPageOptions {
  display: flex;
  gap: 10px;
}

.timeline-perPageOptions span {
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s;
}

.timeline-perPageOptions span.active,
.timeline-perPageOptions span:hover {
  background-color: #ddd;
  border-radius: 2px;
}

.timeline-pager-info {
  font-size: 14px;
  color: #666;
}

.timeline-pager {
  display: flex;
  align-items: center;
  gap: 5px;
}

.timeline-pager button {
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: background-color 0.3s;
}

.timeline-pager button:hover,
.timeline-pager button.active {
  background-color: #ddd;
  border-radius: 2px;
}

.timeline-pager button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.dark-layout .timeline-card-header h2 {
  color: #d0d2d6;
}

.dark-layout .timeline-pager button {
  color: #d0d2d6;
  background-color: #555;
}

.dark-layout .timeline-perPageOptions span.active {
  color: #d0d2d6;
  background-color: #555;
}

@media screen and (min-width: 0px) {
  head {
    font-family: "xs 0px";
  }

  body:after {
    content: "xs - min-width: 0px";
  }
}
@media screen and (min-width: 544px) {
  head {
    font-family: "sm 544px";
  }

  body:after {
    content: "sm - min-width: 544px";
  }
}
@media screen and (min-width: 768px) {
  head {
    font-family: "md 768px";
  }

  body:after {
    content: "md - min-width: 768px";
  }
}
@media screen and (min-width: 992px) {
  head {
    font-family: "lg 992px";
  }

  body:after {
    content: "lg - min-width: 992px";
  }
}
@media screen and (min-width: 1200px) {
  head {
    font-family: "xl 1200px";
  }

  body:after {
    content: "xl - min-width: 1200px";
  }
}
head {
  clear: both;
}
head title {
  font-family: "xs 0px, sm 544px, md 768px, lg 992px, xl 1200px";
}

body:after {
  display: none;
}

*[data-usn-if] {
  display: none;
}

.vertical-timeline-element-icon svg {
  display: block !important;
}

.select2-container {
  width: 100% !important;
  margin: 0;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  box-sizing: border-box;
}

.select2-container--classic:focus,
.select2-container--default:focus {
  outline: none;
}
.select2-container--classic .select2-selection__choice,
.select2-container--default .select2-selection__choice {
  font-size: 0.7875rem;
  margin-top: 6px !important;
}
.select2-container--classic .select2-selection--single,
.select2-container--default .select2-selection--single {
  min-height: 2.37475rem;
  padding: 5px;
  border: 1px solid #d8d6de;
}
.select2-container--classic .select2-selection--single:focus,
.select2-container--default .select2-selection--single:focus {
  outline: 0;
  border-color: #00a0dd !important;
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1) !important;
}
.select2-container--classic .select2-selection--single .select2-selection__rendered i,
.select2-container--classic .select2-selection--single .select2-selection__rendered svg,
.select2-container--default .select2-selection--single .select2-selection__rendered i,
.select2-container--default .select2-selection--single .select2-selection__rendered svg {
  font-size: 1.00625rem;
  height: 1.00625rem;
  width: 1.00625rem;
  margin-right: 0.4375rem;
}
.select2-container--classic .select2-selection--single .select2-selection__arrow b,
.select2-container--default .select2-selection--single .select2-selection__arrow b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: 18px 14px, 18px 14px;
  background-repeat: no-repeat;
  height: 0.875rem;
  padding-right: 1.3125rem;
  margin-left: 0;
  margin-top: 0;
  left: -8px;
  border-style: none;
}
.select2-container--classic.select2-container--open,
.select2-container--default.select2-container--open {
  box-shadow: 0 5px 25px rgba(30, 29, 43, 0.1);
}
.select2-container--classic.select2-container--open .select2-selection--single,
.select2-container--default.select2-container--open .select2-selection--single {
  border-color: #00a0dd !important;
  outline: 0;
}
.select2-container--classic.select2-container--focus,
.select2-container--default.select2-container--focus {
  outline: 0;
}
.select2-container--classic.select2-container--focus .select2-selection--multiple,
.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #00a0dd !important;
  outline: 0;
}
.select2-container--classic .select2-dropdown,
.select2-container--default .select2-dropdown {
  border-color: #d8d6de;
}
.select2-container--classic .select2-search--dropdown,
.select2-container--default .select2-search--dropdown {
  padding: 0.4375rem;
}
.select2-container--classic .select2-search--dropdown .select2-search__field,
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: none !important;
  border-radius: 0.3125rem;
  border-color: #d8d6de;
  padding: 0.438rem 1rem;
}
.select2-container--classic .select2-selection--multiple,
.select2-container--default .select2-selection--multiple {
  min-height: 38px !important;
  border: 1px solid #d8d6de;
}
.select2-container--classic .select2-selection--multiple:focus,
.select2-container--default .select2-selection--multiple:focus {
  outline: 0;
  border-color: #00a0dd !important;
  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1) !important;
}
.select2-container--classic .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  background-color: #00a0dd !important;
  border-color: #00a0dd !important;
  color: #fdfeff;
  padding: 2px 5px;
}
.select2-container--classic .select2-selection--multiple .select2-selection__rendered,
.select2-container--default .select2-selection--multiple .select2-selection__rendered {
  padding: 0 6px;
}
.select2-container--classic .select2-selection--multiple .select2-selection__rendered li .select2-search__field,
.select2-container--default .select2-selection--multiple .select2-selection__rendered li .select2-search__field {
  margin-top: 7px;
}
.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  float: right;
  margin-left: 0.6125rem;
  margin-right: 0.4375rem;
  font-size: 0px;
  display: inline-block;
  position: relative;
  line-height: 0.875rem;
}
.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: 0.74375rem;
  height: 0.74375rem;
  width: 0.74375rem;
  position: absolute;
  top: 22%;
  left: -4px;
}
.select2-container--classic .select2-selection--multiple i,
.select2-container--classic .select2-selection--multiple svg,
.select2-container--default .select2-selection--multiple i,
.select2-container--default .select2-selection--multiple svg {
  position: relative;
  top: 1px;
  margin-right: 0.4375rem;
  height: 1.00625rem;
  width: 1.00625rem;
  font-size: 1.00625rem;
  padding-left: 1px;
}
.select2-container--classic .select2-results__group,
.select2-container--default .select2-results__group {
  padding: 6px 9px;
  font-weight: 600;
}
.select2-container--classic .select2-results__option,
.select2-container--default .select2-results__option {
  padding: 0.3745rem 0.875rem;
}
.select2-container--classic .select2-results__option[role=group],
.select2-container--default .select2-results__option[role=group] {
  padding: 0;
}
.select2-container--classic .select2-results__option[aria-selected=true],
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: #00a0dd !important;
  color: white !important;
}
.select2-container--classic .select2-results__option i,
.select2-container--classic .select2-results__option svg,
.select2-container--default .select2-results__option i,
.select2-container--default .select2-results__option svg {
  height: 1.00625rem;
  width: 1.00625rem;
  font-size: 1.00625rem;
  margin-right: 0.4375rem;
}
.select2-container--classic .select2-results__option--highlighted,
.select2-container--default .select2-results__option--highlighted {
  background-color: rgba(0, 160, 221, 0.12) !important;
  color: #00a0dd !important;
}
.select2-container--classic .select2-result-repository__avatar img,
.select2-container--default .select2-result-repository__avatar img {
  width: 50px;
}
.select2-container--classic .select-lg,
.select2-container--default .select-lg {
  min-height: 2.714rem !important;
  font-size: 1.2rem;
  margin-bottom: 0 !important;
  padding: 0.2625rem 0.6125rem;
}
.select2-container--classic .select-lg.select2-selection--single .select2-selection__rendered,
.select2-container--default .select-lg.select2-selection--single .select2-selection__rendered {
  padding-top: -0.2rem;
}
.select2-container--classic .select-lg.select2-selection--single .select2-selection__arrow,
.select2-container--default .select-lg.select2-selection--single .select2-selection__arrow {
  top: -0.1rem !important;
}
.select2-container--classic .select-lg.select2-selection--multiple,
.select2-container--default .select-lg.select2-selection--multiple {
  padding: 0 0.175rem;
}
.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered,
.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered {
  padding-top: 0 !important;
}
.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li,
.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li {
  font-size: 1.2rem;
}
.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field,
.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field {
  margin-top: 10px;
}
.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice,
.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice {
  padding: 5px;
}
.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before,
.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before {
  top: 46%;
}
.select2-container--classic .select-sm,
.select2-container--default .select-sm {
  min-height: 2.142rem !important;
  padding: 0 0.175rem;
  font-size: 0.65625rem;
  margin-bottom: 0 !important;
  line-height: 1.5;
}
.select2-container--classic .select-sm.select2-selection--single .select2-selection__arrow,
.select2-container--default .select-sm.select2-selection--single .select2-selection__arrow {
  top: -0.2625rem !important;
}
.select2-container--classic .select-sm.select2-selection--multiple,
.select2-container--default .select-sm.select2-selection--multiple {
  line-height: 1.3;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered,
.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered {
  padding: 3px;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li,
.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li {
  font-size: 0.65625rem;
  margin-top: 2px;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field,
.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field {
  margin-top: 4px;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice,
.select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice {
  padding: 0 0.175rem;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before,
.select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before {
  top: 5%;
}
.select2-container--classic .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field,
.select2-container--default .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field {
  margin-top: 0;
}

.dark-layout .select2-container .select2-selection,
.dark-layout .select2-container .select2-search__field,
.dark-layout .select2-container .select2-selection__placeholder {
  background: #283046;
  border-color: #3b4253;
  color: #b4b7bd;
}
.dark-layout .select2-container .select2-selection__rendered {
  color: #b4b7bd;
}
.dark-layout .select2-container .select2-dropdown {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice {
  background: rgba(0, 160, 221, 0.12) !important;
  color: #00a0dd !important;
  border: none;
}
.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {
  color: #00a0dd !important;
}
.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice__remove:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.dark-layout .select2-container .select2-results__option[aria-disabled=true] {
  color: #676d7d;
}
.dark-layout .select2-container .select2-selection__arrow b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.dark-layout .select2-container--disabled .select2-selection {
  opacity: 0.5;
}

table.dataTable {
  width: 100% !important;
  border-collapse: collapse !important;
}
table.dataTable td,
table.dataTable th {
  padding: 0.625rem 1.3125rem;
  vertical-align: middle;
}
table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc {
  padding-right: inherit;
}
table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px;
  color: #6e6b7b;
  width: 14px;
  height: 14px;
  content: "";
  right: 0.2625rem;
  top: 0.4375rem;
}
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px;
  color: #6e6b7b;
  width: 14px;
  height: 14px;
  content: "";
  right: 0.2625rem;
  top: 1.1375rem;
}
table.dataTable .dt-checkboxes-cell .custom-control {
  padding-left: 0;
  padding-right: 1.09375rem;
}

div.dataTables_wrapper .dt-button-collection {
  background-color: #fdfeff;
}
div.dataTables_wrapper .dt-button-collection > div[role=menu] {
  text-align: left;
  box-shadow: 0px 5px 16px -8px;
  min-width: 7rem;
}
div.dataTables_wrapper .dt-button-collection [class*=buttons-]:focus {
  outline: 0;
}

table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  line-height: 16px;
}

div.dataTables_wrapper div.dataTables_filter label,
div.dataTables_wrapper div.dataTables_length label {
  margin-top: 0.875rem;
  margin-bottom: 0.4375rem;
}
div.dataTables_wrapper div.dataTables_filter select,
div.dataTables_wrapper div.dataTables_length select {
  background-position: calc(100% - 3px) 11px, calc(100% - 20px) 13px, 100% 0;
  padding: 0 0.7rem;
  width: 4.375rem;
  margin: 0 0.4375rem;
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.65625rem;
}
div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin-top: 0.875rem;
  margin-bottom: 1.3125rem;
}
div.dataTables_wrapper .dataTables_info {
  padding-top: 1.09375rem !important;
  color: #b9b9c3;
}

tr.group {
  background-color: #fafafc;
}

@media only screen and (max-width: 768px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: center;
  }

  div.dataTables_wrapper div.dataTables_info {
    white-space: inherit;
  }

  div.dt-buttons {
    justify-content: center;
    margin-top: 0.875rem;
  }
  div.dt-buttons button {
    margin-bottom: 0.4375rem;
  }
}
@media (max-width: 575.98px) {
  .dtr-bs-modal .modal-body {
    padding-left: 0;
    padding-right: 0;
    overflow-x: scroll;
  }
  .dtr-bs-modal .table.dtr-details {
    margin: 0 auto 0.875rem;
  }
  .dtr-bs-modal .table.dtr-details td {
    padding-left: 0;
    padding-right: 0;
  }
  .dtr-bs-modal .table.dtr-details tr td:first-child {
    padding-left: 0.65625rem;
  }

  div.dataTables_wrapper {
    overflow: scroll;
  }
}
/* Bootstrap Touchspin */
.bootstrap-touchspin.input-group {
  width: 7.35rem;
  align-items: center;
}
.bootstrap-touchspin.input-group .form-control {
  padding: 5px;
  height: auto;
  border: 0;
  background-color: #f8f8f8;
  border-radius: 0.3125rem !important;
  text-align: center;
  font-weight: 500;
}
.bootstrap-touchspin.input-group .form-control:focus {
  z-index: 1;
  box-shadow: none;
}
.bootstrap-touchspin .bootstrap-touchspin-injected {
  margin: 0 !important;
}
.bootstrap-touchspin .bootstrap-touchspin-injected.input-group-prepend {
  left: 12px;
  position: relative;
}
.bootstrap-touchspin .bootstrap-touchspin-injected.input-group-append {
  right: 12px;
  position: relative;
}
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up {
  padding: 0;
  min-width: 20px;
  min-height: 20px;
  border-radius: 0.3125rem !important;
}
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down i,
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up i,
.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {
  height: 0.7rem;
  width: 0.7rem;
  font-size: 0.7rem;
  position: relative;
  top: -1px;
}
.bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-down,
.bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-up {
  background-color: rgba(30, 29, 43, 0.5) !important;
  cursor: default;
  opacity: 0.5;
}
.bootstrap-touchspin.input-group-lg {
  width: 8.203125rem;
}
.bootstrap-touchspin.input-group-lg .touchspin.form-control {
  height: auto !important;
}
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down,
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up {
  min-width: 24px;
  min-height: 24px;
}
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down i,
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down svg,
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up i,
.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up svg {
  height: 0.875rem;
  width: 0.875rem;
  font-size: 0.875rem;
  top: -3px;
}
.bootstrap-touchspin.input-group-sm {
  width: 5.46875rem;
}
.bootstrap-touchspin.input-group-sm .touchspin.form-control {
  height: auto !important;
}
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down,
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up {
  min-width: 16px;
  min-height: 16px;
}
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down i,
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up i,
.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {
  height: 0.525rem;
  width: 0.525rem;
  font-size: 0.525rem;
}

/* Number Type Input Box Scss for Touchspin - Remove arrow for firefox */
.bootstrap-touchspin.input-group input[type=number] {
  -moz-appearance: textfield;
}

.dark-layout .bootstrap-touchspin.input-group .form-control {
  background-color: #161d31;
}
.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,
.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up,
.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .disabled-max-min {
  background-color: #b8c2cc !important;
  opacity: 1;
}
.dark-layout .bootstrap-touchspin .bootstrap-touchspin-injected .disabled-max-min {
  background-color: #b8c2cc !important;
  opacity: 1;
}

.dark-layout {
  /********* COMPONENTS *********/
  /********** FORMS **********/
  /********** TABLE **********/
  /********** PAGES **********/
  /********** APPLICATIONS **********/
  /********** CUSTOMIZER **********/
  /********** HORIZONTAL LAYOUT **********/
}
body.dark-layout {
  color: #b4b7bd;
  background-color: #161d31;
}

.dark-layout body {
  color: #b4b7bd;
  background-color: #161d31;
}
.dark-layout h1,
.dark-layout h2,
.dark-layout h3,
.dark-layout h4,
.dark-layout h5,
.dark-layout h6 {
  color: #d0d2d6;
}
.dark-layout .border,
.dark-layout .border-top,
.dark-layout .border-right,
.dark-layout .border-bottom,
.dark-layout .border-left {
  border-color: #3b4253 !important;
}
.dark-layout a:hover {
  color: #00a0dd;
}
.dark-layout label {
  color: #d0d2d6;
}
.dark-layout .btn span {
  color: inherit;
}
.dark-layout hr {
  border-color: #3b4253;
}
.dark-layout pre {
  background-color: #161d31 !important;
  border: 0;
}
.dark-layout pre code {
  background-color: inherit;
  text-shadow: none;
}
.dark-layout pre code .url {
  background-color: #161d31;
}
.dark-layout code {
  background-color: #161d31;
}
.dark-layout kbd {
  background-color: #161d31;
}
.dark-layout .text-dark {
  color: #b8c2cc !important;
}
.dark-layout .text-muted {
  color: #676d7d !important;
}
.dark-layout .text-body {
  color: #b4b7bd !important;
}
.dark-layout .text-body-heading {
  color: #d0d2d6;
}
.dark-layout .section-label {
  color: #676d7d;
}
.dark-layout .shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24) !important;
}
.dark-layout .blockquote-footer {
  color: #676d7d;
}
.dark-layout .header-navbar-shadow {
  background: linear-gradient(180deg, rgba(22, 29, 49, 0.9) 44%, rgba(22, 29, 49, 0.43) 73%, rgba(22, 29, 49, 0));
}
.dark-layout .horizontal-layout .header-navbar {
  background-color: #283046;
}
.dark-layout .horizontal-layout.navbar-sticky .header-navbar, .dark-layout .horizontal-layout.navbar-static .header-navbar {
  background-color: #161d31;
}
.dark-layout .navbar-sticky .header-navbar.navbar-shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75);
}
.dark-layout .header-navbar {
  background-color: #283046;
}
.dark-layout .header-navbar.navbar-static-top {
  background-color: transparent !important;
}
.dark-layout .blank-page .card.bg-transparent h1,
.dark-layout .blank-page .card.bg-transparent h2,
.dark-layout .blank-page .card.bg-transparent h3,
.dark-layout .blank-page .card.bg-transparent h4,
.dark-layout .blank-page .card.bg-transparent h5,
.dark-layout .blank-page .card.bg-transparent h6 {
  color: #283046;
}
.dark-layout .blank-page .card.bg-transparent p {
  color: #161d31;
}
.dark-layout .ps__thumb-x,
.dark-layout .ps__thumb-y {
  background-color: #b4b7bd;
}
.dark-layout .ps .ps__rail-x.ps--clicking,
.dark-layout .ps .ps__rail-x:focus,
.dark-layout .ps .ps__rail-x:hover,
.dark-layout .ps .ps__rail-y.ps--clicking,
.dark-layout .ps .ps__rail-y:focus,
.dark-layout .ps .ps__rail-y:hover {
  background-color: #3b4253;
}
.dark-layout .ps__rail-y.ps--clicking .ps__thumb-y,
.dark-layout .ps__rail-y:focus > .ps__thumb-y,
.dark-layout .ps__rail-y:hover > .ps__thumb-y {
  background-color: #b4b7bd;
}
.dark-layout .alert .alert-heading,
.dark-layout .alert p {
  color: inherit;
}
.dark-layout .alert .close {
  text-shadow: none;
}
.dark-layout .alert.alert-dark .alert-heading,
.dark-layout .alert.alert-dark .alert-body,
.dark-layout .alert.alert-dark p {
  color: #b8c2cc;
}
.dark-layout .alert.alert-dark.alert-dismissible .close {
  color: #b8c2cc !important;
}
.dark-layout .content-header-left .breadcrumbs-top .content-header-title {
  color: #d0d2d6;
  border-color: #3b4253;
}
.dark-layout .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.dark-layout [class*=collapse-] .card:not(:last-of-type) {
  border-color: #3b4253;
}
.dark-layout .collapse-border .card {
  border-color: #3b4253;
}
.dark-layout .collapse-shadow {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);
}
.dark-layout .collapse-margin .card {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24) !important;
}
.dark-layout .collapse-icon .card-header a {
  color: #b4b7bd;
}
.dark-layout .collapse-icon [data-toggle=collapse]:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.dark-layout .collapse-icon [data-toggle=collapse]:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.dark-layout .btn:not([class*=btn-]) {
  color: #b4b7bd;
}
.dark-layout .btn.btn-dark, .dark-layout .btn.btn-outline-dark, .dark-layout .btn.btn-flat-dark {
  color: #b8c2cc;
}
.dark-layout .btn.btn-dark {
  background-color: #232323 !important;
}
.dark-layout .btn.btn-outline-dark {
  border-color: #232323;
  color: #b8c2cc;
}
.dark-layout .btn.btn-outline-dark:hover:not(.disabled):not(:disabled) {
  color: #b8c2cc;
}
.dark-layout .btn.btn-flat-dark:active, .dark-layout .btn.btn-flat-dark:focus {
  background: #232323;
}
.dark-layout .btn-group-toggle label[class*=btn-outline-] {
  color: #00a0dd !important;
}
.dark-layout .dropdown-menu {
  background-color: #283046;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);
}
.dark-layout .dropdown-menu .dropdown-header {
  color: #d0d2d6;
}
.dark-layout .dropdown-menu .dropdown-item {
  color: #b4b7bd;
}
.dark-layout .dropdown-menu .dropdown-item:hover, .dark-layout .dropdown-menu .dropdown-item:focus {
  background: rgba(0, 160, 221, 0.12);
  color: #00a0dd;
}
.dark-layout .dropdown-menu .dropdown-item:active, .dark-layout .dropdown-menu .dropdown-item.active {
  color: #fdfeff;
  background-color: #00a0dd;
}
.dark-layout .dropdown-menu .dropdown-item.disabled, .dark-layout .dropdown-menu .dropdown-item:disabled {
  color: #676d7d;
}
.dark-layout .dropdown-divider {
  border-color: #3b4253;
}
.dark-layout .modal .modal-header,
.dark-layout .modal .modal-header[class*=bg-] {
  background-color: #161d31;
}
.dark-layout .modal .modal-header .close {
  text-shadow: none;
  background-color: #283046 !important;
  color: #b4b7bd;
  box-shadow: 0 3px 8px 0 rgba(11, 10, 25, 0.49) !important;
}
.dark-layout .modal .modal-content,
.dark-layout .modal .modal-body,
.dark-layout .modal .modal-footer {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item.active {
  background-color: #242b3d;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link {
  background-color: #00a0dd;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link:hover {
  color: #fdfeff;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {
  background-color: #242b3d;
  color: #b4b7bd;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link:hover {
  color: #00a0dd;
}
.dark-layout .pagination:not([class*=pagination-]) .page-item.prev-item .page-link:hover, .dark-layout .pagination:not([class*=pagination-]) .page-item.next-item .page-link:hover {
  color: #fdfeff;
}
.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link {
  background-color: #242b3d;
}
.dark-layout .pagination[class*=pagination-] .page-item:not(.active):not(:hover) .page-link {
  color: #fdfeff;
}
.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link:hover {
  background-color: #242b3d;
}
.dark-layout .pagination[class*=pagination-] .page-item.active {
  background-color: #242b3d;
}
.dark-layout .pagination .page-item.prev-item .page-link:before, .dark-layout .pagination .page-item.prev .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.dark-layout .pagination .page-item.prev-item.disabled .page-link:before, .dark-layout .pagination .page-item.prev.disabled .page-link:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.dark-layout .pagination .page-item.next-item .page-link::after, .dark-layout .pagination .page-item.next .page-link::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.dark-layout .pagination .page-item.next-item.disabled .page-link:after, .dark-layout .pagination .page-item.next.disabled .page-link:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.dark-layout .pagination .page-item.disabled .page-link {
  color: #676d7d;
}
.dark-layout .nav.wrap-border {
  border-color: #3b4253;
}
.dark-layout .media-bordered .media:not(:first-child) {
  border-color: #3b4253;
}
.dark-layout .popover[x-placement=top] .arrow:before {
  border-top-color: #3b4253;
}
.dark-layout .popover[x-placement=top] .arrow:after {
  border-top-color: #283046;
}
.dark-layout .popover[x-placement=left] .arrow:before {
  border-left-color: #3b4253;
}
.dark-layout .popover[x-placement=left] .arrow:after {
  border-left-color: #283046;
}
.dark-layout .popover[x-placement=right] .arrow:before {
  border-right-color: #3b4253;
}
.dark-layout .popover[x-placement=right] .arrow:after {
  border-right-color: #283046;
}
.dark-layout .popover .popover-header {
  color: #fdfeff;
}
.dark-layout .popover .popover-body {
  background-color: #283046;
  color: #b4b7bd;
  border-color: #3b4253 !important;
}
.dark-layout .toast {
  background-color: rgba(40, 48, 70, 0.85);
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
  color: #b4b7bd;
}
.dark-layout .toast .toast-header {
  background-color: #283046;
  color: #b4b7bd;
}
.dark-layout .toast .toast-header .close {
  background-color: transparent !important;
  box-shadow: none !important;
  text-shadow: none;
}
.dark-layout .list-group .list-group-item:not([class*=list-group-item-]), .dark-layout .list-group .list-group-item.list-group-item-action {
  background-color: #283046;
  border-color: #3b4253;
  color: #b4b7bd;
}
.dark-layout .list-group .list-group-item:not([class*=list-group-item-]):hover, .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):focus, .dark-layout .list-group .list-group-item.list-group-item-action:hover, .dark-layout .list-group .list-group-item.list-group-item-action:focus {
  background-color: #161d31;
}
.dark-layout .list-group .list-group-item:not([class*=list-group-item-]).active, .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):active, .dark-layout .list-group .list-group-item.list-group-item-action.active, .dark-layout .list-group .list-group-item.list-group-item-action:active {
  background-color: #00a0dd;
  color: #fdfeff;
}
.dark-layout .list-group .list-group-item.active p,
.dark-layout .list-group .list-group-item.active small {
  color: #fdfeff;
}
.dark-layout .list-group .list-group-item.disabled {
  color: #676d7d;
}
.dark-layout .list-group.list-group-circle .list-group-item:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.dark-layout .spinner-border {
  border-color: currentColor !important;
  border-right-color: transparent !important;
}
.dark-layout .avatar {
  background-color: #161d31;
}
.dark-layout .avatar [class*=avatar-status-] {
  border-color: #283046;
}
.dark-layout .avatar-group .avatar img,
.dark-layout .avatar-group .avatar .avatar-content {
  box-shadow: 0 0 0 2px #283046, inset 0 0 0 1px rgba(40, 48, 70, 0.07);
}
.dark-layout .divider .divider-text {
  color: #b4b7bd;
}
.dark-layout .divider .divider-text::before, .dark-layout .divider .divider-text::after {
  border-color: #3b4253;
}
.dark-layout .divider.divider-dark .divider-text::before, .dark-layout .divider.divider-dark .divider-text::after {
  border-color: #3b4253 !important;
}
.dark-layout .timeline .timeline-item {
  border-color: #3b4253;
}
.dark-layout .timeline .timeline-item .timeline-point:not(.timeline-point-indicator) {
  background-color: #283046;
}
.dark-layout .timeline .timeline-item .timeline-event .timeline-event-time {
  color: #676d7d;
}
.dark-layout .timeline .timeline-item:last-of-type:after {
  background: linear-gradient(#3b4253, transparent);
}
.dark-layout .vertical-timeline-element-content {
  background-color: #283046;
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
}
.dark-layout .vertical-timeline-element-content-arrow {
  border: #283046;
}
.dark-layout .vertical-timeline::before {
  background-color: #3b4253;
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
}
.dark-layout .card {
  background-color: #283046;
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
}
.dark-layout .card .card-footer {
  border-color: #3b4253;
}
.dark-layout .card.overlay-img-card .card-img-overlay span,
.dark-layout .card.overlay-img-card .card-img-overlay p,
.dark-layout .card.overlay-img-card .card-img-overlay .card-body {
  color: #fdfeff;
}
.dark-layout .card-developer-meetup .meetup-header .meetup-day {
  border-right-color: #404656;
}
.dark-layout .card-profile .profile-image-wrapper .profile-image {
  background-color: #161d31;
}
.dark-layout .business-card .business-items .business-item {
  border-color: #3b4253;
}
.dark-layout .card-app-design .design-planning-wrapper .design-planning {
  background-color: #161d31;
}
.dark-layout .card-tiny-line-stats .apexcharts-series-markers .apexcharts-marker {
  stroke: #222d69;
}
.dark-layout .card-tiny-line-stats .apexcharts-series-markers:last-child .apexcharts-marker {
  fill: #283046;
}
.dark-layout .card-revenue-budget .revenue-report-wrapper {
  border-right-color: #3b4253;
}
.dark-layout .card-revenue-budget .budget-wrapper .apexcharts-series:not(:first-child) path {
  stroke: #b4b7bd;
}
.dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-label {
  fill: #b4b7bd !important;
}
.dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-value {
  fill: #d0d2d6;
}
.dark-layout .card-company-table .avatar {
  background-color: #161d31;
}
.dark-layout input.form-control,
.dark-layout .custom-file-label,
.dark-layout textarea.form-control {
  background-color: #283046;
  color: #b4b7bd;
}
.dark-layout input.form-control:not(:focus),
.dark-layout .custom-file-label:not(:focus),
.dark-layout textarea.form-control:not(:focus) {
  border-color: #404656;
}
.dark-layout input.form-control::placeholder,
.dark-layout .custom-file-label::placeholder,
.dark-layout textarea.form-control::placeholder {
  color: #676d7d;
}
.dark-layout input.form-control:disabled, .dark-layout input.form-control[readonly=readonly],
.dark-layout .custom-file-label:disabled,
.dark-layout .custom-file-label[readonly=readonly],
.dark-layout textarea.form-control:disabled,
.dark-layout textarea.form-control[readonly=readonly] {
  opacity: 0.5;
}
.dark-layout .char-textarea.active {
  color: #b4b7bd !important;
}
.dark-layout .char-textarea.max-limit {
  color: #de4827 !important;
}
.dark-layout .custom-file-label:after {
  background-color: #161d31;
  border-left: 1px solid #3b4253;
  color: #b4b7bd;
}
.dark-layout .custom-control-input:not(:checked) ~ .custom-control-label:before {
  background-color: #283046;
  border-color: #404656;
}
.dark-layout .custom-control-input:disabled ~ .custom-control-label:before {
  background-color: #444b60;
  border-color: #444b60;
}
.dark-layout .custom-switch .custom-control-input:not(:checked) ~ .custom-control-label:before {
  background-color: #545a6a;
}
.dark-layout .custom-switch .custom-control-input:disabled ~ .custom-control-label:before {
  background-color: #1b2337;
}
.dark-layout select.form-control,
.dark-layout .custom-select {
  background-color: #283046;
  color: #b4b7bd;
  border-color: #3b4253;
}
.dark-layout select.form-control option:checked,
.dark-layout .custom-select option:checked {
  background-color: #283046;
}
.dark-layout select.form-control:disabled,
.dark-layout .custom-select:disabled {
  opacity: 0.5;
}
.dark-layout select.form-control:focus,
.dark-layout .custom-select:focus {
  border-color: #00a0dd;
}
.dark-layout select.form-control:not([multiple=multiple]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.dark-layout .was-validated .form-control:invalid,
.dark-layout .form-control.is-invalid {
  border-color: #de4827 !important;
}
.dark-layout .was-validated .form-control:valid,
.dark-layout .form-control.is-valid {
  border-color: #28c76f !important;
}
.dark-layout .wizard .steps ul .disabled a,
.dark-layout .wizard .steps ul .done a {
  color: #b4b7bd !important;
}
.dark-layout .wizard .steps ul .disabled a:hover,
.dark-layout .wizard .steps ul .done a:hover {
  color: #b4b7bd;
}
.dark-layout .wizard .steps ul .disabled a .step,
.dark-layout .wizard .steps ul .done a .step {
  background-color: #161d31 !important;
  color: #fdfeff !important;
}
.dark-layout .input-group .input-group-text {
  background-color: #283046;
  border-color: #3b4253;
  color: #b4b7bd;
}
.dark-layout .input-group:focus-within .form-control,
.dark-layout .input-group:focus-within .input-group-text {
  border-color: #00a0dd;
  box-shadow: none;
}
.dark-layout .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label, .dark-layout .form-label-group > textarea:not(:focus):not(:placeholder-shown) ~ label {
  color: #b4b7bd !important;
}
.dark-layout .counter-value {
  color: white;
}
.dark-layout .table {
  background-color: #283046;
}
.dark-layout .table td,
.dark-layout .table th {
  border-color: #3b4253 !important;
}
.dark-layout .table .thead tr:not([class*=stock-styled]) th,
.dark-layout .table .thead tr:not([class*=stock-styled]) td,
.dark-layout .table tbody tr:not([class*=stock-styled]) th,
.dark-layout .table tbody tr:not([class*=stock-styled]) td {
  border-color: #3b4253;
  color: #b4b7bd;
}
.dark-layout .table .thead tr:not([class*=stock-styled]) th code,
.dark-layout .table .thead tr:not([class*=stock-styled]) td code,
.dark-layout .table tbody tr:not([class*=stock-styled]) th code,
.dark-layout .table tbody tr:not([class*=stock-styled]) td code {
  background-color: #283046;
}
.dark-layout .table thead tr th,
.dark-layout .table tfoot tr th {
  border-color: #3b4253;
  background-color: #343d55;
  color: #d0d2d6;
}
.dark-layout .table thead.thead-dark th,
.dark-layout .table tfoot.thead-dark th {
  background-color: #fdfeff;
  color: #232323 !important;
}
.dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th, .dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  background-color: #343d55;
}
.dark-layout .table.table-dark {
  background-color: #fdfeff;
}
.dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(35, 35, 35, 0.05);
}
.dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) td {
  background-color: inherit;
}
.dark-layout .table.table-dark td,
.dark-layout .table.table-dark th {
  border-color: #f8f9fa !important;
  color: #232323 !important;
  background-color: #fdfeff;
}
.dark-layout .table.table-dark td .text-white,
.dark-layout .table.table-dark th .text-white {
  color: #232323 !important;
}
.dark-layout .table tbody tr[class*=table-] td,
.dark-layout .table tbody tr[class*=table-] th {
  background-color: unset;
}
.dark-layout .table tbody tr.table-dark td,
.dark-layout .table tbody tr.table-dark th {
  color: #fdfeff;
}
.dark-layout .table.table-bordered {
  border-color: #3b4253;
}
.dark-layout .table.table-hover tbody tr:hover {
  background-color: #242b3d;
}
.dark-layout .table.table-hover tbody tr th,
.dark-layout .table.table-hover tbody tr td {
  background-color: unset;
}
.dark-layout .table.table-hover-animation tbody tr {
  background-color: #283046;
}
.dark-layout .table.table-hover-animation tbody tr:hover {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
}
.dark-layout .table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #242b3d;
}
.dark-layout .dataTables_wrapper .dt-buttons .buttons-copy,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-excel,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-print,
.dark-layout .dataTables_wrapper .dt-buttons .btn-secondary,
.dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-] {
  background-color: #161d31 !important;
}
.dark-layout .dataTables_wrapper .dt-buttons .buttons-copy:active,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-excel:active,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf:active,
.dark-layout .dataTables_wrapper .dt-buttons .buttons-print:active,
.dark-layout .dataTables_wrapper .dt-buttons .btn-secondary:active,
.dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-]:active {
  background-color: #00a0dd !important;
  color: #fdfeff;
}
.dark-layout .dataTables_wrapper .dt-button-collection > div[role=menu] {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);
}
.dark-layout .dataTables_wrapper .table.dataTable tr.group td {
  background-color: #242b3d;
  color: #d0d2d6;
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before,
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before,
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after,
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after,
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before, .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after {
  opacity: 0.5;
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before {
  opacity: 1;
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after {
  opacity: 0.5;
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {
  opacity: 1;
}
.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {
  opacity: 0.5;
}
.dark-layout .ag-grid-btns .filter-btn {
  background-color: transparent !important;
}
.dark-layout .aggrid .ag-input-wrapper input {
  color: #b4b7bd;
}
.dark-layout .aggrid,
.dark-layout .ag-header {
  background-color: #283046;
  color: #b4b7bd;
  border-color: #3b4253;
}
.dark-layout .aggrid .ag-row-hover,
.dark-layout .aggrid .ag-row-selected,
.dark-layout .ag-header .ag-row-hover,
.dark-layout .ag-header .ag-row-selected {
  background-color: #242b3d !important;
}
.dark-layout .aggrid .ag-icon,
.dark-layout .ag-header .ag-icon {
  color: #404656;
}
.dark-layout .aggrid .ag-header-cell.ag-column-hover,
.dark-layout .ag-header .ag-header-cell.ag-column-hover {
  background: transparent !important;
}
.dark-layout .aggrid .ag-header-cell,
.dark-layout .aggrid .ag-cell,
.dark-layout .aggrid .ag-row,
.dark-layout .aggrid .ag-pinned-left-header,
.dark-layout .aggrid .ag-pinned-left-cols-container,
.dark-layout .aggrid .ag-horizontal-left-spacer,
.dark-layout .aggrid .ag-paging-panel,
.dark-layout .aggrid .ag-floating-filter-input,
.dark-layout .ag-header .ag-header-cell,
.dark-layout .ag-header .ag-cell,
.dark-layout .ag-header .ag-row,
.dark-layout .ag-header .ag-pinned-left-header,
.dark-layout .ag-header .ag-pinned-left-cols-container,
.dark-layout .ag-header .ag-horizontal-left-spacer,
.dark-layout .ag-header .ag-paging-panel,
.dark-layout .ag-header .ag-floating-filter-input {
  border-color: #3b4253 !important;
  color: #b4b7bd;
}
.dark-layout .aggrid .ag-cell.ag-cell-inline-editing,
.dark-layout .ag-header .ag-cell.ag-cell-inline-editing {
  border-color: #3b4253;
  background: #161d31;
  height: auto;
  padding-top: 0;
}
.dark-layout .aggrid .ag-paging-panel .ag-paging-button,
.dark-layout .ag-header .ag-paging-panel .ag-paging-button {
  background-color: #161d31;
}
.dark-layout .aggrid .ag-paging-panel .ag-disabled,
.dark-layout .ag-header .ag-paging-panel .ag-disabled {
  background: #283046;
}
.dark-layout .aggrid .ag-paging-panel span[ref=lbTotal],
.dark-layout .ag-header .ag-paging-panel span[ref=lbTotal] {
  background-color: #242b3d;
  color: #b4b7bd !important;
}
.dark-layout .aggrid ::-webkit-scrollbar-track,
.dark-layout .ag-header ::-webkit-scrollbar-track {
  background: #161d31;
}
.dark-layout .aggrid ::-webkit-scrollbar-thumb,
.dark-layout .ag-header ::-webkit-scrollbar-thumb {
  background: #00a0dd;
}
.dark-layout .getting-started .clockCard p {
  color: #b4b7bd !important;
}
.dark-layout #user-profile .profile-header .navbar {
  background-color: #283046;
}
.dark-layout #user-profile .profile-header .navbar .navbar-toggler {
  color: #b4b7bd;
  border-color: #3b4253;
}
.dark-layout .search-bar .form-control {
  background-color: #283046;
}
.dark-layout .blog-edit-wrapper .border {
  border-color: #3b4253 !important;
}
.dark-layout .kb-search-content-info .kb-search-content .card-img-top {
  background-color: #3f4860;
}
.dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):hover, .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):focus, .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):active,
.dark-layout .list-group-circle .list-group-item-action:hover,
.dark-layout .list-group-circle .list-group-item-action:focus,
.dark-layout .list-group-circle .list-group-item-action:active {
  background-color: transparent !important;
}
.dark-layout .content-area-wrapper {
  border-color: #3b4253 !important;
}
.dark-layout .content-area-wrapper .sidebar .sidebar-content {
  background-color: #283046 !important;
}
.dark-layout .content-area-wrapper .app-fixed-search {
  background-color: #283046 !important;
  border-color: #3b4253 !important;
}
.dark-layout .content-area-wrapper .content-right {
  border-color: #3b4253 !important;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .app-action {
  border-color: #3b4253;
  background-color: #283046;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .app-action .action-right .list-inline-item .dropdown-toggle {
  color: #b4b7bd;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media {
  border-color: #3b4253;
  background-color: #283046;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media:hover {
  box-shadow: 0 3px 10px 0 #283046;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media.selected-row-bg {
  background-color: rgba(0, 160, 221, 0.06);
  border-color: #3b4253;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details p,
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details .mail-date,
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message p,
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message .mail-date {
  color: #676d7d;
}
.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .mail-read {
  background-color: #242b3d;
}
.dark-layout .email-application .content-area-wrapper .email-app-details {
  border-color: #3b4253;
}
.dark-layout .email-application .content-area-wrapper .email-app-details .email-scroll-area {
  background-color: #161d31;
}
.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .dropdown-toggle,
.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .action-icon {
  color: #b4b7bd;
}
.dark-layout .email-application .content-area-wrapper .email-app-details .email-info-dropup .dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.dark-layout .email-application .content-area-wrapper .email-app-details .mail-message-wrapper,
.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-head {
  border-color: #3b4253 !important;
}
.dark-layout .email-application .content-area-wrapper #compose-mail .compose-mail-form-field,
.dark-layout .email-application .content-area-wrapper #compose-mail .ql-toolbar,
.dark-layout .email-application .content-area-wrapper #compose-mail .ql-container {
  border-color: #3b4253;
}
.dark-layout .email-application .content-area-wrapper #compose-mail label {
  color: #b4b7bd;
}
.dark-layout .email-application .content-area-wrapper #compose-mail .modal-body {
  border-bottom-left-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}
.dark-layout .file-manager-application .sidebar-file-manager {
  background-color: #283046 !important;
}
.dark-layout .file-manager-application .sidebar-file-manager .jstree .jstree-container-ul .jstree-anchor {
  color: #b4b7bd;
}
.dark-layout .file-manager-application .sidebar-file-manager .storage-status i,
.dark-layout .file-manager-application .sidebar-file-manager .storage-status svg {
  color: #b4b7bd !important;
}
.dark-layout .file-manager-application .sidebar-file-manager .file-manager-title {
  color: #d0d2d6;
}
.dark-layout .file-manager-application .sidebar-file-manager.show {
  border: 1px solid #3b4253 !important;
}
.dark-layout .file-manager-application .content-area-wrapper {
  border: 1px solid #3b4253 !important;
}
.dark-layout .file-manager-application .file-manager-main-content {
  border: 1px solid #3b4253 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar {
  background-color: transparent !important;
  border-bottom: 1px solid #3b4253 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar .file-manager-toggler {
  color: #b4b7bd !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header,
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body {
  background-color: #283046 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header {
  border-color: #3b4253 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .drives .card {
  background-color: #283046;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item .file-logo-wrapper {
  background-color: #161d31 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item:not(.selected) {
  border-color: #3b4253 !important;
}
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-size,
.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-accessed {
  color: #676d7d !important;
}
.dark-layout .file-manager-application #app-file-manager-info-sidebar .tab-content .tab-pane {
  background-color: transparent;
}
.dark-layout .app-calendar .app-calendar-sidebar {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .app-calendar .app-calendar-sidebar .sidebar-content-title {
  color: #d0d2d6;
}
.dark-layout .app-calendar .app-calendar-sidebar .select-all ~ label,
.dark-layout .app-calendar .app-calendar-sidebar .input-filter ~ label {
  color: #d0d2d6;
}
.dark-layout .app-calendar .fc .fc-day-today {
  background: #161d31 !important;
  background-color: #161d31 !important;
}
.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,
.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis,
.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-daygrid-day {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today {
  background-color: rgba(186, 191, 199, 0.12) !important;
}
.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today.fc-col-header-cell {
  background-color: #283046 !important;
}
.dark-layout .app-calendar .fc .fc-popover {
  background: #283046;
  border-color: #3b4253;
}
.dark-layout .app-calendar .fc .fc-popover-header .fc-popover-title,
.dark-layout .app-calendar .fc .fc-popover-header .fc-popover-close {
  color: #b4b7bd;
}
.dark-layout .app-calendar .fc tbody td,
.dark-layout .app-calendar .fc thead th {
  border-color: #3b4253;
}
.dark-layout .app-calendar .fc .fc-scrollgrid {
  border-color: #3b4253;
}
.dark-layout .app-calendar .fc .fc-list,
.dark-layout .app-calendar .fc th {
  border-color: #3b4253;
}
.dark-layout .app-calendar .fc .fc-list .fc-list-day-cushion,
.dark-layout .app-calendar .fc th .fc-list-day-cushion {
  background: #161d31;
}
.dark-layout .app-calendar .fc .fc-list .fc-list-event:hover td,
.dark-layout .app-calendar .fc th .fc-list-event:hover td {
  background-color: #161d31;
}
.dark-layout .app-calendar .fc .fc-list .fc-list-event-time,
.dark-layout .app-calendar .fc th .fc-list-event-time {
  color: #b4b7bd;
}
.dark-layout .app-calendar .fc .fc-list .fc-list-event td,
.dark-layout .app-calendar .fc th .fc-list-event td {
  border-color: #3b4253;
}
.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-list-dataTable-header {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table {
  background-color: #283046;
}
.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table tbody .selected-row-bg {
  background-color: #3b4253;
}
.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table td {
  background-color: inherit;
}
.dark-layout .invoice-edit .invoice-preview-card .invoice-product-details,
.dark-layout .invoice-add .invoice-preview-card .invoice-product-details {
  background-color: #161d31;
}
.dark-layout .invoice-edit .invoice-preview-card .invoice-product-details .product-details-border,
.dark-layout .invoice-add .invoice-preview-card .invoice-product-details .product-details-border {
  background-color: #283046;
  border-color: #3b4253;
}
.dark-layout .invoice-print .form-control {
  background-color: #283046;
}
.dark-layout .app-user-view .plan-card {
  border-color: #00a0dd !important;
}
.dark-layout .app-user-edit .form-control.error {
  border-color: #de4827 !important;
}
.dark-layout .customizer {
  background-color: #283046;
}
.dark-layout .customizer .customizer-close i,
.dark-layout .customizer .customizer-close svg {
  color: #b4b7bd;
}
.dark-layout .footer-fixed .footer {
  background-color: #283046;
}
.dark-layout .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75) !important;
}
.dark-layout .horizontal-layout .horizontal-menu-wrapper {
  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(253, 254, 255, 0) 100%) !important;
}
.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar {
  background: #283046 !important;
}
.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-shadow {
  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75);
}
.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover:not(.active) > a {
  background: #161d31;
}

.bordered-layout .header-navbar {
  box-shadow: none;
}
.bordered-layout .header-navbar.floating-nav {
  border: 1px solid #ebe9f1;
}
.bordered-layout .header-navbar.fixed-top {
  border-bottom: 1px solid #ebe9f1;
  background: #f8f8f8;
}
.bordered-layout .dropdown-menu {
  border: 1px solid #ebe9f1 !important;
  box-shadow: none;
}
.bordered-layout .card,
.bordered-layout .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps),
.bordered-layout .bs-stepper.wizard-modern .bs-stepper-content {
  border: 1px solid #ebe9f1;
  box-shadow: none;
}
.bordered-layout .footer {
  box-shadow: none !important;
}
.bordered-layout .footer-fixed .footer {
  border-top: 1px solid #ebe9f1;
}

.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.header-navbar .dropdown .dropdown-menu.dropdown-menu-right::before,
.header-navbar .dropup .dropdown-menu.dropdown-menu-right::before {
  right: auto;
  left: 0.4375rem;
}

.dropdown .dropdown-menu,
.dropup .dropdown-menu,
.btn-group .dropdown-menu {
  right: auto !important;
  top: 0 !important;
  left: auto !important;
}
.dropdown .dropdown-menu.dropdown-menu-right,
.dropup .dropdown-menu.dropdown-menu-right,
.btn-group .dropdown-menu.dropdown-menu-right {
  left: 0 !important;
}
.dropdown .dropdown-menu.dropdown-menu-right::before,
.dropup .dropdown-menu.dropdown-menu-right::before,
.btn-group .dropdown-menu.dropdown-menu-right::before {
  right: 0.525rem;
  left: auto;
}

.dropleft .dropdown-toggle::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) !important;
}
.dropleft .dropdown-menu {
  left: 0 !important;
  margin-left: 0;
  margin-right: 0.4375rem;
}

.dropright .dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
}
.dropright .dropdown-menu {
  left: 0 !important;
  margin-right: 0;
  margin-left: 0.4375rem;
}

.input-group .dropdown-menu.show {
  top: 0 !important;
  right: auto !important;
  left: 0px !important;
}

.toast {
  right: 0.875rem;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  left: 1px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  float: right;
}

.select2-search__field {
  direction: rtl;
}

.chartjs-render-monitor {
  margin-right: 0.875rem;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: left !important;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  right: 0.39375rem;
}

.avatar-group .avatar {
  margin-right: -0.686875rem;
  margin-left: 0;
}
.avatar-group .avatar-sm {
  margin-right: -0.56875rem;
}
.avatar-group .avatar-lg {
  margin-right: -1.3125rem;
}
.avatar-group .avatar-xl {
  margin-right: -1.61875rem;
}

.breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before,
.breadcrumb.breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {
  transform: rotate(180deg);
}

.pagination .page-item.prev-item .page-link:before, .pagination .page-item.prev .page-link:before, .pagination .page-item.previous .page-link:before {
  transform: rotate(180deg);
}
.pagination .page-item.prev-item .page-link:hover:before, .pagination .page-item.prev-item .page-link:active:before, .pagination .page-item.prev .page-link:hover:before, .pagination .page-item.prev .page-link:active:before, .pagination .page-item.previous .page-link:hover:before, .pagination .page-item.previous .page-link:active:before {
  transform: rotate(180deg);
}
.pagination .page-item.prev-item.disabled .page-link:before, .pagination .page-item.prev.disabled .page-link:before, .pagination .page-item.previous.disabled .page-link:before {
  transform: rotate(180deg);
}
.pagination .page-item.next-item .page-link:after, .pagination .page-item.next .page-link:after {
  transform: rotate(180deg);
}
.pagination .page-item.next-item .page-link:hover:after, .pagination .page-item.next-item .page-link:active:after, .pagination .page-item.next .page-link:hover:after, .pagination .page-item.next .page-link:active:after {
  transform: rotate(180deg);
}
.pagination .page-item.next-item.disabled .page-link:before, .pagination .page-item.next.disabled .page-link:before {
  transform: rotate(180deg);
}

code[class*=language-],
pre[class*=language-] {
  direction: ltr;
}

@media print {
  code[class*=language-],
pre[class*=language-] {
    text-shadow: none;
  }
}
.fc .fc-header-toolbar .fc-right .fc-button.fc-prev-button .fc-icon {
  right: 4px !important;
}

.fc .fc-header-toolbar .fc-right .fc-button.fc-next-button .fc-icon {
  left: -3px !important;
}

.carousel-control-next {
  left: auto;
  right: 0;
}

.carousel-control-prev {
  left: 0;
  right: auto;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-width: 0.35rem 0 0.35rem 0.35rem;
  border-left-color: #323232;
}

.bs-tooltip-left .arrow,
.bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  left: auto;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-width: 0.35rem 0.35rem 0.35rem 0;
  border-right-color: #323232;
}

.bs-tooltip-right .arrow,
.bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  right: auto;
}

.popover {
  right: auto !important;
}

.progress-bar-animated {
  animation: progress-bar-stripes 40s linear infinite;
}

body .ps__rail-y {
  right: auto !important;
  left: 1px !important;
}

.faq-navigation img,
.pricing-free-trial .pricing-trial-img {
  transform: scaleX(-1);
}

.feather-chevron-left,
.feather-chevron-right {
  transform: rotate(-180deg) !important;
}

.kanban-application .kanban-container .kanban-item i,
.kanban-application .kanban-container .kanban-item svg {
  margin-right: 0 !important;
  margin-left: 0.21875rem;
}

.invoice-list-wrapper .dataTables_filter input {
  margin-left: 0 !important;
  margin-right: 0.4375rem;
}
.invoice-list-wrapper .dropdown .dropdown-menu.dropdown-menu-right {
  left: 1.75rem !important;
}

.file-manager-application .sidebar-file-manager .sidebar-inner .my-drive .jstree-node.jstree-closed > .jstree-icon {
  transform: rotate(180deg);
}

body,
#root,
.wrapper {
  height: 100%;
}

body #root .wrapper .ps__rail-y {
  left: auto !important;
  right: 1px !important;
}

.horizontal-layout.navbar-static .navbar-scrolled {
  background: #fdfeff !important;
  box-shadow: rgba(30, 29, 43, 0.05) 0px 4px 20px 0px !important;
}
.horizontal-layout .header-navbar .navbar-container .dropdown-language .dropdown-menu,
.horizontal-layout .header-navbar .navbar-container .dropdown-cart .dropdown-menu,
.horizontal-layout .header-navbar .navbar-container .dropdown-notification .dropdown-menu,
.horizontal-layout .header-navbar .navbar-container .dropdown-user .dropdown-menu {
  top: 2.625rem !important;
}
.horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown .dropdown-submenu .dropdown-toggle:after {
  margin-top: -5px;
}
.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 20px;
}
.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {
  background: #dae1e7;
  border-radius: 30px;
}

.card-snippet pre {
  margin-top: 0;
  border-radius: 0.4375rem;
}

.card-congratulations .avatar svg {
  height: 28px !important;
  width: 28px !important;
}

.avg-session-progress {
  height: 6px;
}

.block-ui-container .block-ui-overlay {
  background: rgba(30, 29, 43, 0.6);
}

.animate__animated.animate__zoomIn,
.animate__animated.animate__fadeInLeft {
  --animate-duration: 1s;
}

.ecommerce-application .content-wrapper.animate__animated {
  animation: none;
}

.customizer .react-select {
  width: 100%;
  max-width: 200px;
}
.customizer .react-select .select__menu {
  z-index: 2;
}

.dark-layout .autocomplete-container .suggestions-list .suggestion-item.suggestion-title-wrapper h6 {
  color: #676d7d;
}
.dark-layout .ecommerce-application .list-view .ecommerce-card .card-body {
  border-right-color: #3b4253;
}
.dark-layout .pagination .break {
  background-color: #242b3d;
}
.dark-layout .pagination .break a {
  color: #b4b7bd;
}
.dark-layout .invoice-list-wrapper header {
  background-color: #283046;
}
.dark-layout .block-ui-container .block-ui-overlay {
  background: #161d31;
}
.dark-layout .block-ui-container .block-ui-message {
  color: #b4b7bd;
}
.dark-layout .form-control {
  background-color: transparent;
}
.dark-layout .apexcharts-gridlines-vertical line {
  stroke: #3b4253;
}
.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {
  background: #161d31;
}
.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {
  background: #3b4253;
}

html[dir=rtl] body .ps__rail-y {
  right: auto !important;
  left: 1px !important;
}
html[dir=rtl] .scroll-to-top div:first-of-type {
  left: auto !important;
  right: 30px;
}
html[dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
html[dir=rtl] .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before,
html[dir=rtl] .breadcrumb.breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.prev-item .page-link:before, html[dir=rtl] .pagination .page-item.prev .page-link:before, html[dir=rtl] .pagination .page-item.previous .page-link:before {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.prev-item .page-link:hover:before, html[dir=rtl] .pagination .page-item.prev-item .page-link:active:before, html[dir=rtl] .pagination .page-item.prev .page-link:hover:before, html[dir=rtl] .pagination .page-item.prev .page-link:active:before, html[dir=rtl] .pagination .page-item.previous .page-link:hover:before, html[dir=rtl] .pagination .page-item.previous .page-link:active:before {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.prev-item.disabled .page-link:before, html[dir=rtl] .pagination .page-item.prev.disabled .page-link:before, html[dir=rtl] .pagination .page-item.previous.disabled .page-link:before {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.next-item .page-link:after, html[dir=rtl] .pagination .page-item.next .page-link:after {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.next-item .page-link:hover:after, html[dir=rtl] .pagination .page-item.next-item .page-link:active:after, html[dir=rtl] .pagination .page-item.next .page-link:hover:after, html[dir=rtl] .pagination .page-item.next .page-link:active:after {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item.next-item.disabled .page-link:before, html[dir=rtl] .pagination .page-item.next.disabled .page-link:before {
  transform: rotate(180deg);
}
html[dir=rtl] .pagination .page-item:first-of-type .page-link svg, html[dir=rtl] .pagination .page-item:last-of-type .page-link svg {
  transform: rotate(180deg);
}
html[dir=rtl] .popover {
  left: auto !important;
}
html[dir=rtl] .progress-bar-animated {
  animation: progress-bar-stripes 40s linear infinite;
}
html[dir=rtl] .bs-tooltip-left .arrow::before,
html[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-width: 0.35rem 0 0.35rem 0.35rem;
  border-right-color: #323232;
}
html[dir=rtl] .bs-tooltip-left .arrow,
html[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow {
  left: 0;
  right: auto;
  transform: rotate(180deg);
}
html[dir=rtl] .bs-tooltip-right .arrow::before,
html[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-width: 0.35rem 0.35rem 0.35rem 0;
  border-left-color: #323232;
}
html[dir=rtl] .bs-tooltip-right .arrow,
html[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow {
  right: 0;
  left: auto;
  transform: rotate(180deg);
}
html[dir=rtl] .email-application .toggle-cc.mr-1 {
  margin-right: 0 !important;
  margin-left: 0.875rem !important;
}
html[dir=rtl] .app-calendar .fc-toolbar .fc-prev-button,
html[dir=rtl] .app-calendar .fc-toolbar .fc-next-button {
  transform: rotate(180deg);
}
html[dir=rtl] .app-ecommerce-details .swiper-button-next {
  right: 0;
  left: auto;
}
html[dir=rtl] .invoice-list-table-header select {
  background-position: calc(100% - (100% - 45px)) 13px, calc(100% - (100% - 20px)) 13px, 0% 0 !important;
}
html[dir=rtl] .tox-tinymce .tox-editor-header {
  direction: ltr;
}
html[dir=rtl] .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-marker {
  margin-right: 10px;
  margin-left: 0 !important;
}
html[dir=rtl] .react-contexify {
  z-index: 1031;
}
html[dir=rtl] .swiper-button-next {
  right: 10px !important;
  left: auto !important;
}
html[dir=rtl] .swiper-button-prev {
  left: 10px !important;
  right: auto !important;
}
html[dir=rtl] .bs-stepper:not(.vertical) .bs-stepper-header .line svg {
  transform: rotate(180deg);
}
html[dir=rtl] .bs-stepper .btn-next svg,
html[dir=rtl] .bs-stepper .btn-prev svg {
  transform: rotate(180deg);
}
html[dir=rtl] .rdt_Table [aria-label="Expand Row"] svg {
  transform: rotate(180deg);
}
html[dir=rtl] #profile-info .post .post-actions .share-post span.mr-1 {
  margin-right: 0 !important;
}

.form-control[readonly] {
  opacity: 0.5;
}

select.form-control[multiple] {
  background-image: none !important;
}

.input-group .form-control.is-invalid ~ .input-group-append .input-group-text {
  border-color: #de4827;
}
.input-group.is-invalid .form-control,
.input-group.is-invalid .input-group-append .input-group-text,
.input-group.is-invalid .input-group-prepend .input-group-text {
  border-color: #de4827 !important;
}

.dark-layout .card .toast {
  background-color: rgba(22, 29, 49, 0.85);
}
.dark-layout .card .toast .toast-header {
  background-color: #161d31;
}
.dark-layout .card .toast .toast-header .close {
  color: #b4b7bd;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #00a0dd;
  background-color: #00a0dd;
}

.dropdown-notification .dropdown-menu,
.dropdown-cart .dropdown-menu {
  left: inherit !important;
}

.dropdown-language .country-flag {
  height: 18px !important;
  width: 18px !important;
}
.dropdown-language .dropdown-menu {
  left: auto !important;
}

.dropdown-user .dropdown-menu {
  left: auto !important;
  right: 0;
}

.dropdown-menu .dropdown-item:focus {
  outline: 0;
}

.dropdown-icon-wrapper .dropdown-toggle:after {
  display: none;
}
.dropdown-icon-wrapper .dropdown-menu {
  min-width: auto;
}
.dropdown-icon-wrapper .dropdown-menu .dropdown-item {
  padding: 0.4375rem 0.9625rem;
  cursor: pointer;
}

.app-collapse.card .card-header {
  padding: 0.875rem;
}
.app-collapse.card svg {
  transition: all 300ms linear 0s;
}
.app-collapse.card .card-header:not(.collapsed) svg {
  transform: rotate(180deg);
}
.app-collapse .collapse-title {
  max-width: calc(100% - 25px);
}

html[dir=rtl] .carousel .carousel-control-next-icon,
html[dir=rtl] .carousel .carousel-control-prev-icon {
  transform: rotate(180deg);
}

.pagination.react-paginate .page-item.prev a.page-link:before,
.pagination.react-paginate .page-item.prev a.page-link:after,
.pagination.react-paginate .page-item.next a.page-link:before,
.pagination.react-paginate .page-item.next a.page-link:after {
  height: 16.5px;
  margin-top: 1px;
}
.pagination.react-paginate.pagination-sm .page-item.prev a.page-link:before,
.pagination.react-paginate.pagination-sm .page-item.prev a.page-link:after,
.pagination.react-paginate.pagination-sm .page-item.next a.page-link:before,
.pagination.react-paginate.pagination-sm .page-item.next a.page-link:after {
  height: 15px;
}
.pagination.react-paginate.pagination-lg .page-item.prev a.page-link:before,
.pagination.react-paginate.pagination-lg .page-item.prev a.page-link:after,
.pagination.react-paginate.pagination-lg .page-item.next a.page-link:before,
.pagination.react-paginate.pagination-lg .page-item.next a.page-link:after {
  height: 19px;
}
.pagination.no-navigation li:first-of-type,
.pagination.no-navigation li:last-of-type {
  display: none;
}

.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid transparent;
}
.loading.component-loader {
  margin-top: -60px;
}
.loading .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid #7961f9;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.loading .effect-1 {
  animation: rotate 1s ease infinite;
}
.loading .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}
.loading .effect-3 {
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid #7961f9;
  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.loading .loading .effects {
  transition: all 0.3s ease;
}

.fallback-logo {
  position: absolute;
  left: calc(50% - 28px);
  width: 45px;
  height: auto;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
    opacity: 1;
  }
}
/* IMPORTANT NOTE
This is a Vuexy Theme Admin Customized CSS
Thise file was made to override the admin panel CSS for MarketFuel®
Take Caution in making changes to this file or everything will explode
*/
.dark-layout .footer-fixed .footer {
  background-color: #2b2b2b !important;
}

.dark-layout .avatar {
  background: none !important;
}

.avatar {
  background-color: #fdfeff;
}

.btn-danger {
  background-color: #de4827 !important;
}

.btn-danger:hover {
  background-color: #00a0dd !important;
}

.admin-buttons {
  background: none !important;
  border: none !important;
}

.dark-layout .table,
.dark-layout .card,
.dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,
.dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {
  background-color: #2b2b2b !important;
}

.dark-layout .table thead th {
  border-bottom: 2px solid #00a0dd !important;
  border-top: none !important;
  border-color: #00a0dd !important;
}

.dark-layout .table.table-hover tbody tr:hover,
.dark-layout .table.table-striped tbody tr:nth-of-type(odd),
.dark-layout input.form-control,
.dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  background-color: #232323;
}

.badge {
  border-radius: 4px !important;
}

.badge-danger {
  background-color: #de4827 !important;
}

.card-header {
  padding: 0.65625rem 1.3125rem;
}

.action-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin: 2%;
  padding: 3px;
  border: 1px solid #ffffff00;
}

.action-item:hover {
  background-color: #f3f2f7 !important;
  border-radius: 4px;
  border: solid 1px #b1b1b1 !important;
}

.action-icon {
  justify-items: center;
}

.action-icon > svg,
.action-icons > svg,
.simple-sku-menubar > svg,
.user-status > svg {
  width: 19px !important;
  margin-right: 0px !important;
}

.delete {
  color: #de4827 !important;
}

.icon-width > svg {
  width: 17px;
  margin-left: 4px !important;
  margin: 0 !important;
}

.search-icon {
  width: fit-content;
  height: auto !important;
  display: flex;
  justify-content: flex-end;
  background-color: #01a0dd !important;
  border-radius: 4px;
  align-items: center;
  padding: 4.5px 13px;
  color: white;
  margin: 0;
  justify-content: center;
  align-items: center;
}

.search-icon > svg {
  width: 19px;
}

.role-flex,
.icon-width {
  display: flex !important;
  align-items: center !important;
}

.breadcrumb {
  background: none !important;
}

.simple-sku-menubar:last-child {
  border-right: none;
}

.card > .card-header:nth-child(2) {
  padding: inherit;
}

.dark-layout select.form-control,
.dark-layout .custom-select {
  background-color: #232323;
}

.simple-sku-form-link-row {
  display: flex;
  height: 42px;
  margin: 0;
}

.portal_actions {
  display: flex;
}

.badge {
  padding: 5px !important;
  margin: 0px !important;
}

.mgtags {
  padding: 2px 20px !important;
}

[dir] .admin-buttons .btn:not(.customer-btn, .product-btn) {
  margin-bottom: 0px !important;
}

.tdactions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
}

.si-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
}

.devex-success {
  color: #fff;
  background-color: #28c76f;
}

.dx-icon-clear .devex-success {
  background-color: #fff;
}

.edit-customer-btn {
  display: flex;
  justify-content: flex-end;
}

/*================================================================================
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Version: 2.0
	Author: PIXINVENT
	Author URL: http://www.themeforest.net/user/pixinvent
================================================================================

NOTE:
------
PLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.
WE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */
.quarterCol {
  padding: 10px 25px;
}

.dx-widget {
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
}

.dx-badge {
  background-color: #ff0000;
  color: white;
  border-radius: 50%;
  padding: 4px;
  width: 12px;
  height: 12px;
  font-size: 16px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: unset;
}

.quarterCol > .row {
  height: 100%;
  border-radius: 10px;
  padding-bottom: 10px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  box-shadow: 0px 0px 8px #d9d9d9;
}

.quarterColDividerContainer {
  text-align: center;
  height: 40px;
  align-items: center;
}

.quarterColDivider {
  color: lightgrey;
}

.quarterColDivider .horizontal {
  width: 75%;
  padding: "15px 30px";
  margin: "15px 30px";
}

.icon-info {
  content: "ⓘ";
}

.dx-radiobutton-icon:before {
  transform: scale(0.7);
  margin: auto;
}

.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
}

.fulfillmentNavButton > .dx-button-content {
  padding: 5px 10px;
}

.app-footer {
  justify-content: right;
}

.smart-grid {
  width: auto;
  height: auto;
}

.smart-grid-command-item {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  align-items: center;
}

.danger-color {
  color: #de3f3f;
}

.paginated-checkbox-select,
.checkbox-header-cell {
  width: 39px;
}

ul {
  list-style-type: none;
  padding-inline-start: 0;
}

.error {
  color: red;
  font-weight: bold;
}

.btn-left-space {
  margin-left: 4px;
}

.show-logo {
  max-height: 50px;
  padding-right: 20px;
}

.inline-block {
  display: inline-block;
}

label {
  font-weight: 600;
}

.page_list_item {
  background: white;
  border: 1px solid #c8ced3;
}

.lifted {
  display: table;
  background: lightgray;
}

.grip_icon {
  display: flex;
}
.grip_icon i {
  width: 6px;
}

.card-header .tooltip_label label {
  color: inherit;
}
.card-header .btn-link {
  color: inherit;
}
.card-header h4 {
  color: inherit;
}

.tooltip_label {
  display: flex;
  align-items: center;
}
.tooltip_label label {
  margin-right: 6px;
}
.tooltip_label i {
  margin-bottom: 7px;
}

.tooltip_checkbox {
  display: inline-flex;
  align-items: center;
}
.tooltip_checkbox span {
  margin-right: 6px;
}
.tooltip_checkbox i {
  margin-bottom: 3px;
}

.tooltip_text {
  max-width: 250px;
  font-weight: 400;
}

.breadcrumb-container {
  position: fixed;
  width: 100%;
  z-index: 9;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  background-color: #3a4248;
  border: none;
}

.breadcrumb-root {
  position: absolute;
  left: calc(100% - 400px);
  top: 0px;
  font-weight: 600;
  padding-top: 10px;
  width: 200px;
  text-align: center;
  background: #20a8d8;
}

.mf-card {
  border: none;
  box-shadow: 1px 1px 12px #b9b9b9;
}

.card {
  margin-bottom: 0.875rem;
  margin-top: 0.875rem;
}

.card-for-credit {
  margin-bottom: 0.2625rem;
  min-height: 500px;
}

.login-page {
  min-height: 100vh;
}

.dark-layout .login-card h1 {
  color: #676d7d;
}

.dark-layout .login-page {
  background-color: #2b2a33 !important;
}

.dark-layout .sign-in-input {
  background-color: #e8f0fe !important;
  color: #2b2a33 !important;
}

.sign-in-input {
  width: 100%;
}

.login-container {
  background-color: #1e1d2b;
}

.login-card {
  background-color: #fdfeff;
}
.login-card a {
  color: #5440d2;
}
.login-card a:hover {
  color: #3d2bb4;
}

.admin_login_logo {
  height: 100%;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin_login_logo img {
  max-width: 200px;
  height: auto;
}

.card-password-form {
  display: flex;
}

.card-body-password-form {
  margin-top: 30px;
}

.login-divider-container {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 10px 0;
}

.login-divider-border {
  flex-grow: 1;
  height: 1px;
  background: #6e6b7b;
  margin: 0;
}

.login-divider-text {
  padding: 0 10px;
  color: #6e6b7b;
}

.full-width-button {
  width: 100%;
}

.token-button {
  background-color: darkgrey;
  color: default;
  border: none;
  height: 38px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
}
.token-button:hover, .token-button:focus, .token-button:active {
  background: #808080 !important;
}

.login-button {
  background-color: #5440d2;
  border: none;
}
.login-button:hover, .login-button:active, .login-button:focus {
  background-color: #3d2bb4 !important;
}

.sso-button {
  border: none;
  background-color: #cfd0d2;
  height: 38px;
  color: black;
  margin-bottom: 10px;
}
.sso-button:hover, .sso-button:focus, .sso-button:active {
  background-color: #adaeb3 !important;
  color: black;
}

.google-signin-button img {
  cursor: pointer;
  height: 21px;
  margin: 0;
  padding-right: 10px;
}

.microsoft-signin-button img {
  cursor: pointer;
  max-height: 38px;
  margin: 0;
  padding-right: 10px;
}

.user-nav {
  min-width: 115px;
}

.dropdown-options {
  min-width: 190px;
  width: auto;
}

.simple-sku-menubar,
.simple-sku-form-breadcrumb {
  text-align: center;
  background-color: var(--mf-colors-bg);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-right: 1px solid var(--mf-colors-neutral-50);
}

.simple-sku-menubar.active,
.simple-sku-form-breadcrumb.active {
  background-color: var(--mf-colors-neutral-50);
  font-weight: 900;
  text-decoration: underline;
}

.simple-sku-form-breadcrumb.active::before,
.simple-sku-form-breadcrumb.active::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.simple-sku-form-link {
  width: calc(100% - 30px);
  height: 95%;
  background-color: #fff;
  color: grey;
}

.simple-sku-form-link:active {
  background-color: #20a8d8 !important;
  color: #fff !important;
}

.sku-form-warning-text {
  text-align: right;
  color: red;
  margin-top: 15px;
}

.sku-client-dropdown {
  margin-top: 15px;
}

.warehouse-list-info {
  margin-bottom: 0.875rem;
  margin-top: 2px;
  margin-left: 10px;
  margin-right: 5px;
  background-color: aliceblue;
}

.btn-info {
  color: #fff;
}

img {
  max-height: 240px;
  max-width: 100%;
  margin: 0 auto;
}

.app-container {
  width: 500px;
  margin: 30px auto;
}

.clear {
  clear: both;
}

.details,
.title {
  text-align: center;
}

.error {
  margin-top: 4px;
  color: red;
}

.red-text {
  color: red;
}

.has-error {
  border: 1px dotted red;
}

.image-container {
  align-items: center;
  display: flex;
  width: 85%;
  height: 80%;
  float: left;
  margin: 15px 10px 10px 37px;
  text-align: center;
  justify-content: "center";
}

.preview-container {
  height: 335px;
  width: 100%;
  margin-bottom: 10px;
}

.placeholder-preview {
  cursor: pointer;
}

.placeholder-preview,
.render-preview {
  text-align: center;
  background-color: #efebeb;
  height: 100%;
  width: 100%;
  border-radius: 5px;
}

.upload-container {
  cursor: pointer;
  height: 300px;
}

.jqx-fill-state-normal {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

.img-avatar,
.avatar > img,
.img-circle {
  max-width: 100%;
  height: auto;
  border-radius: 0;
}

.image-deletion {
  position: absolute;
  margin-left: -40px;
  margin-top: 4px;
  background: #fff;
}

.admin-buttons {
  background: #f0f3f5;
  border: 1px solid #c8ced3;
  border-radius: 0.21875rem;
  padding: 5px;
  float: left;
  margin: 6px 16px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.admin-buttons.col-12 {
  flex: 0 1 100%;
}

.admin-buttons .btn {
  margin-right: 10px;
  margin-bottom: 5px;
}

.product-actions {
  float: right;
}

.product-actions .btn {
  margin-right: 10px;
}

.product-actions .btn:last-child {
  margin-right: 0px;
}

.th-width {
  min-width: 300px;
}

.text-difference-portal {
  background-color: #4dbd74;
  color: #fff;
  padding-left: 5px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 85%;
}

.text-difference-location {
  background-color: #ffc107;
  color: #23282c;
  padding-left: 5px;
  border-radius: 5px;
  font-size: 85%;
  font-weight: 700;
}

#spinner-overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1030;
  background-color: rgba(0, 0, 0, 0.2);
}

.wrapper.menu-hide #spinner-overlay {
  width: 100%;
  left: 0;
}

.mf-loading-spinner {
  width: 5.25rem;
  height: 5.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 10000000;
  border-radius: 999px;
  border: 3px solid #5440d2;
  background-color: rgba(200, 200, 200, 0.6);
  -webkit-animation: sk-scaleout 1s infinite ease-out alternate;
  animation: sk-scaleout 1s infinite ease-out alternate;
}

.mf-loading-logo {
  -webkit-animation: logo-spin 1s infinite ease-out alternate;
  animation: logo-spin 1s infinite ease-out alternate;
  border-radius: 999px;
}

.simple-sku-form-link-row .simple-sku-form-links button.simple-sku-form-link.active {
  color: #ffffff;
  background-color: #21a8d8;
  border: none;
}

.simple-sku-form-link.btn-secondary:not(:disabled):not(.disabled).active {
  color: #ffffff !important;
  background-color: #21a8d8;
  border: none;
}

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
  margin-top: 60px;
}

.client-background {
  background: #caffc7;
}

.portal-background {
  background: #fdffc7;
}

.product-background {
  background: #f5c687;
}

.admin-background {
  background: #fbd2d9;
}

.location-background {
  background: #d3ccfd;
}

.label-column.col-md-6 {
  padding-top: 10px;
}

.new-menu-item {
  margin-bottom: 1.75rem;
}

.cat_box {
  width: 100%;
  height: auto;
  padding-left: 15px;
}
.cat_box .button_text {
  font-size: 20px;
  line-height: 28px;
}

.disabled_text {
  font-size: 10px;
}

.cat_prod_box {
  width: 100%;
  height: auto;
  padding-left: 15px;
}
.cat_prod_box p {
  font-size: 15px;
  line-height: 15px;
}

.card-header .dropdown button.btn-secondary {
  padding: 0px 10px;
  margin: 0 10px;
}

.configurable-option-img-avatar {
  width: 50px;
  height: 50px;
}

.basic-multi-select {
  color: black;
}

.badge {
  padding: 10px;
  margin-bottom: 5px;
}

.add-remove-modal-cont {
  margin-top: 15px;
  padding-right: 15px;
  padding-left: 30px;
}

.stock-col {
  padding-right: 5px;
  width: 50%;
}

.vertical-rule-col {
  width: 2%;
  flex: none;
}

.vertical-rule {
  height: 100%;
  width: 1px;
  background-color: #ebe9f1;
  margin-left: 20px;
  display: flex;
}

.on-hand-col {
  padding-top: 5px;
  padding-right: 5px;
  width: 24%;
  flex: none;
  padding-left: 100px;
}

.available-col {
  padding-top: 5px;
  padding-left: 45px;
  width: 24%;
  flex: none;
}

.reason-col {
  padding-left: 14px;
  padding-right: 28px;
}

.stock-error {
  width: 100%;
  margin-top: 0.21875rem;
  font-size: 0.749875rem;
  color: #de4827;
}

.reason-error {
  text-align: right;
}

.stock-hr {
  margin-right: 16px;
}

.stock-buttons {
  margin: 10px 16px 20px 0;
}

#all-stocks {
  padding: 0px !important;
}

#base-n-sub-sku-stocks {
  padding: 0px !important;
}

.product-at-stock-management-header {
  display: inline-flex;
  width: 340px;
}

.product-at-stock-management {
  display: inline-flex;
  width: 325px;
}

#stock-product-header .badge-primary {
  width: 150px;
}
#stock-product-header .badge-secondary {
  width: 150px;
}
#stock-product-header .badge-warning {
  width: 150px;
}

#stock-product-search-form .form-control {
  border: 1px solid #5d9ee0;
}

#stock-product-top-header {
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding-left: 33px;
  border: 1px solid #ccc;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
#stock-product-top-header .top-header-column {
  display: inline-block;
  width: 150px;
  text-align: center;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
#stock-product-top-header .top-header-column-sku {
  display: inline-block;
  width: 180px;
  text-align: center;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

.form-control-stock-search {
  padding: 0.4375rem 0.875rem;
  font-size: 13px;
  line-height: 0.5;
  border: 1px solid #ccc;
}

#base-n-sub-sku-stocks .card-header {
  padding-top: 0px;
  padding-bottom: 0px;
}

.top-bottom-padding {
  padding-top: 15px;
  padding-bottom: 15px;
}

.statement-header {
  background-color: #f0f3f5;
  text-align: right;
}

.credit {
  background-color: #c2e9ef;
  text-align: right;
}

.debit {
  background-color: #efcfb8;
  text-align: right;
}

.menu-example-container {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
  border: 1px solid #000;
}

.menu-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-example p {
  padding: 10px;
}

.menu-example-logo {
  width: 300px;
  height: auto;
  padding-top: 20px;
}

.no-decoration {
  color: #23282c;
}

.no-decoration:hover {
  color: #23282c;
  text-decoration: none;
}

.th-column-action {
  width: 25%;
  padding-bottom: 47px !important;
}

.td-column-action {
  width: 25%;
}

.th-column-sku {
  padding-bottom: 47px !important;
}

.card-header {
  color: var(--mf-colors-fg);
  background-color: var(--mf-colors-surface) !important;
  border-bottom: 5px solid var(--mf-colors-surface);
}
.card-header input {
  color: var(--mf-colors-fg);
}

[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
}

.child-product-table {
  padding: 15px;
}

.column {
  padding: 10px;
  margin-right: 5px;
  height: 30px;
  -webkit-box-shadow: inset 0 0 3px #000;
  -ms-box-shadow: inset 0 0 3px #000;
  box-shadow: inset 0 0 3px #000;
  text-align: left;
  cursor: move;
}
.column td {
  padding: 7px;
}

.child-product-table {
  border: none;
}

.child-table {
  width: 100%;
  min-height: 250px;
}

#child-product-table {
  width: 100%;
}

.child-table-over,
.group-dropzone-over {
  min-height: 250px;
  border: 2px dashed #000;
}

.user-cart-table tr td {
  color: #fff;
}

.group-bundle-body,
.group-dropzone {
  min-height: 250px;
}

.dropzone-item {
  padding: 7px;
}

.dropzone-cell {
  padding: 2px;
}

.selected-bundle-name {
  display: flex;
  justify-content: space-between;
}

.group-dropzone-select {
  margin: 5px;
}

.group-user-select {
  padding: 5px;
  margin: 5px 24px 0px 0px;
  border: 2px solid lightblue;
  border-radius: 3px;
  color: lightblue;
}

.preview-group-products {
  margin-left: 10px;
}

.preview-group-bundle,
.preview-individual-bundle {
  border: 1px solid #ccc;
  padding-left: 7px;
  padding-top: 7px;
  margin-top: 15px;
}
.preview-group-bundle h5,
.preview-individual-bundle h5 {
  margin-top: 7px;
}

.bundle-flag {
  color: #335269;
  border: 1px solid #335269;
  padding: 0.21875rem 0.4375rem;
  border-radius: 0.175rem;
  font-size: 0.6699175rem;
}

.table.bundleProducts {
  margin-top: 20px;
}

.formgroup-bundle {
  flex-direction: row !important;
  padding: 15px 5px 5px 5px;
}
.formgroup-bundle label {
  padding: 10px;
}

.bundle-product-table {
  display: flex;
  justify-content: space-between;
}

.bundle-table {
  padding: 8px;
  margin-bottom: 0px;
}

table td.bundle-table-cell {
  padding: 0;
}

.category-table {
  color: #5c6873;
  background-color: #e4e7ea;
  vertical-align: bottom;
  border: 2px solid #c8ced3;
  font-size: 15px;
  font-weight: bold;
  padding: 10px;
  margin: 0px;
}

.parent-category-list {
  background-color: white;
  border: 0.5px solid #c8ced3;
  padding: 15px 0px 7.5px 0px;
  margin: 0px;
  vertical-align: middle;
}

.child-category-list {
  background-color: #f4f4f4;
  border: 0.5px solid #c8ced3;
  padding: 15px 0px 7.5px 0px;
  margin: 0px;
  vertical-align: middle;
}

.modal-dialog {
  max-width: 90%;
  width: 90%;
}

.modal-dialog.modal-slim {
  width: 40%;
}

.sk-spinner-pulse.sk-spinner-green.sk-spinner-inline {
  width: 10%;
  height: 40px;
  position: relative;
  left: 0;
  top: 0;
  margin: 0px auto;
}

.form-group.d-inline {
  display: inline !important;
}

.purchase-order-new-product {
  max-width: 100%;
}

.code-generation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 60px 0 60px 0;
}
.code-generation h3 {
  padding-bottom: 25px;
}

.top-form-po {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 0.5px solid #c8ced3;
  margin-top: -1px;
  position: relative;
  padding-top: 10px;
}

.header-top-form-po {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #c8ced3;
  padding-top: 11px;
  padding-left: 18px;
}

.total-product-price {
  width: 100%;
  text-align: right;
  background-color: white;
  padding: 8px 27px;
  font-weight: 700;
  border: 0.5px solid #c8ced3;
}

.discount-taxes-po {
  width: 100%;
  background-color: white;
  padding: 10px;
  margin-bottom: 5px;
}

.total-price {
  width: 100%;
  text-align: right;
  background-color: white;
  padding: 8px 27px;
  margin-bottom: 5px;
  font-weight: 700;
  border: 0.5px solid #c8ced3;
}

.po-bottom-fields {
  border: 0.5px solid #c8ced3;
  background-color: white;
  margin-bottom: 15px;
}

.product-table-po {
  margin-bottom: 0px !important;
}

.tr-header-style {
  background-color: #335169;
  color: white;
}

.po-creation-date {
  padding: 14px 1px 16px 16px;
}

.po-discount {
  background-color: white;
  padding: 10px;
  text-align: right;
  margin-bottom: 1px;
  padding-right: 27px;
  border: 0.5px solid #c8ced3;
}

.product-table-po .table-bordered tr td {
  padding: 5px;
}

.product-table-po .table-bordered tr td datafield {
  background-color: red;
}

.po-form .rw-dropdown-list.rw-widget {
  width: 300px;
}

.date-picker-po-edit .date-input {
  width: 180px;
  height: 33px;
  border-radius: 5px;
  border-width: thin;
}

.date-picker-po-edit .date-input-error {
  width: 180px;
  border-color: #ea5455;
  border-radius: 5px;
  border-width: 2px;
}

.goods-receipt-form {
  background-color: white;
}

/** Shipper HQ items */
.shipping-selected-names {
  padding: 7px;
  border: 1px solid black;
  border-radius: 4px;
  margin-right: 7px;
}

.shipping-selected-names-row {
  padding: 5px;
  line-height: 2.5;
}

.comparison-list {
  white-space: normal;
  text-align: left;
}

.po-list .react-bs-table table td,
.react-bs-table table th {
  white-space: initial;
}

.good-receipts-notes-PO-show {
  border: 0.5px solid #c8ced3;
  padding: 10px;
  margin-bottom: 20px;
}

.po-form-status {
  margin-bottom: 12px;
}

.td-header-error {
  color: red;
}

.suborder-tag-remove-btn {
  position: absolute;
  top: -20px;
  left: -20px;
}

.nav-bar-warning,
.nav-bar-warning a {
  margin: 0 auto !important;
  font-size: 30px !important;
  text-align: center !important;
  color: red !important;
}
.nav-bar-warning p,
.nav-bar-warning a p {
  margin-bottom: 0px !important;
}

.address_error {
  color: red;
}

.roleButton {
  margin-top: 10px;
}

.icon {
  padding: 4px;
}

.product-spec-component .form-group {
  padding: 5px 15px;
  margin-bottom: 0;
}

.field-group .field-option {
  margin-bottom: none !important;
}

.tier-price-box {
  border: 1px solid #e4e5e6;
  padding: 15px;
  border-radius: 5px;
}

.role-table .react-bs-table table td {
  white-space: normal !important;
}

.role-name {
  margin-right: 7px;
}

.price-configuration {
  display: flex;
  justify-content: space-between;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-container .checkmark {
  position: absolute;
  top: -10px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1px solid black;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #335269;
}

.checkbox-container :after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

#custom_css_block {
  max-width: 100%;
}

.portal-form {
  background-color: #ffffff !important;
}

.bundle-edit-name {
  font-size: 15px;
  width: 300px;
}

.bundle-edit-name-input {
  width: 300px;
  color: #000;
}

.bundle-edit-description-input {
  width: 300px;
}

.bundle-edit-description {
  margin-left: 5px;
}

.bundle-edit-descr-label {
  font-size: 15px;
  font-weight: bold;
}

.bundle-edit-filter {
  float: right;
  color: #000;
}

.bundle-edit-label {
  display: inline-block;
  width: 100px;
}

.bundle-group-new-edit {
  margin-bottom: 5px;
}
.bundle-group-new-edit input {
  width: 200px;
}

.bundle-product-disabled {
  background-color: #dcdcdc;
}
.bundle-product-disabled td {
  color: rgba(0, 0, 0, 0.3);
}

.bundle-group-disabled {
  background-color: #dcdcdc;
}
.bundle-group-disabled div span {
  color: rgba(0, 0, 0, 0.4);
}

.disabled-group-header {
  color: rgba(0, 0, 0, 0.4);
}

.bundle-group-body-disabled .bundle-edit-descr-label,
.bundle-group-body-disabled .bundle-edit-description,
.bundle-group-body-disabled th,
.bundle-group-body-disabled td {
  color: rgba(0, 0, 0, 0.4);
}

.icon-button-dimensions {
  background-color: #00a0dd !important;
  border-color: #00a0dd !important;
}

.icon-button-dimensions:hover {
  background-color: #0576a3 !important;
  border-color: #0576a3 !important;
}

.cell-left-aligned {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding-bottom: 2px !important;
  text-align: left !important;
  margin-right: 2px !important;
  margin-left: 4px !important;
  font-weight: normal !important;
  margin-left: 4px !important;
}

.custom-modal-style {
  width: 30%;
  margin: 0 auto;
}

.modal-title {
  width: 100%;
  padding: 5px;
}

.protected-button-left-space {
  margin-left: 10px !important;
}

.dx-toolbar.dx-widget.dx-popup-title {
  background: #00a0dd;
}

.dx-popup-title.dx-toolbar .dx-item.dx-toolbar-item.dx-toolbar-label {
  color: #fff;
  font-size: 20px;
  font-family: "Montserrat", Helvetica, Arial, serif;
}

.devex-column-vertical-align {
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.dx-freespace-row {
  display: none !important;
}

.devex-grid-nodata-container {
  width: 95%;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fdfeff;
  padding: 4rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.devex-grid-nodata-container .devex-grid-nodata-container-copy {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.card-header-light {
  color: #4e5154 !important;
  background-color: #f7f7f7 !important;
}

.card-header-white {
  color: #4e5154 !important;
  background-color: #fff !important;
}

.card-header-dark-blue {
  color: #dae1e7 !important;
  background-color: #3a4459 !important;
}

.dx-tabs-wrapper {
  background-color: #f7f7f7;
}

.dark-layout textarea.notes-input {
  color: #2e2b3b !important;
}

.modal-progress {
  position: absolute;
  width: 50%;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}

.full-width {
  width: 100%;
}

.left-align {
  justify-content: flex-start;
  display: flex;
  align-items: center;
}

.right-align {
  justify-content: flex-end;
  display: flex;
  align-items: center;
}

.center-align {
  justify-content: center;
  display: flex;
  align-items: center;
}

.sweet-alert-confirm-btn,
.sweet-alert-confirm-btn:focus,
.sweet-alert-confirm-btn:active {
  color: #fff !important;
}

.sweet-alert-cancel-btn,
.sweet-alert-cancel-btn:focus,
.sweet-alert-cancel-btn:active {
  color: #00a0dd !important;
}

.sweetalert-wide {
  width: 500px !important;
}

.sweetalert-narrow {
  width: 280px !important;
}

.sweetalert-tag-inputs {
  padding: 0 25px;
}

.sweetalert-narrow > p {
  margin: 0 !important;
}

.dx-first-row.dx-last-col.dx-first-row.dx-first-row.dx-first-row > .dx-item-content .dx-box-item-content {
  background-color: blue !important;
  /* text-align: right!important; */
}

.align-right {
  text-align: right;
}

.duration {
  padding-top: 8px;
  color: #84858c;
}

.image-item {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.image-item:hover {
  transform: scale(1.05);
}

.image-item button {
  opacity: 0.7;
}

.image-item button:hover {
  opacity: 1;
}

html body .app.flex-row.align-items-center {
  height: 100vh;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  #root {
    display: flex;
    flex-direction: column;
  }
}
@-webkit-keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0.95) translate(-50%, -50%);
    transform: scale(0.95) translate(-50%, -50%);
    opacity: 0.65;
  }
  100% {
    -webkit-transform: scale(1) translate(-50%, -50%);
    transform: scale(1) translate(-50%, -50%);
  }
}
@keyframes roll {
  0% {
    transform: translateX(-150%) rotate(0deg);
  }
  100% {
    transform: translateX(150%) rotate(360deg);
  }
}
@keyframes logo-spin {
  0% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(0.8);
  }
}`, "",{"version":3,"sources":["webpack://./src/@core/scss/core.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/@core/scss/base/bootstrap-extended/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/@core/scss/base/bootstrap-extended/_reboot.scss","webpack://./src/@core/scss/base/bootstrap-extended/_helper.scss","webpack://./src/@core/scss/base/bootstrap-extended/_type.scss","webpack://./src/@core/scss/base/bootstrap-extended/_code.scss","webpack://./src/@core/scss/base/bootstrap-extended/_tables.scss","webpack://./src/@core/scss/base/bootstrap-extended/_forms.scss","webpack://./src/@core/scss/base/components/_variables.scss","webpack://./src/@core/scss/base/bootstrap-extended/_buttons.scss","webpack://./src/@core/scss/base/bootstrap-extended/_button-group.scss","webpack://./src/@core/scss/base/bootstrap-extended/_dropdown.scss","webpack://./src/@core/scss/base/bootstrap-extended/_navbar.scss","webpack://./src/@core/scss/base/bootstrap-extended/_breadcrumb.scss","webpack://./src/@core/scss/base/bootstrap-extended/_badge.scss","webpack://./src/@core/scss/base/bootstrap-extended/_nav.scss","webpack://./src/@core/scss/base/bootstrap-extended/mixins/_navs.scss","webpack://./src/@core/scss/base/bootstrap-extended/_media.scss","webpack://./src/@core/scss/base/bootstrap-extended/_progress.scss","webpack://./src/@core/scss/base/bootstrap-extended/_list-group.scss","webpack://./src/@core/scss/base/bootstrap-extended/_collapse.scss","webpack://./src/@core/scss/base/bootstrap-extended/_pagination.scss","webpack://./src/@core/scss/base/bootstrap-extended/_modal.scss","webpack://./src/@core/scss/base/bootstrap-extended/_popover.scss","webpack://./src/@core/scss/base/bootstrap-extended/_utilities.scss","webpack://./src/@core/scss/base/core/colors/_palette.scss","webpack://./src/@core/scss/base/core/mixins/hex2rgb.scss","webpack://./src/@core/scss/base/core/colors/palette-variables.scss","webpack://./src/@core/scss/base/core/colors/palette-gradient.scss","webpack://./src/@core/scss/base/core/layouts/_content.scss","webpack://./src/@core/scss/base/core/mixins/main-menu-mixin.scss","webpack://./src/@core/scss/base/core/layouts/_sidebar.scss","webpack://./src/@core/scss/base/core/layouts/_footer.scss","webpack://./src/@core/scss/base/core/menu/_navigation.scss","webpack://./src/@core/scss/base/components/avatar.scss","webpack://./src/@core/scss/base/components/search.scss","webpack://./src/@core/scss/base/components/bootstrap-social.scss","webpack://./src/@core/scss/base/components/demo.scss","webpack://./src/@core/scss/base/components/customizer.scss","webpack://./src/@core/scss/base/components/divider.scss","webpack://./src/@core/scss/base/components/timeline.scss","webpack://./src/@core/scss/base/plugins/ui/_breakpoints.scss","webpack://./src/@core/scss/base/plugins/forms/select2/_select2.scss","webpack://./src/@core/scss/base/components/_variables-dark.scss","webpack://./src/@core/scss/base/plugins/tables/_datatables.scss","webpack://./src/@core/scss/base/plugins/forms/form-number-input.scss","webpack://./src/@core/scss/base/themes/dark-layout.scss","webpack://./src/@core/scss/base/themes/bordered-layout.scss","webpack://./src/@core/scss/base/custom-rtl.scss","webpack://./src/@core/scss/react/_base-extended.scss","webpack://./src/@core/scss/react/_dark-layout.scss","webpack://./src/@core/scss/react/_rtl.scss","webpack://./src/@core/scss/react/reactstrap/_input.scss","webpack://./src/@core/scss/react/reactstrap/_toast.scss","webpack://./src/@core/scss/react/reactstrap/_switch.scss","webpack://./src/@core/scss/react/reactstrap/_dropdown.scss","webpack://./src/@core/scss/react/reactstrap/_collapse.scss","webpack://./src/@core/scss/react/reactstrap/_carousel.scss","webpack://./src/@core/scss/react/reactstrap/_pagination.scss","webpack://./src/@core/scss/react/app-loader.scss","webpack://./src/assets/scss/style_vuexy.scss","webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/_custom.scss","webpack://./src/assets/scss/_ie-fix.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACCA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,+DAAA;EACA,8DAAA;AFkBF;;AGlBA;;;EAGE,sBAAA;AHqBF;;AGlBA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gDAAA;AHqBF;;AGfA;EACE,cAAA;AHkBF;;AGRA;EACE,SAAA;EACA,kDC4GuB;EC5BnB,mBAtCa;EFxCjB,gBCmHmB;EDlHnB,iBCsHiB;EDrHjB,cCmEW;EDlEX,gBAAA;EACA,yBCgEQ;AJrDV;;AGCA;EACE,qBAAA;AHEF;;AGOA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHJF;;AGiBA;EACE,aAAA;EACA,wBGgN4B;AN9N9B;;AGqBA;EACE,aAAA;EACA,mBGoF0B;ANtG5B;;AG6BA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AH1BF;;AG6BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AH1BF;;AG6BA;;;EAGE,aAAA;EACA,mBAAA;AH1BF;;AG6BA;;;;EAIE,gBAAA;AH1BF;;AG6BA;EACE,gBCsBiB;AJhDnB;;AG6BA;EACE,qBAAA;EACA,cAAA;AH1BF;;AG6BA;EACE,gBAAA;AH1BF;;AG6BA;;EAEE,gBCSmB;AJnCrB;;AG6BA;EExFI,cAAA;AL+DJ;;AGkCA;;EAEE,kBAAA;EEnGE,cAAA;EFqGF,cAAA;EACA,wBAAA;AH/BF;;AGkCA;EAAM,eAAA;AH9BN;;AG+BA;EAAM,WAAA;AH3BN;;AGkCA;EACE,cCnJa;EDoJb,qBGXwC;EHYxC,6BAAA;AH/BF;AOjJE;EJmLE,cClEe;EDmEf,qBClEoB;AJmCxB;;AGwCA;EACE,cAAA;EACA,qBAAA;AHrCF;AO1JE;EJkME,cAAA;EACA,qBAAA;AHrCJ;;AG8CA;;;;EAIE,kDChEsB;ECpFpB,cAAA;AL0GJ;;AG8CA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AHhDF;;AGwDA;EAEE,gBAAA;AHtDF;;AG8DA;EACE,sBAAA;EACA,kBAAA;AH3DF;;AG8DA;EAGE,gBAAA;EACA,sBAAA;AH7DF;;AGqEA;EACE,yBAAA;AHlEF;;AGqEA;EACE,qBC7EmB;ED8EnB,wBC9EmB;ED+EnB,cCtFW;EDuFX,gBAAA;EACA,oBAAA;AHlEF;;AGqEA;EAGE,mBAAA;AHpEF;;AG4EA;EAEE,qBAAA;EACA,sBCvDoB;AJnBtB;;AGgFA;EAEE,gBAAA;AH9EF;;AGqFA;EACE,mBAAA;EACA,0CAAA;AHlFF;;AGqFA;;;;;EAKE,SAAA;EACA,oBAAA;EExPE,kBAAA;EF0PF,oBAAA;AHlFF;;AGqFA;;EAEE,iBAAA;AHlFF;;AGqFA;;EAEE,oBAAA;AHlFF;;AGwFA;EACE,eAAA;AHrFF;;AG2FA;EACE,iBAAA;AHxFF;;AG+FA;;;;EAIE,0BAAA;AH5FF;;AGqGI;;;;EACE,eAAA;AH/FN;;AGqGA;;;;EAIE,UAAA;EACA,kBAAA;AHlGF;;AGqGA;;EAEE,sBAAA;EACA,UAAA;AHlGF;;AGsGA;EACE,cAAA;EAEA,gBAAA;AHpGF;;AGuGA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AH1GF;;AG+GA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE/RI,iBAtCa;EFuUjB,oBAAA;EACA,cAAA;EACA,mBAAA;AH5GF;;AG+GA;EACE,wBAAA;AH5GF;;AGgHA;;EAEE,YAAA;AH7GF;;AGgHA;EAKE,oBAAA;EACA,wBAAA;AHjHF;;AGwHA;EACE,wBAAA;AHrHF;;AG6HA;EACE,aAAA;EACA,0BAAA;AH1HF;;AGiIA;EACE,qBAAA;AH9HF;;AGiIA;EACE,kBAAA;EACA,eAAA;AH9HF;;AGiIA;EACE,aAAA;AH9HF;;AGmIA;EACE,wBAAA;AHhIF;;AQxVA;;EAEE,wBFqS4B;EEpS5B,oBJuKqB;EItKrB,gBFqS4B;EEpS5B,gBFqS4B;EEpS5B,cJqKe;AJsLjB;;AQxVA;EHgHM,kBAtCa;ALkRnB;;AQ3VA;EH+GM,qBAtCa;ALsRnB;;AQ9VA;EH8GM,oBAtCa;AL0RnB;;AQjWA;EH6GM,qBAtCa;AL8RnB;;AQpWA;EH4GM,qBAtCa;ALkSnB;;AQvWA;EH2GM,mBAtCa;ALsSnB;;AQzWA;EHyGM,oBAtCa;EGjEjB,gBJ4ImB;AJgOrB;;AQxWA;EHmGM,eAtCa;EG3DjB,gBJsImB;EIrInB,gBFiR4B;AN0F9B;;AQzWA;EH8FM,iBAtCa;EGtDjB,gBJiImB;EIhInB,gBF4Q4B;ANgG9B;;AQ1WA;EHyFM,iBAtCa;EGjDjB,gBJ4HmB;EI3HnB,gBFuQ4B;ANsG9B;;AQ3WA;EHoFM,iBAtCa;EG5CjB,gBJuHmB;EItHnB,gBFkQ4B;AN4G9B;;AQtWA;EACE,oBJyBO;EIxBP,uBJwBO;EIvBP,SAAA;EACA,6BAAA;ARyWF;;AQjWA;;EH6DM,kBAtCa;EGpBjB,gBJ+FmB;AJqQrB;;AQjWA;;EAEE,cFkQ4B;EEjQ5B,yBF0Q4B;AN0F9B;;AQ5VA;EC/EE,eAAA;EACA,gBAAA;AT+aF;;AQ5VA;ECpFE,eAAA;EACA,gBAAA;ATobF;;AQ9VA;EACE,qBAAA;ARiWF;AQ/VE;EACE,oBFoP0B;AN6G9B;;AQvVA;EHjCI,cAAA;EGmCF,yBAAA;AR0VF;;AQtVA;EACE,uBJhCO;EC+CH,qBAtCa;ALiXnB;;AQtVA;EACE,cAAA;EHUI,kBAtCa;EG8BjB,cJsEW;AJmRb;AQvVE;EACE,aAAA;ARyVJ;;AU5cA;ECIE,eAAA;EAGA,YAAA;AX0cF;;AU3cA;EACE,gBJ6/BkC;EI5/BlC,yBNsGQ;EMrGR,yBAAA;EEEE,wBAAA;EDPF,eAAA;EAGA,YAAA;AXmdF;;AUrcA;EAEE,qBAAA;AVucF;;AUpcA;EACE,wBAAA;EACA,cAAA;AVucF;;AUpcA;ELkCI,cAAA;EKhCF,cNtBS;AJ6dX;;Aa9eA;ERuEI,cAAA;EQrEF,cPmCQ;EOlCR,qBAAA;AbifF;Aa9eE;EACE,cAAA;AbgfJ;;Aa3eA;EACE,sBAAA;ER0DE,cAAA;EQxDF,cTLM;ESMN,sBT4eO;EQ3eL,yBAAA;AZ8eJ;Aa3eE;EACE,UAAA;ERkDA,eAAA;EQhDA,gBT6Ie;AJgWnB;;AaveA;EACE,cAAA;ERyCE,cAAA;EQvCF,cTZS;AJsfX;AaveE;ERoCE,kBAAA;EQlCA,cAAA;EACA,kBAAA;AbyeJ;;AapeA;EACE,iBPwjCkC;EOvjClC,kBAAA;AbueF;;Ac/gBE;;;;;;;ECDA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;Af0hBF;;AgBveI;EFzCE;IACE,gBVkDe;EJkerB;AACF;AgB7eI;EFzCE;IACE,gBVkDe;EJuerB;AACF;AgBlfI;EFzCE;IACE,gBVkDe;EJ4erB;AACF;AgBvfI;EFzCE;IACE,iBVkDe;EJifrB;AACF;AcriBM;EACE,iBVkDe;AJqfvB;;Ac3gBE;ECnCA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;AfkjBF;;Ac5gBE;EACE,eAAA;EACA,cAAA;Ad+gBJ;Ac7gBI;;EAEE,gBAAA;EACA,eAAA;Ad+gBN;;AiBrkBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AjB6kBJ;;AiBvjBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjB0jBR;;Ae9hBE;EACE,cAAA;EACA,eAAA;AfiiBJ;;AeniBE;EACE,aAAA;EACA,cAAA;AfsiBJ;;AexiBE;EACE,wBAAA;EACA,yBAAA;Af2iBJ;;Ae7iBE;EACE,aAAA;EACA,cAAA;AfgjBJ;;AeljBE;EACE,aAAA;EACA,cAAA;AfqjBJ;;AevjBE;EACE,wBAAA;EACA,yBAAA;Af0jBJ;;AiB7kBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AfglBF;;AiB7kBU;EFbR,uBAAA;EAIA,wBAAA;Af2lBF;;AiBllBU;EFbR,wBAAA;EAIA,yBAAA;AfgmBF;;AiBvlBU;EFbR,aAAA;EAIA,cAAA;AfqmBF;;AiB5lBU;EFbR,wBAAA;EAIA,yBAAA;Af0mBF;;AiBjmBU;EFbR,wBAAA;EAIA,yBAAA;Af+mBF;;AiBtmBU;EFbR,aAAA;EAIA,cAAA;AfonBF;;AiB3mBU;EFbR,wBAAA;EAIA,yBAAA;AfynBF;;AiBhnBU;EFbR,wBAAA;EAIA,yBAAA;Af8nBF;;AiBrnBU;EFbR,aAAA;EAIA,cAAA;AfmoBF;;AiB1nBU;EFbR,wBAAA;EAIA,yBAAA;AfwoBF;;AiB/nBU;EFbR,wBAAA;EAIA,yBAAA;Af6oBF;;AiBpoBU;EFbR,cAAA;EAIA,eAAA;AfkpBF;;AiBnoBM;EAAwB,SAAA;AjBuoB9B;;AiBroBM;EAAuB,SAAA;AjByoB7B;;AiBtoBQ;EAAwB,QADb;AjB2oBnB;;AiB1oBQ;EAAwB,QADb;AjB+oBnB;;AiB9oBQ;EAAwB,QADb;AjBmpBnB;;AiBlpBQ;EAAwB,QADb;AjBupBnB;;AiBtpBQ;EAAwB,QADb;AjB2pBnB;;AiB1pBQ;EAAwB,QADb;AjB+pBnB;;AiB9pBQ;EAAwB,QADb;AjBmqBnB;;AiBlqBQ;EAAwB,QADb;AjBuqBnB;;AiBtqBQ;EAAwB,QADb;AjB2qBnB;;AiB1qBQ;EAAwB,QADb;AjB+qBnB;;AiB9qBQ;EAAwB,SADb;AjBmrBnB;;AiBlrBQ;EAAwB,SADb;AjBurBnB;;AiBtrBQ;EAAwB,SADb;AjB2rBnB;;AiBnrBY;EFhBV,0BAAA;AfusBF;;AiBvrBY;EFhBV,2BAAA;Af2sBF;;AiB3rBY;EFhBV,gBAAA;Af+sBF;;AiB/rBY;EFhBV,2BAAA;AfmtBF;;AiBnsBY;EFhBV,2BAAA;AfutBF;;AiBvsBY;EFhBV,gBAAA;Af2tBF;;AiB3sBY;EFhBV,2BAAA;Af+tBF;;AiB/sBY;EFhBV,2BAAA;AfmuBF;;AiBntBY;EFhBV,gBAAA;AfuuBF;;AiBvtBY;EFhBV,2BAAA;Af2uBF;;AiB3tBY;EFhBV,2BAAA;Af+uBF;;AgB1uBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBywBN;;Ee7uBA;IACE,cAAA;IACA,eAAA;EfgvBF;;EelvBA;IACE,aAAA;IACA,cAAA;EfqvBF;;EevvBA;IACE,wBAAA;IACA,yBAAA;Ef0vBF;;Ee5vBA;IACE,aAAA;IACA,cAAA;Ef+vBF;;EejwBA;IACE,aAAA;IACA,cAAA;EfowBF;;EetwBA;IACE,wBAAA;IACA,yBAAA;EfywBF;;EiB5xBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ef+xBA;;EiB5xBQ;IFbR,uBAAA;IAIA,wBAAA;Ef0yBA;;EiBjyBQ;IFbR,wBAAA;IAIA,yBAAA;Ef+yBA;;EiBtyBQ;IFbR,aAAA;IAIA,cAAA;EfozBA;;EiB3yBQ;IFbR,wBAAA;IAIA,yBAAA;EfyzBA;;EiBhzBQ;IFbR,wBAAA;IAIA,yBAAA;Ef8zBA;;EiBrzBQ;IFbR,aAAA;IAIA,cAAA;Efm0BA;;EiB1zBQ;IFbR,wBAAA;IAIA,yBAAA;Efw0BA;;EiB/zBQ;IFbR,wBAAA;IAIA,yBAAA;Ef60BA;;EiBp0BQ;IFbR,aAAA;IAIA,cAAA;Efk1BA;;EiBz0BQ;IFbR,wBAAA;IAIA,yBAAA;Efu1BA;;EiB90BQ;IFbR,wBAAA;IAIA,yBAAA;Ef41BA;;EiBn1BQ;IFbR,cAAA;IAIA,eAAA;Efi2BA;;EiBl1BI;IAAwB,SAAA;EjBs1B5B;;EiBp1BI;IAAuB,SAAA;EjBw1B3B;;EiBr1BM;IAAwB,QADb;EjB01BjB;;EiBz1BM;IAAwB,QADb;EjB81BjB;;EiB71BM;IAAwB,QADb;EjBk2BjB;;EiBj2BM;IAAwB,QADb;EjBs2BjB;;EiBr2BM;IAAwB,QADb;EjB02BjB;;EiBz2BM;IAAwB,QADb;EjB82BjB;;EiB72BM;IAAwB,QADb;EjBk3BjB;;EiBj3BM;IAAwB,QADb;EjBs3BjB;;EiBr3BM;IAAwB,QADb;EjB03BjB;;EiBz3BM;IAAwB,QADb;EjB83BjB;;EiB73BM;IAAwB,SADb;EjBk4BjB;;EiBj4BM;IAAwB,SADb;EjBs4BjB;;EiBr4BM;IAAwB,SADb;EjB04BjB;;EiBl4BU;IFhBV,cAAA;Efs5BA;;EiBt4BU;IFhBV,0BAAA;Ef05BA;;EiB14BU;IFhBV,2BAAA;Ef85BA;;EiB94BU;IFhBV,gBAAA;Efk6BA;;EiBl5BU;IFhBV,2BAAA;Efs6BA;;EiBt5BU;IFhBV,2BAAA;Ef06BA;;EiB15BU;IFhBV,gBAAA;Ef86BA;;EiB95BU;IFhBV,2BAAA;Efk7BA;;EiBl6BU;IFhBV,2BAAA;Efs7BA;;EiBt6BU;IFhBV,gBAAA;Ef07BA;;EiB16BU;IFhBV,2BAAA;Ef87BA;;EiB96BU;IFhBV,2BAAA;Efk8BA;AACF;AgB97BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB49BN;;Eeh8BA;IACE,cAAA;IACA,eAAA;Efm8BF;;Eer8BA;IACE,aAAA;IACA,cAAA;Efw8BF;;Ee18BA;IACE,wBAAA;IACA,yBAAA;Ef68BF;;Ee/8BA;IACE,aAAA;IACA,cAAA;Efk9BF;;Eep9BA;IACE,aAAA;IACA,cAAA;Efu9BF;;Eez9BA;IACE,wBAAA;IACA,yBAAA;Ef49BF;;EiB/+BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Efk/BA;;EiB/+BQ;IFbR,uBAAA;IAIA,wBAAA;Ef6/BA;;EiBp/BQ;IFbR,wBAAA;IAIA,yBAAA;EfkgCA;;EiBz/BQ;IFbR,aAAA;IAIA,cAAA;EfugCA;;EiB9/BQ;IFbR,wBAAA;IAIA,yBAAA;Ef4gCA;;EiBngCQ;IFbR,wBAAA;IAIA,yBAAA;EfihCA;;EiBxgCQ;IFbR,aAAA;IAIA,cAAA;EfshCA;;EiB7gCQ;IFbR,wBAAA;IAIA,yBAAA;Ef2hCA;;EiBlhCQ;IFbR,wBAAA;IAIA,yBAAA;EfgiCA;;EiBvhCQ;IFbR,aAAA;IAIA,cAAA;EfqiCA;;EiB5hCQ;IFbR,wBAAA;IAIA,yBAAA;Ef0iCA;;EiBjiCQ;IFbR,wBAAA;IAIA,yBAAA;Ef+iCA;;EiBtiCQ;IFbR,cAAA;IAIA,eAAA;EfojCA;;EiBriCI;IAAwB,SAAA;EjByiC5B;;EiBviCI;IAAuB,SAAA;EjB2iC3B;;EiBxiCM;IAAwB,QADb;EjB6iCjB;;EiB5iCM;IAAwB,QADb;EjBijCjB;;EiBhjCM;IAAwB,QADb;EjBqjCjB;;EiBpjCM;IAAwB,QADb;EjByjCjB;;EiBxjCM;IAAwB,QADb;EjB6jCjB;;EiB5jCM;IAAwB,QADb;EjBikCjB;;EiBhkCM;IAAwB,QADb;EjBqkCjB;;EiBpkCM;IAAwB,QADb;EjBykCjB;;EiBxkCM;IAAwB,QADb;EjB6kCjB;;EiB5kCM;IAAwB,QADb;EjBilCjB;;EiBhlCM;IAAwB,SADb;EjBqlCjB;;EiBplCM;IAAwB,SADb;EjBylCjB;;EiBxlCM;IAAwB,SADb;EjB6lCjB;;EiBrlCU;IFhBV,cAAA;EfymCA;;EiBzlCU;IFhBV,0BAAA;Ef6mCA;;EiB7lCU;IFhBV,2BAAA;EfinCA;;EiBjmCU;IFhBV,gBAAA;EfqnCA;;EiBrmCU;IFhBV,2BAAA;EfynCA;;EiBzmCU;IFhBV,2BAAA;Ef6nCA;;EiB7mCU;IFhBV,gBAAA;EfioCA;;EiBjnCU;IFhBV,2BAAA;EfqoCA;;EiBrnCU;IFhBV,2BAAA;EfyoCA;;EiBznCU;IFhBV,gBAAA;Ef6oCA;;EiB7nCU;IFhBV,2BAAA;EfipCA;;EiBjoCU;IFhBV,2BAAA;EfqpCA;AACF;AgBjpCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB+qCN;;EenpCA;IACE,cAAA;IACA,eAAA;EfspCF;;EexpCA;IACE,aAAA;IACA,cAAA;Ef2pCF;;Ee7pCA;IACE,wBAAA;IACA,yBAAA;EfgqCF;;EelqCA;IACE,aAAA;IACA,cAAA;EfqqCF;;EevqCA;IACE,aAAA;IACA,cAAA;Ef0qCF;;Ee5qCA;IACE,wBAAA;IACA,yBAAA;Ef+qCF;;EiBlsCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfqsCA;;EiBlsCQ;IFbR,uBAAA;IAIA,wBAAA;EfgtCA;;EiBvsCQ;IFbR,wBAAA;IAIA,yBAAA;EfqtCA;;EiB5sCQ;IFbR,aAAA;IAIA,cAAA;Ef0tCA;;EiBjtCQ;IFbR,wBAAA;IAIA,yBAAA;Ef+tCA;;EiBttCQ;IFbR,wBAAA;IAIA,yBAAA;EfouCA;;EiB3tCQ;IFbR,aAAA;IAIA,cAAA;EfyuCA;;EiBhuCQ;IFbR,wBAAA;IAIA,yBAAA;Ef8uCA;;EiBruCQ;IFbR,wBAAA;IAIA,yBAAA;EfmvCA;;EiB1uCQ;IFbR,aAAA;IAIA,cAAA;EfwvCA;;EiB/uCQ;IFbR,wBAAA;IAIA,yBAAA;Ef6vCA;;EiBpvCQ;IFbR,wBAAA;IAIA,yBAAA;EfkwCA;;EiBzvCQ;IFbR,cAAA;IAIA,eAAA;EfuwCA;;EiBxvCI;IAAwB,SAAA;EjB4vC5B;;EiB1vCI;IAAuB,SAAA;EjB8vC3B;;EiB3vCM;IAAwB,QADb;EjBgwCjB;;EiB/vCM;IAAwB,QADb;EjBowCjB;;EiBnwCM;IAAwB,QADb;EjBwwCjB;;EiBvwCM;IAAwB,QADb;EjB4wCjB;;EiB3wCM;IAAwB,QADb;EjBgxCjB;;EiB/wCM;IAAwB,QADb;EjBoxCjB;;EiBnxCM;IAAwB,QADb;EjBwxCjB;;EiBvxCM;IAAwB,QADb;EjB4xCjB;;EiB3xCM;IAAwB,QADb;EjBgyCjB;;EiB/xCM;IAAwB,QADb;EjBoyCjB;;EiBnyCM;IAAwB,SADb;EjBwyCjB;;EiBvyCM;IAAwB,SADb;EjB4yCjB;;EiB3yCM;IAAwB,SADb;EjBgzCjB;;EiBxyCU;IFhBV,cAAA;Ef4zCA;;EiB5yCU;IFhBV,0BAAA;Efg0CA;;EiBhzCU;IFhBV,2BAAA;Efo0CA;;EiBpzCU;IFhBV,gBAAA;Efw0CA;;EiBxzCU;IFhBV,2BAAA;Ef40CA;;EiB5zCU;IFhBV,2BAAA;Efg1CA;;EiBh0CU;IFhBV,gBAAA;Efo1CA;;EiBp0CU;IFhBV,2BAAA;Efw1CA;;EiBx0CU;IFhBV,2BAAA;Ef41CA;;EiB50CU;IFhBV,gBAAA;Efg2CA;;EiBh1CU;IFhBV,2BAAA;Efo2CA;;EiBp1CU;IFhBV,2BAAA;Efw2CA;AACF;AgBp2CI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBk4CN;;Eet2CA;IACE,cAAA;IACA,eAAA;Efy2CF;;Ee32CA;IACE,aAAA;IACA,cAAA;Ef82CF;;Eeh3CA;IACE,wBAAA;IACA,yBAAA;Efm3CF;;Eer3CA;IACE,aAAA;IACA,cAAA;Efw3CF;;Ee13CA;IACE,aAAA;IACA,cAAA;Ef63CF;;Ee/3CA;IACE,wBAAA;IACA,yBAAA;Efk4CF;;EiBr5CI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Efw5CA;;EiBr5CQ;IFbR,uBAAA;IAIA,wBAAA;Efm6CA;;EiB15CQ;IFbR,wBAAA;IAIA,yBAAA;Efw6CA;;EiB/5CQ;IFbR,aAAA;IAIA,cAAA;Ef66CA;;EiBp6CQ;IFbR,wBAAA;IAIA,yBAAA;Efk7CA;;EiBz6CQ;IFbR,wBAAA;IAIA,yBAAA;Efu7CA;;EiB96CQ;IFbR,aAAA;IAIA,cAAA;Ef47CA;;EiBn7CQ;IFbR,wBAAA;IAIA,yBAAA;Efi8CA;;EiBx7CQ;IFbR,wBAAA;IAIA,yBAAA;Efs8CA;;EiB77CQ;IFbR,aAAA;IAIA,cAAA;Ef28CA;;EiBl8CQ;IFbR,wBAAA;IAIA,yBAAA;Efg9CA;;EiBv8CQ;IFbR,wBAAA;IAIA,yBAAA;Efq9CA;;EiB58CQ;IFbR,cAAA;IAIA,eAAA;Ef09CA;;EiB38CI;IAAwB,SAAA;EjB+8C5B;;EiB78CI;IAAuB,SAAA;EjBi9C3B;;EiB98CM;IAAwB,QADb;EjBm9CjB;;EiBl9CM;IAAwB,QADb;EjBu9CjB;;EiBt9CM;IAAwB,QADb;EjB29CjB;;EiB19CM;IAAwB,QADb;EjB+9CjB;;EiB99CM;IAAwB,QADb;EjBm+CjB;;EiBl+CM;IAAwB,QADb;EjBu+CjB;;EiBt+CM;IAAwB,QADb;EjB2+CjB;;EiB1+CM;IAAwB,QADb;EjB++CjB;;EiB9+CM;IAAwB,QADb;EjBm/CjB;;EiBl/CM;IAAwB,QADb;EjBu/CjB;;EiBt/CM;IAAwB,SADb;EjB2/CjB;;EiB1/CM;IAAwB,SADb;EjB+/CjB;;EiB9/CM;IAAwB,SADb;EjBmgDjB;;EiB3/CU;IFhBV,cAAA;Ef+gDA;;EiB//CU;IFhBV,0BAAA;EfmhDA;;EiBngDU;IFhBV,2BAAA;EfuhDA;;EiBvgDU;IFhBV,gBAAA;Ef2hDA;;EiB3gDU;IFhBV,2BAAA;Ef+hDA;;EiB/gDU;IFhBV,2BAAA;EfmiDA;;EiBnhDU;IFhBV,gBAAA;EfuiDA;;EiBvhDU;IFhBV,2BAAA;Ef2iDA;;EiB3hDU;IFhBV,2BAAA;Ef+iDA;;EiB/hDU;IFhBV,gBAAA;EfmjDA;;EiBniDU;IFhBV,2BAAA;EfujDA;;EiBviDU;IFhBV,2BAAA;Ef2jDA;AACF;AkB/mDA;EACE,WAAA;EACA,uBd0EO;EczEP,cd+GW;AJkgDb;AkB9mDE;;EAEE,iBdwLiB;EcvLjB,mBAAA;EACA,6BAAA;AlBgnDJ;AkB7mDE;EACE,sBAAA;EACA,gCAAA;AlB+mDJ;AkB5mDE;EACE,6BAAA;AlB8mDJ;;AkBpmDE;;EAEE,eZ4T0B;AN2yC9B;;AkB9lDA;EACE,yBAAA;AlBimDF;AkB/lDE;;EAEE,yBAAA;AlBimDJ;AkB7lDI;;EAEE,wBAAA;AlB+lDN;;AkBzlDE;;;;EAIE,SAAA;AlB4lDJ;;AkBnlDE;EACE,yBd2Hc;AJ29ClB;;AOrpDE;EW2EI,cd+BO;Ec9BP,yBd+GW;AJ+9CjB;;AmBhqDI;;;EAGE,yBD2F+B;AlBwkDrC;AmB/pDM;;;;EAIE,qBDmFyE;AlB8kDjF;;AOtqDE;EYiBM,yBAJe;AnB6pDvB;AmBvpDQ;;EAEE,yBARa;AnBiqDvB;;AmBprDI;;;EAGE,yBD2F+B;AlB4lDrC;AmBnrDM;;;;EAIE,qBDmFyE;AlBkmDjF;;AO1rDE;EYiBM,yBAJe;AnBirDvB;AmB3qDQ;;EAEE,yBARa;AnBqrDvB;;AmBxsDI;;;EAGE,yBD2F+B;AlBgnDrC;AmBvsDM;;;;EAIE,qBDmFyE;AlBsnDjF;;AO9sDE;EYiBM,yBAJe;AnBqsDvB;AmB/rDQ;;EAEE,yBARa;AnBysDvB;;AmB5tDI;;;EAGE,yBD2F+B;AlBooDrC;AmB3tDM;;;;EAIE,qBDmFyE;AlB0oDjF;;AOluDE;EYiBM,yBAJe;AnBytDvB;AmBntDQ;;EAEE,yBARa;AnB6tDvB;;AmBhvDI;;;EAGE,yBD2F+B;AlBwpDrC;AmB/uDM;;;;EAIE,qBDmFyE;AlB8pDjF;;AOtvDE;EYiBM,yBAJe;AnB6uDvB;AmBvuDQ;;EAEE,yBARa;AnBivDvB;;AmBpwDI;;;EAGE,yBD2F+B;AlB4qDrC;AmBnwDM;;;;EAIE,qBDmFyE;AlBkrDjF;;AO1wDE;EYiBM,yBAJe;AnBiwDvB;AmB3vDQ;;EAEE,yBARa;AnBqwDvB;;AmBxxDI;;;EAGE,yBD2F+B;AlBgsDrC;AmBvxDM;;;;EAIE,qBDmFyE;AlBssDjF;;AO9xDE;EYiBM,yBAJe;AnBqxDvB;AmB/wDQ;;EAEE,yBARa;AnByxDvB;;AmB5yDI;;;EAGE,yBD2F+B;AlBotDrC;AmB3yDM;;;;EAIE,qBDmFyE;AlB0tDjF;;AOlzDE;EYiBM,yBAJe;AnByyDvB;AmBnyDQ;;EAEE,yBARa;AnB6yDvB;;AmBh0DI;;;EAGE,yBf8LW;AJqoDjB;;AOh0DE;EYiBM,yBAJe;AnBuzDvB;AmBjzDQ;;EAEE,yBARa;AnB2zDvB;;AkBnuDI;EACE,cdvGE;EcwGF,yBdxEQ;EcyER,qBd2FoB;AJ2oD1B;AkBjuDI;EACE,cduDW;EctDX,yBdgFU;Ec/EV,qBdkBS;AJitDf;;AkB9tDA;EACE,cdvHM;EcwHN,yBdxFY;AJyzDd;AkB/tDE;;;EAGE,qBduEsB;AJ0pD1B;AkB9tDE;EACE,SAAA;AlBguDJ;AkB5tDI;EACE,2CZ+NwB;AN+/C9B;AOn2DE;EW4IM,cd7IA;Ec8IA,4CZyNsB;ANigD9B;;AgB1yDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB4sDN;EkBzsDM;IACE,SAAA;ElB2sDR;AACF;AgBtzDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElButDN;EkBptDM;IACE,SAAA;ElBstDR;AACF;AgBj0DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBkuDN;EkB/tDM;IACE,SAAA;ElBiuDR;AACF;AgB50DI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB6uDN;EkB1uDM;IACE,SAAA;ElB4uDR;AACF;AkBtvDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AlBuvDR;AkBpvDQ;EACE,SAAA;AlBsvDV;;AoBn6DA;EACE,cAAA;EACA,WAAA;EACA,gBhBqQa;EgBpQb,sBAAA;EfqHI,eAtCa;Ee5EjB,gBhBuJmB;EgBtJnB,iBhB0JiB;EgBzJjB,chBuGW;EgBtGX,yBhBLM;EgBMN,4BAAA;EACA,yBAAA;ERAE,wBAAA;ESFE,wEDQJ;ApBi6DF;AqBr6DM;EDdN;ICeQ,gBAAA;ErBw6DN;AACF;AoBn6DE;EACE,6BAAA;EACA,SAAA;ApBq6DJ;AoBj6DE;EACE,kBAAA;EACA,0BAAA;ApBm6DJ;AsBz7DE;EACE,clBwGS;EkBvGT,yBlBJI;EkBKJ,qBlBuBW;EkBtBX,UAAA;EAKE,8ClBmPmB;AJosDzB;AoBn6DE;EACE,chBkJS;EgBhJT,UAAA;ApBo6DJ;AoB55DE;EAEE,yBhBuMgB;EgBrMhB,UAAA;ApB45DJ;;AoBp5DE;;;;EACE,gBAAA;ApB05DJ;;AoBr5DE;EAME,chByCS;EgBxCT,yBhBnEI;AJs9DR;;AoB94DA;;EAEE,cAAA;EACA,WAAA;ApBi5DF;;AoBv4DA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;Ef3BE,kBAAA;Ee6BF,iBhBmEiB;AJu0DnB;;AoBv4DA;EACE,gCAAA;EACA,mCAAA;EfqBI,mBAtCa;EemBjB,iBhB8Be;AJ42DjB;;AoBv4DA;EACE,iCAAA;EACA,oCAAA;EfcI,mBAtCa;Ee0BjB,chBwBe;AJk3DjB;;AoBj4DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EfDI,eAtCa;EeyCjB,iBhBsCiB;EgBrCjB,chBbW;EgBcX,6BAAA;EACA,yBAAA;EACA,mBAAA;ApBo4DF;AoBl4DE;EAEE,gBAAA;EACA,eAAA;ApBm4DJ;;AoBv3DA;EACE,gBhBuHgB;EgBtHhB,0BAAA;Ef1BI,mBAtCa;EekEjB,chBhBe;EQzHb,wBAAA;AZogEJ;;AoBv3DA;EACE,iBhBgHgB;EgB/GhB,yBAAA;EflCI,mBAtCa;Ee0EjB,iBhBzBe;EQxHb,wBAAA;AZ4gEJ;;AoBr3DE;EAEE,YAAA;ApBu3DJ;;AoBn3DA;EACE,YAAA;ApBs3DF;;AoB92DA;EACE,mBdyUsC;ANwiDxC;;AoB92DA;EACE,cAAA;EACA,mBd0TsC;ANujDxC;;AoBz2DA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApB42DF;AoB12DE;;EAEE,kBAAA;EACA,iBAAA;ApB42DJ;;AoBn2DA;EACE,kBAAA;EACA,cAAA;EACA,qBd+RsC;ANukDxC;;AoBn2DA;EACE,kBAAA;EACA,kBd2RsC;Ec1RtC,qBAAA;ApBs2DF;AoBn2DE;EAEE,chBzCS;AJ64Db;;AoBh2DA;EACE,gBAAA;ApBm2DF;;AoBh2DA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBd4QsC;ANulDxC;AoBh2DE;EACE,gBAAA;EACA,aAAA;EACA,uBduQoC;EctQpC,cAAA;ApBk2DJ;;AsB/iEE;EACE,aAAA;EACA,WAAA;EACA,mBhBycoC;EDzXlC,kBAtCa;EiBxCf,cFqNqC;ApB61DzC;;AsB/iEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EjBmEE,kBAtCa;EiB3Bf,iBlB0Ge;EkBzGf,cAAA;EACA,yBAAA;EV9CA,wBAAA;AZimEJ;;AsB9iEI;;;;EAEE,cAAA;AtBmjEN;;AsB1lEI;EA6CE,qBFyLmC;EEtLjC,sChB8ZgC;EgB7ZhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,kEAAA;AtB+iER;AsB5iEM;EACE,qBF8KiC;EE7KjC,iDAAA;AtB8iER;;AsBvmEI;EAkEI,sChB4YgC;EgB3YhC,kFAAA;AtByiER;;AsB5mEI;EA0EE,qBF4JmC;EEzJjC,sChB6doC;EgB5dpC,wNAAA;AtBoiER;AsBjiEM;EACE,qBFoJiC;EEnJjC,iDAAA;AtBmiER;;AsB5hEM;EACE,cF2IiC;ApBo5DzC;AsB5hEM;;;EAEE,cAAA;AtB+hER;;AsBxhEM;EACE,cF8HiC;ApB65DzC;AsBzhEQ;EACE,qBF2H+B;ApBg6DzC;AsBthEQ;EACE,qBAAA;EC3IN,yBD4I2B;AtBwhE/B;AsBnhEQ;EACE,iDAAA;AtBqhEV;AsBlhEQ;EACE,qBAVqB;AtB8hE/B;;AsB3gEM;EACE,qBApBuB;AtBkiE/B;AsB1gEQ;EACE,qBAzBqB;EA0BrB,iDAAA;AtB4gEV;;AsB5oEE;EACE,aAAA;EACA,WAAA;EACA,mBhBycoC;EDzXlC,kBAtCa;EiBxCf,cFqNqC;ApB07DzC;;AsB5oEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EjBmEE,kBAtCa;EiB3Bf,iBlB0Ge;EkBzGf,cAAA;EACA,yBAAA;EV9CA,wBAAA;AZ8rEJ;;AsB3oEI;;;;EAEE,cAAA;AtBgpEN;;AsBvrEI;EA6CE,qBFyLmC;EEtLjC,sChB8ZgC;EgB7ZhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,kEAAA;AtB4oER;AsBzoEM;EACE,qBF8KiC;EE7KjC,gDAAA;AtB2oER;;AsBpsEI;EAkEI,sChB4YgC;EgB3YhC,kFAAA;AtBsoER;;AsBzsEI;EA0EE,qBF4JmC;EEzJjC,sChB6doC;EgB5dpC,wNAAA;AtBioER;AsB9nEM;EACE,qBFoJiC;EEnJjC,gDAAA;AtBgoER;;AsBznEM;EACE,cF2IiC;ApBi/DzC;AsBznEM;;;EAEE,cAAA;AtB4nER;;AsBrnEM;EACE,cF8HiC;ApB0/DzC;AsBtnEQ;EACE,qBF2H+B;ApB6/DzC;AsBnnEQ;EACE,qBAAA;EC3IN,yBD4I2B;AtBqnE/B;AsBhnEQ;EACE,gDAAA;AtBknEV;AsB/mEQ;EACE,qBAVqB;AtB2nE/B;;AsBxmEM;EACE,qBApBuB;AtB+nE/B;AsBvmEQ;EACE,qBAzBqB;EA0BrB,gDAAA;AtBymEV;;AoBngEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApBsgEF;AoBjgEE;EACE,WAAA;ApBmgEJ;AgBluEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpBigEJ;EoB7/DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpB+/DJ;EoB3/DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpB6/DJ;EoBz/DE;IACE,qBAAA;EpB2/DJ;EoBx/DE;;IAEE,WAAA;EpB0/DJ;EoBr/DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpBu/DJ;EoBr/DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBd8KkC;Ic7KlC,cAAA;EpBu/DJ;EoBp/DE;IACE,mBAAA;IACA,uBAAA;EpBs/DJ;EoBp/DE;IACE,gBAAA;EpBs/DJ;AACF;;AwBx0EA;EACE,qBAAA;EAEA,gBpB2JmB;EoB1JnB,cpB4GW;EoB3GX,kBAAA;EAGA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,4BAAA;EpBuBI,mBAtCa;EoBiBjB,crBsHgB;EQ9Md,uBAAA;ESFE,+JGGJ;AxB20EF;AqB10EM;EGdN;IHeQ,gBAAA;ErB60EN;AACF;AOv1EE;EiBUE,cpBgGS;EoB/FT,qBAAA;AxBg1EJ;AwB70EE;EAEE,UAAA;EACA,gDlB4W0B;ANk+D9B;AwB10EE;EAEE,alBgZ0B;AN27D9B;AwBv0EE;EACE,eAAA;AxBy0EJ;AwB3zEA;;EAEE,oBAAA;AxB6zEF;;AwBpzEE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AN+yEf;AO/2EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB23EzG;AyB/2EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzB42EN;AyBv2EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AN+zEf;AyBj2EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB24E7L;AyB51EI;EAKI,gDAAA;AzB01ER;;AwBl1EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AN60Ef;AO74EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBy5EzG;AyB74EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AzB04EN;AyBr4EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AN61Ef;AyB/3EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBy6E7L;AyB13EI;EAKI,+CAAA;AzBw3ER;;AwBh3EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AN22Ef;AO36EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBu7EzG;AyB36EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzBw6EN;AyBn6EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AN23Ef;AyB75EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBu8E7L;AyBx5EI;EAKI,gDAAA;AzBs5ER;;AwB94EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;ANy4Ef;AOz8EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBq9EzG;AyBz8EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AzBs8EN;AyBj8EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;ANy5Ef;AyB37EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBq+E7L;AyBt7EI;EAKI,+CAAA;AzBo7ER;;AwB56EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;ANu6Ef;AOv+EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBm/EzG;AyBv+EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;AzBo+EN;AyB/9EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;ANu7Ef;AyBz9EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBmgF7L;AyBp9EI;EAKI,gDAAA;AzBk9ER;;AwB18EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;ANq8Ef;AOrgFE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzBihFzG;AyBrgFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;AzBkgFN;AyB7/EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;ANq9Ef;AyBv/EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBiiF7L;AyBl/EI;EAKI,+CAAA;AzBg/ER;;AwBx+EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;ANm+Ef;AOniFE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB+iFzG;AyBniFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;AzBgiFN;AyB3hFE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;ANm/Ef;AyBrhFE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB+jF7L;AyBhhFI;EAKI,iDAAA;AzB8gFR;;AwBtgFE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;ANigFf;AOjkFE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;AzB6kFzG;AyBjkFE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,8CAAA;AzB8jFN;AyBzjFE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;ANihFf;AyBnjFE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB6lF7L;AyB9iFI;EAKI,8CAAA;AzB4iFR;;AwB9hFE;ECPA,cnBYa;EmBXb,qBnBWa;AN8hFf;AO9lFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANmiFf;AyBtiFE;EAEE,+CAAA;AzBuiFJ;AyBpiFE;EAEE,cnBJW;EmBKX,6BAAA;AzBqiFJ;AyBliFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AN+iFf;AyBhiFI;EAKI,+CAAA;AzB8hFR;;AwBvjFE;ECPA,cnBYa;EmBXb,qBnBWa;ANujFf;AOvnFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AN4jFf;AyB/jFE;EAEE,+CAAA;AzBgkFJ;AyB7jFE;EAEE,cnBJW;EmBKX,6BAAA;AzB8jFJ;AyB3jFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;ANwkFf;AyBzjFI;EAKI,+CAAA;AzBujFR;;AwBhlFE;ECPA,cnBYa;EmBXb,qBnBWa;ANglFf;AOhpFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANqlFf;AyBxlFE;EAEE,gDAAA;AzBylFJ;AyBtlFE;EAEE,cnBJW;EmBKX,6BAAA;AzBulFJ;AyBplFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;ANimFf;AyBllFI;EAKI,gDAAA;AzBglFR;;AwBzmFE;ECPA,cnBYa;EmBXb,qBnBWa;ANymFf;AOzqFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AN8mFf;AyBjnFE;EAEE,+CAAA;AzBknFJ;AyB/mFE;EAEE,cnBJW;EmBKX,6BAAA;AzBgnFJ;AyB7mFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AN0nFf;AyB3mFI;EAKI,+CAAA;AzBymFR;;AwBloFE;ECPA,cnBYa;EmBXb,qBnBWa;ANkoFf;AOlsFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANuoFf;AyB1oFE;EAEE,gDAAA;AzB2oFJ;AyBxoFE;EAEE,cnBJW;EmBKX,6BAAA;AzByoFJ;AyBtoFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;ANmpFf;AyBpoFI;EAKI,gDAAA;AzBkoFR;;AwB3pFE;ECPA,cnBYa;EmBXb,qBnBWa;AN2pFf;AO3tFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANgqFf;AyBnqFE;EAEE,+CAAA;AzBoqFJ;AyBjqFE;EAEE,cnBJW;EmBKX,6BAAA;AzBkqFJ;AyB/pFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AN4qFf;AyB7pFI;EAKI,+CAAA;AzB2pFR;;AwBprFE;ECPA,cnBYa;EmBXb,qBnBWa;ANorFf;AOpvFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANyrFf;AyB5rFE;EAEE,iDAAA;AzB6rFJ;AyB1rFE;EAEE,cnBJW;EmBKX,6BAAA;AzB2rFJ;AyBxrFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;ANqsFf;AyBtrFI;EAKI,iDAAA;AzBorFR;;AwB7sFE;ECPA,cnBYa;EmBXb,qBnBWa;AN6sFf;AO7wFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;ANktFf;AyBrtFE;EAEE,8CAAA;AzBstFJ;AyBntFE;EAEE,cnBJW;EmBKX,6BAAA;AzBotFJ;AyBjtFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AN8tFf;AyB/sFI;EAKI,8CAAA;AzB6sFR;;AwB3tFA;EACE,gBpBiFmB;EoBhFnB,cpB7Ca;EoB8Cb,qBlB2FwC;ANmoF1C;AOvyFE;EiB4EE,cpBqCe;EoBpCf,qBpBqCoB;AJyrFxB;AwB3tFE;EAEE,qBpBgCoB;AJ4rFxB;AwBztFE;EAEE,cpBjFO;EoBkFP,oBAAA;AxB0tFJ;;AwB/sFA;ECPE,uBAAA;EpBuBI,qBAtCa;EoBiBjB,iBrBgCe;EQxHb,uBAAA;AZmzFJ;;AwBltFA;ECXE,0BAAA;EpBuBI,oBAtCa;EoBiBjB,crBiCe;EQzHb,uBAAA;AZ0zFJ;;AwBhtFA;EACE,cAAA;EACA,WAAA;AxBmtFF;AwBhtFE;EACE,kBlBsT0B;AN45E9B;;AwB1sFE;;;EACE,WAAA;AxB+sFJ;;A0B11FA;ELgBM,gCKfJ;A1B61FF;AqB10FM;EKpBN;ILqBQ,gBAAA;ErB60FN;AACF;A0Bh2FE;EACE,UAAA;A1Bk2FJ;;A0B71FE;EACE,aAAA;A1Bg2FJ;;A0B51FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A1B+1FF;AqB71FM;EKNN;ILOQ,gBAAA;ErBg2FN;AACF;;A2Br3FA;;;;EAIE,kBAAA;A3Bw3FF;;A2Br3FA;EACE,mBAAA;A3Bw3FF;A4Bp2FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5Bu4FF;A4Bl1FI;EACE,cAAA;A5Bo1FN;;A2B93FA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WvB0TgB;EuBzThB,aAAA;EACA,WAAA;EACA,gBrB6tBkC;EqB5tBlC,iBAAA;EACA,aAAA;EtBsGI,eAtCa;EsB9DjB,cvB2FW;EuB1FX,gBAAA;EACA,gBAAA;EACA,yBvBnBM;EuBoBN,4BAAA;EACA,wCAAA;EfdE,uBAAA;AZg5FJ;;A2Bz3FI;EACE,WAAA;EACA,OAAA;A3B43FN;;A2Bz3FI;EACE,QAAA;EACA,UAAA;A3B43FN;;AgBh3FI;EWnBA;IACE,WAAA;IACA,OAAA;E3Bu4FJ;;E2Bp4FE;IACE,QAAA;IACA,UAAA;E3Bu4FJ;AACF;AgB53FI;EWnBA;IACE,WAAA;IACA,OAAA;E3Bk5FJ;;E2B/4FE;IACE,QAAA;IACA,UAAA;E3Bk5FJ;AACF;AgBv4FI;EWnBA;IACE,WAAA;IACA,OAAA;E3B65FJ;;E2B15FE;IACE,QAAA;IACA,UAAA;E3B65FJ;AACF;AgBl5FI;EWnBA;IACE,WAAA;IACA,OAAA;E3Bw6FJ;;E2Br6FE;IACE,QAAA;IACA,UAAA;E3Bw6FJ;AACF;A2Bj6FE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,gBvBiRc;AJkpFlB;A4Bl8FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5B89FF;A4Bh7FI;EACE,cAAA;A5Bk7FN;;A2Bv6FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,cvBmQc;AJuqFlB;A4Bv9FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A5B4+FF;A4Br8FI;EACE,cAAA;A5Bu8FN;A2Bl7FI;EACE,iBAAA;A3Bo7FN;;A2B96FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,evBkPc;AJ+rFlB;A4B/+FI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;A5Bi/FN;A4Bt+FM;EACE,aAAA;A5Bw+FR;A4Br+FM;EACE,qBAAA;EACA,qBtB4MsB;EsB3MtB,uBtB0MsB;EsBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5BsgGF;A4Br+FI;EACE,cAAA;A5Bu+FN;A2Bj8FI;EACE,iBAAA;A3Bm8FN;;A2B37FE;EAIE,WAAA;EACA,YAAA;A3B27FJ;;A2Bt7FA;EE9GE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;A7BwiGF;;A2Bt7FA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,gBvBqCmB;EuBpCnB,cvBVW;EuBWX,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3Bw7FF;AO7iGE;EoBoIE,cvB7GW;EuB8GX,qBAAA;EJ/IA,yCnBmUqB;AJyvFzB;A2Bz6FE;EAEE,cvBhJI;EuBiJJ,qBAAA;EJtJA,yBjBoP0B;AN60F9B;A2Bv6FE;EAEE,cvB2BS;EuB1BT,oBAAA;EACA,6BAAA;A3Bw6FJ;;A2Bh6FA;EACE,cAAA;A3Bm6FF;;A2B/5FA;EACE,cAAA;EACA,uBrB4lBkC;EqB3lBlC,gBAAA;EtBrDI,eAtCa;EsB6FjB,cvBLe;EuBMf,mBAAA;A3Bk6FF;;A2B95FA;EACE,cAAA;EACA,wBAAA;EACA,cvBxEW;AJy+Fb;;A8B5lGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9B+lGF;A8B7lGE;;EACE,kBAAA;EACA,cAAA;A9BgmGJ;AO/lGE;;EuBII,UAAA;A9B+lGN;A8B7lGI;;;;EAGE,UAAA;A9BgmGN;;A8B1lGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9B6lGF;A8B3lGE;EACE,WAAA;A9B6lGJ;;A8BvlGE;;EAEE,iBAAA;A9B0lGJ;A8BtlGE;;ElBXE,0BAAA;EACA,6BAAA;AZqmGJ;A8BtlGE;;ElBFE,yBAAA;EACA,4BAAA;AZ4lGJ;;A8BzkGA;EACE,0BAAA;EACA,yBAAA;A9B4kGF;A8B1kGE;EAGE,cAAA;A9B0kGJ;A8BvkGE;EACE,eAAA;A9BykGJ;;A8BrkGA;EACE,yBAAA;EACA,wBAAA;A9BwkGF;;A8BrkGA;EACE,wBAAA;EACA,uBAAA;A9BwkGF;;A8BpjGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9BujGF;A8BrjGE;;EAEE,WAAA;A9BujGJ;A8BpjGE;;EAEE,gBAAA;A9BsjGJ;A8BljGE;;ElBrFE,6BAAA;EACA,4BAAA;AZ2oGJ;A8BljGE;;ElBxGE,yBAAA;EACA,0BAAA;AZ8pGJ;;A8BniGE;;EAEE,gBAAA;A9BsiGJ;A8BpiGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9BwiGN;;A+BjsGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BosGF;A+BlsGE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A/BosGJ;A+BlsGI;;;;;;;;;;;;EAGE,iBAAA;A/B6sGN;A+BxsGE;;;EAGE,UAAA;A/B0sGJ;A+BtsGE;EACE,UAAA;A/BwsGJ;A+BnsGI;;EnBVA,0BAAA;EACA,6BAAA;AZitGJ;A+BvsGI;;EnBGA,yBAAA;EACA,4BAAA;AZwsGJ;A+BvsGE;EACE,aAAA;EACA,mBAAA;A/BysGJ;A+BvsGI;EnBpBA,0BAAA;EACA,6BAAA;AZ8tGJ;A+BzsGI;EnBRA,yBAAA;EACA,4BAAA;AZotGJ;;A+BlsGA;;EAEE,aAAA;A/BqsGF;A+BhsGE;;EACE,kBAAA;EACA,UAAA;A/BmsGJ;A+BjsGI;;EACE,UAAA;A/BosGN;A+BhsGE;;;;;;;;EAIE,iBAAA;A/BssGJ;;A+BlsGA;EAAuB,kBAAA;A/BssGvB;;A+BrsGA;EAAsB,iBAAA;A/BysGtB;;A+BjsGA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;E1BuBI,eAtCa;E0BiBjB,gB3B0DmB;E2BzDnB,iB3B6DiB;E2B5DjB,c3BUW;E2BTX,kBAAA;EACA,mBAAA;EACA,uB3BmKqB;E2BlKrB,yBAAA;EnB9FE,wBAAA;AZmyGJ;A+BjsGE;;EAEE,aAAA;A/BmsGJ;;A+BzrGA;;EAEE,iB3B8IgB;AJ8iGlB;;A+BzrGA;;;;;;EAME,yBAAA;E1BZI,mBAtCa;E0BoDjB,iB3BHe;EQxHb,wBAAA;AZwzGJ;;A+BzrGA;;EAEE,gB3B4HgB;AJgkGlB;;A+BzrGA;;;;;;EAME,0BAAA;E1B7BI,mBAtCa;E0BqEjB,c3BnBe;EQzHb,wBAAA;AZy0GJ;;A+BzrGA;;EAEE,mBAAA;A/B4rGF;;A+BjrGA;;;;;;EnB7II,0BAAA;EACA,6BAAA;AZu0GJ;;A+BlrGA;;;;;;EnBxII,yBAAA;EACA,4BAAA;AZm0GJ;;AgC32GA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AhC82GF;;AgC32GA;EACE,oBAAA;EACA,kB1BwfsC;ANs3FxC;;AgC32GA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W1BofsC;E0BnftC,mBAAA;EACA,UAAA;AhC82GF;AgC52GE;EACE,c5BpBI;E4BqBJ,qB1B0N0B;EiBpP1B,yBjBoP0B;ANqpG9B;AgC12GE;EAKI,8C5B+NmB;AJyoGzB;AgCp2GE;EACE,qB5BRW;AJ82Gf;AgCn2GE;EACE,c5BxCI;E4ByCJ,yB1Bif4C;E0Bhf5C,qB1Bgf4C;ANq3FhD;AgC91GI;EACE,c5B3CK;AJ24GX;AgC91GM;EACE,yB5B8LY;AJkqGpB;;AgCt1GA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AhCw1GF;AgCp1GE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,W1BuboC;E0BtbpC,Y1BsboC;E0BrbpC,oBAAA;EACA,WAAA;EACA,yB5BhFI;E4BiFJ,yBAAA;AhCs1GJ;AgCj1GE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,W1BwaoC;E0BvapC,Y1BuaoC;E0BtapC,WAAA;EACA,iCAAA;AhCm1GJ;;AgCz0GE;EpBjGE,kBAAA;AZ86GJ;AgCx0GI;EACE,yDAAA;AhC00GN;AgCr0GI;EACE,qB1B2HwB;EiBpP1B,yBjBoP0B;AN6sG9B;AgCp0GI;EACE,yDAAA;AhCs0GN;AgCj0GI;ETnIA,yCnB6R2C;AJ0qG/C;AgCj0GI;ETtIA,yCnB6R2C;AJ6qG/C;;AgCzzGE;EAEE,kB1ByZ4C;ANk6FhD;AgCvzGI;EACE,sBAAA;AhCyzGN;AgCpzGI;ET7JA,yCnB6R2C;AJurG/C;;AgC5yGA;EACE,sBAAA;AhC+yGF;AgC5yGI;EACE,eAAA;EACA,e5B4UgB;E4B3UhB,mBAAA;EAEA,uB5B0UkC;AJm+FxC;AgC1yGI;EACE,4BAAA;EACA,2BAAA;EACA,e5BqUyB;E4BpUzB,gB5BoUyB;E4BnUzB,yB5B+CwB;E4B7CxB,uB5BgUkC;EiBjflC,yKWkLA;AhC2yGN;AqBz9GM;EWsKF;IXrKI,gBAAA;ErB49GN;AACF;AgC3yGI;EACE,yB5B7LE;E4B8LF,+BAAA;AhC6yGN;AgCxyGI;ETxMA,yCnB6R2C;AJstG/C;;AgC9xGA;EACE,qBAAA;EACA,WAAA;EACA,gB5BgDa;E4B/Cb,oCAAA;E3BhGI,eAtCa;E2ByIjB,gB5B9DmB;E4B+DnB,iB5B3DiB;E4B4DjB,c5B9GW;E4B+GX,sBAAA;EACA,iGAAA;EACA,yBAAA;EpBrNE,wBAAA;EoBwNF,gBAAA;AhC+xGF;AgC7xGE;EACE,qB5BtMW;E4BuMX,UAAA;EAKE,8C5BsBmB;AJqwGzB;AgCxxGI;EAME,c5BtIO;E4BuIP,yB5BlPE;AJugHR;AgCjxGE;EAEE,YAAA;EACA,mB5BlBc;E4BmBd,sBAAA;AhCkxGJ;AgC/wGE;EACE,c5BvPO;E4BwPP,yB5BZgB;AJ6xGpB;AgC7wGE;EACE,aAAA;AhC+wGJ;AgC3wGE;EACE,kBAAA;EACA,0BAAA;AhC6wGJ;;AgCzwGA;EACE,gB5BXgB;E4BYhB,qB5BrCmB;E4BsCnB,wB5BtCmB;E4BuCnB,sB5BtCmB;ECxHf,mBAtCa;ALi9GnB;;AgCzwGA;EACE,iB5BlBgB;E4BmBhB,oB5BzCmB;E4B0CnB,uB5B1CmB;E4B2CnB,sB5B1CmB;EC5Hf,mBAtCa;ALy9GnB;;AgCpwGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gB5BpCa;E4BqCb,gBAAA;AhCuwGF;;AgCpwGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gB5B5Ca;E4B6Cb,SAAA;EACA,UAAA;AhCuwGF;AgCrwGE;EACE,qB5BxRW;E4ByRX,8C5BvDqB;AJ8zGzB;AgCnwGE;EAEE,yB5BxEgB;AJ40GpB;AgChwGI;EACE,iB1B2Ta;ANu8FnB;AgC9vGE;EACE,0BAAA;AhCgwGJ;;AgC5vGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,gB5B5Ea;E4B6Eb,sBAAA;EAEA,gB5BzLmB;E4B0LnB,iB5BtLiB;E4BuLjB,c5BzOW;E4B0OX,yB5BrVM;E4BsVN,yBAAA;EpB/UE,wBAAA;AZ8kHJ;AgC3vGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,gB5B9FW;E4B+FX,sBAAA;EACA,iB5BtMe;E4BuMf,c5BzPS;E4B0PT,iBAAA;ET1WA,uBnB4QmB;E4BgGnB,oBAAA;EpBhWA,sCAAA;AZ8lHJ;;AgCnvGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AhCsvGF;AgCpvGE;EACE,aAAA;AhCsvGJ;AgClvGI;EAA0B,iE1BqOe;ANghG7C;AgCpvGI;EAA0B,iE1BoOe;ANmhG7C;AgCtvGI;EAA0B,iE1BmOe;ANshG7C;AgCtvGE;EACE,SAAA;AhCwvGJ;AgCrvGE;EACE,W1BqNyC;E0BpNzC,Y1BoNyC;E0BnNzC,oBAAA;ET/YA,yBjBoP0B;E0B6J1B,S1BoNyC;EMzlBzC,mBAAA;ESFE,4IW0YF;EACA,gBAAA;AhCsvGJ;AqB7nHM;EW8XJ;IX7XM,gBAAA;ErBgoHN;AACF;AgCzvGI;ETvZA,yBjB0mByC;ANyiG7C;AgCvvGE;EACE,W1B8LgC;E0B7LhC,c1B8LgC;E0B7LhC,kBAAA;EACA,e1B6LgC;E0B5LhC,yB5BxZO;E4ByZP,yBAAA;EpBtZA,mBAAA;AZgpHJ;AgCrvGE;EACE,W1B0LyC;E0BzLzC,Y1ByLyC;EiBlmBzC,yBjBoP0B;E0BuL1B,S1B0LyC;EMzlBzC,mBAAA;ESFE,4IWoaF;EACA,gBAAA;AhCsvGJ;AqBvpHM;EWyZJ;IXxZM,gBAAA;ErB0pHN;AACF;AgCzvGI;ETjbA,yBjB0mByC;ANmkG7C;AgCvvGE;EACE,W1BoKgC;E0BnKhC,c1BoKgC;E0BnKhC,kBAAA;EACA,e1BmKgC;E0BlKhC,yB5BlbO;E4BmbP,yBAAA;EpBhbA,mBAAA;AZ0qHJ;AgCrvGE;EACE,W1BgKyC;E0B/JzC,Y1B+JyC;E0B9JzC,aAAA;EACA,oB1BpE0B;E0BqE1B,mB1BrE0B;EiBjY1B,yBjBoP0B;E0BoN1B,S1B6JyC;EMzlBzC,mBAAA;ESFE,4IWicF;EACA,gBAAA;AhCsvGJ;AqBprHM;EWmbJ;IXlbM,gBAAA;ErBurHN;AACF;AgCzvGI;ET9cA,yBjB0mByC;ANgmG7C;AgCvvGE;EACE,W1BuIgC;E0BtIhC,c1BuIgC;E0BtIhC,kBAAA;EACA,e1BsIgC;E0BrIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;AhCyvGJ;AgCrvGE;EACE,yB5BtdO;EQGP,mBAAA;AZ2sHJ;AgCpvGE;EACE,kBAAA;EACA,yB5B5dO;EQGP,mBAAA;AZgtHJ;AgClvGI;EACE,yB5BheK;AJotHX;AgCjvGI;EACE,eAAA;AhCmvGN;AgChvGI;EACE,yB5BxeK;AJ0tHX;AgC/uGI;EACE,eAAA;AhCivGN;AgC9uGI;EACE,yB5BhfK;AJguHX;;AgC3uGA;;;EXtfM,4IWyfJ;AhC8uGF;AqBnuHM;EWkfN;;;IXjfQ,gBAAA;ErBwuHN;AACF;;AiCzvHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC4vHF;;AiCzvHA;EACE,cAAA;EACA,wBAAA;AjC4vHF;AO3vHE;E0BGE,qBAAA;AjC2vHJ;AiCvvHE;EACE,c7BqKS;E6BpKT,oBAAA;EACA,eAAA;AjCyvHJ;;AiCjvHA;EACE,8BAAA;AjCovHF;AiClvHE;EACE,gBAAA;AjCovHJ;AiCjvHE;EACE,2BAAA;ErBfA,4BAAA;EACA,6BAAA;AZmwHJ;AO/wHE;E0B8BI,qC3B+oB8B;ANqmGpC;AiCjvHI;EACE,c7B2IO;E6B1IP,6BAAA;EACA,yBAAA;AjCmvHN;AiC/uHE;;EAEE,c7BnBW;E6BoBX,6B7BoVsB;E6BnVtB,yC3BooBgC;AN6mGpC;AiC9uHE;EAEE,aAAA;ErBtCA,yBAAA;EACA,0BAAA;AZsxHJ;;AiCruHE;ErB3DE,uBAAA;AZoyHJ;AiCruHE;;EAEE,c7BxEI;E6ByEJ,yB3BsK0B;ANikH9B;;AiC7tHE;;EAEE,cAAA;EACA,kBAAA;AjCguHJ;;AiC3tHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AjC8tHJ;;AiCptHE;EACE,aAAA;AjCutHJ;AiCrtHE;EACE,cAAA;AjCutHJ;;AkC9zHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;AlCi0HF;AkC7zHE;;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlCq0HJ;AkCjzHA;EACE,qBAAA;EACA,yB5BgqBkC;E4B/pBlC,4B5B+pBkC;E4B9pBlC,sB9ByBO;EC+CH,eAtCa;E6BhCjB,oBAAA;EACA,mBAAA;AlCmzHF;AO71HE;E2B6CE,qBAAA;AlCmzHJ;;AkC1yHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlC6yHF;AkC3yHE;EACE,gBAAA;EACA,eAAA;AlC6yHJ;AkC1yHE;EACE,gBAAA;EACA,WAAA;AlC4yHJ;;AkCnyHA;EACE,qBAAA;EACA,qB9BwSmB;E8BvSnB,wB9BuSmB;AJ+/GrB;;AkC1xHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlC2xHF;;AkCvxHA;EACE,wBAAA;E7BSI,eAtCa;E6B+BjB,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,uBAAA;AZm4HJ;AOr4HE;E2B8GE,qBAAA;AlC0xHJ;;AkCpxHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;AlCuxHF;;AgBz1HI;EkB8EI;;;;;;;IACE,gBAAA;IACA,eAAA;ElCqxHR;AACF;AgBn3HI;EkByFA;IAoBI,qBAAA;IACA,2BAAA;ElC0wHN;EkCxwHM;IACE,mBAAA;ElC0wHR;EkCxwHQ;IACE,kBAAA;ElC0wHV;EkCvwHQ;IACE,qB5B2hBwB;I4B1hBxB,oB5B0hBwB;EN+uGlC;EkCpwHM;;;;;;;IACE,iBAAA;ElC4wHR;EkC9vHM;IACE,wBAAA;IAGA,gBAAA;ElC8vHR;EkC3vHM;IACE,aAAA;ElC6vHR;AACF;AgBt4HI;EkB8EI;;;;;;;IACE,gBAAA;IACA,eAAA;ElCi0HR;AACF;AgB/5HI;EkByFA;IAoBI,qBAAA;IACA,2BAAA;ElCszHN;EkCpzHM;IACE,mBAAA;ElCszHR;EkCpzHQ;IACE,kBAAA;ElCszHV;EkCnzHQ;IACE,qB5B2hBwB;I4B1hBxB,oB5B0hBwB;EN2xGlC;EkChzHM;;;;;;;IACE,iBAAA;ElCwzHR;EkC1yHM;IACE,wBAAA;IAGA,gBAAA;ElC0yHR;EkCvyHM;IACE,aAAA;ElCyyHR;AACF;AgBl7HI;EkB8EI;;;;;;;IACE,gBAAA;IACA,eAAA;ElC62HR;AACF;AgB38HI;EkByFA;IAoBI,qBAAA;IACA,2BAAA;ElCk2HN;EkCh2HM;IACE,mBAAA;ElCk2HR;EkCh2HQ;IACE,kBAAA;ElCk2HV;EkC/1HQ;IACE,qB5B2hBwB;I4B1hBxB,oB5B0hBwB;ENu0GlC;EkC51HM;;;;;;;IACE,iBAAA;ElCo2HR;EkCt1HM;IACE,wBAAA;IAGA,gBAAA;ElCs1HR;EkCn1HM;IACE,aAAA;ElCq1HR;AACF;AgB99HI;EkB8EI;;;;;;;IACE,gBAAA;IACA,eAAA;ElCy5HR;AACF;AgBv/HI;EkByFA;IAoBI,qBAAA;IACA,2BAAA;ElC84HN;EkC54HM;IACE,mBAAA;ElC84HR;EkC54HQ;IACE,kBAAA;ElC84HV;EkC34HQ;IACE,qB5B2hBwB;I4B1hBxB,oB5B0hBwB;ENm3GlC;EkCx4HM;;;;;;;IACE,iBAAA;ElCg5HR;EkCl4HM;IACE,wBAAA;IAGA,gBAAA;ElCk4HR;EkC/3HM;IACE,aAAA;ElCi4HR;AACF;AkC97HI;EAoBI,qBAAA;EACA,2BAAA;AlC66HR;AkCh8HQ;;;;;;;EACE,gBAAA;EACA,eAAA;AlCw8HV;AkCr7HQ;EACE,mBAAA;AlCu7HV;AkCr7HU;EACE,kBAAA;AlCu7HZ;AkCp7HU;EACE,qB5B2hBwB;E4B1hBxB,oB5B0hBwB;AN45GpC;AkCj7HQ;;;;;;;EACE,iBAAA;AlCy7HV;AkC36HQ;EACE,wBAAA;EAGA,gBAAA;AlC26HV;AkCx6HQ;EACE,aAAA;AlC06HV;;AkC55HE;EACE,4B5BqgBgC;AN05GpC;AO/mIE;E2BmNI,4B5BkgB8B;AN65GpC;AkC15HI;EACE,4B5B0f8B;ANk6GpC;AOrnIE;E2B4NM,4B5Bwf4B;ANo6GpC;AkCz5HM;EACE,4B5Bsf4B;ANq6GpC;AkCv5HI;;;;EAIE,4B5B6e8B;AN46GpC;AkCr5HE;EACE,4B5BsegC;E4BrehC,mC5B0egC;AN66GpC;AkCp5HE;EACE,yDAAA;AlCs5HJ;AkCn5HE;EACE,4B5B6dgC;ANw7GpC;AkCp5HI;EACE,4B5B6d8B;ANy7GpC;AO9oIE;E2B2PM,4B5B0d4B;AN47GpC;;AkC94HE;EACE,c9BzQI;AJ0pIR;AOrpIE;E2BuQI,c9B5QE;AJ6pIR;AkC54HI;EACE,+B5B+b8B;AN+8GpC;AO3pIE;E2BgRM,gC5B6b4B;ANi9GpC;AkC34HM;EACE,gC5B2b4B;ANk9GpC;AkCz4HI;;;;EAIE,c9BjSE;AJ4qIR;AkCv4HE;EACE,+B5B2agC;E4B1ahC,sC5B+agC;AN09GpC;AkCt4HE;EACE,yDAAA;AlCw4HJ;AkCr4HE;EACE,+B5BkagC;ANq+GpC;AkCt4HI;EACE,c9BjTE;AJyrIR;AOprIE;E2B+SM,c9BpTA;AJ4rIR;;AmCnsIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,yCAAA;EvBKE,uBAAA;AZisIJ;AmCnsIE;EACE,eAAA;EACA,cAAA;AnCqsIJ;AmClsIE;EACE,mBAAA;EACA,sBAAA;AnCosIJ;AmClsII;EACE,mBAAA;EvBCF,4CAAA;EACA,6CAAA;AZosIJ;AmClsII;EACE,sBAAA;EvBUF,gDAAA;EACA,+CAAA;AZ2rIJ;AmC/rIE;;EAEE,aAAA;AnCisIJ;;AmC7rIA;EAGE,cAAA;EAGA,eAAA;EACA,e/BmUc;AJy3HhB;;AmCxrIA;EACE,qB/B6Tc;AJ83HhB;;AmCxrIA;EACE,oBAAA;EACA,gBAAA;AnC2rIF;;AmCxrIA;EACE,gBAAA;AnC2rIF;;AOhvIE;E4B0DE,qBAAA;AnC0rIJ;AmCvrIE;EACE,mB/B4SY;AJ64HhB;;AmCjrIA;EACE,sBAAA;EACA,gBAAA;EAEA,wC7B0uBkC;E6BzuBlC,gDAAA;AnCmrIF;AmCjrIE;EvBvEE,4DAAA;AZ2vIJ;;AmC/qIA;EACE,sBAAA;EAEA,wC7B+tBkC;E6B9tBlC,6CAAA;AnCirIF;AmC/qIE;EvBlFE,4DAAA;AZowIJ;;AmCxqIA;EACE,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AnC2qIF;;AmCxqIA;EACE,sBAAA;EACA,qBAAA;AnC2qIF;;AmCvqIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB7BqsBkC;EMpzBhC,mCAAA;AZ0xIJ;;AmCvqIA;;;EAGE,cAAA;EACA,WAAA;AnC0qIF;;AmCvqIA;;EvBjHI,4CAAA;EACA,6CAAA;AZ6xIJ;;AmCxqIA;;EvBxGI,gDAAA;EACA,+CAAA;AZqxIJ;;AmCrqIE;EACE,uB7B6qBgC;AN2/GpC;AgBvwII;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,sBAAA;EnCwqIF;EmCtqIE;IAEE,YAAA;IACA,sB7BiqB8B;I6BhqB9B,gBAAA;IACA,qB7B+pB8B;ENwgHlC;AACF;;AmC3pIE;EACE,uB7BipBgC;AN6gHpC;AgBzxII;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EnC8pIF;EmC3pIE;IAEE,YAAA;IACA,gBAAA;EnC4pIJ;EmC1pII;IACE,cAAA;IACA,cAAA;EnC4pIN;EmCvpIM;IvBzKJ,0BAAA;IACA,6BAAA;EZm0IF;EmCxpIQ;;IAGE,0BAAA;EnCypIV;EmCvpIQ;;IAGE,6BAAA;EnCwpIV;EmCppIM;IvB1KJ,yBAAA;IACA,4BAAA;EZi0IF;EmCrpIQ;;IAGE,yBAAA;EnCspIV;EmCppIQ;;IAGE,4BAAA;EnCqpIV;AACF;;AmCxoIE;EACE,qB/BiIY;AJ0gIhB;AgBn0II;EmBsLJ;IAMI,e7BmlBgC;I6BllBhC,mB7BmlBgC;I6BllBhC,UAAA;IACA,SAAA;EnC2oIF;EmCzoIE;IACE,qBAAA;IACA,WAAA;EnC2oIJ;AACF;;AmCloIA;EACE,qBAAA;AnCqoIF;AmCnoIE;EACE,gBAAA;AnCqoIJ;AmCnoII;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AZ62IJ;AmCnoII;EvBzPA,yBAAA;EACA,0BAAA;AZ+3IJ;AmCnoII;EvBtQA,gBAAA;EuBwQE,mBAAA;AnCqoIN;;AoC/5IA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,gBhCucyB;EC5UrB,mBAtCa;E+BnFjB,gBAAA;EACA,6BhCscc;EQ3bZ,gBAAA;AZw5IJ;;AoC/5IA;EACE,aAAA;ApCk6IF;AoC/5IE;EACE,sBhCybsB;AJw+H1B;AoC/5II;EACE,qBAAA;EACA,uBhCqboB;EgCpbpB,chCiGO;EgChGP,YAAA;ApCi6IN;AoCv5IE;EACE,0BAAA;ApCy5IJ;AoCt5IE;EACE,qBAAA;ApCw5IJ;AoCr5IE;EACE,chC6ES;AJ00Ib;;AqCh8IA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,wBAAA;AZq7IJ;;AqCj8IA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iB/B+wBkC;E+B9wBlC,cjC0GW;EiCxGX,yBjCyVc;EiCxVd,yBAAA;ArCm8IF;AqCj8IE;EACE,UAAA;EACA,cjCoBW;EiCnBX,qBAAA;EACA,yBjCqVkB;EiCpVlB,qBjCPO;AJ08IX;AqCh8IE;EACE,UAAA;EACA,U/BuwBgC;E+BtwBhC,gD/B6W0B;ANqlI9B;;AqC57II;EACE,cAAA;EzBaF,iCAAA;EACA,oCAAA;AZm7IJ;AqC57II;EzBNA,kCAAA;EACA,qCAAA;AZq8IJ;AqC37IE;EACE,UAAA;EACA,cjCRW;EiCSX,yB/B0M0B;E+BzM1B,qB/ByM0B;ANovI9B;AqC17IE;EACE,cjCwIS;EiCvIT,oBAAA;EAEA,YAAA;EACA,yBjCsTqB;EiCrTrB,qBjC3CO;AJs+IX;;AsCl/IE;EACE,uBAAA;EjC2HE,eAtCa;EiCnFf,iBlCoIa;AJi3IjB;AsCh/IM;E1BqCF,gCAAA;EACA,mCAAA;AZ88IJ;AsC/+IM;E1BkBF,iCAAA;EACA,oCAAA;AZg+IJ;;AsChgJE;EACE,0BAAA;EjC2HE,eAtCa;EiCnFf,clCqIa;AJ83IjB;AsC9/IM;E1BqCF,kCAAA;EACA,qCAAA;AZ49IJ;AsC7/IM;E1BkBF,mCAAA;EACA,sCAAA;AZ8+IJ;;AuC5gJA;EACE,qBAAA;EACA,4BAAA;ElCiEE,cAAA;EkC/DF,gBnCqdkB;EmCpdlB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,wBAAA;ESFE,+JkBDJ;AvC+gJF;AqB1gJM;EkBfN;IlBgBQ,gBAAA;ErB6gJN;AACF;AOnhJE;EgCGI,qBAAA;AvCmhJN;;AuC9gJE;EACE,aAAA;AvCihJJ;;AuC5gJA;EACE,kBAAA;EACA,SAAA;AvC+gJF;;AuCxgJA;EACE,wBnCybqB;EmCxbrB,uBnCwbqB;EQ/cnB,oBAAA;AZmiJJ;;AuCngJE;ECjDA,cAAA;EACA,yBlC0Ea;AN8+If;AO1iJE;EiCVI,cAAA;EACA,yBAAA;AxCujJN;AwCpjJI;EAEE,UAAA;EACA,+CAAA;AxCqjJN;;AuChhJE;ECjDA,cAAA;EACA,yBlC0Ea;AN2/If;AOvjJE;EiCVI,cAAA;EACA,yBAAA;AxCokJN;AwCjkJI;EAEE,UAAA;EACA,+CAAA;AxCkkJN;;AuC7hJE;ECjDA,cAAA;EACA,yBlC0Ea;ANwgJf;AOpkJE;EiCVI,cAAA;EACA,yBAAA;AxCilJN;AwC9kJI;EAEE,UAAA;EACA,gDAAA;AxC+kJN;;AuC1iJE;ECjDA,cAAA;EACA,yBlC0Ea;ANqhJf;AOjlJE;EiCVI,cAAA;EACA,yBAAA;AxC8lJN;AwC3lJI;EAEE,UAAA;EACA,+CAAA;AxC4lJN;;AuCvjJE;ECjDA,cAAA;EACA,yBlC0Ea;ANkiJf;AO9lJE;EiCVI,cAAA;EACA,yBAAA;AxC2mJN;AwCxmJI;EAEE,UAAA;EACA,gDAAA;AxCymJN;;AuCpkJE;ECjDA,cAAA;EACA,yBlC0Ea;AN+iJf;AO3mJE;EiCVI,cAAA;EACA,yBAAA;AxCwnJN;AwCrnJI;EAEE,UAAA;EACA,+CAAA;AxCsnJN;;AuCjlJE;ECjDA,cAAA;EACA,yBlC0Ea;AN4jJf;AOxnJE;EiCVI,cAAA;EACA,yBAAA;AxCqoJN;AwCloJI;EAEE,UAAA;EACA,iDAAA;AxCmoJN;;AuC9lJE;ECjDA,cAAA;EACA,yBlC0Ea;ANykJf;AOroJE;EiCVI,cAAA;EACA,yBAAA;AxCkpJN;AwC/oJI;EAEE,UAAA;EACA,8CAAA;AxCgpJN;;AyC7pJA;EACE,kBAAA;EACA,mBnCizBkC;EmC/yBlC,yBrCUS;EQIP,uBAAA;AZkpJJ;AgBxmJI;EyB5DJ;IAQI,kBAAA;EzCgqJF;AACF;;AyC7pJA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AZ6pJJ;;A0C3qJA;EACE,kBAAA;EACA,qBAAA;EACA,mBpCi9BkC;EoCh9BlC,6BAAA;E9BUE,uBAAA;AZqqJJ;;A0C1qJA;EAEE,cAAA;A1C4qJF;;A0CxqJA;EACE,gBtC0WuB;AJi0IzB;;A0CnqJA;EACE,sBAAA;A1CsqJF;A0CnqJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;A1CqqJJ;;A0C3pJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CgqJvE;A2C3sJE;EACE,yBAAA;A3C6sJJ;A2C1sJE;EACE,cAAA;A3C4sJJ;;A0CvqJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1C4qJvE;A2CvtJE;EACE,yBAAA;A3CytJJ;A2CttJE;EACE,cAAA;A3CwtJJ;;A0CnrJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CwrJvE;A2CnuJE;EACE,yBAAA;A3CquJJ;A2CluJE;EACE,cAAA;A3CouJJ;;A0C/rJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CosJvE;A2C/uJE;EACE,yBAAA;A3CivJJ;A2C9uJE;EACE,cAAA;A3CgvJJ;;A0C3sJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CgtJvE;A2C3vJE;EACE,yBAAA;A3C6vJJ;A2C1vJE;EACE,cAAA;A3C4vJJ;;A0CvtJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1C4tJvE;A2CvwJE;EACE,yBAAA;A3CywJJ;A2CtwJE;EACE,cAAA;A3CwwJJ;;A0CnuJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CwuJvE;A2CnxJE;EACE,yBAAA;A3CqxJJ;A2ClxJE;EACE,cAAA;A3CoxJJ;;A0C/uJE;EC9CA,cD+CqH;EnB1CnH,yBmB0CuB;EC7CzB,qBD6CqE;A1CovJvE;A2C/xJE;EACE,yBAAA;A3CiyJJ;A2C9xJE;EACE,cAAA;A3CgyJJ;;A4CxyJE;EACE;IAAO,8BAAA;E5C4yJT;E4C3yJE;IAAK,wBAAA;E5C8yJP;AACF;A4C3yJA;EACE,aAAA;EACA,exCqbgB;EwCpbhB,gBAAA;EACA,cAAA;EvCmHI,sBAtCa;EuC3EjB,yCxCobY;EQhbV,uBAAA;AZ0yJJ;;A4CzyJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cxCbM;EwCcN,kBAAA;EACA,mBAAA;EACA,yBtC+8BkC;Ee19B9B,2BuBYJ;A5C4yJF;AqBpzJM;EuBDN;IvBEQ,gBAAA;ErBuzJN;AACF;;A4C9yJA;ErBYE,qMAAA;EqBVA,gCAAA;A5CizJF;;A4C7yJE;EACE,kDAAA;A5CgzJJ;A4C7yJM;EAJJ;IAKM,eAAA;E5CgzJN;AACF;;A6C31JA;EACE,aAAA;EACA,uBAAA;A7C81JF;;A6C31JA;EACE,OAAA;A7C81JF;;A8Ch2JA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,uBAAA;AZ01JJ;;A8Cx1JA;EACE,WAAA;EACA,c1CHS;E0CIT,mBAAA;A9C21JF;AOl2JE;EuCWE,UAAA;EACA,c1CTO;E0CUP,qBAAA;EACA,yB1CjBO;AJ22JX;A8Cv1JE;EACE,c1CoFS;E0CnFT,yB1CrBO;AJ82JX;;A8Ch1JA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,yB1CvCM;E0CwCN,yCAAA;A9Ci1JF;A8C/0JE;ElC1BE,+BAAA;EACA,gCAAA;AZ42JJ;A8C/0JE;ElChBE,mCAAA;EACA,kCAAA;AZk2JJ;A8C/0JE;EAEE,c1C8HS;E0C7HT,oBAAA;EACA,yB1CtDI;AJs4JR;A8C50JE;EACE,UAAA;EACA,c1C5DI;E0C6DJ,yBxCkL0B;EwCjL1B,qBxCiL0B;AN6pJ9B;A8C30JE;EACE,mBAAA;A9C60JJ;A8C30JI;EACE,gBAAA;EACA,qB1C4DS;AJixJf;;A8C/zJI;EACE,mBAAA;A9Ck0JN;A8C/zJQ;ElC1BJ,mCAAA;EAZA,0BAAA;AZy2JJ;A8C9zJQ;ElC3CJ,iCAAA;EAYA,4BAAA;AZi2JJ;A8C7zJQ;EACE,aAAA;A9C+zJV;A8C5zJQ;EACE,qB1C2BK;E0C1BL,oBAAA;A9C8zJV;A8C5zJU;EACE,iBAAA;EACA,sB1CsBG;AJwyJf;;AgBz3JI;E8BmCA;IACE,mBAAA;E9C01JJ;E8Cv1JM;IlC1BJ,mCAAA;IAZA,0BAAA;EZi4JF;E8Ct1JM;IlC3CJ,iCAAA;IAYA,4BAAA;EZy3JF;E8Cr1JM;IACE,aAAA;E9Cu1JR;E8Cp1JM;IACE,qB1C2BK;I0C1BL,oBAAA;E9Cs1JR;E8Cp1JQ;IACE,iBAAA;IACA,sB1CsBG;EJg0Jb;AACF;AgBl5JI;E8BmCA;IACE,mBAAA;E9Ck3JJ;E8C/2JM;IlC1BJ,mCAAA;IAZA,0BAAA;EZy5JF;E8C92JM;IlC3CJ,iCAAA;IAYA,4BAAA;EZi5JF;E8C72JM;IACE,aAAA;E9C+2JR;E8C52JM;IACE,qB1C2BK;I0C1BL,oBAAA;E9C82JR;E8C52JQ;IACE,iBAAA;IACA,sB1CsBG;EJw1Jb;AACF;AgB16JI;E8BmCA;IACE,mBAAA;E9C04JJ;E8Cv4JM;IlC1BJ,mCAAA;IAZA,0BAAA;EZi7JF;E8Ct4JM;IlC3CJ,iCAAA;IAYA,4BAAA;EZy6JF;E8Cr4JM;IACE,aAAA;E9Cu4JR;E8Cp4JM;IACE,qB1C2BK;I0C1BL,oBAAA;E9Cs4JR;E8Cp4JQ;IACE,iBAAA;IACA,sB1CsBG;EJg3Jb;AACF;AgBl8JI;E8BmCA;IACE,mBAAA;E9Ck6JJ;E8C/5JM;IlC1BJ,mCAAA;IAZA,0BAAA;EZy8JF;E8C95JM;IlC3CJ,iCAAA;IAYA,4BAAA;EZi8JF;E8C75JM;IACE,aAAA;E9C+5JR;E8C55JM;IACE,qB1C2BK;I0C1BL,oBAAA;E9C85JR;E8C55JQ;IACE,iBAAA;IACA,sB1CsBG;EJw4Jb;AACF;A8Cj5JA;ElCnHI,gBAAA;AZugKJ;A8Cj5JE;EACE,qBAAA;A9Cm5JJ;A8Cj5JI;EACE,sBAAA;A9Cm5JN;;A+C5hKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C44J3C;AOphKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C8hKR;A+C3hKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9Cq5J1E;;A+C1iKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C05J3C;AOliKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C4iKR;A+CziKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9Cm6J1E;;A+CxjKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cw6J3C;AOhjKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/C0jKR;A+CvjKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9Ci7J1E;;A+CtkKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cs7J3C;AO9jKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CwkKR;A+CrkKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9C+7J1E;;A+CplKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Co8J3C;AO5kKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CslKR;A+CnlKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9C68J1E;;A+ClmKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Ck9J3C;AO1lKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/ComKR;A+CjmKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9C29J1E;;A+ChnKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9Cg+J3C;AOxmKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CknKR;A+C/mKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9Cy+J1E;;A+C9nKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A9C8+J3C;AOtnKE;EwCPM,cD+IkE;EC9IlE,yBAAA;A/CgoKR;A+C7nKM;EACE,c3CHA;E2CIA,yBDyIkE;ECxIlE,qBDwIkE;A9Cu/J1E;;AgD/oKA;EACE,YAAA;E3C8HI,kBAtCa;E2CtFjB,gB5CofkB;E4CnflB,cAAA;EACA,c5C4Ke;E4C3Kf,4B1CglCkC;E0C/kClC,YAAA;AhDkpKF;AO7oKE;EyCDE,c5CsKa;E4CrKb,qBAAA;AhDipKJ;AO7oKE;EyCCI,aAAA;AhD+oKN;;AgDpoKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AhDuoKF;;AgDjoKA;EACE,oBAAA;AhDooKF;;AiD1qKA;EAGE,iB7C8agB;E6C7ahB,gB7C6agB;EClTZ,kBAtCa;E4CnFjB,c7CgHW;E6C/GX,2C3Co4BkC;E2Cn4BlC,4BAAA;EACA,kCAAA;EACA,+C7C8aiB;E6C7ajB,UAAA;ErCOE,sBAAA;AZqqKJ;AiDzqKE;EACE,mB7Cmac;AJwwJlB;AiDxqKE;EACE,UAAA;AjD0qKJ;AiDvqKE;EACE,cAAA;EACA,UAAA;AjDyqKJ;AiDtqKE;EACE,aAAA;AjDwqKJ;;AiDpqKA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,c7CkFW;E6CjFX,yB7C1BM;E6C2BN,4BAAA;EACA,0CAAA;ErCZE,+BAAA;EACA,gCAAA;AZorKJ;;AiDrqKA;EACE,a7CsYgB;AJkyJlB;;AkD9sKA;EAEE,gBAAA;AlDgtKF;AkD9sKE;EACE,kBAAA;EACA,gBAAA;AlDgtKJ;;AkD3sKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0pBkC;E4CzpBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AlD4sKF;;AkDrsKA;EACE,kBAAA;EACA,WAAA;EACA,c5Cy4BkC;E4Cv4BlC,oBAAA;AlDusKF;AkDpsKE;E7B3BI,mC6B4BF;EACA,8B5C+5BgC;ANuyIpC;AqB/tKM;E6BuBJ;I7BtBM,gBAAA;ErBkuKN;AACF;AkDzsKE;EACE,e5C65BgC;AN8yIpC;AkDvsKE;EACE,sB5C05BgC;AN+yIpC;;AkDrsKA;EACE,aAAA;EACA,6BAAA;AlDwsKF;AkDtsKE;EACE,8BAAA;EACA,gBAAA;AlDwsKJ;AkDrsKE;;EAEE,cAAA;AlDusKJ;AkDpsKE;EACE,gBAAA;AlDssKJ;;AkDlsKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlDqsKF;AkDlsKE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AlDosKJ;AkDhsKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AlDksKJ;AkDhsKI;EACE,gBAAA;AlDksKN;AkD/rKI;EACE,aAAA;AlDisKN;;AkD3rKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,yB9CvGM;E8CwGN,4BAAA;EACA,uCAAA;EtClGE,wBAAA;EsCsGF,UAAA;AlD0rKF;;AkDtrKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C8iBkC;E4C7iBlC,YAAA;EACA,aAAA;EACA,yB9C7GM;AJsyKR;AkDtrKE;EAAS,UAAA;AlDyrKX;AkDxrKE;EAAS,Y5CuzByB;ANo4IpC;;AkDtrKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,wB5CqzBkC;E4CpzBlC,gCAAA;EtCtHE,6CAAA;EACA,8CAAA;AZgzKJ;AkDxrKE;EACE,wB5CgzBgC;E4C9yBhC,sCAAA;AlDyrKJ;;AkDprKA;EACE,gBAAA;EACA,iB9CUiB;AJ6qKnB;;AkDlrKA;EACE,kBAAA;EAGA,cAAA;EACA,wB9C4ToB;AJu3JtB;;AkD/qKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4CAAA;EtCzIE,iDAAA;EACA,gDAAA;AZ4zKJ;AkD9qKE;EACE,eAAA;AlDgrKJ;;AkD3qKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AlD8qKF;;AgBrzKI;EkC6IF;IACE,gB5C+vBgC;I4C9vBhC,oBAAA;ElD4qKF;;EkDzqKA;IACE,+BAAA;ElD4qKF;EkD1qKE;IACE,gCAAA;ElD4qKJ;;EkDxqKA;IACE,+BAAA;ElD2qKF;EkDzqKE;IACE,4BAAA;IACA,mBAAA;ElD2qKJ;;EkDnqKA;IAAY,gB9C0QH;EJ65JT;AACF;AgB/0KI;EkC2KF;;IAEE,gB5C+tBgC;ENw8IlC;AACF;AgBr1KI;EkCkLF;IAAY,c9C8PH;EJy6JT;AACF;AmDr5KA;EACE,kBAAA;EACA,a7C8qBkC;E6C7qBlC,cAAA;EACA,S7Cq1BkC;E8Cz1BlC,kDhD0JuB;EgDxJvB,kBAAA;EACA,gBhDgKmB;EgD/JnB,iBhDmKiB;EgDlKjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CgHI,kBAtCa;E8C9EjB,qBAAA;EACA,UAAA;AnDi6KF;AmD/5KE;EAAS,U/CiZO;AJihKlB;AmDh6KE;EACE,kBAAA;EACA,cAAA;EACA,a7Cy0BgC;E6Cx0BhC,c7Cy0BgC;ANylJpC;AmDh6KI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDk6KN;;AmD75KA;EACE,iBAAA;AnDg6KF;AmD95KE;EACE,SAAA;AnDg6KJ;AmD95KI;EACE,MAAA;EACA,6BAAA;EACA,yB/CkXO;AJ8iKb;;AmD35KA;EACE,iBAAA;AnD85KF;AmD55KE;EACE,OAAA;EACA,a7C2yBgC;E6C1yBhC,c7CyyBgC;ANqnJpC;AmD55KI;EACE,QAAA;EACA,oCAAA;EACA,2B/CkWO;AJ4jKb;;AmDz5KA;EACE,iBAAA;AnD45KF;AmD15KE;EACE,MAAA;AnD45KJ;AmD15KI;EACE,SAAA;EACA,6BAAA;EACA,4B/CoVO;AJwkKb;;AmDv5KA;EACE,iBAAA;AnD05KF;AmDx5KE;EACE,QAAA;EACA,a7C6wBgC;E6C5wBhC,c7C2wBgC;AN+oJpC;AmDx5KI;EACE,OAAA;EACA,oCAAA;EACA,0B/CoUO;AJslKb;;AmDr4KA;EACE,gB/CoTkB;E+CnTlB,4BAAA;EACA,c/CnGM;E+CoGN,kBAAA;EACA,yB/C0SW;EQxYT,wBAAA;AZu+KJ;;AqDz/KA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C4qBkC;E+C3qBlC,cAAA;EACA,gB/Cu2BkC;E8C52BlC,kDhD0JuB;EgDxJvB,kBAAA;EACA,gBhDgKmB;EgD/JnB,iBhDmKiB;EgDlKjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CgHI,mBAtCa;EgD7EjB,qBAAA;EACA,yBjDFM;EiDGN,4BAAA;EACA,uBAAA;EzCGE,wBAAA;AZogLJ;AqDngLE;EACE,kBAAA;EACA,cAAA;EACA,W/Cu2BgC;E+Ct2BhC,c/Cu2BgC;E+Ct2BhC,mBAAA;ArDqgLJ;AqDngLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDogLN;;AqD//KA;EACE,qB/Cw1BkC;AN0qJpC;AqDhgLE;EACE,eAAA;ArDkgLJ;AqDhgLI;EACE,SAAA;EACA,6BAAA;EACA,yB/Cm1B8B;AN+qJpC;AqD//KI;EACE,SjDmXiB;EiDlXjB,6BAAA;EACA,yBjDzCE;AJ0iLR;;AqD5/KA;EACE,mB/Co0BkC;AN2rJpC;AqD7/KE;EACE,aAAA;EACA,a/Cg0BgC;E+C/zBhC,Y/C8zBgC;E+C7zBhC,mBAAA;ArD+/KJ;AqD7/KI;EACE,OAAA;EACA,oCAAA;EACA,2B/C4zB8B;ANmsJpC;AqD5/KI;EACE,OjD4ViB;EiD3VjB,oCAAA;EACA,2BjDhEE;AJ8jLR;;AqDz/KA;EACE,kB/C6yBkC;AN+sJpC;AqD1/KE;EACE,YAAA;ArD4/KJ;AqD1/KI;EACE,MAAA;EACA,oCAAA;EACA,4B/CwyB8B;ANotJpC;AqDz/KI;EACE,MjDwUiB;EiDvUjB,oCAAA;EACA,4BjDpFE;AJ+kLR;AqDt/KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W/CoxBgC;E+CnxBhC,oBAAA;EACA,WAAA;EACA,8BAAA;ArDw/KJ;;AqDp/KA;EACE,oB/C6wBkC;AN0uJpC;AqDr/KE;EACE,cAAA;EACA,a/CywBgC;E+CxwBhC,Y/CuwBgC;E+CtwBhC,mBAAA;ArDu/KJ;AqDr/KI;EACE,QAAA;EACA,oCAAA;EACA,0B/CqwB8B;ANkvJpC;AqDp/KI;EACE,QjDqSiB;EiDpSjB,oCAAA;EACA,0BjDvHE;AJ6mLR;;AqDh+KA;EACE,4BAAA;EACA,gBAAA;EhD3BI,mBAtCa;EgDmEjB,cjDjJM;EiDkJN,yBjDtHa;EiDuHb,8BAAA;EzCnIE,iCAAA;EACA,kCAAA;AZumLJ;AqDl+KE;EACE,aAAA;ArDo+KJ;;AqDh+KA;EACE,4BAAA;EACA,cjDlDW;AJqhLb;;AsD9nLA;EACE,kBAAA;AtDioLF;;AsD9nLA;EACE,mBAAA;AtDioLF;;AsD9nLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDioLF;AuDxpLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD0pLJ;;AsDloLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;AtDqoLF;AqBppLM;EiCQN;IjCPQ,gBAAA;ErBupLN;AACF;;AsDvoLA;;;EAGE,cAAA;AtD0oLF;;AsDvoLA;;EAEE,2BAAA;AtD0oLF;;AsDvoLA;;EAEE,4BAAA;AtD0oLF;;AsDjoLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDooLJ;AsDjoLE;;;EAGE,UAAA;EACA,UAAA;AtDmoLJ;AsDhoLE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;AtDkoLJ;AqB3rLM;EiCqDJ;;IjCpDM,gBAAA;ErB+rLN;AACF;;AsD/nLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhD88BmC;EgD78BnC,clDtFM;EkDuFN,kBAAA;EACA,YhD48BmC;Ee/hC/B,8BiCoFJ;AtDioLF;AqBjtLM;EiCkEN;;IjCjEQ,gBAAA;ErBqtLN;AACF;AO3tLE;;;E+CwFE,clD7FI;EkD8FJ,qBAAA;EACA,UAAA;EACA,YhDq8BiC;ANmsJrC;;AsDroLA;EACE,OAAA;AtDwoLF;;AsDnoLA;EACE,QAAA;AtDsoLF;;AsD/nLA;;EAEE,qBAAA;EACA,WhD87BmC;EgD77BnC,YhD67BmC;EgD57BnC,mCAAA;AtDkoLF;;AsDhoLA;EACE,yDAAA;AtDmoLF;;AsDjoLA;EACE,yDAAA;AtDooLF;;AsD3nLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDo5BmC;EgDn5BnC,gBhDm5BmC;EgDl5BnC,gBAAA;AtD6nLF;AsD3nLE;EACE,uBAAA;EACA,cAAA;EACA,WhDk5BiC;EgDj5BjC,WhDk5BiC;EgDj5BjC,iBhDm5BiC;EgDl5BjC,gBhDk5BiC;EgDj5BjC,mBAAA;EACA,eAAA;EACA,yBlD5JI;EkD6JJ,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC5JE,6BiC6JF;AtD4nLJ;AqBrxLM;EiC0IJ;IjCzIM,gBAAA;ErBwxLN;AACF;AsD9nLE;EACE,UAAA;AtDgoLJ;;AsDvnLA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,clDvLM;EkDwLN,kBAAA;AtD0nLF;;AwDzzLA;EACE;IAAK,yBAAA;ExD6zLL;AACF;AwD3zLA;EACE,qBAAA;EACA,WlD8jCsB;EkD7jCtB,YlD6jCsB;EkD5jCtB,2BAAA;EACA,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AxD4zLF;;AwDzzLA;EACE,WlDujCwB;EkDtjCxB,YlDsjCwB;EkDrjCxB,mBlDujCwB;ANqwJ1B;;AwDrzLA;EACE;IACE,mBAAA;ExDwzLF;EwDtzLA;IACE,UAAA;IACA,eAAA;ExDwzLF;AACF;AwDrzLA;EACE,qBAAA;EACA,WlD8hCsB;EkD7hCtB,YlD6hCsB;EkD5hCtB,2BAAA;EACA,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AxDszLF;;AwDnzLA;EACE,WlDuhCwB;EkDthCxB,YlDshCwB;ANgyJ1B;;AyD12LA;EAAqB,mCAAA;AzD82LrB;;AyD72LA;EAAqB,8BAAA;AzDi3LrB;;AyDh3LA;EAAqB,iCAAA;AzDo3LrB;;AyDn3LA;EAAqB,iCAAA;AzDu3LrB;;AyDt3LA;EAAqB,sCAAA;AzD03LrB;;AyDz3LA;EAAqB,mCAAA;AzD63LrB;;A0D/3LE;EACE,oCAAA;A1Dk4LJ;;AOx3LE;;;EmDLI,oCAAA;A1Dm4LN;;A0Dz4LE;EACE,oCAAA;A1D44LJ;;AOl4LE;;;EmDLI,oCAAA;A1D64LN;;A0Dn5LE;EACE,oCAAA;A1Ds5LJ;;AO54LE;;;EmDLI,oCAAA;A1Du5LN;;A0D75LE;EACE,oCAAA;A1Dg6LJ;;AOt5LE;;;EmDLI,oCAAA;A1Di6LN;;A0Dv6LE;EACE,oCAAA;A1D06LJ;;AOh6LE;;;EmDLI,oCAAA;A1D26LN;;A0Dj7LE;EACE,oCAAA;A1Do7LJ;;AO16LE;;;EmDLI,oCAAA;A1Dq7LN;;A0D37LE;EACE,oCAAA;A1D87LJ;;AOp7LE;;;EmDLI,oCAAA;A1D+7LN;;A0Dr8LE;EACE,oCAAA;A1Dw8LJ;;AO97LE;;;EmDLI,oCAAA;A1Dy8LN;;A2Dx8LA;EACE,oCAAA;A3D28LF;;A2Dx8LA;EACE,wCAAA;A3D28LF;;A4Dt9LA;EAAkB,oCAAA;A5D09LlB;;A4Dz9LA;EAAkB,wCAAA;A5D69LlB;;A4D59LA;EAAkB,0CAAA;A5Dg+LlB;;A4D/9LA;EAAkB,2CAAA;A5Dm+LlB;;A4Dl+LA;EAAkB,yCAAA;A5Ds+LlB;;A4Dp+LA;EAAmB,oBAAA;A5Dw+LnB;;A4Dv+LA;EAAmB,wBAAA;A5D2+LnB;;A4D1+LA;EAAmB,0BAAA;A5D8+LnB;;A4D7+LA;EAAmB,2BAAA;A5Di/LnB;;A4Dh/LA;EAAmB,yBAAA;A5Do/LnB;;A4Dj/LE;EACE,gCAAA;A5Do/LJ;;A4Dr/LE;EACE,gCAAA;A5Dw/LJ;;A4Dz/LE;EACE,gCAAA;A5D4/LJ;;A4D7/LE;EACE,gCAAA;A5DggMJ;;A4DjgME;EACE,gCAAA;A5DogMJ;;A4DrgME;EACE,gCAAA;A5DwgMJ;;A4DzgME;EACE,gCAAA;A5D4gMJ;;A4D7gME;EACE,gCAAA;A5DghMJ;;A4D5gMA;EACE,gCAAA;A5D+gMF;;A4DxgMA;EACE,oCAAA;A5D2gMF;;A4DxgMA;EACE,mCAAA;A5D2gMF;;A4DxgMA;EACE,4CAAA;EACA,6CAAA;A5D2gMF;;A4DxgMA;EACE,6CAAA;EACA,gDAAA;A5D2gMF;;A4DxgMA;EACE,gDAAA;EACA,+CAAA;A5D2gMF;;A4DxgMA;EACE,4CAAA;EACA,+CAAA;A5D2gMF;;A4DxgMA;EACE,kCAAA;A5D2gMF;;A4DxgMA;EACE,6BAAA;A5D2gMF;;A4DxgMA;EACE,+BAAA;A5D2gMF;;A4DxgMA;EACE,2BAAA;A5D2gMF;;AuDnlME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDslMJ;;A6D/kMM;EAAwB,wBAAA;A7DmlM9B;;A6DnlMM;EAAwB,0BAAA;A7DulM9B;;A6DvlMM;EAAwB,gCAAA;A7D2lM9B;;A6D3lMM;EAAwB,yBAAA;A7D+lM9B;;A6D/lMM;EAAwB,yBAAA;A7DmmM9B;;A6DnmMM;EAAwB,6BAAA;A7DumM9B;;A6DvmMM;EAAwB,8BAAA;A7D2mM9B;;A6D3mMM;EAAwB,wBAAA;A7D+mM9B;;A6D/mMM;EAAwB,+BAAA;A7DmnM9B;;AgBlkMI;E6CjDE;IAAwB,wBAAA;E7DwnM5B;;E6DxnMI;IAAwB,0BAAA;E7D4nM5B;;E6D5nMI;IAAwB,gCAAA;E7DgoM5B;;E6DhoMI;IAAwB,yBAAA;E7DooM5B;;E6DpoMI;IAAwB,yBAAA;E7DwoM5B;;E6DxoMI;IAAwB,6BAAA;E7D4oM5B;;E6D5oMI;IAAwB,8BAAA;E7DgpM5B;;E6DhpMI;IAAwB,wBAAA;E7DopM5B;;E6DppMI;IAAwB,+BAAA;E7DwpM5B;AACF;AgBxmMI;E6CjDE;IAAwB,wBAAA;E7D6pM5B;;E6D7pMI;IAAwB,0BAAA;E7DiqM5B;;E6DjqMI;IAAwB,gCAAA;E7DqqM5B;;E6DrqMI;IAAwB,yBAAA;E7DyqM5B;;E6DzqMI;IAAwB,yBAAA;E7D6qM5B;;E6D7qMI;IAAwB,6BAAA;E7DirM5B;;E6DjrMI;IAAwB,8BAAA;E7DqrM5B;;E6DrrMI;IAAwB,wBAAA;E7DyrM5B;;E6DzrMI;IAAwB,+BAAA;E7D6rM5B;AACF;AgB7oMI;E6CjDE;IAAwB,wBAAA;E7DksM5B;;E6DlsMI;IAAwB,0BAAA;E7DssM5B;;E6DtsMI;IAAwB,gCAAA;E7D0sM5B;;E6D1sMI;IAAwB,yBAAA;E7D8sM5B;;E6D9sMI;IAAwB,yBAAA;E7DktM5B;;E6DltMI;IAAwB,6BAAA;E7DstM5B;;E6DttMI;IAAwB,8BAAA;E7D0tM5B;;E6D1tMI;IAAwB,wBAAA;E7D8tM5B;;E6D9tMI;IAAwB,+BAAA;E7DkuM5B;AACF;AgBlrMI;E6CjDE;IAAwB,wBAAA;E7DuuM5B;;E6DvuMI;IAAwB,0BAAA;E7D2uM5B;;E6D3uMI;IAAwB,gCAAA;E7D+uM5B;;E6D/uMI;IAAwB,yBAAA;E7DmvM5B;;E6DnvMI;IAAwB,yBAAA;E7DuvM5B;;E6DvvMI;IAAwB,6BAAA;E7D2vM5B;;E6D3vMI;IAAwB,8BAAA;E7D+vM5B;;E6D/vMI;IAAwB,wBAAA;E7DmwM5B;;E6DnwMI;IAAwB,+BAAA;E7DuwM5B;AACF;A6D9vMA;EAEI;IAAqB,wBAAA;E7DgwMvB;;E6DhwME;IAAqB,0BAAA;E7DowMvB;;E6DpwME;IAAqB,gCAAA;E7DwwMvB;;E6DxwME;IAAqB,yBAAA;E7D4wMvB;;E6D5wME;IAAqB,yBAAA;E7DgxMvB;;E6DhxME;IAAqB,6BAAA;E7DoxMvB;;E6DpxME;IAAqB,8BAAA;E7DwxMvB;;E6DxxME;IAAqB,wBAAA;E7D4xMvB;;E6D5xME;IAAqB,+BAAA;E7DgyMvB;AACF;A8DtzMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A9DwzMF;A8DtzME;EACE,cAAA;EACA,WAAA;A9DwzMJ;A8DrzME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A9DuzMJ;;A8D9yMI;EACE,2BAAA;A9DizMN;;A8DlzMI;EACE,mBAAA;A9DqzMN;;A8DtzMI;EACE,gBAAA;A9DyzMN;;A8D1zMI;EACE,iBAAA;A9D6zMN;;A8D9zMI;EACE,2BAAA;A9Di0MN;;A8Dl0MI;EACE,mBAAA;A9Dq0MN;;A8Dt0MI;EACE,gBAAA;A9Dy0MN;;A8D10MI;EACE,iBAAA;A9D60MN;;A+Dt2MI;EAAgC,8BAAA;A/D02MpC;;A+Dz2MI;EAAgC,iCAAA;A/D62MpC;;A+D52MI;EAAgC,sCAAA;A/Dg3MpC;;A+D/2MI;EAAgC,yCAAA;A/Dm3MpC;;A+Dj3MI;EAA8B,0BAAA;A/Dq3MlC;;A+Dp3MI;EAA8B,4BAAA;A/Dw3MlC;;A+Dv3MI;EAA8B,kCAAA;A/D23MlC;;A+D13MI;EAA8B,yBAAA;A/D83MlC;;A+D73MI;EAA8B,uBAAA;A/Di4MlC;;A+Dh4MI;EAA8B,uBAAA;A/Do4MlC;;A+Dn4MI;EAA8B,yBAAA;A/Du4MlC;;A+Dt4MI;EAA8B,yBAAA;A/D04MlC;;A+Dx4MI;EAAoC,sCAAA;A/D44MxC;;A+D34MI;EAAoC,oCAAA;A/D+4MxC;;A+D94MI;EAAoC,kCAAA;A/Dk5MxC;;A+Dj5MI;EAAoC,yCAAA;A/Dq5MxC;;A+Dp5MI;EAAoC,wCAAA;A/Dw5MxC;;A+Dt5MI;EAAiC,kCAAA;A/D05MrC;;A+Dz5MI;EAAiC,gCAAA;A/D65MrC;;A+D55MI;EAAiC,8BAAA;A/Dg6MrC;;A+D/5MI;EAAiC,gCAAA;A/Dm6MrC;;A+Dl6MI;EAAiC,+BAAA;A/Ds6MrC;;A+Dp6MI;EAAkC,oCAAA;A/Dw6MtC;;A+Dv6MI;EAAkC,kCAAA;A/D26MtC;;A+D16MI;EAAkC,gCAAA;A/D86MtC;;A+D76MI;EAAkC,uCAAA;A/Di7MtC;;A+Dh7MI;EAAkC,sCAAA;A/Do7MtC;;A+Dn7MI;EAAkC,iCAAA;A/Du7MtC;;A+Dr7MI;EAAgC,2BAAA;A/Dy7MpC;;A+Dx7MI;EAAgC,iCAAA;A/D47MpC;;A+D37MI;EAAgC,+BAAA;A/D+7MpC;;A+D97MI;EAAgC,6BAAA;A/Dk8MpC;;A+Dj8MI;EAAgC,+BAAA;A/Dq8MpC;;A+Dp8MI;EAAgC,8BAAA;A/Dw8MpC;;AgB57MI;E+ClDA;IAAgC,8BAAA;E/Dm/MlC;;E+Dl/ME;IAAgC,iCAAA;E/Ds/MlC;;E+Dr/ME;IAAgC,sCAAA;E/Dy/MlC;;E+Dx/ME;IAAgC,yCAAA;E/D4/MlC;;E+D1/ME;IAA8B,0BAAA;E/D8/MhC;;E+D7/ME;IAA8B,4BAAA;E/DigNhC;;E+DhgNE;IAA8B,kCAAA;E/DogNhC;;E+DngNE;IAA8B,yBAAA;E/DugNhC;;E+DtgNE;IAA8B,uBAAA;E/D0gNhC;;E+DzgNE;IAA8B,uBAAA;E/D6gNhC;;E+D5gNE;IAA8B,yBAAA;E/DghNhC;;E+D/gNE;IAA8B,yBAAA;E/DmhNhC;;E+DjhNE;IAAoC,sCAAA;E/DqhNtC;;E+DphNE;IAAoC,oCAAA;E/DwhNtC;;E+DvhNE;IAAoC,kCAAA;E/D2hNtC;;E+D1hNE;IAAoC,yCAAA;E/D8hNtC;;E+D7hNE;IAAoC,wCAAA;E/DiiNtC;;E+D/hNE;IAAiC,kCAAA;E/DmiNnC;;E+DliNE;IAAiC,gCAAA;E/DsiNnC;;E+DriNE;IAAiC,8BAAA;E/DyiNnC;;E+DxiNE;IAAiC,gCAAA;E/D4iNnC;;E+D3iNE;IAAiC,+BAAA;E/D+iNnC;;E+D7iNE;IAAkC,oCAAA;E/DijNpC;;E+DhjNE;IAAkC,kCAAA;E/DojNpC;;E+DnjNE;IAAkC,gCAAA;E/DujNpC;;E+DtjNE;IAAkC,uCAAA;E/D0jNpC;;E+DzjNE;IAAkC,sCAAA;E/D6jNpC;;E+D5jNE;IAAkC,iCAAA;E/DgkNpC;;E+D9jNE;IAAgC,2BAAA;E/DkkNlC;;E+DjkNE;IAAgC,iCAAA;E/DqkNlC;;E+DpkNE;IAAgC,+BAAA;E/DwkNlC;;E+DvkNE;IAAgC,6BAAA;E/D2kNlC;;E+D1kNE;IAAgC,+BAAA;E/D8kNlC;;E+D7kNE;IAAgC,8BAAA;E/DilNlC;AACF;AgBtkNI;E+ClDA;IAAgC,8BAAA;E/D4nNlC;;E+D3nNE;IAAgC,iCAAA;E/D+nNlC;;E+D9nNE;IAAgC,sCAAA;E/DkoNlC;;E+DjoNE;IAAgC,yCAAA;E/DqoNlC;;E+DnoNE;IAA8B,0BAAA;E/DuoNhC;;E+DtoNE;IAA8B,4BAAA;E/D0oNhC;;E+DzoNE;IAA8B,kCAAA;E/D6oNhC;;E+D5oNE;IAA8B,yBAAA;E/DgpNhC;;E+D/oNE;IAA8B,uBAAA;E/DmpNhC;;E+DlpNE;IAA8B,uBAAA;E/DspNhC;;E+DrpNE;IAA8B,yBAAA;E/DypNhC;;E+DxpNE;IAA8B,yBAAA;E/D4pNhC;;E+D1pNE;IAAoC,sCAAA;E/D8pNtC;;E+D7pNE;IAAoC,oCAAA;E/DiqNtC;;E+DhqNE;IAAoC,kCAAA;E/DoqNtC;;E+DnqNE;IAAoC,yCAAA;E/DuqNtC;;E+DtqNE;IAAoC,wCAAA;E/D0qNtC;;E+DxqNE;IAAiC,kCAAA;E/D4qNnC;;E+D3qNE;IAAiC,gCAAA;E/D+qNnC;;E+D9qNE;IAAiC,8BAAA;E/DkrNnC;;E+DjrNE;IAAiC,gCAAA;E/DqrNnC;;E+DprNE;IAAiC,+BAAA;E/DwrNnC;;E+DtrNE;IAAkC,oCAAA;E/D0rNpC;;E+DzrNE;IAAkC,kCAAA;E/D6rNpC;;E+D5rNE;IAAkC,gCAAA;E/DgsNpC;;E+D/rNE;IAAkC,uCAAA;E/DmsNpC;;E+DlsNE;IAAkC,sCAAA;E/DssNpC;;E+DrsNE;IAAkC,iCAAA;E/DysNpC;;E+DvsNE;IAAgC,2BAAA;E/D2sNlC;;E+D1sNE;IAAgC,iCAAA;E/D8sNlC;;E+D7sNE;IAAgC,+BAAA;E/DitNlC;;E+DhtNE;IAAgC,6BAAA;E/DotNlC;;E+DntNE;IAAgC,+BAAA;E/DutNlC;;E+DttNE;IAAgC,8BAAA;E/D0tNlC;AACF;AgB/sNI;E+ClDA;IAAgC,8BAAA;E/DqwNlC;;E+DpwNE;IAAgC,iCAAA;E/DwwNlC;;E+DvwNE;IAAgC,sCAAA;E/D2wNlC;;E+D1wNE;IAAgC,yCAAA;E/D8wNlC;;E+D5wNE;IAA8B,0BAAA;E/DgxNhC;;E+D/wNE;IAA8B,4BAAA;E/DmxNhC;;E+DlxNE;IAA8B,kCAAA;E/DsxNhC;;E+DrxNE;IAA8B,yBAAA;E/DyxNhC;;E+DxxNE;IAA8B,uBAAA;E/D4xNhC;;E+D3xNE;IAA8B,uBAAA;E/D+xNhC;;E+D9xNE;IAA8B,yBAAA;E/DkyNhC;;E+DjyNE;IAA8B,yBAAA;E/DqyNhC;;E+DnyNE;IAAoC,sCAAA;E/DuyNtC;;E+DtyNE;IAAoC,oCAAA;E/D0yNtC;;E+DzyNE;IAAoC,kCAAA;E/D6yNtC;;E+D5yNE;IAAoC,yCAAA;E/DgzNtC;;E+D/yNE;IAAoC,wCAAA;E/DmzNtC;;E+DjzNE;IAAiC,kCAAA;E/DqzNnC;;E+DpzNE;IAAiC,gCAAA;E/DwzNnC;;E+DvzNE;IAAiC,8BAAA;E/D2zNnC;;E+D1zNE;IAAiC,gCAAA;E/D8zNnC;;E+D7zNE;IAAiC,+BAAA;E/Di0NnC;;E+D/zNE;IAAkC,oCAAA;E/Dm0NpC;;E+Dl0NE;IAAkC,kCAAA;E/Ds0NpC;;E+Dr0NE;IAAkC,gCAAA;E/Dy0NpC;;E+Dx0NE;IAAkC,uCAAA;E/D40NpC;;E+D30NE;IAAkC,sCAAA;E/D+0NpC;;E+D90NE;IAAkC,iCAAA;E/Dk1NpC;;E+Dh1NE;IAAgC,2BAAA;E/Do1NlC;;E+Dn1NE;IAAgC,iCAAA;E/Du1NlC;;E+Dt1NE;IAAgC,+BAAA;E/D01NlC;;E+Dz1NE;IAAgC,6BAAA;E/D61NlC;;E+D51NE;IAAgC,+BAAA;E/Dg2NlC;;E+D/1NE;IAAgC,8BAAA;E/Dm2NlC;AACF;AgBx1NI;E+ClDA;IAAgC,8BAAA;E/D84NlC;;E+D74NE;IAAgC,iCAAA;E/Di5NlC;;E+Dh5NE;IAAgC,sCAAA;E/Do5NlC;;E+Dn5NE;IAAgC,yCAAA;E/Du5NlC;;E+Dr5NE;IAA8B,0BAAA;E/Dy5NhC;;E+Dx5NE;IAA8B,4BAAA;E/D45NhC;;E+D35NE;IAA8B,kCAAA;E/D+5NhC;;E+D95NE;IAA8B,yBAAA;E/Dk6NhC;;E+Dj6NE;IAA8B,uBAAA;E/Dq6NhC;;E+Dp6NE;IAA8B,uBAAA;E/Dw6NhC;;E+Dv6NE;IAA8B,yBAAA;E/D26NhC;;E+D16NE;IAA8B,yBAAA;E/D86NhC;;E+D56NE;IAAoC,sCAAA;E/Dg7NtC;;E+D/6NE;IAAoC,oCAAA;E/Dm7NtC;;E+Dl7NE;IAAoC,kCAAA;E/Ds7NtC;;E+Dr7NE;IAAoC,yCAAA;E/Dy7NtC;;E+Dx7NE;IAAoC,wCAAA;E/D47NtC;;E+D17NE;IAAiC,kCAAA;E/D87NnC;;E+D77NE;IAAiC,gCAAA;E/Di8NnC;;E+Dh8NE;IAAiC,8BAAA;E/Do8NnC;;E+Dn8NE;IAAiC,gCAAA;E/Du8NnC;;E+Dt8NE;IAAiC,+BAAA;E/D08NnC;;E+Dx8NE;IAAkC,oCAAA;E/D48NpC;;E+D38NE;IAAkC,kCAAA;E/D+8NpC;;E+D98NE;IAAkC,gCAAA;E/Dk9NpC;;E+Dj9NE;IAAkC,uCAAA;E/Dq9NpC;;E+Dp9NE;IAAkC,sCAAA;E/Dw9NpC;;E+Dv9NE;IAAkC,iCAAA;E/D29NpC;;E+Dz9NE;IAAgC,2BAAA;E/D69NlC;;E+D59NE;IAAgC,iCAAA;E/Dg+NlC;;E+D/9NE;IAAgC,+BAAA;E/Dm+NlC;;E+Dl+NE;IAAgC,6BAAA;E/Ds+NlC;;E+Dr+NE;IAAgC,+BAAA;E/Dy+NlC;;E+Dx+NE;IAAgC,8BAAA;E/D4+NlC;AACF;AgEvhOI;EAAwB,sBAAA;AhE0hO5B;;AgEzhOI;EAAwB,uBAAA;AhE6hO5B;;AgE5hOI;EAAwB,sBAAA;AhEgiO5B;;AgB5+NI;EgDtDA;IAAwB,sBAAA;EhEuiO1B;;EgEtiOE;IAAwB,uBAAA;EhE0iO1B;;EgEziOE;IAAwB,sBAAA;EhE6iO1B;AACF;AgB1/NI;EgDtDA;IAAwB,sBAAA;EhEojO1B;;EgEnjOE;IAAwB,uBAAA;EhEujO1B;;EgEtjOE;IAAwB,sBAAA;EhE0jO1B;AACF;AgBvgOI;EgDtDA;IAAwB,sBAAA;EhEikO1B;;EgEhkOE;IAAwB,uBAAA;EhEokO1B;;EgEnkOE;IAAwB,sBAAA;EhEukO1B;AACF;AgBphOI;EgDtDA;IAAwB,sBAAA;EhE8kO1B;;EgE7kOE;IAAwB,uBAAA;EhEilO1B;;EgEhlOE;IAAwB,sBAAA;EhEolO1B;AACF;AiE1lOE;EAAyB,2BAAA;AjE6lO3B;;AiE7lOE;EAAyB,4BAAA;AjEimO3B;;AiEjmOE;EAAyB,4BAAA;AjEqmO3B;;AkErmOE;EAAsB,yBAAA;AlEymOxB;;AkEzmOE;EAAsB,2BAAA;AlE6mOxB;;AmE5mOE;EAAyB,2BAAA;AnEgnO3B;;AmEhnOE;EAAyB,6BAAA;AnEonO3B;;AmEpnOE;EAAyB,6BAAA;AnEwnO3B;;AmExnOE;EAAyB,0BAAA;AnE4nO3B;;AmE5nOE;EAAyB,2BAAA;AnEgoO3B;;AmE3nOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a7D+pBkC;AN+9MpC;;AmE3nOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7DupBkC;ANu+MpC;;AmE1nOE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a7D+oBgC;EN++MlC;AACF;;AoExpOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ArE0pOF;;AqEhpOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ArEkpOJ;;AsE/qOA;EAAa,iEAAA;AtEmrOb;;AsElrOA;EAAU,yDAAA;AtEsrOV;;AsErrOA;EAAa,0DAAA;AtEyrOb;;AsExrOA;EAAe,2BAAA;AtE4rOf;;AuE3rOI;EAAuB,qBAAA;AvE+rO3B;;AuE/rOI;EAAuB,qBAAA;AvEmsO3B;;AuEnsOI;EAAuB,qBAAA;AvEusO3B;;AuEvsOI;EAAuB,sBAAA;AvE2sO3B;;AuE3sOI;EAAuB,sBAAA;AvE+sO3B;;AuE/sOI;EAAuB,sBAAA;AvEmtO3B;;AuEntOI;EAAuB,sBAAA;AvEutO3B;;AuEvtOI;EAAuB,sBAAA;AvE2tO3B;;AuE3tOI;EAAuB,uBAAA;AvE+tO3B;;AuE/tOI;EAAuB,uBAAA;AvEmuO3B;;AuE/tOA;EAAU,0BAAA;AvEmuOV;;AuEluOA;EAAU,2BAAA;AvEsuOV;;AuEluOA;EAAc,2BAAA;AvEsuOd;;AuEruOA;EAAc,4BAAA;AvEyuOd;;AuEvuOA;EAAU,uBAAA;AvE2uOV;;AuE1uOA;EAAU,wBAAA;AvE8uOV;;AwEvvOQ;EAAgC,oBAAA;AxE2vOxC;;AwE1vOQ;;EAEE,wBAAA;AxE6vOV;;AwE3vOQ;;EAEE,0BAAA;AxE8vOV;;AwE5vOQ;;EAEE,2BAAA;AxE+vOV;;AwE7vOQ;;EAEE,yBAAA;AxEgwOV;;AwE/wOQ;EAAgC,2BAAA;AxEmxOxC;;AwElxOQ;;EAEE,+BAAA;AxEqxOV;;AwEnxOQ;;EAEE,iCAAA;AxEsxOV;;AwEpxOQ;;EAEE,kCAAA;AxEuxOV;;AwErxOQ;;EAEE,gCAAA;AxEwxOV;;AwEvyOQ;EAAgC,4BAAA;AxE2yOxC;;AwE1yOQ;;EAEE,gCAAA;AxE6yOV;;AwE3yOQ;;EAEE,kCAAA;AxE8yOV;;AwE5yOQ;;EAEE,mCAAA;AxE+yOV;;AwE7yOQ;;EAEE,iCAAA;AxEgzOV;;AwE/zOQ;EAAgC,2BAAA;AxEm0OxC;;AwEl0OQ;;EAEE,+BAAA;AxEq0OV;;AwEn0OQ;;EAEE,iCAAA;AxEs0OV;;AwEp0OQ;;EAEE,kCAAA;AxEu0OV;;AwEr0OQ;;EAEE,gCAAA;AxEw0OV;;AwEv1OQ;EAAgC,4BAAA;AxE21OxC;;AwE11OQ;;EAEE,gCAAA;AxE61OV;;AwE31OQ;;EAEE,kCAAA;AxE81OV;;AwE51OQ;;EAEE,mCAAA;AxE+1OV;;AwE71OQ;;EAEE,iCAAA;AxEg2OV;;AwE/2OQ;EAAgC,yBAAA;AxEm3OxC;;AwEl3OQ;;EAEE,6BAAA;AxEq3OV;;AwEn3OQ;;EAEE,+BAAA;AxEs3OV;;AwEp3OQ;;EAEE,gCAAA;AxEu3OV;;AwEr3OQ;;EAEE,8BAAA;AxEw3OV;;AwEv4OQ;EAAgC,6BAAA;AxE24OxC;;AwE14OQ;;EAEE,iCAAA;AxE64OV;;AwE34OQ;;EAEE,mCAAA;AxE84OV;;AwE54OQ;;EAEE,oCAAA;AxE+4OV;;AwE74OQ;;EAEE,kCAAA;AxEg5OV;;AwE/5OQ;EAAgC,4BAAA;AxEm6OxC;;AwEl6OQ;;EAEE,gCAAA;AxEq6OV;;AwEn6OQ;;EAEE,kCAAA;AxEs6OV;;AwEp6OQ;;EAEE,mCAAA;AxEu6OV;;AwEr6OQ;;EAEE,iCAAA;AxEw6OV;;AwEv7OQ;EAAgC,6BAAA;AxE27OxC;;AwE17OQ;;EAEE,iCAAA;AxE67OV;;AwE37OQ;;EAEE,mCAAA;AxE87OV;;AwE57OQ;;EAEE,oCAAA;AxE+7OV;;AwE77OQ;;EAEE,kCAAA;AxEg8OV;;AwE/8OQ;EAAgC,qBAAA;AxEm9OxC;;AwEl9OQ;;EAEE,yBAAA;AxEq9OV;;AwEn9OQ;;EAEE,2BAAA;AxEs9OV;;AwEp9OQ;;EAEE,4BAAA;AxEu9OV;;AwEr9OQ;;EAEE,0BAAA;AxEw9OV;;AwEv+OQ;EAAgC,4BAAA;AxE2+OxC;;AwE1+OQ;;EAEE,gCAAA;AxE6+OV;;AwE3+OQ;;EAEE,kCAAA;AxE8+OV;;AwE5+OQ;;EAEE,mCAAA;AxE++OV;;AwE7+OQ;;EAEE,iCAAA;AxEg/OV;;AwE//OQ;EAAgC,6BAAA;AxEmgPxC;;AwElgPQ;;EAEE,iCAAA;AxEqgPV;;AwEngPQ;;EAEE,mCAAA;AxEsgPV;;AwEpgPQ;;EAEE,oCAAA;AxEugPV;;AwErgPQ;;EAEE,kCAAA;AxEwgPV;;AwEvhPQ;EAAgC,4BAAA;AxE2hPxC;;AwE1hPQ;;EAEE,gCAAA;AxE6hPV;;AwE3hPQ;;EAEE,kCAAA;AxE8hPV;;AwE5hPQ;;EAEE,mCAAA;AxE+hPV;;AwE7hPQ;;EAEE,iCAAA;AxEgiPV;;AwE/iPQ;EAAgC,6BAAA;AxEmjPxC;;AwEljPQ;;EAEE,iCAAA;AxEqjPV;;AwEnjPQ;;EAEE,mCAAA;AxEsjPV;;AwEpjPQ;;EAEE,oCAAA;AxEujPV;;AwErjPQ;;EAEE,kCAAA;AxEwjPV;;AwEvkPQ;EAAgC,0BAAA;AxE2kPxC;;AwE1kPQ;;EAEE,8BAAA;AxE6kPV;;AwE3kPQ;;EAEE,gCAAA;AxE8kPV;;AwE5kPQ;;EAEE,iCAAA;AxE+kPV;;AwE7kPQ;;EAEE,+BAAA;AxEglPV;;AwE/lPQ;EAAgC,8BAAA;AxEmmPxC;;AwElmPQ;;EAEE,kCAAA;AxEqmPV;;AwEnmPQ;;EAEE,oCAAA;AxEsmPV;;AwEpmPQ;;EAEE,qCAAA;AxEumPV;;AwErmPQ;;EAEE,mCAAA;AxEwmPV;;AwEvnPQ;EAAgC,6BAAA;AxE2nPxC;;AwE1nPQ;;EAEE,iCAAA;AxE6nPV;;AwE3nPQ;;EAEE,mCAAA;AxE8nPV;;AwE5nPQ;;EAEE,oCAAA;AxE+nPV;;AwE7nPQ;;EAEE,kCAAA;AxEgoPV;;AwE/oPQ;EAAgC,8BAAA;AxEmpPxC;;AwElpPQ;;EAEE,kCAAA;AxEqpPV;;AwEnpPQ;;EAEE,oCAAA;AxEspPV;;AwEppPQ;;EAEE,qCAAA;AxEupPV;;AwErpPQ;;EAEE,mCAAA;AxEwpPV;;AwEhpPQ;EAAwB,4BAAA;AxEopPhC;;AwEnpPQ;;EAEE,gCAAA;AxEspPV;;AwEppPQ;;EAEE,kCAAA;AxEupPV;;AwErpPQ;;EAEE,mCAAA;AxEwpPV;;AwEtpPQ;;EAEE,iCAAA;AxEypPV;;AwExqPQ;EAAwB,6BAAA;AxE4qPhC;;AwE3qPQ;;EAEE,iCAAA;AxE8qPV;;AwE5qPQ;;EAEE,mCAAA;AxE+qPV;;AwE7qPQ;;EAEE,oCAAA;AxEgrPV;;AwE9qPQ;;EAEE,kCAAA;AxEirPV;;AwEhsPQ;EAAwB,4BAAA;AxEosPhC;;AwEnsPQ;;EAEE,gCAAA;AxEssPV;;AwEpsPQ;;EAEE,kCAAA;AxEusPV;;AwErsPQ;;EAEE,mCAAA;AxEwsPV;;AwEtsPQ;;EAEE,iCAAA;AxEysPV;;AwExtPQ;EAAwB,6BAAA;AxE4tPhC;;AwE3tPQ;;EAEE,iCAAA;AxE8tPV;;AwE5tPQ;;EAEE,mCAAA;AxE+tPV;;AwE7tPQ;;EAEE,oCAAA;AxEguPV;;AwE9tPQ;;EAEE,kCAAA;AxEiuPV;;AwEhvPQ;EAAwB,0BAAA;AxEovPhC;;AwEnvPQ;;EAEE,8BAAA;AxEsvPV;;AwEpvPQ;;EAEE,gCAAA;AxEuvPV;;AwErvPQ;;EAEE,iCAAA;AxEwvPV;;AwEtvPQ;;EAEE,+BAAA;AxEyvPV;;AwExwPQ;EAAwB,8BAAA;AxE4wPhC;;AwE3wPQ;;EAEE,kCAAA;AxE8wPV;;AwE5wPQ;;EAEE,oCAAA;AxE+wPV;;AwE7wPQ;;EAEE,qCAAA;AxEgxPV;;AwE9wPQ;;EAEE,mCAAA;AxEixPV;;AwEhyPQ;EAAwB,6BAAA;AxEoyPhC;;AwEnyPQ;;EAEE,iCAAA;AxEsyPV;;AwEpyPQ;;EAEE,mCAAA;AxEuyPV;;AwEryPQ;;EAEE,oCAAA;AxEwyPV;;AwEtyPQ;;EAEE,kCAAA;AxEyyPV;;AwExzPQ;EAAwB,8BAAA;AxE4zPhC;;AwE3zPQ;;EAEE,kCAAA;AxE8zPV;;AwE5zPQ;;EAEE,oCAAA;AxE+zPV;;AwE7zPQ;;EAEE,qCAAA;AxEg0PV;;AwE9zPQ;;EAEE,mCAAA;AxEi0PV;;AwE3zPI;EAAmB,uBAAA;AxE+zPvB;;AwE9zPI;;EAEE,2BAAA;AxEi0PN;;AwE/zPI;;EAEE,6BAAA;AxEk0PN;;AwEh0PI;;EAEE,8BAAA;AxEm0PN;;AwEj0PI;;EAEE,4BAAA;AxEo0PN;;AgB70PI;EwDlDI;IAAgC,oBAAA;ExEo4PtC;;EwEn4PM;;IAEE,wBAAA;ExEs4PR;;EwEp4PM;;IAEE,0BAAA;ExEu4PR;;EwEr4PM;;IAEE,2BAAA;ExEw4PR;;EwEt4PM;;IAEE,yBAAA;ExEy4PR;;EwEx5PM;IAAgC,2BAAA;ExE45PtC;;EwE35PM;;IAEE,+BAAA;ExE85PR;;EwE55PM;;IAEE,iCAAA;ExE+5PR;;EwE75PM;;IAEE,kCAAA;ExEg6PR;;EwE95PM;;IAEE,gCAAA;ExEi6PR;;EwEh7PM;IAAgC,4BAAA;ExEo7PtC;;EwEn7PM;;IAEE,gCAAA;ExEs7PR;;EwEp7PM;;IAEE,kCAAA;ExEu7PR;;EwEr7PM;;IAEE,mCAAA;ExEw7PR;;EwEt7PM;;IAEE,iCAAA;ExEy7PR;;EwEx8PM;IAAgC,2BAAA;ExE48PtC;;EwE38PM;;IAEE,+BAAA;ExE88PR;;EwE58PM;;IAEE,iCAAA;ExE+8PR;;EwE78PM;;IAEE,kCAAA;ExEg9PR;;EwE98PM;;IAEE,gCAAA;ExEi9PR;;EwEh+PM;IAAgC,4BAAA;ExEo+PtC;;EwEn+PM;;IAEE,gCAAA;ExEs+PR;;EwEp+PM;;IAEE,kCAAA;ExEu+PR;;EwEr+PM;;IAEE,mCAAA;ExEw+PR;;EwEt+PM;;IAEE,iCAAA;ExEy+PR;;EwEx/PM;IAAgC,yBAAA;ExE4/PtC;;EwE3/PM;;IAEE,6BAAA;ExE8/PR;;EwE5/PM;;IAEE,+BAAA;ExE+/PR;;EwE7/PM;;IAEE,gCAAA;ExEggQR;;EwE9/PM;;IAEE,8BAAA;ExEigQR;;EwEhhQM;IAAgC,6BAAA;ExEohQtC;;EwEnhQM;;IAEE,iCAAA;ExEshQR;;EwEphQM;;IAEE,mCAAA;ExEuhQR;;EwErhQM;;IAEE,oCAAA;ExEwhQR;;EwEthQM;;IAEE,kCAAA;ExEyhQR;;EwExiQM;IAAgC,4BAAA;ExE4iQtC;;EwE3iQM;;IAEE,gCAAA;ExE8iQR;;EwE5iQM;;IAEE,kCAAA;ExE+iQR;;EwE7iQM;;IAEE,mCAAA;ExEgjQR;;EwE9iQM;;IAEE,iCAAA;ExEijQR;;EwEhkQM;IAAgC,6BAAA;ExEokQtC;;EwEnkQM;;IAEE,iCAAA;ExEskQR;;EwEpkQM;;IAEE,mCAAA;ExEukQR;;EwErkQM;;IAEE,oCAAA;ExEwkQR;;EwEtkQM;;IAEE,kCAAA;ExEykQR;;EwExlQM;IAAgC,qBAAA;ExE4lQtC;;EwE3lQM;;IAEE,yBAAA;ExE8lQR;;EwE5lQM;;IAEE,2BAAA;ExE+lQR;;EwE7lQM;;IAEE,4BAAA;ExEgmQR;;EwE9lQM;;IAEE,0BAAA;ExEimQR;;EwEhnQM;IAAgC,4BAAA;ExEonQtC;;EwEnnQM;;IAEE,gCAAA;ExEsnQR;;EwEpnQM;;IAEE,kCAAA;ExEunQR;;EwErnQM;;IAEE,mCAAA;ExEwnQR;;EwEtnQM;;IAEE,iCAAA;ExEynQR;;EwExoQM;IAAgC,6BAAA;ExE4oQtC;;EwE3oQM;;IAEE,iCAAA;ExE8oQR;;EwE5oQM;;IAEE,mCAAA;ExE+oQR;;EwE7oQM;;IAEE,oCAAA;ExEgpQR;;EwE9oQM;;IAEE,kCAAA;ExEipQR;;EwEhqQM;IAAgC,4BAAA;ExEoqQtC;;EwEnqQM;;IAEE,gCAAA;ExEsqQR;;EwEpqQM;;IAEE,kCAAA;ExEuqQR;;EwErqQM;;IAEE,mCAAA;ExEwqQR;;EwEtqQM;;IAEE,iCAAA;ExEyqQR;;EwExrQM;IAAgC,6BAAA;ExE4rQtC;;EwE3rQM;;IAEE,iCAAA;ExE8rQR;;EwE5rQM;;IAEE,mCAAA;ExE+rQR;;EwE7rQM;;IAEE,oCAAA;ExEgsQR;;EwE9rQM;;IAEE,kCAAA;ExEisQR;;EwEhtQM;IAAgC,0BAAA;ExEotQtC;;EwEntQM;;IAEE,8BAAA;ExEstQR;;EwEptQM;;IAEE,gCAAA;ExEutQR;;EwErtQM;;IAEE,iCAAA;ExEwtQR;;EwEttQM;;IAEE,+BAAA;ExEytQR;;EwExuQM;IAAgC,8BAAA;ExE4uQtC;;EwE3uQM;;IAEE,kCAAA;ExE8uQR;;EwE5uQM;;IAEE,oCAAA;ExE+uQR;;EwE7uQM;;IAEE,qCAAA;ExEgvQR;;EwE9uQM;;IAEE,mCAAA;ExEivQR;;EwEhwQM;IAAgC,6BAAA;ExEowQtC;;EwEnwQM;;IAEE,iCAAA;ExEswQR;;EwEpwQM;;IAEE,mCAAA;ExEuwQR;;EwErwQM;;IAEE,oCAAA;ExEwwQR;;EwEtwQM;;IAEE,kCAAA;ExEywQR;;EwExxQM;IAAgC,8BAAA;ExE4xQtC;;EwE3xQM;;IAEE,kCAAA;ExE8xQR;;EwE5xQM;;IAEE,oCAAA;ExE+xQR;;EwE7xQM;;IAEE,qCAAA;ExEgyQR;;EwE9xQM;;IAEE,mCAAA;ExEiyQR;;EwEzxQM;IAAwB,4BAAA;ExE6xQ9B;;EwE5xQM;;IAEE,gCAAA;ExE+xQR;;EwE7xQM;;IAEE,kCAAA;ExEgyQR;;EwE9xQM;;IAEE,mCAAA;ExEiyQR;;EwE/xQM;;IAEE,iCAAA;ExEkyQR;;EwEjzQM;IAAwB,6BAAA;ExEqzQ9B;;EwEpzQM;;IAEE,iCAAA;ExEuzQR;;EwErzQM;;IAEE,mCAAA;ExEwzQR;;EwEtzQM;;IAEE,oCAAA;ExEyzQR;;EwEvzQM;;IAEE,kCAAA;ExE0zQR;;EwEz0QM;IAAwB,4BAAA;ExE60Q9B;;EwE50QM;;IAEE,gCAAA;ExE+0QR;;EwE70QM;;IAEE,kCAAA;ExEg1QR;;EwE90QM;;IAEE,mCAAA;ExEi1QR;;EwE/0QM;;IAEE,iCAAA;ExEk1QR;;EwEj2QM;IAAwB,6BAAA;ExEq2Q9B;;EwEp2QM;;IAEE,iCAAA;ExEu2QR;;EwEr2QM;;IAEE,mCAAA;ExEw2QR;;EwEt2QM;;IAEE,oCAAA;ExEy2QR;;EwEv2QM;;IAEE,kCAAA;ExE02QR;;EwEz3QM;IAAwB,0BAAA;ExE63Q9B;;EwE53QM;;IAEE,8BAAA;ExE+3QR;;EwE73QM;;IAEE,gCAAA;ExEg4QR;;EwE93QM;;IAEE,iCAAA;ExEi4QR;;EwE/3QM;;IAEE,+BAAA;ExEk4QR;;EwEj5QM;IAAwB,8BAAA;ExEq5Q9B;;EwEp5QM;;IAEE,kCAAA;ExEu5QR;;EwEr5QM;;IAEE,oCAAA;ExEw5QR;;EwEt5QM;;IAEE,qCAAA;ExEy5QR;;EwEv5QM;;IAEE,mCAAA;ExE05QR;;EwEz6QM;IAAwB,6BAAA;ExE66Q9B;;EwE56QM;;IAEE,iCAAA;ExE+6QR;;EwE76QM;;IAEE,mCAAA;ExEg7QR;;EwE96QM;;IAEE,oCAAA;ExEi7QR;;EwE/6QM;;IAEE,kCAAA;ExEk7QR;;EwEj8QM;IAAwB,8BAAA;ExEq8Q9B;;EwEp8QM;;IAEE,kCAAA;ExEu8QR;;EwEr8QM;;IAEE,oCAAA;ExEw8QR;;EwEt8QM;;IAEE,qCAAA;ExEy8QR;;EwEv8QM;;IAEE,mCAAA;ExE08QR;;EwEp8QE;IAAmB,uBAAA;ExEw8QrB;;EwEv8QE;;IAEE,2BAAA;ExE08QJ;;EwEx8QE;;IAEE,6BAAA;ExE28QJ;;EwEz8QE;;IAEE,8BAAA;ExE48QJ;;EwE18QE;;IAEE,4BAAA;ExE68QJ;AACF;AgBv9QI;EwDlDI;IAAgC,oBAAA;ExE6gRtC;;EwE5gRM;;IAEE,wBAAA;ExE+gRR;;EwE7gRM;;IAEE,0BAAA;ExEghRR;;EwE9gRM;;IAEE,2BAAA;ExEihRR;;EwE/gRM;;IAEE,yBAAA;ExEkhRR;;EwEjiRM;IAAgC,2BAAA;ExEqiRtC;;EwEpiRM;;IAEE,+BAAA;ExEuiRR;;EwEriRM;;IAEE,iCAAA;ExEwiRR;;EwEtiRM;;IAEE,kCAAA;ExEyiRR;;EwEviRM;;IAEE,gCAAA;ExE0iRR;;EwEzjRM;IAAgC,4BAAA;ExE6jRtC;;EwE5jRM;;IAEE,gCAAA;ExE+jRR;;EwE7jRM;;IAEE,kCAAA;ExEgkRR;;EwE9jRM;;IAEE,mCAAA;ExEikRR;;EwE/jRM;;IAEE,iCAAA;ExEkkRR;;EwEjlRM;IAAgC,2BAAA;ExEqlRtC;;EwEplRM;;IAEE,+BAAA;ExEulRR;;EwErlRM;;IAEE,iCAAA;ExEwlRR;;EwEtlRM;;IAEE,kCAAA;ExEylRR;;EwEvlRM;;IAEE,gCAAA;ExE0lRR;;EwEzmRM;IAAgC,4BAAA;ExE6mRtC;;EwE5mRM;;IAEE,gCAAA;ExE+mRR;;EwE7mRM;;IAEE,kCAAA;ExEgnRR;;EwE9mRM;;IAEE,mCAAA;ExEinRR;;EwE/mRM;;IAEE,iCAAA;ExEknRR;;EwEjoRM;IAAgC,yBAAA;ExEqoRtC;;EwEpoRM;;IAEE,6BAAA;ExEuoRR;;EwEroRM;;IAEE,+BAAA;ExEwoRR;;EwEtoRM;;IAEE,gCAAA;ExEyoRR;;EwEvoRM;;IAEE,8BAAA;ExE0oRR;;EwEzpRM;IAAgC,6BAAA;ExE6pRtC;;EwE5pRM;;IAEE,iCAAA;ExE+pRR;;EwE7pRM;;IAEE,mCAAA;ExEgqRR;;EwE9pRM;;IAEE,oCAAA;ExEiqRR;;EwE/pRM;;IAEE,kCAAA;ExEkqRR;;EwEjrRM;IAAgC,4BAAA;ExEqrRtC;;EwEprRM;;IAEE,gCAAA;ExEurRR;;EwErrRM;;IAEE,kCAAA;ExEwrRR;;EwEtrRM;;IAEE,mCAAA;ExEyrRR;;EwEvrRM;;IAEE,iCAAA;ExE0rRR;;EwEzsRM;IAAgC,6BAAA;ExE6sRtC;;EwE5sRM;;IAEE,iCAAA;ExE+sRR;;EwE7sRM;;IAEE,mCAAA;ExEgtRR;;EwE9sRM;;IAEE,oCAAA;ExEitRR;;EwE/sRM;;IAEE,kCAAA;ExEktRR;;EwEjuRM;IAAgC,qBAAA;ExEquRtC;;EwEpuRM;;IAEE,yBAAA;ExEuuRR;;EwEruRM;;IAEE,2BAAA;ExEwuRR;;EwEtuRM;;IAEE,4BAAA;ExEyuRR;;EwEvuRM;;IAEE,0BAAA;ExE0uRR;;EwEzvRM;IAAgC,4BAAA;ExE6vRtC;;EwE5vRM;;IAEE,gCAAA;ExE+vRR;;EwE7vRM;;IAEE,kCAAA;ExEgwRR;;EwE9vRM;;IAEE,mCAAA;ExEiwRR;;EwE/vRM;;IAEE,iCAAA;ExEkwRR;;EwEjxRM;IAAgC,6BAAA;ExEqxRtC;;EwEpxRM;;IAEE,iCAAA;ExEuxRR;;EwErxRM;;IAEE,mCAAA;ExEwxRR;;EwEtxRM;;IAEE,oCAAA;ExEyxRR;;EwEvxRM;;IAEE,kCAAA;ExE0xRR;;EwEzyRM;IAAgC,4BAAA;ExE6yRtC;;EwE5yRM;;IAEE,gCAAA;ExE+yRR;;EwE7yRM;;IAEE,kCAAA;ExEgzRR;;EwE9yRM;;IAEE,mCAAA;ExEizRR;;EwE/yRM;;IAEE,iCAAA;ExEkzRR;;EwEj0RM;IAAgC,6BAAA;ExEq0RtC;;EwEp0RM;;IAEE,iCAAA;ExEu0RR;;EwEr0RM;;IAEE,mCAAA;ExEw0RR;;EwEt0RM;;IAEE,oCAAA;ExEy0RR;;EwEv0RM;;IAEE,kCAAA;ExE00RR;;EwEz1RM;IAAgC,0BAAA;ExE61RtC;;EwE51RM;;IAEE,8BAAA;ExE+1RR;;EwE71RM;;IAEE,gCAAA;ExEg2RR;;EwE91RM;;IAEE,iCAAA;ExEi2RR;;EwE/1RM;;IAEE,+BAAA;ExEk2RR;;EwEj3RM;IAAgC,8BAAA;ExEq3RtC;;EwEp3RM;;IAEE,kCAAA;ExEu3RR;;EwEr3RM;;IAEE,oCAAA;ExEw3RR;;EwEt3RM;;IAEE,qCAAA;ExEy3RR;;EwEv3RM;;IAEE,mCAAA;ExE03RR;;EwEz4RM;IAAgC,6BAAA;ExE64RtC;;EwE54RM;;IAEE,iCAAA;ExE+4RR;;EwE74RM;;IAEE,mCAAA;ExEg5RR;;EwE94RM;;IAEE,oCAAA;ExEi5RR;;EwE/4RM;;IAEE,kCAAA;ExEk5RR;;EwEj6RM;IAAgC,8BAAA;ExEq6RtC;;EwEp6RM;;IAEE,kCAAA;ExEu6RR;;EwEr6RM;;IAEE,oCAAA;ExEw6RR;;EwEt6RM;;IAEE,qCAAA;ExEy6RR;;EwEv6RM;;IAEE,mCAAA;ExE06RR;;EwEl6RM;IAAwB,4BAAA;ExEs6R9B;;EwEr6RM;;IAEE,gCAAA;ExEw6RR;;EwEt6RM;;IAEE,kCAAA;ExEy6RR;;EwEv6RM;;IAEE,mCAAA;ExE06RR;;EwEx6RM;;IAEE,iCAAA;ExE26RR;;EwE17RM;IAAwB,6BAAA;ExE87R9B;;EwE77RM;;IAEE,iCAAA;ExEg8RR;;EwE97RM;;IAEE,mCAAA;ExEi8RR;;EwE/7RM;;IAEE,oCAAA;ExEk8RR;;EwEh8RM;;IAEE,kCAAA;ExEm8RR;;EwEl9RM;IAAwB,4BAAA;ExEs9R9B;;EwEr9RM;;IAEE,gCAAA;ExEw9RR;;EwEt9RM;;IAEE,kCAAA;ExEy9RR;;EwEv9RM;;IAEE,mCAAA;ExE09RR;;EwEx9RM;;IAEE,iCAAA;ExE29RR;;EwE1+RM;IAAwB,6BAAA;ExE8+R9B;;EwE7+RM;;IAEE,iCAAA;ExEg/RR;;EwE9+RM;;IAEE,mCAAA;ExEi/RR;;EwE/+RM;;IAEE,oCAAA;ExEk/RR;;EwEh/RM;;IAEE,kCAAA;ExEm/RR;;EwElgSM;IAAwB,0BAAA;ExEsgS9B;;EwErgSM;;IAEE,8BAAA;ExEwgSR;;EwEtgSM;;IAEE,gCAAA;ExEygSR;;EwEvgSM;;IAEE,iCAAA;ExE0gSR;;EwExgSM;;IAEE,+BAAA;ExE2gSR;;EwE1hSM;IAAwB,8BAAA;ExE8hS9B;;EwE7hSM;;IAEE,kCAAA;ExEgiSR;;EwE9hSM;;IAEE,oCAAA;ExEiiSR;;EwE/hSM;;IAEE,qCAAA;ExEkiSR;;EwEhiSM;;IAEE,mCAAA;ExEmiSR;;EwEljSM;IAAwB,6BAAA;ExEsjS9B;;EwErjSM;;IAEE,iCAAA;ExEwjSR;;EwEtjSM;;IAEE,mCAAA;ExEyjSR;;EwEvjSM;;IAEE,oCAAA;ExE0jSR;;EwExjSM;;IAEE,kCAAA;ExE2jSR;;EwE1kSM;IAAwB,8BAAA;ExE8kS9B;;EwE7kSM;;IAEE,kCAAA;ExEglSR;;EwE9kSM;;IAEE,oCAAA;ExEilSR;;EwE/kSM;;IAEE,qCAAA;ExEklSR;;EwEhlSM;;IAEE,mCAAA;ExEmlSR;;EwE7kSE;IAAmB,uBAAA;ExEilSrB;;EwEhlSE;;IAEE,2BAAA;ExEmlSJ;;EwEjlSE;;IAEE,6BAAA;ExEolSJ;;EwEllSE;;IAEE,8BAAA;ExEqlSJ;;EwEnlSE;;IAEE,4BAAA;ExEslSJ;AACF;AgBhmSI;EwDlDI;IAAgC,oBAAA;ExEspStC;;EwErpSM;;IAEE,wBAAA;ExEwpSR;;EwEtpSM;;IAEE,0BAAA;ExEypSR;;EwEvpSM;;IAEE,2BAAA;ExE0pSR;;EwExpSM;;IAEE,yBAAA;ExE2pSR;;EwE1qSM;IAAgC,2BAAA;ExE8qStC;;EwE7qSM;;IAEE,+BAAA;ExEgrSR;;EwE9qSM;;IAEE,iCAAA;ExEirSR;;EwE/qSM;;IAEE,kCAAA;ExEkrSR;;EwEhrSM;;IAEE,gCAAA;ExEmrSR;;EwElsSM;IAAgC,4BAAA;ExEssStC;;EwErsSM;;IAEE,gCAAA;ExEwsSR;;EwEtsSM;;IAEE,kCAAA;ExEysSR;;EwEvsSM;;IAEE,mCAAA;ExE0sSR;;EwExsSM;;IAEE,iCAAA;ExE2sSR;;EwE1tSM;IAAgC,2BAAA;ExE8tStC;;EwE7tSM;;IAEE,+BAAA;ExEguSR;;EwE9tSM;;IAEE,iCAAA;ExEiuSR;;EwE/tSM;;IAEE,kCAAA;ExEkuSR;;EwEhuSM;;IAEE,gCAAA;ExEmuSR;;EwElvSM;IAAgC,4BAAA;ExEsvStC;;EwErvSM;;IAEE,gCAAA;ExEwvSR;;EwEtvSM;;IAEE,kCAAA;ExEyvSR;;EwEvvSM;;IAEE,mCAAA;ExE0vSR;;EwExvSM;;IAEE,iCAAA;ExE2vSR;;EwE1wSM;IAAgC,yBAAA;ExE8wStC;;EwE7wSM;;IAEE,6BAAA;ExEgxSR;;EwE9wSM;;IAEE,+BAAA;ExEixSR;;EwE/wSM;;IAEE,gCAAA;ExEkxSR;;EwEhxSM;;IAEE,8BAAA;ExEmxSR;;EwElySM;IAAgC,6BAAA;ExEsyStC;;EwErySM;;IAEE,iCAAA;ExEwySR;;EwEtySM;;IAEE,mCAAA;ExEyySR;;EwEvySM;;IAEE,oCAAA;ExE0ySR;;EwExySM;;IAEE,kCAAA;ExE2ySR;;EwE1zSM;IAAgC,4BAAA;ExE8zStC;;EwE7zSM;;IAEE,gCAAA;ExEg0SR;;EwE9zSM;;IAEE,kCAAA;ExEi0SR;;EwE/zSM;;IAEE,mCAAA;ExEk0SR;;EwEh0SM;;IAEE,iCAAA;ExEm0SR;;EwEl1SM;IAAgC,6BAAA;ExEs1StC;;EwEr1SM;;IAEE,iCAAA;ExEw1SR;;EwEt1SM;;IAEE,mCAAA;ExEy1SR;;EwEv1SM;;IAEE,oCAAA;ExE01SR;;EwEx1SM;;IAEE,kCAAA;ExE21SR;;EwE12SM;IAAgC,qBAAA;ExE82StC;;EwE72SM;;IAEE,yBAAA;ExEg3SR;;EwE92SM;;IAEE,2BAAA;ExEi3SR;;EwE/2SM;;IAEE,4BAAA;ExEk3SR;;EwEh3SM;;IAEE,0BAAA;ExEm3SR;;EwEl4SM;IAAgC,4BAAA;ExEs4StC;;EwEr4SM;;IAEE,gCAAA;ExEw4SR;;EwEt4SM;;IAEE,kCAAA;ExEy4SR;;EwEv4SM;;IAEE,mCAAA;ExE04SR;;EwEx4SM;;IAEE,iCAAA;ExE24SR;;EwE15SM;IAAgC,6BAAA;ExE85StC;;EwE75SM;;IAEE,iCAAA;ExEg6SR;;EwE95SM;;IAEE,mCAAA;ExEi6SR;;EwE/5SM;;IAEE,oCAAA;ExEk6SR;;EwEh6SM;;IAEE,kCAAA;ExEm6SR;;EwEl7SM;IAAgC,4BAAA;ExEs7StC;;EwEr7SM;;IAEE,gCAAA;ExEw7SR;;EwEt7SM;;IAEE,kCAAA;ExEy7SR;;EwEv7SM;;IAEE,mCAAA;ExE07SR;;EwEx7SM;;IAEE,iCAAA;ExE27SR;;EwE18SM;IAAgC,6BAAA;ExE88StC;;EwE78SM;;IAEE,iCAAA;ExEg9SR;;EwE98SM;;IAEE,mCAAA;ExEi9SR;;EwE/8SM;;IAEE,oCAAA;ExEk9SR;;EwEh9SM;;IAEE,kCAAA;ExEm9SR;;EwEl+SM;IAAgC,0BAAA;ExEs+StC;;EwEr+SM;;IAEE,8BAAA;ExEw+SR;;EwEt+SM;;IAEE,gCAAA;ExEy+SR;;EwEv+SM;;IAEE,iCAAA;ExE0+SR;;EwEx+SM;;IAEE,+BAAA;ExE2+SR;;EwE1/SM;IAAgC,8BAAA;ExE8/StC;;EwE7/SM;;IAEE,kCAAA;ExEggTR;;EwE9/SM;;IAEE,oCAAA;ExEigTR;;EwE//SM;;IAEE,qCAAA;ExEkgTR;;EwEhgTM;;IAEE,mCAAA;ExEmgTR;;EwElhTM;IAAgC,6BAAA;ExEshTtC;;EwErhTM;;IAEE,iCAAA;ExEwhTR;;EwEthTM;;IAEE,mCAAA;ExEyhTR;;EwEvhTM;;IAEE,oCAAA;ExE0hTR;;EwExhTM;;IAEE,kCAAA;ExE2hTR;;EwE1iTM;IAAgC,8BAAA;ExE8iTtC;;EwE7iTM;;IAEE,kCAAA;ExEgjTR;;EwE9iTM;;IAEE,oCAAA;ExEijTR;;EwE/iTM;;IAEE,qCAAA;ExEkjTR;;EwEhjTM;;IAEE,mCAAA;ExEmjTR;;EwE3iTM;IAAwB,4BAAA;ExE+iT9B;;EwE9iTM;;IAEE,gCAAA;ExEijTR;;EwE/iTM;;IAEE,kCAAA;ExEkjTR;;EwEhjTM;;IAEE,mCAAA;ExEmjTR;;EwEjjTM;;IAEE,iCAAA;ExEojTR;;EwEnkTM;IAAwB,6BAAA;ExEukT9B;;EwEtkTM;;IAEE,iCAAA;ExEykTR;;EwEvkTM;;IAEE,mCAAA;ExE0kTR;;EwExkTM;;IAEE,oCAAA;ExE2kTR;;EwEzkTM;;IAEE,kCAAA;ExE4kTR;;EwE3lTM;IAAwB,4BAAA;ExE+lT9B;;EwE9lTM;;IAEE,gCAAA;ExEimTR;;EwE/lTM;;IAEE,kCAAA;ExEkmTR;;EwEhmTM;;IAEE,mCAAA;ExEmmTR;;EwEjmTM;;IAEE,iCAAA;ExEomTR;;EwEnnTM;IAAwB,6BAAA;ExEunT9B;;EwEtnTM;;IAEE,iCAAA;ExEynTR;;EwEvnTM;;IAEE,mCAAA;ExE0nTR;;EwExnTM;;IAEE,oCAAA;ExE2nTR;;EwEznTM;;IAEE,kCAAA;ExE4nTR;;EwE3oTM;IAAwB,0BAAA;ExE+oT9B;;EwE9oTM;;IAEE,8BAAA;ExEipTR;;EwE/oTM;;IAEE,gCAAA;ExEkpTR;;EwEhpTM;;IAEE,iCAAA;ExEmpTR;;EwEjpTM;;IAEE,+BAAA;ExEopTR;;EwEnqTM;IAAwB,8BAAA;ExEuqT9B;;EwEtqTM;;IAEE,kCAAA;ExEyqTR;;EwEvqTM;;IAEE,oCAAA;ExE0qTR;;EwExqTM;;IAEE,qCAAA;ExE2qTR;;EwEzqTM;;IAEE,mCAAA;ExE4qTR;;EwE3rTM;IAAwB,6BAAA;ExE+rT9B;;EwE9rTM;;IAEE,iCAAA;ExEisTR;;EwE/rTM;;IAEE,mCAAA;ExEksTR;;EwEhsTM;;IAEE,oCAAA;ExEmsTR;;EwEjsTM;;IAEE,kCAAA;ExEosTR;;EwEntTM;IAAwB,8BAAA;ExEutT9B;;EwEttTM;;IAEE,kCAAA;ExEytTR;;EwEvtTM;;IAEE,oCAAA;ExE0tTR;;EwExtTM;;IAEE,qCAAA;ExE2tTR;;EwEztTM;;IAEE,mCAAA;ExE4tTR;;EwEttTE;IAAmB,uBAAA;ExE0tTrB;;EwEztTE;;IAEE,2BAAA;ExE4tTJ;;EwE1tTE;;IAEE,6BAAA;ExE6tTJ;;EwE3tTE;;IAEE,8BAAA;ExE8tTJ;;EwE5tTE;;IAEE,4BAAA;ExE+tTJ;AACF;AgBzuTI;EwDlDI;IAAgC,oBAAA;ExE+xTtC;;EwE9xTM;;IAEE,wBAAA;ExEiyTR;;EwE/xTM;;IAEE,0BAAA;ExEkyTR;;EwEhyTM;;IAEE,2BAAA;ExEmyTR;;EwEjyTM;;IAEE,yBAAA;ExEoyTR;;EwEnzTM;IAAgC,2BAAA;ExEuzTtC;;EwEtzTM;;IAEE,+BAAA;ExEyzTR;;EwEvzTM;;IAEE,iCAAA;ExE0zTR;;EwExzTM;;IAEE,kCAAA;ExE2zTR;;EwEzzTM;;IAEE,gCAAA;ExE4zTR;;EwE30TM;IAAgC,4BAAA;ExE+0TtC;;EwE90TM;;IAEE,gCAAA;ExEi1TR;;EwE/0TM;;IAEE,kCAAA;ExEk1TR;;EwEh1TM;;IAEE,mCAAA;ExEm1TR;;EwEj1TM;;IAEE,iCAAA;ExEo1TR;;EwEn2TM;IAAgC,2BAAA;ExEu2TtC;;EwEt2TM;;IAEE,+BAAA;ExEy2TR;;EwEv2TM;;IAEE,iCAAA;ExE02TR;;EwEx2TM;;IAEE,kCAAA;ExE22TR;;EwEz2TM;;IAEE,gCAAA;ExE42TR;;EwE33TM;IAAgC,4BAAA;ExE+3TtC;;EwE93TM;;IAEE,gCAAA;ExEi4TR;;EwE/3TM;;IAEE,kCAAA;ExEk4TR;;EwEh4TM;;IAEE,mCAAA;ExEm4TR;;EwEj4TM;;IAEE,iCAAA;ExEo4TR;;EwEn5TM;IAAgC,yBAAA;ExEu5TtC;;EwEt5TM;;IAEE,6BAAA;ExEy5TR;;EwEv5TM;;IAEE,+BAAA;ExE05TR;;EwEx5TM;;IAEE,gCAAA;ExE25TR;;EwEz5TM;;IAEE,8BAAA;ExE45TR;;EwE36TM;IAAgC,6BAAA;ExE+6TtC;;EwE96TM;;IAEE,iCAAA;ExEi7TR;;EwE/6TM;;IAEE,mCAAA;ExEk7TR;;EwEh7TM;;IAEE,oCAAA;ExEm7TR;;EwEj7TM;;IAEE,kCAAA;ExEo7TR;;EwEn8TM;IAAgC,4BAAA;ExEu8TtC;;EwEt8TM;;IAEE,gCAAA;ExEy8TR;;EwEv8TM;;IAEE,kCAAA;ExE08TR;;EwEx8TM;;IAEE,mCAAA;ExE28TR;;EwEz8TM;;IAEE,iCAAA;ExE48TR;;EwE39TM;IAAgC,6BAAA;ExE+9TtC;;EwE99TM;;IAEE,iCAAA;ExEi+TR;;EwE/9TM;;IAEE,mCAAA;ExEk+TR;;EwEh+TM;;IAEE,oCAAA;ExEm+TR;;EwEj+TM;;IAEE,kCAAA;ExEo+TR;;EwEn/TM;IAAgC,qBAAA;ExEu/TtC;;EwEt/TM;;IAEE,yBAAA;ExEy/TR;;EwEv/TM;;IAEE,2BAAA;ExE0/TR;;EwEx/TM;;IAEE,4BAAA;ExE2/TR;;EwEz/TM;;IAEE,0BAAA;ExE4/TR;;EwE3gUM;IAAgC,4BAAA;ExE+gUtC;;EwE9gUM;;IAEE,gCAAA;ExEihUR;;EwE/gUM;;IAEE,kCAAA;ExEkhUR;;EwEhhUM;;IAEE,mCAAA;ExEmhUR;;EwEjhUM;;IAEE,iCAAA;ExEohUR;;EwEniUM;IAAgC,6BAAA;ExEuiUtC;;EwEtiUM;;IAEE,iCAAA;ExEyiUR;;EwEviUM;;IAEE,mCAAA;ExE0iUR;;EwExiUM;;IAEE,oCAAA;ExE2iUR;;EwEziUM;;IAEE,kCAAA;ExE4iUR;;EwE3jUM;IAAgC,4BAAA;ExE+jUtC;;EwE9jUM;;IAEE,gCAAA;ExEikUR;;EwE/jUM;;IAEE,kCAAA;ExEkkUR;;EwEhkUM;;IAEE,mCAAA;ExEmkUR;;EwEjkUM;;IAEE,iCAAA;ExEokUR;;EwEnlUM;IAAgC,6BAAA;ExEulUtC;;EwEtlUM;;IAEE,iCAAA;ExEylUR;;EwEvlUM;;IAEE,mCAAA;ExE0lUR;;EwExlUM;;IAEE,oCAAA;ExE2lUR;;EwEzlUM;;IAEE,kCAAA;ExE4lUR;;EwE3mUM;IAAgC,0BAAA;ExE+mUtC;;EwE9mUM;;IAEE,8BAAA;ExEinUR;;EwE/mUM;;IAEE,gCAAA;ExEknUR;;EwEhnUM;;IAEE,iCAAA;ExEmnUR;;EwEjnUM;;IAEE,+BAAA;ExEonUR;;EwEnoUM;IAAgC,8BAAA;ExEuoUtC;;EwEtoUM;;IAEE,kCAAA;ExEyoUR;;EwEvoUM;;IAEE,oCAAA;ExE0oUR;;EwExoUM;;IAEE,qCAAA;ExE2oUR;;EwEzoUM;;IAEE,mCAAA;ExE4oUR;;EwE3pUM;IAAgC,6BAAA;ExE+pUtC;;EwE9pUM;;IAEE,iCAAA;ExEiqUR;;EwE/pUM;;IAEE,mCAAA;ExEkqUR;;EwEhqUM;;IAEE,oCAAA;ExEmqUR;;EwEjqUM;;IAEE,kCAAA;ExEoqUR;;EwEnrUM;IAAgC,8BAAA;ExEurUtC;;EwEtrUM;;IAEE,kCAAA;ExEyrUR;;EwEvrUM;;IAEE,oCAAA;ExE0rUR;;EwExrUM;;IAEE,qCAAA;ExE2rUR;;EwEzrUM;;IAEE,mCAAA;ExE4rUR;;EwEprUM;IAAwB,4BAAA;ExEwrU9B;;EwEvrUM;;IAEE,gCAAA;ExE0rUR;;EwExrUM;;IAEE,kCAAA;ExE2rUR;;EwEzrUM;;IAEE,mCAAA;ExE4rUR;;EwE1rUM;;IAEE,iCAAA;ExE6rUR;;EwE5sUM;IAAwB,6BAAA;ExEgtU9B;;EwE/sUM;;IAEE,iCAAA;ExEktUR;;EwEhtUM;;IAEE,mCAAA;ExEmtUR;;EwEjtUM;;IAEE,oCAAA;ExEotUR;;EwEltUM;;IAEE,kCAAA;ExEqtUR;;EwEpuUM;IAAwB,4BAAA;ExEwuU9B;;EwEvuUM;;IAEE,gCAAA;ExE0uUR;;EwExuUM;;IAEE,kCAAA;ExE2uUR;;EwEzuUM;;IAEE,mCAAA;ExE4uUR;;EwE1uUM;;IAEE,iCAAA;ExE6uUR;;EwE5vUM;IAAwB,6BAAA;ExEgwU9B;;EwE/vUM;;IAEE,iCAAA;ExEkwUR;;EwEhwUM;;IAEE,mCAAA;ExEmwUR;;EwEjwUM;;IAEE,oCAAA;ExEowUR;;EwElwUM;;IAEE,kCAAA;ExEqwUR;;EwEpxUM;IAAwB,0BAAA;ExEwxU9B;;EwEvxUM;;IAEE,8BAAA;ExE0xUR;;EwExxUM;;IAEE,gCAAA;ExE2xUR;;EwEzxUM;;IAEE,iCAAA;ExE4xUR;;EwE1xUM;;IAEE,+BAAA;ExE6xUR;;EwE5yUM;IAAwB,8BAAA;ExEgzU9B;;EwE/yUM;;IAEE,kCAAA;ExEkzUR;;EwEhzUM;;IAEE,oCAAA;ExEmzUR;;EwEjzUM;;IAEE,qCAAA;ExEozUR;;EwElzUM;;IAEE,mCAAA;ExEqzUR;;EwEp0UM;IAAwB,6BAAA;ExEw0U9B;;EwEv0UM;;IAEE,iCAAA;ExE00UR;;EwEx0UM;;IAEE,mCAAA;ExE20UR;;EwEz0UM;;IAEE,oCAAA;ExE40UR;;EwE10UM;;IAEE,kCAAA;ExE60UR;;EwE51UM;IAAwB,8BAAA;ExEg2U9B;;EwE/1UM;;IAEE,kCAAA;ExEk2UR;;EwEh2UM;;IAEE,oCAAA;ExEm2UR;;EwEj2UM;;IAEE,qCAAA;ExEo2UR;;EwEl2UM;;IAEE,mCAAA;ExEq2UR;;EwE/1UE;IAAmB,uBAAA;ExEm2UrB;;EwEl2UE;;IAEE,2BAAA;ExEq2UJ;;EwEn2UE;;IAEE,6BAAA;ExEs2UJ;;EwEp2UE;;IAEE,8BAAA;ExEu2UJ;;EwEr2UE;;IAEE,4BAAA;ExEw2UJ;AACF;AyEz6UE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AzEy6UJ;;A0En7UA;EAAkB,6DAAA;A1Eu7UlB;;A0En7UA;EAAiB,8BAAA;A1Eu7UjB;;A0Et7UA;EAAiB,8BAAA;A1E07UjB;;A0Ez7UA;EAAiB,8BAAA;A1E67UjB;;A0E57UA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A3Ey8UF;;A0E17UI;EAAwB,2BAAA;A1E87U5B;;A0E77UI;EAAwB,4BAAA;A1Ei8U5B;;A0Eh8UI;EAAwB,6BAAA;A1Eo8U5B;;AgB/5UI;E0DvCA;IAAwB,2BAAA;E1E28U1B;;E0E18UE;IAAwB,4BAAA;E1E88U1B;;E0E78UE;IAAwB,6BAAA;E1Ei9U1B;AACF;AgB76UI;E0DvCA;IAAwB,2BAAA;E1Ew9U1B;;E0Ev9UE;IAAwB,4BAAA;E1E29U1B;;E0E19UE;IAAwB,6BAAA;E1E89U1B;AACF;AgB17UI;E0DvCA;IAAwB,2BAAA;E1Eq+U1B;;E0Ep+UE;IAAwB,4BAAA;E1Ew+U1B;;E0Ev+UE;IAAwB,6BAAA;E1E2+U1B;AACF;AgBv8UI;E0DvCA;IAAwB,2BAAA;E1Ek/U1B;;E0Ej/UE;IAAwB,4BAAA;E1Eq/U1B;;E0Ep/UE;IAAwB,6BAAA;E1Ew/U1B;AACF;A0En/UA;EAAmB,oCAAA;A1Es/UnB;;A0Er/UA;EAAmB,oCAAA;A1Ey/UnB;;A0Ex/UA;EAAmB,qCAAA;A1E4/UnB;;A0Ex/UA;EAAuB,2BAAA;A1E4/UvB;;A0E3/UA;EAAuB,+BAAA;A1E+/UvB;;A0E9/UA;EAAuB,2BAAA;A1EkgVvB;;A0EjgVA;EAAuB,2BAAA;A1EqgVvB;;A0EpgVA;EAAuB,2BAAA;A1EwgVvB;;A0EvgVA;EAAuB,6BAAA;A1E2gVvB;;A0EvgVA;EAAc,yBAAA;A1E2gVd;;A4EljVE;EACE,yBAAA;A5EqjVJ;;AO3iVE;EqELM,yBAAA;A5EojVR;;A4E1jVE;EACE,yBAAA;A5E6jVJ;;AOnjVE;EqELM,yBAAA;A5E4jVR;;A4ElkVE;EACE,yBAAA;A5EqkVJ;;AO3jVE;EqELM,yBAAA;A5EokVR;;A4E1kVE;EACE,yBAAA;A5E6kVJ;;AOnkVE;EqELM,yBAAA;A5E4kVR;;A4EllVE;EACE,yBAAA;A5EqlVJ;;AO3kVE;EqELM,yBAAA;A5EolVR;;A4E1lVE;EACE,yBAAA;A5E6lVJ;;AOnlVE;EqELM,yBAAA;A5E4lVR;;A4ElmVE;EACE,yBAAA;A5EqmVJ;;AO3lVE;EqELM,yBAAA;A5EomVR;;A4E1mVE;EACE,yBAAA;A5E6mVJ;;AOnmVE;EqELM,uBAAA;A5E4mVR;;A0ErkVA;EAAa,yBAAA;A1EykVb;;A0ExkVA;EAAc,yBAAA;A1E4kVd;;A0E1kVA;EAAiB,uCAAA;A1E8kVjB;;A0E7kVA;EAAiB,0CAAA;A1EilVjB;;A0E7kVA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A7EwoVF;;A0EjlVA;EAAwB,gCAAA;A1EqlVxB;;A0EnlVA;EACE,iCAAA;EACA,oCAAA;A1EslVF;;A0EjlVA;EAAc,yBAAA;A1EqlVd;;A8EtpVA;EACE,8BAAA;A9EypVF;;A8EtpVA;EACE,6BAAA;A9EypVF;;A+EzpVE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E/EypVJ;;E+ErpVI;IACE,0BAAA;E/EwpVN;;E+E/oVE;IACE,6BAAA;E/EkpVJ;;E+EpoVE;IACE,gCAAA;E/EuoVJ;;E+EroVE;;IAEE,yBAAA;IACA,wBAAA;E/EwoVJ;;E+EhoVE;IACE,2BAAA;E/EmoVJ;;E+EhoVE;;IAEE,wBAAA;E/EmoVJ;;E+EhoVE;;;IAGE,UAAA;IACA,SAAA;E/EmoVJ;;E+EhoVE;;IAEE,uBAAA;E/EmoVJ;;E+E3nVE;IACE,QzEyhC8B;ENqmTlC;E+E5nVE;IACE,2BAAA;E/E8nVJ;;E+E5nVE;IACE,2BAAA;E/E+nVJ;;E+E3nVE;IACE,aAAA;E/E8nVJ;;E+E5nVE;IACE,yBAAA;E/E+nVJ;;E+E5nVE;IACE,oCAAA;E/E+nVJ;E+E7nVI;;IAEE,oCAAA;E/E+nVN;;E+E1nVI;;IAEE,oCAAA;E/E6nVN;;E+EznVE;IACE,cAAA;E/E4nVJ;E+E1nVI;;;;IAIE,qB3EaO;EJ+mVb;;E+ExnVE;IACE,cAAA;IACA,qB3EOS;EJonVb;AACF;AgFlwVE;EACE,aAAA;AhFowVJ;;AgFhwVA;EACE,cAAA;EACA,qBAAA;AhFmwVF;;AgF3vVA;EACE,aAAA;AhF8vVF;;AiFjwVA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AjFowVF;AiFnwVE;;EAEE,iBAAA;AjFqwVJ;;AiFhwVA;EACE,0BAAA;AjFmwVF;AiFjwVE;EACE,uCAAA;EACA,gDAAA;EACA,WAAA;AjFmwVJ;;AiF9vVA;EACE,qBAAA;EACA,kCAAA;AjFiwVF;;AiF/vVA;EACE,qBAAA;EACA,kCAAA;AjFkwVF;;AiF/vVA;EACE;IACE,uBAAA;EjFkwVF;EiFhwVA;IACE,yBAAA;EjFkwVF;AACF;AiF/vVA;EACE,qBAAA;EACA,0CAAA;AjFiwVF;;AiF/vVA;EACE;IACE,uBAAA;EjFkwVF;EiFhwVA;IACE,0BAAA;EjFkwVF;AACF;AiF9vVA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AjFgwVF;AiF/vVE;EACE,gBAAA;EACA,iBAAA;AjFiwVJ;AiF/vVE;EACE,iBAAA;EACA,kBAAA;AjFiwVJ;AiF/vVE;EACE,iBAAA;EACA,kBAAA;AjFiwVJ;;AiF5vVA;EACE,qBAAA;EACA,c7EmGW;E6ElGX,yBAAA;EACA,qBAAA;AjF+vVF;;AiF3vVA;EACE,WAAA;EACA,mBAAA;AjF8vVF;;AiFzvVE;EACE,aAAA;EACA,iBAAA;AjF4vVJ;AiF1vVI;EACE,cAAA;AjF4vVN;;AkF91VA;EACE,c9EsKe;AJ2rVjB;AkFh2VE;EACE,yBAAA;AlFk2VJ;;AkF71VE;EACE,yBAAA;AlFg2VJ;;AmFh3VA;EACE,0BAAA;EACA,cAAA;EACA,c7EgCQ;E6E/BR,sB/EsfO;EQ3eL,yBAAA;AZy2VJ;;AmFj3VA;EACE,yBAAA;AnFo3VF;AmFn3VE;EACE,wCAAA;AnFq3VJ;;AoFt3VE;;EAEE,mBAAA;ApFy3VJ;;AoFj3VI;;EACE,mBAAA;EACA,yBAAA;EACA,kBhFwLe;EgFvLf,qBAAA;ApFq3VN;AoFl3VE;;EAEE,yBAAA;EACA,sBAAA;ApFo3VJ;AoF/2VM;;EACE,wBAAA;ApFk3VR;;AoF32VE;;EAEE,yBhF4JY;AJktVhB;;AoFx2VI;EACE,eAAA;ApF22VN;;AoFt2VA;EACE,yBhFyDQ;AJgzVV;AoFv2VI;EACE,gBAAA;ApFy2VN;AoFt2VE;;EAEE,SAAA;ApFw2VJ;AoFr2VI;EACE,0BAAA;EACA,yBhF9DE;AJq6VR;AoFt2VM;EACE,2BAAA;ApFw2VR;;AoFj2VA;EACE,gBAAA;EACA,oChF2Dc;EgF1Dd,qChF0Dc;AJ0yVhB;AoFj2VM;EACE,oChFsDQ;AJ6yVhB;AoFj2VM;EACE,qChFmDQ;AJgzVhB;;AoFz1VM;EACE,oChFwCQ;AJozVhB;AoF11VM;EACE,qChFqCQ;AJuzVhB;;AoFr1VA;EAGM;IACE,4BhFyBO;EJ6zVb;AACF;AqFx8VA;EACE,cjF4Ke;EiF3Kf,kBjFqLgB;AJqxVlB;;AqFr8VE;EACE,yBAAA;ArFw8VJ;AqFp8VI;EACE,yBAAA;EACA,yBAAA;ArFs8VN;AqFp8VI;EAEE,8CjFmPmB;AJktVzB;;AqF/7VE;EACE,aAAA;ArFk8VJ;;AqF97VA;EACE,iBAAA;ArFi8VF;AqF/7VE;EACE,iBAAA;EACA,iBAAA;ArFi8VJ;;AqF77VA;;EAEE,SAAA;EACA,SAAA;ArFg8VF;;AqF77VA;;eAAA;AAME;EACE,8CjFkNqB;EiFjNrB,wBjFuFY;AJs2VhB;AqF57VI;;EAEE,qBjFpBS;EiFqBT,gBAAA;ArF87VN;AqF57VM;;EACE,qBjF9BA;AJ69VR;AqF57VM;;EACE,qBjF/BF;AJ89VN;AqF17VI;EACE,gCAAA;ArF47VN;AqFz7VM;EACE,qBjF5CA;AJu+VR;AqFt7VI;EACE,gCAAA;ArFw7VN;AqFr7VM;EACE,qBjFnDF;AJ0+VN;AqFj7VI;EACE,yBjFgKc;AJmxVpB;AqF96VI;;EzEjFA,wBAAA;AZmgWJ;AqF36VI;;EzExFA,gBAAA;AZugWJ;AqFt6VM;EACE,0BAAA;EACA,6BAAA;ArFw6VR;AqFp6VM;EACE,yBAAA;EACA,4BAAA;ArFs6VR;AqFl6VM;EACE,yBAAA;EACA,4BAAA;ArFo6VR;AqFl6VM;EACE,0BAAA;EACA,6BAAA;ArFo6VR;AqF/5VI;;EzExHA,gBAAA;AZ2hWJ;;AqF55VA;EhEjIM,wEgEkIJ;ArF+5VF;AqB7hWM;EgE6HN;IhE5HQ,gBAAA;ErBgiWN;AACF;;AqFh6VE;EACE,eAAA;ArFm6VJ;;AqF95VE;EACE,cAAA;ArFi6VJ;AqF/5VE;EACE,eAAA;ArFi6VJ;;AqF15VI;EACE,eAAA;EACA,cAAA;ArF65VN;AqF15VI;EACE,gBAAA;EACA,eAAA;ArF45VN;AqFv5VQ;EACE,qBjFnJF;AJ4iWR;AqFl5VM;EACE,qBjF3JA;AJ+iWR;;AqF54VE;EACE,mBAAA;EACA,mCAAA;ArF+4VJ;AqF54VE;EACE,uCAAA;ArF84VJ;AqF34VE;EACE,wCAAA;ArF64VJ;;AqFx4VA;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;ArF24VF;AqFz4VE;EACE,yBjFpGM;AJ++VV;AqFz4VE;EACE,kBAAA;ArF24VJ;AqFz4VE;EACE,iBAAA;ArF24VJ;AqFx4VE;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;ArF04VJ;AgBviWI;EqEiKA;IACE,sBAAA;IACA,mBAAA;ErFy4VJ;AACF;;AgB1jWI;EqEyLE;IACE,iBAAA;ErFq4VN;AACF;;AqF93VE;EACE,yDAAA;EACA,2EACE;EAGF,qCACE;EAEF,4BAAA;EACA,wBAAA;EACA,qBAAA;EACA,wBAAA;ArF43VJ;AqF13VE;EACE,2EACE;ArF23VN;AqFv3VE;EACE,yEACE;ArFw3VN;;AqFj3VA;EACE,qBAAA;EACA,wBAAA;ArFo3VF;;AqF/2VE;;EAEE,eAAA;ArFk3VJ;AqF/2VE;EACE,oBAAA;ArFi3VJ;;AqF32VE;EACE,cAAA;ArF82VJ;;AqFv2VE;;EACE,sBAAA;ArF22VJ;AqFz2VI;;EACE,uBAAA;ArF42VN;AqFx2VE;;EACE,kBAAA;EACA,mBAAA;ArF22VJ;AqFx2VE;;EACE,mBjFrKa;EiFsKb,gBAAA;ArF22VJ;AqFz2VI;;;EAEE,WAAA;EACA,YAAA;EACA,OAAA;ArF42VN;AqFr2VE;;EACE,YAAA;EACA,2BAAA;ArFw2VJ;AqFr2VE;;EACE,kBAAA;EACA,yDAAA;ArFw2VJ;;AqFj2VI;EACE,yBjF1TS;EiF2TT,qBjF3TS;AJ+pWf;;AqF/1VA,yBAAA;AACA;EACE,kBAAA;EACA,mB/EwJsC;AN0sVxC;AqF91VI;EACE,ejF5HY;EiF6HZ,iBAAA;ArFg2VN;AqF31VE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,iCAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,4BAAA;EACA,oBAAA;EACA,UAAA;ArF61VJ;AqFr1VM;;;EACE,yBAAA;EACA,iCAAA;EACA,UAAA;ArFy1VR;AqFr1VM;;EACE,uCAAA;ArFw1VR;AqFp1VI;;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ArFu1VN;AqFp1VI;;EACE,UAAA;ArFu1VN;AqFp1VI;;EACE,UAAA;ArFu1VN;;AqFl1VA,aAAA;AAEA;EACE,eAAA;EACA,sBAAA;EAuEA,mBAAA;EAYA,8BAAA;ArFmwVF;AqFp1VE;EACE,uBAAA;EACA,sBAAA;EAEA,0BAAA;EAcA,oBAAA;EAYA,kBAAA;ArF6zVJ;AqFt1VI;EACE,YAAA;EACA,yBCzTY;ED0TZ,iBAAA;EACA,2BAAA;EACA,0DACE;EAEF,eAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;ArFs1VN;AqFn1VI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;EACA,yBjFvbE;EiFwbF,8BAAA;EACA,eAAA;EACA,iBAAA;ArFq1VN;AqFj1VI;;;;EAIE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ArFm1VN;AqFl1VM;;;;;;;;EAEE,YAAA;EACA,WAAA;EACA,eAAA;ArF01VR;AqFv1VI;;EAEE,SAAA;EACA,cjFhdE;EiFidF,UAAA;EACA,0BAAA;EACA,mDACE;ArFw1VR;AqFr1VI;EACE,WAAA;EACA,UAAA;EACA,0BAAA;EACA,oDACE;ArFs1VR;AqFn1VI;EACE,UAAA;ArFq1VN;AqF/0VE;EACE,sBAAA;ArFi1VJ;AqF50VE;EACE,gBAAA;ArF80VJ;AqF10VE;EACE,+BAAA;ArF40VJ;AqFx0VI;;EAEE,wBAAA;EACA,UAAA;ArF00VN;AqFv0VI;;EAEE,2BAAA;EACA,UAAA;ArFy0VN;AqFr0VI;EACE,UAAA;ArFu0VN;AqFr0VI;EACE,UAAA;ArFu0VN;AqFn0VI;EACE,UAAA;ArFq0VN;AqFn0VI;EACE,UAAA;ArFq0VN;;AqFh0VA,0BAAA;AACA;EACE,yBjF1fa;EiF2fb,cjFvhBM;EiFwhBN,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;ArFm0VF;;AqFh0VA;EACE,kDAAA;EACA,eAAA;ArFm0VF;;AqFh0VA,2DAAA;AACA;;EAEE,wBAAA;ArFm0VF;;AqF/zVA;EAGI;IACE,aAAA;ErFg0VJ;;EqF1zVE;IACE,gBAAA;ErF6zVJ;AACF;AqFvzVE;EACE,yBjF7jBI;AJs3WR;;AqFpzVA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;ArFuzVF;;AqFpzVA;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;ArFuzVF;AqFrzVE;EAGE,qBjF1jBW;AJ+2Wf;;AqFjzVA;EACE,wBAAA;ArFozVF;;AqFjzVA;EACE,wBAAA;ArFozVF;;AqFjzVA;EACE,cAAA;ArFozVF;;AqFjzVA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ArFozVF;;AuFz6WA;EACE,gBAAA;EACA,gBAAA;AvF46WF;AuFz6WE;EACE,yBAAA;AvF26WJ;AuF16WI;EACE,2BAAA;AvF46WN;AuFv6WE;EACE,6BAAA;AvFy6WJ;AuFt6WI;EACE,kBAAA;EACA,gBAAA;AvFw6WN;AuFp6WI;EACE,iBAAA;EACA,iBAAA;AvFs6WN;AuFl6WE;EAIE,aAAA;EACA,gBAAA;AvFi6WJ;AuF95WE;EAEE,2BAAA;AvF+5WJ;AuF35WE;EACE,sBAAA;AvF65WJ;;AuFx5WA;EACE,UAAA;AvF25WF;;AgBv4WI;EuEhBF;IACE,cAAA;IACA,WAAA;EvF25WF;AACF;AuFt5WA;EACE,eAAA;AvFw5WF;;AwFt9WA;EACE,8BAAA;EACA,6BAAA;AxFy9WF;;AwFt9WA;;EAEE,mBAAA;EACA,kBAAA;AxFy9WF;;AwFt9WA;;EAEE,8BAAA;EACA,6BAAA;AxFy9WF;;AwFp9WE;EAGE,oDAAA;EACA,qDAAA;AxFq9WJ;;AwFh9WA;;EAQE,yCAAA;AxF68WF;;AwFz8WA;;EAQE,0CAAA;AxFs8WF;;AwFh8WI;EACE,gCAAA;AxFm8WN;AwF/7WI;EAEE,oDAAA;AxFg8WN;;AwF37WA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AxF87WF;AwF57WE;EACE,yBAAA;EACA,qBAAA;AxF87WJ;AwF37WE;EACE,oCAAA;EACA,gCAAA;AxF67WJ;;AwFz7WA;EACE,yBAAA;EACA,qBAAA;EACA,WAAA;AxF47WF;AwF17WE;EACE,yBAAA;EACA,qBAAA;AxF47WJ;AwFz7WE;EACE,oCAAA;EACA,gCAAA;AxF27WJ;;AyFzhXE;EACE,yBAAA;AzF4hXJ;AyFthXM;EACE,aAAA;AzFwhXR;AyFthXM;;EAEE,eAAA;AzFwhXR;;AyFjhXA;EAEE,uBrF2SuB;EqF1SvB,sBAAA;EACA,4CrF0SoB;AJyuWtB;AyFjhXE;EACE,WAAA;EACA,eAAA;AzFmhXJ;AyF/gXE;EACE,gBAAA;EACA,cAAA;AzFihXJ;;AyF5gXE;EACE,sBAAA;EACA,UAAA;EACA,cAAA;AzF+gXJ;AyF7gXE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AzF+gXJ;AyF5gXI;EACE,gBAAA;AzF8gXN;AyFvgXM;EACE,gBAAA;AzFygXR;;AyFhgXE;EACE,uBAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,crFwCS;EqFvCT,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;AzFmgXJ;AyF//WI;EACE,qBAAA;AzFigXN;AyF5/WI;EACE,qBAAA;AzF8/WN;AyFz/WI;EACE,OAAA;AzF2/WN;AyFr/WI;EACE,aAAA;AzFu/WN;AyFl/WE;EACE,UAAA;AzFo/WJ;;AyF/+WA;EACE,kBAAA;AzFk/WF;AyF/+WI;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;AzFi/WN;AyF9+WE;EACE,eAAA;AzFg/WJ;;AyFx+WI;EACE,uBAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;AzF2+WN;AyFx+WE;EACE,eAAA;AzF0+WJ;;AyFl+WI;EACE,uBAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AzFq+WN;AyFl+WE;EACE,eAAA;AzFo+WJ;;AyF59WE;EAEE,kBrF2Je;AJm0WnB;AyF39WE;EAEE,qBrFsJe;AJs0WnB;AyFz9WE;EACE,mBrFkJe;AJy0WnB;AyFz9WE;EACE,oBrF+Ie;AJ40WnB;;AyFl9WM;;EACE,aAAA;AzFs9WR;AyFn9WI;;EACE,eAAA;AzFs9WN;AyFr9WM;;EACE,4BAAA;EACA,eAAA;AzFw9WR;AyFv9WQ;;;;EAEE,iBAAA;EACA,gBAAA;EACA,oBAAA;AzF29WV;;AyFn9WA;;EAEE,wBAAA;EACA,yBAAA;EACA,uBAAA;AzFs9WF;;AyFh9WE;;;EAEE,aAAA;AzFo9WJ;;AyFh9WA;EACE;IACE,+BAAA;IACA,UAAA;EzFm9WF;EyFj9WA;IACE,2BAAA;IACA,UAAA;EzFm9WF;EyFj9WA;IACE,+BAAA;IACA,UAAA;EzFm9WF;AACF;A0FrtXA;;;;;;;;iGAAA;AAkBA;EACE,YAAA;EACA,oBJSc;EIRd,kDtFqIsB;EsFpItB,yCACE;EAEF,YAAA;A1F4sXF;A0F1sXE;EACE,WJmBkB;AtFyrXtB;A0FrsXE;EACE,eAAA;EACA,QAAA;EACA,2BAAA;EACA,+DAAA;EACA,uBtF6UiB;EsF5UjB,WAAA;A1FusXJ;A0FnsXE;EACE,MAAA;EACA,QAAA;EACA,WJDkB;EIElB,2CAAA;EACA,uBAAA;EACA,2BAAA;A1FqsXJ;A0FjsXE;EACE,gCAAA;A1FmsXJ;A0F/rXE;EACE,8CtFqFS;AJ4mXb;A0F9rXE;EACE,gCAAA;A1FgsXJ;A0F1rXE;EACE,wBAAA;EAKA,gBAAA;EACA,0BAAA;EACA,cAAA;A1FwrXJ;AgB7sXI;E0EaF;IAII,wBAAA;E1FgsXJ;AACF;A0FxrXM;EACE,UAAA;A1F0rXR;A0FprXM;EACE,gBAAA;A1FsrXR;A0FnrXQ;EACE,qBAAA;A1FqrXV;A0F/qXI;EACE,eAAA;A1FirXN;A0F/qXM;EACE,gCAAA;A1FirXR;A0F7qXQ;EACE,0BAAA;EACA,YAAA;EACA,gCAAA;A1F+qXV;A0F7qXU;EACE,mBtFDF;AJgrXV;A0F5qXU;EACE,ctFJC;AJkrXb;A0FzqXU;EACE,mBAAA;A1F2qXZ;A0FtqXM;EACE,6BAAA;A1FwqXR;;A0FjqXA;EACE,aAAA;A1FoqXF;;A0F9pXE;EACE,wBAAA;A1FiqXJ;A0F/pXE;EACE,cAAA;EACA,yHAAA;EAMA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;A1F4pXJ;;A0FvpXA;EACE,mBAAA;A1F0pXF;A0FxpXE;EACE,mBAAA;A1F0pXJ;;A0FtpXA;EACE,mBAAA;A1FypXF;A0FvpXE;EACE,yBAAA;A1FypXJ;A0FtpXE;EACE,mBAAA;A1FwpXJ;A0FppXI;;EAEE,ctFtLE;EsFuLF,mBtFhLK;AJs0XX;;AgB/wXI;E0EoII;IACE,QAAA;IACA,WAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;IACA,gBAAA;E1F+oXR;E0F1oXM;IACE,mBAAA;E1F4oXR;AACF;A0FtoXA;EACE,aAAA;EACA,cAAA;A1FwoXF;;A0FroXA;EACE,qCAAA;EACA;IACE,uBAAA;IACA,yEAAA;IACA,kDAAA;E1FwoXF;AACF;A0FroXA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;A1FuoXF;;A0FpoXA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;A1FuoXF;;A0F9nXI;EACE,uDAAA;A1FioXN;A0F/nXI;EACE,OAAA;EACA,WAAA;A1FioXN;;AgBz0XI;E0E+MA;IACE,0EAAA;IAGA,qBAAA;IACA,qBAAA;E1F4nXJ;AACF;A0FxnXA,kDAAA;AAeA,cAAA;AAEA;EAVQ;IACE,iBAUwB;E1F4mXhC;AACF;A0F1mXA,sCAAA;AAEA,cAAA;AAEA;EAlBQ;IACE,iBAkBwB;E1F2mXhC;AACF;A0FxmXA;EAEI;IACE,OAAA;E1FymXJ;;E0FnmXI;IACE,oBAAA;IACA,qBAAA;E1FsmXN;AACF;A0FjmXA;EACE;IACE,2BAAA;E1FmmXF;AACF;A2Fn7XM;EACE,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,cvF6GK;EuF5GL,sBvF+bkB;EuF9blB,qBAAA;A3Fq7XR;A2F16XA,uBAAA;AAGI;EACE,YAAA;A3F06XN;;A2Fp6XI;EACE,YAAA;EACA,kBAAA;EACA,SAAA;A3Fu6XN;;A2Fj6XI;EACE,YAAA;A3Fo6XN;;A2F95XI;EACE,YAAA;A3Fi6XN;;A2F35XI;EACE,YAAA;A3F85XN;;A2Fp5XA;EACE;IACE,aAAA;E3Fu5XF;;E2Fp5XE;IACE,4BAAA;E3Fu5XJ;AACF;A4F79XA;EACE,cxFOM;AJw9XR;A4F79XI;EACE,cAAA;A5F+9XN;A4F59XI;EACE,cAAA;A5F89XN;A4Fx9XM;;;;;EAGE,wBAAA;A5F49XR;A4F19XM;;;EAEE,sBAAA;A5F69XR;A4F39XM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;A5F69XR;A4Fz9XM;EACE,cxFmFK;AJw4Xb;A4Ft9XE;;EAEE,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;A5Fw9XJ;A4Fp9XE;EACE,gBAAA;A5Fs9XJ;A4Fj9XE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;A5Fm9XJ;A4Fl9XI;EACE,eAAA;EACA,iBAAA;A5Fo9XN;;A4F78XE;;EAEE,eAAA;EACA,iBAAA;A5Fg9XJ;;A4F18XE;EACE,eAAA;A5F68XJ;;A6FjiYA;EACE,uBAAA;A7FoiYF;A6F9hYU;EACE,czF2BG;AJqgYf;A6FxhYE;EChBA,WAAA;A9F2iYF;A8FziYE;EACE,SAAA;EACA,UAAA;A9F2iYJ;;A6FzhYA;EACE,uBAAA;EACA,kBAAA;A7F4hYF;A6FzhYE;EC3BA,WAAA;A9FujYF;A8FrjYE;EACE,SAAA;EACA,UAAA;A9FujYJ;;A6F1hYA;EACE,gBAAA;A7F6hYF;A6F1hYI;EACE,WAAA;EACA,cAAA;EACA,sBAAA;A7F4hYN;A6FzhYQ;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;A7F2hYV;A6F1hYU;EACE,cAAA;A7F4hYZ;A6FrhYI;EACE,YAAA;EACA,cAAA;EACA,qBAAA;A7FuhYN;A6FphYQ;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;A7FshYV;A6FrhYU;EACE,cAAA;A7FuhYZ;;A+F1lYE;EACE,mBAAA;EACA,WAAA;EACA,aAAA;A/F6lYJ;A+F5lYI;EACE,sBAAA;A/F8lYN;A+F5lYI;EACE,qBAAA;A/F8lYN;A+F3lYE;EACE,yBAAA;A/F6lYJ;;A+FxlYE;EACE,6BAAA;A/F2lYJ;;AgGhnYA;;;;;;;;2FAAA;AAYE;EACE,gBAAA;AhGgnYJ;AgG9mYE;EACE,iC5FgbqB;E4F/arB,oC5F+aqB;AJisXzB;;AiG/nYA;;;;;;;iGAAA;AAYE;EACE,qBAAA;AjG8nYJ;AiG1nYI;EACE,cAAA;EACA,kBAAA;AjG4nYN;;AiGrnYE;EACE,gBAAA;AjGwnYJ;AiGtnYM;EACE,yB7FOO;AJinYf;AiGtnYM;EAEE,UAAA;AjGunYR;AiGtnYQ;EACE,c7F3BF;AJmpYR;AiGrnYM;EACE,yBAAA;AjGunYR;AiGpnYI;EACE,yB7FuEI;AJ+iYV;AiGnnYI;;EAEE,kBAAA;AjGqnYN;AiGlnYI;EACE,cAAA;AjGonYN;AiGhnYI;EACE,yB7FrBS;E6FsBT,c7FlDE;AJoqYR;AiGjnYM;EACE,yB7FxBO;AJ2oYf;AiGhnYI;EACE,yB7FkDI;E6FjDJ,UAAA;AjGknYN;AiG7mYE;EACE,YAAA;AjG+mYJ;AiG9mYI;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;AjGgnYN;AiG/mYM;EACE,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,c7FkCK;E6FjCL,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;AjGinYR;AiG/mYM;EACE,6BAAA;AjGinYR;;AiG1mYA;EACE,gBAAA;AjG6mYF;;AkG7sYE;EACE,gBAAA;EACA,oBAAA;AlGgtYJ;AkG9sYE;EACE,gBAAA;AlGgtYJ;AkG/sYI;EACE,gBAAA;AlGitYN;AkG/sYI;EACE,gCAAA;AlGitYN;AkG/sYI;EACE,eAAA;EACA,2CAAA;AlGitYN;AkG/sYI;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;AlGitYN;;AkG3sYA;EACE,cAAA;AlG8sYF;AkG7sYE;EACE,cAAA;AlG+sYJ;;AkGzsYE;EACE,aAAA;AlG4sYJ;AkG1sYE;EACE,gBAAA;AlG4sYJ;AkG1sYE;EACE,gBAAA;AlG4sYJ;;AkGrsYE;EACE,yBAAA;AlGwsYJ;AkGvsYI;EACE,gBAAA;EACA,6BAAA;EACA,4BAAA;AlGysYN;AkGvsYI;EACE,yBAAA;EACA,0BAAA;AlGysYN;;AkGnsYA;EACE,6CAAA;EACA,8BAAA;EACA,wB9FwEc;AJ8nYhB;AkGrsYE;EACE,gBAAA;EACA,yDACE;AlGssYN;AkGpsYI;EACE,0BAAA;EACA,cAAA;EACA,SAAA;EACA,4DAAA;AlGssYN;AkGnsYE;EACE,mCAAA;EACA,oCAAA;AlGqsYJ;AkGnsYE;EACE,sCAAA;EACA,uCAAA;AlGqsYJ;;AkG/rYE;EACE,sBAAA;EACA,yBAAA;EACA,0DAAA;EACA,yBAAA;EACA,6CAAA;AlGksYJ;AkGhsYE;EACE,yBAAA;AlGksYJ;;AkG5rYE;EACE,kBAAA;AlG+rYJ;AkG3rYI;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;AlG6rYN;AkGzrYM;EACE,0DAAA;AlG2rYR;AkGrrYI;EACE,0BAAA;AlGurYN;;AmG7zYA;EACE,uBAAA;AnGg0YF;AmGzzYI;EACE,gBAAA;AnG2zYN;AmGvzYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AnGyzYJ;AmGlzYI;EACE,WAAA;AnGozYN;AmG9yYI;EACE,6BAAA;AnGgzYN;AmG3yYE;EACE,0BAAA;AnG6yYJ;AmG3yYI;EACE,kBAAA;AnG6yYN;AmG3yYM;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,c/FkEK;E+FjEL,UAAA;EACA,YAAA;EACA,WAAA;AnG6yYR;AmG1yYM;EACE,mB/F+Sc;E+F9Sd,c/FrBO;AJi0Yf;AmG1yYM;EAEE,oCAAA;AnG2yYR;AmG1yYQ;EACE,qEAAA;AnG4yYV;AmGtyYQ;EACE,0DAAA;AnGwyYV;AmG/xYI;EACE,gCAAA;EACA,mCAAA;AnGiyYN;AmGhyYM;EACE,2CAAA;EACA,8CAAA;AnGkyYR;AmG9xYI;EACE,iCAAA;EACA,oCAAA;AnGgyYN;AmG/xYM;EACE,4CAAA;EACA,+CAAA;AnGiyYR;AmG5xYE;EACE,yBAAA;AnG8xYJ;AmG5xYI;EACE,kBAAA;AnG8xYN;AmG5xYM;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AnG8xYR;AmG3xYM;EACE,mB/FoPc;E+FnPd,c/FhFO;AJ62Yf;AmG3xYM;EAEE,oCAAA;AnG4xYR;AmG3xYQ;EACE,qEAAA;AnG6xYV;AmGnxYQ;EACE,0DAAA;AnGqxYV;AmGvwYM;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,c/FrCK;E+FsCL,WAAA;EACA,YAAA;EACA,WAAA;AnGywYR;AmGrwYQ;EACE,qEAAA;AnGuwYV;AmG7vYQ;EACE,0DAAA;AnG+vYV;AmGpvYM;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,c/FxEK;E+FyEL,WAAA;EACA,YAAA;EACA,WAAA;AnGsvYR;AmGlvYQ;EACE,qEAAA;AnGovYV;AmG1uYQ;EACE,0DAAA;AnG4uYV;AmGjuYI;EACE,c/FhCO;AJmwYb;AmG7tYE;EACE,YAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AnG+tYJ;AmG9tYI;EACE,gBAAA;AnGguYN;AmG7tYI;EACE,c/FvMS;AJs6Yf;AmG1tYE;EACE,yB/FmHY;E+FlHZ,gBAAA;AnG4tYJ;AmG1tYI;EACE,UAAA;EACA,uBAAA;EACA,yB/FnNS;E+FoNT,yBAAA;EACA,gBAAA;AnG4tYN;AmGrtYI;EACE,iCAAA;EACA,oCAAA;AnGutYN;AmGttYM;EACE,uBAAA;AnGwtYR;AmGrtYI;EACE,iCAAA;EACA,oCAAA;AnGutYN;AmGltYI;EACE,kCAAA;EACA,qCAAA;AnGotYN;AmGntYM;EACE,uBAAA;AnGqtYR;AmGltYI;EACE,kCAAA;EACA,qCAAA;AnGotYN;;AmG1sYM;EACE,kB/F4EkB;E+F3ElB,mBAAA;AnG6sYR;AmGtsYM;EACE,mB/FoEkB;E+FnElB,kBAAA;AnGwsYR;;AoGh/YE;EACE,yBhG6GM;EgG5GN,mBAAA;EACA,4BAAA;EACA,6BAAA;ApGm/YJ;AoGh/YI;EACE,2BAAA;EACA,8CAAA;EACA,wBhG8HU;EgG7HV,mBhGPE;EgGQF,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;ApGk/YN;AoG/+YM;EAGE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;ApG++YR;AoG1+YE;EACE,YAAA;EAEA,iBAAA;EACA,8CAAA;ApG2+YJ;AoGx+YE;EACE,wBhGwbkB;AJkjYtB;AoGt+YE;EACE,SAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;ApGw+YJ;AoGv+YI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ApGy+YN;AoGv+YI;EACE,gCAAA;EACA,iDAAA;EACA,wBhGgFU;AJy5YhB;AoGv+YI;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;ApGy+YN;;AoGn+YA;EACE,gBAAA;ApGs+YF;;AoGl+YA;EACE;IACE,eAAA;IACA,gBAAA;EpGq+YF;AACF;AoGj+YA;;EAEE,qBAAA;EACA,2BAAA;ApGm+YF;;AoG/9YE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;ApGk+YJ;AoGh+YI;EACE,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;ApGk+YN;AoG/9YI;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;ApGi+YN;AoG99YI;EAzBF;IA0BI,chGyXiB;EJwmYrB;AACF;AoG/9YI;EACE,gBhGoXoB;AJ6mY1B;AoG99YM;EADF;IAEI,ehGkXkB;EJ+mYxB;AACF;AoG79YE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,ehG8VqB;EgG7VrB,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;ApG+9YJ;;AoG19YA;;EAEE,2BAAA;EACA,mCAAA;ApG69YF;;AoG19YA;;EAEE,mCAAA;EACA,mCAAA;ApG69YF;;AoGx9YA;EACE;IACE,uBAAA;IACA,sBAAA;EpG29YF;EoG19YE;;IAEE,gBAAA;EpG49YJ;EoG19YE;IACE,iCAAA;IACA,qBAAA;IACA,uBAAA;EpG49YJ;AACF;AqGvoZA;EACE,4CjGoamB;EiGnanB,wBAAA;ArGyoZF;AqGvoZE;EhGiEE,qBAAA;EgG/DA,yBAAA;ArGyoZJ;AqGtoZE;EACE,yBAAA;EACA,yBjGHI;EiGIJ,oCjGuZoB;EiGtZpB,qCjGsZoB;AJkvYxB;AqGpoZI;EACE,4BjGkBS;AJonZf;;AqG/nZI;EACE,WAAA;ArGkoZN;;AqG5nZI;EACE,SAAA;ArG+nZN;;AqGznZI;EACE,UAAA;ArG4nZN;;AsG1mZA;EACE,+BAAA;AtG6mZF;AsG1mZW;EACP,4BAAA;EACA,2BAAA;AtG4mZJ;;AsGzmZA;EACE,4BAAA;AtG4mZF;AsG3mZW;EACP,yBAAA;EACA,wBAAA;AtG6mZJ;;AsG1mZA;EACE,+BAAA;AtG6mZF;AsG5mZW;EACP,4BAAA;EACA,2BAAA;AtG8mZJ;;AsG3mZA;EACE,8BAAA;AtG8mZF;AsG7mZW;EACP,2BAAA;EACA,0BAAA;AtG+mZJ;;AsG3mZA;EACE,+BAAA;AtG8mZF;AsG7mZW;EACP,4BAAA;EACA,2BAAA;AtG+mZJ;;AsG5mZA;EACE,6BAAA;AtG+mZF;AsG9mZW;EACP,0BAAA;EACA,yBAAA;AtGgnZJ;;AsG7mZA;EACE,+BAAA;AtGgnZF;AsG/mZW;EACP,4BAAA;EACA,2BAAA;AtGinZJ;;AsG9mZA;EACE,8BAAA;AtGinZF;AsGhnZW;EACP,2BAAA;EACA,0BAAA;AtGknZJ;;AsG/mZA;EACE,+BAAA;AtGknZF;AsGjnZW;EACP,4BAAA;EACA,2BAAA;AtGmnZJ;;AsG/mZA;EACE,6BAAA;AtGknZF;AsGjnZW;EACP,0BAAA;EACA,yBAAA;AtGmnZJ;;AsGhnZA;EACE,8BAAA;AtGmnZF;AsGlnZW;EACP,2BAAA;EACA,0BAAA;AtGonZJ;;AsGjnZA;EACE,4BAAA;AtGonZF;AsGnnZW;EACP,yBAAA;EACA,wBAAA;AtGqnZJ;;AsGlnZA;EACE,8BAAA;AtGqnZF;AsGpnZW;EACP,2BAAA;EACA,0BAAA;AtGsnZJ;;AsGnnZA;EACE,6BAAA;AtGsnZF;AsGrnZW;EACP,0BAAA;EACA,yBAAA;AtGunZJ;;AsGjnZA;EACE,yBAAA;AtGonZF;;AsGlnZA;EACE,2BAAA;AtGqnZF;;AsGnnZA;EACE,+BAAA;AtGsnZF;;AsGjnZA;EACE,wBAAA;AtGonZF;;AsGlnZA;EACE,yBAAA;AtGqnZF;;AsGnnZA;EACE,wBAAA;AtGsnZF;;AsGpnZA;EACE,yBAAA;AtGunZF;;AsGrnZA;EACE,yBAAA;AtGwnZF;;AsGtnZA;EACE,0BAAA;AtGynZF;;AsGlnZA;EACE,4BAAA;AtGqnZF;;AsGnnZA;EACE,gCAAA;AtGsnZF;;AsGpnZA;EACE,mCAAA;AtGunZF;;AsGrnZA;EACE,iCAAA;AtGwnZF;;AsGtnZA;EACE,kCAAA;AtGynZF;;AsGrnZA;EACE,4BAAA;AtGwnZF;;AsGtnZA;EACE,gCAAA;AtGynZF;;AsGvnZA;EACE,mCAAA;AtG0nZF;;AsGxnZA;EACE,iCAAA;AtG2nZF;;AsGznZA;EACE,kCAAA;AtG4nZF;;AsGxnZA;E1FzNI,wBAAA;AZq1ZJ;;AsGznZA;E1F5NI,gBAAA;AZy1ZJ;;AsGrnZA;EACE,0BAAA;AtGwnZF;;AsGtnZA;EACE,qBAAA;AtGynZF;;AsGvnZA;EACE,sBAAA;AtG0nZF;;AsGxnZA;EACE,uBAAA;AtG2nZF;;AsGtnZE;EACE,uBAAA;AtGynZJ;;AsGtnZE;EACE,sBAAA;AtGynZJ;;AsG9nZE;EACE,wBAAA;AtGioZJ;;AsG9nZE;EACE,uBAAA;AtGioZJ;;AsGtoZE;EACE,wBAAA;AtGyoZJ;;AsGtoZE;EACE,uBAAA;AtGyoZJ;;AsG9oZE;EACE,wBAAA;AtGipZJ;;AsG9oZE;EACE,uBAAA;AtGipZJ;;AsGtpZE;EACE,wBAAA;AtGypZJ;;AsGtpZE;EACE,uBAAA;AtGypZJ;;AsG9pZE;EACE,wBAAA;AtGiqZJ;;AsG9pZE;EACE,uBAAA;AtGiqZJ;;AsGtqZE;EACE,wBAAA;AtGyqZJ;;AsGtqZE;EACE,uBAAA;AtGyqZJ;;AsG9qZE;EACE,wBAAA;AtGirZJ;;AsG9qZE;EACE,uBAAA;AtGirZJ;;AsGtrZE;EACE,wBAAA;AtGyrZJ;;AsGtrZE;EACE,uBAAA;AtGyrZJ;;AsG9rZE;EACE,wBAAA;AtGisZJ;;AsG9rZE;EACE,uBAAA;AtGisZJ;;AsGtsZE;EACE,wBAAA;AtGysZJ;;AsGtsZE;EACE,uBAAA;AtGysZJ;;AsG9sZE;EACE,wBAAA;AtGitZJ;;AsG9sZE;EACE,uBAAA;AtGitZJ;;AsGttZE;EACE,wBAAA;AtGytZJ;;AsGttZE;EACE,uBAAA;AtGytZJ;;AsG9tZE;EACE,wBAAA;AtGiuZJ;;AsG9tZE;EACE,uBAAA;AtGiuZJ;;AsGtuZE;EACE,wBAAA;AtGyuZJ;;AsGtuZE;EACE,uBAAA;AtGyuZJ;;AsG9uZE;EACE,wBAAA;AtGivZJ;;AsG9uZE;EACE,uBAAA;AtGivZJ;;AsG3uZE;EACE,qBAAA;AtG8uZJ;;AsG3uZE;EACE,oBAAA;AtG8uZJ;;AsGnvZE;EACE,sBAAA;AtGsvZJ;;AsGnvZE;EACE,qBAAA;AtGsvZJ;;AsG3vZE;EACE,sBAAA;AtG8vZJ;;AsG3vZE;EACE,qBAAA;AtG8vZJ;;AsGnwZE;EACE,sBAAA;AtGswZJ;;AsGnwZE;EACE,qBAAA;AtGswZJ;;AsG3wZE;EACE,sBAAA;AtG8wZJ;;AsG3wZE;EACE,qBAAA;AtG8wZJ;;AsGnxZE;EACE,sBAAA;AtGsxZJ;;AsGnxZE;EACE,qBAAA;AtGsxZJ;;AsG3xZE;EACE,sBAAA;AtG8xZJ;;AsG3xZE;EACE,qBAAA;AtG8xZJ;;AsGnyZE;EACE,sBAAA;AtGsyZJ;;AsGnyZE;EACE,qBAAA;AtGsyZJ;;AsG3yZE;EACE,sBAAA;AtG8yZJ;;AsG3yZE;EACE,qBAAA;AtG8yZJ;;AsGnzZE;EACE,sBAAA;AtGszZJ;;AsGnzZE;EACE,qBAAA;AtGszZJ;;AsG3zZE;EACE,sBAAA;AtG8zZJ;;AsG3zZE;EACE,qBAAA;AtG8zZJ;;AsGn0ZE;EACE,sBAAA;AtGs0ZJ;;AsGn0ZE;EACE,qBAAA;AtGs0ZJ;;AsG30ZE;EACE,sBAAA;AtG80ZJ;;AsG30ZE;EACE,qBAAA;AtG80ZJ;;AsGn1ZE;EACE,sBAAA;AtGs1ZJ;;AsGn1ZE;EACE,qBAAA;AtGs1ZJ;;AsG31ZE;EACE,sBAAA;AtG81ZJ;;AsG31ZE;EACE,qBAAA;AtG81ZJ;;AsGn2ZE;EACE,sBAAA;AtGs2ZJ;;AsGn2ZE;EACE,qBAAA;AtGs2ZJ;;AsG32ZE;EACE,sBAAA;AtG82ZJ;;AsG32ZE;EACE,qBAAA;AtG82ZJ;;AsGn3ZE;EACE,sBAAA;AtGs3ZJ;;AsGn3ZE;EACE,qBAAA;AtGs3ZJ;;AsG33ZE;EACE,sBAAA;AtG83ZJ;;AsG33ZE;EACE,qBAAA;AtG83ZJ;;AsGx3ZA;EACE,MAAA;AtG23ZF;;AsGz3ZA;EACE,QAAA;AtG43ZF;;AsG13ZA;EACE,SAAA;AtG63ZF;;AsG33ZA;EACE,OAAA;AtG83ZF;;AsGz3ZA;EACE,iBAAA;AtG43ZF;;AsG13ZA;EACE,gBAAA;AtG63ZF;;AsG33ZA;EACE,gBAAA;AtG83ZF;;AsG53ZA;EACE,gBAAA;AtG+3ZF;;AsG13ZA;EACE,eAAA;AtG63ZF;;AsG33ZA;EACE,YAAA;AtG83ZF;;AsG53ZA;EACE,eAAA;AtG+3ZF;;AsG73ZA;EACE,gBAAA;AtGg4ZF;;AsG93ZA;EACE,mBAAA;AtGi4ZF;;AsG53ZA;EACE,qBAAA;AtG+3ZF;;AsG73ZA;EACE,qBAAA;AtGg4ZF;;AsG93ZA;EACE,qBAAA;AtGi4ZF;;AsG/3ZA;EACE,qBAAA;AtGk4ZF;;AsGh4ZA;EACE,qBAAA;AtGm4ZF;;AsGj4ZA;EACE,sBAAA;AtGo4ZF;;AsGl4ZA;EACE,sBAAA;AtGq4ZF;;AsGn4ZA;EACE,sBAAA;AtGs4ZF;;AsGp4ZA;EACE,sBAAA;AtGu4ZF;;AsGl4ZA;EACE,2BAAA;AtGq4ZF;;AsGn4ZA;EACE,mFACE;AtGq4ZJ;;AsGl4ZA;EACE,mFACE;AtGo4ZJ;;AsGj4ZA;EACE,sFACE;AtGm4ZJ;;AsGh4ZA;EACE,sFACE;AtGk4ZJ;;AsG/3ZA;EACE,qFACE;AtGi4ZJ;;AsG93ZA;EACE,kFACE;AtGg4ZJ;;AsG13ZA;EACE,wBAAA;AtG63ZF;;AsGx3ZA;EACE,kBAAA;AtG23ZF;;AsGz3ZA;EACE,kBAAA;AtG43ZF;;AsG13ZA;EACE,kBAAA;AtG63ZF;;AsGx3ZA;EACE,iCAAA;AtG23ZF;;AsGz3ZA;EACE,oCAAA;AtG43ZF;;AsG13ZA;EACE,uCAAA;AtG63ZF;;AsGx3ZA;EACE,clGjaM;EkGkaN,kBAAA;EACA,kBAAA;AtG23ZF;;AsGz3ZA;EACE,uBAAA;AtG43ZF;;AsG13ZA;EACE,uBAAA;AtG63ZF;;AsGz3ZA;EACE,wBAAA;AtG43ZF;;AsG13ZA;;EAEE,wBAAA;AtG63ZF;;AsG13ZA;EACE,aAAA;EACA,kBAAA;AtG63ZF;;AsGz3ZE;EACE,eAAA;AtG43ZJ;;AsGr3ZE;EACE,sBAAA;AtGw3ZJ;;AsGl3ZA;EACE,kBAAA;AtGq3ZF;;AsGh3ZA;EACE,oBAAA;AtGm3ZF;;AuG/xaM;EACE,oCAAA;AvGkyaR;AuGhyaQ;;EAEE,6BAAA;AvGkyaV;;AuGruaM;EACE,oCAAA;AvGwuaR;;AuGruaM;EACE,6BAAA;AvGwuaR;;AuGruaM;EACE,gCAAA;AvGwuaR;;AuGruaM;EACE,8BAAA;AvGwuaR;;AuGruaM;EACE,+BAAA;AvGwuaR;;AuGjuaQ;;;EACE,gCAAA;AvGsuaV;;AuGttaM;EC1JJ,mBCiHO;EDjHa,iBAAA;AxGq3atB;;AuGz8ZM;EACE,0EACE;AvG28ZV;;AuG10aM;EACE,oCAAA;AvG60aR;AuG30aQ;;EAEE,6BAAA;AvG60aV;;AuGhxaM;EACE,oCAAA;AvGmxaR;;AuGhxaM;EACE,6BAAA;AvGmxaR;;AuGhxaM;EACE,gCAAA;AvGmxaR;;AuGhxaM;EACE,8BAAA;AvGmxaR;;AuGhxaM;EACE,+BAAA;AvGmxaR;;AuG5waQ;;;EACE,gCAAA;AvGixaV;;AuGjwaM;EC1JJ,mBCiHO;EDjHa,iBAAA;AxGg6atB;;AuGp/ZM;EACE,0EACE;AvGs/ZV;;AuGr3aM;EACE,oCAAA;AvGw3aR;AuGt3aQ;;EAEE,6BAAA;AvGw3aV;;AuGl3aQ;EAEE,yBAAA;AvGo3aV;AuGz2aU;EACE,yBAAA;AvG22aZ;;AuGl0aM;EACE,oCAAA;AvGq0aR;;AuGl0aM;EACE,6BAAA;AvGq0aR;;AuGl0aM;EACE,gCAAA;AvGq0aR;;AuGl0aM;EACE,8BAAA;AvGq0aR;;AuGl0aM;EACE,+BAAA;AvGq0aR;;AuG9zaQ;;;EACE,gCAAA;AvGm0aV;;AuG3zaU;EAEE,yBAAA;AvG6zaZ;;AuGvzaM;EC1JJ,mBCiHO;EDjHa,iBAAA;AxGs9atB;;AuG9xaQ;EACE,6BAAA;EACA,cEzED;AzG02aT;AuG/xaU;EACE,cE5EH;AzG62aT;AuG1xaU;EAIE,cEvFH;AzGg3aT;AuGtxaU;EACE,0DAAA;AvGwxaZ;;AuGjxaQ;EACE,yBEnGD;EFoGC,kDAAA;EACA,cnG5MF;EmG6ME,yBAAA;AvGoxaV;AuGlxaY;EACE,yBAAA;AvGoxad;AuG7waU;EAGE,yBAAA;AvG6waZ;AuG1waU;EACE,cnG9NJ;AJ0+aR;AuG1waU;EAEE,aAAA;EACA,gBAAA;EACA,0BAAA;AvG2waZ;;AuGpwaQ;EACE,oCAAA;EACA,6BAAA;EACA,cEvID;AzG84aT;AuGrwaU;EAEE,cE3IH;AzGi5aT;AuGpwaU;EACE,gBAAA;AvGswaZ;AuGpwaU;EAIE,cEpJH;AzGu5aT;AuGhwaU;EACE,0DAAA;AvGkwaZ;AuG/vaU;EAEE,cE7JH;AzG65aT;;AuGtuaU;EACE,yBExLH;AzGi6aT;;AuG/tac;EACE,cEnMP;AzGq6aT;AuGhuac;EACE,yBAAA;AvGkuahB;;AuGxpaU;EACE,yBEjRH;AzG46aT;;AuGnpaU;EACE,gCAAA;AvGspaZ;AuGppaY;;EAEE,0BAAA;AvGspad;AuGnpaY;EACE,oCAAA;AvGqpad;AuGxoaY;EAEE,gCAAA;AvGyoad;;AuG/naM;EACE,0EACE;AvGioaV;;AuG1naU;;EAEE,qBEtUH;EFuUG,yBEvUH;AzGo8aT;AuGnnaU;EAEE,YAAA;EACA,2BAAA;AvGonaZ;AuGlnaU;EACE,qBEvVH;AzG28aT;;AuG5maU;EACE,oCAAA;EACA,cnGxcJ;EmGycI,6BAAA;AvG+maZ;;AuGrmac;EACE,8BAAA;EACA,gCAAA;AvGwmahB;;AuGjmaM;EACE,yBAAA;AvGomaR;;AuGjmaM;EACE,oCAAA;AvGomaR;;AuGjmaM;EACE,oCAAA;AvGomaR;;AuGjmaM;EACE,wCAAA;AvGomaR;;AuGjmaM;EACE,2CAAA;AvGomaR;;AuGjmaM;EACE,yCAAA;AvGomaR;;AuGjmaM;EACE,0CAAA;AvGomaR;;AuGjmaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGwmbtB;;AuGloaM;EACE,yBAAA;AvGqoaR;;AuGloaM;EACE,oCAAA;AvGqoaR;;AuGloaM;EACE,oCAAA;AvGqoaR;;AuGloaM;EACE,wCAAA;AvGqoaR;;AuGloaM;EACE,2CAAA;AvGqoaR;;AuGloaM;EACE,yCAAA;AvGqoaR;;AuGloaM;EACE,0CAAA;AvGqoaR;;AuGloaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGyobtB;;AuGnqaM;EACE,yBAAA;AvGsqaR;;AuGnqaM;EACE,oCAAA;AvGsqaR;;AuGnqaM;EACE,oCAAA;AvGsqaR;;AuGnqaM;EACE,wCAAA;AvGsqaR;;AuGnqaM;EACE,2CAAA;AvGsqaR;;AuGnqaM;EACE,yCAAA;AvGsqaR;;AuGnqaM;EACE,0CAAA;AvGsqaR;;AuGnqaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG0qbtB;;AuG3nbM;EACE,oCAAA;AvG8nbR;AuG5nbQ;;EAEE,6BAAA;AvG8nbV;;AuGjkbM;EACE,oCAAA;AvGokbR;;AuGjkbM;EACE,6BAAA;AvGokbR;;AuGjkbM;EACE,gCAAA;AvGokbR;;AuGjkbM;EACE,8BAAA;AvGokbR;;AuGjkbM;EACE,+BAAA;AvGokbR;;AuG7jbQ;;;EACE,gCAAA;AvGkkbV;;AuGljbM;EC1JJ,mBCiHO;EDjHa,iBAAA;AxGitbtB;;AuGryaM;EACE,0EACE;AvGuyaV;;AuG/uaM;EACE,yBAAA;AvGkvaR;;AuG/uaM;EACE,oCAAA;AvGkvaR;;AuG/uaM;EACE,oCAAA;AvGkvaR;;AuG/uaM;EACE,wCAAA;AvGkvaR;;AuG/uaM;EACE,2CAAA;AvGkvaR;;AuG/uaM;EACE,yCAAA;AvGkvaR;;AuG/uaM;EACE,0CAAA;AvGkvaR;;AuG/uaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGsvbtB;;AuGhxaM;EACE,yBAAA;AvGmxaR;;AuGhxaM;EACE,oCAAA;AvGmxaR;;AuGhxaM;EACE,oCAAA;AvGmxaR;;AuGhxaM;EACE,wCAAA;AvGmxaR;;AuGhxaM;EACE,2CAAA;AvGmxaR;;AuGhxaM;EACE,yCAAA;AvGmxaR;;AuGhxaM;EACE,0CAAA;AvGmxaR;;AuGhxaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGuxbtB;;AuGjzaM;EACE,yBAAA;AvGozaR;;AuGjzaM;EACE,oCAAA;AvGozaR;;AuGjzaM;EACE,oCAAA;AvGozaR;;AuGjzaM;EACE,wCAAA;AvGozaR;;AuGjzaM;EACE,2CAAA;AvGozaR;;AuGjzaM;EACE,yCAAA;AvGozaR;;AuGjzaM;EACE,0CAAA;AvGozaR;;AuGjzaM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGwzbtB;;AuGl1aM;EACE,yBAAA;AvGq1aR;;AuGl1aM;EACE,oCAAA;AvGq1aR;;AuGl1aM;EACE,oCAAA;AvGq1aR;;AuGl1aM;EACE,wCAAA;AvGq1aR;;AuGl1aM;EACE,2CAAA;AvGq1aR;;AuGl1aM;EACE,yCAAA;AvGq1aR;;AuGl1aM;EACE,0CAAA;AvGq1aR;;AuGl1aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGy1btB;;AuGn3aM;EACE,yBAAA;AvGs3aR;;AuGn3aM;EACE,oCAAA;AvGs3aR;;AuGn3aM;EACE,oCAAA;AvGs3aR;;AuGn3aM;EACE,wCAAA;AvGs3aR;;AuGn3aM;EACE,2CAAA;AvGs3aR;;AuGn3aM;EACE,yCAAA;AvGs3aR;;AuGn3aM;EACE,0CAAA;AvGs3aR;;AuGn3aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG03btB;;AuGp5aM;EACE,yBAAA;AvGu5aR;;AuGp5aM;EACE,oCAAA;AvGu5aR;;AuGp5aM;EACE,oCAAA;AvGu5aR;;AuGp5aM;EACE,wCAAA;AvGu5aR;;AuGp5aM;EACE,2CAAA;AvGu5aR;;AuGp5aM;EACE,yCAAA;AvGu5aR;;AuGp5aM;EACE,0CAAA;AvGu5aR;;AuGp5aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG25btB;;AuGr7aM;EACE,yBAAA;AvGw7aR;;AuGr7aM;EACE,oCAAA;AvGw7aR;;AuGr7aM;EACE,oCAAA;AvGw7aR;;AuGr7aM;EACE,wCAAA;AvGw7aR;;AuGr7aM;EACE,2CAAA;AvGw7aR;;AuGr7aM;EACE,yCAAA;AvGw7aR;;AuGr7aM;EACE,0CAAA;AvGw7aR;;AuGr7aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG47btB;;AuGt9aM;EACE,yBAAA;AvGy9aR;;AuGt9aM;EACE,oCAAA;AvGy9aR;;AuGt9aM;EACE,oCAAA;AvGy9aR;;AuGt9aM;EACE,wCAAA;AvGy9aR;;AuGt9aM;EACE,2CAAA;AvGy9aR;;AuGt9aM;EACE,yCAAA;AvGy9aR;;AuGt9aM;EACE,0CAAA;AvGy9aR;;AuGt9aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG69btB;;AuGv/aM;EACE,yBAAA;AvG0/aR;;AuGv/aM;EACE,oCAAA;AvG0/aR;;AuGv/aM;EACE,oCAAA;AvG0/aR;;AuGv/aM;EACE,wCAAA;AvG0/aR;;AuGv/aM;EACE,2CAAA;AvG0/aR;;AuGv/aM;EACE,yCAAA;AvG0/aR;;AuGv/aM;EACE,0CAAA;AvG0/aR;;AuGv/aM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG8/btB;;AuGxhbM;EACE,yBAAA;AvG2hbR;;AuGxhbM;EACE,oCAAA;AvG2hbR;;AuGxhbM;EACE,oCAAA;AvG2hbR;;AuGxhbM;EACE,wCAAA;AvG2hbR;;AuGxhbM;EACE,2CAAA;AvG2hbR;;AuGxhbM;EACE,yCAAA;AvG2hbR;;AuGxhbM;EACE,0CAAA;AvG2hbR;;AuGxhbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxG+hctB;;AuGzjbM;EACE,yBAAA;AvG4jbR;;AuGzjbM;EACE,oCAAA;AvG4jbR;;AuGzjbM;EACE,oCAAA;AvG4jbR;;AuGzjbM;EACE,wCAAA;AvG4jbR;;AuGzjbM;EACE,2CAAA;AvG4jbR;;AuGzjbM;EACE,yCAAA;AvG4jbR;;AuGzjbM;EACE,0CAAA;AvG4jbR;;AuGzjbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGgkctB;;AuG1lbM;EACE,yBAAA;AvG6lbR;;AuG1lbM;EACE,oCAAA;AvG6lbR;;AuG1lbM;EACE,oCAAA;AvG6lbR;;AuG1lbM;EACE,wCAAA;AvG6lbR;;AuG1lbM;EACE,2CAAA;AvG6lbR;;AuG1lbM;EACE,yCAAA;AvG6lbR;;AuG1lbM;EACE,0CAAA;AvG6lbR;;AuG1lbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGimctB;;AuG3nbM;EACE,yBAAA;AvG8nbR;;AuG3nbM;EACE,oCAAA;AvG8nbR;;AuG3nbM;EACE,oCAAA;AvG8nbR;;AuG3nbM;EACE,wCAAA;AvG8nbR;;AuG3nbM;EACE,2CAAA;AvG8nbR;;AuG3nbM;EACE,yCAAA;AvG8nbR;;AuG3nbM;EACE,0CAAA;AvG8nbR;;AuG3nbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGkoctB;;AuG5pbM;EACE,yBAAA;AvG+pbR;;AuG5pbM;EACE,oCAAA;AvG+pbR;;AuG5pbM;EACE,oCAAA;AvG+pbR;;AuG5pbM;EACE,wCAAA;AvG+pbR;;AuG5pbM;EACE,2CAAA;AvG+pbR;;AuG5pbM;EACE,yCAAA;AvG+pbR;;AuG5pbM;EACE,0CAAA;AvG+pbR;;AuG5pbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGmqctB;;AuG7rbM;EACE,yBAAA;AvGgsbR;;AuG7rbM;EACE,oCAAA;AvGgsbR;;AuG7rbM;EACE,oCAAA;AvGgsbR;;AuG7rbM;EACE,wCAAA;AvGgsbR;;AuG7rbM;EACE,2CAAA;AvGgsbR;;AuG7rbM;EACE,yCAAA;AvGgsbR;;AuG7rbM;EACE,0CAAA;AvGgsbR;;AuG7rbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGosctB;;AuG9tbM;EACE,yBAAA;AvGiubR;;AuG9tbM;EACE,oCAAA;AvGiubR;;AuG9tbM;EACE,oCAAA;AvGiubR;;AuG9tbM;EACE,wCAAA;AvGiubR;;AuG9tbM;EACE,2CAAA;AvGiubR;;AuG9tbM;EACE,yCAAA;AvGiubR;;AuG9tbM;EACE,0CAAA;AvGiubR;;AuG9tbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGquctB;;AuG/vbM;EACE,yBAAA;AvGkwbR;;AuG/vbM;EACE,oCAAA;AvGkwbR;;AuG/vbM;EACE,oCAAA;AvGkwbR;;AuG/vbM;EACE,wCAAA;AvGkwbR;;AuG/vbM;EACE,2CAAA;AvGkwbR;;AuG/vbM;EACE,yCAAA;AvGkwbR;;AuG/vbM;EACE,0CAAA;AvGkwbR;;AuG/vbM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGswctB;;AuGhybM;EACE,yBAAA;AvGmybR;;AuGhybM;EACE,oCAAA;AvGmybR;;AuGhybM;EACE,oCAAA;AvGmybR;;AuGhybM;EACE,wCAAA;AvGmybR;;AuGhybM;EACE,2CAAA;AvGmybR;;AuGhybM;EACE,yCAAA;AvGmybR;;AuGhybM;EACE,0CAAA;AvGmybR;;AuGhybM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGuyctB;;AuGj0bM;EACE,yBAAA;AvGo0bR;;AuGj0bM;EACE,oCAAA;AvGo0bR;;AuGj0bM;EACE,oCAAA;AvGo0bR;;AuGj0bM;EACE,wCAAA;AvGo0bR;;AuGj0bM;EACE,2CAAA;AvGo0bR;;AuGj0bM;EACE,yCAAA;AvGo0bR;;AuGj0bM;EACE,0CAAA;AvGo0bR;;AuGj0bM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGw0ctB;;AuGl2bM;EACE,yBAAA;AvGq2bR;;AuGl2bM;EACE,oCAAA;AvGq2bR;;AuGl2bM;EACE,oCAAA;AvGq2bR;;AuGl2bM;EACE,wCAAA;AvGq2bR;;AuGl2bM;EACE,2CAAA;AvGq2bR;;AuGl2bM;EACE,yCAAA;AvGq2bR;;AuGl2bM;EACE,0CAAA;AvGq2bR;;AuGl2bM;EClgBJ,mBCiHO;EDjHa,iBAAA;AxGy2ctB;;A0G50cQ;;EAEE,ctGrBF;EsGsBE,yBAAA;EnFNR,0DAAA;EACA,2BAAA;EmFeU,yBAAA;A1Gw0cZ;A0G50cY;;EnFZV,0DAAA;EACA,2BAAA;EmFaY,yBAAA;A1Gg1cd;A0Gv0cU;;;EAEE,ctGzCJ;AJm3cR;A0Gx0cU;;EACE,2BAAA;A1G20cZ;A0Gz0cU;;EACE,wBAAA;A1G40cZ;A0G10cU;;;EnFjCR,0DAAA;EACA,2BAAA;EmFqCU,yBAAA;A1G40cZ;;A2G73cA;EAEE,YAAA;EACA,0BAAA;EAkWA;;KAAA;A3GgicF;A2Gj4cE;EACE,erBJa;EqBKb,YAAA;EACA,yBvG8FM;EuG7FN,crBNa;AtFy4cjB;A2Gj4cI;EACE,sBAAA;A3Gm4cN;A2Gh4cE;EACE,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mCAAA;EACA,kBrBakB;AtFq3ctB;A2Gj4cI;EACE,uDAAA;A3Gm4cN;A2Gj4cQ;EACE,WAAA;EACA,UAAA;A3Gm4cV;A2Gl4cU;EACE,aAAA;A3Go4cZ;A2Gh4cM;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,eAAA;EACA,gCACE;EAEF,WAAA;A3Gg4cR;A2G93cM;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;A3Gg4cR;A2G/3cQ;;EAEE,YAAA;A3Gi4cV;A2G73cI;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;A3G+3cN;A2G93cM;EACE,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,uCAAA;EACA,yBAAA;A3Gg4cR;A2G53cM;EACE,gBAAA;EACA,cvGhFG;EuGiFH,uBvGjBC;EuGkBD,+BAAA;A3G83cR;A2G13cU;EACE,aAAA;A3G43cZ;A2G13cU;;EAEE,eAAA;A3G43cZ;A2Gz3cQ;EACE,eAAA;A3G23cV;A2G13cU;;EAEE,gBvG6CK;EuG5CL,evG4CK;AJg1cjB;A2Gh3cQ;;EC7EN,4FAAA;EAMA,2GAAA;A5G47cF;AgB36cI;E2FsDI;;ICnDF,qHAAA;IAMA,oIAAA;E5Gw6cJ;AACF;A2G/2cQ;;EC1FN,sFAAA;EAMA,qGAAA;A5Gw8cF;AgBv7cI;E2FmEI;;IChEF,+GAAA;IAMA,8HAAA;E5Go7cJ;AACF;A2G52cQ;;ECzGN,4FAAA;EAMA,2GAAA;A5Go9cF;AgBn8cI;E2FkFI;;IC/EF,qHAAA;IAMA,oIAAA;E5Gg8cJ;AACF;A2Gv2cI;EACE,6CAAA;A3Gy2cN;A2Gr2cQ;;EC/HN,mFAAA;EAMA,kGAAA;A5Gm+cF;AgBl9cI;E2FwGI;;ICrGF,4GAAA;IAMA,2HAAA;E5G+8cJ;AACF;A2Gz2cQ;;ECvIN,6EAAA;EAMA,4FAAA;A5G++cF;AgB99cI;E2FgHI;;IC7GF,sGAAA;IAMA,qHAAA;E5G29cJ;AACF;A2Gt2cQ;;ECtJN,mFAAA;EAMA,kGAAA;A5G2/cF;AgB1+cI;E2F+HI;;IC5HF,4GAAA;IAMA,2HAAA;E5Gu+cJ;AACF;A2Gj2cI;EACE,MAAA;A3Gm2cN;A2Gj2cI;EACE,oDAAA;A3Gm2cN;A2Gj2cI;EACE,kCAAA;A3Gm2cN;A2G/1cQ;;EClLN,uFAAA;EAMA,sGAAA;A5GghdF;AgB//cI;E2F2JI;;ICxJF,gHAAA;IAMA,+HAAA;E5G4/cJ;AACF;A2Gn2cQ;;EC1LN,iFAAA;EAMA,gGAAA;A5G4hdF;AgB3gdI;E2FmKI;;IChKF,0GAAA;IAMA,yHAAA;E5GwgdJ;AACF;A2Gh2cQ;;ECzMN,uFAAA;EAMA,sGAAA;A5GwidF;AgBvhdI;E2FkLI;;IC/KF,gHAAA;IAMA,+HAAA;E5GohdJ;AACF;A2G31cI;EACE,mDAAA;A3G61cN;A2Gz1cQ;;EC/NN,uFAAA;EAMA,sGAAA;A5GujdF;AgBtidI;E2FwMI;;ICrMF,gHAAA;IAMA,+HAAA;E5GmidJ;AACF;A2G71cQ;;ECvON,iFAAA;EAMA,gGAAA;A5GmkdF;AgBljdI;E2FgNI;;IC7MF,0GAAA;IAMA,yHAAA;E5G+idJ;AACF;A2G11cQ;;ECtPN,uFAAA;EAMA,sGAAA;A5G+kdF;AgB9jdI;E2F+NI;;IC5NF,gHAAA;IAMA,+HAAA;E5G2jdJ;AACF;A2Gn1cM;;EACE,oBAAA;EACA,qBAAA;A3Gs1cR;A2Gn1cY;;EACE,UAAA;EACA,QAAA;A3Gs1cd;A2G30cM;EACE,qCAAA;A3G60cR;A2Gt0cI;EAOE,WAAA;EACA,kBAAA;A3Gk0cN;A2Gx0cM;EACE,oEAAA;A3G00cR;A2Gn0cI;;EAEE,2BAAA;A3Gq0cN;A2Gh0cM;EACE,sBAAA;A3Gk0cR;A2Gh0cM;EACE,0EAAA;A3Gk0cR;A2G/zcQ;EACE,mFAAA;A3Gi0cV;A2GrzcI;EACE,cAAA;A3GuzcN;A2GrzcM;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;A3GuzcR;A2GrzcQ;EACE,aAAA;A3GuzcV;A2GlzcI;EACE,qBAAA;A3GozcN;A2GlzcM;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,uBAAA;A3GozcR;A2G9ycI;EACE,mBvGjXS;AJiqdf;;A2G3ycA;EACE,gBAAA;A3G8ycF;;A2G3ycA;;CAAA;A3FrWI;E2F4WA;IACE,2CAAA;IACA,YAAA;E3G2ycJ;E2GzycE;IACE,2CAAA;IACA,WAAA;E3G2ycJ;E2GxycE;IACE,WAAA;E3G0ycJ;E2GzycI;IACE,YAAA;IACA,mBAAA;E3G2ycN;E2G1ycM;IACE,kCAAA;E3G4ycR;E2GzycI;IACE,WAAA;IACA,oBAAA;E3G2ycN;E2G1ycM;IACE,mCAAA;E3G4ycR;;E2GvycA;IACE,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,wBAAA;E3G0ycF;AACF;AgBzqdI;E2FmYF;IACE,iHAAA;E3GyycF;;E2GpycA;IACE,0FAAA;E3GuycF;;E2GnycA;IACE,qGAAA;E3GsycF;;E2GjycA;IACE,0FAAA;E3GoycF;AACF;AgB1rdI;E2F8ZI;;IACE,sBAAA;IACA,wBAAA;E3GgycR;AACF;A2GzxcA;EACE;IACE,WAAA;E3G2xcF;E2G1xcE;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;E3G4xcJ;AACF;A6GpxdA;;;;;;;2FAAA;AAaA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;A7GixdF;AgBrudI;E6F/CJ;IAOI,mBAAA;E7GixdF;AACF;;A6G/wdA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;A7GkxdF;;A6G/wdA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uCAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;A7GkxdF;A6GjxdE;EACE,UAAA;EACA,mBAAA;EACA,yBAAA;A7GmxdJ;;A6G/wdA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A7GkxdF;;A6G9wdE;EACE,YvBJY;AtFqxdhB;;AgBhxdI;E6FIF;IACE,WAAA;E7GgxdF;;E6G9wdA;IACE,YAAA;E7GixdF;AACF;AgB7wdI;E6FCA;IACE,WAAA;E7G+wdJ;AACF;A8G90dE;EACE,uBAAA;EACA,sBxBkBY;EwBjBZ,0BAAA;A9Gg1dJ;A8G50dM;;EAEE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,c1GUF;AJo0dN;A8G30dI;EACE,8BAAA;A9G60dN;A8Gx0dE;EACE,8C1GgHS;AJ0tdb;A8Gx0dE;EACE,6BAAA;A9G00dJ;;A8Gp0dE;EACE,0BAAA;EACA,aAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;A9Gu0dJ;A8Gp0dI;EACE,mB1G3CE;E0G4CF,8C1G6FO;AJyudb;A8Gn0dI;EACE,mB1GzCK;E0G0CL,c1GjDE;AJs3dR;;A8G9zdE;EACE,gCAAA;A9Gi0dJ;;A8G5zdA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;A9G+zdF;;A+G34dA;;;;;;;2FAAA;A/F0DI;E+F3CF;IACE,UAAA;E/Gw4dF;AACF;AgH54dA;EACE,kBAAA;EACA,iB5G+hBS;E4G9hBT,gB5G8hBS;E4G7hBT,kB5GuhBQ;E4GthBR,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,oB5GshBQ;E4GrhBR,yBAAA;EACA,c5GfM;E4GgBN,oBAAA;EACA,gBAAA;AhH84dF;AgH54dE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;AhH84dJ;;AgH14dA;EACE,mBAAA;EACA,yB1B4BU;E0B3BV,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,c5GnCM;E4GoCN,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AhH64dF;AgH14dE;EACE,W1BOU;E0BNV,Y1BMU;E0BLV,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AhH44dJ;AgH34dI;EACE,gBAAA;EACA,eAAA;AhH64dN;AgH14dE;EACE,kBAAA;EACA,W1BNiB;E0BOjB,Y1BPiB;E0BQjB,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;AhH44dJ;AgH34dI;EAEE,W1BbkB;E0BclB,Y1BdkB;E0BelB,iBAAA;AhH44dN;AgHz4dE;EACE,yB5GlDI;AJ67dR;AgHz4dE;EACE,yB5GlDE;AJ67dN;AgHz4dE;EACE,yB5GhDQ;AJ27dZ;AgHz4dE;EACE,yB5GpDK;AJ+7dT;AgHt4dE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,wB5GwCY;AJg2dhB;AgHp4dE;EACE,kBAAA;AhHs4dJ;AgHh4dE;EACE,oBAAA;AhHk4dJ;AgHj4dI;EACE,W1BnDW;E0BoDX,Y1BpDW;AtFu7djB;AgHj4dI;EACE,Y1BvDW;E0BwDX,W1BxDW;E0ByDX,qBAAA;AhHm4dN;AgHl4dM;;;EAGE,gBAAA;EACA,eAAA;EACA,mBAAA;AhHo4dR;AgHj4dI;EACE,UAAA;EACA,SAAA;AhHm4dN;AgHh4dE;EACE,kBAAA;AhHk4dJ;AgHj4dI;EACE,W1BzEW;E0B0EX,Y1B1EW;AtF68djB;AgHj4dI;EACE,W1B7EW;E0B8EX,Y1B9EW;E0B+EX,qBAAA;AhHm4dN;AgHl4dM;;;EAGE,eAAA;EACA,cAAA;EACA,kBAAA;AhHo4dR;AgHj4dI;EACE,UAAA;EACA,WAAA;AhHm4dN;AgH93dI;EACE,W1B/FW;E0BgGX,Y1BhGW;AtFg+djB;AgH/3dM;;;EAGE,gBAAA;EACA,eAAA;EACA,mBAAA;AhHi4dR;AgH93dI;EACE,W1B1GW;E0B2GX,Y1B3GW;AtF2+djB;AgH93dI;EACE,WAAA;EACA,YAAA;AhHg4dN;;AgH13dA;EACE,aAAA;EACA,2BAAA;AhH63dF;AgH53dE;EACE,0BAAA;AhH83dJ;AgH73dI;;EAEE,qEACE;AhH83dR;AgHz3dI;EACE,0BAAA;AhH23dN;AgHz3dI;EACE,uCAAA;AhH23dN;AgHv3dE;EACE,wBAAA;AhHy3dJ;AgHv3dE;EACE,qBAAA;AhHy3dJ;AgHv3dE;EACE,sBAAA;AhHy3dJ;AgHv3dE;EACE,uBAAA;AhHy3dJ;;AiH/keA;;;;;;;2FAAA;AAUE;EACE,QAAA;EACA,WAAA;EACA,aAAA;AjHgleJ;AiH7keI;EACE,QAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,uBAAA;AjH+keN;AiH5keI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,mB7GvBE;E6GwBF,wBAAA;AjH8keN;AiH5keM;;EAEE,cAAA;AjH8keR;AiHzkeM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AjH2keR;AiHvkeI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mB7GjDE;E6GkDF,WAAA;EACA,qBAAA;EACA,eAAA;EACA,wB7G+EU;E6G9EV,aAAA;AjHykeN;AiHxkeM;EAZF;IAaI,iBAAA;EjH2keN;AACF;AiHzkeM;EACE,uBAAA;AjH2keR;AiH1keQ;;EAEE,kBAAA;EACA,eAAA;EACA,cAAA;AjH4keV;AiHxkeM;EACE,cAAA;EACA,oBAAA;AjH0keR;AiHtkeQ;EACE,2BAAA;EACA,c7G8BG;AJ0ieb;AiHtkeU;;EAEE,kBAAA;EACA,iBAAA;EACA,qBAAA;AjHwkeZ;AiHpkeQ;EACE,iC7G4CM;E6G3CN,kC7G2CM;AJ2hehB;AiHnkeQ;EACE,oC7GuCM;E6GtCN,qC7GsCM;AJ+hehB;AiHlkeQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AjHokeV;AiHnkeU;EAEE,yB7GGF;AJikeV;AiH9jeI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AjHgkeN;AiH9jeM;;EAEE,kBAAA;EACA,iBAAA;EACA,qBAAA;AjHgkeR;AiH5jeI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,eAAA;AjH8jeN;AiH5jeM;;EAEE,kBAAA;EACA,iBAAA;EACA,qBAAA;AjH8jeR;AiHzjeE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mB7GnJI;E6GoJJ,wB7GhBY;E6GiBZ,qFACE;AjH0jeN;AiHvjeI;EACE,cAAA;AjHyjeN;AiHtjeI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AjHwjeN;AiHrjeI;EACE,gDAAA;EACA,YAAA;EACA,wBAAA;EACA,mB7GxKE;E6GyKF,uCAAA;AjHujeN;AiHrjeM;EACE,yBAAA;AjHujeR;AiHnjeI;EACE,kBAAA;AjHqjeN;AiHjjeE;EACE,eAAA;AjHmjeJ;AiHhjeE;EACE,sCAAA;AjHkjeJ;AiHhjeI;EACE,aAAA;AjHkjeN;AiH9ieE;EACE,uBAAA;AjHgjeJ;;AiH1ieI;EACE,cAAA;EACA,wBAAA;AjH6ieN;AiHzieM;EACE,cAAA;EACA,yBAAA;AjH2ieR;;AiHjieM;EACE,gBAAA;AjHoieR;;AkHrweA;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlHwweF;AkHvweE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAjBa;EAkBb,sBAAA;EACA,mB9G4Ia;E8G3Ib,kBAAA;EACA,6CAAA;AlHyweJ;;AkHrweA;EAEE,iBAAA;EACA,gBAAA;EACA,UAAA;AlHuweF;AkHtweE;EACE,YAAA;EACA,kBAAA;EACA,sBAAA;AlHwweJ;;AkH/ueA;EAnBE,yBAoBoB;EzFrDpB,cAAA;EFAE,yB2FqDkB;EzFnDpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHwweF;AOtyeE;EkBAE,cAAA;EFNA,yB2FqDkB;EzF7ClB,qByF6CkB;AlH4vetB;AyBtyeE;EAEE,cAAA;EFbA,yB2FqDkB;EzFtClB,qByFsCkB;EzFjChB,iDAAA;AzBmyeN;AyB9xeE;EAEE,cAAA;EACA,yByFyBkB;EzFxBlB,kByFGiC;AlH4xerC;AyBxxeE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBk0e7L;AyBnxeI;EAKI,iDAAA;AzBixeR;;AkH7weA;EAtBE,yBAuBoB;EzFxDpB,cAAA;EFAE,yB2FwDkB;EzFtDpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHyyeF;AOv0eE;EkBAE,cAAA;EFNA,yB2FwDkB;EzFhDlB,qByFgDkB;AlH0xetB;AyBv0eE;EAEE,cAAA;EFbA,yB2FwDkB;EzFzClB,qByFyCkB;EzFpChB,iDAAA;AzBo0eN;AyB/zeE;EAEE,cAAA;EACA,yByF4BkB;EzF3BlB,kByFGiC;AlH6zerC;AyBzzeE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBm2e7L;AyBpzeI;EAKI,iDAAA;AzBkzeR;;AkH3yeA;EAzBE,yBA0BoB;EzF3DpB,cAAA;EFAE,yB2F2DkB;EzFzDpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH00eF;AOx2eE;EkBAE,cAAA;EFNA,yB2F2DkB;EzFnDlB,qByFmDkB;AlHwzetB;AyBx2eE;EAEE,cAAA;EFbA,yB2F2DkB;EzF5ClB,qByF4CkB;EzFvChB,iDAAA;AzBq2eN;AyBh2eE;EAEE,cAAA;EACA,yByF+BkB;EzF9BlB,kByFGiC;AlH81erC;AyB11eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBo4e7L;AyBr1eI;EAKI,iDAAA;AzBm1eR;;AkHz0eA;EA5BE,yBA6BoB;EzF9DpB,cAAA;EFAE,yB2F8DkB;EzF5DpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH22eF;AOz4eE;EkBAE,cAAA;EFNA,yB2F8DkB;EzFtDlB,qByFsDkB;AlHs1etB;AyBz4eE;EAEE,cAAA;EFbA,yB2F8DkB;EzF/ClB,qByF+CkB;EzF1ChB,iDAAA;AzBs4eN;AyBj4eE;EAEE,cAAA;EACA,yByFkCkB;EzFjClB,kByFGiC;AlH+3erC;AyB33eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBq6e7L;AyBt3eI;EAKI,iDAAA;AzBo3eR;;AkHv2eA;EA/BE,yBAgCoB;EzFjEpB,cAAA;EFAE,yB2FiEkB;EzF/DpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH44eF;AO16eE;EkBAE,cAAA;EFNA,yB2FiEkB;EzFzDlB,qByFyDkB;AlHo3etB;AyB16eE;EAEE,cAAA;EFbA,yB2FiEkB;EzFlDlB,qByFkDkB;EzF7ChB,iDAAA;AzBu6eN;AyBl6eE;EAEE,cAAA;EACA,yByFqCkB;EzFpClB,kByFGiC;AlHg6erC;AyB55eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBs8e7L;AyBv5eI;EAKI,iDAAA;AzBq5eR;;AkHr4eA;EAlCE,yBAmCoB;EzFpEpB,cAAA;EFAE,yB2FoEkB;EzFlEpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH66eF;AO38eE;EkBAE,cAAA;EFNA,yB2FoEkB;EzF5DlB,qByF4DkB;AlHk5etB;AyB38eE;EAEE,cAAA;EFbA,yB2FoEkB;EzFrDlB,qByFqDkB;EzFhDhB,iDAAA;AzBw8eN;AyBn8eE;EAEE,cAAA;EACA,yByFwCkB;EzFvClB,kByFGiC;AlHi8erC;AyB77eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBu+e7L;AyBx7eI;EAKI,iDAAA;AzBs7eR;;AkHn6eA;EArCE,yBAsCoB;EzFvEpB,cAAA;EFAE,yB2FuEkB;EzFrEpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH88eF;AO5+eE;EkBAE,cAAA;EFNA,yB2FuEkB;EzF/DlB,qByF+DkB;AlHg7etB;AyB5+eE;EAEE,cAAA;EFbA,yB2FuEkB;EzFxDlB,qByFwDkB;EzFnDhB,iDAAA;AzBy+eN;AyBp+eE;EAEE,cAAA;EACA,yByF2CkB;EzF1ClB,kByFGiC;AlHk+erC;AyB99eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBwgf7L;AyBz9eI;EAKI,iDAAA;AzBu9eR;;AkHj8eA;EAxCE,yBAyCoB;EzF1EpB,cAAA;EFAE,yB2F0EkB;EzFxEpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH++eF;AO7gfE;EkBAE,cAAA;EFNA,yB2F0EkB;EzFlElB,qByFkEkB;AlH88etB;AyB7gfE;EAEE,cAAA;EFbA,yB2F0EkB;EzF3DlB,qByF2DkB;EzFtDhB,iDAAA;AzB0gfN;AyBrgfE;EAEE,cAAA;EACA,yByF8CkB;EzF7ClB,kByFGiC;AlHmgfrC;AyB//eE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzByif7L;AyB1/eI;EAKI,iDAAA;AzBw/eR;;AkH/9eA;EA3CE,yBA4CoB;EzF7EpB,cAAA;EFAE,yB2F6EkB;EzF3EpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHghfF;AO9ifE;EkBAE,cAAA;EFNA,yB2F6EkB;EzFrElB,qByFqEkB;AlH4+etB;AyB9ifE;EAEE,cAAA;EFbA,yB2F6EkB;EzF9DlB,qByF8DkB;EzFzDhB,iDAAA;AzB2ifN;AyBtifE;EAEE,cAAA;EACA,yByFiDkB;EzFhDlB,kByFGiC;AlHoifrC;AyBhifE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB0kf7L;AyB3hfI;EAKI,iDAAA;AzByhfR;;AkH7/eA;EA9CE,yBA+CoB;EzFhFpB,cAAA;EFAE,yB2FgFkB;EzF9EpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHijfF;AO/kfE;EkBAE,cAAA;EFNA,yB2FgFkB;EzFxElB,qByFwEkB;AlH0gftB;AyB/kfE;EAEE,cAAA;EFbA,yB2FgFkB;EzFjElB,qByFiEkB;EzF5DhB,iDAAA;AzB4kfN;AyBvkfE;EAEE,cAAA;EACA,yByFoDkB;EzFnDlB,kByFGiC;AlHqkfrC;AyBjkfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB2mf7L;AyB5jfI;EAKI,iDAAA;AzB0jfR;;AkH3hfA;EAjDE,yBAkDoB;EzFnFpB,cAAA;EFAE,yB2FmFkB;EzFjFpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHklfF;AOhnfE;EkBAE,cAAA;EFNA,yB2FmFkB;EzF3ElB,qByF2EkB;AlHwiftB;AyBhnfE;EAEE,cAAA;EFbA,yB2FmFkB;EzFpElB,qByFoEkB;EzF/DhB,iDAAA;AzB6mfN;AyBxmfE;EAEE,cAAA;EACA,yByFuDkB;EzFtDlB,kByFGiC;AlHsmfrC;AyBlmfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB4of7L;AyB7lfI;EAKI,iDAAA;AzB2lfR;;AkHzjfA;EApDE,yBAqDoB;EzFtFpB,cAAA;EFAE,yB2FsFkB;EzFpFpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHmnfF;AOjpfE;EkBAE,cAAA;EFNA,yB2FsFkB;EzF9ElB,qByF8EkB;AlHskftB;AyBjpfE;EAEE,cAAA;EFbA,yB2FsFkB;EzFvElB,qByFuEkB;EzFlEhB,iDAAA;AzB8ofN;AyBzofE;EAEE,cAAA;EACA,yByF0DkB;EzFzDlB,kByFGiC;AlHuofrC;AyBnofE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB6qf7L;AyB9nfI;EAKI,iDAAA;AzB4nfR;;AkHvlfA;EAvDE,yBAwDoB;EzFzFpB,cAAA;EFAE,yB2FyFkB;EzFvFpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHopfF;AOlrfE;EkBAE,cAAA;EFNA,yB2FyFkB;EzFjFlB,qByFiFkB;AlHomftB;AyBlrfE;EAEE,cAAA;EFbA,yB2FyFkB;EzF1ElB,qByF0EkB;EzFrEhB,iDAAA;AzB+qfN;AyB1qfE;EAEE,cAAA;EACA,yByF6DkB;EzF5DlB,kByFGiC;AlHwqfrC;AyBpqfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB8sf7L;AyB/pfI;EAKI,iDAAA;AzB6pfR;;AkHrnfA;EA1DE,yBA2DoB;EzF5FpB,cAAA;EFAE,yB2F4FkB;EzF1FpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHqrfF;AOntfE;EkBAE,cAAA;EFNA,yB2F4FkB;EzFpFlB,qByFoFkB;AlHkoftB;AyBntfE;EAEE,cAAA;EFbA,yB2F4FkB;EzF7ElB,qByF6EkB;EzFxEhB,iDAAA;AzBgtfN;AyB3sfE;EAEE,cAAA;EACA,yByFgEkB;EzF/DlB,kByFGiC;AlHysfrC;AyBrsfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzB+uf7L;AyBhsfI;EAKI,iDAAA;AzB8rfR;;AkHnpfA;EA7DE,yBA8DoB;EzF/FpB,cAAA;EFAE,yB2F+FkB;EzF7FpB,kByF6F6B;EA5D7B,yBAAA;EACA,YAAA;AlHstfF;AOpvfE;EkBAE,cAAA;EFNA,sB2F+FiC;EzFvFjC,kByFuFuC;AlHgqf3C;AyBpvfE;EAEE,cAAA;EFbA,sB2F+FiC;EzFhFjC,kByFgFuC;EzF3ErC,2CAAA;AzBivfN;AyB5ufE;EAEE,cAAA;EACA,yByFmEkB;EzFlElB,kByFkE2B;AlH2qf/B;AyBtufE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,mBA7CyL;AzBgxf7L;AyBjufI;EAKI,2CAAA;AzB+tfR;;AkHjrfA;EAhEE,yBAiEoB;EzFlGpB,cAAA;EFAE,yB2FkGkB;EzFhGpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHuvfF;AOrxfE;EkBAE,cAAA;EFNA,yB2FkGkB;EzF1FlB,qByF0FkB;AlH8rftB;AyBrxfE;EAEE,cAAA;EFbA,yB2FkGkB;EzFnFlB,qByFmFkB;EzF9EhB,iDAAA;AzBkxfN;AyB7wfE;EAEE,cAAA;EACA,yByFsEkB;EzFrElB,kByFGiC;AlH2wfrC;AyBvwfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBizf7L;AyBlwfI;EAKI,iDAAA;AzBgwfR;;AkH/sfA;EAnEE,yBAoEoB;EzFrGpB,cAAA;EFAE,yB2FqGkB;EzFnGpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlHwxfF;AOtzfE;EkBAE,cAAA;EFNA,yB2FqGkB;EzF7FlB,qByF6FkB;AlH4tftB;AyBtzfE;EAEE,cAAA;EFbA,yB2FqGkB;EzFtFlB,qByFsFkB;EzFjFhB,iDAAA;AzBmzfN;AyB9yfE;EAEE,cAAA;EACA,yByFyEkB;EzFxElB,kByFGiC;AlH4yfrC;AyBxyfE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBk1f7L;AyBnyfI;EAKI,iDAAA;AzBiyfR;;AkH7ufA;EAtEE,yBAuEoB;EzFxGpB,cAAA;EFAE,yB2FwGkB;EzFtGpB,kByFsG6B;EArE7B,yBAAA;EACA,YAAA;AlHyzfF;AOv1fE;EkBAE,cAAA;EFNA,yB2FwGkB;EzFhGlB,qByFgGkB;AlH0vftB;AyBv1fE;EAEE,cAAA;EFbA,yB2FwGkB;EzFzFlB,qByFyFkB;EzFpFhB,iDAAA;AzBo1fN;AyB/0fE;EAEE,cAAA;EACA,yByF4EkB;EzF3ElB,kByF2E2B;AlHqwf/B;AyBz0fE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBm3f7L;AyBp0fI;EAKI,iDAAA;AzBk0fR;;AkH3wfA;EAzEE,yBA0EoB;EzF3GpB,cAAA;EFAE,yB2F2GkB;EzFzGpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH01fF;AOx3fE;EkBAE,cAAA;EFNA,yB2F2GkB;EzFnGlB,qByFmGkB;AlHwxftB;AyBx3fE;EAEE,cAAA;EFbA,yB2F2GkB;EzF5FlB,qByF4FkB;EzFvFhB,iDAAA;AzBq3fN;AyBh3fE;EAEE,cAAA;EACA,yByF+EkB;EzF9ElB,kByFGiC;AlH82frC;AyB12fE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBo5f7L;AyBr2fI;EAKI,iDAAA;AzBm2fR;;AkHzyfA;EA5EE,yBA6EoB;EzF9GpB,cAAA;EFAE,yB2F8GkB;EzF5GpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH23fF;AOz5fE;EkBAE,cAAA;EFNA,yB2F8GkB;EzFtGlB,qByFsGkB;AlHszftB;AyBz5fE;EAEE,cAAA;EFbA,yB2F8GkB;EzF/FlB,qByF+FkB;EzF1FhB,iDAAA;AzBs5fN;AyBj5fE;EAEE,cAAA;EACA,yByFkFkB;EzFjFlB,kByFGiC;AlH+4frC;AyB34fE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBq7f7L;AyBt4fI;EAKI,iDAAA;AzBo4fR;;AkHv0fA;EA/EE,yBAgFoB;EzFjHpB,cAAA;EFAE,yB2FiHkB;EzF/GpB,kByF8BmC;EAGnC,yBAAA;EACA,YAAA;AlH45fF;AO17fE;EkBAE,cAAA;EFNA,yB2FiHkB;EzFzGlB,qByFyGkB;AlHo1ftB;AyB17fE;EAEE,cAAA;EFbA,yB2FiHkB;EzFlGlB,qByFkGkB;EzF7FhB,iDAAA;AzBu7fN;AyBl7fE;EAEE,cAAA;EACA,yByFqFkB;EzFpFlB,kByFGiC;AlHg7frC;AyB56fE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;AzBs9f7L;AyBv6fI;EAKI,iDAAA;AzBq6fR;;AkHn2fA;EA5EE,oCAAA;EACA,cA4E4B;AlHu2f9B;;AkHr2fA;EA/EE,oCAAA;EACA,cA+E4B;AlHy2f9B;;AkHv2fA;EAlFE,oCAAA;EACA,cAkF4B;AlH22f9B;;AkHz2fA;EArFE,oCAAA;EACA,cAqF4B;AlH62f9B;;AkH32fA;EAxFE,oCAAA;EACA,cAwF4B;AlH+2f9B;;AkH72fA;EA3FE,oCAAA;EACA,cA2F4B;AlHi3f9B;;AkH/2fA;EA9FE,oCAAA;EACA,cA8F4B;AlHm3f9B;;AkHj3fA;EAjGE,oCAAA;EACA,cAiG4B;AlHq3f9B;;AkHn3fA;EApGE,oCAAA;EACA,cAoG4B;AlHu3f9B;;AkHr3fA;EAvGE,oCAAA;EACA,cAuG4B;AlHy3f9B;;AkHv3fA;EA1GE,oCAAA;EACA,cA0G4B;AlH23f9B;;AkHz3fA;EA7GE,oCAAA;EACA,cA6G4B;AlH63f9B;;AkH33fA;EAhHE,oCAAA;EACA,cAgH4B;AlH+3f9B;;AkH73fA;EAnHE,oCAAA;EACA,cAmH4B;AlHi4f9B;;AkH/3fA;EAtHE,oCAAA;EACA,cAsH4B;AlHm4f9B;;AkHj4fA;EAzHE,oCAAA;EACA,cAyH4B;AlHq4f9B;;AkHn4fA;EA5HE,oCAAA;EACA,cA4H4B;AlHu4f9B;;AkHr4fA;EA/HE,oCAAA;EACA,cA+H4B;AlHy4f9B;;AkHv4fA;EAlIE,oCAAA;EACA,cAkI4B;AlH24f9B;;AkHz4fA;EArIE,oCAAA;EACA,cAqI4B;AlH64f9B;;AkH34fA;EAxIE,oCAAA;EACA,cAwI4B;AlH+4f9B;;AkH34fA;EAvIE,cAAA;EACA,oCAAA;AlHshgBF;;AkH74fA;EA1IE,cAAA;EACA,oCAAA;AlH2hgBF;;AkH/4fA;EA7IE,cAAA;EACA,oCAAA;AlHgigBF;;AkHj5fA;EAhJE,cAAA;EACA,oCAAA;AlHqigBF;;AkHn5fA;EAnJE,cAAA;EACA,oCAAA;AlH0igBF;;AkHr5fA;EAtJE,cAAA;EACA,oCAAA;AlH+igBF;;AkHv5fA;EAzJE,cAAA;EACA,oCAAA;AlHojgBF;;AkHz5fA;EA5JE,cAAA;EACA,oCAAA;AlHyjgBF;;AkH35fA;EA/JE,cAAA;EACA,oCAAA;AlH8jgBF;;AkH75fA;EAlKE,cAAA;EACA,oCAAA;AlHmkgBF;;AkH/5fA;EArKE,cAAA;EACA,oCAAA;AlHwkgBF;;AkHj6fA;EAxKE,cAAA;EACA,oCAAA;AlH6kgBF;;AkHn6fA;EA3KE,cAAA;EACA,oCAAA;AlHklgBF;;AkHr6fA;EA9KE,cAAA;EACA,oCAAA;AlHulgBF;;AkHv6fA;EAjLE,cAAA;EACA,oCAAA;AlH4lgBF;;AkHz6fA;EApLE,cAAA;EACA,oCAAA;AlHimgBF;;AkH36fA;EAvLE,cAAA;EACA,oCAAA;AlHsmgBF;;AkH76fA;EA1LE,cAAA;EACA,oCAAA;AlH2mgBF;;AkH/6fA;EA7LE,cAAA;EACA,oCAAA;AlHgngBF;;AkHj7fA;EAhME,cAAA;EACA,oCAAA;AlHqngBF;;AkHn7fA;EAnME,cAAA;EACA,oCAAA;AlH0ngBF;;AkHn7fA;EACE,yBAAA;AlHs7fF;;AkHp7fA;EACE,yBAAA;AlHu7fF;;AkHr7fA;EACE,yBAAA;AlHw7fF;;AkHt7fA;EACE,yBAAA;AlHy7fF;;AkHv7fA;EACE,yBAAA;AlH07fF;;AkHx7fA;EACE,yBAAA;AlH27fF;;AkHz7fA;EACE,yBAAA;AlH47fF;;AkH17fA;EACE,yBAAA;AlH67fF;;AkH37fA;EACE,yBAAA;AlH87fF;;AkH57fA;EACE,yBAAA;AlH+7fF;;AkH77fA;EACE,yBAAA;AlHg8fF;;AkH97fA;EACE,yBAAA;AlHi8fF;;AkH/7fA;EACE,yBAAA;AlHk8fF;;AkHh8fA;EACE,yBAAA;AlHm8fF;;AkHj8fA;EACE,yBAAA;AlHo8fF;;AkHl8fA;EACE,yBAAA;AlHq8fF;;AkHn8fA;EACE,yBAAA;AlHs8fF;;AkHp8fA;EACE,yBAAA;AlHu8fF;;AkHr8fA;EACE,yBAAA;AlHw8fF;;AkHt8fA;EACE,yBAAA;AlHy8fF;;AkHv8fA;EACE,yBAAA;AlH08fF;;AmHlwgBA;;;;;;;2FAAA;AAUA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AnHmwgBF;AmHlwgBE;EACE,uBAAA;EACA,qBAAA;AnHowgBJ;;AmH/vgBA;EACE,SAAA;EACA,wBAAA;AnHkwgBF;AmHjwgBE;EACE,SAAA;AnHmwgBJ;;AmH/vgBA;EACE,SAAA;AnHkwgBF;;AmH7vgBE;EACE,YAAA;EACA,WAAA;AnHgwgBJ;;AmH5vgBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AnH+vgBF;AmH7vgBE;EACE,aAAA;AnH+vgBJ;;AmH3vgBA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,2BAAA;EACA,sBAAA;AnH8vgBF;;AmH3vgBA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AnH8vgBF;;AmH3vgBA;EACE,WAAA;AnH8vgBF;;AmH3vgBA;EACE,iBAAA;AnH8vgBF;;AmH3vgBA;EACE,WAAA;EACA,YAAA;AnH8vgBF;;AmHlvgBA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AnHqvgBF;AmHpvgBE;EACE,6CAAA;AnHsvgBJ;AmHrvgBI;EACE,2BAAA;AnHuvgBN;;AoH71gBA;;;;;;;2FAAA;AASA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,yBhHJM;EgHKN,aAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kCAAA;EACA,0DAAA;EACA,2BAAA;EACA,6CAAA;ApH+1gBF;AoH71gBE;EACE,qFACE;EAEF,QAAA;ApH61gBJ;AoHz1gBE;EACE,kBAAA;EACA,YAAA;ApH21gBJ;AoHv1gBE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,chHkIa;AJutgBjB;AoHx1gBI;;EAEE,oBAAA;EACA,iBAAA;EACA,gBAAA;ApH01gBN;AoHr1gBE;EACE,mBhHnBW;EgHoBX,yBAAA;EACA,cAAA;EACA,8CAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;ApHu1gBJ;AoHn1gBE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;ApHq1gBJ;AoHn1gBM;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;ApHq1gBR;AoHl1gBQ;EACE,SAAA;EACA,UAAA;ApHo1gBV;;AqHj7gBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ArHo7gBF;AqHh7gBE;EACE,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;ArHk7gBJ;AqH96gBI;;EAEE,gBAAA;EACA,eAAA;EACA,mBAAA;ArHg7gBN;AqH36gBI;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;ArH46gBN;AqHx6gBI;EACE,WAAA;ArH06gBN;AqHv6gBI;EACE,UAAA;ArHy6gBN;AqHl6gBI;EACE,WAAA;EACA,eAAA;ArHo6gBN;AqHn6gBM;EACE,aAAA;ArHq6gBR;AqHh6gBI;EACE,UAAA;ArHk6gBN;AqH75gBI;EACE,YAAA;EACA,gBAAA;ArH+5gBN;AqH95gBM;EACE,aAAA;ArHg6gBR;AqH35gBI;EACE,WAAA;ArH65gBN;AqHr5gBM;EAEE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBjHqDO;AJi2gBf;AqHh5gBM;EAEE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBjH0CO;AJu2gBf;;AsHv+gBA;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AtH0+gBF;AsHv+gBE;EACE,kBAAA;EACA,uBAAA;EACA,8BAAA;AtHy+gBJ;AsHv+gBI;EACE,wBAAA;AtHy+gBN;AsHr+gBI;EACE,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBhCyFgB;EgCxFhB,iBhCwFgB;EgCvFhB,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBlHjCE;AJwghBR;AsHp+gBM;EACE,gBAAA;EACA,eAAA;EACA,YhC+EwB;EgC9ExB,WhC8EwB;EgC7ExB,SAAA;EACA,yBlHdO;AJo/gBf;AsHp+gBQ;EACE,WAAA;EACA,mCAAA;EACA,YhCyE8B;EgCxE9B,WhCwE8B;EgCvE9B,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AtHs+gBV;AsHj+gBM;;EAEE,clHhCO;EkHiCP,qBhC8DuB;EgC7DvB,wBAAA;AtHm+gBR;AsH/9gBI;EACE,kBAAA;EACA,WAAA;EACA,kBhCqDqB;AtF46gB3B;AsH99gBM;EACE,qBhCoDmB;EgCnDnB,clHwGK;AJw3gBb;AsH59gBI;EACE,yCAAA;AtH89gBN;AsH79gBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,iDAAA;AtH+9gBR;;AsHx9gBA;EACE,gCAAA;EACA,mBAAA;EACA,oBAAA;AtH29gBF;;AsHx9gBA;EACE,2CAAA;EACA,gBAAA;AtH29gBF;;AsHx9gBA;EACE,2CAAA;AtH29gBF;;AsHx9gBA;EACE,2CAAA;AtH29gBF;;AsHx9gBA;EACE,aAAA;EACA,sBAAA;AtH29gBF;;AsHx9gBA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;AtH29gBF;;AsHx9gBA;EACE,kBAAA;EACA,UAAA;AtH29gBF;;AsHx9gBA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AtH29gBF;;AsHx9gBA;EACE,aAAA;EACA,8BAAA;AtH29gBF;;AsHx9gBA;;EAEE,iBAAA;EACA,YAAA;EACA,aAAA;AtH29gBF;;AsHx9gBA;EACE,UAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AtH29gBF;;AsHx9gBA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AtH29gBF;;AsHx9gBA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AtH29gBF;;AsHx9gBA;EACE,OAAA;EACA,eAAA;AtH29gBF;;AsHx9gBA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AtH29gBF;;AsHx9gBA;EACE,sBAAA;AtH29gBF;;AsHx9gBA;EACE,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AtH29gBF;;AsHx9gBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;AtH29gBF;;AsHx9gBA;EACE,OAAA;EACA,eAAA;AtH29gBF;;AsHx9gBA;EACE,uBAAA;EACA,sBAAA;AtH29gBF;;AsHx9gBA;EACE,qBAAA;AtH29gBF;;AsHx9gBA;EACE,OAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AtH29gBF;;AsHx9gBA;EACE,yBAAA;EACA,UAAA;AtH29gBF;;AsHx9gBA;EACE,yBAAA;EACA,UAAA;AtH29gBF;;AsHx9gBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;AtH29gBF;;AsHx9gBA;EACE,kBAAA;AtH29gBF;;AsHx9gBA;EACE;IACE,eAAA;EtH29gBF;;EsHz9gBA;IACE,UAAA;IACA,OAAA;EtH49gBF;;EsH19gBA;IACE,OAAA;IACA,cAAA;EtH69gBF;;EsH39gBA;IACE,OAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,mBAAA;IACA,iBAAA;EtH89gBF;;EsH39gBA;IACE,wBAAA;IACA,UAAA;IACA,OAAA;EtH89gBF;;EsH39gBA;IACE,wBAAA;IACA,UAAA;IACA,OAAA;EtH89gBF;;EsH39gBA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,OAAA;EtH89gBF;AACF;AsH39gBA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,8BAAA;EtH69gBF;;EsH39gBA;IACE,YAAA;EtH89gBF;;EsH59gBA;IACE,2BAAA;EtH+9gBF;;EsH79gBA;IACE,sBAAA;IACA,uBAAA;IACA,2BAAA;EtHg+gBF;;EsH99gBA;IACE,WAAA;EtHi+gBF;;EsH/9gBA;IACE,WAAA;EtHk+gBF;;EsHh+gBA;IACE,2BAAA;EtHm+gBF;AACF;AsHh+gBA;EACE,kBAAA;AtHk+gBF;;AsH/9gBA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AtHk+gBF;;AsH/9gBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AtHk+gBF;;AsH/9gBA;EACE,aAAA;EACA,SAAA;AtHk+gBF;;AsH/9gBA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iCAAA;AtHk+gBF;;AsH/9gBA;;EAEE,sBAAA;EACA,kBAAA;AtHk+gBF;;AsH/9gBA;EACE,eAAA;EACA,WAAA;AtHk+gBF;;AsH/9gBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AtHk+gBF;;AsH/9gBA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,iCAAA;AtHk+gBF;;AsH/9gBA;;EAEE,sBAAA;EACA,kBAAA;AtHk+gBF;;AsH/9gBA;EACE,mBAAA;EACA,YAAA;AtHk+gBF;;AsH99gBA;EACE,cAAA;AtHi+gBF;;AsH99gBA;EACE,cAAA;EACA,sBAAA;AtHi+gBF;;AsH99gBA;EACE,cAAA;EACA,sBAAA;AtHi+gBF;;AuHt2hBE;EACE;IACE,qBAAA;EvHy2hBJ;;EuHv2hBE;IACE,8BAAA;EvH02hBJ;AACF;AuHh3hBE;EACE;IACE,uBAAA;EvHk3hBJ;;EuHh3hBE;IACE,gCAAA;EvHm3hBJ;AACF;AuHz3hBE;EACE;IACE,uBAAA;EvH23hBJ;;EuHz3hBE;IACE,gCAAA;EvH43hBJ;AACF;AuHl4hBE;EACE;IACE,uBAAA;EvHo4hBJ;;EuHl4hBE;IACE,gCAAA;EvHq4hBJ;AACF;AuH34hBE;EACE;IACE,wBAAA;EvH64hBJ;;EuH34hBE;IACE,iCAAA;EvH84hBJ;AACF;AuH14hBA;EAEE,WAAA;AvH24hBF;AuHz4hBE;EACE,8DAAA;AvH24hBJ;;AuHt4hBA;EACE,aAAA;AvHy4hBF;;AuHl3hBA;EACE,aAAA;AvHq3hBF;;AwHr7hBA;EACE,yBAAA;AxHw7hBF;;AwHr7hBA;EACE,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AxHw7hBF;;AwHp7hBE;;EACE,aAAA;AxHw7hBJ;AwHr7hBE;;EACE,oBAAA;EACA,0BAAA;AxHw7hBJ;AwHr7hBE;;EACE,sBAAA;EACA,YAAA;EACA,yBAAA;AxHw7hBJ;AwHt7hBI;;EACE,UAAA;EACA,gCAAA;EACA,yDAAA;AxHy7hBN;AwHp7hBM;;;;EAEE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AxHw7hBR;AwHn7hBM;;EACE,yDAAA;EACA,qCACE;EAEF,4BAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AxHo7hBR;AwH/6hBE;;EACE,4CpHmQkB;AJ+qhBtB;AwHj7hBI;;EACE,gCAAA;EACA,UAAA;AxHo7hBN;AwH/6hBE;;EACE,UAAA;AxHk7hBJ;AwHj7hBI;;EACE,gCAAA;EACA,UAAA;AxHo7hBN;AwH/6hBE;;EACE,qBpH0J0B;AJwxhB9B;AwHh7hBE;;EACE,kBAAA;AxHm7hBJ;AwHl7hBI;;EACE,wBAAA;EACA,wBpHqDU;EoHpDV,qBpHmJwB;EoHlJxB,sBAAA;AxHq7hBN;AwHh7hBE;;EACE,2BAAA;EACA,yBAAA;AxHm7hBJ;AwHl7hBI;;EACE,UAAA;EACA,gCAAA;EACA,yDAAA;AxHq7hBN;AwHl7hBI;;EACE,oCAAA;EACA,gCAAA;EACA,cpHlGE;EoHmGF,gBAAA;AxHq7hBN;AwHl7hBI;;EACE,cAAA;AxHq7hBN;AwHn7hBQ;;EACE,eAAA;AxHs7hBV;AwHl7hBI;;EAEE,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AxHo7hBN;AwHn7hBM;;EACE,WAAA;EACA,0DAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AxHs7hBR;AwHl7hBI;;;;EAEE,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AxHs7hBN;AwHj7hBE;;EACE,gBAAA;EACA,gBAAA;AxHo7hBJ;AwHj7hBE;;EACE,2BAAA;AxHo7hBJ;AwHn7hBI;;EACE,UAAA;AxHs7hBN;AwHp7hBI;;EACE,oCAAA;EACA,uBAAA;AxHu7hBN;AwHr7hBI;;;;EAEE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;AxHy7hBN;AwHr7hBE;;EACE,oDAAA;EACA,yBAAA;AxHw7hBJ;AwHn7hBI;;EACE,WAAA;AxHs7hBN;AwH96hBE;;EACE,+BAAA;EACA,iBAAA;EACA,2BAAA;EACA,4BAAA;AxHi7hBJ;AwH/6hBM;;EACE,oBAAA;AxHk7hBR;AwH/6hBM;;EACE,uBAAA;AxHk7hBR;AwH76hBI;;EACE,mBAAA;AxHg7hBN;AwH/6hBM;;EACE,yBAAA;AxHk7hBR;AwHj7hBQ;;EACE,iBAAA;AxHo7hBV;AwHn7hBU;;EACE,gBAAA;AxHs7hBZ;AwHn7hBQ;;EACE,YAAA;AxHs7hBV;AwHp7hBU;;EACE,QAAA;AxHu7hBZ;AwHh7hBE;;EACE,+BAAA;EACA,mBAAA;EACA,qBlCpJW;EkCqJX,2BAAA;EACA,gBlCnJa;AtFskiBjB;AwHh7hBM;;EACE,0BAAA;AxHm7hBR;AwH96hBI;;EACE,gBAAA;AxHi7hBN;AwHh7hBM;;EACE,YAAA;AxHm7hBR;AwHl7hBQ;;EACE,qBlCpKK;EkCqKL,eAAA;AxHq7hBV;AwHp7hBU;;EACE,eAAA;AxHu7hBZ;AwHn7hBM;;EACE,mBAAA;AxHs7hBR;AwHr7hBQ;;EACE,OAAA;AxHw7hBV;AwHp7hBM;;EACE,aAAA;AxHu7hBR;;AwH96hBI;;;EAGE,mBCrPgB;EDsPhB,qBCnQoB;EDoQpB,cCrQkB;AzHsriBxB;AwH96hBI;EACE,cCzQkB;AzHyriBxB;AwH76hBI;EACE,yBCnQe;EDoQf,qBC7QoB;AzH4riB1B;AwH36hBM;EACE,8CAAA;EACA,yBAAA;EACA,YAAA;AxH66hBR;AwH56hBQ;EACE,yBAAA;AxH86hBV;AwH36hBM;EACE,0DAAA;AxH66hBR;AwHz6hBI;EACE,cCzRwB;AzHosiB9B;AwHv6hBM;EACE,0DAAA;AxHy6hBR;AwHh6hBI;EACE,YAAA;AxHk6hBN;;A0HztiBA;EAEE,sBAAA;EACA,oCAAA;A1H2tiBF;A0H1tiBE;;EAEE,2BAAA;EACA,sBAAA;A1H4tiBJ;A0HxtiBI;;;EAGE,sBAAA;A1H0tiBN;A0HztiBM;;;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,ctHwFK;EsHvFL,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;A1H6tiBR;A0H3tiBM;;;EACE,0DAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,ctH4EK;EsH3EL,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;A1H+tiBR;A0HxtiBI;EACE,eAAA;EACA,yBAAA;A1H0tiBN;;A0HrtiBA;EACE,yBtHnDM;AJ2wiBR;A0HvtiBE;EACE,gBAAA;EACA,6BAAA;EACA,eAAA;A1HytiBJ;A0HvtiBE;EACE,UAAA;A1HytiBJ;;A0HptiBA;;EAEE,iBAAA;A1HutiBF;;A0H/siBI;;EACE,oBAAA;EACA,wBAAA;A1HmtiBN;A0HhtiBI;;EACE,0EACE;EAGF,iBAAA;EACA,eAAA;EACA,mBAAA;A1HgtiBN;A0H7siBE;EACE,uBAAA;A1H+siBJ;A0H1siBI;EACE,oBAAA;EACA,wBAAA;A1H4siBN;A0HvsiBE;EACE,kCAAA;EACA,ctH2ES;AJ8niBb;;A0HpsiBA;EAEE,yBtH6EgB;AJyniBlB;;A0HlsiBA;EAGM;IACE,uBAAA;E1HmsiBN;;E0H9riBA;IACE,oBAAA;E1HisiBF;;E0H9riBA;IACE,uBAAA;IACA,oBAAA;E1HisiBF;E0HhsiBE;IACE,wBAAA;E1HksiBJ;AACF;AgBxwiBI;E0G2EA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;E1HgsiBJ;E0H9riBE;IACE,uBAAA;E1HgsiBJ;E0H/riBI;IACE,eAAA;IACA,gBAAA;E1HisiBN;E0H/riBI;IACE,wBAAA;E1HisiBN;;E0H7riBA;IACE,gBAAA;E1HgsiBF;AACF;A2Hv1iBA,wBAAA;AAGE;EACE,cAfwB;EAgBxB,mBAAA;A3Hu1iBJ;A2Ht1iBI;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,yBvH4FI;EuH3FJ,mCAAA;EACA,kBAAA;EACA,gBAAA;A3Hw1iBN;A2Hv1iBM;EACE,UAAA;EACA,gBAAA;A3Hy1iBR;A2Hp1iBE;EACE,oBAAA;A3Hs1iBJ;A2Hr1iBI;EACE,UAAA;EACA,kBAAA;A3Hu1iBN;A2Hr1iBI;EACE,WAAA;EACA,kBAAA;A3Hu1iBN;A2Hr1iBI;;EAEE,UAAA;EACA,eAzC0B;EA0C1B,gBA1C0B;EA2C1B,mCAAA;A3Hu1iBN;A2Ht1iBM;;;;EAEE,cAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;A3H01iBR;A2Hn1iBI;;EAEE,kDAAA;EACA,eAAA;EACA,YAAA;A3Hq1iBN;A2Hh1iBE;EACE,kBAtE2B;A3Hw5iB/B;A2Hh1iBM;EACE,uBAAA;A3Hk1iBR;A2H/0iBI;;EAEE,eAzE6B;EA0E7B,gBA1E6B;A3H25iBnC;A2Hh1iBM;;;;EAEE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;A3Ho1iBR;A2H90iBE;EACE,iBA3F2B;A3H26iB/B;A2H90iBM;EACE,uBAAA;A3Hg1iBR;A2H50iBM;;EAEE,eA9F2B;EA+F3B,gBA/F2B;A3H66iBnC;A2H70iBQ;;;;EAEE,gBAAA;EACA,eAAA;EACA,mBAAA;A3Hi1iBV;;A2H10iBA,wEAAA;AAGI;EACE,0BAAA;A3H20iBN;;A2Hj0iBM;EACE,yBFrHa;AzHy7iBrB;A2H9ziBQ;;;EAGE,oCAAA;EACA,UAAA;A3Hg0iBV;A2H1ziBM;EACE,oCAAA;EACA,UAAA;A3H4ziBR;;A4Hx8iBA;EA4KE,+BAAA;EAymBA,4BAAA;EAoKA,4BAAA;EA4RA,4BAAA;EA0DA,mCAAA;EAiVA,iCAAA;EAmBA,wCAAA;A5H+1fF;A4Hj9iBW;EACP,cHIoB;EGHpB,yBHEiB;AzHi9iBrB;;A4Hj9iBE;EACE,cAAA;EACA,yBHFiB;AzHs9iBrB;A4Hh9iBE;;;;;;EAME,cHNwB;AzHw9iB5B;A4H98iBE;;;;;EAKE,gCAAA;A5Hg9iBJ;A4H38iBI;EACE,cxHLS;AJk9iBf;A4Hz8iBE;EACE,cHzBqB;AzHo+iBzB;A4Hx8iBE;EACE,cAAA;A5H08iBJ;A4Hv8iBE;EACE,qBHtCsB;AzH++iB1B;A4Ht8iBE;EACE,oCAAA;EACA,SAAA;A5Hw8iBJ;A4Ht8iBI;EACE,yBAAA;EACA,iBAAA;A5Hw8iBN;A4Hr8iBM;EACE,yBHrDa;AzH4/iBrB;A4Hl8iBE;EACE,yBH3DiB;AzH+/iBrB;A4Hj8iBE;EACE,yBH/DiB;AzHkgjBrB;A4H/7iBE;EACE,yBAAA;A5Hi8iBJ;A4H97iBE;EACE,yBAAA;A5Hg8iBJ;A4H77iBE;EACE,yBAAA;A5H+7iBJ;A4H77iBE;EACE,cHzEwB;AzHwgjB5B;A4H57iBE;EACE,cH3E0B;AzHygjB9B;A4H17iBE;EACE,0DAAA;A5H47iBJ;A4Hx7iBE;EACE,cHrF0B;AzH+gjB9B;A4Ht7iBE;EACE,+GAAA;A5Hw7iBJ;A4Hl7iBI;EACE,yBH9Fe;AzHkhjBrB;A4Hh7iBM;EACE,yBH9Ga;AzHgijBrB;A4H56iBM;EACE,+CAAA;A5H86iBR;A4H16iBE;EACE,yBH/GiB;AzH2hjBrB;A4H16iBI;EACE,wCAAA;A5H46iBN;A4Hr6iBM;;;;;;EAME,cH/Ha;AzHsijBrB;A4Hp6iBM;EACE,cH9Ia;AzHojjBrB;A4Hh6iBE;;EAEE,yBHrJoB;AzHujjBxB;A4Hh6iBE;;;;;;EAME,yBH5JsB;AzH8jjB1B;A4H/5iBE;;;EAGE,yBHnKoB;AzHokjBxB;A4H35iBI;;EAEE,cAAA;A5H65iBN;A4H35iBI;EACE,iBAAA;A5H65iBN;A4H15iBM;;;EAGE,cxHpLG;AJgljBX;A4H15iBM;EACE,yBAAA;A5H45iBR;A4Hl5iBM;EACE,cH7LoB;EG8LpB,qBHlMkB;AzHsljB1B;A4Hx3iBM;EACE,0DAAA;A5H03iBR;A4H/2iBE;EACE,qBH3OsB;AzH4ljB1B;A4H72iBI;EACE,qBHhPoB;AzH+ljB1B;A4H12iBE;EACE,4CAAA;A5H42iBJ;A4Hv2iBI;EACE,uDAAA;A5Hy2iBN;A4Hl2iBM;EACE,cHrQgB;AzHymjBxB;A4Hh2iBM;EACE,0DAAA;A5Hk2iBR;A4H51iBM;EACE,0DAAA;A5H81iBR;A4Hn1iBI;EACE,cH7RkB;AzHknjBxB;A4Hl1iBI;EAGE,cxHnSK;AJqnjBX;A4H/0iBI;EACE,oCAAA;A5Hi1iBN;A4H90iBI;EACE,qBxHlRQ;EwHmRR,cxH5SK;AJ4njBX;A4H/0iBM;EACE,cxH9SG;AJ+njBX;A4H50iBM;EAEE,mBxH5RM;AJymjBd;A4Hv0iBI;EACE,yBAAA;A5Hy0iBN;A4Hp0iBE;EACE,yBHxTiB;EGyTjB,4CAAA;A5Hs0iBJ;A4Hp0iBI;EACE,cHjUsB;AzHuojB5B;A4Hn0iBI;EACE,cH1UkB;AzH+ojBxB;A4Hp0iBM;EAEE,mCxHtBiB;EwHuBjB,cxHzTO;AJ8njBf;A4Hn0iBM;EAEE,cxHzVA;EwH0VA,yBtH3GsB;AN+6iB9B;A4Hl0iBM;EAEE,cHhVsB;AzHmpjB9B;A4H/ziBE;EACE,qBH3VsB;AzH4pjB1B;A4H5ziBI;;EAIE,yBHtWe;AzHkqjBrB;A4HxziBI;EACE,iBAAA;EACA,oCAAA;EACA,cH5WkB;EG6WlB,yDAAA;A5H0ziBN;A4HvziBI;;;EAGE,yBHzWe;EG0Wf,qBHnXoB;AzH4qjB1B;A4HjziBQ;EACE,yBH7ViB;AzHgpjB3B;A4HjziBU;EACE,yBxH3WG;AJ8pjBf;A4HjziBY;EACE,cxH1YN;AJ6rjBR;A4H9yiBQ;EACE,yBHzWiB;EG0WjB,cH1Yc;AzH0rjBxB;A4H9yiBU;EACE,cxHxXG;AJwqjBf;A4H1yiBU;EACE,cxH3ZJ;AJusjBR;A4HpyiBQ;EACE,yBH7XiB;AzHmqjB3B;A4HlyiBU;EACE,cxHzaJ;AJ6sjBR;A4H7xiBU;EACE,yBH1Ye;AzHyqjB3B;A4H3xiBQ;EACE,yBH/YiB;AzH4qjB3B;A4HrxiBQ;EACE,0DAAA;A5HuxiBV;A4H/wiBY;EACE,0DAAA;A5HixiBd;A4HtwiBQ;EACE,0DAAA;A5HwwiBV;A4HhwiBY;EACE,0DAAA;A5HkwiBd;A4HxviBQ;EACE,cH1doB;AzHotjB9B;A4HnviBE;EACE,qBHxesB;AzH6tjB1B;A4HhviBI;EACE,qBH9eoB;AzHgujB1B;A4H1uiBQ;EACE,yBHvfgB;AzHmujB1B;A4H1uiBQ;EACE,yBHjfW;AzH6tjBrB;A4HruiBQ;EACE,0BHlgBgB;AzHyujB1B;A4HruiBQ;EACE,0BH5fW;AzHmujBrB;A4HhuiBQ;EACE,2BH7gBgB;AzH+ujB1B;A4HhuiBQ;EACE,2BHvgBW;AzHyujBrB;A4H9tiBI;EACE,cxH7hBE;AJ6vjBR;A4H7tiBI;EACE,yBHhhBe;EGihBf,cH3hBkB;EG4hBlB,gCAAA;A5H+tiBN;A4H1tiBE;EACE,wCAAA;EACA,+CHxhBoB;EGyhBpB,cHpiBoB;AzHgwjBxB;A4H1tiBI;EACE,yBH7hBe;EG8hBf,cHxiBkB;AzHowjBxB;A4H1tiBM;EACE,wCAAA;EACA,2BAAA;EACA,iBAAA;A5H4tiBR;A4HptiBM;EAEE,yBH7iBa;EG8iBb,qBHvjBkB;EGwjBlB,cHzjBgB;AzH8wjBxB;A4HntiBQ;EAEE,yBH9jBW;AzHkxjBrB;A4HltiBQ;EAEE,yBxH5iBK;EwH6iBL,cxHzkBF;AJ4xjBR;A4H9siBQ;;EAEE,cxHhlBF;AJgyjBR;A4H5siBM;EACE,cHvkBsB;AzHqxjB9B;A4H1siBI;EACE,0DAAA;A5H4siBN;A4HvsiBE;EACE,qCAAA;EACA,0CAAA;A5HysiBJ;A4HrsiBE;EACE,yBHhmBiB;AzHuyjBrB;A4HrsiBI;EACE,qBHxlBe;AzH+xjBrB;A4HlsiBM;;EAEE,qEACE;A5HmsiBV;A4H3riBI;EACE,cHnnBkB;AzHgzjBxB;A4H3riBM;EAEE,qBHtnBkB;AzHkzjB1B;A4HtriBQ;EAEE,gCAAA;A5HuriBV;A4H/qiBI;EACE,qBHvoBoB;AzHwzjB1B;A4H/qiBM;EACE,yBHjoBa;AzHkzjBrB;A4H9qiBQ;EACE,cHxoBoB;AzHwzjB9B;A4H7qiBM;EACE,iDAAA;A5H+qiBR;A4HzqiBE;EACE,yBHhpBiB;EGipBjB,+CHhpBoB;AzH2zjBxB;A4HxqiBE;EACE,eHrpBiB;AzH+zjBrB;A4HvqiBE;EACE,yBHlqBsB;EGmqBtB,+CHzpBoB;AzHk0jBxB;A4HrqiBE;EACE,yBH/pBiB;EGgqBjB,+CH/pBoB;AzHs0jBxB;A4HtqiBI;EACE,qBH3qBoB;AzHm1jB1B;A4HnqiBQ;;;EAGE,cxH3rBF;AJg2jBR;A4H1piBI;EACE,2BHhrB0B;AzH40jBhC;A4HtpiBI;EACE,yBHxsBe;AzHg2jBrB;A4HlpiBI;EACE,qBH7sBoB;AzHi2jB1B;A4H9oiBI;EACE,yBHttBe;AzHs2jBrB;A4HvoiBM;EACE,exHvsBE;AJg1jBV;A4HroiBQ;EACE,aH1tBW;AzHi2jBrB;A4H5niBI;EACE,2BH/uBoB;AzH62jB1B;A4H1niBQ;EACE,eHrvBc;AzHi3jBxB;A4HnniBM;EACE,wBAAA;A5HqniBR;A4HlniBM;EACE,aH9vBoB;AzHk3jB5B;A4H7miBI;EACE,yBH5wBe;AzH23jBrB;A4HxmiBE;;;EAGE,yBHvwBkB;EGwwBlB,cHtxBoB;AzHg4jBxB;A4HxmiBI;;;EACE,qBHzwB0B;AzHq3jBhC;A4HzmiBI;;;EACE,cH9wB+B;AzH23jBrC;A4H1miBI;;;;;EAEE,YAAA;A5H+miBN;A4HzmiBI;EACE,yBAAA;A5H2miBN;A4HxmiBI;EACE,yBAAA;A5H0miBN;A4HpmiBI;EACE,yBHrzBe;EGszBf,8BAAA;EACA,cHtzBkB;AzH45jBxB;A4H/liBM;EACE,yBHpzBa;EGqzBb,qBH/yBwB;AzHg5jBhC;A4H7liBM;EACE,yBHlzBiC;EGmzBjC,qBHnzBiC;AzHk5jBzC;A4HxliBM;EACE,yBHxzBe;AzHk5jBvB;A4HtliBM;EACE,yBH5zBwB;AzHo5jBhC;A4HlliBE;;EAEE,yBH50BkB;EG60BlB,cH31BoB;EG41BpB,qBH31BsB;AzH+6jB1B;A4HlliBI;;EACE,yBHr1Be;AzH06jBrB;A4HlliBI;;EACE,YAAA;A5HqliBN;A4HnliBI;;EACE,qBxHj1BS;AJu6jBf;A4HjliBI;EACE,0DAAA;A5HmliBN;A4H1kiBE;;EAEE,gCAAA;A5H4kiBJ;A4HzkiBE;;EAEE,gCAAA;A5H2kiBJ;A4HlkiBU;;EACE,yBAAA;A5HqkiBZ;A4HnkiBY;;EACE,cHz4BU;AzH+8jBxB;A4HnkiBY;;EACE,oCAAA;EACA,yBAAA;A5HskiBd;A4H5jiBI;EACE,yBH34BgB;EG44BhB,qBHz5BoB;EG05BpB,cH35BkB;AzHy9jBxB;A4H1jiBM;;EAEE,qBxH54BO;EwH64BP,gBAAA;A5H4jiBR;A4HrjiBI;EAEE,yBAAA;A5HsjiBN;A4HljiBE;EACE,YAAA;A5HojiBJ;A4H9iiBE;EACE,yBH95BkB;AzH88jBtB;A4H9iiBI;;EAGE,gCAAA;A5H+iiBN;A4HziiBQ;;;;EAEE,qBHn8BgB;EGo8BhB,cHr8Bc;AzHk/jBxB;A4H3iiBU;;;;EACE,yBH76Bc;AzH69jB1B;A4HviiBQ;;EACE,qBHj9BgB;EGk9BhB,yBHz7BmB;EG07BnB,cH/8BkB;AzHy/jB5B;A4HviiBM;;EACE,yBxH/9BA;EwHg+BA,yBAAA;A5H0iiBR;A4HriiBI;EAEE,yBHt8BuB;AzH4+jB7B;A4HliiBI;EACE,yBxH5+BE;AJghkBR;A4HniiBM;EACE,wCAAA;A5HqiiBR;A4HpiiBQ;EACE,yBAAA;A5HsiiBV;A4HniiBM;;EAEE,gCAAA;EACA,yBAAA;EACA,yBxHv/BA;AJ4hkBR;A4HpiiBQ;;EACE,yBAAA;A5HuiiBV;A4H/hiBU;;EAEE,uBAAA;A5HiiiBZ;A4H5hiBU;;EAEE,cxH1gCJ;AJwikBR;A4HhhiBI;EACE,qBHjhCoB;AzHmikB1B;A4H3giBU;EACE,yBH9/BgB;AzH2gkB5B;A4H1giBU;;EAEE,uBAAA;A5H4giBZ;A4HrgiBI;EACE,yBH9gCgB;AzHqhkBtB;A4HtgiBM;EACE,+CH9hCgB;AzHsikBxB;A4HhgiBU;EACE,yBHrhCkB;AzHuhkB9B;A4Hx/hBM;;;;;;EAME,oCAAA;A5H0/hBR;A4Hz/hBQ;;;;;;EACE,oCAAA;EACA,cxH5kCF;AJ4kkBR;A4H3/hBM;EACE,+CHhkCgB;AzH6jkBxB;A4Ht/hBU;EACE,yBHtjCkB;EGujClB,cH/kCgB;AzHukkB5B;A4H9+hBU;;;EACE,0DAAA;A5Hk/hBZ;A4H5+hBU;;;EACE,0DAAA;A5Hg/hBZ;A4Hx+hBU;EAEE,YAAA;A5Hy+hBZ;A4Hr+hBU;EACE,UAAA;A5Hu+hBZ;A4Hr+hBU;EACE,YAAA;A5Hu+hBZ;A4Hn+hBU;EACE,UAAA;A5Hq+hBZ;A4Hn+hBU;EACE,YAAA;A5Hq+hBZ;A4H59hBI;EACE,wCAAA;A5H89hBN;A4Hx9hBI;EACE,cHjpCkB;AzH2mkBxB;A4Hv9hBE;;EAEE,yBH5oCiB;EG6oCjB,cHvpCoB;EGwpCpB,qBHvpCsB;AzHgnkB1B;A4Hv9hBI;;;;EAEE,oCAAA;A5H29hBN;A4Hx9hBI;;EACE,cHhpC0B;AzH2mkBhC;A4Hz9hBI;;EACE,kCAAA;A5H49hBN;A4Hz9hBI;;;;;;;;;;;;;;;;EAQE,gCAAA;EACA,cH/qCkB;AzHkpkBxB;A4Hj+hBI;;EACE,qBHjrCoB;EGkrCpB,mBHprCe;EGqrCf,YAAA;EACA,cAAA;A5Ho+hBN;A4Hh+hBM;;EACE,yBH3rCa;AzH8pkBrB;A4Hj+hBM;;EACE,mBHnrCa;AzHupkBrB;A4Hj+hBM;;EACE,yBHjqCmB;EGkqCnB,yBAAA;A5Ho+hBR;A4Hh+hBI;;EACE,mBHxsCe;AzH2qkBrB;A4Hh+hBI;;EACE,mBxHtrCS;AJypkBf;A4H19hBM;EACE,yBAAA;A5H49hBR;A4Hp9hBM;EACE,yBHptCa;AzH0qkBrB;A4Hr9hBQ;EACE,cHhuCc;EGiuCd,qBHhuCgB;AzHurkB1B;A4H/8hBI;EACE,yBHhuCe;AzHirkBrB;A4H38hBI;EACE,gCAAA;A5H68hBN;A4Hv8hBM;EACE,yBAAA;A5Hy8hBR;A4Hh8hBM;;;;EAGE,wCAAA;A5Hm8hBR;A4H37hBE;EACE,gCAAA;A5H67hBJ;A4H17hBM;EACE,oCAAA;A5H47hBR;A4Hz7hBI;EACE,oCAAA;EACA,gCAAA;A5H27hBN;A4Hz7hBI;EACE,gCAAA;A5H27hBN;A4Hl7hBQ;EACE,qBHlyCgB;EGmyChB,yBH1xCW;AzH8skBrB;A4Hj7hBc;EACE,cHxyCQ;AzH2tkBxB;A4H56hBU;EACE,qBH/yCc;EGgzCd,yBHvyCS;AzHqtkBrB;A4H56hBY;EACE,gCAAA;A5H86hBd;A4H36hBY;EACE,yCAAA;EACA,qBHxzCY;AzHqukB1B;A4Ht6hBc;;;;EAEE,cH3zCc;AzHqukB9B;A4Hr6hBU;EACE,yBH5yCgB;AzHmtkB5B;A4Hj6hBM;EACE,qBH90CkB;AzHivkB1B;A4Hl6hBQ;EACE,yBHl1CW;AzHsvkBrB;A4Hj6hBQ;EACE,yBH30CW;EG40CX,qBHr1CgB;AzHwvkB1B;A4H/5hBc;;EAEE,cH51CQ;AzH6vkBxB;A4H35hBU;EACE,0DAAA;A5H65hBZ;A4Hr5hBQ;;EAEE,gCAAA;A5Hu5hBV;A4Hj5hBQ;;;EAGE,qBHr3CgB;AzHwwkB1B;A4Hj5hBQ;EACE,cHz3Cc;AzH4wkBxB;A4Hj5hBQ;EACE,oCxHp6BoB;EwHq6BpB,qCxHr6BoB;AJwzjB9B;A4H34hBI;EACE,oCAAA;A5H64hBN;A4H14hBU;EACE,cH14CY;AzHsxkBxB;A4Hv4hBQ;;EAEE,yBAAA;A5Hy4hBV;A4Hr4hBM;EACE,cHh5CiB;AzHuxkBzB;A4Hp4hBM;EACE,oCAAA;A5Hs4hBR;A4Hl4hBI;EACE,oCAAA;A5Ho4hBN;A4Hh4hBI;EACE,oCAAA;A5Hk4hBN;A4Hh4hBM;EACE,wCAAA;EACA,2CAAA;A5Hk4hBR;A4Hh4hBQ;EACE,yBAAA;A5Hk4hBV;A4H93hBM;;EAEE,oCAAA;A5Hg4hBR;A4H73hBM;EACE,gCAAA;A5H+3hBR;A4H13hBU;EACE,yBHl6CU;AzH8xkBtB;A4Ht3hBY;EACE,oCAAA;A5Hw3hBd;A4Ht3hBY;EACE,gCAAA;A5Hw3hBd;A4Hn3hBc;;EAEE,yBAAA;A5Hq3hBhB;A4H52hBM;EACE,6BAAA;A5H82hBR;A4Hv2hBI;EACE,yBHp9Ce;EGq9Cf,qBH99CoB;AzHu0kB1B;A4Hv2hBM;EACE,cH59CiB;AzHq0kBzB;A4Hr2hBQ;;EACE,cHj+Ce;AzHy0kBzB;A4Hn2hBM;EACE,8BAAA;EACA,oCAAA;A5Hq2hBR;A4Hh2hBU;;;EAGE,yBH5+CS;EG6+CT,qBHt/Cc;AzHw1kB1B;A4Hh2hBU;EACE,sDAAA;A5Hk2hBZ;A4Hh2hBY;EACE,oCAAA;A5Hk2hBd;A4H71hBM;EACE,mBHz/Ca;EG0/Cb,qBHngDkB;AzHk2kB1B;A4H51hBQ;;EAEE,cHzgDc;AzHu2kBxB;A4H31hBM;;EAEE,qBH7gDkB;AzH02kB1B;A4H11hBM;EACE,qBHjhDkB;AzH62kB1B;A4Hz1hBM;;EAEE,qBHthDkB;AzHi3kB1B;A4H11hBQ;;EACE,mBH1hDW;AzHu3kBrB;A4H31hBQ;;EACE,yBH7hDW;AzH23kBrB;A4H51hBQ;;EACE,cH/hDc;AzH83kBxB;A4H51hBU;;EACE,qBHliDc;AzHi4kB1B;A4Hr1hBM;EACE,yBHpiDa;EGqiDb,qBH9iDkB;AzHq4kB1B;A4Hr1hBM;EACE,yBHxiDa;AzH+3kBrB;A4Ht1hBQ;EACE,yBHnjDgB;AzH24kB1B;A4Ht1hBQ;EACE,yBAAA;A5Hw1hBV;A4Hh1hBM;;EACE,yBHjkDa;AzHo5kBrB;A4Hl1hBQ;;EACE,yBHxjDW;EGyjDX,qBHlkDgB;AzHu5kB1B;A4H/0hBI;EACE,yBHhkDe;AzHi5kBrB;A4H30hBI;EACE,gCAAA;A5H60hBN;A4Hz0hBI;EACE,gCAAA;A5H20hBN;A4Hr0hBE;EACE,yBHnlDiB;AzH05kBrB;A4Hp0hBM;;EAEE,cHlmDgB;AzHw6kBxB;A4Hh0hBI;EACE,yBH/lDe;AzHi6kBrB;A4H5zhBI;EACE,0DAAA;A5H8zhBN;A4H5zhBI;EACE,sIAAA;A5H8zhBN;A4HxzhBM;EACE,8BAAA;A5H0zhBR;A4HzzhBQ;EACE,+CAAA;A5H2zhBV;A4HxzhBU;EACE,mBHjoDS;AzH27kBrB;;A6H/7kBE;EACE,gBAAA;A7Hk8kBJ;A6Hj8kBI;EACE,yBAAA;A7Hm8kBN;A6Hj8kBI;EACE,gCAAA;EACA,mBzHiGI;AJk2kBV;A6Hh8kBE;EACE,oCAAA;EACA,gBAAA;A7Hk8kBJ;A6H/7kBE;;;EAGE,yBAAA;EACA,gBAAA;A7Hi8kBJ;A6H97kBE;EACE,2BAAA;A7Hg8kBJ;A6H77kBI;EACE,6BAAA;A7H+7kBN;;A8Ht9kBA;EACE,0DAAA;A9Hy9kBF;;A8Hn9kBI;;EACE,WAAA;EACA,eAAA;A9Hu9kBN;;A8H/8kBE;;;EACE,sBAAA;EACA,iBAAA;EACA,qBAAA;A9Ho9kBJ;A8Hl9kBI;;;EACE,kBAAA;A9Hs9kBN;A8Hp9kBM;;;EACE,eAAA;EACA,UAAA;A9Hw9kBR;;A8Hh9kBI;EACE,qEAAA;A9Hm9kBN;A8Hh9kBE;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;A9Hk9kBJ;;A8H58kBI;EACE,qEAAA;A9H+8kBN;A8H58kBE;EACE,kBAAA;EACA,eAAA;EACA,sBAAA;A9H88kBJ;;A8Hx8kBE;EACE,iBAAA;EACA,sBAAA;EACA,oBAAA;A9H28kBJ;;A8Ht8kBA;EACE,eAAA;A9Hy8kBF;;A8Hr8kBA;EACE,SAAA;A9Hw8kBF;;A8Ht8kBA;EACE,YAAA;A9Hy8kBF;;A8Hv8kBA;EACE,cAAA;A9H08kBF;;A8Ht8kBA;EACE,sBAAA;A9Hy8kBF;;A8Hr8kBA;EACE,2BAAA;A9Hw8kBF;;A8Ht8kBA;;;EAGE,iBAAA;A9Hy8kBF;;A8Hn8kBE;EACE,0BAAA;EACA,cAAA;A9Hs8kBJ;A8Hp8kBE;EACE,yBAAA;A9Hs8kBJ;A8Hp8kBE;EACE,wBAAA;A9Hs8kBJ;A8Hp8kBE;EACE,yBAAA;A9Hs8kBJ;;A8H97kBI;;EACE,yBAAA;A9Hk8kBN;;A8Hv7kBM;EACE,yBAAA;A9H07kBR;A8Ht7kBQ;EACE,yBAAA;A9Hw7kBV;A8Hl7kBQ;EACE,yBAAA;A9Ho7kBV;A8H36kBM;EACE,yBAAA;A9H66kBR;A8Hz6kBQ;EACE,yBAAA;A9H26kBV;A8Hr6kBQ;EACE,yBAAA;A9Hu6kBV;;A8Hh6kBA;;EAEE,cAAA;A9Hm6kBF;;A8Hh6kBA;EACE;;IAEE,iBAAA;E9Hm6kBF;AACF;A8H/5kBA;EACE,qBAAA;A9Hi6kBF;;A8H95kBA;EACE,qBAAA;A9Hi6kBF;;A8H75kBA;EACE,UAAA;EACA,QAAA;A9Hg6kBF;;A8H75kBA;EACE,OAAA;EACA,WAAA;A9Hg6kBF;;A8H55kBA;;EAEE,uCAAA;EACA,0B1HsLW;AJyukBb;;A8H55kBA;;EAEE,QAAA;EACA,UAAA;A9H+5kBF;;A8H55kBA;;EAEE,uCAAA;EACA,2B1H0KW;AJqvkBb;;A8H55kBA;;EAEE,OAAA;EACA,WAAA;A9H+5kBF;;A8H35kBA;EACE,sBAAA;A9H85kBF;;A8H15kBA;EACE,mDAAA;A9H65kBF;;A8Hz5kBA;EACE,sBAAA;EACA,oBAAA;A9H45kBF;;A8Hx5kBA;;EAEE,qBAAA;A9H25kBF;;A8Hx5kBA;;EAEE,qCAAA;A9H25kBF;;A8Hp5kBM;;EAEE,0BAAA;EACA,uBAAA;A9Hu5kBR;;A8H94kBI;EACE,yBAAA;EACA,uBAAA;A9Hi5kBN;A8H74kBE;EACE,wBAAA;A9H+4kBJ;;A8Hv4kBM;EACE,yBAAA;A9H04kBR;;A+H1rlBA;;;EAGE,YAAA;A/H6rlBF;;A+H1rlBA;EACE,qBAAA;EACA,qBAAA;A/H6rlBF;;A+HvrlBE;EACE,8BAAA;EACA,8DAAA;A/H0rlBJ;A+HhrlBQ;;;;EACE,wBAAA;A/HqrlBV;A+H1qlBU;EACE,gBAAA;A/H4qlBZ;A+HnqlBQ;EACE,UAAA;EACA,WAAA;A/HqqlBV;A+HlqlBQ;EACE,mB3HzCC;E2H0CD,mBAAA;A/HoqlBV;A+HjqlBQ;EACE,mB3HhDC;E2HiDD,mBAAA;A/HmqlBV;;A+HzplBE;EACE,aAAA;EACA,wBAAA;A/H4plBJ;;A+HpplBE;EACE,uBAAA;EACA,sBAAA;A/HuplBJ;;A+HjplBA;EACE,WAAA;A/HoplBF;;A+H9olBE;EACE,iCAAA;A/HiplBJ;;A+H3olBA;;EAEE,sBAAA;A/H8olBF;;A+HxolBE;EACE,eAAA;A/H2olBJ;;A+HpolBE;EACE,WAAA;EACA,gBAAA;A/HuolBJ;A+HrolBI;EACE,UAAA;A/HuolBN;;AgI9vlBQ;EACE,cPgBoB;AzHivlB9B;AgI1vlBE;EACE,2BPEsB;AzH0vlB1B;AgIvvlBI;EACE,yBP2BqB;AzH8tlB3B;AgIxvlBM;EACE,cPPgB;AzHiwlBxB;AgIpvlBE;EACE,yBPJiB;AzH0vlBrB;AgIjvlBI;EACE,mBPrBe;AzHwwlBrB;AgIjvlBI;EACE,cPvBkB;AzH0wlBxB;AgI9ulBE;EACE,6BAAA;AhIgvlBJ;AgI5ulBE;EACE,ePjCsB;AzH+wlB1B;AgItulBU;EACE,mBP5CS;AzHoxlBrB;AgIrulBU;EACE,mBP9Cc;AzHqxlB1B;;AiIrylBE;EACE,sBAAA;EACA,oBAAA;AjIwylBJ;AiInylBI;EACE,qBAAA;EACA,WAAA;AjIqylBN;AiIhylBE;EACE,0DAAA;AjIkylBJ;AiI3xlBM;;EACE,yBAAA;AjI8xlBR;AiInxlBQ;EACE,yBAAA;AjIqxlBV;AiIjxlBU;EACE,yBAAA;AjImxlBZ;AiI7wlBU;EACE,yBAAA;AjI+wlBZ;AiItwlBQ;EACE,yBAAA;AjIwwlBV;AiIpwlBU;EACE,yBAAA;AjIswlBZ;AiIhwlBU;EACE,yBAAA;AjIkwlBZ;AiI3vlBM;EACE,yBAAA;AjI6vlBR;AiIvvlBE;EACE,qBAAA;AjIyvlBJ;AiIrvlBE;EACE,mDAAA;AjIuvlBJ;AiInvlBE;;EAEE,uCAAA;EACA,2B7HuTS;AJ87kBb;AiIlvlBE;;EAEE,OAAA;EACA,WAAA;EAEA,yBAAA;AjImvlBJ;AiIhvlBE;;EAEE,uCAAA;EACA,0B7HySS;AJy8kBb;AiI/ulBE;;EAEE,QAAA;EACA,UAAA;EAEA,yBAAA;AjIgvlBJ;AiI3ulBI;EACE,0BAAA;EACA,gCAAA;AjI6ulBN;AiItulBM;;EAEE,yBAAA;AjIwulBR;AiIjulBI;EACE,QAAA;EACA,UAAA;AjImulBN;AiI7tlBI;EACE,sGACE;AjI8tlBR;AiIttlBI;EACE,cAAA;AjIwtlBN;AiIjtlBM;EACE,kBAAA;EACA,yBAAA;AjImtlBR;AiI7slBE;EACE,aAAA;AjI+slBJ;AiI3slBE;EACE,sBAAA;EACA,qBAAA;AjI6slBJ;AiI1slBE;EACE,qBAAA;EACA,sBAAA;AjI4slBJ;AiI7rlBM;EACE,yBAAA;AjI+rlBR;AiI5rlBI;;EAEE,yBAAA;AjI8rlBN;AiIvrlBM;EACE,yBAAA;AjIyrlBR;AiIhrlBU;EACE,0BAAA;AjIkrlBZ;;AkIp5lBA;EACE,YAAA;AlIu5lBF;;AkIp5lBA;EACE,iCAAA;AlIu5lBF;;AkIn5lBE;EACE,qB9HuBE;AJ+3lBN;AkIn5lBI;;;EAGE,gCAAA;AlIq5lBN;;AmIn6lBI;EACE,wCAAA;AnIs6lBN;AmIr6lBM;EACE,yBVSa;AzH85lBrB;AmIr6lBQ;EACE,cVOc;AzHg6lBxB;;AoIh7lBA;EACE,qBhIoCa;EgInCb,yBhImCa;AJg5lBf;;AqI/6lBE;;EACE,wBAAA;ArIm7lBJ;;AqI96lBE;EACE,uBAAA;EACA,sBAAA;ArIi7lBJ;AqI96lBE;EACE,qBAAA;ArIg7lBJ;;AqI36lBE;EACE,qBAAA;EACA,QAAA;ArI86lBJ;;AqIx6lBE;EACE,UAAA;ArI26lBJ;;AqIr6lBE;EACE,aAAA;ArIw6lBJ;AqIt6lBE;EACE,eAAA;ArIw6lBJ;AqIv6lBI;EACE,4BAAA;EACA,eAAA;ArIy6lBN;;AsIl9lBI;EACE,iBAAA;AtIq9lBN;AsIl9lBI;EACE,+BAAA;AtIo9lBN;AsIj9lBM;EACE,yBAAA;AtIm9lBR;AsI/8lBE;EACE,4BAAA;AtIi9lBJ;;AuIh+lBI;;EAEE,yBAAA;AvIm+lBN;;AwIp+lBM;;;;EAEE,cAAA;EACA,eAAA;AxIy+lBR;AwIn+lBQ;;;;EAEE,YAAA;AxIu+lBV;AwIh+lBQ;;;;EAEE,YAAA;AxIo+lBV;AwI79lBI;;EAEE,aAAA;AxI+9lBN;;AyIlgmBA;EACE,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;EACA,6BAAA;AzIqgmBF;AyIngmBE;EACE,iBAAA;AzIqgmBJ;AyIlgmBE;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;AzIogmBJ;AyIjgmBE;EACE,kCAAA;AzImgmBJ;AyIjgmBE;EACE,8CAAA;AzImgmBJ;AyIjgmBE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,sDAAA;EACA,8CAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;AzImgmBJ;AyIhgmBE;EACE,yBAAA;AzIkgmBJ;;AyI//lBA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AzIkgmBF;;AyI//lBA;EACE;IACE,+BAAA;IACA,uBAAA;EzIkgmBF;EyIhgmBA;IACE,gCAAA;IACA,wBAAA;EzIkgmBF;AACF;AyIhgmBA;EACE;IACE,+BAAA;IACA,uBAAA;IACA,YAAA;EzIkgmBF;EyIhgmBA;IACE,gCAAA;IACA,wBAAA;IACA,UAAA;EzIkgmBF;AACF;A0I9kmBA;;;;CAAA;AAQA;EACE,oCAAA;A1I6kmBF;;A0ItkmBA;EACE,2BAAA;A1IykmBF;;A0IvkmBA;EACE,yBtITM;AJmlmBR;;A0InkmBA;EACE,oCAAA;A1IskmBF;;A0IpkmBA;EACE,oCAAA;A1IukmBF;;A0IrkmBA;EACE,2BAAA;EACA,uBAAA;A1IwkmBF;;A0IpkmBA;;;;EAIE,oCAAA;A1IukmBF;;A0IrkmBA;EACE,2CAAA;EACA,2BAAA;EACA,gCAAA;A1IwkmBF;;A0ItkmBA;;;;;EAKE,yBtIZY;AJqlmBd;;A0IvkmBA;EACE,6BAAA;A1I0kmBF;;A0IxkmBA;EACE,oCAAA;A1I2kmBF;;A0IzkmBA;EACE,6BAAA;A1I4kmBF;;A0IxkmBA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;A1I2kmBF;;A0IzkmBA;EACE,oCAAA;EACA,kBAAA;EACA,oCAAA;A1I4kmBF;;A0I1kmBA;EAEE,qBAAA;A1I4kmBF;;A0I1kmBA;;;;EAIE,sBAAA;EACA,4BAAA;A1I6kmBF;;A0I3kmBA;EACE,yBAAA;A1I8kmBF;;A0IzkmBA;EACE,WAAA;EACA,2BAAA;EACA,oBAAA;A1I4kmBF;;A0IvkmBA;EACE,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;A1I0kmBF;;A0IxkmBA;EACE,WAAA;A1I2kmBF;;A0IzkmBA;;EAEE,wBAAA;EACA,8BAAA;A1I4kmBF;;A0I1kmBA;EACE,2BAAA;A1I6kmBF;;A0ItjmBA;EACE,kBAAA;A1IyjmBF;;A0IvjmBA;EAEE,gBAAA;A1IyjmBF;;A0IvjmBA;;EAEE,yBtIxHY;AJkrmBd;;A0IxjmBA;EACE,aAAA;EACA,YAAA;EACA,SAAA;A1I2jmBF;;A0IzjmBA;EACE,aAAA;A1I4jmBF;;A0IzjmBA;EACE,uBAAA;EACA,sBAAA;A1I4jmBF;;A0IzjmBA;EACE,4BAAA;A1I4jmBF;;A0IzjmBA;EACE,6BAAA;A1I4jmBF;;A0IzjmBA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;A1I4jmBF;;A0IrjmBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;A1IwjmBF;;A0IljmBA;EACE,WAAA;EACA,yBAAA;A1IqjmBF;;A0IljmBA;EACE,sBAAA;A1IqjmBF;;A0IljmBA;EACE,aAAA;EACA,yBAAA;A1IqjmBF;;A2IpxmBA;;;;;;;;;;iGAAA;ACYA;EACE,kBAAA;A5IsxmBF;;A4InxmBA;EACE,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;A5IsxmBF;;A4InxmBA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;A5IsxmBF;;A4InxmBA;EACE,YAAA;EAEA,mBAAA;EAGA,oBAAA;EAEA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;A5IkxmBF;;A4I/wmBA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;A5IkxmBF;;A4I/wmBA;EACE,gBAAA;A5IkxmBF;;A4I/wmBA;EACE,UAAA;EACA,oBAAA;EACA,mBAAA;A5IkxmBF;;A4I3wmBA;EACE,YAAA;A5I8wmBF;;A4I3wmBA;EAGE,qBAAA;EACA,YAAA;A5I4wmBF;;A4IzwmBA;EACE,qBAAA;EASA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,wBAAA;A5IowmBF;;A4IjwmBA;EACE,iBAAA;A5IowmBF;;A4I/vmBA;EACE,sBAAA;A5IkwmBF;;A4I/vmBA;EACE,WAAA;EACA,YAAA;A5IkwmBF;;A4I/vmBA;EACE,6EAAA;EACA,mBAAA;A5IkwmBF;;A4I/vmBA;EACE,cApHO;A5Is3mBT;;A4I/vmBA;;EAOE,WAAA;A5I6vmBF;;A4I1vmBA;EACE,qBAAA;EACA,uBAAA;A5I6vmBF;;A4I1vmBA;EACE,UAAA;EACA,iBAAA;A5I6vmBF;;A4I1vmBA;EACE,gBAAA;A5I6vmBF;;A4I1vmBA;EACE,gBAAA;EACA,mBAAA;A5I6vmBF;;A4I1vmBA;EACE,qBAAA;A5I6vmBF;;A4I1vmBA;EACE,gBAAA;A5I6vmBF;;A4I1vmBA;EACE,iBAAA;EACA,yBAAA;A5I6vmBF;;A4I1vmBA;EACE,cAAA;EACA,qBAAA;A5I6vmBF;;A4I1vmBA;EACE,aAAA;A5I6vmBF;A4I3vmBE;EACE,UAAA;A5I6vmBJ;;A4IvvmBI;EACE,cAAA;A5I0vmBN;A4IvvmBE;EACE,cAAA;A5IyvmBJ;A4IvvmBE;EACE,cAAA;A5IyvmBJ;;A4IrvmBA;EACE,aAAA;EACA,mBAAA;A5IwvmBF;A4ItvmBE;EACE,iBAAA;A5IwvmBJ;A4IrvmBE;EACE,kBAAA;A5IuvmBJ;;A4InvmBA;EACE,oBAAA;EACA,mBAAA;A5IsvmBF;A4IpvmBE;EACE,iBAAA;A5IsvmBJ;A4InvmBE;EACE,kBAAA;A5IqvmBJ;;A4IjvmBA;EACE,gBAAA;EACA,gBAAA;A5IovmBF;;A4IjvmBA;EACE,eAAA;EACA,WAAA;EACA,UAAA;A5IovmBF;;A4IjvmBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;A5IovmBF;;A4IjvmBA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EAEA,YAAA;EACA,kBAAA;EAEA,mBAAA;A5IkvmBF;;A4I/umBA;EACE,YAAA;EACA,gCAAA;A5IkvmBF;;A4I/umBA;EACE,uBAAA;EACA,oBAAA;A5IkvmBF;;A4I/umBA;EACE,wBAAA;EACA,iBAAA;A5IkvmBF;;A4I/umBA;EACE,iBAAA;A5IkvmBF;;A4I3umBE;EACE,cAAA;A5I8umBJ;;A4I1umBA;EACE,oCAAA;A5I6umBF;;A4I1umBA;EACE,oCAAA;EACA,yBAAA;A5I6umBF;;A4I1umBA;EACE,WAAA;A5I6umBF;;A4ItumBA;EACE,yBxIjRc;AJ0/mBhB;;A4ItumBA;EACE,yBxInSM;AJ4gnBR;A4IvumBE;EACE,cxIvRW;AJggnBf;A4IvumBI;EACE,cxIzRe;AJkgnBrB;;A4IpumBA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5IuumBF;A4IpumBE;EACE,gBAAA;EACA,YAAA;A5IsumBJ;;A4IlumBA;EACE,aAAA;A5IqumBF;;A4IlumBA;EACE,gBAAA;A5IqumBF;;A4IlumBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;A5IqumBF;;A4IlumBA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;A5IqumBF;;A4IlumBA;EACE,eAAA;EACA,cAAA;A5IqumBF;;A4IlumBA;EACE,WAAA;A5IqumBF;;A4IlumBA;EACE,0BAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;A5IqumBF;A4InumBE;EAGE,8BAAA;A5ImumBJ;;A4I/tmBA;EACE,yBxI/Va;EwIgWb,YAAA;A5IkumBF;A4IhumBE;EAGE,oCAAA;A5IgumBJ;;A4I5tmBA;EACE,YAAA;EACA,yBxIxWQ;EwIyWR,YAAA;EACA,YAAA;EACA,mBAAA;A5I+tmBF;A4I7tmBE;EAGE,oCAAA;EACA,YAAA;A5I6tmBJ;;A4IztmBA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;A5I4tmBF;;A4IztmBA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;A5I4tmBF;;A4IztmBA;EACE,gBAAA;A5I4tmBF;;A4IztmBA;EACE,gBAAA;EACA,WAAA;A5I4tmBF;;A4IxtmBA;;EAEE,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,mDAAA;A5I2tmBF;;A4IxtmBA;;EAEE,6CAAA;EACA,gBAAA;EACA,0BAAA;A5I2tmBF;;A4IxtmBA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;A5I2tmBF;;A4IhtmBA;EACE,wBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;A5ImtmBF;;A4IhtmBA;EACE,oCAAA;EACA,sBAAA;A5ImtmBF;;A4IhtmBA;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;A5ImtmBF;;A4IhtmBA;EACE,gBAAA;A5ImtmBF;;A4IhtmBA;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;A5ImtmBF;;A4IhtmBA;EACE,WAAA;A5ImtmBF;;A4I9smBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;A5IitmBF;;A4I9smBA;EACE,YAAA;EACA,iBAAA;A5IitmBF;;A4I9smBA;EACE,WAAA;A5IitmBF;;A4I9smBA;;EAEE,kBAAA;A5IitmBF;;A4I9smBA;EACE,eAAA;EACA,UAAA;A5IitmBF;;A4I9smBA;EACE,UAAA;A5IitmBF;;A4I9smBA;EACE,sBAAA;A5IitmBF;;A4I9smBA;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;A5IitmBF;;A4I9smBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;A5IitmBF;;A4I9smBA;EACE,eAAA;A5IitmBF;;A4I9smBA;;EAEE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;A5IitmBF;;A4I9smBA;EACE,eAAA;EACA,aAAA;A5IitmBF;;A4I9smBA;EACE,6MACE;A5IgtmBJ;;A4I5smBA;;;EAGE,eAAA;EACA,YAAA;EACA,gBAAA;A5I+smBF;;A4I5smBA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;A5I+smBF;;A4I5smBA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;A5I+smBF;;A4I5smBA;EACE,cAAA;A5I+smBF;;A4I5smBA;EACE,kBAAA;EACA,kBAAA;A5I+smBF;;A4I5smBA;EACE,YAAA;A5I+smBF;;A4I5smBA;EACE,kBAAA;A5I+smBF;;A4I5smBA;EACE,iBAAA;A5I+smBF;;A4I5smBA;EACE,gBAAA;A5I+smBF;;A4I5smBA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A5I+smBF;;A4I5smBA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;A5I+smBF;;A4I5smBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,oCAAA;A5I+smBF;;A4I5smBA;EACE,WAAA;EACA,OAAA;A5I+smBF;;A4I5smBA;EACE,cxI7FS;EwI8FT,exI9FS;EwI+FT,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0CAAA;EAGA,6DAAA;EACA,qDAAA;A5I6smBF;;A4I1smBA;EAKE,2DAAA;EACA,mDAAA;EACA,oBAAA;A5IysmBF;;A4IrsmBA;EACE,cAAA;EACA,yBAAA;EACA,YAAA;A5IwsmBF;;A4IrsmBA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;A5IwsmBF;;A4IhsmBA;EACE,gBAAA;A5ImsmBF;;A4IhsmBA;EACE,mBAAA;A5ImsmBF;;A4IhsmBA;EACE,mBAAA;A5ImsmBF;;A4IhsmBA;EACE,mBAAA;A5ImsmBF;;A4IhsmBA;EACE,mBAAA;A5ImsmBF;;A4IhsmBA;EACE,mBAAA;A5ImsmBF;;A4IhsmBA;EACE,iBAAA;A5ImsmBF;;A4I9rmBA;EACE,sBAAA;A5IismBF;;A4I9rmBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A5IismBF;A4I/rmBE;EACE,eAAA;EACA,iBAAA;A5IismBJ;;A4IrrmBA;EACE,eAAA;A5IwrmBF;;A4IrrmBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A5IwrmBF;A4ItrmBE;EACE,eAAA;EACA,iBAAA;A5IwrmBJ;;A4IprmBA;EACE,iBAAA;EACA,cAAA;A5IurmBF;;A4IlrmBA;EACE,WAAA;EACA,YAAA;A5IqrmBF;;A4IlrmBA;EACE,YAAA;A5IqrmBF;;A4IlrmBA;EACE,aAAA;EACA,kBAAA;A5IqrmBF;;A4IlrmBA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;A5IqrmBF;;A4IlrmBA;EACE,kBAAA;EACA,UAAA;A5IqrmBF;;A4IlrmBA;EACE,SAAA;EACA,UAAA;A5IqrmBF;;A4IlrmBA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;A5IqrmBF;;A4IlrmBA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;A5IqrmBF;;A4IlrmBA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A5IqrmBF;;A4IlrmBA;EACE,kBAAA;EACA,mBAAA;A5IqrmBF;;A4IlrmBA;EACE,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;A5IqrmBF;;A4IlrmBA;EACE,iBAAA;A5IqrmBF;;A4IlrmBA;EACE,kBAAA;A5IqrmBF;;A4IlrmBA;EACE,wBAAA;A5IqrmBF;;A4IlrmBA;EACE,uBAAA;A5IqrmBF;;A4IlrmBA;EACE,uBAAA;A5IqrmBF;;A4IhrmBA;EACE,oBAAA;EACA,YAAA;A5ImrmBF;;A4IhrmBA;EACE,oBAAA;EACA,YAAA;A5ImrmBF;;A4I/qmBE;EACE,YAAA;A5IkrmBJ;A4I/qmBE;EACE,YAAA;A5IirmBJ;A4I9qmBE;EACE,YAAA;A5IgrmBJ;;A4I3qmBE;EACE,yBAAA;A5I8qmBJ;;A4I1qmBA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;A5I6qmBF;A4I3qmBE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,+BAAA;A5I6qmBJ;A4I1qmBE;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,+BAAA;A5I4qmBJ;;A4IxqmBA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;A5I2qmBF;;A4IvqmBE;EACE,gBAAA;EACA,mBAAA;A5I0qmBJ;;A4ItqmBA;EACE,iBAAA;EACA,oBAAA;A5IyqmBF;;A4ItqmBA;EACE,yBAAA;EACA,iBAAA;A5IyqmBF;;A4ItqmBA;EACE,yBAAA;EACA,iBAAA;A5IyqmBF;;A4ItqmBA;EACE,yBAAA;EACA,iBAAA;A5IyqmBF;;A4ItqmBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;A5IyqmBF;;A4ItqmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A5IyqmBF;A4IvqmBE;EACE,aAAA;A5IyqmBJ;;A4IrqmBA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;A5IwqmBF;;A4IrqmBA;EACE,cAAA;A5IwqmBF;;A4IrqmBA;EACE,cAAA;EACA,qBAAA;A5IwqmBF;;A4IpqmBA;EACE,UAAA;EACA,+BAAA;A5IuqmBF;;A4IpqmBA;EACE,UAAA;A5IuqmBF;;A4IpqmBA;EACE,+BAAA;A5IuqmBF;;A4IpqmBA;EACE,0BAAA;EACA,qDAAA;EACA,iDAAA;A5IuqmBF;A4IrqmBE;EACE,0BAAA;A5IuqmBJ;;A4I/pmBA;EACE,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sDAAA;EACA,yBAAA;EACA,0BAAA;A5IkqmBF;;A4I/pmBA;EACE,aAAA;A5IkqmBF;;A4I/pmBA;EACE,aAAA;EAEA,iBAAA;EAEA,YAAA;EACA,sCAAA;EACA,kCAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;A5IgqmBF;A4I9pmBE;EACE,YAAA;A5IgqmBJ;;A4I5pmBA;EACE,YAAA;A5I+pmBF;;A4I5pmBA;EACE,WAAA;EACA,iBAAA;A5I+pmBF;;A4I5pmBA;EACE,WAAA;A5I+pmBF;;A4I5pmBA;;EAEE,iBAAA;EACA,uBAAA;A5I+pmBF;;A4I5pmBA;EACE,WAAA;A5I+pmBF;;A4I5pmBA;;EAEE,iBAAA;A5I+pmBF;;A4I5pmBA;EACE,YAAA;A5I+pmBF;;A4I5pmBA;EACE,YAAA;A5I+pmBF;;A4I5pmBA;EACE,aAAA;EACA,8BAAA;A5I+pmBF;;A4I5pmBA;EACE,WAAA;A5I+pmBF;;A4I5pmBA;EACE,YAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;A5I+pmBF;;A4I5pmBA;EACE,iBAAA;A5I+pmBF;;A4I5pmBA;;EAEE,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;A5I+pmBF;A4I7pmBE;;EACE,eAAA;A5IgqmBJ;;A4I5pmBA;EACE,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,uBAAA;A5I+pmBF;;A4I5pmBA;EACE,gBAAA;A5I+pmBF;;A4I5pmBA;EACE,8BAAA;EACA,yBAAA;A5I+pmBF;A4I7pmBE;EACE,aAAA;A5I+pmBJ;;A4I3pmBA;EACE,aAAA;EACA,8BAAA;A5I8pmBF;;A4I3pmBA;EACE,YAAA;EACA,kBAAA;A5I8pmBF;;A4I3pmBA;EACE,UAAA;A5I8pmBF;;A4I3pmBA;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;A5I8pmBF;;A4I3pmBA;EACE,uBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;A5I6pmBF;;A4I1pmBA;EACE,yBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;A5I4pmBF;;A4IzpmBA;EACE,cAAA;EACA,UAAA;A5I4pmBF;;A4IzpmBA;EACE,UAAA;A5I4pmBF;;A4IzpmBA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;A5I4pmBF;;A4IzpmBA;EACE,0BAAA;A5I4pmBF;;A4IzpmBA;EACE,eAAA;A5I4pmBF;;A4IzpmBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;A5I4pmBF;A4I1pmBE;EACE,oBAAA;A5I4pmBJ;;A4IxpmBA;EACE,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;A5I2pmBF;;A4IxpmBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;A5I2pmBF;;A4IxpmBA;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;A5I2pmBF;;A4IxpmBA;EACE,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;A5I2pmBF;;A4IxpmBA;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;A5I2pmBF;;A4IxpmBA;EACE,2BAAA;EACA,uBAAA;EACA,mBAAA;A5I2pmBF;;A4IxpmBA;EACE,6BAAA;A5I2pmBF;;A4IxpmBA;EACE,yBAAA;EACA,YAAA;A5I2pmBF;;A4IxpmBA;EACE,2BAAA;A5I2pmBF;;A4IxpmBA;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;A5I2pmBF;;A4IxpmBA;EACE,YAAA;A5I2pmBF;;A4IxpmBA;EACE,qBAAA;A5I2pmBF;;A4IxpmBA;EACE,YAAA;A5I2pmBF;;A4IxpmBA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A5I2pmBF;;A4IxpmBA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;A5I2pmBF;;A4ItpmBA;EACE,uBAAA;A5IypmBF;;A4ItpmBA,sBAAA;AAEA;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;A5IwpmBF;;A4IrpmBA;EACE,YAAA;EACA,gBAAA;A5IwpmBF;;A4IrpmBA;EACE,mBAAA;EACA,gBAAA;A5IwpmBF;;A4IrpmBA;;EAEE,oBAAA;A5IwpmBF;;A4IrpmBA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;A5IwpmBF;;A4IrpmBA;EACE,mBAAA;A5IwpmBF;;A4IppmBA;EACE,UAAA;A5IupmBF;;A4IppmBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;A5IupmBF;;A4IppmBA;;EAEE,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,qBAAA;A5IupmBF;A4ItpmBE;;EACE,6BAAA;A5IypmBJ;;A4IrpmBA;EACE,UAAA;A5IwpmBF;;A4IrpmBA;EACE,gBAAA;A5IwpmBF;;A4IrpmBA;EACE,YAAA;A5IwpmBF;;A4IrpmBA;EACE,iBAAA;EACA,gBAAA;A5IwpmBF;;A4IrpmBA;EACE,8BAAA;A5IwpmBF;;A4IrpmBA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;A5IwpmBF;;A4IrpmBA;EACE,8BAAA;A5IwpmBF;;A4IrpmBA;EACE,iBAAA;A5IwpmBF;;A4IrpmBA;EACE,aAAA;EACA,8BAAA;A5IwpmBF;;A4IrpmBA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;A5IwpmBF;A4ItpmBE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;A5IwpmBJ;A4IrpmBE;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;A5IupmBJ;;A4InpmBA;EACE,sBAAA;A5IspmBF;;A4InpmBA;EACE,yBAAA;A5IspmBF;;A4InpmBA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;A5IspmBF;;A4InpmBA;EACE,cAAA;A5IspmBF;;A4InpmBA;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;A5IspmBF;;A4InpmBA;EACE,eAAA;A5IspmBF;;A4InpmBA;EACE,oCAAA;A5IspmBF;;A4InpmBA;EACE,eAAA;EACA,YAAA;A5IspmBF;;A4InpmBA;EACE,YAAA;EACA,WAAA;A5IspmBF;;A4InpmBA;EACE,YAAA;A5IspmBF;;A4InpmBA;EACE,gBAAA;A5IspmBF;;A4InpmBA;EACE,eAAA;EACA,iBAAA;A5IspmBF;;A4InpmBA;EACE,YAAA;EACA,WAAA;A5IspmBF;;A4InpmBA;EACE,qBAAA;EACA,YAAA;A5IspmBF;;A4InpmBA;EACE,kBAAA;A5IspmBF;A4IppmBE;EACE,YAAA;A5IspmBJ;;A4IlpmBA;EACE,yBAAA;A5IqpmBF;A4InpmBE;EACE,yBAAA;A5IqpmBJ;;A4IjpmBA;EACE,yBAAA;A5IopmBF;A4IlpmBE;EACE,yBAAA;A5IopmBJ;;A4IhpmBA;EACE,yBAAA;A5ImpmBF;;A4I/omBE;;;;EAIE,yBAAA;A5IkpmBJ;;A4I9omBA;EACE,oCAAA;EACA,gCAAA;A5IipmBF;;A4I9omBA;EACE,oCAAA;EACA,gCAAA;A5IipmBF;;A4I5omBA;EACE,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;A5I+omBF;;A4I1omBA;EACE,UAAA;EACA,cAAA;A5I6omBF;;A4I1omBA;EACE,WAAA;EACA,YAAA;A5I6omBF;;A4InomBA;EACE,4BAAA;A5IsomBF;;A4IjomBA;EACE,mBAAA;A5IoomBF;;A4IhomBA;EACE,WAAA;EACA,eAAA;EACA,kDAAA;A5ImomBF;;A4I9nmBA;EACE,iCAAA;EACA,8BAAA;A5IiomBF;;A4I9nmBA;EACE,wBAAA;A5IiomBF;;A4I9nmBA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBxIvlDM;EwIwlDN,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;A5IiomBF;;A4I9nmBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;A5IiomBF;;A4IznmBA;EACE,yBAAA;EACA,oCAAA;A5I4nmBF;;A4IznmBA;EACE,yBAAA;EACA,iCAAA;A5I4nmBF;;A4IznmBA;EACE,yBAAA;EACA,oCAAA;A5I4nmBF;;A4IznmBA;EACE,yBAAA;A5I4nmBF;;A4IxnmBA;EACE,yBAAA;A5I2nmBF;;A4IxnmBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;A5I2nmBF;;A4IxnmBA;EACE,WAAA;A5I2nmBF;;A4IxnmBA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;A5I2nmBF;;A4IxnmBA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;A5I2nmBF;;A4IxnmBA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;A5I2nmBF;;A4IxnmBA;;;EAGE,sBAAA;A5I2nmBF;;A4IxnmBA;;;EAGE,yBAAA;A5I2nmBF;;A4IxnmBA;EACE,uBAAA;A5I2nmBF;;A4IxnmBA;EACE,uBAAA;A5I2nmBF;;A4IxnmBA;EACE,eAAA;A5I2nmBF;;A4IxnmBA;EACE,oBAAA;A5I2nmBF;;A4IxnmBA;EAEE,iCAAA;EACA,iCAAA;A5I0nmBF;;A4IvnmBA;EACE,iBAAA;A5I0nmBF;;A4IvnmBA;EACE,gBAAA;EACA,cAAA;A5I0nmBF;;A4IvnmBA;EACE,wCAAA;EACA,0BAAA;A5I0nmBF;;A4IvnmBA;EACE,sBAAA;A5I0nmBF;;A4IvnmBA;EACE,YAAA;A5I0nmBF;;A4IvnmBA;EACE,UAAA;A5I0nmBF;;A6Ih2pBA;EACE,aAAA;A7Im2pBF;;A6I/1pBA;EACE;IACE,aAAA;IACA,sBAAA;E7Ik2pBF;AACF;A2I90pBA;EACE;IACE,2BAAA;E3Ig1pBF;E2I90pBA;IACE,2BAAA;IACA,UAAA;E3Ig1pBF;AACF;A2I70pBA;EACE;IACE,oDAAA;IACA,4CAAA;IACA,aAAA;E3I+0pBF;E2Ij0pBA;IACE,iDAAA;IACA,yCAAA;E3Im0pBF;AACF;A2Ih0pBA;EACE;IACE,yCAAA;E3Ik0pBF;E2Ih0pBA;IACE,0CAAA;E3Ik0pBF;AACF;A2I/zpBA;EACE;IACE,sBAAA;E3Ii0pBF;E2I/zpBA;IACE,qBAAA;E3Ii0pBF;AACF","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap v4.5.2 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n  --blue: #00cfe8;\n  --indigo: #6610f2;\n  --purple: #9b67f0;\n  --pink: #e83e8c;\n  --red: #de4827;\n  --orange: #d56729;\n  --yellow: #ffc107;\n  --green: #28c76f;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fdfeff;\n  --gray: #b8c2cc;\n  --gray-dark: #1e1e1e;\n  --primary: #00a0dd;\n  --secondary: #de4827;\n  --success: #28c76f;\n  --info: #222d69;\n  --warning: #d56729;\n  --danger: #de4827;\n  --light: #f6f6f6;\n  --dark: #232323;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: \"Montserrat\", Helvetica, Arial, serif;\n  --font-family-monospace: \"Montserrat\", Helvetica, Arial, serif;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(30, 29, 43, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #6e6b7b;\n  text-align: left;\n  background-color: #f8f8f8;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.4375rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 500;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: 600;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #00a0dd;\n  text-decoration: none;\n  background-color: transparent;\n}\na:hover {\n  color: #008ec4;\n  text-decoration: none;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n  color: #b9b9c3;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.25rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.4375rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #5e5873;\n}\n\nh1, .h1 {\n  font-size: 1.75rem;\n}\n\nh2, .h2 {\n  font-size: 1.49975rem;\n}\n\nh3, .h3 {\n  font-size: 1.3125rem;\n}\n\nh4, .h4 {\n  font-size: 1.12525rem;\n}\n\nh5, .h5 {\n  font-size: 0.93625rem;\n}\n\nh6, .h6 {\n  font-size: 0.875rem;\n}\n\n.lead {\n  font-size: 0.9975rem;\n  font-weight: 400;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\nhr {\n  margin-top: 0.875rem;\n  margin-bottom: 0.875rem;\n  border: 0;\n  border-top: 1px solid #ebe9f1;\n}\n\nsmall,\n.small {\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 0.875rem;\n  font-size: 1.09375rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 0.75rem;\n  color: #b9b9c3;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #f8f8f8;\n  border: 1px solid #dae1e7;\n  border-radius: 0.3125rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.4375rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #b8c2cc;\n}\n\ncode {\n  font-size: 90%;\n  color: #e83e8c;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 90%;\n  color: #fdfeff;\n  background-color: #eee;\n  border-radius: 0.21875rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 500;\n}\n\npre {\n  display: block;\n  font-size: 90%;\n  color: #2a2e30;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: 0.875rem;\n  padding-left: 0.875rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n.container-xl, .container-lg, .container-md, .container-sm, .container {\n  max-width: 1440px;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -0.875rem;\n  margin-left: -0.875rem;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-xl,\n.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,\n.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,\n.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,\n.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,\n.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {\n  position: relative;\n  width: 100%;\n  padding-right: 0.875rem;\n  padding-left: 0.875rem;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.3333333333%;\n}\n\n.offset-2 {\n  margin-left: 16.6666666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.3333333333%;\n}\n\n.offset-5 {\n  margin-left: 41.6666666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.3333333333%;\n}\n\n.offset-8 {\n  margin-left: 66.6666666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.3333333333%;\n}\n\n.offset-11 {\n  margin-left: 91.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-sm-first {\n    order: -1;\n  }\n\n  .order-sm-last {\n    order: 13;\n  }\n\n  .order-sm-0 {\n    order: 0;\n  }\n\n  .order-sm-1 {\n    order: 1;\n  }\n\n  .order-sm-2 {\n    order: 2;\n  }\n\n  .order-sm-3 {\n    order: 3;\n  }\n\n  .order-sm-4 {\n    order: 4;\n  }\n\n  .order-sm-5 {\n    order: 5;\n  }\n\n  .order-sm-6 {\n    order: 6;\n  }\n\n  .order-sm-7 {\n    order: 7;\n  }\n\n  .order-sm-8 {\n    order: 8;\n  }\n\n  .order-sm-9 {\n    order: 9;\n  }\n\n  .order-sm-10 {\n    order: 10;\n  }\n\n  .order-sm-11 {\n    order: 11;\n  }\n\n  .order-sm-12 {\n    order: 12;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-md-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-md-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-md-first {\n    order: -1;\n  }\n\n  .order-md-last {\n    order: 13;\n  }\n\n  .order-md-0 {\n    order: 0;\n  }\n\n  .order-md-1 {\n    order: 1;\n  }\n\n  .order-md-2 {\n    order: 2;\n  }\n\n  .order-md-3 {\n    order: 3;\n  }\n\n  .order-md-4 {\n    order: 4;\n  }\n\n  .order-md-5 {\n    order: 5;\n  }\n\n  .order-md-6 {\n    order: 6;\n  }\n\n  .order-md-7 {\n    order: 7;\n  }\n\n  .order-md-8 {\n    order: 8;\n  }\n\n  .order-md-9 {\n    order: 9;\n  }\n\n  .order-md-10 {\n    order: 10;\n  }\n\n  .order-md-11 {\n    order: 11;\n  }\n\n  .order-md-12 {\n    order: 12;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-lg-first {\n    order: -1;\n  }\n\n  .order-lg-last {\n    order: 13;\n  }\n\n  .order-lg-0 {\n    order: 0;\n  }\n\n  .order-lg-1 {\n    order: 1;\n  }\n\n  .order-lg-2 {\n    order: 2;\n  }\n\n  .order-lg-3 {\n    order: 3;\n  }\n\n  .order-lg-4 {\n    order: 4;\n  }\n\n  .order-lg-5 {\n    order: 5;\n  }\n\n  .order-lg-6 {\n    order: 6;\n  }\n\n  .order-lg-7 {\n    order: 7;\n  }\n\n  .order-lg-8 {\n    order: 8;\n  }\n\n  .order-lg-9 {\n    order: 9;\n  }\n\n  .order-lg-10 {\n    order: 10;\n  }\n\n  .order-lg-11 {\n    order: 11;\n  }\n\n  .order-lg-12 {\n    order: 12;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .order-xl-first {\n    order: -1;\n  }\n\n  .order-xl-last {\n    order: 13;\n  }\n\n  .order-xl-0 {\n    order: 0;\n  }\n\n  .order-xl-1 {\n    order: 1;\n  }\n\n  .order-xl-2 {\n    order: 2;\n  }\n\n  .order-xl-3 {\n    order: 3;\n  }\n\n  .order-xl-4 {\n    order: 4;\n  }\n\n  .order-xl-5 {\n    order: 5;\n  }\n\n  .order-xl-6 {\n    order: 6;\n  }\n\n  .order-xl-7 {\n    order: 7;\n  }\n\n  .order-xl-8 {\n    order: 8;\n  }\n\n  .order-xl-9 {\n    order: 9;\n  }\n\n  .order-xl-10 {\n    order: 10;\n  }\n\n  .order-xl-11 {\n    order: 11;\n  }\n\n  .order-xl-12 {\n    order: 12;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.3333333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.6666666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.3333333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.6666666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.3333333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.6666666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.3333333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n.table {\n  width: 100%;\n  margin-bottom: 0.875rem;\n  color: #6e6b7b;\n}\n.table th,\n.table td {\n  padding: 0.625rem;\n  vertical-align: top;\n  border-top: 1px solid #ebe9f1;\n}\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ebe9f1;\n}\n.table tbody + tbody {\n  border-top: 2px solid #ebe9f1;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 1px solid #ebe9f1;\n}\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #ebe9f1;\n}\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #fafafc;\n}\n\n.table-hover tbody tr:hover {\n  color: #6e6b7b;\n  background-color: #f6f6f9;\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #b6e4f5;\n}\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #79cded;\n}\n\n.table-hover .table-primary:hover {\n  background-color: #a0dcf2;\n}\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: #a0dcf2;\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #f4cbc3;\n}\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #ed9f8f;\n}\n\n.table-hover .table-secondary:hover {\n  background-color: #f0b8ad;\n}\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: #f0b8ad;\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #c1efd7;\n}\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #8ee1b4;\n}\n\n.table-hover .table-success:hover {\n  background-color: #adeaca;\n}\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: #adeaca;\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #c0c3d5;\n}\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #8b91b1;\n}\n\n.table-hover .table-info:hover {\n  background-color: #b1b4cb;\n}\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: #b1b4cb;\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #f2d4c3;\n}\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #e8af90;\n}\n\n.table-hover .table-warning:hover {\n  background-color: #edc5ae;\n}\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: #edc5ae;\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #f4cbc3;\n}\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #ed9f8f;\n}\n\n.table-hover .table-danger:hover {\n  background-color: #f0b8ad;\n}\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: #f0b8ad;\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fbfcfc;\n}\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #f9fafa;\n}\n\n.table-hover .table-light:hover {\n  background-color: #ecf1f1;\n}\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: #ecf1f1;\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c0c1c1;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #8c8c8d;\n}\n\n.table-hover .table-dark:hover {\n  background-color: #b3b4b4;\n}\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: #b3b4b4;\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: #f6f6f9;\n}\n\n.table-hover .table-active:hover {\n  background-color: #e7e7ef;\n}\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: #e7e7ef;\n}\n\n.table .thead-dark th {\n  color: #fdfeff;\n  background-color: #232323;\n  border-color: #404040;\n}\n.table .thead-light th {\n  color: #5e5873;\n  background-color: #f3f2f7;\n  border-color: #ebe9f1;\n}\n\n.table-dark {\n  color: #fdfeff;\n  background-color: #232323;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: #404040;\n}\n.table-dark.table-bordered {\n  border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(253, 254, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n  color: #fdfeff;\n  background-color: rgba(253, 254, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: 2.714rem;\n  padding: 0.438rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #6e6b7b;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border: 1px solid #d8d6de;\n  border-radius: 0.3125rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #6e6b7b;\n}\n.form-control:focus {\n  color: #6e6b7b;\n  background-color: #fdfeff;\n  border-color: #00a0dd;\n  outline: 0;\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.form-control::placeholder {\n  color: #b9b9c3;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #efefef;\n  opacity: 1;\n}\n\ninput[type=date].form-control,\ninput[type=time].form-control,\ninput[type=datetime-local].form-control,\ninput[type=month].form-control {\n  appearance: none;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #6e6b7b;\n  background-color: #fdfeff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.438rem + 1px);\n  padding-bottom: calc(0.438rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.45;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.75rem + 1px);\n  padding-bottom: calc(0.75rem + 1px);\n  font-size: 1.143rem;\n  line-height: 1.25;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.188rem + 1px);\n  padding-bottom: calc(0.188rem + 1px);\n  font-size: 0.857rem;\n  line-height: 1;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.438rem 0;\n  margin-bottom: 0;\n  font-size: 1rem;\n  line-height: 1.45;\n  color: #6e6b7b;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: 2.142rem;\n  padding: 0.188rem 0.857rem;\n  font-size: 0.857rem;\n  line-height: 1;\n  border-radius: 0.3125rem;\n}\n\n.form-control-lg {\n  height: 3.2857rem;\n  padding: 0.75rem 1.143rem;\n  font-size: 1.143rem;\n  line-height: 1.25;\n  border-radius: 0.3125rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  color: #b9b9c3;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #28c76f;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.35rem 0.678125rem;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: #fdfeff;\n  background-color: #28c76f;\n  border-radius: 0.3125rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #28c76f;\n  padding-right: calc(1.45em + 0.876rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328c76f' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.3625em + 0.219rem) center;\n  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #28c76f;\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.45em + 0.876rem);\n  background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);\n}\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #28c76f;\n  padding-right: calc(0.75em + 2.657rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23d8d6de' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 1rem center/10px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328c76f' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fdfeff no-repeat center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);\n}\n.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n  border-color: #28c76f;\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28c76f;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28c76f;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  border-color: #28c76f;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #48da89;\n  background-color: #48da89;\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);\n}\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #28c76f;\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28c76f;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #28c76f;\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #de4827;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.35rem 0.678125rem;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  line-height: 1.45;\n  color: #fdfeff;\n  background-color: #de4827;\n  border-radius: 0.3125rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #de4827;\n  padding-right: calc(1.45em + 0.876rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23de4827' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23de4827' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.3625em + 0.219rem) center;\n  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #de4827;\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.45em + 0.876rem);\n  background-position: top calc(0.3625em + 0.219rem) right calc(0.3625em + 0.219rem);\n}\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #de4827;\n  padding-right: calc(0.75em + 2.657rem);\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23d8d6de' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 1rem center/10px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23de4827' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23de4827' stroke='none'/%3e%3c/svg%3e\") #fdfeff no-repeat center right 2rem/calc(0.725em + 0.438rem) calc(0.725em + 0.438rem);\n}\n.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n  border-color: #de4827;\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #de4827;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #de4827;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  border-color: #de4827;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #e56d53;\n  background-color: #e56d53;\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);\n}\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #de4827;\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #de4827;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #de4827;\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n.form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  color: #6e6b7b;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.6875rem 1.3125rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  border-radius: 0.313rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #6e6b7b;\n  text-decoration: none;\n}\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.25);\n}\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n}\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.btn-primary:hover {\n  color: #fdfeff;\n  background-color: #0084b7;\n  border-color: #007baa;\n}\n.btn-primary:focus, .btn-primary.focus {\n  color: #fdfeff;\n  background-color: #0084b7;\n  border-color: #007baa;\n  box-shadow: 0 0 0 0.2rem rgba(38, 174, 226, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #007baa;\n  border-color: #00729d;\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(38, 174, 226, 0.5);\n}\n\n.btn-secondary {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-secondary:hover {\n  color: #fdfeff;\n  background-color: #c13b1e;\n  border-color: #b6381c;\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  color: #fdfeff;\n  background-color: #c13b1e;\n  border-color: #b6381c;\n  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #b6381c;\n  border-color: #ab341a;\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);\n}\n\n.btn-success {\n  color: #fdfeff;\n  background-color: #28c76f;\n  border-color: #28c76f;\n}\n.btn-success:hover {\n  color: #fdfeff;\n  background-color: #22a75d;\n  border-color: #1f9d57;\n}\n.btn-success:focus, .btn-success.focus {\n  color: #fdfeff;\n  background-color: #22a75d;\n  border-color: #1f9d57;\n  box-shadow: 0 0 0 0.2rem rgba(72, 207, 133, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fdfeff;\n  background-color: #28c76f;\n  border-color: #28c76f;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #1f9d57;\n  border-color: #1d9251;\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(72, 207, 133, 0.5);\n}\n\n.btn-info {\n  color: #fdfeff;\n  background-color: #222d69;\n  border-color: #222d69;\n}\n.btn-info:hover {\n  color: #fdfeff;\n  background-color: #19214c;\n  border-color: #161c42;\n}\n.btn-info:focus, .btn-info.focus {\n  color: #fdfeff;\n  background-color: #19214c;\n  border-color: #161c42;\n  box-shadow: 0 0 0 0.2rem rgba(67, 76, 128, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fdfeff;\n  background-color: #222d69;\n  border-color: #222d69;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #161c42;\n  border-color: #121839;\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(67, 76, 128, 0.5);\n}\n\n.btn-warning {\n  color: #fdfeff;\n  background-color: #d56729;\n  border-color: #d56729;\n}\n.btn-warning:hover {\n  color: #fdfeff;\n  background-color: #b55723;\n  border-color: #aa5221;\n}\n.btn-warning:focus, .btn-warning.focus {\n  color: #fdfeff;\n  background-color: #b55723;\n  border-color: #aa5221;\n  box-shadow: 0 0 0 0.2rem rgba(219, 126, 73, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #fdfeff;\n  background-color: #d56729;\n  border-color: #d56729;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #aa5221;\n  border-color: #a04d1f;\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(219, 126, 73, 0.5);\n}\n\n.btn-danger {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-danger:hover {\n  color: #fdfeff;\n  background-color: #c13b1e;\n  border-color: #b6381c;\n}\n.btn-danger:focus, .btn-danger.focus {\n  color: #fdfeff;\n  background-color: #c13b1e;\n  border-color: #b6381c;\n  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #b6381c;\n  border-color: #ab341a;\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(227, 99, 71, 0.5);\n}\n\n.btn-light {\n  color: #2a2e30;\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n}\n.btn-light:hover {\n  color: #2a2e30;\n  background-color: #e3e3e3;\n  border-color: #dddddd;\n}\n.btn-light:focus, .btn-light.focus {\n  color: #2a2e30;\n  background-color: #e3e3e3;\n  border-color: #dddddd;\n  box-shadow: 0 0 0 0.2rem rgba(215, 216, 216, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #2a2e30;\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #2a2e30;\n  background-color: #dddddd;\n  border-color: #d6d6d6;\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(215, 216, 216, 0.5);\n}\n\n.btn-dark {\n  color: #fdfeff;\n  background-color: #232323;\n  border-color: #232323;\n}\n.btn-dark:hover {\n  color: #fdfeff;\n  background-color: #101010;\n  border-color: #0a0a0a;\n}\n.btn-dark:focus, .btn-dark.focus {\n  color: #fdfeff;\n  background-color: #101010;\n  border-color: #0a0a0a;\n  box-shadow: 0 0 0 0.2rem rgba(68, 68, 68, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fdfeff;\n  background-color: #232323;\n  border-color: #232323;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #0a0a0a;\n  border-color: #030303;\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(68, 68, 68, 0.5);\n}\n\n.btn-outline-primary {\n  color: #00a0dd;\n  border-color: #00a0dd;\n}\n.btn-outline-primary:hover {\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #00a0dd;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-secondary:hover {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #de4827;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n\n.btn-outline-success {\n  color: #28c76f;\n  border-color: #28c76f;\n}\n.btn-outline-success:hover {\n  color: #fdfeff;\n  background-color: #28c76f;\n  border-color: #28c76f;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #28c76f;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #28c76f;\n  border-color: #28c76f;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);\n}\n\n.btn-outline-info {\n  color: #222d69;\n  border-color: #222d69;\n}\n.btn-outline-info:hover {\n  color: #fdfeff;\n  background-color: #222d69;\n  border-color: #222d69;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #222d69;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #222d69;\n  border-color: #222d69;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);\n}\n\n.btn-outline-warning {\n  color: #d56729;\n  border-color: #d56729;\n}\n.btn-outline-warning:hover {\n  color: #fdfeff;\n  background-color: #d56729;\n  border-color: #d56729;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #d56729;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #d56729;\n  border-color: #d56729;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);\n}\n\n.btn-outline-danger {\n  color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-danger:hover {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #de4827;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #de4827;\n  border-color: #de4827;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n\n.btn-outline-light {\n  color: #f6f6f6;\n  border-color: #f6f6f6;\n}\n.btn-outline-light:hover {\n  color: #2a2e30;\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #f6f6f6;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #2a2e30;\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);\n}\n\n.btn-outline-dark {\n  color: #232323;\n  border-color: #232323;\n}\n.btn-outline-dark:hover {\n  color: #fdfeff;\n  background-color: #232323;\n  border-color: #232323;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #232323;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #232323;\n  border-color: #232323;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #00a0dd;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: #008ec4;\n  text-decoration: none;\n}\n.btn-link:focus, .btn-link.focus {\n  text-decoration: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #b8c2cc;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.7rem 1.75rem;\n  font-size: 1.09375rem;\n  line-height: 1.25;\n  border-radius: 0.313rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.425rem 0.875rem;\n  font-size: 0.7875rem;\n  line-height: 1;\n  border-radius: 0.313rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=submit].btn-block,\ninput[type=reset].btn-block,\ninput[type=button].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 10;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0 0 0;\n  font-size: 1rem;\n  color: #6e6b7b;\n  text-align: left;\n  list-style: none;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border: 1px solid rgba(30, 29, 43, 0.05);\n  border-radius: 0.358rem;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.4375rem 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(30, 29, 43, 0.08);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.65rem 1.28rem;\n  clear: both;\n  font-weight: 400;\n  color: #6e6b7b;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: #00a0dd;\n  text-decoration: none;\n  background-color: rgba(0, 160, 221, 0.12);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fdfeff;\n  text-decoration: none;\n  background-color: #00a0dd;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #b9b9c3;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.28rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: #5e5873;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.65rem 1.28rem;\n  color: #6e6b7b;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.984375rem;\n  padding-left: 0.984375rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.65625rem;\n  padding-left: 0.65625rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.3125rem;\n  padding-left: 1.3125rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=radio],\n.btn-group-toggle > .btn input[type=checkbox],\n.btn-group-toggle > .btn-group > .btn input[type=radio],\n.btn-group-toggle > .btn-group > .btn input[type=checkbox] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n.input-group > .form-control:not(:last-child),\n.input-group > .custom-select:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.438rem 1rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #6e6b7b;\n  text-align: center;\n  white-space: nowrap;\n  background-color: white;\n  border: 1px solid #d8d6de;\n  border-radius: 0.3125rem;\n}\n.input-group-text input[type=radio],\n.input-group-text input[type=checkbox] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: 3.2857rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.75rem 1.143rem;\n  font-size: 1.143rem;\n  line-height: 1.25;\n  border-radius: 0.3125rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: 2.142rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.188rem 0.857rem;\n  font-size: 0.857rem;\n  line-height: 1;\n  border-radius: 0.3125rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 2rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.26875rem;\n  padding-left: 1.5rem;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1rem;\n  height: 1.134375rem;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fdfeff;\n  border-color: #00a0dd;\n  background-color: #00a0dd;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #00a0dd;\n}\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fdfeff;\n  background-color: #91e1ff;\n  border-color: #91e1ff;\n}\n.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n  color: #b8c2cc;\n}\n.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #efefef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n.custom-control-label::before {\n  position: absolute;\n  top: 0.134375rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fdfeff;\n  border: #d8d6de solid 1px;\n}\n.custom-control-label::after {\n  position: absolute;\n  top: 0.134375rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background: no-repeat 50%/50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 3px;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.5 7.5'%3E%3Cpolyline points='0.75 4.35 4.18 6.75 8.75 0.75' style='fill:none;stroke:%23fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px'/%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #00a0dd;\n  background-color: #00a0dd;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cline x1='5' y1='12' x2='19' y2='12'%3E%3C/line%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 160, 221, 0.65);\n}\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(0, 160, 221, 0.65);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: none;\n}\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 160, 221, 0.65);\n}\n\n.custom-switch {\n  padding-left: 3.125rem;\n}\n.custom-switch .custom-control-label::before {\n  left: -3.125rem;\n  width: 2.625rem;\n  pointer-events: all;\n  border-radius: 0.875rem;\n}\n.custom-switch .custom-control-label::after {\n  top: calc(0.134375rem + 2px);\n  left: calc(-3.125rem + 2px);\n  width: 0.875rem;\n  height: 0.875rem;\n  background-color: #d8d6de;\n  border-radius: 0.875rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fdfeff;\n  transform: translateX(1.625rem);\n}\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 160, 221, 0.65);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: 2.714rem;\n  padding: 0.438rem 2rem 0.438rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #6e6b7b;\n  vertical-align: middle;\n  background: #fdfeff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23d8d6de' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 1rem center/10px 10px;\n  border: 1px solid #d8d6de;\n  border-radius: 0.3125rem;\n  appearance: none;\n}\n.custom-select:focus {\n  border-color: #00a0dd;\n  outline: 0;\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-select:focus::-ms-value {\n  color: #6e6b7b;\n  background-color: #fdfeff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 1rem;\n  background-image: none;\n}\n.custom-select:disabled {\n  color: #b8c2cc;\n  background-color: #efefef;\n}\n.custom-select::-ms-expand {\n  display: none;\n}\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #6e6b7b;\n}\n\n.custom-select-sm {\n  height: 2.142rem;\n  padding-top: 0.188rem;\n  padding-bottom: 0.188rem;\n  padding-left: 0.857rem;\n  font-size: 0.857rem;\n}\n\n.custom-select-lg {\n  height: 3.2857rem;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1.143rem;\n  font-size: 1.143rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 2.714rem;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: 2.714rem;\n  margin: 0;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: #00a0dd;\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {\n  background-color: #efefef;\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: 2.714rem;\n  padding: 0.438rem 1rem;\n  font-weight: 400;\n  line-height: 1.45;\n  color: #6e6b7b;\n  background-color: #fdfeff;\n  border: 1px solid #d8d6de;\n  border-radius: 0.3125rem;\n}\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: 2.714rem;\n  padding: 0.438rem 1rem;\n  line-height: 1.45;\n  color: #6e6b7b;\n  content: \"Browse\";\n  background-color: white;\n  border-left: inherit;\n  border-radius: 0 0.3125rem 0.3125rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.custom-range:focus {\n  outline: none;\n}\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #f8f8f8, 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #00a0dd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #91e1ff;\n}\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dae1e7;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #00a0dd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.custom-range::-moz-range-thumb:active {\n  background-color: #91e1ff;\n}\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dae1e7;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #00a0dd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n.custom-range::-ms-thumb:active {\n  background-color: #91e1ff;\n}\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n.custom-range::-ms-fill-lower {\n  background-color: #dae1e7;\n  border-radius: 1rem;\n}\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dae1e7;\n  border-radius: 1rem;\n}\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border-color 0s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n.custom-file-label,\n.custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.358rem 0.5rem;\n}\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n.nav-link.disabled {\n  color: #b9b9c3;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 0 solid #dae1e7;\n}\n.nav-tabs .nav-item {\n  margin-bottom: 0;\n}\n.nav-tabs .nav-link {\n  border: 0 solid transparent;\n  border-top-left-radius: 0.25;\n  border-top-right-radius: 0.25;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #ededed #ededed #dae1e7;\n}\n.nav-tabs .nav-link.disabled {\n  color: #b9b9c3;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #00a0dd;\n  background-color: transparent;\n  border-color: #dae1e7 #dae1e7 transparent;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.313rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fdfeff;\n  background-color: #00a0dd;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.4375rem 0.875rem;\n}\n.navbar .container,\n.navbar .container-fluid,\n.navbar .container-sm,\n.navbar .container-md,\n.navbar .container-lg,\n.navbar .container-xl,\n.navbar .container-xxl {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: -0.457625rem;\n  padding-bottom: -0.457625rem;\n  margin-right: 0.875rem;\n  font-size: 2rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.358rem;\n  padding-bottom: 0.358rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 2rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.313rem;\n}\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n.navbar-expand-sm > .container-fluid,\n.navbar-expand-sm > .container-sm,\n.navbar-expand-sm > .container-md,\n.navbar-expand-sm > .container-lg,\n.navbar-expand-sm > .container-xl,\n.navbar-expand-sm > .container-xxl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm > .container,\n.navbar-expand-sm > .container-fluid,\n.navbar-expand-sm > .container-sm,\n.navbar-expand-sm > .container-md,\n.navbar-expand-sm > .container-lg,\n.navbar-expand-sm > .container-xl,\n.navbar-expand-sm > .container-xxl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n.navbar-expand-md > .container-fluid,\n.navbar-expand-md > .container-sm,\n.navbar-expand-md > .container-md,\n.navbar-expand-md > .container-lg,\n.navbar-expand-md > .container-xl,\n.navbar-expand-md > .container-xxl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container,\n.navbar-expand-md > .container-fluid,\n.navbar-expand-md > .container-sm,\n.navbar-expand-md > .container-md,\n.navbar-expand-md > .container-lg,\n.navbar-expand-md > .container-xl,\n.navbar-expand-md > .container-xxl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n.navbar-expand-lg > .container-fluid,\n.navbar-expand-lg > .container-sm,\n.navbar-expand-lg > .container-md,\n.navbar-expand-lg > .container-lg,\n.navbar-expand-lg > .container-xl,\n.navbar-expand-lg > .container-xxl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg > .container,\n.navbar-expand-lg > .container-fluid,\n.navbar-expand-lg > .container-sm,\n.navbar-expand-lg > .container-md,\n.navbar-expand-lg > .container-lg,\n.navbar-expand-lg > .container-xl,\n.navbar-expand-lg > .container-xxl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n.navbar-expand-xl > .container-fluid,\n.navbar-expand-xl > .container-sm,\n.navbar-expand-xl > .container-md,\n.navbar-expand-xl > .container-lg,\n.navbar-expand-xl > .container-xl,\n.navbar-expand-xl > .container-xxl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl > .container,\n.navbar-expand-xl > .container-fluid,\n.navbar-expand-xl > .container-sm,\n.navbar-expand-xl > .container-md,\n.navbar-expand-xl > .container-lg,\n.navbar-expand-xl > .container-xl,\n.navbar-expand-xl > .container-xxl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl,\n.navbar-expand > .container-xxl {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl,\n.navbar-expand > .container-xxl {\n  flex-wrap: nowrap;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(30, 29, 43, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(30, 29, 43, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(30, 29, 43, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(30, 29, 43, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(30, 29, 43, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(30, 29, 43, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(30, 29, 43, 0.5);\n  border-color: rgba(30, 29, 43, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2830, 29, 43, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(30, 29, 43, 0.5);\n}\n.navbar-light .navbar-text a {\n  color: rgba(30, 29, 43, 0.9);\n}\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(30, 29, 43, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fdfeff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fdfeff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(253, 254, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(253, 254, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(253, 254, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fdfeff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(253, 254, 255, 0.5);\n  border-color: rgba(253, 254, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28253, 254, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(253, 254, 255, 0.5);\n}\n.navbar-dark .navbar-text a {\n  color: #fdfeff;\n}\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: #fdfeff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fdfeff;\n  background-clip: border-box;\n  border: 1px solid rgba(30, 29, 43, 0.125);\n  border-radius: 0.428rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.428rem - 1px);\n  border-top-right-radius: calc(0.428rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.428rem - 1px);\n  border-bottom-left-radius: calc(0.428rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.5rem;\n}\n\n.card-title {\n  margin-bottom: 1.5rem;\n}\n\n.card-subtitle {\n  margin-top: -0.75rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.5rem;\n}\n\n.card-header {\n  padding: 1.5rem 1.5rem;\n  margin-bottom: 0;\n  background-color: rgba(30, 29, 43, 0.03);\n  border-bottom: 1px solid rgba(30, 29, 43, 0.125);\n}\n.card-header:first-child {\n  border-radius: calc(0.428rem - 1px) calc(0.428rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 1.5rem 1.5rem;\n  background-color: rgba(30, 29, 43, 0.03);\n  border-top: 1px solid rgba(30, 29, 43, 0.125);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.428rem - 1px) calc(0.428rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.75rem;\n  margin-bottom: -1.5rem;\n  margin-left: -0.75rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.75rem;\n  margin-left: -0.75rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.428rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.428rem - 1px);\n  border-top-right-radius: calc(0.428rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.428rem - 1px);\n  border-bottom-left-radius: calc(0.428rem - 1px);\n}\n\n.card-deck .card {\n  margin-bottom: 0.875rem;\n}\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -0.875rem;\n    margin-left: -0.875rem;\n  }\n  .card-deck .card {\n    flex: 1 0 0%;\n    margin-right: 0.875rem;\n    margin-bottom: 0;\n    margin-left: 0.875rem;\n  }\n}\n\n.card-group > .card {\n  margin-bottom: 0.875rem;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n.card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n.card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n.card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n.card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 1.5rem;\n}\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n.accordion > .card {\n  overflow: hidden;\n}\n.accordion > .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.accordion > .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.accordion > .card > .card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  list-style: none;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.breadcrumb-item {\n  display: flex;\n}\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.525rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.525rem;\n  color: #6e6b7b;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #6e6b7b;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.3125rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.85rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #6e6b7b;\n  background-color: #f3f2f7;\n  border: 1px solid #dae1e7;\n}\n.page-link:hover {\n  z-index: 2;\n  color: #00a0dd;\n  text-decoration: none;\n  background-color: #f3f2f7;\n  border-color: #dae1e7;\n}\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.25);\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  color: #00a0dd;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.page-item.disabled .page-link {\n  color: #b9b9c3;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #f3f2f7;\n  border-color: #dae1e7;\n}\n\n.pagination-lg .page-link {\n  padding: 0.5575rem 1rem;\n  font-size: 2rem;\n  line-height: 1.25;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.525rem;\n  border-bottom-left-radius: 0.525rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.525rem;\n  border-bottom-right-radius: 0.525rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.443rem 0.745rem;\n  font-size: 1rem;\n  line-height: 1;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.21875rem;\n  border-bottom-left-radius: 0.21875rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.21875rem;\n  border-bottom-right-radius: 0.21875rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.2625rem 0.4375rem;\n  font-size: 85%;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.3125rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.4375rem;\n  padding-left: 0.4375rem;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fdfeff;\n  background-color: #00a0dd;\n}\na.badge-primary:hover, a.badge-primary:focus {\n  color: #fdfeff;\n  background-color: #007baa;\n}\na.badge-primary:focus, a.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 160, 221, 0.5);\n}\n\n.badge-secondary {\n  color: #fdfeff;\n  background-color: #de4827;\n}\na.badge-secondary:hover, a.badge-secondary:focus {\n  color: #fdfeff;\n  background-color: #b6381c;\n}\na.badge-secondary:focus, a.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n\n.badge-success {\n  color: #fdfeff;\n  background-color: #28c76f;\n}\na.badge-success:hover, a.badge-success:focus {\n  color: #fdfeff;\n  background-color: #1f9d57;\n}\na.badge-success:focus, a.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(40, 199, 111, 0.5);\n}\n\n.badge-info {\n  color: #fdfeff;\n  background-color: #222d69;\n}\na.badge-info:hover, a.badge-info:focus {\n  color: #fdfeff;\n  background-color: #161c42;\n}\na.badge-info:focus, a.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(34, 45, 105, 0.5);\n}\n\n.badge-warning {\n  color: #fdfeff;\n  background-color: #d56729;\n}\na.badge-warning:hover, a.badge-warning:focus {\n  color: #fdfeff;\n  background-color: #aa5221;\n}\na.badge-warning:focus, a.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(213, 103, 41, 0.5);\n}\n\n.badge-danger {\n  color: #fdfeff;\n  background-color: #de4827;\n}\na.badge-danger:hover, a.badge-danger:focus {\n  color: #fdfeff;\n  background-color: #b6381c;\n}\na.badge-danger:focus, a.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(222, 72, 39, 0.5);\n}\n\n.badge-light {\n  color: #2a2e30;\n  background-color: #f6f6f6;\n}\na.badge-light:hover, a.badge-light:focus {\n  color: #2a2e30;\n  background-color: #dddddd;\n}\na.badge-light:focus, a.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(246, 246, 246, 0.5);\n}\n\n.badge-dark {\n  color: #fdfeff;\n  background-color: #232323;\n}\na.badge-dark:hover, a.badge-dark:focus {\n  color: #fdfeff;\n  background-color: #0a0a0a;\n}\na.badge-dark:focus, a.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(35, 35, 35, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #ededed;\n  border-radius: 0.525rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.71rem 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.358rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.71rem 1rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #0e6188;\n  background-color: #caebf8;\n  border-color: #b6e4f5;\n}\n.alert-primary hr {\n  border-top-color: #a0dcf2;\n}\n.alert-primary .alert-link {\n  color: #09405a;\n}\n\n.alert-secondary {\n  color: #823329;\n  background-color: #f7dad4;\n  border-color: #f4cbc3;\n}\n.alert-secondary hr {\n  border-top-color: #f0b8ad;\n}\n.alert-secondary .alert-link {\n  color: #5b241d;\n}\n\n.alert-success {\n  color: #23754e;\n  background-color: #d2f3e2;\n  border-color: #c1efd7;\n}\n.alert-success hr {\n  border-top-color: #adeaca;\n}\n.alert-success .alert-link {\n  color: #174e34;\n}\n\n.alert-info {\n  color: #20254b;\n  background-color: #d1d4e1;\n  border-color: #c0c3d5;\n}\n.alert-info hr {\n  border-top-color: #b1b4cb;\n}\n.alert-info .alert-link {\n  color: #111327;\n}\n\n.alert-warning {\n  color: #7d432a;\n  background-color: #f5e0d4;\n  border-color: #f2d4c3;\n}\n.alert-warning hr {\n  border-top-color: #edc5ae;\n}\n.alert-warning .alert-link {\n  color: #572f1d;\n}\n\n.alert-danger {\n  color: #823329;\n  background-color: #f7dad4;\n  border-color: #f4cbc3;\n}\n.alert-danger hr {\n  border-top-color: #f0b8ad;\n}\n.alert-danger .alert-link {\n  color: #5b241d;\n}\n\n.alert-light {\n  color: #8e8e95;\n  background-color: #fcfcfd;\n  border-color: #fbfcfc;\n}\n.alert-light hr {\n  border-top-color: #ecf1f1;\n}\n.alert-light .alert-link {\n  color: #74747c;\n}\n\n.alert-dark {\n  color: #212027;\n  background-color: #d1d2d3;\n  border-color: #c0c1c1;\n}\n.alert-dark hr {\n  border-top-color: #b3b4b4;\n}\n.alert-dark .alert-link {\n  color: #09090b;\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 0.75rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  display: flex;\n  height: 0.75rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.749875rem;\n  background-color: rgba(0, 160, 221, 0.12);\n  border-radius: 4.375rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fdfeff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #00a0dd;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(253, 254, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(253, 254, 255, 0.15) 50%, rgba(253, 254, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 0.75rem 0.75rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.358rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #4e5154;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #4e5154;\n  text-decoration: none;\n  background-color: #babfc7;\n}\n.list-group-item-action:active {\n  color: #6e6b7b;\n  background-color: #ededed;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fdfeff;\n  border: 1px solid rgba(30, 29, 43, 0.125);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #b9b9c3;\n  pointer-events: none;\n  background-color: #fdfeff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.358rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.358rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.358rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.358rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.358rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.358rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.358rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.358rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.358rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.358rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: #0e6188;\n  background-color: #b6e4f5;\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: #0e6188;\n  background-color: #a0dcf2;\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #0e6188;\n  border-color: #0e6188;\n}\n\n.list-group-item-secondary {\n  color: #823329;\n  background-color: #f4cbc3;\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: #823329;\n  background-color: #f0b8ad;\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #823329;\n  border-color: #823329;\n}\n\n.list-group-item-success {\n  color: #23754e;\n  background-color: #c1efd7;\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: #23754e;\n  background-color: #adeaca;\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #23754e;\n  border-color: #23754e;\n}\n\n.list-group-item-info {\n  color: #20254b;\n  background-color: #c0c3d5;\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: #20254b;\n  background-color: #b1b4cb;\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #20254b;\n  border-color: #20254b;\n}\n\n.list-group-item-warning {\n  color: #7d432a;\n  background-color: #f2d4c3;\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: #7d432a;\n  background-color: #edc5ae;\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #7d432a;\n  border-color: #7d432a;\n}\n\n.list-group-item-danger {\n  color: #823329;\n  background-color: #f4cbc3;\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: #823329;\n  background-color: #f0b8ad;\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #823329;\n  border-color: #823329;\n}\n\n.list-group-item-light {\n  color: #8e8e95;\n  background-color: #fbfcfc;\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: #8e8e95;\n  background-color: #ecf1f1;\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #8e8e95;\n  border-color: #8e8e95;\n}\n\n.list-group-item-dark {\n  color: #212027;\n  background-color: #c0c1c1;\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: #212027;\n  background-color: #b3b4b4;\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fdfeff;\n  background-color: #212027;\n  border-color: #212027;\n}\n\n.close {\n  float: right;\n  font-size: 1.75rem;\n  font-weight: 400;\n  line-height: 1;\n  color: #5e5873;\n  text-shadow: 0 1px 0 #fdfeff;\n  opacity: 0.5;\n}\n.close:hover {\n  color: #5e5873;\n  text-decoration: none;\n}\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: 0.75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  flex-basis: 380px;\n  max-width: 380px;\n  font-size: 0.75rem;\n  color: #6e6b7b;\n  background-color: rgba(253, 254, 255, 0.85);\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 20px 0 rgba(30, 29, 43, 0.08);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n.toast:not(:last-child) {\n  margin-bottom: 1rem;\n}\n.toast.showing {\n  opacity: 1;\n}\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.125rem 1rem;\n  color: #6e6b7b;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border-bottom: 0 solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.toast-body {\n  padding: 1rem;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  flex-shrink: 0;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: min-content;\n  content: \"\";\n}\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border: 1px solid rgba(30, 29, 43, 0.2);\n  border-radius: 0.3125rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #1e1d2b;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 0.7rem 1.225rem;\n  border-bottom: 1px solid #ebe9f1;\n  border-top-left-radius: calc(0.3125rem - 1px);\n  border-top-right-radius: calc(0.3125rem - 1px);\n}\n.modal-header .close {\n  padding: 0.7rem 1.225rem;\n  margin: -0.7rem -1.225rem -0.7rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.45;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 0.7rem 1.225rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.7rem 1.225rem-0.25rem;\n  border-top: 1px solid rgba(30, 29, 43, 0.05);\n  border-bottom-right-radius: calc(0.3125rem - 1px);\n  border-bottom-left-radius: calc(0.3125rem - 1px);\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: min-content;\n  }\n\n  .modal-sm {\n    max-width: 400px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n.modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 94%;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.45;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.75rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 1;\n}\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #323232;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #323232;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #323232;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #323232;\n}\n\n.tooltip-inner {\n  max-width: 220px;\n  padding: 0.35rem 0.678125rem;\n  color: #fdfeff;\n  text-align: center;\n  background-color: #323232;\n  border-radius: 0.3125rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.45;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border: 0 solid #ebe9f1;\n  border-radius: 0.3125rem;\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.3125rem;\n}\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=top] {\n  margin-bottom: 0.5rem;\n}\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {\n  bottom: -0.5rem;\n}\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #ebe9f1;\n}\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fdfeff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=right] {\n  margin-left: 0.5rem;\n}\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {\n  left: -0.5rem;\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3125rem 0;\n}\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #ebe9f1;\n}\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fdfeff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {\n  margin-top: 0.5rem;\n}\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {\n  top: -0.5rem;\n}\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #ebe9f1;\n}\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fdfeff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 0 solid #00a0dd;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=left] {\n  margin-right: 0.5rem;\n}\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {\n  right: -0.5rem;\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.3125rem 0;\n}\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #ebe9f1;\n}\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fdfeff;\n}\n\n.popover-header {\n  padding: 0.5625rem 1.0625rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #fdfeff;\n  background-color: #00a0dd;\n  border-bottom: 0 solid #008ec4;\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5625rem 1.0625rem;\n  color: #6e6b7b;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fdfeff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n.carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fdfeff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50%/100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%23fdfeff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"%3e%3cpolyline points=\"15 18 9 12 15 6\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n\n.carousel-control-next-icon {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"%23fdfeff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"%3e%3cpolyline points=\"9 18 15 12 9 6\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fdfeff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fdfeff;\n  text-align: center;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow 0.75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #00a0dd !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #007baa !important;\n}\n\n.bg-secondary {\n  background-color: #de4827 !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #b6381c !important;\n}\n\n.bg-success {\n  background-color: #28c76f !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #1f9d57 !important;\n}\n\n.bg-info {\n  background-color: #222d69 !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #161c42 !important;\n}\n\n.bg-warning {\n  background-color: #d56729 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #aa5221 !important;\n}\n\n.bg-danger {\n  background-color: #de4827 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #b6381c !important;\n}\n\n.bg-light {\n  background-color: #f6f6f6 !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #dddddd !important;\n}\n\n.bg-dark {\n  background-color: #232323 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #0a0a0a !important;\n}\n\n.bg-white {\n  background-color: #fdfeff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #ebe9f1 !important;\n}\n\n.border-top {\n  border-top: 1px solid #ebe9f1 !important;\n}\n\n.border-right {\n  border-right: 1px solid #ebe9f1 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #ebe9f1 !important;\n}\n\n.border-left {\n  border-left: 1px solid #ebe9f1 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #00a0dd !important;\n}\n\n.border-secondary {\n  border-color: #de4827 !important;\n}\n\n.border-success {\n  border-color: #28c76f !important;\n}\n\n.border-info {\n  border-color: #222d69 !important;\n}\n\n.border-warning {\n  border-color: #d56729 !important;\n}\n\n.border-danger {\n  border-color: #de4827 !important;\n}\n\n.border-light {\n  border-color: #f6f6f6 !important;\n}\n\n.border-dark {\n  border-color: #232323 !important;\n}\n\n.border-white {\n  border-color: #fdfeff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.21875rem !important;\n}\n\n.rounded {\n  border-radius: 0.3125rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.3125rem !important;\n  border-top-right-radius: 0.3125rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.3125rem !important;\n  border-bottom-right-radius: 0.3125rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.3125rem !important;\n  border-bottom-left-radius: 0.3125rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.3125rem !important;\n  border-bottom-left-radius: 0.3125rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.525rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n\n  .float-sm-right {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n\n  .float-md-right {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n\n  .float-lg-right {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n\n  .float-xl-right {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(30, 29, 43, 0.075) !important;\n}\n\n.shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(30, 29, 43, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.875rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.875rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.875rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.875rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.875rem !important;\n}\n\n.m-2 {\n  margin: 1.3125rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 1.3125rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 1.3125rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 1.3125rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 1.3125rem !important;\n}\n\n.m-3 {\n  margin: 2.625rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 2.625rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 2.625rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 2.625rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 2.625rem !important;\n}\n\n.m-4 {\n  margin: 3.0625rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 3.0625rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 3.0625rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 3.0625rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 3.0625rem !important;\n}\n\n.m-5 {\n  margin: 3.5rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3.5rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3.5rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3.5rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3.5rem !important;\n}\n\n.m-25 {\n  margin: 0.21875rem !important;\n}\n\n.mt-25,\n.my-25 {\n  margin-top: 0.21875rem !important;\n}\n\n.mr-25,\n.mx-25 {\n  margin-right: 0.21875rem !important;\n}\n\n.mb-25,\n.my-25 {\n  margin-bottom: 0.21875rem !important;\n}\n\n.ml-25,\n.mx-25 {\n  margin-left: 0.21875rem !important;\n}\n\n.m-50 {\n  margin: 0.4375rem !important;\n}\n\n.mt-50,\n.my-50 {\n  margin-top: 0.4375rem !important;\n}\n\n.mr-50,\n.mx-50 {\n  margin-right: 0.4375rem !important;\n}\n\n.mb-50,\n.my-50 {\n  margin-bottom: 0.4375rem !important;\n}\n\n.ml-50,\n.mx-50 {\n  margin-left: 0.4375rem !important;\n}\n\n.m-75 {\n  margin: 0.65625rem !important;\n}\n\n.mt-75,\n.my-75 {\n  margin-top: 0.65625rem !important;\n}\n\n.mr-75,\n.mx-75 {\n  margin-right: 0.65625rem !important;\n}\n\n.mb-75,\n.my-75 {\n  margin-bottom: 0.65625rem !important;\n}\n\n.ml-75,\n.mx-75 {\n  margin-left: 0.65625rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.875rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.875rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.875rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.875rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.875rem !important;\n}\n\n.p-2 {\n  padding: 1.3125rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 1.3125rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 1.3125rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 1.3125rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 1.3125rem !important;\n}\n\n.p-3 {\n  padding: 2.625rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 2.625rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 2.625rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 2.625rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 2.625rem !important;\n}\n\n.p-4 {\n  padding: 3.0625rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 3.0625rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 3.0625rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 3.0625rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 3.0625rem !important;\n}\n\n.p-5 {\n  padding: 3.5rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3.5rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3.5rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3.5rem !important;\n}\n\n.p-25 {\n  padding: 0.21875rem !important;\n}\n\n.pt-25,\n.py-25 {\n  padding-top: 0.21875rem !important;\n}\n\n.pr-25,\n.px-25 {\n  padding-right: 0.21875rem !important;\n}\n\n.pb-25,\n.py-25 {\n  padding-bottom: 0.21875rem !important;\n}\n\n.pl-25,\n.px-25 {\n  padding-left: 0.21875rem !important;\n}\n\n.p-50 {\n  padding: 0.4375rem !important;\n}\n\n.pt-50,\n.py-50 {\n  padding-top: 0.4375rem !important;\n}\n\n.pr-50,\n.px-50 {\n  padding-right: 0.4375rem !important;\n}\n\n.pb-50,\n.py-50 {\n  padding-bottom: 0.4375rem !important;\n}\n\n.pl-50,\n.px-50 {\n  padding-left: 0.4375rem !important;\n}\n\n.p-75 {\n  padding: 0.65625rem !important;\n}\n\n.pt-75,\n.py-75 {\n  padding-top: 0.65625rem !important;\n}\n\n.pr-75,\n.px-75 {\n  padding-right: 0.65625rem !important;\n}\n\n.pb-75,\n.py-75 {\n  padding-bottom: 0.65625rem !important;\n}\n\n.pl-75,\n.px-75 {\n  padding-left: 0.65625rem !important;\n}\n\n.m-n1 {\n  margin: -0.875rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.875rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.875rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.875rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.875rem !important;\n}\n\n.m-n2 {\n  margin: -1.3125rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -1.3125rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -1.3125rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -1.3125rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -1.3125rem !important;\n}\n\n.m-n3 {\n  margin: -2.625rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -2.625rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -2.625rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -2.625rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -2.625rem !important;\n}\n\n.m-n4 {\n  margin: -3.0625rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -3.0625rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -3.0625rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -3.0625rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -3.0625rem !important;\n}\n\n.m-n5 {\n  margin: -3.5rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3.5rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3.5rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3.5rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3.5rem !important;\n}\n\n.m-n25 {\n  margin: -0.21875rem !important;\n}\n\n.mt-n25,\n.my-n25 {\n  margin-top: -0.21875rem !important;\n}\n\n.mr-n25,\n.mx-n25 {\n  margin-right: -0.21875rem !important;\n}\n\n.mb-n25,\n.my-n25 {\n  margin-bottom: -0.21875rem !important;\n}\n\n.ml-n25,\n.mx-n25 {\n  margin-left: -0.21875rem !important;\n}\n\n.m-n50 {\n  margin: -0.4375rem !important;\n}\n\n.mt-n50,\n.my-n50 {\n  margin-top: -0.4375rem !important;\n}\n\n.mr-n50,\n.mx-n50 {\n  margin-right: -0.4375rem !important;\n}\n\n.mb-n50,\n.my-n50 {\n  margin-bottom: -0.4375rem !important;\n}\n\n.ml-n50,\n.mx-n50 {\n  margin-left: -0.4375rem !important;\n}\n\n.m-n75 {\n  margin: -0.65625rem !important;\n}\n\n.mt-n75,\n.my-n75 {\n  margin-top: -0.65625rem !important;\n}\n\n.mr-n75,\n.mx-n75 {\n  margin-right: -0.65625rem !important;\n}\n\n.mb-n75,\n.my-n75 {\n  margin-bottom: -0.65625rem !important;\n}\n\n.ml-n75,\n.mx-n75 {\n  margin-left: -0.65625rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .mt-sm-0,\n.my-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-sm-0,\n.mx-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-sm-0,\n.my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-sm-0,\n.mx-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.875rem !important;\n  }\n\n  .mt-sm-1,\n.my-sm-1 {\n    margin-top: 0.875rem !important;\n  }\n\n  .mr-sm-1,\n.mx-sm-1 {\n    margin-right: 0.875rem !important;\n  }\n\n  .mb-sm-1,\n.my-sm-1 {\n    margin-bottom: 0.875rem !important;\n  }\n\n  .ml-sm-1,\n.mx-sm-1 {\n    margin-left: 0.875rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 1.3125rem !important;\n  }\n\n  .mt-sm-2,\n.my-sm-2 {\n    margin-top: 1.3125rem !important;\n  }\n\n  .mr-sm-2,\n.mx-sm-2 {\n    margin-right: 1.3125rem !important;\n  }\n\n  .mb-sm-2,\n.my-sm-2 {\n    margin-bottom: 1.3125rem !important;\n  }\n\n  .ml-sm-2,\n.mx-sm-2 {\n    margin-left: 1.3125rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 2.625rem !important;\n  }\n\n  .mt-sm-3,\n.my-sm-3 {\n    margin-top: 2.625rem !important;\n  }\n\n  .mr-sm-3,\n.mx-sm-3 {\n    margin-right: 2.625rem !important;\n  }\n\n  .mb-sm-3,\n.my-sm-3 {\n    margin-bottom: 2.625rem !important;\n  }\n\n  .ml-sm-3,\n.mx-sm-3 {\n    margin-left: 2.625rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 3.0625rem !important;\n  }\n\n  .mt-sm-4,\n.my-sm-4 {\n    margin-top: 3.0625rem !important;\n  }\n\n  .mr-sm-4,\n.mx-sm-4 {\n    margin-right: 3.0625rem !important;\n  }\n\n  .mb-sm-4,\n.my-sm-4 {\n    margin-bottom: 3.0625rem !important;\n  }\n\n  .ml-sm-4,\n.mx-sm-4 {\n    margin-left: 3.0625rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 3.5rem !important;\n  }\n\n  .mt-sm-5,\n.my-sm-5 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mr-sm-5,\n.mx-sm-5 {\n    margin-right: 3.5rem !important;\n  }\n\n  .mb-sm-5,\n.my-sm-5 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .ml-sm-5,\n.mx-sm-5 {\n    margin-left: 3.5rem !important;\n  }\n\n  .m-sm-25 {\n    margin: 0.21875rem !important;\n  }\n\n  .mt-sm-25,\n.my-sm-25 {\n    margin-top: 0.21875rem !important;\n  }\n\n  .mr-sm-25,\n.mx-sm-25 {\n    margin-right: 0.21875rem !important;\n  }\n\n  .mb-sm-25,\n.my-sm-25 {\n    margin-bottom: 0.21875rem !important;\n  }\n\n  .ml-sm-25,\n.mx-sm-25 {\n    margin-left: 0.21875rem !important;\n  }\n\n  .m-sm-50 {\n    margin: 0.4375rem !important;\n  }\n\n  .mt-sm-50,\n.my-sm-50 {\n    margin-top: 0.4375rem !important;\n  }\n\n  .mr-sm-50,\n.mx-sm-50 {\n    margin-right: 0.4375rem !important;\n  }\n\n  .mb-sm-50,\n.my-sm-50 {\n    margin-bottom: 0.4375rem !important;\n  }\n\n  .ml-sm-50,\n.mx-sm-50 {\n    margin-left: 0.4375rem !important;\n  }\n\n  .m-sm-75 {\n    margin: 0.65625rem !important;\n  }\n\n  .mt-sm-75,\n.my-sm-75 {\n    margin-top: 0.65625rem !important;\n  }\n\n  .mr-sm-75,\n.mx-sm-75 {\n    margin-right: 0.65625rem !important;\n  }\n\n  .mb-sm-75,\n.my-sm-75 {\n    margin-bottom: 0.65625rem !important;\n  }\n\n  .ml-sm-75,\n.mx-sm-75 {\n    margin-left: 0.65625rem !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .pt-sm-0,\n.py-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-sm-0,\n.px-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-sm-0,\n.py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-sm-0,\n.px-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.875rem !important;\n  }\n\n  .pt-sm-1,\n.py-sm-1 {\n    padding-top: 0.875rem !important;\n  }\n\n  .pr-sm-1,\n.px-sm-1 {\n    padding-right: 0.875rem !important;\n  }\n\n  .pb-sm-1,\n.py-sm-1 {\n    padding-bottom: 0.875rem !important;\n  }\n\n  .pl-sm-1,\n.px-sm-1 {\n    padding-left: 0.875rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 1.3125rem !important;\n  }\n\n  .pt-sm-2,\n.py-sm-2 {\n    padding-top: 1.3125rem !important;\n  }\n\n  .pr-sm-2,\n.px-sm-2 {\n    padding-right: 1.3125rem !important;\n  }\n\n  .pb-sm-2,\n.py-sm-2 {\n    padding-bottom: 1.3125rem !important;\n  }\n\n  .pl-sm-2,\n.px-sm-2 {\n    padding-left: 1.3125rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 2.625rem !important;\n  }\n\n  .pt-sm-3,\n.py-sm-3 {\n    padding-top: 2.625rem !important;\n  }\n\n  .pr-sm-3,\n.px-sm-3 {\n    padding-right: 2.625rem !important;\n  }\n\n  .pb-sm-3,\n.py-sm-3 {\n    padding-bottom: 2.625rem !important;\n  }\n\n  .pl-sm-3,\n.px-sm-3 {\n    padding-left: 2.625rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 3.0625rem !important;\n  }\n\n  .pt-sm-4,\n.py-sm-4 {\n    padding-top: 3.0625rem !important;\n  }\n\n  .pr-sm-4,\n.px-sm-4 {\n    padding-right: 3.0625rem !important;\n  }\n\n  .pb-sm-4,\n.py-sm-4 {\n    padding-bottom: 3.0625rem !important;\n  }\n\n  .pl-sm-4,\n.px-sm-4 {\n    padding-left: 3.0625rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 3.5rem !important;\n  }\n\n  .pt-sm-5,\n.py-sm-5 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pr-sm-5,\n.px-sm-5 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pb-sm-5,\n.py-sm-5 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pl-sm-5,\n.px-sm-5 {\n    padding-left: 3.5rem !important;\n  }\n\n  .p-sm-25 {\n    padding: 0.21875rem !important;\n  }\n\n  .pt-sm-25,\n.py-sm-25 {\n    padding-top: 0.21875rem !important;\n  }\n\n  .pr-sm-25,\n.px-sm-25 {\n    padding-right: 0.21875rem !important;\n  }\n\n  .pb-sm-25,\n.py-sm-25 {\n    padding-bottom: 0.21875rem !important;\n  }\n\n  .pl-sm-25,\n.px-sm-25 {\n    padding-left: 0.21875rem !important;\n  }\n\n  .p-sm-50 {\n    padding: 0.4375rem !important;\n  }\n\n  .pt-sm-50,\n.py-sm-50 {\n    padding-top: 0.4375rem !important;\n  }\n\n  .pr-sm-50,\n.px-sm-50 {\n    padding-right: 0.4375rem !important;\n  }\n\n  .pb-sm-50,\n.py-sm-50 {\n    padding-bottom: 0.4375rem !important;\n  }\n\n  .pl-sm-50,\n.px-sm-50 {\n    padding-left: 0.4375rem !important;\n  }\n\n  .p-sm-75 {\n    padding: 0.65625rem !important;\n  }\n\n  .pt-sm-75,\n.py-sm-75 {\n    padding-top: 0.65625rem !important;\n  }\n\n  .pr-sm-75,\n.px-sm-75 {\n    padding-right: 0.65625rem !important;\n  }\n\n  .pb-sm-75,\n.py-sm-75 {\n    padding-bottom: 0.65625rem !important;\n  }\n\n  .pl-sm-75,\n.px-sm-75 {\n    padding-left: 0.65625rem !important;\n  }\n\n  .m-sm-n1 {\n    margin: -0.875rem !important;\n  }\n\n  .mt-sm-n1,\n.my-sm-n1 {\n    margin-top: -0.875rem !important;\n  }\n\n  .mr-sm-n1,\n.mx-sm-n1 {\n    margin-right: -0.875rem !important;\n  }\n\n  .mb-sm-n1,\n.my-sm-n1 {\n    margin-bottom: -0.875rem !important;\n  }\n\n  .ml-sm-n1,\n.mx-sm-n1 {\n    margin-left: -0.875rem !important;\n  }\n\n  .m-sm-n2 {\n    margin: -1.3125rem !important;\n  }\n\n  .mt-sm-n2,\n.my-sm-n2 {\n    margin-top: -1.3125rem !important;\n  }\n\n  .mr-sm-n2,\n.mx-sm-n2 {\n    margin-right: -1.3125rem !important;\n  }\n\n  .mb-sm-n2,\n.my-sm-n2 {\n    margin-bottom: -1.3125rem !important;\n  }\n\n  .ml-sm-n2,\n.mx-sm-n2 {\n    margin-left: -1.3125rem !important;\n  }\n\n  .m-sm-n3 {\n    margin: -2.625rem !important;\n  }\n\n  .mt-sm-n3,\n.my-sm-n3 {\n    margin-top: -2.625rem !important;\n  }\n\n  .mr-sm-n3,\n.mx-sm-n3 {\n    margin-right: -2.625rem !important;\n  }\n\n  .mb-sm-n3,\n.my-sm-n3 {\n    margin-bottom: -2.625rem !important;\n  }\n\n  .ml-sm-n3,\n.mx-sm-n3 {\n    margin-left: -2.625rem !important;\n  }\n\n  .m-sm-n4 {\n    margin: -3.0625rem !important;\n  }\n\n  .mt-sm-n4,\n.my-sm-n4 {\n    margin-top: -3.0625rem !important;\n  }\n\n  .mr-sm-n4,\n.mx-sm-n4 {\n    margin-right: -3.0625rem !important;\n  }\n\n  .mb-sm-n4,\n.my-sm-n4 {\n    margin-bottom: -3.0625rem !important;\n  }\n\n  .ml-sm-n4,\n.mx-sm-n4 {\n    margin-left: -3.0625rem !important;\n  }\n\n  .m-sm-n5 {\n    margin: -3.5rem !important;\n  }\n\n  .mt-sm-n5,\n.my-sm-n5 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mr-sm-n5,\n.mx-sm-n5 {\n    margin-right: -3.5rem !important;\n  }\n\n  .mb-sm-n5,\n.my-sm-n5 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .ml-sm-n5,\n.mx-sm-n5 {\n    margin-left: -3.5rem !important;\n  }\n\n  .m-sm-n25 {\n    margin: -0.21875rem !important;\n  }\n\n  .mt-sm-n25,\n.my-sm-n25 {\n    margin-top: -0.21875rem !important;\n  }\n\n  .mr-sm-n25,\n.mx-sm-n25 {\n    margin-right: -0.21875rem !important;\n  }\n\n  .mb-sm-n25,\n.my-sm-n25 {\n    margin-bottom: -0.21875rem !important;\n  }\n\n  .ml-sm-n25,\n.mx-sm-n25 {\n    margin-left: -0.21875rem !important;\n  }\n\n  .m-sm-n50 {\n    margin: -0.4375rem !important;\n  }\n\n  .mt-sm-n50,\n.my-sm-n50 {\n    margin-top: -0.4375rem !important;\n  }\n\n  .mr-sm-n50,\n.mx-sm-n50 {\n    margin-right: -0.4375rem !important;\n  }\n\n  .mb-sm-n50,\n.my-sm-n50 {\n    margin-bottom: -0.4375rem !important;\n  }\n\n  .ml-sm-n50,\n.mx-sm-n50 {\n    margin-left: -0.4375rem !important;\n  }\n\n  .m-sm-n75 {\n    margin: -0.65625rem !important;\n  }\n\n  .mt-sm-n75,\n.my-sm-n75 {\n    margin-top: -0.65625rem !important;\n  }\n\n  .mr-sm-n75,\n.mx-sm-n75 {\n    margin-right: -0.65625rem !important;\n  }\n\n  .mb-sm-n75,\n.my-sm-n75 {\n    margin-bottom: -0.65625rem !important;\n  }\n\n  .ml-sm-n75,\n.mx-sm-n75 {\n    margin-left: -0.65625rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mt-sm-auto,\n.my-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-sm-auto,\n.mx-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-auto,\n.my-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-sm-auto,\n.mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .mt-md-0,\n.my-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-md-0,\n.mx-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-md-0,\n.my-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-md-0,\n.mx-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.875rem !important;\n  }\n\n  .mt-md-1,\n.my-md-1 {\n    margin-top: 0.875rem !important;\n  }\n\n  .mr-md-1,\n.mx-md-1 {\n    margin-right: 0.875rem !important;\n  }\n\n  .mb-md-1,\n.my-md-1 {\n    margin-bottom: 0.875rem !important;\n  }\n\n  .ml-md-1,\n.mx-md-1 {\n    margin-left: 0.875rem !important;\n  }\n\n  .m-md-2 {\n    margin: 1.3125rem !important;\n  }\n\n  .mt-md-2,\n.my-md-2 {\n    margin-top: 1.3125rem !important;\n  }\n\n  .mr-md-2,\n.mx-md-2 {\n    margin-right: 1.3125rem !important;\n  }\n\n  .mb-md-2,\n.my-md-2 {\n    margin-bottom: 1.3125rem !important;\n  }\n\n  .ml-md-2,\n.mx-md-2 {\n    margin-left: 1.3125rem !important;\n  }\n\n  .m-md-3 {\n    margin: 2.625rem !important;\n  }\n\n  .mt-md-3,\n.my-md-3 {\n    margin-top: 2.625rem !important;\n  }\n\n  .mr-md-3,\n.mx-md-3 {\n    margin-right: 2.625rem !important;\n  }\n\n  .mb-md-3,\n.my-md-3 {\n    margin-bottom: 2.625rem !important;\n  }\n\n  .ml-md-3,\n.mx-md-3 {\n    margin-left: 2.625rem !important;\n  }\n\n  .m-md-4 {\n    margin: 3.0625rem !important;\n  }\n\n  .mt-md-4,\n.my-md-4 {\n    margin-top: 3.0625rem !important;\n  }\n\n  .mr-md-4,\n.mx-md-4 {\n    margin-right: 3.0625rem !important;\n  }\n\n  .mb-md-4,\n.my-md-4 {\n    margin-bottom: 3.0625rem !important;\n  }\n\n  .ml-md-4,\n.mx-md-4 {\n    margin-left: 3.0625rem !important;\n  }\n\n  .m-md-5 {\n    margin: 3.5rem !important;\n  }\n\n  .mt-md-5,\n.my-md-5 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mr-md-5,\n.mx-md-5 {\n    margin-right: 3.5rem !important;\n  }\n\n  .mb-md-5,\n.my-md-5 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .ml-md-5,\n.mx-md-5 {\n    margin-left: 3.5rem !important;\n  }\n\n  .m-md-25 {\n    margin: 0.21875rem !important;\n  }\n\n  .mt-md-25,\n.my-md-25 {\n    margin-top: 0.21875rem !important;\n  }\n\n  .mr-md-25,\n.mx-md-25 {\n    margin-right: 0.21875rem !important;\n  }\n\n  .mb-md-25,\n.my-md-25 {\n    margin-bottom: 0.21875rem !important;\n  }\n\n  .ml-md-25,\n.mx-md-25 {\n    margin-left: 0.21875rem !important;\n  }\n\n  .m-md-50 {\n    margin: 0.4375rem !important;\n  }\n\n  .mt-md-50,\n.my-md-50 {\n    margin-top: 0.4375rem !important;\n  }\n\n  .mr-md-50,\n.mx-md-50 {\n    margin-right: 0.4375rem !important;\n  }\n\n  .mb-md-50,\n.my-md-50 {\n    margin-bottom: 0.4375rem !important;\n  }\n\n  .ml-md-50,\n.mx-md-50 {\n    margin-left: 0.4375rem !important;\n  }\n\n  .m-md-75 {\n    margin: 0.65625rem !important;\n  }\n\n  .mt-md-75,\n.my-md-75 {\n    margin-top: 0.65625rem !important;\n  }\n\n  .mr-md-75,\n.mx-md-75 {\n    margin-right: 0.65625rem !important;\n  }\n\n  .mb-md-75,\n.my-md-75 {\n    margin-bottom: 0.65625rem !important;\n  }\n\n  .ml-md-75,\n.mx-md-75 {\n    margin-left: 0.65625rem !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .pt-md-0,\n.py-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-md-0,\n.px-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-md-0,\n.py-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-md-0,\n.px-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.875rem !important;\n  }\n\n  .pt-md-1,\n.py-md-1 {\n    padding-top: 0.875rem !important;\n  }\n\n  .pr-md-1,\n.px-md-1 {\n    padding-right: 0.875rem !important;\n  }\n\n  .pb-md-1,\n.py-md-1 {\n    padding-bottom: 0.875rem !important;\n  }\n\n  .pl-md-1,\n.px-md-1 {\n    padding-left: 0.875rem !important;\n  }\n\n  .p-md-2 {\n    padding: 1.3125rem !important;\n  }\n\n  .pt-md-2,\n.py-md-2 {\n    padding-top: 1.3125rem !important;\n  }\n\n  .pr-md-2,\n.px-md-2 {\n    padding-right: 1.3125rem !important;\n  }\n\n  .pb-md-2,\n.py-md-2 {\n    padding-bottom: 1.3125rem !important;\n  }\n\n  .pl-md-2,\n.px-md-2 {\n    padding-left: 1.3125rem !important;\n  }\n\n  .p-md-3 {\n    padding: 2.625rem !important;\n  }\n\n  .pt-md-3,\n.py-md-3 {\n    padding-top: 2.625rem !important;\n  }\n\n  .pr-md-3,\n.px-md-3 {\n    padding-right: 2.625rem !important;\n  }\n\n  .pb-md-3,\n.py-md-3 {\n    padding-bottom: 2.625rem !important;\n  }\n\n  .pl-md-3,\n.px-md-3 {\n    padding-left: 2.625rem !important;\n  }\n\n  .p-md-4 {\n    padding: 3.0625rem !important;\n  }\n\n  .pt-md-4,\n.py-md-4 {\n    padding-top: 3.0625rem !important;\n  }\n\n  .pr-md-4,\n.px-md-4 {\n    padding-right: 3.0625rem !important;\n  }\n\n  .pb-md-4,\n.py-md-4 {\n    padding-bottom: 3.0625rem !important;\n  }\n\n  .pl-md-4,\n.px-md-4 {\n    padding-left: 3.0625rem !important;\n  }\n\n  .p-md-5 {\n    padding: 3.5rem !important;\n  }\n\n  .pt-md-5,\n.py-md-5 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pr-md-5,\n.px-md-5 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pb-md-5,\n.py-md-5 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pl-md-5,\n.px-md-5 {\n    padding-left: 3.5rem !important;\n  }\n\n  .p-md-25 {\n    padding: 0.21875rem !important;\n  }\n\n  .pt-md-25,\n.py-md-25 {\n    padding-top: 0.21875rem !important;\n  }\n\n  .pr-md-25,\n.px-md-25 {\n    padding-right: 0.21875rem !important;\n  }\n\n  .pb-md-25,\n.py-md-25 {\n    padding-bottom: 0.21875rem !important;\n  }\n\n  .pl-md-25,\n.px-md-25 {\n    padding-left: 0.21875rem !important;\n  }\n\n  .p-md-50 {\n    padding: 0.4375rem !important;\n  }\n\n  .pt-md-50,\n.py-md-50 {\n    padding-top: 0.4375rem !important;\n  }\n\n  .pr-md-50,\n.px-md-50 {\n    padding-right: 0.4375rem !important;\n  }\n\n  .pb-md-50,\n.py-md-50 {\n    padding-bottom: 0.4375rem !important;\n  }\n\n  .pl-md-50,\n.px-md-50 {\n    padding-left: 0.4375rem !important;\n  }\n\n  .p-md-75 {\n    padding: 0.65625rem !important;\n  }\n\n  .pt-md-75,\n.py-md-75 {\n    padding-top: 0.65625rem !important;\n  }\n\n  .pr-md-75,\n.px-md-75 {\n    padding-right: 0.65625rem !important;\n  }\n\n  .pb-md-75,\n.py-md-75 {\n    padding-bottom: 0.65625rem !important;\n  }\n\n  .pl-md-75,\n.px-md-75 {\n    padding-left: 0.65625rem !important;\n  }\n\n  .m-md-n1 {\n    margin: -0.875rem !important;\n  }\n\n  .mt-md-n1,\n.my-md-n1 {\n    margin-top: -0.875rem !important;\n  }\n\n  .mr-md-n1,\n.mx-md-n1 {\n    margin-right: -0.875rem !important;\n  }\n\n  .mb-md-n1,\n.my-md-n1 {\n    margin-bottom: -0.875rem !important;\n  }\n\n  .ml-md-n1,\n.mx-md-n1 {\n    margin-left: -0.875rem !important;\n  }\n\n  .m-md-n2 {\n    margin: -1.3125rem !important;\n  }\n\n  .mt-md-n2,\n.my-md-n2 {\n    margin-top: -1.3125rem !important;\n  }\n\n  .mr-md-n2,\n.mx-md-n2 {\n    margin-right: -1.3125rem !important;\n  }\n\n  .mb-md-n2,\n.my-md-n2 {\n    margin-bottom: -1.3125rem !important;\n  }\n\n  .ml-md-n2,\n.mx-md-n2 {\n    margin-left: -1.3125rem !important;\n  }\n\n  .m-md-n3 {\n    margin: -2.625rem !important;\n  }\n\n  .mt-md-n3,\n.my-md-n3 {\n    margin-top: -2.625rem !important;\n  }\n\n  .mr-md-n3,\n.mx-md-n3 {\n    margin-right: -2.625rem !important;\n  }\n\n  .mb-md-n3,\n.my-md-n3 {\n    margin-bottom: -2.625rem !important;\n  }\n\n  .ml-md-n3,\n.mx-md-n3 {\n    margin-left: -2.625rem !important;\n  }\n\n  .m-md-n4 {\n    margin: -3.0625rem !important;\n  }\n\n  .mt-md-n4,\n.my-md-n4 {\n    margin-top: -3.0625rem !important;\n  }\n\n  .mr-md-n4,\n.mx-md-n4 {\n    margin-right: -3.0625rem !important;\n  }\n\n  .mb-md-n4,\n.my-md-n4 {\n    margin-bottom: -3.0625rem !important;\n  }\n\n  .ml-md-n4,\n.mx-md-n4 {\n    margin-left: -3.0625rem !important;\n  }\n\n  .m-md-n5 {\n    margin: -3.5rem !important;\n  }\n\n  .mt-md-n5,\n.my-md-n5 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mr-md-n5,\n.mx-md-n5 {\n    margin-right: -3.5rem !important;\n  }\n\n  .mb-md-n5,\n.my-md-n5 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .ml-md-n5,\n.mx-md-n5 {\n    margin-left: -3.5rem !important;\n  }\n\n  .m-md-n25 {\n    margin: -0.21875rem !important;\n  }\n\n  .mt-md-n25,\n.my-md-n25 {\n    margin-top: -0.21875rem !important;\n  }\n\n  .mr-md-n25,\n.mx-md-n25 {\n    margin-right: -0.21875rem !important;\n  }\n\n  .mb-md-n25,\n.my-md-n25 {\n    margin-bottom: -0.21875rem !important;\n  }\n\n  .ml-md-n25,\n.mx-md-n25 {\n    margin-left: -0.21875rem !important;\n  }\n\n  .m-md-n50 {\n    margin: -0.4375rem !important;\n  }\n\n  .mt-md-n50,\n.my-md-n50 {\n    margin-top: -0.4375rem !important;\n  }\n\n  .mr-md-n50,\n.mx-md-n50 {\n    margin-right: -0.4375rem !important;\n  }\n\n  .mb-md-n50,\n.my-md-n50 {\n    margin-bottom: -0.4375rem !important;\n  }\n\n  .ml-md-n50,\n.mx-md-n50 {\n    margin-left: -0.4375rem !important;\n  }\n\n  .m-md-n75 {\n    margin: -0.65625rem !important;\n  }\n\n  .mt-md-n75,\n.my-md-n75 {\n    margin-top: -0.65625rem !important;\n  }\n\n  .mr-md-n75,\n.mx-md-n75 {\n    margin-right: -0.65625rem !important;\n  }\n\n  .mb-md-n75,\n.my-md-n75 {\n    margin-bottom: -0.65625rem !important;\n  }\n\n  .ml-md-n75,\n.mx-md-n75 {\n    margin-left: -0.65625rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mt-md-auto,\n.my-md-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-md-auto,\n.mx-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-auto,\n.my-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-md-auto,\n.mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .mt-lg-0,\n.my-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-lg-0,\n.mx-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-lg-0,\n.my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-lg-0,\n.mx-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.875rem !important;\n  }\n\n  .mt-lg-1,\n.my-lg-1 {\n    margin-top: 0.875rem !important;\n  }\n\n  .mr-lg-1,\n.mx-lg-1 {\n    margin-right: 0.875rem !important;\n  }\n\n  .mb-lg-1,\n.my-lg-1 {\n    margin-bottom: 0.875rem !important;\n  }\n\n  .ml-lg-1,\n.mx-lg-1 {\n    margin-left: 0.875rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 1.3125rem !important;\n  }\n\n  .mt-lg-2,\n.my-lg-2 {\n    margin-top: 1.3125rem !important;\n  }\n\n  .mr-lg-2,\n.mx-lg-2 {\n    margin-right: 1.3125rem !important;\n  }\n\n  .mb-lg-2,\n.my-lg-2 {\n    margin-bottom: 1.3125rem !important;\n  }\n\n  .ml-lg-2,\n.mx-lg-2 {\n    margin-left: 1.3125rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 2.625rem !important;\n  }\n\n  .mt-lg-3,\n.my-lg-3 {\n    margin-top: 2.625rem !important;\n  }\n\n  .mr-lg-3,\n.mx-lg-3 {\n    margin-right: 2.625rem !important;\n  }\n\n  .mb-lg-3,\n.my-lg-3 {\n    margin-bottom: 2.625rem !important;\n  }\n\n  .ml-lg-3,\n.mx-lg-3 {\n    margin-left: 2.625rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 3.0625rem !important;\n  }\n\n  .mt-lg-4,\n.my-lg-4 {\n    margin-top: 3.0625rem !important;\n  }\n\n  .mr-lg-4,\n.mx-lg-4 {\n    margin-right: 3.0625rem !important;\n  }\n\n  .mb-lg-4,\n.my-lg-4 {\n    margin-bottom: 3.0625rem !important;\n  }\n\n  .ml-lg-4,\n.mx-lg-4 {\n    margin-left: 3.0625rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 3.5rem !important;\n  }\n\n  .mt-lg-5,\n.my-lg-5 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mr-lg-5,\n.mx-lg-5 {\n    margin-right: 3.5rem !important;\n  }\n\n  .mb-lg-5,\n.my-lg-5 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .ml-lg-5,\n.mx-lg-5 {\n    margin-left: 3.5rem !important;\n  }\n\n  .m-lg-25 {\n    margin: 0.21875rem !important;\n  }\n\n  .mt-lg-25,\n.my-lg-25 {\n    margin-top: 0.21875rem !important;\n  }\n\n  .mr-lg-25,\n.mx-lg-25 {\n    margin-right: 0.21875rem !important;\n  }\n\n  .mb-lg-25,\n.my-lg-25 {\n    margin-bottom: 0.21875rem !important;\n  }\n\n  .ml-lg-25,\n.mx-lg-25 {\n    margin-left: 0.21875rem !important;\n  }\n\n  .m-lg-50 {\n    margin: 0.4375rem !important;\n  }\n\n  .mt-lg-50,\n.my-lg-50 {\n    margin-top: 0.4375rem !important;\n  }\n\n  .mr-lg-50,\n.mx-lg-50 {\n    margin-right: 0.4375rem !important;\n  }\n\n  .mb-lg-50,\n.my-lg-50 {\n    margin-bottom: 0.4375rem !important;\n  }\n\n  .ml-lg-50,\n.mx-lg-50 {\n    margin-left: 0.4375rem !important;\n  }\n\n  .m-lg-75 {\n    margin: 0.65625rem !important;\n  }\n\n  .mt-lg-75,\n.my-lg-75 {\n    margin-top: 0.65625rem !important;\n  }\n\n  .mr-lg-75,\n.mx-lg-75 {\n    margin-right: 0.65625rem !important;\n  }\n\n  .mb-lg-75,\n.my-lg-75 {\n    margin-bottom: 0.65625rem !important;\n  }\n\n  .ml-lg-75,\n.mx-lg-75 {\n    margin-left: 0.65625rem !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .pt-lg-0,\n.py-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-lg-0,\n.px-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-lg-0,\n.py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-lg-0,\n.px-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.875rem !important;\n  }\n\n  .pt-lg-1,\n.py-lg-1 {\n    padding-top: 0.875rem !important;\n  }\n\n  .pr-lg-1,\n.px-lg-1 {\n    padding-right: 0.875rem !important;\n  }\n\n  .pb-lg-1,\n.py-lg-1 {\n    padding-bottom: 0.875rem !important;\n  }\n\n  .pl-lg-1,\n.px-lg-1 {\n    padding-left: 0.875rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 1.3125rem !important;\n  }\n\n  .pt-lg-2,\n.py-lg-2 {\n    padding-top: 1.3125rem !important;\n  }\n\n  .pr-lg-2,\n.px-lg-2 {\n    padding-right: 1.3125rem !important;\n  }\n\n  .pb-lg-2,\n.py-lg-2 {\n    padding-bottom: 1.3125rem !important;\n  }\n\n  .pl-lg-2,\n.px-lg-2 {\n    padding-left: 1.3125rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 2.625rem !important;\n  }\n\n  .pt-lg-3,\n.py-lg-3 {\n    padding-top: 2.625rem !important;\n  }\n\n  .pr-lg-3,\n.px-lg-3 {\n    padding-right: 2.625rem !important;\n  }\n\n  .pb-lg-3,\n.py-lg-3 {\n    padding-bottom: 2.625rem !important;\n  }\n\n  .pl-lg-3,\n.px-lg-3 {\n    padding-left: 2.625rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 3.0625rem !important;\n  }\n\n  .pt-lg-4,\n.py-lg-4 {\n    padding-top: 3.0625rem !important;\n  }\n\n  .pr-lg-4,\n.px-lg-4 {\n    padding-right: 3.0625rem !important;\n  }\n\n  .pb-lg-4,\n.py-lg-4 {\n    padding-bottom: 3.0625rem !important;\n  }\n\n  .pl-lg-4,\n.px-lg-4 {\n    padding-left: 3.0625rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 3.5rem !important;\n  }\n\n  .pt-lg-5,\n.py-lg-5 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pr-lg-5,\n.px-lg-5 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pb-lg-5,\n.py-lg-5 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pl-lg-5,\n.px-lg-5 {\n    padding-left: 3.5rem !important;\n  }\n\n  .p-lg-25 {\n    padding: 0.21875rem !important;\n  }\n\n  .pt-lg-25,\n.py-lg-25 {\n    padding-top: 0.21875rem !important;\n  }\n\n  .pr-lg-25,\n.px-lg-25 {\n    padding-right: 0.21875rem !important;\n  }\n\n  .pb-lg-25,\n.py-lg-25 {\n    padding-bottom: 0.21875rem !important;\n  }\n\n  .pl-lg-25,\n.px-lg-25 {\n    padding-left: 0.21875rem !important;\n  }\n\n  .p-lg-50 {\n    padding: 0.4375rem !important;\n  }\n\n  .pt-lg-50,\n.py-lg-50 {\n    padding-top: 0.4375rem !important;\n  }\n\n  .pr-lg-50,\n.px-lg-50 {\n    padding-right: 0.4375rem !important;\n  }\n\n  .pb-lg-50,\n.py-lg-50 {\n    padding-bottom: 0.4375rem !important;\n  }\n\n  .pl-lg-50,\n.px-lg-50 {\n    padding-left: 0.4375rem !important;\n  }\n\n  .p-lg-75 {\n    padding: 0.65625rem !important;\n  }\n\n  .pt-lg-75,\n.py-lg-75 {\n    padding-top: 0.65625rem !important;\n  }\n\n  .pr-lg-75,\n.px-lg-75 {\n    padding-right: 0.65625rem !important;\n  }\n\n  .pb-lg-75,\n.py-lg-75 {\n    padding-bottom: 0.65625rem !important;\n  }\n\n  .pl-lg-75,\n.px-lg-75 {\n    padding-left: 0.65625rem !important;\n  }\n\n  .m-lg-n1 {\n    margin: -0.875rem !important;\n  }\n\n  .mt-lg-n1,\n.my-lg-n1 {\n    margin-top: -0.875rem !important;\n  }\n\n  .mr-lg-n1,\n.mx-lg-n1 {\n    margin-right: -0.875rem !important;\n  }\n\n  .mb-lg-n1,\n.my-lg-n1 {\n    margin-bottom: -0.875rem !important;\n  }\n\n  .ml-lg-n1,\n.mx-lg-n1 {\n    margin-left: -0.875rem !important;\n  }\n\n  .m-lg-n2 {\n    margin: -1.3125rem !important;\n  }\n\n  .mt-lg-n2,\n.my-lg-n2 {\n    margin-top: -1.3125rem !important;\n  }\n\n  .mr-lg-n2,\n.mx-lg-n2 {\n    margin-right: -1.3125rem !important;\n  }\n\n  .mb-lg-n2,\n.my-lg-n2 {\n    margin-bottom: -1.3125rem !important;\n  }\n\n  .ml-lg-n2,\n.mx-lg-n2 {\n    margin-left: -1.3125rem !important;\n  }\n\n  .m-lg-n3 {\n    margin: -2.625rem !important;\n  }\n\n  .mt-lg-n3,\n.my-lg-n3 {\n    margin-top: -2.625rem !important;\n  }\n\n  .mr-lg-n3,\n.mx-lg-n3 {\n    margin-right: -2.625rem !important;\n  }\n\n  .mb-lg-n3,\n.my-lg-n3 {\n    margin-bottom: -2.625rem !important;\n  }\n\n  .ml-lg-n3,\n.mx-lg-n3 {\n    margin-left: -2.625rem !important;\n  }\n\n  .m-lg-n4 {\n    margin: -3.0625rem !important;\n  }\n\n  .mt-lg-n4,\n.my-lg-n4 {\n    margin-top: -3.0625rem !important;\n  }\n\n  .mr-lg-n4,\n.mx-lg-n4 {\n    margin-right: -3.0625rem !important;\n  }\n\n  .mb-lg-n4,\n.my-lg-n4 {\n    margin-bottom: -3.0625rem !important;\n  }\n\n  .ml-lg-n4,\n.mx-lg-n4 {\n    margin-left: -3.0625rem !important;\n  }\n\n  .m-lg-n5 {\n    margin: -3.5rem !important;\n  }\n\n  .mt-lg-n5,\n.my-lg-n5 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mr-lg-n5,\n.mx-lg-n5 {\n    margin-right: -3.5rem !important;\n  }\n\n  .mb-lg-n5,\n.my-lg-n5 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .ml-lg-n5,\n.mx-lg-n5 {\n    margin-left: -3.5rem !important;\n  }\n\n  .m-lg-n25 {\n    margin: -0.21875rem !important;\n  }\n\n  .mt-lg-n25,\n.my-lg-n25 {\n    margin-top: -0.21875rem !important;\n  }\n\n  .mr-lg-n25,\n.mx-lg-n25 {\n    margin-right: -0.21875rem !important;\n  }\n\n  .mb-lg-n25,\n.my-lg-n25 {\n    margin-bottom: -0.21875rem !important;\n  }\n\n  .ml-lg-n25,\n.mx-lg-n25 {\n    margin-left: -0.21875rem !important;\n  }\n\n  .m-lg-n50 {\n    margin: -0.4375rem !important;\n  }\n\n  .mt-lg-n50,\n.my-lg-n50 {\n    margin-top: -0.4375rem !important;\n  }\n\n  .mr-lg-n50,\n.mx-lg-n50 {\n    margin-right: -0.4375rem !important;\n  }\n\n  .mb-lg-n50,\n.my-lg-n50 {\n    margin-bottom: -0.4375rem !important;\n  }\n\n  .ml-lg-n50,\n.mx-lg-n50 {\n    margin-left: -0.4375rem !important;\n  }\n\n  .m-lg-n75 {\n    margin: -0.65625rem !important;\n  }\n\n  .mt-lg-n75,\n.my-lg-n75 {\n    margin-top: -0.65625rem !important;\n  }\n\n  .mr-lg-n75,\n.mx-lg-n75 {\n    margin-right: -0.65625rem !important;\n  }\n\n  .mb-lg-n75,\n.my-lg-n75 {\n    margin-bottom: -0.65625rem !important;\n  }\n\n  .ml-lg-n75,\n.mx-lg-n75 {\n    margin-left: -0.65625rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mt-lg-auto,\n.my-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-lg-auto,\n.mx-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-auto,\n.my-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-lg-auto,\n.mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .mt-xl-0,\n.my-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mr-xl-0,\n.mx-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .mb-xl-0,\n.my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .ml-xl-0,\n.mx-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.875rem !important;\n  }\n\n  .mt-xl-1,\n.my-xl-1 {\n    margin-top: 0.875rem !important;\n  }\n\n  .mr-xl-1,\n.mx-xl-1 {\n    margin-right: 0.875rem !important;\n  }\n\n  .mb-xl-1,\n.my-xl-1 {\n    margin-bottom: 0.875rem !important;\n  }\n\n  .ml-xl-1,\n.mx-xl-1 {\n    margin-left: 0.875rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 1.3125rem !important;\n  }\n\n  .mt-xl-2,\n.my-xl-2 {\n    margin-top: 1.3125rem !important;\n  }\n\n  .mr-xl-2,\n.mx-xl-2 {\n    margin-right: 1.3125rem !important;\n  }\n\n  .mb-xl-2,\n.my-xl-2 {\n    margin-bottom: 1.3125rem !important;\n  }\n\n  .ml-xl-2,\n.mx-xl-2 {\n    margin-left: 1.3125rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 2.625rem !important;\n  }\n\n  .mt-xl-3,\n.my-xl-3 {\n    margin-top: 2.625rem !important;\n  }\n\n  .mr-xl-3,\n.mx-xl-3 {\n    margin-right: 2.625rem !important;\n  }\n\n  .mb-xl-3,\n.my-xl-3 {\n    margin-bottom: 2.625rem !important;\n  }\n\n  .ml-xl-3,\n.mx-xl-3 {\n    margin-left: 2.625rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 3.0625rem !important;\n  }\n\n  .mt-xl-4,\n.my-xl-4 {\n    margin-top: 3.0625rem !important;\n  }\n\n  .mr-xl-4,\n.mx-xl-4 {\n    margin-right: 3.0625rem !important;\n  }\n\n  .mb-xl-4,\n.my-xl-4 {\n    margin-bottom: 3.0625rem !important;\n  }\n\n  .ml-xl-4,\n.mx-xl-4 {\n    margin-left: 3.0625rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 3.5rem !important;\n  }\n\n  .mt-xl-5,\n.my-xl-5 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mr-xl-5,\n.mx-xl-5 {\n    margin-right: 3.5rem !important;\n  }\n\n  .mb-xl-5,\n.my-xl-5 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .ml-xl-5,\n.mx-xl-5 {\n    margin-left: 3.5rem !important;\n  }\n\n  .m-xl-25 {\n    margin: 0.21875rem !important;\n  }\n\n  .mt-xl-25,\n.my-xl-25 {\n    margin-top: 0.21875rem !important;\n  }\n\n  .mr-xl-25,\n.mx-xl-25 {\n    margin-right: 0.21875rem !important;\n  }\n\n  .mb-xl-25,\n.my-xl-25 {\n    margin-bottom: 0.21875rem !important;\n  }\n\n  .ml-xl-25,\n.mx-xl-25 {\n    margin-left: 0.21875rem !important;\n  }\n\n  .m-xl-50 {\n    margin: 0.4375rem !important;\n  }\n\n  .mt-xl-50,\n.my-xl-50 {\n    margin-top: 0.4375rem !important;\n  }\n\n  .mr-xl-50,\n.mx-xl-50 {\n    margin-right: 0.4375rem !important;\n  }\n\n  .mb-xl-50,\n.my-xl-50 {\n    margin-bottom: 0.4375rem !important;\n  }\n\n  .ml-xl-50,\n.mx-xl-50 {\n    margin-left: 0.4375rem !important;\n  }\n\n  .m-xl-75 {\n    margin: 0.65625rem !important;\n  }\n\n  .mt-xl-75,\n.my-xl-75 {\n    margin-top: 0.65625rem !important;\n  }\n\n  .mr-xl-75,\n.mx-xl-75 {\n    margin-right: 0.65625rem !important;\n  }\n\n  .mb-xl-75,\n.my-xl-75 {\n    margin-bottom: 0.65625rem !important;\n  }\n\n  .ml-xl-75,\n.mx-xl-75 {\n    margin-left: 0.65625rem !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .pt-xl-0,\n.py-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pr-xl-0,\n.px-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pb-xl-0,\n.py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pl-xl-0,\n.px-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.875rem !important;\n  }\n\n  .pt-xl-1,\n.py-xl-1 {\n    padding-top: 0.875rem !important;\n  }\n\n  .pr-xl-1,\n.px-xl-1 {\n    padding-right: 0.875rem !important;\n  }\n\n  .pb-xl-1,\n.py-xl-1 {\n    padding-bottom: 0.875rem !important;\n  }\n\n  .pl-xl-1,\n.px-xl-1 {\n    padding-left: 0.875rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 1.3125rem !important;\n  }\n\n  .pt-xl-2,\n.py-xl-2 {\n    padding-top: 1.3125rem !important;\n  }\n\n  .pr-xl-2,\n.px-xl-2 {\n    padding-right: 1.3125rem !important;\n  }\n\n  .pb-xl-2,\n.py-xl-2 {\n    padding-bottom: 1.3125rem !important;\n  }\n\n  .pl-xl-2,\n.px-xl-2 {\n    padding-left: 1.3125rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 2.625rem !important;\n  }\n\n  .pt-xl-3,\n.py-xl-3 {\n    padding-top: 2.625rem !important;\n  }\n\n  .pr-xl-3,\n.px-xl-3 {\n    padding-right: 2.625rem !important;\n  }\n\n  .pb-xl-3,\n.py-xl-3 {\n    padding-bottom: 2.625rem !important;\n  }\n\n  .pl-xl-3,\n.px-xl-3 {\n    padding-left: 2.625rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 3.0625rem !important;\n  }\n\n  .pt-xl-4,\n.py-xl-4 {\n    padding-top: 3.0625rem !important;\n  }\n\n  .pr-xl-4,\n.px-xl-4 {\n    padding-right: 3.0625rem !important;\n  }\n\n  .pb-xl-4,\n.py-xl-4 {\n    padding-bottom: 3.0625rem !important;\n  }\n\n  .pl-xl-4,\n.px-xl-4 {\n    padding-left: 3.0625rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 3.5rem !important;\n  }\n\n  .pt-xl-5,\n.py-xl-5 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pr-xl-5,\n.px-xl-5 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pb-xl-5,\n.py-xl-5 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pl-xl-5,\n.px-xl-5 {\n    padding-left: 3.5rem !important;\n  }\n\n  .p-xl-25 {\n    padding: 0.21875rem !important;\n  }\n\n  .pt-xl-25,\n.py-xl-25 {\n    padding-top: 0.21875rem !important;\n  }\n\n  .pr-xl-25,\n.px-xl-25 {\n    padding-right: 0.21875rem !important;\n  }\n\n  .pb-xl-25,\n.py-xl-25 {\n    padding-bottom: 0.21875rem !important;\n  }\n\n  .pl-xl-25,\n.px-xl-25 {\n    padding-left: 0.21875rem !important;\n  }\n\n  .p-xl-50 {\n    padding: 0.4375rem !important;\n  }\n\n  .pt-xl-50,\n.py-xl-50 {\n    padding-top: 0.4375rem !important;\n  }\n\n  .pr-xl-50,\n.px-xl-50 {\n    padding-right: 0.4375rem !important;\n  }\n\n  .pb-xl-50,\n.py-xl-50 {\n    padding-bottom: 0.4375rem !important;\n  }\n\n  .pl-xl-50,\n.px-xl-50 {\n    padding-left: 0.4375rem !important;\n  }\n\n  .p-xl-75 {\n    padding: 0.65625rem !important;\n  }\n\n  .pt-xl-75,\n.py-xl-75 {\n    padding-top: 0.65625rem !important;\n  }\n\n  .pr-xl-75,\n.px-xl-75 {\n    padding-right: 0.65625rem !important;\n  }\n\n  .pb-xl-75,\n.py-xl-75 {\n    padding-bottom: 0.65625rem !important;\n  }\n\n  .pl-xl-75,\n.px-xl-75 {\n    padding-left: 0.65625rem !important;\n  }\n\n  .m-xl-n1 {\n    margin: -0.875rem !important;\n  }\n\n  .mt-xl-n1,\n.my-xl-n1 {\n    margin-top: -0.875rem !important;\n  }\n\n  .mr-xl-n1,\n.mx-xl-n1 {\n    margin-right: -0.875rem !important;\n  }\n\n  .mb-xl-n1,\n.my-xl-n1 {\n    margin-bottom: -0.875rem !important;\n  }\n\n  .ml-xl-n1,\n.mx-xl-n1 {\n    margin-left: -0.875rem !important;\n  }\n\n  .m-xl-n2 {\n    margin: -1.3125rem !important;\n  }\n\n  .mt-xl-n2,\n.my-xl-n2 {\n    margin-top: -1.3125rem !important;\n  }\n\n  .mr-xl-n2,\n.mx-xl-n2 {\n    margin-right: -1.3125rem !important;\n  }\n\n  .mb-xl-n2,\n.my-xl-n2 {\n    margin-bottom: -1.3125rem !important;\n  }\n\n  .ml-xl-n2,\n.mx-xl-n2 {\n    margin-left: -1.3125rem !important;\n  }\n\n  .m-xl-n3 {\n    margin: -2.625rem !important;\n  }\n\n  .mt-xl-n3,\n.my-xl-n3 {\n    margin-top: -2.625rem !important;\n  }\n\n  .mr-xl-n3,\n.mx-xl-n3 {\n    margin-right: -2.625rem !important;\n  }\n\n  .mb-xl-n3,\n.my-xl-n3 {\n    margin-bottom: -2.625rem !important;\n  }\n\n  .ml-xl-n3,\n.mx-xl-n3 {\n    margin-left: -2.625rem !important;\n  }\n\n  .m-xl-n4 {\n    margin: -3.0625rem !important;\n  }\n\n  .mt-xl-n4,\n.my-xl-n4 {\n    margin-top: -3.0625rem !important;\n  }\n\n  .mr-xl-n4,\n.mx-xl-n4 {\n    margin-right: -3.0625rem !important;\n  }\n\n  .mb-xl-n4,\n.my-xl-n4 {\n    margin-bottom: -3.0625rem !important;\n  }\n\n  .ml-xl-n4,\n.mx-xl-n4 {\n    margin-left: -3.0625rem !important;\n  }\n\n  .m-xl-n5 {\n    margin: -3.5rem !important;\n  }\n\n  .mt-xl-n5,\n.my-xl-n5 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mr-xl-n5,\n.mx-xl-n5 {\n    margin-right: -3.5rem !important;\n  }\n\n  .mb-xl-n5,\n.my-xl-n5 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .ml-xl-n5,\n.mx-xl-n5 {\n    margin-left: -3.5rem !important;\n  }\n\n  .m-xl-n25 {\n    margin: -0.21875rem !important;\n  }\n\n  .mt-xl-n25,\n.my-xl-n25 {\n    margin-top: -0.21875rem !important;\n  }\n\n  .mr-xl-n25,\n.mx-xl-n25 {\n    margin-right: -0.21875rem !important;\n  }\n\n  .mb-xl-n25,\n.my-xl-n25 {\n    margin-bottom: -0.21875rem !important;\n  }\n\n  .ml-xl-n25,\n.mx-xl-n25 {\n    margin-left: -0.21875rem !important;\n  }\n\n  .m-xl-n50 {\n    margin: -0.4375rem !important;\n  }\n\n  .mt-xl-n50,\n.my-xl-n50 {\n    margin-top: -0.4375rem !important;\n  }\n\n  .mr-xl-n50,\n.mx-xl-n50 {\n    margin-right: -0.4375rem !important;\n  }\n\n  .mb-xl-n50,\n.my-xl-n50 {\n    margin-bottom: -0.4375rem !important;\n  }\n\n  .ml-xl-n50,\n.mx-xl-n50 {\n    margin-left: -0.4375rem !important;\n  }\n\n  .m-xl-n75 {\n    margin: -0.65625rem !important;\n  }\n\n  .mt-xl-n75,\n.my-xl-n75 {\n    margin-top: -0.65625rem !important;\n  }\n\n  .mr-xl-n75,\n.mx-xl-n75 {\n    margin-right: -0.65625rem !important;\n  }\n\n  .mb-xl-n75,\n.my-xl-n75 {\n    margin-bottom: -0.65625rem !important;\n  }\n\n  .ml-xl-n75,\n.mx-xl-n75 {\n    margin-left: -0.65625rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mt-xl-auto,\n.my-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .mr-xl-auto,\n.mx-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-auto,\n.my-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ml-xl-auto,\n.mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: \"Montserrat\", Helvetica, Arial, serif !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n\n  .text-sm-right {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n\n  .text-md-right {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n\n  .text-lg-right {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n\n  .text-xl-right {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 500 !important;\n}\n\n.font-weight-bolder {\n  font-weight: 600 !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fdfeff !important;\n}\n\n.text-primary {\n  color: #00a0dd !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: #006991 !important;\n}\n\n.text-secondary {\n  color: #de4827 !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #a03118 !important;\n}\n\n.text-success {\n  color: #28c76f !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: #1b874b !important;\n}\n\n.text-info {\n  color: #222d69 !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: #0f142f !important;\n}\n\n.text-warning {\n  color: #d56729 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: #95481d !important;\n}\n\n.text-danger {\n  color: #de4827 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: #a03118 !important;\n}\n\n.text-light {\n  color: #f6f6f6 !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: #d0d0d0 !important;\n}\n\n.text-dark {\n  color: #232323 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: black !important;\n}\n\n.text-body {\n  color: #6e6b7b !important;\n}\n\n.text-muted {\n  color: #b9b9c3 !important;\n}\n\n.text-black-50 {\n  color: rgba(30, 29, 43, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(253, 254, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n*::before,\n*::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  pre {\n    white-space: pre-wrap !important;\n  }\n\n  pre,\nblockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group;\n  }\n\n  tr,\nimg {\n    page-break-inside: avoid;\n  }\n\n  p,\nh2,\nh3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\nh3 {\n    page-break-after: avoid;\n  }\n\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n\n  .container {\n    min-width: 992px !important;\n  }\n\n  .navbar {\n    display: none;\n  }\n\n  .badge {\n    border: 1px solid #1e1d2b;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n.table th {\n    background-color: #fdfeff !important;\n  }\n\n  .table-bordered th,\n.table-bordered td {\n    border: 1px solid #dae1e7 !important;\n  }\n\n  .table-dark {\n    color: inherit;\n  }\n  .table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n    border-color: #ebe9f1;\n  }\n\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #ebe9f1;\n  }\n}\na:focus {\n  outline: none;\n}\n\na:not([href]) {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.list-style-icons {\n  padding-left: 10px;\n  margin-left: 0;\n  list-style: none;\n}\n.list-style-icons > li svg,\n.list-style-icons > li i {\n  margin-right: 6px;\n}\n\n.pull-up {\n  transition: all 0.25s ease;\n}\n.pull-up:hover {\n  transform: translateY(-4px) scale(1.02);\n  box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);\n  z-index: 30;\n}\n\n.spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n\n.settings-spinner {\n  display: inline-block;\n  animation: spin 3s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner-reverse {\n  display: inline-block;\n  animation: spin-reverse 1s linear infinite;\n}\n\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n.bullet {\n  width: 0.875rem;\n  height: 0.875rem;\n  border-radius: 50%;\n  display: inline-block;\n}\n.bullet.bullet-xs {\n  width: 0.4375rem;\n  height: 0.4375rem;\n}\n.bullet.bullet-sm {\n  width: 0.62475rem;\n  height: 0.62475rem;\n}\n.bullet.bullet-lg {\n  width: 1.09375rem;\n  height: 1.09375rem;\n}\n\n.section-label {\n  font-size: 0.74375rem;\n  color: #b9b9c3;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n.cell-fit {\n  width: 0.1%;\n  white-space: nowrap;\n}\n\n.match-height > [class*=col] {\n  display: flex;\n  flex-flow: column;\n}\n.match-height > [class*=col] > .card {\n  flex: 1 1 auto;\n}\n\n.text-body-heading {\n  color: #5e5873;\n}\n.text-body-heading:hover {\n  color: inherit !important;\n}\n\n.text-body[href]:hover {\n  color: #008ec4 !important;\n}\n\ncode {\n  padding: 0.0875rem 0.35rem;\n  font-size: 90%;\n  color: #e83e8c;\n  background-color: #eee;\n  border-radius: 0.15625rem;\n}\n\npre {\n  background-color: #f7f7f9;\n}\npre code {\n  background-color: transparent !important;\n}\n\n.table-white-space th,\n.table-white-space td {\n  white-space: nowrap;\n}\n\n.table thead th,\n.table tfoot th {\n  vertical-align: top;\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  letter-spacing: 0.5px;\n}\n.table th,\n.table td {\n  padding: 0.625rem 1.75rem;\n  vertical-align: middle;\n}\n.table.table-sm th:first-child,\n.table.table-sm td:first-child {\n  padding-left: 0.65625rem;\n}\n\n.table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,\n.table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {\n  background-color: #f3f2f7;\n}\n\n.table-hover tbody tr {\n  cursor: pointer;\n}\n\n.table-hover-animation {\n  background-color: #f8f8f8;\n}\n.table-hover-animation thead th {\n  border-bottom: 0;\n}\n.table-hover-animation th,\n.table-hover-animation td {\n  border: 0;\n}\n.table-hover-animation tbody tr {\n  transition: all 0.25s ease;\n  background-color: #fdfeff;\n}\n.table-hover-animation tbody tr:hover {\n  transform: translateY(-4px);\n}\n\n.card .table {\n  margin-bottom: 0;\n  border-bottom-left-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n.card .table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 0.3125rem;\n}\n.card .table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 0.3125rem;\n}\n\n.card table tr[class*=table-]:last-child td:first-child {\n  border-bottom-left-radius: 0.3125rem;\n}\n.card table tr[class*=table-]:last-child td:last-child {\n  border-bottom-right-radius: 0.3125rem;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .table-hover-animation tr:hover {\n    border-bottom-color: #ebe9f1;\n  }\n}\nlabel {\n  color: #5e5873;\n  font-size: 0.75rem;\n}\n\n.form-control::placeholder {\n  transition: all 0.2s ease;\n}\n.form-control:focus::placeholder {\n  transform: translate(5px);\n  transition: all 0.2s ease;\n}\n.form-control:focus:valid, .form-control:focus.is-valid {\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n}\n\n.form-control-plaintext:focus {\n  outline: none;\n}\n\n.custom-file-label {\n  line-height: 1.75;\n}\n.custom-file-label:after {\n  height: 2.2575rem;\n  line-height: 1.75;\n}\n\n.valid-tooltip,\n.invalid-tooltip {\n  top: 102%;\n  left: 5px;\n}\n\n/***************\n* Form Group\n***************/\n.input-group:not(.bootstrap-touchspin):focus-within {\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1);\n  border-radius: 0.3125rem;\n}\n.input-group:not(.bootstrap-touchspin):focus-within .form-control,\n.input-group:not(.bootstrap-touchspin):focus-within .input-group-text {\n  border-color: #00a0dd;\n  box-shadow: none;\n}\n.input-group:not(.bootstrap-touchspin):focus-within .form-control.is-valid,\n.input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-valid {\n  border-color: #28c76f;\n}\n.input-group:not(.bootstrap-touchspin):focus-within .form-control.is-invalid,\n.input-group:not(.bootstrap-touchspin):focus-within .input-group-text.is-invalid {\n  border-color: #de4827;\n}\n.input-group.is-valid .input-group-text {\n  border-color: #28c76f !important;\n}\n.input-group.is-valid:not(.bootstrap-touchspin):focus-within .input-group-text {\n  border-color: #28c76f;\n}\n.input-group.is-invalid .input-group-text {\n  border-color: #de4827 !important;\n}\n.input-group.is-invalid:not(.bootstrap-touchspin):focus-within .input-group-text {\n  border-color: #de4827;\n}\n.input-group.disabled .input-group-text {\n  background-color: #efefef;\n}\n.input-group.round .form-control,\n.input-group.round .input-group-text, .input-group.round:focus-within {\n  border-radius: 1.3125rem;\n}\n.input-group.square .form-control,\n.input-group.square .input-group-text, .input-group.square:focus-within {\n  border-radius: 0;\n}\n.input-group.round .input-group-prepend .input-group-text, .input-group.square .input-group-prepend .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.round .input-group-append .input-group-text, .input-group.square .input-group-append .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group.round .form-control:not(:first-child), .input-group.square .form-control:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group.round .form-control:not(:last-child), .input-group.square .form-control:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.square .form-control,\n.input-group.square .input-group-text {\n  border-radius: 0;\n}\n\n.input-group-text {\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .input-group-text {\n    transition: none;\n  }\n}\n\n.input-group-prepend .input-group-text {\n  border-right: 0;\n}\n\n.input-group-append .input-group-text {\n  border-left: 0;\n}\n.input-group-append:not(:last-child) .input-group-text {\n  border-right: 0;\n}\n\n.input-group-merge .form-control:not(:first-child) {\n  padding-left: 0;\n  border-left: 0;\n}\n.input-group-merge .form-control:not(:last-child) {\n  padding-right: 0;\n  border-right: 0;\n}\n.input-group-merge .form-control.is-valid ~ .input-group-append .input-group-text {\n  border-color: #28c76f;\n}\n.input-group-text .input-group-merge .input-group-prepend ~ .form-control.is-valid {\n  border-color: #28c76f;\n}\n\ntextarea.form-control {\n  line-height: 1.4rem;\n  padding: 0.7rem 0.875rem !important;\n}\ntextarea.form-control-sm {\n  padding: 0.35rem 0.749875rem !important;\n}\ntextarea.form-control-lg {\n  padding: 0.875rem 1.000125rem !important;\n}\n\n.form-actions {\n  border-top: 1px solid #dfdfdf;\n  padding: 20px 0;\n  margin-top: 20px;\n}\n.form-actions.filled {\n  background-color: #f8f8f8;\n}\n.form-actions.center {\n  text-align: center;\n}\n.form-actions.right {\n  text-align: right;\n}\n.form-actions.top {\n  border-top: 0;\n  border-bottom: 1px solid #dfdfdf;\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n@media (max-width: 767.98px) {\n  .form-actions .buttons-group {\n    float: left !important;\n    margin-bottom: 10px;\n  }\n}\n\n@media (min-width: 576px) {\n  .form-horizontal .form-group .label-control {\n    text-align: right;\n  }\n}\n\nselect.form-control:not([multiple=multiple]) {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23d8d6de' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-position: calc(100% - 12px) 13px, calc(100% - 20px) 13px, 100% 0;\n  background-size: 18px 14px, 18px 14px;\n  background-repeat: no-repeat;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 1.3125rem;\n}\nselect.form-control.form-control-lg {\n  background-position: calc(100% - 12px) 16px, calc(100% - 20px) 16px, 100% 0;\n}\nselect.form-control.form-control-sm {\n  background-position: calc(100% - 12px) 8px, calc(100% - 20px) 8px, 100% 0;\n}\n\n.custom-select {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\n.custom-checkbox .custom-control-label::before,\n.custom-checkbox .custom-control-label::after {\n  top: 0.06125rem;\n}\n.custom-checkbox .custom-control-label::after {\n  background-size: 57%;\n}\n\n.custom-radio .custom-control-label::before {\n  top: 0.0875rem;\n}\n\n.custom-checkbox.custom-control,\n.custom-radio.custom-control {\n  padding-left: 1.575rem;\n}\n.input-group .custom-checkbox.custom-control,\n.input-group .custom-radio.custom-control {\n  padding-left: 1.1375rem;\n}\n.custom-checkbox .custom-control-input,\n.custom-radio .custom-control-input {\n  width: 1.124375rem;\n  height: 1.124375rem;\n}\n.custom-checkbox .custom-control-label,\n.custom-radio .custom-control-label {\n  font-size: 0.875rem;\n  position: static;\n}\n.custom-checkbox .custom-control-label::before, .custom-checkbox .custom-control-label::after,\n.custom-radio .custom-control-label::before,\n.custom-radio .custom-control-label::after {\n  width: 18px;\n  height: 18px;\n  left: 0;\n}\n.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before,\n.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {\n  border: none;\n  box-shadow: none !important;\n}\n.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,\n.custom-radio .custom-control-input:focus ~ .custom-control-label::before {\n  border-color: none;\n  box-shadow: 0 2px 4px 0 rgba(0, 160, 221, 0.4) !important;\n}\n\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  background-color: #00a0dd;\n  border-color: #00a0dd;\n}\n\n/* Floating label Group */\n.form-label-group {\n  position: relative;\n  margin-bottom: 1rem;\n}\n.form-label-group .form-control-lg ~ label {\n  font-size: 1rem;\n  padding: 0.875rem;\n}\n.form-label-group > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  transition: all 0.25s ease-in-out;\n  padding: 0.525rem;\n  pointer-events: none;\n  cursor: text;\n  color: rgba(30, 29, 43, 0.4);\n  font-size: 0.6125rem;\n  opacity: 0;\n}\n.form-label-group > input:focus:not(:placeholder-shown) ~ label, .form-label-group > input:not(:active):not(:placeholder-shown) ~ label,\n.form-label-group textarea:focus:not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:active):not(:placeholder-shown) ~ label {\n  color: #00a0dd !important;\n  transition: all 0.25s ease-in-out;\n  opacity: 1;\n}\n.form-label-group > input:not(:focus):not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:focus):not(:placeholder-shown) ~ label {\n  color: rgba(30, 29, 43, 0.4) !important;\n}\n.form-label-group > input:not(:placeholder-shown) ~ label,\n.form-label-group textarea:not(:placeholder-shown) ~ label {\n  padding: 0.21875rem 0;\n  top: -20px;\n  left: 3px;\n}\n.form-label-group > input.form-control-lg:not(:placeholder-shown) ~ label,\n.form-label-group textarea.form-control-lg:not(:placeholder-shown) ~ label {\n  top: -23px;\n}\n.form-label-group > input.form-control-sm:not(:placeholder-shown) ~ label,\n.form-label-group textarea.form-control-sm:not(:placeholder-shown) ~ label {\n  top: -18px;\n}\n\n/* Switches */\n.custom-switch {\n  padding-left: 0;\n  line-height: 1.4875rem;\n  /*For Switch label*/\n  /*For Switch Handle Animation*/\n}\n.custom-switch .custom-control-label {\n  padding-left: 3.0625rem;\n  line-height: 1.4875rem;\n  /* For bg color of switch*/\n  /*For Switch handle*/\n  /*For Switch text*/\n}\n.custom-switch .custom-control-label::before {\n  border: none;\n  background-color: #e2e2e2;\n  height: 1.4875rem;\n  box-shadow: none !important;\n  transition: opacity 0.25s ease, background-color 0.1s ease;\n  cursor: pointer;\n  user-select: none;\n  top: 0;\n  left: 0;\n}\n.custom-switch .custom-control-label:after {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  box-shadow: -1px 2px 3px 0 rgba(30, 29, 43, 0.2);\n  background-color: #fdfeff;\n  transition: all 0.15s ease-out;\n  cursor: pointer;\n  user-select: none;\n}\n.custom-switch .custom-control-label .switch-text-left,\n.custom-switch .custom-control-label .switch-text-right,\n.custom-switch .custom-control-label .switch-icon-left,\n.custom-switch .custom-control-label .switch-icon-right {\n  position: absolute;\n  cursor: pointer;\n  user-select: none;\n  line-height: 1.8;\n}\n.custom-switch .custom-control-label .switch-text-left i,\n.custom-switch .custom-control-label .switch-text-left svg,\n.custom-switch .custom-control-label .switch-text-right i,\n.custom-switch .custom-control-label .switch-text-right svg,\n.custom-switch .custom-control-label .switch-icon-left i,\n.custom-switch .custom-control-label .switch-icon-left svg,\n.custom-switch .custom-control-label .switch-icon-right i,\n.custom-switch .custom-control-label .switch-icon-right svg {\n  height: 13px;\n  width: 13px;\n  font-size: 13px;\n}\n.custom-switch .custom-control-label .switch-text-left,\n.custom-switch .custom-control-label .switch-icon-left {\n  left: 6px;\n  color: #fdfeff;\n  opacity: 0;\n  transform: translateX(8px);\n  transition: opacity 0.1s ease, transform 0.15s ease;\n}\n.custom-switch .custom-control-label .switch-icon-right {\n  right: 13px;\n  opacity: 1;\n  transform: translateX(0px);\n  transition: opacity 0.08s ease, transform 0.15s ease;\n}\n.custom-switch .custom-control-label:focus {\n  outline: 0;\n}\n.custom-switch .switch-label {\n  padding-left: 0.875rem;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::before {\n  box-shadow: none;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  transform: translateX(1.225rem);\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left,\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-left {\n  transform: translateX(0);\n  opacity: 1;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right,\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-icon-right {\n  transform: translateX(-8px);\n  opacity: 0;\n}\n.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-left {\n  opacity: 0;\n}\n.custom-switch .custom-control-input:not(:checked) ~ .custom-control-label .switch-text-right {\n  opacity: 1;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-right {\n  opacity: 0;\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label .switch-text-left {\n  opacity: 1;\n}\n\n/* Textarea with Counter */\n.textarea-counter-value {\n  background-color: #00a0dd;\n  color: #fdfeff;\n  padding: 1px 6px;\n  font-size: 0.525rem;\n  border-radius: 0 0 5px 5px;\n  margin-right: 0.875rem;\n}\n\n.btn.disabled-max-min {\n  background-color: rgba(30, 29, 43, 0.5) !important;\n  cursor: default;\n}\n\n/* Number Type Input Box Scss for - Remove arrow on hover */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .form-label-group label {\n    display: none;\n  }\n\n  select.form-control:not([multiple=multiple]) {\n    background: none;\n  }\n}\n.picker__input.form-control {\n  background-color: #fdfeff;\n}\n\n.input-group-append {\n  height: 38px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n}\n\n.stepper-btn {\n  height: 50%;\n  border: 1px solid #d8d6de;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n.stepper-btn:focus, .stepper-btn:hover, .stepper-btn:active {\n  border-color: #00a0dd;\n}\n\n.stepper-btn.top {\n  border-radius: 0 5px 0 0;\n}\n\n.stepper-btn.bottom {\n  border-radius: 0 0 5px 0;\n}\n\n.input-group-append .stepper-btn span {\n  display: block;\n}\n\n.stepper-arrow {\n  display: block;\n  line-height: 1;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n}\n\n.btn {\n  box-shadow: none;\n  font-weight: 500;\n}\n.btn[class*=bg-gradient-] {\n  transition: all 0.2s ease;\n}\n.btn[class*=bg-gradient-]:hover {\n  transform: translateY(-2px);\n}\n.btn.btn-icon {\n  padding: 0.625625rem 0.644rem;\n}\n.btn.btn-sm.btn-icon, .btn-group-sm > .btn.btn-icon {\n  padding: 0.4375rem;\n  line-height: 0.5;\n}\n.btn.btn-lg.btn-icon, .btn-group-lg > .btn.btn-icon {\n  padding: 0.875rem;\n  line-height: 0.75;\n}\n.btn:focus, .btn.focus, .btn:active, .btn.active {\n  outline: none;\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {\n  box-shadow: none !important;\n}\n.btn .feather {\n  vertical-align: bottom;\n}\n\n.btn.waves-input-wrapper {\n  padding: 0;\n}\n\n@media (max-width: 767.98px) {\n  .btn-sm-block {\n    display: block;\n    width: 100%;\n  }\n}\n.waves-effect {\n  cursor: inherit;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.6907894737rem;\n  padding-left: 0.6907894737rem;\n}\n\n.btn-lg + .dropdown-toggle-split,\n.btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n.btn-sm + .dropdown-toggle-split,\n.btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.4605263158rem;\n  padding-left: 0.4605263158rem;\n}\n\n.btn-group [class*=btn-]:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]) {\n  border-left-color: rgba(30, 29, 43, 0.08) !important;\n  border-right-color: rgba(30, 29, 43, 0.08) !important;\n}\n\n.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-child,\n.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):first-of-type {\n  border-left-color: transparent !important;\n}\n\n.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-child,\n.btn-group > .btn:not([class*=btn-outline-]):not([class*=btn-flat-]):not([class*=btn-gradient-]):not([class*=btn-relief-]):last-of-type {\n  border-right-color: transparent !important;\n}\n\n.btn-group-toggle [class*=btn-outline-]:not(:last-child) {\n  border-right-width: 0 !important;\n}\n.btn-group-toggle :not([class*=btn-outline-]).active, .btn-group-toggle :not([class*=btn-outline-]):active {\n  box-shadow: inset 0 4px 24px 0 rgba(30, 29, 43, 0.1);\n}\n\n.btn-group .button-group-selected {\n  background-color: #02A0DD;\n  border-color: #02A0DD;\n  color: #fff;\n}\n.btn-group .button-group-selected:hover {\n  background-color: #0290bb;\n  border-color: #0290bb;\n}\n.btn-group .button-group-selected:active {\n  background-color: #027ab8 !important;\n  border-color: #027ab8 !important;\n}\n\n.btn-group .button-group-unselected {\n  background-color: #D8DEE9;\n  border-color: #D8DEE9;\n  color: #000;\n}\n.btn-group .button-group-unselected:hover {\n  background-color: #c0c7d1;\n  border-color: #c0c7d1;\n}\n.btn-group .button-group-unselected:active {\n  background-color: #b0bccd !important;\n  border-color: #b0bccd !important;\n}\n\n.dropdown [class*=btn-outline-].dropdown-toggle.dropdown-toggle-split {\n  border-left: 0 !important;\n}\n.dropdown.no-arrow .dropdown-toggle:after {\n  display: none;\n}\n.dropdown.no-arrow .dropdown-toggle i,\n.dropdown.no-arrow .dropdown-toggle svg {\n  margin-right: 0;\n}\n\n.dropdown-menu {\n  border-radius: 0.358rem;\n  transform: scale(1, 0);\n  box-shadow: 0 5px 25px rgba(30, 29, 43, 0.1);\n}\n.dropdown-menu .dropdown-item {\n  width: auto;\n  cursor: pointer;\n}\n.dropdown-menu .dropdown-header {\n  font-weight: 500;\n  line-height: 1;\n}\n\n.show > .dropdown-menu {\n  transform: scale(1, 1);\n  opacity: 1;\n  display: block;\n}\n.show > .dropdown-content {\n  max-height: 500px;\n  overflow: scroll;\n  overflow-x: hidden;\n}\n.show .dropdown-toggle:focus {\n  box-shadow: none;\n}\n.show .btn.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.dropdown-toggle::after {\n  border: none !important;\n  content: \" \";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px;\n  color: #6e6b7b;\n  width: 14px;\n  height: 11px;\n  position: relative;\n  top: 1px;\n  right: 0px;\n  left: 0.62475rem;\n  padding: 0;\n  margin: 0;\n  vertical-align: 0;\n}\n.dropdown-toggle.btn-lg::after, .btn-group-lg > .dropdown-toggle.btn::after {\n  background-size: 18px;\n}\n.dropdown-toggle.btn-sm::after, .btn-group-sm > .dropdown-toggle.btn::after {\n  background-size: 14px;\n}\n.dropdown-toggle.dropdown-toggle-split:after {\n  left: 0;\n}\n.dropdown-toggle.nav-hide-arrow::after {\n  display: none;\n}\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n.dropup {\n  position: relative;\n}\n.dropup .dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px;\n  width: 14px;\n  height: 11px;\n  content: \"\";\n  vertical-align: 0.04375rem;\n}\n.dropup .dropdown-menu {\n  min-width: 7rem;\n}\n\n.dropleft .dropdown-toggle::before {\n  border: none !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px;\n  width: 14px;\n  height: 11px;\n  content: \"\";\n  position: relative;\n  left: 0;\n}\n.dropleft .dropdown-menu {\n  min-width: 7rem;\n}\n\n.dropright .dropdown-toggle::after {\n  border: none !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 16px;\n  width: 14px;\n  height: 11px;\n  content: \"\";\n}\n.dropright .dropdown-menu {\n  min-width: 7rem;\n}\n\n.dropdown-menu[x-placement=bottom-start], .dropdown-menu[x-placement=bottom-end] {\n  margin-top: 0.5rem;\n}\n.dropdown-menu[x-placement=top-start], .dropdown-menu[x-placement=top-end] {\n  margin-bottom: 0.5rem;\n}\n.dropdown-menu[x-placement=right-start] {\n  margin-left: 0.5rem;\n}\n.dropdown-menu[x-placement=left-start] {\n  margin-right: 0.5rem;\n}\n\n.dropdown.dropdown-icon-wrapper .dropdown-toggle:after,\n.dropup.dropdown-icon-wrapper .dropdown-toggle:after {\n  display: none;\n}\n.dropdown.dropdown-icon-wrapper .dropdown-menu,\n.dropup.dropdown-icon-wrapper .dropdown-menu {\n  min-width: auto;\n}\n.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item,\n.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item {\n  padding: 0.4375rem 0.9625rem;\n  cursor: pointer;\n}\n.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,\n.dropdown.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg,\n.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item i,\n.dropup.dropdown-icon-wrapper .dropdown-menu .dropdown-item svg {\n  height: 1.1375rem;\n  width: 1.1375rem;\n  font-size: 1.1375rem;\n}\n\n.horizontal-menu-wrapper .dropdown-menu,\n.header-navbar .dropdown-menu {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-name: slideIn;\n}\n\n.dropdown-toggle.hide-arrow::before, .dropdown-toggle.hide-arrow::after,\n.dropdown-toggle-hide-arrow > .dropdown-toggle::before,\n.dropdown-toggle-hide-arrow > .dropdown-toggle::after {\n  display: none;\n}\n\n@keyframes slideIn {\n  0% {\n    transform: translateY(0.875rem);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0rem);\n    opacity: 1;\n  }\n  0% {\n    transform: translateY(0.875rem);\n    opacity: 0;\n  }\n}\n/* ===============================================================================================\n    File Name: navbar.scss\n    Description: Contain header navigation bar, vertical main navigation bar and\n    horiznotal main navigation bar related SCSS.\n    ----------------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n.header-navbar {\n  padding: 0px;\n  min-height: 4.375rem;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n  transition: 300ms ease all, background 0s;\n  z-index: 997;\n}\n.header-navbar.fixed-top {\n  left: 260px;\n}\n.header-navbar.floating-nav {\n  position: fixed;\n  right: 0;\n  margin: 1.1375rem 1.75rem 0;\n  width: calc(100vw - (100vw - 100%) - calc(1.75rem * 2) - 260px);\n  border-radius: 0.428rem;\n  z-index: 12;\n}\n.header-navbar.navbar-static-top {\n  top: 0;\n  right: 0;\n  left: 260px;\n  width: calc(100vw - (100vw - 100%) - 260px);\n  background: transparent;\n  box-shadow: none !important;\n}\n.header-navbar.navbar-border {\n  border-bottom: 1px solid #ebe9f1;\n}\n.header-navbar.navbar-shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);\n}\n.header-navbar.navbar-dark.navbar-border {\n  border-bottom: 1px solid #3b4253;\n}\n.header-navbar .navbar-container {\n  padding: 0.7rem 0.875rem;\n  flex-basis: 100%;\n  transition: 300ms ease all;\n  margin-left: 0;\n}\n@media (min-width: 576px) {\n  .header-navbar .navbar-container {\n    padding: 0.7rem 1.225rem;\n  }\n}\n.header-navbar .navbar-container .bookmark-wrapper .bookmark-input {\n  z-index: 1;\n}\n.header-navbar .navbar-container .dropdown-language .selected-language {\n  font-weight: 500;\n}\n.header-navbar .navbar-container .dropdown-language .dropdown-menu .dropdown-item .flag-icon {\n  margin-right: 0.35rem;\n}\n.header-navbar .navbar-container .dropdown-menu-media {\n  width: 26.25rem;\n}\n.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-header {\n  border-bottom: 1px solid #ebe9f1;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media {\n  padding: 0.7875rem 1.12rem;\n  border: none;\n  border-bottom: 1px solid #ebe9f1;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media:hover {\n  background: #f8f8f8;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list .media .media-meta {\n  color: #6e6b7b;\n}\n.header-navbar .navbar-container .dropdown-menu-media .media-list a:last-of-type .media {\n  border-bottom: none;\n}\n.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer {\n  border-top: 1px solid #ebe9f1;\n}\n\n.header-navbar-shadow {\n  display: none;\n}\n\n.navbar-floating .navbar-container {\n  padding: 0.7rem 0.875rem;\n}\n.navbar-floating .header-navbar-shadow {\n  display: block;\n  background: linear-gradient(180deg, rgba(248, 248, 248, 0.95) 44%, rgba(248, 248, 248, 0.46) 73%, rgba(255, 255, 255, 0));\n  padding-top: 1.925rem;\n  background-repeat: repeat;\n  width: 100%;\n  height: 102px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11;\n}\n\n.navbar-light {\n  background: #fbfbfe;\n}\n.navbar-light.navbar-horizontal {\n  background: #fbfbfe;\n}\n\n.navbar-dark {\n  background: #2b2a33;\n}\n.navbar-dark .navbar-brand {\n  color: #fdfeff !important;\n}\n.navbar-dark.navbar-horizontal {\n  background: #2b2a33;\n}\n.navbar-dark .nav-search .form-control,\n.navbar-dark .nav-search .btn-secondary {\n  color: #fdfeff;\n  background: #b8c2cc;\n}\n\n@media (max-width: 767.98px) {\n  .header-navbar .navbar-container .show .dropdown-menu {\n    right: 0;\n    float: none;\n    width: auto !important;\n    margin-top: 0;\n    margin-left: -210px;\n    overflow: hidden;\n  }\n  .header-navbar .navbar-container .dropdown-user .dropdown-menu-right {\n    right: 0 !important;\n  }\n}\n.dropdown-menu {\n  padding: 11px;\n  margin: 10px 0;\n}\n\n@media (min-width: 780px) {\n  /* Adjust this breakpoint as needed */\n  .custom-dropdown-menu {\n    width: 300px !important;\n    /* Re-enable the transform if needed, otherwise, leave it commented out */\n    transform: translate3d(-95px, 9px, 0px) !important;\n  }\n}\n.custom-dropdown-toggle {\n  display: inline-flex;\n  align-items: center;\n  background-color: #f8f9fa;\n  color: #000;\n  padding: 0.21875rem 0.4375rem;\n  border-radius: 0.21875rem;\n  text-decoration: none;\n  border: 1px solid #d1d3d4;\n  font-size: 0.7875rem;\n}\n\n.custom-dropdown-toggle-dark {\n  display: inline-flex;\n  align-items: center;\n  background-color: #2b2b32;\n  color: #adb0b6;\n  padding: 0.21875rem 0.4375rem;\n  border-radius: 0.21875rem;\n  text-decoration: none;\n  border: 1px solid #6a6b6c;\n  font-size: 0.7875rem;\n}\n\n.header-navbar.floating-nav {\n  width: calc(100vw - (100vw - 100%) - calc(1.75rem * 2));\n}\n.header-navbar.navbar-static-top {\n  left: 0;\n  width: 100%;\n}\n\n@media (max-width: 575.98px) {\n  .header-navbar.floating-nav {\n    width: calc( 100vw - (100vw - 100%) - calc(1.75rem + 0.35rem) ) !important;\n    margin-left: 0.875rem;\n    margin-right: 1.05rem;\n  }\n}\n/* ----------- iPhone 5, 5S  iPhone 6----------- */\n/* Landscape */\n@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  .header-navbar .navbar-container .show .dropdown-menu {\n    max-height: 180px;\n  }\n}\n/* ----------- iPhone 6+ ----------- */\n/* Landscape */\n@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {\n  .header-navbar .navbar-container .show .dropdown-menu {\n    max-height: 280px;\n  }\n}\n@media (max-width: 1201px) {\n  .header-navbar.fixed-top {\n    left: 0;\n  }\n\n  .horizontal-layout .header-navbar .navbar-container {\n    padding-left: 0.7rem;\n    padding-right: 0.7rem;\n  }\n}\n@media (max-width: 575.98px) {\n  .navbar-container .dropdown-menu {\n    margin-top: 30px !important;\n  }\n}\n.breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before {\n  content: \" \";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #6e6b7b;\n  margin-right: 0.525rem;\n  background-size: 14px;\n}\n/* Component Specific */\n.breadcrumb-slash.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"/\";\n}\n\n.breadcrumb-dots.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \".\";\n  position: relative;\n  top: -4px;\n}\n\n.breadcrumb-dashes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"-\";\n}\n\n.breadcrumb-pipes.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"|\";\n}\n\n.breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \" \";\n}\n\n@media (max-width: 648px) {\n  .content-header .breadcrumb {\n    display: none;\n  }\n\n  .breadcrumbs-top .content-header-title {\n    display: contents !important;\n  }\n}\n.badge {\n  color: #fdfeff;\n}\n.badge[class*=badge-] [class*=icon-] {\n  line-height: 1;\n}\n.badge[class*=badge-] a {\n  color: #fdfeff;\n}\n.badge[class*=badge-] .dropdown-toggle span,\n.badge[class*=badge-] .dropdown-toggle i,\n.badge[class*=badge-] .dropdown-toggle svg, .badge[class*=badge-].dropdown-toggle span,\n.badge[class*=badge-].dropdown-toggle i,\n.badge[class*=badge-].dropdown-toggle svg {\n  vertical-align: text-top;\n}\n.badge[class*=badge-] .dropdown-toggle i,\n.badge[class*=badge-] .dropdown-toggle svg, .badge[class*=badge-].dropdown-toggle i,\n.badge[class*=badge-].dropdown-toggle svg {\n  padding-left: 0.175rem;\n}\n.badge[class*=badge-] .dropdown-toggle::after, .badge[class*=badge-].dropdown-toggle::after {\n  position: relative;\n  top: 0;\n  left: 0;\n  font-size: 0.875rem;\n}\n.badge[class*=badge-] .dropdown-menu a {\n  color: #6e6b7b;\n}\n.badge i,\n.badge svg {\n  height: 12px;\n  width: 11px;\n  font-size: 12px;\n  stroke-width: 3;\n  vertical-align: top;\n}\n.badge.badge-square {\n  border-radius: 0;\n}\n.badge.badge-up {\n  position: absolute;\n  top: -11px;\n  right: -9px;\n  min-width: 1.250375rem;\n  min-height: 1.250375rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.68775rem;\n  line-height: 0.786;\n  padding-left: 0.21875rem;\n  padding-right: 0.21875rem;\n}\n.badge.badge-up.badge-sm {\n  top: -0.4375rem;\n  right: -0.4375rem;\n}\n\n.badge-icon i,\n.badge-icon svg {\n  font-size: 100%;\n  margin-right: 5px;\n}\n\n.dropup .badge {\n  cursor: pointer;\n}\n\n.nav-pills {\n  margin-bottom: 0.875rem;\n}\n.nav-pills.dropdown.show .dropdown-item.active:hover {\n  color: #00a0dd;\n}\n.nav-pills.nav-justified {\n  width: 100%;\n}\n.nav-pills.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n\n.nav-tabs {\n  margin-bottom: 0.875rem;\n  position: relative;\n}\n.nav-tabs.nav-justified {\n  width: 100%;\n}\n.nav-tabs.nav-justified > .dropdown .dropdown-menu {\n  top: auto;\n  left: auto;\n}\n\n.nav-vertical {\n  overflow: hidden;\n}\n.nav-vertical .nav.nav-tabs.nav-left {\n  float: left;\n  display: table;\n  margin-right: 0.875rem;\n}\n.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane {\n  display: none;\n  overflow-y: auto;\n  padding-left: 0.875rem;\n}\n.nav-vertical .nav.nav-tabs.nav-left ~ .tab-content .tab-pane.active {\n  display: block;\n}\n.nav-vertical .nav.nav-tabs.nav-right {\n  float: right;\n  display: table;\n  margin-left: 0.875rem;\n}\n.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane {\n  display: none;\n  overflow-y: auto;\n  padding-right: 0.875rem;\n}\n.nav-vertical .nav.nav-tabs.nav-right ~ .tab-content .tab-pane.active {\n  display: block;\n}\n\n.media-list .media {\n  padding: 1.09375rem;\n  width: 100%;\n  margin-top: 0;\n}\n.media-list .media .media-left {\n  margin-right: 0.875rem;\n}\n.media-list .media .media-right {\n  margin-left: 0.875rem;\n}\n.media-list a.media {\n  color: #b8c2cc !important;\n}\n\n.media-bordered .media:not(:first-child) {\n  border-top: 1px solid #ebe9f1;\n}\n\n/*=========================================================================================\n  File Name: progress.scss\n  Description: Extended bootstrap progress bar scss.\n  ----------------------------------------------------------------------------------------\n  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n  ----------------------------------------------------------------------------------------\n==========================================================================================*/\n.progress .progress-bar + .progress-bar:not(:last-child) {\n  border-radius: 0;\n}\n.progress .progress-bar:last-child {\n  border-top-right-radius: 4.375rem;\n  border-bottom-right-radius: 4.375rem;\n}\n\n/* ===============================================================================================\n  File Name: list-group.scss\n  Description: Contain list item, list group related extended SCSS.\n  ----------------------------------------------------------------------------------------------\n  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\nul.list-inline li {\n  display: inline-block;\n}\nul.list-inline.list-inline-pipe > li + li:before {\n  content: \" | \";\n  padding-right: 2px;\n}\n\n.list-group .list-group-item {\n  line-height: 1.5;\n}\n.list-group .list-group-item.active:hover {\n  background-color: #00a0dd;\n}\n.list-group .list-group-item.active:focus {\n  outline: 0;\n}\n.list-group .list-group-item.active:focus:hover {\n  color: #fdfeff;\n}\n.list-group .list-group-item.active small {\n  color: #fdfeff !important;\n}\n.list-group .list-group-item:hover {\n  background-color: #f8f8f8;\n}\n.list-group .list-group-item i,\n.list-group .list-group-item svg {\n  position: relative;\n}\n.list-group .list-group-item:not(.active):focus:active {\n  color: inherit;\n}\n.list-group .list-group-item-action.active {\n  background-color: #00a0dd;\n  color: #fdfeff;\n}\n.list-group .list-group-item-action.active:focus {\n  background-color: #00a0dd;\n}\n.list-group .list-group-item-action:focus {\n  background-color: #f8f8f8;\n  outline: 0;\n}\n.list-group.list-group-circle {\n  border: none;\n}\n.list-group.list-group-circle .list-group-item {\n  border: none;\n  position: relative;\n  padding-left: 1.3125rem;\n}\n.list-group.list-group-circle .list-group-item:after {\n  content: \" \";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #6e6b7b;\n  background-size: 10px;\n  position: absolute;\n  height: 10px;\n  width: 10px;\n  top: 1.00625rem;\n  left: 0;\n}\n.list-group.list-group-circle .list-group-item:hover {\n  background-color: transparent;\n}\n\n.list-group-item.gu-mirror {\n  border-radius: 0;\n}\n\n[class*=collapse-] .collapse-title {\n  font-weight: 500;\n  font-size: 0.9625rem;\n}\n[class*=collapse-] .card {\n  margin-bottom: 0;\n}\n[class*=collapse-] .card:last-of-type {\n  margin-bottom: 0;\n}\n[class*=collapse-] .card:not(:last-of-type) {\n  border-bottom: 1px solid #ebe9f1;\n}\n[class*=collapse-] .card .card-header {\n  cursor: pointer;\n  padding: 0.875rem 2.45rem 0.875rem 0.875rem;\n}\n[class*=collapse-] .card .card-body {\n  padding: 0.875rem;\n  line-height: 1.5;\n  padding-top: 0.3675rem;\n}\n\n.collapse-title {\n  color: inherit;\n}\n.collapse-title:hover {\n  color: inherit;\n}\n\n.collapse-default .card:first-child {\n  border-top: 0;\n}\n.collapse-default .card:last-child {\n  border-bottom: 0;\n}\n.collapse-default .card {\n  border-radius: 0;\n}\n\n.collapse-border .card {\n  border: 1px solid #ebe9f1;\n}\n.collapse-border .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.collapse-border .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.collapse-shadow {\n  box-shadow: 0 0px 4px 0 rgba(30, 29, 43, 0.1);\n  padding: 0.13125rem 0.65625rem;\n  border-radius: 0.3125rem;\n}\n.collapse-shadow .card {\n  border-radius: 0;\n  transition: border 0.5s ease-in-out, all 0.3s ease-in-out;\n}\n.collapse-shadow .card.open {\n  border-radius: 0.499625rem;\n  margin: 10px 0;\n  border: 0;\n  box-shadow: 0px 0px 8px 0px rgba(30, 29, 43, 0.1) !important;\n}\n.collapse-shadow .card:first-child {\n  border-top-left-radius: 0.499625rem;\n  border-top-right-radius: 0.499625rem;\n}\n.collapse-shadow .card:last-child {\n  border-bottom-left-radius: 0.499625rem;\n  border-bottom-right-radius: 0.499625rem;\n}\n\n.collapse-margin .card {\n  margin-top: 0.62125rem;\n  margin-bottom: 0.62125rem;\n  box-shadow: 0 2px 15px 0 rgba(30, 29, 43, 0.05) !important;\n  border-radius: 0.31325rem;\n  border-bottom: 0 solid transparent !important;\n}\n.collapse-margin .card-header {\n  border-radius: 0.31325rem;\n}\n\n.collapse-icon .card-header {\n  position: relative;\n}\n.collapse-icon [data-toggle=collapse]:after {\n  position: absolute;\n  top: 58%;\n  right: 0.875rem;\n  margin-top: -8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 14px;\n  width: 14px;\n  height: 11px;\n  content: \"\";\n  transition: all 300ms linear 0s;\n}\n.collapse-icon [data-toggle=collapse]:disabled:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.collapse-icon [aria-expanded=false]:after {\n  transform: rotate(-180deg);\n}\n\n.page-item {\n  border-radius: 4.375rem;\n}\n.page-item:not(.prev-item) .page-link, .page-item:not(.next-item) .page-link, .page-item:not(.first) .page-link, .page-item:not(.last) .page-link, .page-item:not(.active) .page-link {\n  line-height: 1.3;\n}\n.page-item .page-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.page-item.previous .page-link, .page-item.prev .page-link, .page-item.next .page-link, .page-item.first .page-link, .page-item.last .page-link {\n  width: auto;\n}\n.page-item.prev-item .page-link, .page-item.next-item .page-link {\n  transition: all 0.2s ease-out;\n}\n.page-item.prev-item {\n  margin-right: 0.3124625rem;\n}\n.page-item.prev-item .page-link {\n  border-radius: 50%;\n}\n.page-item.prev-item .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 14px;\n  color: #6e6b7b;\n  width: 8px;\n  height: 18px;\n  content: \"\";\n}\n.page-item.prev-item .page-link:hover {\n  background: #f3f2f7;\n  color: #00a0dd;\n}\n.page-item.prev-item .page-link:active, .page-item.prev-item .page-link:hover {\n  background-color: #00a0dd !important;\n}\n.page-item.prev-item .page-link:active:before, .page-item.prev-item .page-link:hover:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.page-item.prev-item.disabled .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.page-item.prev-item ~ .page-item:nth-child(2) {\n  border-top-left-radius: 4.375rem;\n  border-bottom-left-radius: 4.375rem;\n}\n.page-item.prev-item ~ .page-item:nth-child(2) .page-link {\n  border-top-left-radius: 4.375rem !important;\n  border-bottom-left-radius: 4.375rem !important;\n}\n.page-item.prev-item ~ .page-item:nth-last-child(2) {\n  border-top-right-radius: 4.375rem;\n  border-bottom-right-radius: 4.375rem;\n}\n.page-item.prev-item ~ .page-item:nth-last-child(2) .page-link {\n  border-top-right-radius: 4.375rem !important;\n  border-bottom-right-radius: 4.375rem !important;\n}\n.page-item.next-item {\n  margin-left: 0.3124625rem;\n}\n.page-item.next-item .page-link {\n  border-radius: 50%;\n}\n.page-item.next-item .page-link:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 14px;\n  width: 8px;\n  height: 18px;\n  content: \"\";\n}\n.page-item.next-item .page-link:hover {\n  background: #f3f2f7;\n  color: #00a0dd;\n}\n.page-item.next-item .page-link:active, .page-item.next-item .page-link:hover {\n  background-color: #00a0dd !important;\n}\n.page-item.next-item .page-link:active:after, .page-item.next-item .page-link:hover:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.page-item.next-item.disabled .page-link:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.page-item.prev .page-link:before, .page-item.previous .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 14px;\n  color: #6e6b7b;\n  width: 12px;\n  height: 18px;\n  content: \"\";\n}\n.page-item.prev .page-link:hover:before, .page-item.previous .page-link:hover:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300a0dd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.page-item.prev.disabled .page-link:before, .page-item.previous.disabled .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.page-item.next .page-link:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 14px;\n  color: #6e6b7b;\n  width: 12px;\n  height: 18px;\n  content: \"\";\n}\n.page-item.next .page-link:hover:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300a0dd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.page-item.next.disabled .page-link:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b9b9c3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.page-item.disabled .page-link {\n  color: #b9b9c3;\n}\n.page-item .page-link {\n  border: none;\n  margin: 0;\n  margin-left: 0;\n  font-size: 0.875rem;\n  min-width: 2.00025rem;\n}\n.page-item .page-link:focus {\n  box-shadow: none;\n}\n.page-item .page-link:hover {\n  color: #00a0dd;\n}\n.page-item.active {\n  background-color: #f3f2f7;\n  border-radius: 0;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  border-radius: 4.375rem;\n  background-color: #00a0dd;\n  color: #fdfeff !important;\n  font-weight: 600;\n}\n.page-item:first-child:not(.prev-item).active {\n  border-top-left-radius: 1.2495rem;\n  border-bottom-left-radius: 1.2495rem;\n}\n.page-item:first-child:not(.prev-item).active .page-link {\n  border-radius: 4.375rem;\n}\n.page-item:first-child:not(.prev-item) .page-link {\n  border-top-left-radius: 1.2495rem;\n  border-bottom-left-radius: 1.2495rem;\n}\n.page-item:last-child:not(.next-item).active {\n  border-top-right-radius: 1.2495rem;\n  border-bottom-right-radius: 1.2495rem;\n}\n.page-item:last-child:not(.next-item).active .page-link {\n  border-radius: 4.375rem;\n}\n.page-item:last-child:not(.next-item) .page-link {\n  border-top-right-radius: 1.2495rem;\n  border-bottom-right-radius: 1.2495rem;\n}\n\n.pagination.pagination-lg .page-item .page-link {\n  font-size: 1.14rem;\n  min-width: 2.275rem;\n}\n.pagination.pagination-sm .page-item .page-link {\n  font-size: 0.857rem;\n  min-width: 1.75rem;\n}\n\n.modal .modal-header {\n  background-color: #f8f8f8;\n  border-bottom: none;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.modal .modal-header .close {\n  padding: 0.175rem 0.5425rem;\n  box-shadow: 0 5px 20px 0 rgba(30, 29, 43, 0.1);\n  border-radius: 0.3125rem;\n  background: #fdfeff;\n  opacity: 1;\n  transition: all 0.23s ease 0.1s;\n  position: relative;\n  transform: translate(8px, -2px);\n}\n.modal .modal-header .close:hover, .modal .modal-header .close:focus, .modal .modal-header .close:active {\n  opacity: 1;\n  outline: none;\n  transform: translate(5px, 3px);\n  box-shadow: none;\n}\n.modal .modal-content {\n  border: none;\n  overflow: visible;\n  box-shadow: 0 5px 20px 0 rgba(30, 29, 43, 0.1);\n}\n.modal .modal-footer {\n  padding: 0.7rem 1.225rem;\n}\n.modal.modal-sticky {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  left: auto;\n  height: auto;\n  position: fixed;\n}\n.modal.modal-sticky .modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.modal.modal-sticky .modal-dialog {\n  margin-right: 1.75rem !important;\n  box-shadow: 0px 0px 24px 0 rgba(30, 29, 43, 0.25);\n  border-radius: 0.3125rem;\n}\n.modal.modal-sticky .modal-actions {\n  background: transparent;\n  box-shadow: none;\n  line-height: 0;\n}\n\n.modal-xs {\n  max-width: 300px;\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    margin-left: 3%;\n    margin-right: 3%;\n  }\n}\n.modal-slide-in,\n.modal-slide-in .modal {\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.modal-slide-in .modal-dialog {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  margin: 0;\n  max-width: none;\n  width: 16.875rem;\n}\n.modal-slide-in .modal-dialog .modal-content {\n  padding-bottom: 3.2375rem;\n  padding-top: 3.2375rem;\n  overflow: auto;\n  border-radius: 0;\n  height: 100%;\n}\n.modal-slide-in .modal-dialog .modal-body {\n  padding-bottom: 0;\n  padding-top: 0;\n  margin: auto 0;\n  flex-grow: 0;\n}\n@media (min-width: 576px) {\n  .modal-slide-in .modal-dialog {\n    width: 24.5rem;\n  }\n}\n.modal-slide-in .modal-dialog.sidebar-sm {\n  width: 21.875rem;\n}\n@media (min-width: 576px) {\n  .modal-slide-in .modal-dialog.sidebar-lg {\n    width: 26.25rem;\n  }\n}\n.modal-slide-in .close {\n  top: 0.35rem;\n  z-index: 10;\n  transform: none;\n  position: absolute;\n  top: 1.3125rem;\n  right: 1.225rem;\n  margin: 0;\n  padding: 0 !important;\n  line-height: 0.5;\n  transform: translate(0, -50%);\n}\n\n.modal-slide-in.fade .modal-dialog,\n.modal-slide-in .modal.fade .modal-dialog {\n  transform: translateX(100%);\n  transition: transform 0.1s ease-out;\n}\n\n.modal-slide-in.show .modal-dialog,\n.modal-slide-in .modal.show .modal-dialog {\n  transform: translateX(0) !important;\n  transition: transform 0.1s ease-out;\n}\n\n@media (max-width: 576px) {\n  .modal {\n    padding-right: 0.875rem;\n    padding-left: 0.875rem;\n  }\n  .modal .modal-xs,\n.modal .modal-sm {\n    max-width: unset;\n  }\n  .modal.modal-sticky .modal-dialog {\n    margin-right: 0.175rem !important;\n    margin-left: 0.175rem;\n    margin-bottom: 2.625rem;\n  }\n}\n.popover {\n  box-shadow: 0 0 10px 0 rgba(30, 29, 43, 0.1);\n  z-index: 2000 !important;\n}\n.popover .popover-header {\n  font-size: 0.93625rem;\n  border: 1px solid #00a0dd;\n}\n.popover .popover-body {\n  border: 1px solid #ebe9f1;\n  border-top-color: #fdfeff;\n  border-bottom-left-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n.popover.bs-popover-bottom .arrow:after, .popover.bs-popover-auto[x-placement^=bottom] .arrow:after {\n  border-bottom-color: #00a0dd;\n}\n\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {\n  bottom: 1px;\n}\n\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {\n  left: 1px;\n}\n\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {\n  right: 1px;\n}\n\n.font-small-1 {\n  font-size: 0.6125rem !important;\n}\nsvg.font-small-1 {\n  height: 0.6125rem !important;\n  width: 0.6125rem !important;\n}\n\n.font-small-2 {\n  font-size: 0.7rem !important;\n}\nsvg.font-small-2 {\n  height: 0.7rem !important;\n  width: 0.7rem !important;\n}\n\n.font-small-3 {\n  font-size: 0.7875rem !important;\n}\nsvg.font-small-3 {\n  height: 0.7875rem !important;\n  width: 0.7875rem !important;\n}\n\n.font-small-4 {\n  font-size: 0.875rem !important;\n}\nsvg.font-small-4 {\n  height: 0.875rem !important;\n  width: 0.875rem !important;\n}\n\n.font-medium-1 {\n  font-size: 0.9625rem !important;\n}\nsvg.font-medium-1 {\n  height: 0.9625rem !important;\n  width: 0.9625rem !important;\n}\n\n.font-medium-2 {\n  font-size: 1.05rem !important;\n}\nsvg.font-medium-2 {\n  height: 1.05rem !important;\n  width: 1.05rem !important;\n}\n\n.font-medium-3 {\n  font-size: 1.1375rem !important;\n}\nsvg.font-medium-3 {\n  height: 1.1375rem !important;\n  width: 1.1375rem !important;\n}\n\n.font-medium-4 {\n  font-size: 1.225rem !important;\n}\nsvg.font-medium-4 {\n  height: 1.225rem !important;\n  width: 1.225rem !important;\n}\n\n.font-medium-5 {\n  font-size: 1.3125rem !important;\n}\nsvg.font-medium-5 {\n  height: 1.3125rem !important;\n  width: 1.3125rem !important;\n}\n\n.font-large-1 {\n  font-size: 1.75rem !important;\n}\nsvg.font-large-1 {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n\n.font-large-2 {\n  font-size: 2.625rem !important;\n}\nsvg.font-large-2 {\n  height: 2.625rem !important;\n  width: 2.625rem !important;\n}\n\n.font-large-3 {\n  font-size: 3.5rem !important;\n}\nsvg.font-large-3 {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n\n.font-large-4 {\n  font-size: 4.375rem !important;\n}\nsvg.font-large-4 {\n  height: 4.375rem !important;\n  width: 4.375rem !important;\n}\n\n.font-large-5 {\n  font-size: 5.25rem !important;\n}\nsvg.font-large-5 {\n  height: 5.25rem !important;\n  width: 5.25rem !important;\n}\n\n.line-height-1 {\n  line-height: 1 !important;\n}\n\n.line-height-condensed {\n  line-height: 1.5 !important;\n}\n\n.line-height-inherit {\n  line-height: inherit !important;\n}\n\n.rotate-45 {\n  transform: rotate(45deg);\n}\n\n.rotate-45-inverse {\n  transform: rotate(-45deg);\n}\n\n.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.rotate-90-inverse {\n  transform: rotate(-90deg);\n}\n\n.rotate-180 {\n  transform: rotate(180deg);\n}\n\n.rotate-180-inverse {\n  transform: rotate(-180deg);\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.round {\n  border-radius: 1.3125rem;\n}\n\n.square {\n  border-radius: 0;\n}\n\n.fit {\n  max-width: 100% !important;\n}\n\n.half-width {\n  width: 50% !important;\n}\n\n.full-width {\n  width: 100% !important;\n}\n\n.full-height {\n  height: 100% !important;\n}\n\n.height-50 {\n  height: 50px !important;\n}\n\n.width-50 {\n  width: 50px !important;\n}\n\n.height-100 {\n  height: 100px !important;\n}\n\n.width-100 {\n  width: 100px !important;\n}\n\n.height-150 {\n  height: 150px !important;\n}\n\n.width-150 {\n  width: 150px !important;\n}\n\n.height-200 {\n  height: 200px !important;\n}\n\n.width-200 {\n  width: 200px !important;\n}\n\n.height-250 {\n  height: 250px !important;\n}\n\n.width-250 {\n  width: 250px !important;\n}\n\n.height-300 {\n  height: 300px !important;\n}\n\n.width-300 {\n  width: 300px !important;\n}\n\n.height-350 {\n  height: 350px !important;\n}\n\n.width-350 {\n  width: 350px !important;\n}\n\n.height-400 {\n  height: 405px !important;\n}\n\n.width-400 {\n  width: 405px !important;\n}\n\n.height-450 {\n  height: 455px !important;\n}\n\n.width-450 {\n  width: 455px !important;\n}\n\n.height-500 {\n  height: 500px !important;\n}\n\n.width-500 {\n  width: 500px !important;\n}\n\n.height-550 {\n  height: 550px !important;\n}\n\n.width-550 {\n  width: 550px !important;\n}\n\n.height-600 {\n  height: 600px !important;\n}\n\n.width-600 {\n  width: 600px !important;\n}\n\n.height-650 {\n  height: 650px !important;\n}\n\n.width-650 {\n  width: 650px !important;\n}\n\n.height-700 {\n  height: 700px !important;\n}\n\n.width-700 {\n  width: 700px !important;\n}\n\n.height-750 {\n  height: 750px !important;\n}\n\n.width-750 {\n  width: 750px !important;\n}\n\n.height-800 {\n  height: 800px !important;\n}\n\n.width-800 {\n  width: 800px !important;\n}\n\n.height-5-per {\n  height: 5% !important;\n}\n\n.width-5-per {\n  width: 5% !important;\n}\n\n.height-10-per {\n  height: 10% !important;\n}\n\n.width-10-per {\n  width: 10% !important;\n}\n\n.height-15-per {\n  height: 15% !important;\n}\n\n.width-15-per {\n  width: 15% !important;\n}\n\n.height-20-per {\n  height: 20% !important;\n}\n\n.width-20-per {\n  width: 20% !important;\n}\n\n.height-25-per {\n  height: 25% !important;\n}\n\n.width-25-per {\n  width: 25% !important;\n}\n\n.height-30-per {\n  height: 30% !important;\n}\n\n.width-30-per {\n  width: 30% !important;\n}\n\n.height-35-per {\n  height: 35% !important;\n}\n\n.width-35-per {\n  width: 35% !important;\n}\n\n.height-40-per {\n  height: 40% !important;\n}\n\n.width-40-per {\n  width: 40% !important;\n}\n\n.height-45-per {\n  height: 45% !important;\n}\n\n.width-45-per {\n  width: 45% !important;\n}\n\n.height-50-per {\n  height: 50% !important;\n}\n\n.width-50-per {\n  width: 50% !important;\n}\n\n.height-55-per {\n  height: 55% !important;\n}\n\n.width-55-per {\n  width: 55% !important;\n}\n\n.height-60-per {\n  height: 60% !important;\n}\n\n.width-60-per {\n  width: 60% !important;\n}\n\n.height-65-per {\n  height: 65% !important;\n}\n\n.width-65-per {\n  width: 65% !important;\n}\n\n.height-70-per {\n  height: 70% !important;\n}\n\n.width-70-per {\n  width: 70% !important;\n}\n\n.height-75-per {\n  height: 75% !important;\n}\n\n.width-75-per {\n  width: 75% !important;\n}\n\n.height-80-per {\n  height: 80% !important;\n}\n\n.width-80-per {\n  width: 80% !important;\n}\n\n.height-85-per {\n  height: 85% !important;\n}\n\n.width-85-per {\n  width: 85% !important;\n}\n\n.height-90-per {\n  height: 90% !important;\n}\n\n.width-90-per {\n  width: 90% !important;\n}\n\n.height-95-per {\n  height: 95% !important;\n}\n\n.width-95-per {\n  width: 95% !important;\n}\n\n.position-top-0 {\n  top: 0;\n}\n\n.position-right-0 {\n  right: 0;\n}\n\n.position-bottom-0 {\n  bottom: 0;\n}\n\n.position-left-0 {\n  left: 0;\n}\n\n.overflow-visible {\n  overflow: visible;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.overflow-x-scroll {\n  overflow: scroll;\n}\n\n.overflow-y-scroll {\n  overflow: scroll;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-progress {\n  cursor: progress;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n.zindex-1 {\n  z-index: 1 !important;\n}\n\n.zindex-2 {\n  z-index: 2 !important;\n}\n\n.zindex-3 {\n  z-index: 3 !important;\n}\n\n.zindex-4 {\n  z-index: 4 !important;\n}\n\n.zindex-0 {\n  z-index: 0 !important;\n}\n\n.zindex-minus-1 {\n  z-index: -1 !important;\n}\n\n.zindex-minus-2 {\n  z-index: -2 !important;\n}\n\n.zindex-minus-3 {\n  z-index: -3 !important;\n}\n\n.zindex-minus-4 {\n  z-index: -4 !important;\n}\n\n.box-shadow-0 {\n  box-shadow: none !important;\n}\n\n.box-shadow-1 {\n  box-shadow: 0 2px 5px 0 rgba(30, 29, 43, 0.16), 0 2px 10px 0 rgba(30, 29, 43, 0.12);\n}\n\n.box-shadow-2 {\n  box-shadow: 0 8px 17px 0 rgba(30, 29, 43, 0.2), 0 6px 20px 0 rgba(30, 29, 43, 0.19);\n}\n\n.box-shadow-3 {\n  box-shadow: 0 12px 15px 0 rgba(30, 29, 43, 0.24), 0 17px 50px 0 rgba(30, 29, 43, 0.19);\n}\n\n.box-shadow-4 {\n  box-shadow: 0 16px 28px 0 rgba(30, 29, 43, 0.22), 0 25px 55px 0 rgba(30, 29, 43, 0.21);\n}\n\n.box-shadow-5 {\n  box-shadow: 0 27px 24px 0 rgba(30, 29, 43, 0.2), 0 40px 77px 0 rgba(30, 29, 43, 0.22);\n}\n\n.box-shadow-6 {\n  box-shadow: 0 4px 8px 0 rgba(30, 29, 43, 0.12), 0 2px 4px 0 rgba(30, 29, 43, 0.08);\n}\n\n.outline-none {\n  outline: none !important;\n}\n\n.list-style-inside {\n  list-style: inside;\n}\n\n.list-style-circle {\n  list-style: circle;\n}\n\n.list-style-square {\n  list-style: square;\n}\n\n.bg-cover {\n  background-size: cover !important;\n}\n\n.background-repeat {\n  background-repeat: repeat !important;\n}\n\n.background-no-repeat {\n  background-repeat: no-repeat !important;\n}\n\n.icon-bg-circle {\n  color: #fdfeff;\n  padding: 0.4375rem;\n  border-radius: 50%;\n}\n\n.icon-left {\n  margin-right: 0.4375rem;\n}\n\n.icon-right {\n  margin-right: 0.4375rem;\n}\n\n.blockOverlay {\n  z-index: 1050 !important;\n}\n\n.blockElement,\n.blockPage {\n  z-index: 1051 !important;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\na:hover {\n  cursor: pointer;\n}\n\n.table-middle td {\n  vertical-align: middle;\n}\n\n.fill-current {\n  fill: currentColor;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.bg-white {\n  background-color: #ffffff !important;\n}\n.bg-white .card-header,\n.bg-white .card-footer {\n  background-color: transparent;\n}\n\n.border-white {\n  border: 1px solid #ffffff !important;\n}\n\n.border-top-white {\n  border-top: 1px solid #ffffff;\n}\n\n.border-bottom-white {\n  border-bottom: 1px solid #ffffff;\n}\n\n.border-left-white {\n  border-left: 1px solid #ffffff;\n}\n\n.border-right-white {\n  border-right: 1px solid #ffffff;\n}\n\n.bg-white.badge-glow,\n.border-white.badge-glow,\n.badge-white.badge-glow {\n  box-shadow: 0px 0px 10px #ffffff;\n}\n\n.overlay-white {\n  background: #ffffff;\n  /* The Fallback */\n}\n\ninput:focus ~ .bg-white {\n  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #ffffff !important;\n}\n\n.bg-black {\n  background-color: #000000 !important;\n}\n.bg-black .card-header,\n.bg-black .card-footer {\n  background-color: transparent;\n}\n\n.border-black {\n  border: 1px solid #000000 !important;\n}\n\n.border-top-black {\n  border-top: 1px solid #000000;\n}\n\n.border-bottom-black {\n  border-bottom: 1px solid #000000;\n}\n\n.border-left-black {\n  border-left: 1px solid #000000;\n}\n\n.border-right-black {\n  border-right: 1px solid #000000;\n}\n\n.bg-black.badge-glow,\n.border-black.badge-glow,\n.badge-black.badge-glow {\n  box-shadow: 0px 0px 10px #000000;\n}\n\n.overlay-black {\n  background: #000000;\n  /* The Fallback */\n}\n\ninput:focus ~ .bg-black {\n  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #000000 !important;\n}\n\n.bg-dark {\n  background-color: #232323 !important;\n}\n.bg-dark .card-header,\n.bg-dark .card-footer {\n  background-color: transparent;\n}\n\n.alert-dark {\n  color: #232323 !important;\n}\n.alert-dark .close {\n  color: #232323 !important;\n}\n\n.border-dark {\n  border: 1px solid #232323 !important;\n}\n\n.border-top-dark {\n  border-top: 1px solid #232323;\n}\n\n.border-bottom-dark {\n  border-bottom: 1px solid #232323;\n}\n\n.border-left-dark {\n  border-left: 1px solid #232323;\n}\n\n.border-right-dark {\n  border-right: 1px solid #232323;\n}\n\n.bg-dark.badge-glow,\n.border-dark.badge-glow,\n.badge-dark.badge-glow {\n  box-shadow: 0px 0px 10px #232323;\n}\n\n.badge.badge-light-dark {\n  color: #232323 !important;\n}\n\n.overlay-dark {\n  background: #232323;\n  /* The Fallback */\n}\n\n.btn-flat-dark {\n  background-color: transparent;\n  color: #232323;\n}\n.btn-flat-dark:hover {\n  color: #232323;\n}\n.btn-flat-dark:active, .btn-flat-dark.active, .btn-flat-dark:focus {\n  color: #232323;\n}\n.btn-flat-dark.dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23232323' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.btn-relief-dark {\n  background-color: #232323;\n  box-shadow: inset 0 -3px 0 0 rgba(30, 29, 43, 0.2);\n  color: #fdfeff;\n  transition: all 0.2s ease;\n}\n.btn-relief-dark:hover:not(.disabled):not(:disabled) {\n  background-color: #626262;\n}\n.btn-relief-dark:active, .btn-relief-dark.active, .btn-relief-dark:focus {\n  background-color: #343434;\n}\n.btn-relief-dark:hover {\n  color: #fdfeff;\n}\n.btn-relief-dark:active, .btn-relief-dark.active {\n  outline: none;\n  box-shadow: none;\n  transform: translateY(3px);\n}\n\n.btn-outline-dark {\n  border: 1px solid #232323 !important;\n  background-color: transparent;\n  color: #232323;\n}\n.btn-outline-dark:hover:not(.disabled):not(:disabled) {\n  color: #232323;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus {\n  box-shadow: none;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .btn-outline-dark:not(:disabled):not(.disabled):focus {\n  color: #232323;\n}\n.btn-outline-dark.dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23232323' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #232323;\n}\n\n.bullet.bullet-dark {\n  background-color: #232323;\n}\n\n.modal.modal-dark .modal-header .modal-title {\n  color: #232323;\n}\n.modal.modal-dark .modal-header .close {\n  color: #232323 !important;\n}\n\n.progress-bar-dark .progress-bar {\n  background-color: #232323;\n}\n\n.timeline .timeline-point-dark {\n  border-color: #232323 !important;\n}\n.timeline .timeline-point-dark i,\n.timeline .timeline-point-dark svg {\n  stroke: #232323 !important;\n}\n.timeline .timeline-point-dark.timeline-point-indicator {\n  background-color: #232323 !important;\n}\n.divider.divider-dark .divider-text:before, .divider.divider-dark .divider-text:after {\n  border-color: #232323 !important;\n}\n\ninput:focus ~ .bg-dark {\n  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #232323 !important;\n}\n\n.custom-control-dark .custom-control-input:checked ~ .custom-control-label::before,\n.custom-control-dark .custom-control-input:active ~ .custom-control-label::before {\n  border-color: #232323;\n  background-color: #232323;\n}\n.custom-control-dark .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  border: none;\n  box-shadow: none !important;\n}\n.custom-control-dark .custom-control-input:focus ~ .custom-control-label::before {\n  border-color: #232323;\n}\n\n.custom-switch-dark .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #232323 !important;\n  color: #fdfeff;\n  transition: all 0.2s ease-out;\n}\n\n.select2-dark .select2-container--default .select2-selection--multiple .select2-selection__choice {\n  background: #232323 !important;\n  border-color: #232323 !important;\n}\n\n.text-dark.text-darken-1 {\n  color: #343434 !important;\n}\n\n.bg-dark.bg-darken-1 {\n  background-color: #343434 !important;\n}\n\n.border-dark.border-darken-1 {\n  border: 1px solid #343434 !important;\n}\n\n.border-top-dark.border-top-darken-1 {\n  border-top: 1px solid #343434 !important;\n}\n\n.border-bottom-dark.border-bottom-darken-1 {\n  border-bottom: 1px solid #343434 !important;\n}\n\n.border-left-dark.border-left-darken-1 {\n  border-left: 1px solid #343434 !important;\n}\n\n.border-right-dark.border-right-darken-1 {\n  border-right: 1px solid #343434 !important;\n}\n\n.overlay-dark.overlay-darken-1 {\n  background: #343434;\n  /* The Fallback */\n}\n\n.text-dark.text-darken-2 {\n  color: #1e1e1e !important;\n}\n\n.bg-dark.bg-darken-2 {\n  background-color: #1e1e1e !important;\n}\n\n.border-dark.border-darken-2 {\n  border: 1px solid #1e1e1e !important;\n}\n\n.border-top-dark.border-top-darken-2 {\n  border-top: 1px solid #1e1e1e !important;\n}\n\n.border-bottom-dark.border-bottom-darken-2 {\n  border-bottom: 1px solid #1e1e1e !important;\n}\n\n.border-left-dark.border-left-darken-2 {\n  border-left: 1px solid #1e1e1e !important;\n}\n\n.border-right-dark.border-right-darken-2 {\n  border-right: 1px solid #1e1e1e !important;\n}\n\n.overlay-dark.overlay-darken-2 {\n  background: #1e1e1e;\n  /* The Fallback */\n}\n\n.text-dark.text-darken-3 {\n  color: #626262 !important;\n}\n\n.bg-dark.bg-darken-3 {\n  background-color: #626262 !important;\n}\n\n.border-dark.border-darken-3 {\n  border: 1px solid #626262 !important;\n}\n\n.border-top-dark.border-top-darken-3 {\n  border-top: 1px solid #626262 !important;\n}\n\n.border-bottom-dark.border-bottom-darken-3 {\n  border-bottom: 1px solid #626262 !important;\n}\n\n.border-left-dark.border-left-darken-3 {\n  border-left: 1px solid #626262 !important;\n}\n\n.border-right-dark.border-right-darken-3 {\n  border-right: 1px solid #626262 !important;\n}\n\n.overlay-dark.overlay-darken-3 {\n  background: #626262;\n  /* The Fallback */\n}\n\n.bg-light {\n  background-color: #f6f6f6 !important;\n}\n.bg-light .card-header,\n.bg-light .card-footer {\n  background-color: transparent;\n}\n\n.border-light {\n  border: 1px solid #f6f6f6 !important;\n}\n\n.border-top-light {\n  border-top: 1px solid #f6f6f6;\n}\n\n.border-bottom-light {\n  border-bottom: 1px solid #f6f6f6;\n}\n\n.border-left-light {\n  border-left: 1px solid #f6f6f6;\n}\n\n.border-right-light {\n  border-right: 1px solid #f6f6f6;\n}\n\n.bg-light.badge-glow,\n.border-light.badge-glow,\n.badge-light.badge-glow {\n  box-shadow: 0px 0px 10px #f6f6f6;\n}\n\n.overlay-light {\n  background: #f6f6f6;\n  /* The Fallback */\n}\n\ninput:focus ~ .bg-light {\n  box-shadow: 0 0 0 0.065625rem #fdfeff, 0 0 0 0.18375rem #f6f6f6 !important;\n}\n\n.text-primary.text-accent-1 {\n  color: #bdfdff !important;\n}\n\n.bg-primary.bg-accent-1 {\n  background-color: #bdfdff !important;\n}\n\n.border-primary.border-accent-1 {\n  border: 1px solid #bdfdff !important;\n}\n\n.border-top-primary.border-top-accent-1 {\n  border-top: 1px solid #bdfdff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-1 {\n  border-bottom: 1px solid #bdfdff !important;\n}\n\n.border-left-primary.border-left-accent-1 {\n  border-left: 1px solid #bdfdff !important;\n}\n\n.border-right-primary.border-right-accent-1 {\n  border-right: 1px solid #bdfdff !important;\n}\n\n.overlay-primary.overlay-accent-1 {\n  background: #bdfdff;\n  /* The Fallback */\n}\n\n.text-primary.text-accent-2 {\n  color: #8afbff !important;\n}\n\n.bg-primary.bg-accent-2 {\n  background-color: #8afbff !important;\n}\n\n.border-primary.border-accent-2 {\n  border: 1px solid #8afbff !important;\n}\n\n.border-top-primary.border-top-accent-2 {\n  border-top: 1px solid #8afbff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-2 {\n  border-bottom: 1px solid #8afbff !important;\n}\n\n.border-left-primary.border-left-accent-2 {\n  border-left: 1px solid #8afbff !important;\n}\n\n.border-right-primary.border-right-accent-2 {\n  border-right: 1px solid #8afbff !important;\n}\n\n.overlay-primary.overlay-accent-2 {\n  background: #8afbff;\n  /* The Fallback */\n}\n\n.text-primary.text-accent-3 {\n  color: #57faff !important;\n}\n\n.bg-primary.bg-accent-3 {\n  background-color: #57faff !important;\n}\n\n.border-primary.border-accent-3 {\n  border: 1px solid #57faff !important;\n}\n\n.border-top-primary.border-top-accent-3 {\n  border-top: 1px solid #57faff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-3 {\n  border-bottom: 1px solid #57faff !important;\n}\n\n.border-left-primary.border-left-accent-3 {\n  border-left: 1px solid #57faff !important;\n}\n\n.border-right-primary.border-right-accent-3 {\n  border-right: 1px solid #57faff !important;\n}\n\n.overlay-primary.overlay-accent-3 {\n  background: #57faff;\n  /* The Fallback */\n}\n\n.text-primary.text-accent-4 {\n  color: #3df9ff !important;\n}\n\n.bg-primary.bg-accent-4 {\n  background-color: #3df9ff !important;\n}\n\n.border-primary.border-accent-4 {\n  border: 1px solid #3df9ff !important;\n}\n\n.border-top-primary.border-top-accent-4 {\n  border-top: 1px solid #3df9ff !important;\n}\n\n.border-bottom-primary.border-bottom-accent-4 {\n  border-bottom: 1px solid #3df9ff !important;\n}\n\n.border-left-primary.border-left-accent-4 {\n  border-left: 1px solid #3df9ff !important;\n}\n\n.border-right-primary.border-right-accent-4 {\n  border-right: 1px solid #3df9ff !important;\n}\n\n.overlay-primary.overlay-accent-4 {\n  background: #3df9ff;\n  /* The Fallback */\n}\n\n.text-success.text-accent-1 {\n  color: #e1fff1 !important;\n}\n\n.bg-success.bg-accent-1 {\n  background-color: #e1fff1 !important;\n}\n\n.border-success.border-accent-1 {\n  border: 1px solid #e1fff1 !important;\n}\n\n.border-top-success.border-top-accent-1 {\n  border-top: 1px solid #e1fff1 !important;\n}\n\n.border-bottom-success.border-bottom-accent-1 {\n  border-bottom: 1px solid #e1fff1 !important;\n}\n\n.border-left-success.border-left-accent-1 {\n  border-left: 1px solid #e1fff1 !important;\n}\n\n.border-right-success.border-right-accent-1 {\n  border-right: 1px solid #e1fff1 !important;\n}\n\n.overlay-success.overlay-accent-1 {\n  background: #e1fff1;\n  /* The Fallback */\n}\n\n.text-success.text-accent-2 {\n  color: #aeffd9 !important;\n}\n\n.bg-success.bg-accent-2 {\n  background-color: #aeffd9 !important;\n}\n\n.border-success.border-accent-2 {\n  border: 1px solid #aeffd9 !important;\n}\n\n.border-top-success.border-top-accent-2 {\n  border-top: 1px solid #aeffd9 !important;\n}\n\n.border-bottom-success.border-bottom-accent-2 {\n  border-bottom: 1px solid #aeffd9 !important;\n}\n\n.border-left-success.border-left-accent-2 {\n  border-left: 1px solid #aeffd9 !important;\n}\n\n.border-right-success.border-right-accent-2 {\n  border-right: 1px solid #aeffd9 !important;\n}\n\n.overlay-success.overlay-accent-2 {\n  background: #aeffd9;\n  /* The Fallback */\n}\n\n.text-success.text-accent-3 {\n  color: #7bffc1 !important;\n}\n\n.bg-success.bg-accent-3 {\n  background-color: #7bffc1 !important;\n}\n\n.border-success.border-accent-3 {\n  border: 1px solid #7bffc1 !important;\n}\n\n.border-top-success.border-top-accent-3 {\n  border-top: 1px solid #7bffc1 !important;\n}\n\n.border-bottom-success.border-bottom-accent-3 {\n  border-bottom: 1px solid #7bffc1 !important;\n}\n\n.border-left-success.border-left-accent-3 {\n  border-left: 1px solid #7bffc1 !important;\n}\n\n.border-right-success.border-right-accent-3 {\n  border-right: 1px solid #7bffc1 !important;\n}\n\n.overlay-success.overlay-accent-3 {\n  background: #7bffc1;\n  /* The Fallback */\n}\n\n.text-success.text-accent-4 {\n  color: #62ffb5 !important;\n}\n\n.bg-success.bg-accent-4 {\n  background-color: #62ffb5 !important;\n}\n\n.border-success.border-accent-4 {\n  border: 1px solid #62ffb5 !important;\n}\n\n.border-top-success.border-top-accent-4 {\n  border-top: 1px solid #62ffb5 !important;\n}\n\n.border-bottom-success.border-bottom-accent-4 {\n  border-bottom: 1px solid #62ffb5 !important;\n}\n\n.border-left-success.border-left-accent-4 {\n  border-left: 1px solid #62ffb5 !important;\n}\n\n.border-right-success.border-right-accent-4 {\n  border-right: 1px solid #62ffb5 !important;\n}\n\n.overlay-success.overlay-accent-4 {\n  background: #62ffb5;\n  /* The Fallback */\n}\n\n.text-info.text-accent-1 {\n  color: #feffff !important;\n}\n\n.bg-info.bg-accent-1 {\n  background-color: #feffff !important;\n}\n\n.border-info.border-accent-1 {\n  border: 1px solid #feffff !important;\n}\n\n.border-top-info.border-top-accent-1 {\n  border-top: 1px solid #feffff !important;\n}\n\n.border-bottom-info.border-bottom-accent-1 {\n  border-bottom: 1px solid #feffff !important;\n}\n\n.border-left-info.border-left-accent-1 {\n  border-left: 1px solid #feffff !important;\n}\n\n.border-right-info.border-right-accent-1 {\n  border-right: 1px solid #feffff !important;\n}\n\n.overlay-info.overlay-accent-1 {\n  background: #feffff;\n  /* The Fallback */\n}\n\n.text-info.text-accent-2 {\n  color: #cbf5ff !important;\n}\n\n.bg-info.bg-accent-2 {\n  background-color: #cbf5ff !important;\n}\n\n.border-info.border-accent-2 {\n  border: 1px solid #cbf5ff !important;\n}\n\n.border-top-info.border-top-accent-2 {\n  border-top: 1px solid #cbf5ff !important;\n}\n\n.border-bottom-info.border-bottom-accent-2 {\n  border-bottom: 1px solid #cbf5ff !important;\n}\n\n.border-left-info.border-left-accent-2 {\n  border-left: 1px solid #cbf5ff !important;\n}\n\n.border-right-info.border-right-accent-2 {\n  border-right: 1px solid #cbf5ff !important;\n}\n\n.overlay-info.overlay-accent-2 {\n  background: #cbf5ff;\n  /* The Fallback */\n}\n\n.text-info.text-accent-3 {\n  color: #98ecff !important;\n}\n\n.bg-info.bg-accent-3 {\n  background-color: #98ecff !important;\n}\n\n.border-info.border-accent-3 {\n  border: 1px solid #98ecff !important;\n}\n\n.border-top-info.border-top-accent-3 {\n  border-top: 1px solid #98ecff !important;\n}\n\n.border-bottom-info.border-bottom-accent-3 {\n  border-bottom: 1px solid #98ecff !important;\n}\n\n.border-left-info.border-left-accent-3 {\n  border-left: 1px solid #98ecff !important;\n}\n\n.border-right-info.border-right-accent-3 {\n  border-right: 1px solid #98ecff !important;\n}\n\n.overlay-info.overlay-accent-3 {\n  background: #98ecff;\n  /* The Fallback */\n}\n\n.text-info.text-accent-4 {\n  color: #7fe7ff !important;\n}\n\n.bg-info.bg-accent-4 {\n  background-color: #7fe7ff !important;\n}\n\n.border-info.border-accent-4 {\n  border: 1px solid #7fe7ff !important;\n}\n\n.border-top-info.border-top-accent-4 {\n  border-top: 1px solid #7fe7ff !important;\n}\n\n.border-bottom-info.border-bottom-accent-4 {\n  border-bottom: 1px solid #7fe7ff !important;\n}\n\n.border-left-info.border-left-accent-4 {\n  border-left: 1px solid #7fe7ff !important;\n}\n\n.border-right-info.border-right-accent-4 {\n  border-right: 1px solid #7fe7ff !important;\n}\n\n.overlay-info.overlay-accent-4 {\n  background: #7fe7ff;\n  /* The Fallback */\n}\n\n.text-warning.text-accent-1 {\n  color: #fff5ef !important;\n}\n\n.bg-warning.bg-accent-1 {\n  background-color: #fff5ef !important;\n}\n\n.border-warning.border-accent-1 {\n  border: 1px solid #fff5ef !important;\n}\n\n.border-top-warning.border-top-accent-1 {\n  border-top: 1px solid #fff5ef !important;\n}\n\n.border-bottom-warning.border-bottom-accent-1 {\n  border-bottom: 1px solid #fff5ef !important;\n}\n\n.border-left-warning.border-left-accent-1 {\n  border-left: 1px solid #fff5ef !important;\n}\n\n.border-right-warning.border-right-accent-1 {\n  border-right: 1px solid #fff5ef !important;\n}\n\n.overlay-warning.overlay-accent-1 {\n  background: #fff5ef;\n  /* The Fallback */\n}\n\n.text-warning.text-accent-2 {\n  color: #ffe5d8 !important;\n}\n\n.bg-warning.bg-accent-2 {\n  background-color: #ffe5d8 !important;\n}\n\n.border-warning.border-accent-2 {\n  border: 1px solid #ffe5d8 !important;\n}\n\n.border-top-warning.border-top-accent-2 {\n  border-top: 1px solid #ffe5d8 !important;\n}\n\n.border-bottom-warning.border-bottom-accent-2 {\n  border-bottom: 1px solid #ffe5d8 !important;\n}\n\n.border-left-warning.border-left-accent-2 {\n  border-left: 1px solid #ffe5d8 !important;\n}\n\n.border-right-warning.border-right-accent-2 {\n  border-right: 1px solid #ffe5d8 !important;\n}\n\n.overlay-warning.overlay-accent-2 {\n  background: #ffe5d8;\n  /* The Fallback */\n}\n\n.text-warning.text-accent-3 {\n  color: #fff6f3 !important;\n}\n\n.bg-warning.bg-accent-3 {\n  background-color: #fff6f3 !important;\n}\n\n.border-warning.border-accent-3 {\n  border: 1px solid #fff6f3 !important;\n}\n\n.border-top-warning.border-top-accent-3 {\n  border-top: 1px solid #fff6f3 !important;\n}\n\n.border-bottom-warning.border-bottom-accent-3 {\n  border-bottom: 1px solid #fff6f3 !important;\n}\n\n.border-left-warning.border-left-accent-3 {\n  border-left: 1px solid #fff6f3 !important;\n}\n\n.border-right-warning.border-right-accent-3 {\n  border-right: 1px solid #fff6f3 !important;\n}\n\n.overlay-warning.overlay-accent-3 {\n  background: #fff6f3;\n  /* The Fallback */\n}\n\n.text-warning.text-accent-4 {\n  color: #ffe3da !important;\n}\n\n.bg-warning.bg-accent-4 {\n  background-color: #ffe3da !important;\n}\n\n.border-warning.border-accent-4 {\n  border: 1px solid #ffe3da !important;\n}\n\n.border-top-warning.border-top-accent-4 {\n  border-top: 1px solid #ffe3da !important;\n}\n\n.border-bottom-warning.border-bottom-accent-4 {\n  border-bottom: 1px solid #ffe3da !important;\n}\n\n.border-left-warning.border-left-accent-4 {\n  border-left: 1px solid #ffe3da !important;\n}\n\n.border-right-warning.border-right-accent-4 {\n  border-right: 1px solid #ffe3da !important;\n}\n\n.overlay-warning.overlay-accent-4 {\n  background: #ffe3da;\n  /* The Fallback */\n}\n\n.text-danger.text-accent-1 {\n  color: #ffeef1 !important;\n}\n\n.bg-danger.bg-accent-1 {\n  background-color: #ffeef1 !important;\n}\n\n.border-danger.border-accent-1 {\n  border: 1px solid #ffeef1 !important;\n}\n\n.border-top-danger.border-top-accent-1 {\n  border-top: 1px solid #ffeef1 !important;\n}\n\n.border-bottom-danger.border-bottom-accent-1 {\n  border-bottom: 1px solid #ffeef1 !important;\n}\n\n.border-left-danger.border-left-accent-1 {\n  border-left: 1px solid #ffeef1 !important;\n}\n\n.border-right-danger.border-right-accent-1 {\n  border-right: 1px solid #ffeef1 !important;\n}\n\n.overlay-danger.overlay-accent-1 {\n  background: #ffeef1;\n  /* The Fallback */\n}\n\n.text-danger.text-accent-2 {\n  color: #ffd6db !important;\n}\n\n.bg-danger.bg-accent-2 {\n  background-color: #ffd6db !important;\n}\n\n.border-danger.border-accent-2 {\n  border: 1px solid #ffd6db !important;\n}\n\n.border-top-danger.border-top-accent-2 {\n  border-top: 1px solid #ffd6db !important;\n}\n\n.border-bottom-danger.border-bottom-accent-2 {\n  border-bottom: 1px solid #ffd6db !important;\n}\n\n.border-left-danger.border-left-accent-2 {\n  border-left: 1px solid #ffd6db !important;\n}\n\n.border-right-danger.border-right-accent-2 {\n  border-right: 1px solid #ffd6db !important;\n}\n\n.overlay-danger.overlay-accent-2 {\n  background: #ffd6db;\n  /* The Fallback */\n}\n\n.text-danger.text-accent-3 {\n  color: #ffecee !important;\n}\n\n.bg-danger.bg-accent-3 {\n  background-color: #ffecee !important;\n}\n\n.border-danger.border-accent-3 {\n  border: 1px solid #ffecee !important;\n}\n\n.border-top-danger.border-top-accent-3 {\n  border-top: 1px solid #ffecee !important;\n}\n\n.border-bottom-danger.border-bottom-accent-3 {\n  border-bottom: 1px solid #ffecee !important;\n}\n\n.border-left-danger.border-left-accent-3 {\n  border-left: 1px solid #ffecee !important;\n}\n\n.border-right-danger.border-right-accent-3 {\n  border-right: 1px solid #ffecee !important;\n}\n\n.overlay-danger.overlay-accent-3 {\n  background: #ffecee;\n  /* The Fallback */\n}\n\n.text-danger.text-accent-4 {\n  color: #ffd3d7 !important;\n}\n\n.bg-danger.bg-accent-4 {\n  background-color: #ffd3d7 !important;\n}\n\n.border-danger.border-accent-4 {\n  border: 1px solid #ffd3d7 !important;\n}\n\n.border-top-danger.border-top-accent-4 {\n  border-top: 1px solid #ffd3d7 !important;\n}\n\n.border-bottom-danger.border-bottom-accent-4 {\n  border-bottom: 1px solid #ffd3d7 !important;\n}\n\n.border-left-danger.border-left-accent-4 {\n  border-left: 1px solid #ffd3d7 !important;\n}\n\n.border-right-danger.border-right-accent-4 {\n  border-right: 1px solid #ffd3d7 !important;\n}\n\n.overlay-danger.overlay-accent-4 {\n  background: #ffd3d7;\n  /* The Fallback */\n}\n\n.bg-gradient-dark,\n.btn-gradient-dark {\n  color: #fdfeff;\n  transition: all 0.2s ease;\n  background-image: linear-gradient(47deg, #232323, #1e1e1e);\n  background-repeat: repeat-x;\n  background-repeat: repeat;\n}\n.dark-layout .bg-gradient-dark,\n.dark-layout .btn-gradient-dark {\n  background-image: linear-gradient(47deg, #1e1e1e, #232323);\n  background-repeat: repeat-x;\n  background-repeat: repeat;\n}\n.bg-gradient-dark:hover, .bg-gradient-dark:active,\n.btn-gradient-dark:hover,\n.btn-gradient-dark:active {\n  color: #fdfeff;\n}\n.bg-gradient-dark:hover:not(.disabled):not(:disabled),\n.btn-gradient-dark:hover:not(.disabled):not(:disabled) {\n  transform: translateY(-2px);\n}\n.bg-gradient-dark:active,\n.btn-gradient-dark:active {\n  transform: translateY(0);\n}\n.bg-gradient-dark:active, .bg-gradient-dark:focus,\n.btn-gradient-dark:active,\n.btn-gradient-dark:focus {\n  background-image: linear-gradient(47deg, #1e1e1e, #232323);\n  background-repeat: repeat-x;\n  background-repeat: repeat;\n}\n\nhtml {\n  height: 100%;\n  letter-spacing: 0.00875rem;\n  /*\n    * Blank page\n    */\n}\nhtml body {\n  font-size: 14px;\n  height: 100%;\n  background-color: #f8f8f8;\n  direction: ltr;\n}\nhtml body p {\n  line-height: 1.3125rem;\n}\nhtml .content {\n  padding: 0;\n  position: relative;\n  transition: 300ms ease all;\n  backface-visibility: hidden;\n  min-height: calc(100% - 2.93125rem);\n  margin-left: 260px;\n}\nhtml .content.app-content {\n  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 0;\n}\nhtml .content.app-content.show-overlay .content-overlay {\n  z-index: 10;\n  opacity: 1;\n}\nhtml .content.app-content.show-overlay .content-overlay ~ .header-navbar-shadow {\n  display: none;\n}\nhtml .content.app-content .content-overlay {\n  position: fixed;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(30, 29, 43, 0.5);\n  cursor: pointer;\n  transition: all 0.7s, z-index 0s;\n  z-index: -1;\n}\nhtml .content.app-content .content-area-wrapper {\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\nhtml .content.app-content .content-area-wrapper .content-wrapper,\nhtml .content.app-content .content-area-wrapper .content-body {\n  height: 100%;\n}\nhtml .content .body-content-overlay {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  display: block;\n  z-index: 4;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.3s ease;\n}\nhtml .content .body-content-overlay.show {\n  visibility: visible;\n  transition: all 0.3s ease;\n  opacity: 1;\n  background-color: rgba(30, 29, 43, 0.2);\n  border-radius: 0.15625rem;\n}\nhtml .content .content-wrapper .content-header-title {\n  font-weight: 500;\n  color: #636363;\n  padding-right: 0.875rem;\n  border-right: 1px solid #d6dce1;\n}\nhtml .content .content-wrapper .content-header-right .dropdown-toggle::after {\n  display: none;\n}\nhtml .content .content-wrapper .content-header-right .dropdown-toggle i,\nhtml .content .content-wrapper .content-header-right .dropdown-toggle svg {\n  margin-right: 0;\n}\nhtml .content .content-wrapper .content-header-right .btn-icon {\n  padding: 0.7rem;\n}\nhtml .content .content-wrapper .content-header-right .btn-icon i,\nhtml .content .content-wrapper .content-header-right .btn-icon svg {\n  height: 0.875rem;\n  width: 0.875rem;\n}\nhtml .navbar-floating.footer-static .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-static .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-floating.footer-static .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-static .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n  }\n}\nhtml .navbar-floating.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-hidden .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 1.1375rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 1.1375rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-floating.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-hidden .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 1.1375rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 1.1375rem + 0rem ) );\n  }\n}\nhtml .navbar-floating.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-fixed .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-floating.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-floating.footer-fixed .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 1.1375rem + 0rem ) );\n  }\n}\nhtml .navbar-hidden .app-content {\n  padding: 1.75rem 1.75rem 0 1.75rem !important;\n}\nhtml .navbar-hidden.footer-static .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-static .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 1) + 0rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 0rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-hidden.footer-static .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-static .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 0rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 0rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-hidden.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-hidden .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 0rem + 0rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 0rem + 0rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-hidden.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-hidden .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 0rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-hidden.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-fixed .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 0rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 0rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-hidden.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-hidden.footer-fixed .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 0rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-static .main-menu {\n  top: 0;\n}\nhtml .navbar-static .content {\n  min-height: calc(100% - calc(4.375rem + 2.93125rem));\n}\nhtml .navbar-static .app-content {\n  padding: 1.75rem 1.75rem 0 1.75rem;\n}\nhtml .navbar-static.footer-static .app-content .content-area-wrapper,\nhtml .navbar-static.footer-static .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-static.footer-static .app-content .content-area-wrapper,\nhtml .navbar-static.footer-static .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-static.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-static.footer-hidden .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-static.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-static.footer-hidden .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-static.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-static.footer-fixed .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-static.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-static.footer-fixed .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-sticky .app-content {\n  padding: calc(1.75rem + 4.375rem) 1.75rem 0 1.75rem;\n}\nhtml .navbar-sticky.footer-static .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-static .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 1) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-sticky.footer-static .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-static .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 1) - calc(0.7rem * 1)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-sticky.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-hidden .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 0rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-sticky.footer-hidden .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-hidden .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 0rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-sticky.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-fixed .app-content .kanban-wrapper {\n  height: calc( 100vh - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  height: calc( var(--vh, 1vh) * 100 - calc( calc(1.75rem * 2) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n}\n@media (max-width: 575.98px) {\n  html .navbar-sticky.footer-fixed .app-content .content-area-wrapper,\nhtml .navbar-sticky.footer-fixed .app-content .kanban-wrapper {\n    height: calc( 100vh - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n    height: calc( var(--vh, 1vh) * 100 - calc( calc(calc(1.75rem * 2) - calc(0.7rem * 2)) + 4.375rem + 2.93125rem + 0rem + 0rem ) );\n  }\n}\nhtml .navbar-static .nav.header-navbar .navbar-container,\nhtml .navbar-sticky .nav.header-navbar .navbar-container {\n  padding-left: 1.4rem;\n  padding-right: 1.4rem;\n}\nhtml .navbar-static .nav.header-navbar .navbar-container .search-input .search-list.show,\nhtml .navbar-sticky .nav.header-navbar .navbar-container .search-input .search-list.show {\n  width: 98%;\n  left: 1%;\n}\nhtml .footer-fixed .content.app-content {\n  padding-bottom: 2.93125rem !important;\n}\nhtml [data-col=\"1-column\"] .header-navbar {\n  width: 100%;\n  left: 0 !important;\n}\nhtml [data-col=\"1-column\"] .header-navbar.floating-nav {\n  width: calc( 100vw - (100vw - 100%) - calc(1.75rem * 2) ) !important;\n}\nhtml [data-col=\"1-column\"] .content,\nhtml [data-col=\"1-column\"] .footer {\n  margin-left: 0px !important;\n}\nhtml [data-col=\"1-column\"].horizontal-layout .header-navbar {\n  width: 100% !important;\n}\nhtml [data-col=\"1-column\"].horizontal-layout .app-content {\n  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 0 1.75rem !important;\n}\nhtml [data-col=\"1-column\"].horizontal-layout.footer-fixed .app-content {\n  padding: calc(1.75rem + 4.375rem + 1.1375rem) 1.75rem 2.93125rem 1.75rem !important;\n}\nhtml .blank-page .content {\n  margin-left: 0;\n}\nhtml .blank-page .content.app-content {\n  overflow: overlay;\n  overflow-x: hidden;\n  padding: 0 !important;\n  transition: none;\n}\nhtml .blank-page .content.app-content .header-navbar-shadow {\n  display: none;\n}\nhtml .blank-page .content-wrapper {\n  padding: 0 !important;\n}\nhtml .blank-page .content-wrapper .flexbox-container {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  justify-content: center;\n}\nhtml .pace .pace-progress {\n  background: #00a0dd;\n}\n\n.app-content.center-layout {\n  overflow: hidden;\n}\n\n/*\n* Col 3 layout for detached and general type\n*/\n@media (min-width: 992px) {\n  body .content-right {\n    width: calc(100vw - (100vw - 100%) - 260px);\n    float: right;\n  }\n  body .content-left {\n    width: calc(100vw - (100vw - 100%) - 260px);\n    float: left;\n  }\n  body .content-detached {\n    width: 100%;\n  }\n  body .content-detached.content-right {\n    float: right;\n    margin-left: -260px;\n  }\n  body .content-detached.content-right .content-body {\n    margin-left: calc(260px + 1.75rem);\n  }\n  body .content-detached.content-left {\n    float: left;\n    margin-right: -260px;\n  }\n  body .content-detached.content-left .content-body {\n    margin-right: calc(260px + 1.75rem);\n  }\n\n  .sidebar-right.sidebar-sticky {\n    float: right !important;\n    margin-left: -260px;\n    width: 260px !important;\n    margin-top: 4.375rem1.25;\n  }\n}\n@media (max-width: 575.98px) {\n  html body .app-content {\n    padding: calc(1.75rem - 0.7rem + 4.375rem + 1.1375rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;\n  }\n\n  html body.navbar-static .app-content {\n    padding: calc(1.75rem - 0.7rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;\n  }\n\n  html body.navbar-sticky .app-content {\n    padding: calc(1.75rem - 0.7rem + 4.375rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;\n  }\n\n  html body.navbar-hidden .app-content {\n    padding: calc(1.75rem - 0.7rem) calc(1.75rem - 0.7rem) 0 calc(1.75rem - 0.7rem) !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .navbar-static .app-content .header-navbar .navbar-container,\n.navbar-sticky .app-content .header-navbar .navbar-container {\n    padding-left: 0.875rem;\n    padding-right: 0.4375rem;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  html.full-screen {\n    width: 100%;\n  }\n  html.full-screen .content.app-content {\n    height: 100%;\n    overflow: scroll;\n    overflow-x: hidden;\n  }\n}\n/*=========================================================================================\n    File Name: sidebar.scss\n    Description: content sidebar specific scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.sidebar {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n@media (min-width: 992px) {\n  .sidebar {\n    vertical-align: top;\n  }\n}\n\n.sidebar-fixed {\n  position: fixed;\n  height: 100%;\n  overflow: scroll;\n}\n\n.sidenav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120vh;\n  background-color: rgba(30, 29, 43, 0.5);\n  z-index: 997;\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n.sidenav-overlay.show {\n  opacity: 1;\n  visibility: visible;\n  transition: all 0.5s ease;\n}\n\n.drag-target {\n  height: 100%;\n  width: 40px;\n  position: fixed;\n  top: 0;\n  left: -10px;\n  z-index: 1036;\n}\n\n.sidebar-detached .sidebar {\n  width: 260px;\n}\n\n@media (min-width: 992px) {\n  .sidebar-left {\n    float: left;\n  }\n\n  .sidebar-right {\n    float: right;\n  }\n}\n@media (max-width: 991.98px) {\n  .sidebar-detached .sidebar {\n    width: 100%;\n  }\n}\nfooter.footer {\n  padding: 0.7rem 1.75rem;\n  min-height: 2.93125rem;\n  transition: 300ms ease all;\n}\nfooter.footer span i,\nfooter.footer span svg {\n  height: 1.32125rem;\n  width: 1.32125rem;\n  font-size: 1.32125rem;\n  margin-left: 0.4375rem;\n  color: #de4827;\n}\nfooter.footer .scroll-top {\n  padding: 0.70875rem 0.72625rem;\n}\nfooter.footer-shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);\n}\nfooter.footer-border {\n  border-top: 1px solid #ebe9f1;\n}\n\n.footer-fixed footer {\n  position: fixed !important;\n  z-index: 1030;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n.footer-fixed footer.footer-light {\n  background: #fdfeff;\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.1);\n}\n.footer-fixed footer.footer-dark {\n  background: #b8c2cc;\n  color: #fdfeff;\n}\n\n.footer-hidden .app-content {\n  padding-bottom: 0.1px !important;\n}\n\n.scroll-top {\n  position: fixed;\n  bottom: 5%;\n  right: 30px;\n  display: none;\n  z-index: 99;\n}\n\n/*=========================================================================================\n    File Name: navigation.scss\n    Description: Common mixin for menus, contain dark and light version scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n@media (min-width: 768px) {\n  .drag-target {\n    z-index: 0;\n  }\n}\n.mf-avatar {\n  position: relative;\n  height: 2.1875rem;\n  width: 2.1875rem;\n  padding: 0.4375rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 1.3125rem;\n  background-color: #7b67f9;\n  color: #fdfeff;\n  border-radius: 999px;\n  overflow: hidden;\n}\n.mf-avatar img {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 100%;\n  width: auto;\n  transform: translate(-50%, -50%);\n}\n\n.avatar {\n  white-space: nowrap;\n  background-color: #c3c3c3;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n  color: #fdfeff;\n  display: inline-flex;\n  font-size: 0.875rem;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: 600;\n}\n.avatar .avatar-content {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  font-size: 0.749875rem;\n}\n.avatar .avatar-content .avatar-icon {\n  height: 0.875rem;\n  width: 0.875rem;\n}\n.avatar [class*=avatar-status-] {\n  border-radius: 50%;\n  width: 11px;\n  height: 11px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  border: 1px solid #fdfeff;\n}\n.avatar [class*=avatar-status-].avatar-status-lg, .avatar [class*=avatar-status-].avatar-status-xl {\n  width: 17px;\n  height: 17px;\n  border-width: 2px;\n}\n.avatar .avatar-status-online {\n  background-color: #28c76f;\n}\n.avatar .avatar-status-busy {\n  background-color: #de4827;\n}\n.avatar .avatar-status-away {\n  background-color: #d56729;\n}\n.avatar .avatar-status-offline {\n  background-color: #de4827;\n}\n.avatar.avatar-tag {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  width: 42px;\n  border-radius: 0.3125rem;\n}\n.avatar img {\n  border-radius: 50%;\n}\n.avatar.avatar-xl {\n  font-size: 1.3125rem;\n}\n.avatar.avatar-xl img {\n  width: 70px;\n  height: 70px;\n}\n.avatar.avatar-xl .avatar-content {\n  height: 70px;\n  width: 70px;\n  font-size: 2.24875rem;\n}\n.avatar.avatar-xl .avatar-content .avatar-icon,\n.avatar.avatar-xl .avatar-content i,\n.avatar.avatar-xl .avatar-content svg {\n  height: 2.625rem;\n  width: 2.625rem;\n  font-size: 2.625rem;\n}\n.avatar.avatar-xl [class*=avatar-status-] {\n  right: 3px;\n  bottom: 0;\n}\n.avatar.avatar-lg {\n  font-size: 1.05rem;\n}\n.avatar.avatar-lg img {\n  width: 50px;\n  height: 50px;\n}\n.avatar.avatar-lg .avatar-content {\n  width: 50px;\n  height: 50px;\n  font-size: 1.49975rem;\n}\n.avatar.avatar-lg .avatar-content .avatar-icon,\n.avatar.avatar-lg .avatar-content i,\n.avatar.avatar-lg .avatar-content svg {\n  height: 1.75rem;\n  width: 1.75rem;\n  font-size: 1.75rem;\n}\n.avatar.avatar-lg [class*=avatar-status-] {\n  right: 3px;\n  bottom: 1px;\n}\n.avatar.avatar-sm .avatar-content {\n  width: 24px;\n  height: 24px;\n}\n.avatar.avatar-sm .avatar-content .avatar-icon,\n.avatar.avatar-sm .avatar-content i,\n.avatar.avatar-sm .avatar-content svg {\n  height: 0.875rem;\n  width: 0.875rem;\n  font-size: 0.875rem;\n}\n.avatar.avatar-sm img {\n  width: 24px;\n  height: 24px;\n}\n.avatar.avatar-sm [class*=avatar-status-] {\n  right: -3px;\n  bottom: -2px;\n}\n\n.avatar-group {\n  display: flex;\n  justify-content: flex-start;\n}\n.avatar-group .avatar {\n  transition: all 0.25s ease;\n}\n.avatar-group .avatar img,\n.avatar-group .avatar .avatar-content {\n  box-shadow: 0 0 0 2px #fdfeff, inset 0 0 0 1px rgba(30, 29, 43, 0.07);\n}\n.avatar-group .avatar:hover {\n  transition: all 0.25s ease;\n}\n.avatar-group .avatar.pull-up:hover {\n  transform: translateY(-4px) scale(1.07);\n}\n.avatar-group .avatar:not(:first-child) {\n  margin-left: -0.48125rem;\n}\n.avatar-group .avatar-sm:not(:first-child) {\n  margin-left: -0.35rem;\n}\n.avatar-group .avatar-lg:not(:first-child) {\n  margin-left: -0.875rem;\n}\n.avatar-group .avatar-xl:not(:first-child) {\n  margin-left: -1.3125rem;\n}\n\n/*=========================================================================================\n\tFile Name: search.scss\n\tDescription: Search  functionality.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.navbar-container .search-input {\n  width: 0;\n  float: left;\n  display: none;\n}\n.navbar-container .search-input input {\n  width: 0;\n  border: none;\n  background: none;\n  transition: all 0.2s ease-out;\n  line-height: 16px;\n  padding: 1.4rem 3.15rem;\n}\n.navbar-container .search-input.open {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  display: block;\n  background: #fdfeff;\n  border-radius: 0.4375rem;\n}\n.navbar-container .search-input.open .search-input-close,\n.navbar-container .search-input.open .search-input-icon {\n  display: block;\n}\n.navbar-container .search-input.open input {\n  width: 100%;\n  outline: none;\n  background: none;\n  height: auto;\n  box-shadow: none;\n  transition: all 0.3s ease-out;\n}\n.navbar-container .search-input .search-list {\n  max-height: 450px;\n  height: auto;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #fdfeff;\n  width: 100%;\n  margin-top: 0.4375rem;\n  padding-left: 0;\n  border-radius: 0.3125rem;\n  display: none;\n}\n@media only screen and (min-device-width: 320px) and (max-device-width: 875px) and (orientation: landscape) {\n  .navbar-container .search-input .search-list {\n    max-height: 250px;\n  }\n}\n.navbar-container .search-input .search-list.search-list-bookmark {\n  height: auto !important;\n}\n.navbar-container .search-input .search-list.search-list-bookmark i,\n.navbar-container .search-input .search-list.search-list-bookmark svg {\n  font-size: 1.05rem;\n  height: 1.05rem;\n  width: 1.05rem;\n}\n.navbar-container .search-input .search-list.show {\n  display: block;\n  min-height: 2.625rem;\n}\n.navbar-container .search-input .search-list li a {\n  padding: 0.7875rem 0.875rem;\n  color: #6e6b7b;\n}\n.navbar-container .search-input .search-list li a i,\n.navbar-container .search-input .search-list li a svg[class*=\"feather feather-\"] {\n  height: 1.09375rem;\n  width: 1.09375rem;\n  font-size: 1.09375rem;\n}\n.navbar-container .search-input .search-list li:first-child {\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n.navbar-container .search-input .search-list li:last-child {\n  border-bottom-left-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n.navbar-container .search-input .search-list li.auto-suggestion {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.navbar-container .search-input .search-list li.auto-suggestion:hover, .navbar-container .search-input .search-list li.auto-suggestion.current_item {\n  background-color: #f8f8f8;\n}\n.navbar-container .search-input .search-input-icon {\n  z-index: 2;\n  display: none;\n  position: absolute;\n  left: 1.3125rem;\n  top: 32%;\n  cursor: pointer;\n}\n.navbar-container .search-input .search-input-icon i,\n.navbar-container .search-input .search-input-icon svg {\n  height: 1.09375rem;\n  width: 1.09375rem;\n  font-size: 1.09375rem;\n}\n.navbar-container .search-input .search-input-close {\n  z-index: 1;\n  display: none;\n  position: absolute;\n  right: 1.75rem;\n  top: 32%;\n  cursor: pointer;\n}\n.navbar-container .search-input .search-input-close i,\n.navbar-container .search-input .search-input-close svg {\n  height: 1.09375rem;\n  width: 1.09375rem;\n  font-size: 1.09375rem;\n}\n.navbar-container .bookmark-input {\n  position: absolute;\n  top: 102%;\n  width: 25%;\n  display: none;\n  background: #fdfeff;\n  border-radius: 0.3125rem;\n  box-shadow: 0 15px 30px 0 rgba(30, 29, 43, 0.11), 0 5px 15px 0 rgba(30, 29, 43, 0.08);\n}\n.navbar-container .bookmark-input.show {\n  display: block;\n}\n.navbar-container .bookmark-input .bookmark-input-icon {\n  position: absolute;\n  z-index: 1;\n  top: 20px;\n  left: 24px;\n}\n.navbar-container .bookmark-input input {\n  padding: 0.6125rem 0.6125rem 0.6125rem 2.1875rem;\n  margin: 12px;\n  width: calc(100% - 24px);\n  background: #fdfeff;\n  border: 1px solid rgba(30, 29, 43, 0.2);\n}\n.navbar-container .bookmark-input input:focus {\n  border: 1px solid #00a0dd;\n}\n.navbar-container .bookmark-input .search-list {\n  position: relative;\n}\n.navbar-container .bookmark-icon {\n  cursor: pointer;\n}\n.navbar-container .dropdown.bookmark-dropdown {\n  padding: 1.225rem 0.4375rem 1.18125rem;\n}\n.navbar-container .dropdown.bookmark-dropdown .dropdown-toggle:after {\n  display: none;\n}\n.navbar-container .search-data-title {\n  line-height: 1.09375rem;\n}\n\n.navbar-dark .search-input .input {\n  color: #f5f7fa;\n  border-radius: 0.4375rem;\n}\n.navbar-dark .search-input.open .input {\n  color: #f5f7fa;\n  border: 1px solid #f5f7fa;\n}\n\n.navbar-static .navbar-container .search-input.open {\n  border-radius: 0;\n}\n\n.btn-social, .btn-social-icon {\n  position: relative;\n  padding-left: 4.5125rem;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.btn-social > :first-child, .btn-social-icon > :first-child {\n  position: absolute;\n  left: 0;\n  top: 2px;\n  bottom: 0;\n  width: 2.7625rem;\n  line-height: 2.5125rem;\n  font-size: 0.875rem;\n  text-align: center;\n  border-right: 1px solid rgba(30, 29, 43, 0.2);\n}\n\n.btn-social-icon {\n  height: 2.7625rem;\n  width: 2.7625rem;\n  padding: 0;\n}\n.btn-social-icon > :first-child {\n  border: none;\n  text-align: center;\n  width: 100% !important;\n}\n\n.btn-adn {\n  background-color: #d87a68;\n  color: #fdfeff;\n  background-color: #d87a68;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-adn:hover {\n  color: #fdfeff;\n  background-color: #d87a68;\n  border-color: #d87a68;\n}\n.btn-adn:focus, .btn-adn.focus {\n  color: #fdfeff;\n  background-color: #d87a68;\n  border-color: #d87a68;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-adn.disabled, .btn-adn:disabled {\n  color: #fdfeff;\n  background-color: #d87a68;\n  border-color: #fff;\n}\n.btn-adn:not(:disabled):not(.disabled):active, .btn-adn:not(:disabled):not(.disabled).active, .show > .btn-adn.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #ce563f;\n  border-color: #dfdfdf;\n}\n.btn-adn:not(:disabled):not(.disabled):active:focus, .btn-adn:not(:disabled):not(.disabled).active:focus, .show > .btn-adn.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-bitbucket {\n  background-color: #205081;\n  color: #fdfeff;\n  background-color: #205081;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-bitbucket:hover {\n  color: #fdfeff;\n  background-color: #205081;\n  border-color: #205081;\n}\n.btn-bitbucket:focus, .btn-bitbucket.focus {\n  color: #fdfeff;\n  background-color: #205081;\n  border-color: #205081;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-bitbucket.disabled, .btn-bitbucket:disabled {\n  color: #fdfeff;\n  background-color: #205081;\n  border-color: #fff;\n}\n.btn-bitbucket:not(:disabled):not(.disabled):active, .btn-bitbucket:not(:disabled):not(.disabled).active, .show > .btn-bitbucket.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #163758;\n  border-color: #dfdfdf;\n}\n.btn-bitbucket:not(:disabled):not(.disabled):active:focus, .btn-bitbucket:not(:disabled):not(.disabled).active:focus, .show > .btn-bitbucket.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-dropbox {\n  background-color: #1087dd;\n  color: #fdfeff;\n  background-color: #1087dd;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-dropbox:hover {\n  color: #fdfeff;\n  background-color: #1087dd;\n  border-color: #1087dd;\n}\n.btn-dropbox:focus, .btn-dropbox.focus {\n  color: #fdfeff;\n  background-color: #1087dd;\n  border-color: #1087dd;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-dropbox.disabled, .btn-dropbox:disabled {\n  color: #fdfeff;\n  background-color: #1087dd;\n  border-color: #fff;\n}\n.btn-dropbox:not(:disabled):not(.disabled):active, .btn-dropbox:not(:disabled):not(.disabled).active, .show > .btn-dropbox.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #0d6aad;\n  border-color: #dfdfdf;\n}\n.btn-dropbox:not(:disabled):not(.disabled):active:focus, .btn-dropbox:not(:disabled):not(.disabled).active:focus, .show > .btn-dropbox.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-facebook {\n  background-color: #3b5998;\n  color: #fdfeff;\n  background-color: #3b5998;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-facebook:hover {\n  color: #fdfeff;\n  background-color: #3b5998;\n  border-color: #3b5998;\n}\n.btn-facebook:focus, .btn-facebook.focus {\n  color: #fdfeff;\n  background-color: #3b5998;\n  border-color: #3b5998;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-facebook.disabled, .btn-facebook:disabled {\n  color: #fdfeff;\n  background-color: #3b5998;\n  border-color: #fff;\n}\n.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #2d4373;\n  border-color: #dfdfdf;\n}\n.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-flickr {\n  background-color: #ff0084;\n  color: #fdfeff;\n  background-color: #ff0084;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-flickr:hover {\n  color: #fdfeff;\n  background-color: #ff0084;\n  border-color: #ff0084;\n}\n.btn-flickr:focus, .btn-flickr.focus {\n  color: #fdfeff;\n  background-color: #ff0084;\n  border-color: #ff0084;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-flickr.disabled, .btn-flickr:disabled {\n  color: #fdfeff;\n  background-color: #ff0084;\n  border-color: #fff;\n}\n.btn-flickr:not(:disabled):not(.disabled):active, .btn-flickr:not(:disabled):not(.disabled).active, .show > .btn-flickr.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #cc006a;\n  border-color: #dfdfdf;\n}\n.btn-flickr:not(:disabled):not(.disabled):active:focus, .btn-flickr:not(:disabled):not(.disabled).active:focus, .show > .btn-flickr.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-foursquare {\n  background-color: #f94877;\n  color: #fdfeff;\n  background-color: #f94877;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-foursquare:hover {\n  color: #fdfeff;\n  background-color: #f94877;\n  border-color: #f94877;\n}\n.btn-foursquare:focus, .btn-foursquare.focus {\n  color: #fdfeff;\n  background-color: #f94877;\n  border-color: #f94877;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-foursquare.disabled, .btn-foursquare:disabled {\n  color: #fdfeff;\n  background-color: #f94877;\n  border-color: #fff;\n}\n.btn-foursquare:not(:disabled):not(.disabled):active, .btn-foursquare:not(:disabled):not(.disabled).active, .show > .btn-foursquare.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #f71752;\n  border-color: #dfdfdf;\n}\n.btn-foursquare:not(:disabled):not(.disabled):active:focus, .btn-foursquare:not(:disabled):not(.disabled).active:focus, .show > .btn-foursquare.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-github {\n  background-color: #444444;\n  color: #fdfeff;\n  background-color: #444444;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-github:hover {\n  color: #fdfeff;\n  background-color: #444444;\n  border-color: #444444;\n}\n.btn-github:focus, .btn-github.focus {\n  color: #fdfeff;\n  background-color: #444444;\n  border-color: #444444;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-github.disabled, .btn-github:disabled {\n  color: #fdfeff;\n  background-color: #444444;\n  border-color: #fff;\n}\n.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #2b2b2b;\n  border-color: #dfdfdf;\n}\n.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-google {\n  background-color: #dd4b39;\n  color: #fdfeff;\n  background-color: #dd4b39;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-google:hover {\n  color: #fdfeff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n}\n.btn-google:focus, .btn-google.focus {\n  color: #fdfeff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-google.disabled, .btn-google:disabled {\n  color: #fdfeff;\n  background-color: #dd4b39;\n  border-color: #fff;\n}\n.btn-google:not(:disabled):not(.disabled):active, .btn-google:not(:disabled):not(.disabled).active, .show > .btn-google.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #c23321;\n  border-color: #dfdfdf;\n}\n.btn-google:not(:disabled):not(.disabled):active:focus, .btn-google:not(:disabled):not(.disabled).active:focus, .show > .btn-google.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-instagram {\n  background-color: #3f729b;\n  color: #fdfeff;\n  background-color: #3f729b;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-instagram:hover {\n  color: #fdfeff;\n  background-color: #3f729b;\n  border-color: #3f729b;\n}\n.btn-instagram:focus, .btn-instagram.focus {\n  color: #fdfeff;\n  background-color: #3f729b;\n  border-color: #3f729b;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-instagram.disabled, .btn-instagram:disabled {\n  color: #fdfeff;\n  background-color: #3f729b;\n  border-color: #fff;\n}\n.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #305777;\n  border-color: #dfdfdf;\n}\n.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-linkedin {\n  background-color: #007bb6;\n  color: #fdfeff;\n  background-color: #007bb6;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-linkedin:hover {\n  color: #fdfeff;\n  background-color: #007bb6;\n  border-color: #007bb6;\n}\n.btn-linkedin:focus, .btn-linkedin.focus {\n  color: #fdfeff;\n  background-color: #007bb6;\n  border-color: #007bb6;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-linkedin.disabled, .btn-linkedin:disabled {\n  color: #fdfeff;\n  background-color: #007bb6;\n  border-color: #fff;\n}\n.btn-linkedin:not(:disabled):not(.disabled):active, .btn-linkedin:not(:disabled):not(.disabled).active, .show > .btn-linkedin.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #005983;\n  border-color: #dfdfdf;\n}\n.btn-linkedin:not(:disabled):not(.disabled):active:focus, .btn-linkedin:not(:disabled):not(.disabled).active:focus, .show > .btn-linkedin.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-microsoft {\n  background-color: #2672ec;\n  color: #fdfeff;\n  background-color: #2672ec;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-microsoft:hover {\n  color: #fdfeff;\n  background-color: #2672ec;\n  border-color: #2672ec;\n}\n.btn-microsoft:focus, .btn-microsoft.focus {\n  color: #fdfeff;\n  background-color: #2672ec;\n  border-color: #2672ec;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-microsoft.disabled, .btn-microsoft:disabled {\n  color: #fdfeff;\n  background-color: #2672ec;\n  border-color: #fff;\n}\n.btn-microsoft:not(:disabled):not(.disabled):active, .btn-microsoft:not(:disabled):not(.disabled).active, .show > .btn-microsoft.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #125acd;\n  border-color: #dfdfdf;\n}\n.btn-microsoft:not(:disabled):not(.disabled):active:focus, .btn-microsoft:not(:disabled):not(.disabled).active:focus, .show > .btn-microsoft.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-odnoklassniki {\n  background-color: #f4731c;\n  color: #fdfeff;\n  background-color: #f4731c;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-odnoklassniki:hover {\n  color: #fdfeff;\n  background-color: #f4731c;\n  border-color: #f4731c;\n}\n.btn-odnoklassniki:focus, .btn-odnoklassniki.focus {\n  color: #fdfeff;\n  background-color: #f4731c;\n  border-color: #f4731c;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-odnoklassniki.disabled, .btn-odnoklassniki:disabled {\n  color: #fdfeff;\n  background-color: #f4731c;\n  border-color: #fff;\n}\n.btn-odnoklassniki:not(:disabled):not(.disabled):active, .btn-odnoklassniki:not(:disabled):not(.disabled).active, .show > .btn-odnoklassniki.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #d35b0a;\n  border-color: #dfdfdf;\n}\n.btn-odnoklassniki:not(:disabled):not(.disabled):active:focus, .btn-odnoklassniki:not(:disabled):not(.disabled).active:focus, .show > .btn-odnoklassniki.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-openid {\n  background-color: #f7931e;\n  color: #2a2e30;\n  background-color: #f7931e;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-openid:hover {\n  color: #2a2e30;\n  background-color: #f7931e;\n  border-color: #f7931e;\n}\n.btn-openid:focus, .btn-openid.focus {\n  color: #2a2e30;\n  background-color: #f7931e;\n  border-color: #f7931e;\n  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);\n}\n.btn-openid.disabled, .btn-openid:disabled {\n  color: #2a2e30;\n  background-color: #f7931e;\n  border-color: #fff;\n}\n.btn-openid:not(:disabled):not(.disabled):active, .btn-openid:not(:disabled):not(.disabled).active, .show > .btn-openid.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #da7908;\n  border-color: #dfdfdf;\n}\n.btn-openid:not(:disabled):not(.disabled):active:focus, .btn-openid:not(:disabled):not(.disabled).active:focus, .show > .btn-openid.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);\n}\n\n.btn-pinterest {\n  background-color: #cb2027;\n  color: #fdfeff;\n  background-color: #cb2027;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-pinterest:hover {\n  color: #fdfeff;\n  background-color: #cb2027;\n  border-color: #cb2027;\n}\n.btn-pinterest:focus, .btn-pinterest.focus {\n  color: #fdfeff;\n  background-color: #cb2027;\n  border-color: #cb2027;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-pinterest.disabled, .btn-pinterest:disabled {\n  color: #fdfeff;\n  background-color: #cb2027;\n  border-color: #fff;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #9f191f;\n  border-color: #dfdfdf;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-reddit {\n  background-color: #eff7ff;\n  color: #2a2e30;\n  background-color: #eff7ff;\n  border-color: #000;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-reddit:hover {\n  color: #fdfeff;\n  background-color: #000;\n  border-color: #000;\n}\n.btn-reddit:focus, .btn-reddit.focus {\n  color: #fdfeff;\n  background-color: #000;\n  border-color: #000;\n  box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);\n}\n.btn-reddit.disabled, .btn-reddit:disabled {\n  color: #2a2e30;\n  background-color: #eff7ff;\n  border-color: #000;\n}\n.btn-reddit:not(:disabled):not(.disabled):active, .btn-reddit:not(:disabled):not(.disabled).active, .show > .btn-reddit.dropdown-toggle {\n  color: #2a2e30;\n  background-color: #bcdeff;\n  border-color: black;\n}\n.btn-reddit:not(:disabled):not(.disabled):active:focus, .btn-reddit:not(:disabled):not(.disabled).active:focus, .show > .btn-reddit.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(6, 7, 7, 0.5);\n}\n\n.btn-soundcloud {\n  background-color: #ff5500;\n  color: #fdfeff;\n  background-color: #ff5500;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-soundcloud:hover {\n  color: #fdfeff;\n  background-color: #ff5500;\n  border-color: #ff5500;\n}\n.btn-soundcloud:focus, .btn-soundcloud.focus {\n  color: #fdfeff;\n  background-color: #ff5500;\n  border-color: #ff5500;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-soundcloud.disabled, .btn-soundcloud:disabled {\n  color: #fdfeff;\n  background-color: #ff5500;\n  border-color: #fff;\n}\n.btn-soundcloud:not(:disabled):not(.disabled):active, .btn-soundcloud:not(:disabled):not(.disabled).active, .show > .btn-soundcloud.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #cc4400;\n  border-color: #dfdfdf;\n}\n.btn-soundcloud:not(:disabled):not(.disabled):active:focus, .btn-soundcloud:not(:disabled):not(.disabled).active:focus, .show > .btn-soundcloud.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-tumblr {\n  background-color: #2c4762;\n  color: #fdfeff;\n  background-color: #2c4762;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-tumblr:hover {\n  color: #fdfeff;\n  background-color: #2c4762;\n  border-color: #2c4762;\n}\n.btn-tumblr:focus, .btn-tumblr.focus {\n  color: #fdfeff;\n  background-color: #2c4762;\n  border-color: #2c4762;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-tumblr.disabled, .btn-tumblr:disabled {\n  color: #fdfeff;\n  background-color: #2c4762;\n  border-color: #fff;\n}\n.btn-tumblr:not(:disabled):not(.disabled):active, .btn-tumblr:not(:disabled):not(.disabled).active, .show > .btn-tumblr.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #1c2e3f;\n  border-color: #dfdfdf;\n}\n.btn-tumblr:not(:disabled):not(.disabled):active:focus, .btn-tumblr:not(:disabled):not(.disabled).active:focus, .show > .btn-tumblr.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-twitter {\n  background-color: #55acee;\n  color: #2a2e30;\n  background-color: #55acee;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-twitter:hover {\n  color: #2a2e30;\n  background-color: #55acee;\n  border-color: #55acee;\n}\n.btn-twitter:focus, .btn-twitter.focus {\n  color: #2a2e30;\n  background-color: #55acee;\n  border-color: #55acee;\n  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);\n}\n.btn-twitter.disabled, .btn-twitter:disabled {\n  color: #2a2e30;\n  background-color: #55acee;\n  border-color: #fff;\n}\n.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #2795e9;\n  border-color: #dfdfdf;\n}\n.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(223, 224, 224, 0.5);\n}\n\n.btn-vimeo {\n  background-color: #1ab7ea;\n  color: #fdfeff;\n  background-color: #1ab7ea;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-vimeo:hover {\n  color: #fdfeff;\n  background-color: #1ab7ea;\n  border-color: #1ab7ea;\n}\n.btn-vimeo:focus, .btn-vimeo.focus {\n  color: #fdfeff;\n  background-color: #1ab7ea;\n  border-color: #1ab7ea;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-vimeo.disabled, .btn-vimeo:disabled {\n  color: #fdfeff;\n  background-color: #1ab7ea;\n  border-color: #fff;\n}\n.btn-vimeo:not(:disabled):not(.disabled):active, .btn-vimeo:not(:disabled):not(.disabled).active, .show > .btn-vimeo.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #1295bf;\n  border-color: #dfdfdf;\n}\n.btn-vimeo:not(:disabled):not(.disabled):active:focus, .btn-vimeo:not(:disabled):not(.disabled).active:focus, .show > .btn-vimeo.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-vk {\n  background-color: #587ea3;\n  color: #fdfeff;\n  background-color: #587ea3;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-vk:hover {\n  color: #fdfeff;\n  background-color: #587ea3;\n  border-color: #587ea3;\n}\n.btn-vk:focus, .btn-vk.focus {\n  color: #fdfeff;\n  background-color: #587ea3;\n  border-color: #587ea3;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-vk.disabled, .btn-vk:disabled {\n  color: #fdfeff;\n  background-color: #587ea3;\n  border-color: #fff;\n}\n.btn-vk:not(:disabled):not(.disabled):active, .btn-vk:not(:disabled):not(.disabled).active, .show > .btn-vk.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #466482;\n  border-color: #dfdfdf;\n}\n.btn-vk:not(:disabled):not(.disabled):active:focus, .btn-vk:not(:disabled):not(.disabled).active:focus, .show > .btn-vk.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-yahoo {\n  background-color: #720e9e;\n  color: #fdfeff;\n  background-color: #720e9e;\n  border-color: #fff;\n  color: #fdfeff !important;\n  border: none;\n}\n.btn-yahoo:hover {\n  color: #fdfeff;\n  background-color: #720e9e;\n  border-color: #720e9e;\n}\n.btn-yahoo:focus, .btn-yahoo.focus {\n  color: #fdfeff;\n  background-color: #720e9e;\n  border-color: #720e9e;\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n.btn-yahoo.disabled, .btn-yahoo:disabled {\n  color: #fdfeff;\n  background-color: #720e9e;\n  border-color: #fff;\n}\n.btn-yahoo:not(:disabled):not(.disabled):active, .btn-yahoo:not(:disabled):not(.disabled).active, .show > .btn-yahoo.dropdown-toggle {\n  color: #fdfeff;\n  background-color: #500a6f;\n  border-color: #dfdfdf;\n}\n.btn-yahoo:not(:disabled):not(.disabled):active:focus, .btn-yahoo:not(:disabled):not(.disabled).active:focus, .show > .btn-yahoo.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-adn {\n  border: 1px solid #d87a68 !important;\n  color: #d87a68;\n}\n\n.btn-outline-bitbucket {\n  border: 1px solid #205081 !important;\n  color: #205081;\n}\n\n.btn-outline-dropbox {\n  border: 1px solid #1087dd !important;\n  color: #1087dd;\n}\n\n.btn-outline-facebook {\n  border: 1px solid #3b5998 !important;\n  color: #3b5998;\n}\n\n.btn-outline-flickr {\n  border: 1px solid #ff0084 !important;\n  color: #ff0084;\n}\n\n.btn-outline-foursquare {\n  border: 1px solid #f94877 !important;\n  color: #f94877;\n}\n\n.btn-outline-github {\n  border: 1px solid #444444 !important;\n  color: #444444;\n}\n\n.btn-outline-google {\n  border: 1px solid #dd4b39 !important;\n  color: #dd4b39;\n}\n\n.btn-outline-instagram {\n  border: 1px solid #3f729b !important;\n  color: #3f729b;\n}\n\n.btn-outline-linkedin {\n  border: 1px solid #007bb6 !important;\n  color: #007bb6;\n}\n\n.btn-outline-microsoft {\n  border: 1px solid #2672ec !important;\n  color: #2672ec;\n}\n\n.btn-outline-odnoklassniki {\n  border: 1px solid #f4731c !important;\n  color: #f4731c;\n}\n\n.btn-outline-openid {\n  border: 1px solid #f7931e !important;\n  color: #f7931e;\n}\n\n.btn-outline-pinterest {\n  border: 1px solid #cb2027 !important;\n  color: #cb2027;\n}\n\n.btn-outline-reddit {\n  border: 1px solid #ff4500 !important;\n  color: #ff4500;\n}\n\n.btn-outline-soundcloud {\n  border: 1px solid #ff5500 !important;\n  color: #ff5500;\n}\n\n.btn-outline-tumblr {\n  border: 1px solid #2c4762 !important;\n  color: #2c4762;\n}\n\n.btn-outline-twitter {\n  border: 1px solid #55acee !important;\n  color: #55acee;\n}\n\n.btn-outline-vimeo {\n  border: 1px solid #1ab7ea !important;\n  color: #1ab7ea;\n}\n\n.btn-outline-vk {\n  border: 1px solid #587ea3 !important;\n  color: #587ea3;\n}\n\n.btn-outline-yahoo {\n  border: 1px solid #720e9e !important;\n  color: #720e9e;\n}\n\n.btn-outline-adn:hover {\n  color: #ad412d;\n  border: 1px solid #ad412d !important;\n}\n\n.btn-outline-bitbucket:hover {\n  color: #0c1d2f;\n  border: 1px solid #0c1d2f !important;\n}\n\n.btn-outline-dropbox:hover {\n  color: #094d7e;\n  border: 1px solid #094d7e !important;\n}\n\n.btn-outline-facebook:hover {\n  color: #1e2e4f;\n  border: 1px solid #1e2e4f !important;\n}\n\n.btn-outline-flickr:hover {\n  color: #99004f;\n  border: 1px solid #99004f !important;\n}\n\n.btn-outline-foursquare:hover {\n  color: #d4073d;\n  border: 1px solid #d4073d !important;\n}\n\n.btn-outline-github:hover {\n  color: #111111;\n  border: 1px solid #111111 !important;\n}\n\n.btn-outline-google:hover {\n  color: #96271a;\n  border: 1px solid #96271a !important;\n}\n\n.btn-outline-instagram:hover {\n  color: #223d52;\n  border: 1px solid #223d52 !important;\n}\n\n.btn-outline-linkedin:hover {\n  color: #003650;\n  border: 1px solid #003650 !important;\n}\n\n.btn-outline-microsoft:hover {\n  color: #0e459e;\n  border: 1px solid #0e459e !important;\n}\n\n.btn-outline-odnoklassniki:hover {\n  color: #a24608;\n  border: 1px solid #a24608 !important;\n}\n\n.btn-outline-openid:hover {\n  color: #a95e06;\n  border: 1px solid #a95e06 !important;\n}\n\n.btn-outline-pinterest:hover {\n  color: #731216;\n  border: 1px solid #731216 !important;\n}\n\n.btn-outline-reddit:hover {\n  color: #992900;\n  border: 1px solid #992900 !important;\n}\n\n.btn-outline-soundcloud:hover {\n  color: #993300;\n  border: 1px solid #993300 !important;\n}\n\n.btn-outline-tumblr:hover {\n  color: #0c141c;\n  border: 1px solid #0c141c !important;\n}\n\n.btn-outline-twitter:hover {\n  color: #147bc9;\n  border: 1px solid #147bc9 !important;\n}\n\n.btn-outline-vimeo:hover {\n  color: #0d7091;\n  border: 1px solid #0d7091 !important;\n}\n\n.btn-outline-vk:hover {\n  color: #344b61;\n  border: 1px solid #344b61 !important;\n}\n\n.btn-outline-yahoo:hover {\n  color: #2e0640;\n  border: 1px solid #2e0640 !important;\n}\n\n.bg-adn {\n  background-color: #d87a68;\n}\n\n.bg-bitbucket {\n  background-color: #205081;\n}\n\n.bg-dropbox {\n  background-color: #1087dd;\n}\n\n.bg-facebook {\n  background-color: #3b5998;\n}\n\n.bg-flickr {\n  background-color: #ff0084;\n}\n\n.bg-foursquare {\n  background-color: #f94877;\n}\n\n.bg-github {\n  background-color: #444444;\n}\n\n.bg-google {\n  background-color: #dd4b39;\n}\n\n.bg-instagram {\n  background-color: #3f729b;\n}\n\n.bg-linkedin {\n  background-color: #007bb6;\n}\n\n.bg-microsoft {\n  background-color: #2672ec;\n}\n\n.bg-odnoklassniki {\n  background-color: #f4731c;\n}\n\n.bg-openid {\n  background-color: #f7931e;\n}\n\n.bg-pinterest {\n  background-color: #cb2027;\n}\n\n.bg-reddit {\n  background-color: #ff4500;\n}\n\n.bg-soundcloud {\n  background-color: #ff5500;\n}\n\n.bg-tumblr {\n  background-color: #2c4762;\n}\n\n.bg-twitter {\n  background-color: #55acee;\n}\n\n.bg-vimeo {\n  background-color: #1ab7ea;\n}\n\n.bg-vk {\n  background-color: #587ea3;\n}\n\n.bg-yahoo {\n  background-color: #720e9e;\n}\n\n/*=========================================================================================\n    File Name: demo.scss\n    Description: CSS used for demo purpose only. Remove this css from your project.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.demo-inline-spacing {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n.demo-inline-spacing > * {\n  margin-right: 1.3125rem;\n  margin-top: 1.3125rem;\n}\n\n.demo-vertical-spacing > * {\n  margin: 0;\n  margin-bottom: 1.3125rem;\n}\n.demo-vertical-spacing > *:last-child {\n  margin: 0;\n}\n\n.demo-spacing-0 > *:last-child {\n  margin: 0;\n}\n\n.icon-wrapper .feather {\n  height: 24px;\n  width: 24px;\n}\n\n.scroll-example {\n  padding: 0.4375rem;\n  position: relative;\n  border: 2px solid #dfdfdf;\n  overflow: auto;\n}\n.scroll-example .horz-scroll-content {\n  width: 1200px;\n}\n\n.browser {\n  background: #e0e0e0;\n  border: 4px solid #e0e0e0;\n  width: 100%;\n  height: 10.5rem;\n  padding-top: 20px;\n  margin: 0 0 10px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.browser iframe {\n  border: 0;\n  background: #fff;\n  height: 100%;\n  width: 100%;\n}\n\n.loader-wrapper {\n  height: 8em;\n}\n\n.maintenance-icon {\n  font-size: 3.5rem;\n}\n\n.animationIcon {\n  right: 30px;\n  bottom: 10px;\n}\n\n.buy-now {\n  position: fixed;\n  bottom: 5%;\n  right: 79px;\n  z-index: 1031;\n}\n.buy-now .btn {\n  box-shadow: 0 1px 20px 1px #de4827 !important;\n}\n.buy-now .btn:hover {\n  box-shadow: none !important;\n}\n\n/*=========================================================================================\n\tFile Name: customizer.scss\n\tDescription: CSS used for demo purpose only. Remove this css from your project.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n.customizer {\n  width: 400px;\n  right: -400px;\n  padding: 0;\n  background-color: #fdfeff;\n  z-index: 1051;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  backface-visibility: hidden;\n  border-left: 1px solid rgba(30, 29, 43, 0.05);\n}\n.customizer.open {\n  box-shadow: 0 15px 30px 0 rgba(30, 29, 43, 0.11), 0 5px 15px 0 rgba(30, 29, 43, 0.08);\n  right: 0;\n}\n.customizer .customizer-content {\n  position: relative;\n  height: 100%;\n}\n.customizer .customizer-close {\n  position: absolute;\n  right: 0.525rem;\n  top: 0.525rem;\n  padding: 7px;\n  width: auto;\n  z-index: 10;\n  color: #5e5873;\n}\n.customizer .customizer-close i,\n.customizer .customizer-close svg {\n  font-size: 1.3125rem;\n  height: 1.3125rem;\n  width: 1.3125rem;\n}\n.customizer .customizer-toggle {\n  background: #00a0dd;\n  color: #fdfeff !important;\n  display: block;\n  box-shadow: -3px 0px 8px rgba(30, 29, 43, 0.1);\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n  position: absolute;\n  top: 50%;\n  width: 38px;\n  height: 38px;\n  left: -39px;\n  text-align: center;\n  line-height: 40px;\n  cursor: pointer;\n}\n.customizer .color-box {\n  height: 24px;\n  width: 24px;\n  margin: 0.4375rem;\n  border-radius: 0.4375rem;\n  cursor: pointer;\n  position: relative;\n}\n.customizer .color-box.selected:after {\n  content: \"\";\n  border: 1px solid #00a0dd;\n  height: 30px;\n  width: 30px;\n  top: -3px;\n  left: -3px;\n  position: absolute;\n  border-radius: 0.4375rem;\n}\n.customizer .color-box.selected.border:after {\n  top: -4px;\n  left: -4px;\n}\n\n.divider {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  margin: 0.875rem 0;\n}\n.divider .divider-text {\n  position: relative;\n  display: inline-block;\n  font-size: 0.8203125rem;\n  padding: 0 0.875rem;\n}\n.divider .divider-text i,\n.divider .divider-text svg {\n  height: 0.875rem;\n  width: 0.875rem;\n  font-size: 0.875rem;\n}\n.divider .divider-text:before, .divider .divider-text:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 9999px;\n  border-top: 1px solid #ebe9f1;\n}\n.divider .divider-text:before {\n  right: 100%;\n}\n.divider .divider-text:after {\n  left: 100%;\n}\n.divider.divider-left .divider-text {\n  float: left;\n  padding-left: 0;\n}\n.divider.divider-left .divider-text:before {\n  display: none;\n}\n.divider.divider-left-center .divider-text {\n  left: -25%;\n}\n.divider.divider-right .divider-text {\n  float: right;\n  padding-right: 0;\n}\n.divider.divider-right .divider-text:after {\n  display: none;\n}\n.divider.divider-right-center .divider-text {\n  right: -25%;\n}\n.divider.divider-dotted .divider-text:before, .divider.divider-dotted .divider-text:after {\n  border-style: dotted;\n  border-width: 1px;\n  border-top-width: 0;\n  border-color: #ebe9f1;\n}\n.divider.divider-dashed .divider-text:before, .divider.divider-dashed .divider-text:after {\n  border-style: dashed;\n  border-width: 1px;\n  border-top-width: 0;\n  border-color: #ebe9f1;\n}\n\n.timeline {\n  padding: 0;\n  margin-bottom: 0;\n  margin-left: 0.875rem;\n  list-style: none;\n}\n.timeline .timeline-item {\n  position: relative;\n  padding-left: 2.1875rem;\n  border-left: 1px solid #ebe9f1;\n}\n.timeline .timeline-item:not(:last-child) {\n  padding-bottom: 1.575rem;\n}\n.timeline .timeline-item .timeline-point {\n  position: absolute;\n  left: -0.74375rem;\n  top: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 1.53125rem;\n  width: 1.53125rem;\n  text-align: center;\n  border-radius: 50%;\n  border: 1px solid #00a0dd;\n  background-color: #fdfeff;\n}\n.timeline .timeline-item .timeline-point.timeline-point-indicator {\n  left: -0.3605rem;\n  top: 0.06125rem;\n  height: 12px;\n  width: 12px;\n  border: 0;\n  background-color: #00a0dd;\n}\n.timeline .timeline-item .timeline-point.timeline-point-indicator:before {\n  content: \"\";\n  background: rgba(0, 160, 221, 0.12);\n  height: 20px;\n  width: 20px;\n  display: block;\n  position: absolute;\n  top: -0.249375rem;\n  left: -0.249375rem;\n  border-radius: 50%;\n}\n.timeline .timeline-item .timeline-point i,\n.timeline .timeline-item .timeline-point svg {\n  color: #00a0dd;\n  font-size: 0.74375rem;\n  vertical-align: baseline;\n}\n.timeline .timeline-item .timeline-event {\n  position: relative;\n  width: 100%;\n  min-height: 3.5rem;\n}\n.timeline .timeline-item .timeline-event .timeline-event-time {\n  font-size: 0.74375rem;\n  color: #b9b9c3;\n}\n.timeline .timeline-item:last-of-type {\n  border-left-color: transparent !important;\n}\n.timeline .timeline-item:last-of-type:after {\n  content: \"\";\n  position: absolute;\n  left: -1px;\n  bottom: 0;\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(#ebe9f1, transparent);\n}\n\n.with-border {\n  border-bottom: 2px solid #c8ced3;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n}\n\n.vertical-timeline-element-content {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n  margin-top: 45px;\n}\n\n.vertical-timeline-element-icon {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n}\n\n.vertical-timeline::before {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n}\n\n.timeline-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.timeline-content {\n  position: relative;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.timeline-day-label {\n  position: absolute;\n  z-index: 2;\n}\n\n.timeline-card-header {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n}\n\n.timeline-card-content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.timeline-card-left,\n.timeline-card-right {\n  flex-basis: 49.5%;\n  flex-grow: 1;\n  padding: 10px;\n}\n\n.timeline-card-divider {\n  width: 1px;\n  background-color: #ccc;\n  flex-shrink: 0;\n  margin-right: 10px;\n}\n\n.timeline-horizontal-rule {\n  border-width: 2px;\n  margin-left: 22px;\n  margin-bottom: 20px;\n}\n\n.timeline-toolbar {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  box-shadow: 1px 1px 12px #b9b9b9;\n  border-radius: 4px;\n  margin-top: 20px;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n\n.search-column {\n  flex: 1;\n  padding: 0 10px;\n}\n\n.search-container {\n  position: relative;\n  border: 1px solid #e8eaeb;\n  height: 36px;\n  border-radius: 2px;\n  margin: 20px;\n}\n\n.search-container:hover {\n  border: 1px solid #999;\n}\n\n.timeline-search-bar {\n  padding: 7px 9px 8px;\n  padding-left: 34px;\n  border: none;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.timeline-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #999;\n}\n\n.action-type-column {\n  flex: 1;\n  padding: 0 10px;\n}\n\n.action-type-column .control {\n  height: 36px !important;\n  box-sizing: border-box;\n}\n\n.action-type-column [role=button] svg {\n  fill: #999 !important;\n}\n\n.date-range-column {\n  flex: 2;\n  padding: 0 0 0 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 36px;\n  flex-direction: row;\n  overflow: visible;\n}\n\n.dx-field-label.multiline-label {\n  padding: 13px 0px 0px 0px;\n  width: 28%;\n}\n\n.dx-field-value {\n  padding: 13px 0px 0px 0px;\n  width: 72%;\n}\n\n.button-column {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 0 10px;\n}\n\n.timeline-clear-filters-button {\n  margin-right: 20px;\n}\n\n@media (max-width: 1416px) {\n  .timeline-toolbar {\n    padding: 0 10px;\n  }\n\n  .search-column {\n    padding: 0;\n    flex: 2;\n  }\n\n  .action-type-column {\n    flex: 2;\n    padding: 0 5px;\n  }\n\n  .date-range-column {\n    flex: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 36px;\n    flex-direction: row;\n    overflow: visible;\n  }\n\n  .dx-field-label.multiline-label {\n    padding: 8px 0px 0px 0px;\n    width: 28%;\n    flex: 2;\n  }\n\n  .dx-field-value {\n    padding: 8px 0px 0px 0px;\n    width: 72%;\n    flex: 2;\n  }\n\n  .button-column {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n  }\n}\n@media (max-width: 768px) {\n  .timeline-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n\n  .search-container {\n    margin: 20px;\n  }\n\n  .action-type-column {\n    margin: 20px 14px 20px 14px;\n  }\n\n  .dx-field {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 20px 24px 20px 20px;\n  }\n\n  .dx-field-label.multiline-label {\n    width: 100%;\n  }\n\n  .dx-field-value {\n    width: 100%;\n  }\n\n  .timeline-clear-filters-button {\n    margin: 20px 24px 20px 20px;\n  }\n}\n.timeline-log {\n  position: relative;\n}\n\n.timeline-sticky-button {\n  position: sticky;\n  top: 20 px;\n  z-index: 2;\n}\n\n.timeline-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  margin-bottom: 35px;\n}\n\n.timeline-perPageOptions {\n  display: flex;\n  gap: 10px;\n}\n\n.timeline-perPageOptions span {\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.3s;\n}\n\n.timeline-perPageOptions span.active,\n.timeline-perPageOptions span:hover {\n  background-color: #ddd;\n  border-radius: 2px;\n}\n\n.timeline-pager-info {\n  font-size: 14px;\n  color: #666;\n}\n\n.timeline-pager {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.timeline-pager button {\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  transition: background-color 0.3s;\n}\n\n.timeline-pager button:hover,\n.timeline-pager button.active {\n  background-color: #ddd;\n  border-radius: 2px;\n}\n\n.timeline-pager button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dark-layout .timeline-card-header h2 {\n  color: #d0d2d6;\n}\n\n.dark-layout .timeline-pager button {\n  color: #d0d2d6;\n  background-color: #555;\n}\n\n.dark-layout .timeline-perPageOptions span.active {\n  color: #d0d2d6;\n  background-color: #555;\n}\n\n@media screen and (min-width: 0px) {\n  head {\n    font-family: \"xs 0px\";\n  }\n\n  body:after {\n    content: \"xs - min-width: 0px\";\n  }\n}\n@media screen and (min-width: 544px) {\n  head {\n    font-family: \"sm 544px\";\n  }\n\n  body:after {\n    content: \"sm - min-width: 544px\";\n  }\n}\n@media screen and (min-width: 768px) {\n  head {\n    font-family: \"md 768px\";\n  }\n\n  body:after {\n    content: \"md - min-width: 768px\";\n  }\n}\n@media screen and (min-width: 992px) {\n  head {\n    font-family: \"lg 992px\";\n  }\n\n  body:after {\n    content: \"lg - min-width: 992px\";\n  }\n}\n@media screen and (min-width: 1200px) {\n  head {\n    font-family: \"xl 1200px\";\n  }\n\n  body:after {\n    content: \"xl - min-width: 1200px\";\n  }\n}\nhead {\n  clear: both;\n}\nhead title {\n  font-family: \"xs 0px, sm 544px, md 768px, lg 992px, xl 1200px\";\n}\n\nbody:after {\n  display: none;\n}\n\n*[data-usn-if] {\n  display: none;\n}\n\n.vertical-timeline-element-icon svg {\n  display: block !important;\n}\n\n.select2-container {\n  width: 100% !important;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n\n.select2-container--classic:focus,\n.select2-container--default:focus {\n  outline: none;\n}\n.select2-container--classic .select2-selection__choice,\n.select2-container--default .select2-selection__choice {\n  font-size: 0.7875rem;\n  margin-top: 6px !important;\n}\n.select2-container--classic .select2-selection--single,\n.select2-container--default .select2-selection--single {\n  min-height: 2.37475rem;\n  padding: 5px;\n  border: 1px solid #d8d6de;\n}\n.select2-container--classic .select2-selection--single:focus,\n.select2-container--default .select2-selection--single:focus {\n  outline: 0;\n  border-color: #00a0dd !important;\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1) !important;\n}\n.select2-container--classic .select2-selection--single .select2-selection__rendered i,\n.select2-container--classic .select2-selection--single .select2-selection__rendered svg,\n.select2-container--default .select2-selection--single .select2-selection__rendered i,\n.select2-container--default .select2-selection--single .select2-selection__rendered svg {\n  font-size: 1.00625rem;\n  height: 1.00625rem;\n  width: 1.00625rem;\n  margin-right: 0.4375rem;\n}\n.select2-container--classic .select2-selection--single .select2-selection__arrow b,\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23d8d6de' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-size: 18px 14px, 18px 14px;\n  background-repeat: no-repeat;\n  height: 0.875rem;\n  padding-right: 1.3125rem;\n  margin-left: 0;\n  margin-top: 0;\n  left: -8px;\n  border-style: none;\n}\n.select2-container--classic.select2-container--open,\n.select2-container--default.select2-container--open {\n  box-shadow: 0 5px 25px rgba(30, 29, 43, 0.1);\n}\n.select2-container--classic.select2-container--open .select2-selection--single,\n.select2-container--default.select2-container--open .select2-selection--single {\n  border-color: #00a0dd !important;\n  outline: 0;\n}\n.select2-container--classic.select2-container--focus,\n.select2-container--default.select2-container--focus {\n  outline: 0;\n}\n.select2-container--classic.select2-container--focus .select2-selection--multiple,\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border-color: #00a0dd !important;\n  outline: 0;\n}\n.select2-container--classic .select2-dropdown,\n.select2-container--default .select2-dropdown {\n  border-color: #d8d6de;\n}\n.select2-container--classic .select2-search--dropdown,\n.select2-container--default .select2-search--dropdown {\n  padding: 0.4375rem;\n}\n.select2-container--classic .select2-search--dropdown .select2-search__field,\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  outline: none !important;\n  border-radius: 0.3125rem;\n  border-color: #d8d6de;\n  padding: 0.438rem 1rem;\n}\n.select2-container--classic .select2-selection--multiple,\n.select2-container--default .select2-selection--multiple {\n  min-height: 38px !important;\n  border: 1px solid #d8d6de;\n}\n.select2-container--classic .select2-selection--multiple:focus,\n.select2-container--default .select2-selection--multiple:focus {\n  outline: 0;\n  border-color: #00a0dd !important;\n  box-shadow: 0 3px 10px 0 rgba(30, 29, 43, 0.1) !important;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  background-color: #00a0dd !important;\n  border-color: #00a0dd !important;\n  color: #fdfeff;\n  padding: 2px 5px;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__rendered,\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\n  padding: 0 6px;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__rendered li .select2-search__field,\n.select2-container--default .select2-selection--multiple .select2-selection__rendered li .select2-search__field {\n  margin-top: 7px;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove,\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  float: right;\n  margin-left: 0.6125rem;\n  margin-right: 0.4375rem;\n  font-size: 0px;\n  display: inline-block;\n  position: relative;\n  line-height: 0.875rem;\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove:before,\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E\");\n  background-size: 0.74375rem;\n  height: 0.74375rem;\n  width: 0.74375rem;\n  position: absolute;\n  top: 22%;\n  left: -4px;\n}\n.select2-container--classic .select2-selection--multiple i,\n.select2-container--classic .select2-selection--multiple svg,\n.select2-container--default .select2-selection--multiple i,\n.select2-container--default .select2-selection--multiple svg {\n  position: relative;\n  top: 1px;\n  margin-right: 0.4375rem;\n  height: 1.00625rem;\n  width: 1.00625rem;\n  font-size: 1.00625rem;\n  padding-left: 1px;\n}\n.select2-container--classic .select2-results__group,\n.select2-container--default .select2-results__group {\n  padding: 6px 9px;\n  font-weight: 600;\n}\n.select2-container--classic .select2-results__option,\n.select2-container--default .select2-results__option {\n  padding: 0.3745rem 0.875rem;\n}\n.select2-container--classic .select2-results__option[role=group],\n.select2-container--default .select2-results__option[role=group] {\n  padding: 0;\n}\n.select2-container--classic .select2-results__option[aria-selected=true],\n.select2-container--default .select2-results__option[aria-selected=true] {\n  background-color: #00a0dd !important;\n  color: white !important;\n}\n.select2-container--classic .select2-results__option i,\n.select2-container--classic .select2-results__option svg,\n.select2-container--default .select2-results__option i,\n.select2-container--default .select2-results__option svg {\n  height: 1.00625rem;\n  width: 1.00625rem;\n  font-size: 1.00625rem;\n  margin-right: 0.4375rem;\n}\n.select2-container--classic .select2-results__option--highlighted,\n.select2-container--default .select2-results__option--highlighted {\n  background-color: rgba(0, 160, 221, 0.12) !important;\n  color: #00a0dd !important;\n}\n.select2-container--classic .select2-result-repository__avatar img,\n.select2-container--default .select2-result-repository__avatar img {\n  width: 50px;\n}\n.select2-container--classic .select-lg,\n.select2-container--default .select-lg {\n  min-height: 2.714rem !important;\n  font-size: 1.2rem;\n  margin-bottom: 0 !important;\n  padding: 0.2625rem 0.6125rem;\n}\n.select2-container--classic .select-lg.select2-selection--single .select2-selection__rendered,\n.select2-container--default .select-lg.select2-selection--single .select2-selection__rendered {\n  padding-top: -0.2rem;\n}\n.select2-container--classic .select-lg.select2-selection--single .select2-selection__arrow,\n.select2-container--default .select-lg.select2-selection--single .select2-selection__arrow {\n  top: -0.1rem !important;\n}\n.select2-container--classic .select-lg.select2-selection--multiple,\n.select2-container--default .select-lg.select2-selection--multiple {\n  padding: 0 0.175rem;\n}\n.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered,\n.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered {\n  padding-top: 0 !important;\n}\n.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li,\n.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li {\n  font-size: 1.2rem;\n}\n.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field,\n.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered li .select2-search__field {\n  margin-top: 10px;\n}\n.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice,\n.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice {\n  padding: 5px;\n}\n.select2-container--classic .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before,\n.select2-container--default .select-lg.select2-selection--multiple .select2-selection__rendered .select2-selection__choice .select2-selection__choice__remove:before {\n  top: 46%;\n}\n.select2-container--classic .select-sm,\n.select2-container--default .select-sm {\n  min-height: 2.142rem !important;\n  padding: 0 0.175rem;\n  font-size: 0.65625rem;\n  margin-bottom: 0 !important;\n  line-height: 1.5;\n}\n.select2-container--classic .select-sm.select2-selection--single .select2-selection__arrow,\n.select2-container--default .select-sm.select2-selection--single .select2-selection__arrow {\n  top: -0.2625rem !important;\n}\n.select2-container--classic .select-sm.select2-selection--multiple,\n.select2-container--default .select-sm.select2-selection--multiple {\n  line-height: 1.3;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered,\n.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered {\n  padding: 3px;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li,\n.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li {\n  font-size: 0.65625rem;\n  margin-top: 2px;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field,\n.select2-container--default .select-sm.select2-selection--multiple .select2-selection__rendered li .select2-search__field {\n  margin-top: 4px;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice {\n  padding: 0 0.175rem;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before,\n.select2-container--default .select-sm.select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove:before {\n  top: 5%;\n}\n.select2-container--classic .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field,\n.select2-container--default .select-sm.select2-selection--multiple .select2-search--inline .select2-search__field {\n  margin-top: 0;\n}\n\n.dark-layout .select2-container .select2-selection,\n.dark-layout .select2-container .select2-search__field,\n.dark-layout .select2-container .select2-selection__placeholder {\n  background: #283046;\n  border-color: #3b4253;\n  color: #b4b7bd;\n}\n.dark-layout .select2-container .select2-selection__rendered {\n  color: #b4b7bd;\n}\n.dark-layout .select2-container .select2-dropdown {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice {\n  background: rgba(0, 160, 221, 0.12) !important;\n  color: #00a0dd !important;\n  border: none;\n}\n.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice .select2-selection__choice__remove {\n  color: #00a0dd !important;\n}\n.dark-layout .select2-container .select2-selection--multiple .select2-selection__choice__remove:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2300a0dd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E\");\n}\n.dark-layout .select2-container .select2-results__option[aria-disabled=true] {\n  color: #676d7d;\n}\n.dark-layout .select2-container .select2-selection__arrow b {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .select2-container--disabled .select2-selection {\n  opacity: 0.5;\n}\n\ntable.dataTable {\n  width: 100% !important;\n  border-collapse: collapse !important;\n}\ntable.dataTable td,\ntable.dataTable th {\n  padding: 0.625rem 1.3125rem;\n  vertical-align: middle;\n}\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc {\n  padding-right: inherit;\n}\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235e5873' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 12px;\n  color: #6e6b7b;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n  right: 0.2625rem;\n  top: 0.4375rem;\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235e5873' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 12px;\n  color: #6e6b7b;\n  width: 14px;\n  height: 14px;\n  content: \"\";\n  right: 0.2625rem;\n  top: 1.1375rem;\n}\ntable.dataTable .dt-checkboxes-cell .custom-control {\n  padding-left: 0;\n  padding-right: 1.09375rem;\n}\n\ndiv.dataTables_wrapper .dt-button-collection {\n  background-color: #fdfeff;\n}\ndiv.dataTables_wrapper .dt-button-collection > div[role=menu] {\n  text-align: left;\n  box-shadow: 0px 5px 16px -8px;\n  min-width: 7rem;\n}\ndiv.dataTables_wrapper .dt-button-collection [class*=buttons-]:focus {\n  outline: 0;\n}\n\ntable.dataTable.dtr-column > tbody > tr > td.control:before,\ntable.dataTable.dtr-column > tbody > tr > th.control:before {\n  line-height: 16px;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter label,\ndiv.dataTables_wrapper div.dataTables_length label {\n  margin-top: 0.875rem;\n  margin-bottom: 0.4375rem;\n}\ndiv.dataTables_wrapper div.dataTables_filter select,\ndiv.dataTables_wrapper div.dataTables_length select {\n  background-position: calc(100% - 3px) 11px, calc(100% - 20px) 13px, 100% 0;\n  padding: 0 0.7rem;\n  width: 4.375rem;\n  margin: 0 0.4375rem;\n}\ndiv.dataTables_wrapper div.dataTables_filter input {\n  margin-left: 0.65625rem;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin-top: 0.875rem;\n  margin-bottom: 1.3125rem;\n}\ndiv.dataTables_wrapper .dataTables_info {\n  padding-top: 1.09375rem !important;\n  color: #b9b9c3;\n}\n\ntr.group {\n  background-color: #fafafc;\n}\n\n@media only screen and (max-width: 768px) {\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: center;\n  }\n\n  div.dataTables_wrapper div.dataTables_info {\n    white-space: inherit;\n  }\n\n  div.dt-buttons {\n    justify-content: center;\n    margin-top: 0.875rem;\n  }\n  div.dt-buttons button {\n    margin-bottom: 0.4375rem;\n  }\n}\n@media (max-width: 575.98px) {\n  .dtr-bs-modal .modal-body {\n    padding-left: 0;\n    padding-right: 0;\n    overflow-x: scroll;\n  }\n  .dtr-bs-modal .table.dtr-details {\n    margin: 0 auto 0.875rem;\n  }\n  .dtr-bs-modal .table.dtr-details td {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .dtr-bs-modal .table.dtr-details tr td:first-child {\n    padding-left: 0.65625rem;\n  }\n\n  div.dataTables_wrapper {\n    overflow: scroll;\n  }\n}\n/* Bootstrap Touchspin */\n.bootstrap-touchspin.input-group {\n  width: 7.35rem;\n  align-items: center;\n}\n.bootstrap-touchspin.input-group .form-control {\n  padding: 5px;\n  height: auto;\n  border: 0;\n  background-color: #f8f8f8;\n  border-radius: 0.3125rem !important;\n  text-align: center;\n  font-weight: 500;\n}\n.bootstrap-touchspin.input-group .form-control:focus {\n  z-index: 1;\n  box-shadow: none;\n}\n.bootstrap-touchspin .bootstrap-touchspin-injected {\n  margin: 0 !important;\n}\n.bootstrap-touchspin .bootstrap-touchspin-injected.input-group-prepend {\n  left: 12px;\n  position: relative;\n}\n.bootstrap-touchspin .bootstrap-touchspin-injected.input-group-append {\n  right: 12px;\n  position: relative;\n}\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up {\n  padding: 0;\n  min-width: 20px;\n  min-height: 20px;\n  border-radius: 0.3125rem !important;\n}\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down i,\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up i,\n.bootstrap-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {\n  height: 0.7rem;\n  width: 0.7rem;\n  font-size: 0.7rem;\n  position: relative;\n  top: -1px;\n}\n.bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-down,\n.bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-up {\n  background-color: rgba(30, 29, 43, 0.5) !important;\n  cursor: default;\n  opacity: 0.5;\n}\n.bootstrap-touchspin.input-group-lg {\n  width: 8.203125rem;\n}\n.bootstrap-touchspin.input-group-lg .touchspin.form-control {\n  height: auto !important;\n}\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down,\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up {\n  min-width: 24px;\n  min-height: 24px;\n}\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down i,\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-down svg,\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up i,\n.bootstrap-touchspin.input-group-lg .bootstrap-touchspin-up svg {\n  height: 0.875rem;\n  width: 0.875rem;\n  font-size: 0.875rem;\n  top: -3px;\n}\n.bootstrap-touchspin.input-group-sm {\n  width: 5.46875rem;\n}\n.bootstrap-touchspin.input-group-sm .touchspin.form-control {\n  height: auto !important;\n}\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down,\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up {\n  min-width: 16px;\n  min-height: 16px;\n}\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down i,\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-down svg,\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up i,\n.bootstrap-touchspin.input-group-sm .bootstrap-touchspin-injected .bootstrap-touchspin-up svg {\n  height: 0.525rem;\n  width: 0.525rem;\n  font-size: 0.525rem;\n}\n\n/* Number Type Input Box Scss for Touchspin - Remove arrow for firefox */\n.bootstrap-touchspin.input-group input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.dark-layout .bootstrap-touchspin.input-group .form-control {\n  background-color: #161d31;\n}\n.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-down,\n.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .bootstrap-touchspin-up,\n.dark-layout .bootstrap-touchspin.disabled-touchspin .bootstrap-touchspin-injected .disabled-max-min {\n  background-color: #b8c2cc !important;\n  opacity: 1;\n}\n.dark-layout .bootstrap-touchspin .bootstrap-touchspin-injected .disabled-max-min {\n  background-color: #b8c2cc !important;\n  opacity: 1;\n}\n\n.dark-layout {\n  /********* COMPONENTS *********/\n  /********** FORMS **********/\n  /********** TABLE **********/\n  /********** PAGES **********/\n  /********** APPLICATIONS **********/\n  /********** CUSTOMIZER **********/\n  /********** HORIZONTAL LAYOUT **********/\n}\nbody.dark-layout {\n  color: #b4b7bd;\n  background-color: #161d31;\n}\n\n.dark-layout body {\n  color: #b4b7bd;\n  background-color: #161d31;\n}\n.dark-layout h1,\n.dark-layout h2,\n.dark-layout h3,\n.dark-layout h4,\n.dark-layout h5,\n.dark-layout h6 {\n  color: #d0d2d6;\n}\n.dark-layout .border,\n.dark-layout .border-top,\n.dark-layout .border-right,\n.dark-layout .border-bottom,\n.dark-layout .border-left {\n  border-color: #3b4253 !important;\n}\n.dark-layout a:hover {\n  color: #00a0dd;\n}\n.dark-layout label {\n  color: #d0d2d6;\n}\n.dark-layout .btn span {\n  color: inherit;\n}\n.dark-layout hr {\n  border-color: #3b4253;\n}\n.dark-layout pre {\n  background-color: #161d31 !important;\n  border: 0;\n}\n.dark-layout pre code {\n  background-color: inherit;\n  text-shadow: none;\n}\n.dark-layout pre code .url {\n  background-color: #161d31;\n}\n.dark-layout code {\n  background-color: #161d31;\n}\n.dark-layout kbd {\n  background-color: #161d31;\n}\n.dark-layout .text-dark {\n  color: #b8c2cc !important;\n}\n.dark-layout .text-muted {\n  color: #676d7d !important;\n}\n.dark-layout .text-body {\n  color: #b4b7bd !important;\n}\n.dark-layout .text-body-heading {\n  color: #d0d2d6;\n}\n.dark-layout .section-label {\n  color: #676d7d;\n}\n.dark-layout .shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24) !important;\n}\n.dark-layout .blockquote-footer {\n  color: #676d7d;\n}\n.dark-layout .header-navbar-shadow {\n  background: linear-gradient(180deg, rgba(22, 29, 49, 0.9) 44%, rgba(22, 29, 49, 0.43) 73%, rgba(22, 29, 49, 0));\n}\n.dark-layout .horizontal-layout .header-navbar {\n  background-color: #283046;\n}\n.dark-layout .horizontal-layout.navbar-sticky .header-navbar, .dark-layout .horizontal-layout.navbar-static .header-navbar {\n  background-color: #161d31;\n}\n.dark-layout .navbar-sticky .header-navbar.navbar-shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75);\n}\n.dark-layout .header-navbar {\n  background-color: #283046;\n}\n.dark-layout .header-navbar.navbar-static-top {\n  background-color: transparent !important;\n}\n.dark-layout .blank-page .card.bg-transparent h1,\n.dark-layout .blank-page .card.bg-transparent h2,\n.dark-layout .blank-page .card.bg-transparent h3,\n.dark-layout .blank-page .card.bg-transparent h4,\n.dark-layout .blank-page .card.bg-transparent h5,\n.dark-layout .blank-page .card.bg-transparent h6 {\n  color: #283046;\n}\n.dark-layout .blank-page .card.bg-transparent p {\n  color: #161d31;\n}\n.dark-layout .ps__thumb-x,\n.dark-layout .ps__thumb-y {\n  background-color: #b4b7bd;\n}\n.dark-layout .ps .ps__rail-x.ps--clicking,\n.dark-layout .ps .ps__rail-x:focus,\n.dark-layout .ps .ps__rail-x:hover,\n.dark-layout .ps .ps__rail-y.ps--clicking,\n.dark-layout .ps .ps__rail-y:focus,\n.dark-layout .ps .ps__rail-y:hover {\n  background-color: #3b4253;\n}\n.dark-layout .ps__rail-y.ps--clicking .ps__thumb-y,\n.dark-layout .ps__rail-y:focus > .ps__thumb-y,\n.dark-layout .ps__rail-y:hover > .ps__thumb-y {\n  background-color: #b4b7bd;\n}\n.dark-layout .alert .alert-heading,\n.dark-layout .alert p {\n  color: inherit;\n}\n.dark-layout .alert .close {\n  text-shadow: none;\n}\n.dark-layout .alert.alert-dark .alert-heading,\n.dark-layout .alert.alert-dark .alert-body,\n.dark-layout .alert.alert-dark p {\n  color: #b8c2cc;\n}\n.dark-layout .alert.alert-dark.alert-dismissible .close {\n  color: #b8c2cc !important;\n}\n.dark-layout .content-header-left .breadcrumbs-top .content-header-title {\n  color: #d0d2d6;\n  border-color: #3b4253;\n}\n.dark-layout .breadcrumb-chevron.breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout [class*=collapse-] .card:not(:last-of-type) {\n  border-color: #3b4253;\n}\n.dark-layout .collapse-border .card {\n  border-color: #3b4253;\n}\n.dark-layout .collapse-shadow {\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);\n}\n.dark-layout .collapse-margin .card {\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24) !important;\n}\n.dark-layout .collapse-icon .card-header a {\n  color: #b4b7bd;\n}\n.dark-layout .collapse-icon [data-toggle=collapse]:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .collapse-icon [data-toggle=collapse]:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .btn:not([class*=btn-]) {\n  color: #b4b7bd;\n}\n.dark-layout .btn.btn-dark, .dark-layout .btn.btn-outline-dark, .dark-layout .btn.btn-flat-dark {\n  color: #b8c2cc;\n}\n.dark-layout .btn.btn-dark {\n  background-color: #232323 !important;\n}\n.dark-layout .btn.btn-outline-dark {\n  border-color: #232323;\n  color: #b8c2cc;\n}\n.dark-layout .btn.btn-outline-dark:hover:not(.disabled):not(:disabled) {\n  color: #b8c2cc;\n}\n.dark-layout .btn.btn-flat-dark:active, .dark-layout .btn.btn-flat-dark:focus {\n  background: #232323;\n}\n.dark-layout .btn-group-toggle label[class*=btn-outline-] {\n  color: #00a0dd !important;\n}\n.dark-layout .dropdown-menu {\n  background-color: #283046;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);\n}\n.dark-layout .dropdown-menu .dropdown-header {\n  color: #d0d2d6;\n}\n.dark-layout .dropdown-menu .dropdown-item {\n  color: #b4b7bd;\n}\n.dark-layout .dropdown-menu .dropdown-item:hover, .dark-layout .dropdown-menu .dropdown-item:focus {\n  background: rgba(0, 160, 221, 0.12);\n  color: #00a0dd;\n}\n.dark-layout .dropdown-menu .dropdown-item:active, .dark-layout .dropdown-menu .dropdown-item.active {\n  color: #fdfeff;\n  background-color: #00a0dd;\n}\n.dark-layout .dropdown-menu .dropdown-item.disabled, .dark-layout .dropdown-menu .dropdown-item:disabled {\n  color: #676d7d;\n}\n.dark-layout .dropdown-divider {\n  border-color: #3b4253;\n}\n.dark-layout .modal .modal-header,\n.dark-layout .modal .modal-header[class*=bg-] {\n  background-color: #161d31;\n}\n.dark-layout .modal .modal-header .close {\n  text-shadow: none;\n  background-color: #283046 !important;\n  color: #b4b7bd;\n  box-shadow: 0 3px 8px 0 rgba(11, 10, 25, 0.49) !important;\n}\n.dark-layout .modal .modal-content,\n.dark-layout .modal .modal-body,\n.dark-layout .modal .modal-footer {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item.active {\n  background-color: #242b3d;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link {\n  background-color: #00a0dd;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item.active .page-link:hover {\n  color: #fdfeff;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link {\n  background-color: #242b3d;\n  color: #b4b7bd;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item .page-link:hover {\n  color: #00a0dd;\n}\n.dark-layout .pagination:not([class*=pagination-]) .page-item.prev-item .page-link:hover, .dark-layout .pagination:not([class*=pagination-]) .page-item.next-item .page-link:hover {\n  color: #fdfeff;\n}\n.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link {\n  background-color: #242b3d;\n}\n.dark-layout .pagination[class*=pagination-] .page-item:not(.active):not(:hover) .page-link {\n  color: #fdfeff;\n}\n.dark-layout .pagination[class*=pagination-] .page-item:not(.active) .page-link:hover {\n  background-color: #242b3d;\n}\n.dark-layout .pagination[class*=pagination-] .page-item.active {\n  background-color: #242b3d;\n}\n.dark-layout .pagination .page-item.prev-item .page-link:before, .dark-layout .pagination .page-item.prev .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .pagination .page-item.prev-item.disabled .page-link:before, .dark-layout .pagination .page-item.prev.disabled .page-link:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .pagination .page-item.next-item .page-link::after, .dark-layout .pagination .page-item.next .page-link::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .pagination .page-item.next-item.disabled .page-link:after, .dark-layout .pagination .page-item.next.disabled .page-link:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .pagination .page-item.disabled .page-link {\n  color: #676d7d;\n}\n.dark-layout .nav.wrap-border {\n  border-color: #3b4253;\n}\n.dark-layout .media-bordered .media:not(:first-child) {\n  border-color: #3b4253;\n}\n.dark-layout .popover[x-placement=top] .arrow:before {\n  border-top-color: #3b4253;\n}\n.dark-layout .popover[x-placement=top] .arrow:after {\n  border-top-color: #283046;\n}\n.dark-layout .popover[x-placement=left] .arrow:before {\n  border-left-color: #3b4253;\n}\n.dark-layout .popover[x-placement=left] .arrow:after {\n  border-left-color: #283046;\n}\n.dark-layout .popover[x-placement=right] .arrow:before {\n  border-right-color: #3b4253;\n}\n.dark-layout .popover[x-placement=right] .arrow:after {\n  border-right-color: #283046;\n}\n.dark-layout .popover .popover-header {\n  color: #fdfeff;\n}\n.dark-layout .popover .popover-body {\n  background-color: #283046;\n  color: #b4b7bd;\n  border-color: #3b4253 !important;\n}\n.dark-layout .toast {\n  background-color: rgba(40, 48, 70, 0.85);\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n  color: #b4b7bd;\n}\n.dark-layout .toast .toast-header {\n  background-color: #283046;\n  color: #b4b7bd;\n}\n.dark-layout .toast .toast-header .close {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  text-shadow: none;\n}\n.dark-layout .list-group .list-group-item:not([class*=list-group-item-]), .dark-layout .list-group .list-group-item.list-group-item-action {\n  background-color: #283046;\n  border-color: #3b4253;\n  color: #b4b7bd;\n}\n.dark-layout .list-group .list-group-item:not([class*=list-group-item-]):hover, .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):focus, .dark-layout .list-group .list-group-item.list-group-item-action:hover, .dark-layout .list-group .list-group-item.list-group-item-action:focus {\n  background-color: #161d31;\n}\n.dark-layout .list-group .list-group-item:not([class*=list-group-item-]).active, .dark-layout .list-group .list-group-item:not([class*=list-group-item-]):active, .dark-layout .list-group .list-group-item.list-group-item-action.active, .dark-layout .list-group .list-group-item.list-group-item-action:active {\n  background-color: #00a0dd;\n  color: #fdfeff;\n}\n.dark-layout .list-group .list-group-item.active p,\n.dark-layout .list-group .list-group-item.active small {\n  color: #fdfeff;\n}\n.dark-layout .list-group .list-group-item.disabled {\n  color: #676d7d;\n}\n.dark-layout .list-group.list-group-circle .list-group-item:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E\");\n}\n.dark-layout .spinner-border {\n  border-color: currentColor !important;\n  border-right-color: transparent !important;\n}\n.dark-layout .avatar {\n  background-color: #161d31;\n}\n.dark-layout .avatar [class*=avatar-status-] {\n  border-color: #283046;\n}\n.dark-layout .avatar-group .avatar img,\n.dark-layout .avatar-group .avatar .avatar-content {\n  box-shadow: 0 0 0 2px #283046, inset 0 0 0 1px rgba(40, 48, 70, 0.07);\n}\n.dark-layout .divider .divider-text {\n  color: #b4b7bd;\n}\n.dark-layout .divider .divider-text::before, .dark-layout .divider .divider-text::after {\n  border-color: #3b4253;\n}\n.dark-layout .divider.divider-dark .divider-text::before, .dark-layout .divider.divider-dark .divider-text::after {\n  border-color: #3b4253 !important;\n}\n.dark-layout .timeline .timeline-item {\n  border-color: #3b4253;\n}\n.dark-layout .timeline .timeline-item .timeline-point:not(.timeline-point-indicator) {\n  background-color: #283046;\n}\n.dark-layout .timeline .timeline-item .timeline-event .timeline-event-time {\n  color: #676d7d;\n}\n.dark-layout .timeline .timeline-item:last-of-type:after {\n  background: linear-gradient(#3b4253, transparent);\n}\n.dark-layout .vertical-timeline-element-content {\n  background-color: #283046;\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n}\n.dark-layout .vertical-timeline-element-content-arrow {\n  border: #283046;\n}\n.dark-layout .vertical-timeline::before {\n  background-color: #3b4253;\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n}\n.dark-layout .card {\n  background-color: #283046;\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n}\n.dark-layout .card .card-footer {\n  border-color: #3b4253;\n}\n.dark-layout .card.overlay-img-card .card-img-overlay span,\n.dark-layout .card.overlay-img-card .card-img-overlay p,\n.dark-layout .card.overlay-img-card .card-img-overlay .card-body {\n  color: #fdfeff;\n}\n.dark-layout .card-developer-meetup .meetup-header .meetup-day {\n  border-right-color: #404656;\n}\n.dark-layout .card-profile .profile-image-wrapper .profile-image {\n  background-color: #161d31;\n}\n.dark-layout .business-card .business-items .business-item {\n  border-color: #3b4253;\n}\n.dark-layout .card-app-design .design-planning-wrapper .design-planning {\n  background-color: #161d31;\n}\n.dark-layout .card-tiny-line-stats .apexcharts-series-markers .apexcharts-marker {\n  stroke: #222d69;\n}\n.dark-layout .card-tiny-line-stats .apexcharts-series-markers:last-child .apexcharts-marker {\n  fill: #283046;\n}\n.dark-layout .card-revenue-budget .revenue-report-wrapper {\n  border-right-color: #3b4253;\n}\n.dark-layout .card-revenue-budget .budget-wrapper .apexcharts-series:not(:first-child) path {\n  stroke: #b4b7bd;\n}\n.dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-label {\n  fill: #b4b7bd !important;\n}\n.dark-layout .earnings-card .apexcharts-canvas .apexcharts-pie .apexcharts-datalabel-value {\n  fill: #d0d2d6;\n}\n.dark-layout .card-company-table .avatar {\n  background-color: #161d31;\n}\n.dark-layout input.form-control,\n.dark-layout .custom-file-label,\n.dark-layout textarea.form-control {\n  background-color: #283046;\n  color: #b4b7bd;\n}\n.dark-layout input.form-control:not(:focus),\n.dark-layout .custom-file-label:not(:focus),\n.dark-layout textarea.form-control:not(:focus) {\n  border-color: #404656;\n}\n.dark-layout input.form-control::placeholder,\n.dark-layout .custom-file-label::placeholder,\n.dark-layout textarea.form-control::placeholder {\n  color: #676d7d;\n}\n.dark-layout input.form-control:disabled, .dark-layout input.form-control[readonly=readonly],\n.dark-layout .custom-file-label:disabled,\n.dark-layout .custom-file-label[readonly=readonly],\n.dark-layout textarea.form-control:disabled,\n.dark-layout textarea.form-control[readonly=readonly] {\n  opacity: 0.5;\n}\n.dark-layout .char-textarea.active {\n  color: #b4b7bd !important;\n}\n.dark-layout .char-textarea.max-limit {\n  color: #de4827 !important;\n}\n.dark-layout .custom-file-label:after {\n  background-color: #161d31;\n  border-left: 1px solid #3b4253;\n  color: #b4b7bd;\n}\n.dark-layout .custom-control-input:not(:checked) ~ .custom-control-label:before {\n  background-color: #283046;\n  border-color: #404656;\n}\n.dark-layout .custom-control-input:disabled ~ .custom-control-label:before {\n  background-color: #444b60;\n  border-color: #444b60;\n}\n.dark-layout .custom-switch .custom-control-input:not(:checked) ~ .custom-control-label:before {\n  background-color: #545a6a;\n}\n.dark-layout .custom-switch .custom-control-input:disabled ~ .custom-control-label:before {\n  background-color: #1b2337;\n}\n.dark-layout select.form-control,\n.dark-layout .custom-select {\n  background-color: #283046;\n  color: #b4b7bd;\n  border-color: #3b4253;\n}\n.dark-layout select.form-control option:checked,\n.dark-layout .custom-select option:checked {\n  background-color: #283046;\n}\n.dark-layout select.form-control:disabled,\n.dark-layout .custom-select:disabled {\n  opacity: 0.5;\n}\n.dark-layout select.form-control:focus,\n.dark-layout .custom-select:focus {\n  border-color: #00a0dd;\n}\n.dark-layout select.form-control:not([multiple=multiple]) {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .was-validated .form-control:invalid,\n.dark-layout .form-control.is-invalid {\n  border-color: #de4827 !important;\n}\n.dark-layout .was-validated .form-control:valid,\n.dark-layout .form-control.is-valid {\n  border-color: #28c76f !important;\n}\n.dark-layout .wizard .steps ul .disabled a,\n.dark-layout .wizard .steps ul .done a {\n  color: #b4b7bd !important;\n}\n.dark-layout .wizard .steps ul .disabled a:hover,\n.dark-layout .wizard .steps ul .done a:hover {\n  color: #b4b7bd;\n}\n.dark-layout .wizard .steps ul .disabled a .step,\n.dark-layout .wizard .steps ul .done a .step {\n  background-color: #161d31 !important;\n  color: #fdfeff !important;\n}\n.dark-layout .input-group .input-group-text {\n  background-color: #283046;\n  border-color: #3b4253;\n  color: #b4b7bd;\n}\n.dark-layout .input-group:focus-within .form-control,\n.dark-layout .input-group:focus-within .input-group-text {\n  border-color: #00a0dd;\n  box-shadow: none;\n}\n.dark-layout .form-label-group > input:not(:focus):not(:placeholder-shown) ~ label, .dark-layout .form-label-group > textarea:not(:focus):not(:placeholder-shown) ~ label {\n  color: #b4b7bd !important;\n}\n.dark-layout .counter-value {\n  color: white;\n}\n.dark-layout .table {\n  background-color: #283046;\n}\n.dark-layout .table td,\n.dark-layout .table th {\n  border-color: #3b4253 !important;\n}\n.dark-layout .table .thead tr:not([class*=stock-styled]) th,\n.dark-layout .table .thead tr:not([class*=stock-styled]) td,\n.dark-layout .table tbody tr:not([class*=stock-styled]) th,\n.dark-layout .table tbody tr:not([class*=stock-styled]) td {\n  border-color: #3b4253;\n  color: #b4b7bd;\n}\n.dark-layout .table .thead tr:not([class*=stock-styled]) th code,\n.dark-layout .table .thead tr:not([class*=stock-styled]) td code,\n.dark-layout .table tbody tr:not([class*=stock-styled]) th code,\n.dark-layout .table tbody tr:not([class*=stock-styled]) td code {\n  background-color: #283046;\n}\n.dark-layout .table thead tr th,\n.dark-layout .table tfoot tr th {\n  border-color: #3b4253;\n  background-color: #343d55;\n  color: #d0d2d6;\n}\n.dark-layout .table thead.thead-dark th,\n.dark-layout .table tfoot.thead-dark th {\n  background-color: #fdfeff;\n  color: #232323 !important;\n}\n.dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th, .dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {\n  background-color: #343d55;\n}\n.dark-layout .table.table-dark {\n  background-color: #fdfeff;\n}\n.dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(35, 35, 35, 0.05);\n}\n.dark-layout .table.table-dark.table-striped tbody tr:nth-of-type(odd) td {\n  background-color: inherit;\n}\n.dark-layout .table.table-dark td,\n.dark-layout .table.table-dark th {\n  border-color: #f8f9fa !important;\n  color: #232323 !important;\n  background-color: #fdfeff;\n}\n.dark-layout .table.table-dark td .text-white,\n.dark-layout .table.table-dark th .text-white {\n  color: #232323 !important;\n}\n.dark-layout .table tbody tr[class*=table-] td,\n.dark-layout .table tbody tr[class*=table-] th {\n  background-color: unset;\n}\n.dark-layout .table tbody tr.table-dark td,\n.dark-layout .table tbody tr.table-dark th {\n  color: #fdfeff;\n}\n.dark-layout .table.table-bordered {\n  border-color: #3b4253;\n}\n.dark-layout .table.table-hover tbody tr:hover {\n  background-color: #242b3d;\n}\n.dark-layout .table.table-hover tbody tr th,\n.dark-layout .table.table-hover tbody tr td {\n  background-color: unset;\n}\n.dark-layout .table.table-hover-animation tbody tr {\n  background-color: #283046;\n}\n.dark-layout .table.table-hover-animation tbody tr:hover {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n}\n.dark-layout .table.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #242b3d;\n}\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-copy,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-excel,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-print,\n.dark-layout .dataTables_wrapper .dt-buttons .btn-secondary,\n.dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-] {\n  background-color: #161d31 !important;\n}\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-copy:active,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-excel:active,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-pdf:active,\n.dark-layout .dataTables_wrapper .dt-buttons .buttons-print:active,\n.dark-layout .dataTables_wrapper .dt-buttons .btn-secondary:active,\n.dark-layout .dataTables_wrapper .dt-buttons [class*=buttons-]:active {\n  background-color: #00a0dd !important;\n  color: #fdfeff;\n}\n.dark-layout .dataTables_wrapper .dt-button-collection > div[role=menu] {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.24);\n}\n.dark-layout .dataTables_wrapper .table.dataTable tr.group td {\n  background-color: #242b3d;\n  color: #d0d2d6;\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before,\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before,\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after,\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after,\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23b4b7bd' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting:before, .dark-layout .dataTables_wrapper .table.dataTable thead .sorting:after {\n  opacity: 0.5;\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:before {\n  opacity: 1;\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_asc:after {\n  opacity: 0.5;\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:after {\n  opacity: 1;\n}\n.dark-layout .dataTables_wrapper .table.dataTable thead .sorting_desc:before {\n  opacity: 0.5;\n}\n.dark-layout .ag-grid-btns .filter-btn {\n  background-color: transparent !important;\n}\n.dark-layout .aggrid .ag-input-wrapper input {\n  color: #b4b7bd;\n}\n.dark-layout .aggrid,\n.dark-layout .ag-header {\n  background-color: #283046;\n  color: #b4b7bd;\n  border-color: #3b4253;\n}\n.dark-layout .aggrid .ag-row-hover,\n.dark-layout .aggrid .ag-row-selected,\n.dark-layout .ag-header .ag-row-hover,\n.dark-layout .ag-header .ag-row-selected {\n  background-color: #242b3d !important;\n}\n.dark-layout .aggrid .ag-icon,\n.dark-layout .ag-header .ag-icon {\n  color: #404656;\n}\n.dark-layout .aggrid .ag-header-cell.ag-column-hover,\n.dark-layout .ag-header .ag-header-cell.ag-column-hover {\n  background: transparent !important;\n}\n.dark-layout .aggrid .ag-header-cell,\n.dark-layout .aggrid .ag-cell,\n.dark-layout .aggrid .ag-row,\n.dark-layout .aggrid .ag-pinned-left-header,\n.dark-layout .aggrid .ag-pinned-left-cols-container,\n.dark-layout .aggrid .ag-horizontal-left-spacer,\n.dark-layout .aggrid .ag-paging-panel,\n.dark-layout .aggrid .ag-floating-filter-input,\n.dark-layout .ag-header .ag-header-cell,\n.dark-layout .ag-header .ag-cell,\n.dark-layout .ag-header .ag-row,\n.dark-layout .ag-header .ag-pinned-left-header,\n.dark-layout .ag-header .ag-pinned-left-cols-container,\n.dark-layout .ag-header .ag-horizontal-left-spacer,\n.dark-layout .ag-header .ag-paging-panel,\n.dark-layout .ag-header .ag-floating-filter-input {\n  border-color: #3b4253 !important;\n  color: #b4b7bd;\n}\n.dark-layout .aggrid .ag-cell.ag-cell-inline-editing,\n.dark-layout .ag-header .ag-cell.ag-cell-inline-editing {\n  border-color: #3b4253;\n  background: #161d31;\n  height: auto;\n  padding-top: 0;\n}\n.dark-layout .aggrid .ag-paging-panel .ag-paging-button,\n.dark-layout .ag-header .ag-paging-panel .ag-paging-button {\n  background-color: #161d31;\n}\n.dark-layout .aggrid .ag-paging-panel .ag-disabled,\n.dark-layout .ag-header .ag-paging-panel .ag-disabled {\n  background: #283046;\n}\n.dark-layout .aggrid .ag-paging-panel span[ref=lbTotal],\n.dark-layout .ag-header .ag-paging-panel span[ref=lbTotal] {\n  background-color: #242b3d;\n  color: #b4b7bd !important;\n}\n.dark-layout .aggrid ::-webkit-scrollbar-track,\n.dark-layout .ag-header ::-webkit-scrollbar-track {\n  background: #161d31;\n}\n.dark-layout .aggrid ::-webkit-scrollbar-thumb,\n.dark-layout .ag-header ::-webkit-scrollbar-thumb {\n  background: #00a0dd;\n}\n.dark-layout .getting-started .clockCard p {\n  color: #b4b7bd !important;\n}\n.dark-layout #user-profile .profile-header .navbar {\n  background-color: #283046;\n}\n.dark-layout #user-profile .profile-header .navbar .navbar-toggler {\n  color: #b4b7bd;\n  border-color: #3b4253;\n}\n.dark-layout .search-bar .form-control {\n  background-color: #283046;\n}\n.dark-layout .blog-edit-wrapper .border {\n  border-color: #3b4253 !important;\n}\n.dark-layout .kb-search-content-info .kb-search-content .card-img-top {\n  background-color: #3f4860;\n}\n.dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):hover, .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):focus, .dark-layout .list-group-circle .list-group-item:not([class*=list-group-item-]):active,\n.dark-layout .list-group-circle .list-group-item-action:hover,\n.dark-layout .list-group-circle .list-group-item-action:focus,\n.dark-layout .list-group-circle .list-group-item-action:active {\n  background-color: transparent !important;\n}\n.dark-layout .content-area-wrapper {\n  border-color: #3b4253 !important;\n}\n.dark-layout .content-area-wrapper .sidebar .sidebar-content {\n  background-color: #283046 !important;\n}\n.dark-layout .content-area-wrapper .app-fixed-search {\n  background-color: #283046 !important;\n  border-color: #3b4253 !important;\n}\n.dark-layout .content-area-wrapper .content-right {\n  border-color: #3b4253 !important;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .app-action {\n  border-color: #3b4253;\n  background-color: #283046;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .app-action .action-right .list-inline-item .dropdown-toggle {\n  color: #b4b7bd;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media {\n  border-color: #3b4253;\n  background-color: #283046;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media:hover {\n  box-shadow: 0 3px 10px 0 #283046;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media.selected-row-bg {\n  background-color: rgba(0, 160, 221, 0.06);\n  border-color: #3b4253;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details p,\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .user-details .mail-date,\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message p,\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .media .mail-message .mail-date {\n  color: #676d7d;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-list .email-user-list .mail-read {\n  background-color: #242b3d;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details {\n  border-color: #3b4253;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-scroll-area {\n  background-color: #161d31;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .dropdown-toggle,\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-header .email-header-right .list-inline-item .action-icon {\n  color: #b4b7bd;\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-info-dropup .dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n.dark-layout .email-application .content-area-wrapper .email-app-details .mail-message-wrapper,\n.dark-layout .email-application .content-area-wrapper .email-app-details .email-detail-head {\n  border-color: #3b4253 !important;\n}\n.dark-layout .email-application .content-area-wrapper #compose-mail .compose-mail-form-field,\n.dark-layout .email-application .content-area-wrapper #compose-mail .ql-toolbar,\n.dark-layout .email-application .content-area-wrapper #compose-mail .ql-container {\n  border-color: #3b4253;\n}\n.dark-layout .email-application .content-area-wrapper #compose-mail label {\n  color: #b4b7bd;\n}\n.dark-layout .email-application .content-area-wrapper #compose-mail .modal-body {\n  border-bottom-left-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n.dark-layout .file-manager-application .sidebar-file-manager {\n  background-color: #283046 !important;\n}\n.dark-layout .file-manager-application .sidebar-file-manager .jstree .jstree-container-ul .jstree-anchor {\n  color: #b4b7bd;\n}\n.dark-layout .file-manager-application .sidebar-file-manager .storage-status i,\n.dark-layout .file-manager-application .sidebar-file-manager .storage-status svg {\n  color: #b4b7bd !important;\n}\n.dark-layout .file-manager-application .sidebar-file-manager .file-manager-title {\n  color: #d0d2d6;\n}\n.dark-layout .file-manager-application .sidebar-file-manager.show {\n  border: 1px solid #3b4253 !important;\n}\n.dark-layout .file-manager-application .content-area-wrapper {\n  border: 1px solid #3b4253 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content {\n  border: 1px solid #3b4253 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar {\n  background-color: transparent !important;\n  border-bottom: 1px solid #3b4253 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-app-searchbar .file-manager-toggler {\n  color: #b4b7bd !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header,\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body {\n  background-color: #283046 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-header {\n  border-color: #3b4253 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .drives .card {\n  background-color: #283046;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item .file-logo-wrapper {\n  background-color: #161d31 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container .file-manager-item:not(.selected) {\n  border-color: #3b4253 !important;\n}\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-size,\n.dark-layout .file-manager-application .file-manager-main-content .file-manager-content-body .view-container:not(.list-view) .file-manager-item .file-accessed {\n  color: #676d7d !important;\n}\n.dark-layout .file-manager-application #app-file-manager-info-sidebar .tab-content .tab-pane {\n  background-color: transparent;\n}\n.dark-layout .app-calendar .app-calendar-sidebar {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .app-calendar-sidebar .sidebar-content-title {\n  color: #d0d2d6;\n}\n.dark-layout .app-calendar .app-calendar-sidebar .select-all ~ label,\n.dark-layout .app-calendar .app-calendar-sidebar .input-filter ~ label {\n  color: #d0d2d6;\n}\n.dark-layout .app-calendar .fc .fc-day-today {\n  background: #161d31 !important;\n  background-color: #161d31 !important;\n}\n.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,\n.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis,\n.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-daygrid-day {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today {\n  background-color: rgba(186, 191, 199, 0.12) !important;\n}\n.dark-layout .app-calendar .fc .fc-timegrid .fc-scrollgrid-section .fc-day-today.fc-col-header-cell {\n  background-color: #283046 !important;\n}\n.dark-layout .app-calendar .fc .fc-popover {\n  background: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .fc .fc-popover-header .fc-popover-title,\n.dark-layout .app-calendar .fc .fc-popover-header .fc-popover-close {\n  color: #b4b7bd;\n}\n.dark-layout .app-calendar .fc tbody td,\n.dark-layout .app-calendar .fc thead th {\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .fc .fc-scrollgrid {\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .fc .fc-list,\n.dark-layout .app-calendar .fc th {\n  border-color: #3b4253;\n}\n.dark-layout .app-calendar .fc .fc-list .fc-list-day-cushion,\n.dark-layout .app-calendar .fc th .fc-list-day-cushion {\n  background: #161d31;\n}\n.dark-layout .app-calendar .fc .fc-list .fc-list-event:hover td,\n.dark-layout .app-calendar .fc th .fc-list-event:hover td {\n  background-color: #161d31;\n}\n.dark-layout .app-calendar .fc .fc-list .fc-list-event-time,\n.dark-layout .app-calendar .fc th .fc-list-event-time {\n  color: #b4b7bd;\n}\n.dark-layout .app-calendar .fc .fc-list .fc-list-event td,\n.dark-layout .app-calendar .fc th .fc-list-event td {\n  border-color: #3b4253;\n}\n.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-list-dataTable-header {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table {\n  background-color: #283046;\n}\n.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table tbody .selected-row-bg {\n  background-color: #3b4253;\n}\n.dark-layout .invoice-list-wrapper .dataTables_wrapper .invoice-data-table td {\n  background-color: inherit;\n}\n.dark-layout .invoice-edit .invoice-preview-card .invoice-product-details,\n.dark-layout .invoice-add .invoice-preview-card .invoice-product-details {\n  background-color: #161d31;\n}\n.dark-layout .invoice-edit .invoice-preview-card .invoice-product-details .product-details-border,\n.dark-layout .invoice-add .invoice-preview-card .invoice-product-details .product-details-border {\n  background-color: #283046;\n  border-color: #3b4253;\n}\n.dark-layout .invoice-print .form-control {\n  background-color: #283046;\n}\n.dark-layout .app-user-view .plan-card {\n  border-color: #00a0dd !important;\n}\n.dark-layout .app-user-edit .form-control.error {\n  border-color: #de4827 !important;\n}\n.dark-layout .customizer {\n  background-color: #283046;\n}\n.dark-layout .customizer .customizer-close i,\n.dark-layout .customizer .customizer-close svg {\n  color: #b4b7bd;\n}\n.dark-layout .footer-fixed .footer {\n  background-color: #283046;\n}\n.dark-layout .horizontal-layout.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75) !important;\n}\n.dark-layout .horizontal-layout .horizontal-menu-wrapper {\n  background: linear-gradient(to bottom, rgba(37, 43, 71, 0.76) 44%, rgba(56, 53, 53, 0.46) 73%, rgba(253, 254, 255, 0) 100%) !important;\n}\n.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar {\n  background: #283046 !important;\n}\n.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-shadow {\n  box-shadow: 0 4px 24px 0 rgba(30, 29, 43, 0.75);\n}\n.dark-layout .horizontal-layout .horizontal-menu-wrapper .header-navbar.navbar-horizontal ul#main-menu-navigation > li:hover:not(.active) > a {\n  background: #161d31;\n}\n\n.bordered-layout .header-navbar {\n  box-shadow: none;\n}\n.bordered-layout .header-navbar.floating-nav {\n  border: 1px solid #ebe9f1;\n}\n.bordered-layout .header-navbar.fixed-top {\n  border-bottom: 1px solid #ebe9f1;\n  background: #f8f8f8;\n}\n.bordered-layout .dropdown-menu {\n  border: 1px solid #ebe9f1 !important;\n  box-shadow: none;\n}\n.bordered-layout .card,\n.bordered-layout .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps),\n.bordered-layout .bs-stepper.wizard-modern .bs-stepper-content {\n  border: 1px solid #ebe9f1;\n  box-shadow: none;\n}\n.bordered-layout .footer {\n  box-shadow: none !important;\n}\n.bordered-layout .footer-fixed .footer {\n  border-top: 1px solid #ebe9f1;\n}\n\n.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.header-navbar .dropdown .dropdown-menu.dropdown-menu-right::before,\n.header-navbar .dropup .dropdown-menu.dropdown-menu-right::before {\n  right: auto;\n  left: 0.4375rem;\n}\n\n.dropdown .dropdown-menu,\n.dropup .dropdown-menu,\n.btn-group .dropdown-menu {\n  right: auto !important;\n  top: 0 !important;\n  left: auto !important;\n}\n.dropdown .dropdown-menu.dropdown-menu-right,\n.dropup .dropdown-menu.dropdown-menu-right,\n.btn-group .dropdown-menu.dropdown-menu-right {\n  left: 0 !important;\n}\n.dropdown .dropdown-menu.dropdown-menu-right::before,\n.dropup .dropdown-menu.dropdown-menu-right::before,\n.btn-group .dropdown-menu.dropdown-menu-right::before {\n  right: 0.525rem;\n  left: auto;\n}\n\n.dropleft .dropdown-toggle::before {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.dropleft .dropdown-menu {\n  left: 0 !important;\n  margin-left: 0;\n  margin-right: 0.4375rem;\n}\n\n.dropright .dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fdfeff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n.dropright .dropdown-menu {\n  left: 0 !important;\n  margin-right: 0;\n  margin-left: 0.4375rem;\n}\n\n.input-group .dropdown-menu.show {\n  top: 0 !important;\n  right: auto !important;\n  left: 0px !important;\n}\n\n.toast {\n  right: 0.875rem;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  left: 1px;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  float: right;\n}\n\n.select2-search__field {\n  direction: rtl;\n}\n\n.chartjs-render-monitor {\n  margin-right: 0.875rem;\n}\n\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: left !important;\n}\n\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before {\n  right: 0.39375rem;\n}\n\n.avatar-group .avatar {\n  margin-right: -0.686875rem;\n  margin-left: 0;\n}\n.avatar-group .avatar-sm {\n  margin-right: -0.56875rem;\n}\n.avatar-group .avatar-lg {\n  margin-right: -1.3125rem;\n}\n.avatar-group .avatar-xl {\n  margin-right: -1.61875rem;\n}\n\n.breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before,\n.breadcrumb.breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {\n  transform: rotate(180deg);\n}\n\n.pagination .page-item.prev-item .page-link:before, .pagination .page-item.prev .page-link:before, .pagination .page-item.previous .page-link:before {\n  transform: rotate(180deg);\n}\n.pagination .page-item.prev-item .page-link:hover:before, .pagination .page-item.prev-item .page-link:active:before, .pagination .page-item.prev .page-link:hover:before, .pagination .page-item.prev .page-link:active:before, .pagination .page-item.previous .page-link:hover:before, .pagination .page-item.previous .page-link:active:before {\n  transform: rotate(180deg);\n}\n.pagination .page-item.prev-item.disabled .page-link:before, .pagination .page-item.prev.disabled .page-link:before, .pagination .page-item.previous.disabled .page-link:before {\n  transform: rotate(180deg);\n}\n.pagination .page-item.next-item .page-link:after, .pagination .page-item.next .page-link:after {\n  transform: rotate(180deg);\n}\n.pagination .page-item.next-item .page-link:hover:after, .pagination .page-item.next-item .page-link:active:after, .pagination .page-item.next .page-link:hover:after, .pagination .page-item.next .page-link:active:after {\n  transform: rotate(180deg);\n}\n.pagination .page-item.next-item.disabled .page-link:before, .pagination .page-item.next.disabled .page-link:before {\n  transform: rotate(180deg);\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  direction: ltr;\n}\n\n@media print {\n  code[class*=language-],\npre[class*=language-] {\n    text-shadow: none;\n  }\n}\n.fc .fc-header-toolbar .fc-right .fc-button.fc-prev-button .fc-icon {\n  right: 4px !important;\n}\n\n.fc .fc-header-toolbar .fc-right .fc-button.fc-next-button .fc-icon {\n  left: -3px !important;\n}\n\n.carousel-control-next {\n  left: auto;\n  right: 0;\n}\n\n.carousel-control-prev {\n  left: 0;\n  right: auto;\n}\n\n.bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^=left] .arrow::before {\n  border-width: 0.35rem 0 0.35rem 0.35rem;\n  border-left-color: #323232;\n}\n\n.bs-tooltip-left .arrow,\n.bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  left: auto;\n}\n\n.bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^=right] .arrow::before {\n  border-width: 0.35rem 0.35rem 0.35rem 0;\n  border-right-color: #323232;\n}\n\n.bs-tooltip-right .arrow,\n.bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  right: auto;\n}\n\n.popover {\n  right: auto !important;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 40s linear infinite;\n}\n\nbody .ps__rail-y {\n  right: auto !important;\n  left: 1px !important;\n}\n\n.faq-navigation img,\n.pricing-free-trial .pricing-trial-img {\n  transform: scaleX(-1);\n}\n\n.feather-chevron-left,\n.feather-chevron-right {\n  transform: rotate(-180deg) !important;\n}\n\n.kanban-application .kanban-container .kanban-item i,\n.kanban-application .kanban-container .kanban-item svg {\n  margin-right: 0 !important;\n  margin-left: 0.21875rem;\n}\n\n.invoice-list-wrapper .dataTables_filter input {\n  margin-left: 0 !important;\n  margin-right: 0.4375rem;\n}\n.invoice-list-wrapper .dropdown .dropdown-menu.dropdown-menu-right {\n  left: 1.75rem !important;\n}\n\n.file-manager-application .sidebar-file-manager .sidebar-inner .my-drive .jstree-node.jstree-closed > .jstree-icon {\n  transform: rotate(180deg);\n}\n\nbody,\n#root,\n.wrapper {\n  height: 100%;\n}\n\nbody #root .wrapper .ps__rail-y {\n  left: auto !important;\n  right: 1px !important;\n}\n\n.horizontal-layout.navbar-static .navbar-scrolled {\n  background: #fdfeff !important;\n  box-shadow: rgba(30, 29, 43, 0.05) 0px 4px 20px 0px !important;\n}\n.horizontal-layout .header-navbar .navbar-container .dropdown-language .dropdown-menu,\n.horizontal-layout .header-navbar .navbar-container .dropdown-cart .dropdown-menu,\n.horizontal-layout .header-navbar .navbar-container .dropdown-notification .dropdown-menu,\n.horizontal-layout .header-navbar .navbar-container .dropdown-user .dropdown-menu {\n  top: 2.625rem !important;\n}\n.horizontal-layout .horizontal-menu-wrapper #main-menu-navigation .dropdown .dropdown-submenu .dropdown-toggle:after {\n  margin-top: -5px;\n}\n.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {\n  background: #adb5bd;\n  border-radius: 20px;\n}\n.horizontal-layout .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {\n  background: #dae1e7;\n  border-radius: 30px;\n}\n\n.card-snippet pre {\n  margin-top: 0;\n  border-radius: 0.4375rem;\n}\n\n.card-congratulations .avatar svg {\n  height: 28px !important;\n  width: 28px !important;\n}\n\n.avg-session-progress {\n  height: 6px;\n}\n\n.block-ui-container .block-ui-overlay {\n  background: rgba(30, 29, 43, 0.6);\n}\n\n.animate__animated.animate__zoomIn,\n.animate__animated.animate__fadeInLeft {\n  --animate-duration: 1s;\n}\n\n.ecommerce-application .content-wrapper.animate__animated {\n  animation: none;\n}\n\n.customizer .react-select {\n  width: 100%;\n  max-width: 200px;\n}\n.customizer .react-select .select__menu {\n  z-index: 2;\n}\n\n.dark-layout .autocomplete-container .suggestions-list .suggestion-item.suggestion-title-wrapper h6 {\n  color: #676d7d;\n}\n.dark-layout .ecommerce-application .list-view .ecommerce-card .card-body {\n  border-right-color: #3b4253;\n}\n.dark-layout .pagination .break {\n  background-color: #242b3d;\n}\n.dark-layout .pagination .break a {\n  color: #b4b7bd;\n}\n.dark-layout .invoice-list-wrapper header {\n  background-color: #283046;\n}\n.dark-layout .block-ui-container .block-ui-overlay {\n  background: #161d31;\n}\n.dark-layout .block-ui-container .block-ui-message {\n  color: #b4b7bd;\n}\n.dark-layout .form-control {\n  background-color: transparent;\n}\n.dark-layout .apexcharts-gridlines-vertical line {\n  stroke: #3b4253;\n}\n.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-thumb {\n  background: #161d31;\n}\n.dark-layout .horizontal-menu .horizontal-menu-wrapper .navbar-horizontal ul.dropdown-menu::-webkit-scrollbar-track {\n  background: #3b4253;\n}\n\nhtml[dir=rtl] body .ps__rail-y {\n  right: auto !important;\n  left: 1px !important;\n}\nhtml[dir=rtl] .scroll-to-top div:first-of-type {\n  left: auto !important;\n  right: 30px;\n}\nhtml[dir=rtl] .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\n}\nhtml[dir=rtl] .breadcrumb:not([class*=breadcrumb-]) .breadcrumb-item + .breadcrumb-item:before,\nhtml[dir=rtl] .breadcrumb.breadcrumb-chevron .breadcrumb-item + .breadcrumb-item:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.prev-item .page-link:before, html[dir=rtl] .pagination .page-item.prev .page-link:before, html[dir=rtl] .pagination .page-item.previous .page-link:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.prev-item .page-link:hover:before, html[dir=rtl] .pagination .page-item.prev-item .page-link:active:before, html[dir=rtl] .pagination .page-item.prev .page-link:hover:before, html[dir=rtl] .pagination .page-item.prev .page-link:active:before, html[dir=rtl] .pagination .page-item.previous .page-link:hover:before, html[dir=rtl] .pagination .page-item.previous .page-link:active:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.prev-item.disabled .page-link:before, html[dir=rtl] .pagination .page-item.prev.disabled .page-link:before, html[dir=rtl] .pagination .page-item.previous.disabled .page-link:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.next-item .page-link:after, html[dir=rtl] .pagination .page-item.next .page-link:after {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.next-item .page-link:hover:after, html[dir=rtl] .pagination .page-item.next-item .page-link:active:after, html[dir=rtl] .pagination .page-item.next .page-link:hover:after, html[dir=rtl] .pagination .page-item.next .page-link:active:after {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item.next-item.disabled .page-link:before, html[dir=rtl] .pagination .page-item.next.disabled .page-link:before {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .pagination .page-item:first-of-type .page-link svg, html[dir=rtl] .pagination .page-item:last-of-type .page-link svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .popover {\n  left: auto !important;\n}\nhtml[dir=rtl] .progress-bar-animated {\n  animation: progress-bar-stripes 40s linear infinite;\n}\nhtml[dir=rtl] .bs-tooltip-left .arrow::before,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  border-width: 0.35rem 0 0.35rem 0.35rem;\n  border-right-color: #323232;\n}\nhtml[dir=rtl] .bs-tooltip-left .arrow,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=left] .arrow {\n  left: 0;\n  right: auto;\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .bs-tooltip-right .arrow::before,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  border-width: 0.35rem 0.35rem 0.35rem 0;\n  border-left-color: #323232;\n}\nhtml[dir=rtl] .bs-tooltip-right .arrow,\nhtml[dir=rtl] .bs-tooltip-auto[x-placement^=right] .arrow {\n  right: 0;\n  left: auto;\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .email-application .toggle-cc.mr-1 {\n  margin-right: 0 !important;\n  margin-left: 0.875rem !important;\n}\nhtml[dir=rtl] .app-calendar .fc-toolbar .fc-prev-button,\nhtml[dir=rtl] .app-calendar .fc-toolbar .fc-next-button {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .app-ecommerce-details .swiper-button-next {\n  right: 0;\n  left: auto;\n}\nhtml[dir=rtl] .invoice-list-table-header select {\n  background-position: calc(100% - (100% - 45px)) 13px, calc(100% - (100% - 20px)) 13px, 0% 0 !important;\n}\nhtml[dir=rtl] .tox-tinymce .tox-editor-header {\n  direction: ltr;\n}\nhtml[dir=rtl] .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-marker {\n  margin-right: 10px;\n  margin-left: 0 !important;\n}\nhtml[dir=rtl] .react-contexify {\n  z-index: 1031;\n}\nhtml[dir=rtl] .swiper-button-next {\n  right: 10px !important;\n  left: auto !important;\n}\nhtml[dir=rtl] .swiper-button-prev {\n  left: 10px !important;\n  right: auto !important;\n}\nhtml[dir=rtl] .bs-stepper:not(.vertical) .bs-stepper-header .line svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .bs-stepper .btn-next svg,\nhtml[dir=rtl] .bs-stepper .btn-prev svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] .rdt_Table [aria-label=\"Expand Row\"] svg {\n  transform: rotate(180deg);\n}\nhtml[dir=rtl] #profile-info .post .post-actions .share-post span.mr-1 {\n  margin-right: 0 !important;\n}\n\n.form-control[readonly] {\n  opacity: 0.5;\n}\n\nselect.form-control[multiple] {\n  background-image: none !important;\n}\n\n.input-group .form-control.is-invalid ~ .input-group-append .input-group-text {\n  border-color: #de4827;\n}\n.input-group.is-invalid .form-control,\n.input-group.is-invalid .input-group-append .input-group-text,\n.input-group.is-invalid .input-group-prepend .input-group-text {\n  border-color: #de4827 !important;\n}\n\n.dark-layout .card .toast {\n  background-color: rgba(22, 29, 49, 0.85);\n}\n.dark-layout .card .toast .toast-header {\n  background-color: #161d31;\n}\n.dark-layout .card .toast .toast-header .close {\n  color: #b4b7bd;\n}\n\n[dir] .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #00a0dd;\n  background-color: #00a0dd;\n}\n\n.dropdown-notification .dropdown-menu,\n.dropdown-cart .dropdown-menu {\n  left: inherit !important;\n}\n\n.dropdown-language .country-flag {\n  height: 18px !important;\n  width: 18px !important;\n}\n.dropdown-language .dropdown-menu {\n  left: auto !important;\n}\n\n.dropdown-user .dropdown-menu {\n  left: auto !important;\n  right: 0;\n}\n\n.dropdown-menu .dropdown-item:focus {\n  outline: 0;\n}\n\n.dropdown-icon-wrapper .dropdown-toggle:after {\n  display: none;\n}\n.dropdown-icon-wrapper .dropdown-menu {\n  min-width: auto;\n}\n.dropdown-icon-wrapper .dropdown-menu .dropdown-item {\n  padding: 0.4375rem 0.9625rem;\n  cursor: pointer;\n}\n\n.app-collapse.card .card-header {\n  padding: 0.875rem;\n}\n.app-collapse.card svg {\n  transition: all 300ms linear 0s;\n}\n.app-collapse.card .card-header:not(.collapsed) svg {\n  transform: rotate(180deg);\n}\n.app-collapse .collapse-title {\n  max-width: calc(100% - 25px);\n}\n\nhtml[dir=rtl] .carousel .carousel-control-next-icon,\nhtml[dir=rtl] .carousel .carousel-control-prev-icon {\n  transform: rotate(180deg);\n}\n\n.pagination.react-paginate .page-item.prev a.page-link:before,\n.pagination.react-paginate .page-item.prev a.page-link:after,\n.pagination.react-paginate .page-item.next a.page-link:before,\n.pagination.react-paginate .page-item.next a.page-link:after {\n  height: 16.5px;\n  margin-top: 1px;\n}\n.pagination.react-paginate.pagination-sm .page-item.prev a.page-link:before,\n.pagination.react-paginate.pagination-sm .page-item.prev a.page-link:after,\n.pagination.react-paginate.pagination-sm .page-item.next a.page-link:before,\n.pagination.react-paginate.pagination-sm .page-item.next a.page-link:after {\n  height: 15px;\n}\n.pagination.react-paginate.pagination-lg .page-item.prev a.page-link:before,\n.pagination.react-paginate.pagination-lg .page-item.prev a.page-link:after,\n.pagination.react-paginate.pagination-lg .page-item.next a.page-link:before,\n.pagination.react-paginate.pagination-lg .page-item.next a.page-link:after {\n  height: 19px;\n}\n.pagination.no-navigation li:first-of-type,\n.pagination.no-navigation li:last-of-type {\n  display: none;\n}\n\n.loading {\n  position: absolute;\n  left: calc(50% - 35px);\n  top: 50%;\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 3px solid transparent;\n}\n.loading.component-loader {\n  margin-top: -60px;\n}\n.loading .effect-1,\n.loading .effect-2 {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border: 3px solid transparent;\n  border-left: 3px solid #7961f9;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.loading .effect-1 {\n  animation: rotate 1s ease infinite;\n}\n.loading .effect-2 {\n  animation: rotateOpacity 1s ease infinite 0.1s;\n}\n.loading .effect-3 {\n  width: 100%;\n  height: 100%;\n  border: 3px solid transparent;\n  border-left: 3px solid #7961f9;\n  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\n  animation: rotateOpacity 1s ease infinite 0.2s;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.loading .loading .effects {\n  transition: all 0.3s ease;\n}\n\n.fallback-logo {\n  position: absolute;\n  left: calc(50% - 28px);\n  width: 45px;\n  height: auto;\n}\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes rotateOpacity {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    opacity: 0.1;\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n    opacity: 1;\n  }\n}\n/* IMPORTANT NOTE\nThis is a Vuexy Theme Admin Customized CSS\nThise file was made to override the admin panel CSS for MarketFuel®\nTake Caution in making changes to this file or everything will explode\n*/\n.dark-layout .footer-fixed .footer {\n  background-color: #2b2b2b !important;\n}\n\n.dark-layout .avatar {\n  background: none !important;\n}\n\n.avatar {\n  background-color: #fdfeff;\n}\n\n.btn-danger {\n  background-color: #de4827 !important;\n}\n\n.btn-danger:hover {\n  background-color: #00a0dd !important;\n}\n\n.admin-buttons {\n  background: none !important;\n  border: none !important;\n}\n\n.dark-layout .table,\n.dark-layout .card,\n.dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,\n.dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {\n  background-color: #2b2b2b !important;\n}\n\n.dark-layout .table thead th {\n  border-bottom: 2px solid #00a0dd !important;\n  border-top: none !important;\n  border-color: #00a0dd !important;\n}\n\n.dark-layout .table.table-hover tbody tr:hover,\n.dark-layout .table.table-striped tbody tr:nth-of-type(odd),\n.dark-layout input.form-control,\n.dark-layout .custom-file-label,\n[dir] .dark-layout textarea.form-control {\n  background-color: #232323;\n}\n\n.badge {\n  border-radius: 4px !important;\n}\n\n.badge-danger {\n  background-color: #de4827 !important;\n}\n\n.card-header {\n  padding: 0.65625rem 1.3125rem;\n}\n\n.action-item {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin: 2%;\n  padding: 3px;\n  border: 1px solid #ffffff00;\n}\n\n.action-item:hover {\n  background-color: #f3f2f7 !important;\n  border-radius: 4px;\n  border: solid 1px #b1b1b1 !important;\n}\n\n.action-icon {\n  justify-items: center;\n}\n\n.action-icon > svg,\n.action-icons > svg,\n.simple-sku-menubar > svg,\n.user-status > svg {\n  width: 19px !important;\n  margin-right: 0px !important;\n}\n\n.delete {\n  color: #de4827 !important;\n}\n\n.icon-width > svg {\n  width: 17px;\n  margin-left: 4px !important;\n  margin: 0 !important;\n}\n\n.search-icon {\n  width: fit-content;\n  height: auto !important;\n  display: flex;\n  justify-content: flex-end;\n  background-color: #01a0dd !important;\n  border-radius: 4px;\n  align-items: center;\n  padding: 4.5px 13px;\n  color: white;\n  margin: 0;\n  justify-content: center;\n  align-items: center;\n}\n\n.search-icon > svg {\n  width: 19px;\n}\n\n.role-flex,\n.icon-width {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.breadcrumb {\n  background: none !important;\n}\n\n.simple-sku-menubar:last-child {\n  border-right: none;\n}\n\n.card > .card-header:nth-child(2) {\n  padding: inherit;\n}\n\n.dark-layout select.form-control,\n.dark-layout .custom-select {\n  background-color: #232323;\n}\n\n.simple-sku-form-link-row {\n  display: flex;\n  height: 42px;\n  margin: 0;\n}\n\n.portal_actions {\n  display: flex;\n}\n\n.badge {\n  padding: 5px !important;\n  margin: 0px !important;\n}\n\n.mgtags {\n  padding: 2px 20px !important;\n}\n\n[dir] .admin-buttons .btn:not(.customer-btn, .product-btn) {\n  margin-bottom: 0px !important;\n}\n\n.tdactions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.si-flex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.devex-success {\n  color: #fff;\n  background-color: #28c76f;\n}\n\n.dx-icon-clear .devex-success {\n  background-color: #fff;\n}\n\n.edit-customer-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/*================================================================================\n\tItem Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template\n\tVersion: 2.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n================================================================================\n\nNOTE:\n------\nPLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.\nWE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */\n.quarterCol {\n  padding: 10px 25px;\n}\n\n.dx-widget {\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n}\n\n.dx-badge {\n  background-color: #ff0000;\n  color: white;\n  border-radius: 50%;\n  padding: 4px;\n  width: 12px;\n  height: 12px;\n  font-size: 16px;\n  margin-left: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: unset;\n}\n\n.quarterCol > .row {\n  height: 100%;\n  border-radius: 10px;\n  padding-bottom: 10px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  box-shadow: 0px 0px 8px #d9d9d9;\n}\n\n.quarterColDividerContainer {\n  text-align: center;\n  height: 40px;\n  align-items: center;\n}\n\n.quarterColDivider {\n  color: lightgrey;\n}\n\n.quarterColDivider .horizontal {\n  width: 75%;\n  padding: \"15px 30px\";\n  margin: \"15px 30px\";\n}\n\n.icon-info {\n  content: \"ⓘ\";\n}\n\n.dx-radiobutton-icon:before {\n  transform: scale(0.7);\n  margin: auto;\n}\n\n.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {\n  transform: scale(0.7);\n  -webkit-transform: scale(0.7);\n  -moz-transform: scale(0.7);\n  -ms-transform: scale(0.7);\n  -o-transform: scale(0.7);\n}\n\n.fulfillmentNavButton > .dx-button-content {\n  padding: 5px 10px;\n}\n\n.app-footer {\n  justify-content: right;\n}\n\n.smart-grid {\n  width: auto;\n  height: auto;\n}\n\n.smart-grid-command-item {\n  font-family: \"Gill Sans\", \"Gill Sans MT\", Calibri, \"Trebuchet MS\", sans-serif;\n  align-items: center;\n}\n\n.danger-color {\n  color: #de3f3f;\n}\n\n.paginated-checkbox-select,\n.checkbox-header-cell {\n  width: 39px;\n}\n\nul {\n  list-style-type: none;\n  padding-inline-start: 0;\n}\n\n.error {\n  color: red;\n  font-weight: bold;\n}\n\n.btn-left-space {\n  margin-left: 4px;\n}\n\n.show-logo {\n  max-height: 50px;\n  padding-right: 20px;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\nlabel {\n  font-weight: 600;\n}\n\n.page_list_item {\n  background: white;\n  border: 1px solid #c8ced3;\n}\n\n.lifted {\n  display: table;\n  background: lightgray;\n}\n\n.grip_icon {\n  display: flex;\n}\n.grip_icon i {\n  width: 6px;\n}\n\n.card-header .tooltip_label label {\n  color: inherit;\n}\n.card-header .btn-link {\n  color: inherit;\n}\n.card-header h4 {\n  color: inherit;\n}\n\n.tooltip_label {\n  display: flex;\n  align-items: center;\n}\n.tooltip_label label {\n  margin-right: 6px;\n}\n.tooltip_label i {\n  margin-bottom: 7px;\n}\n\n.tooltip_checkbox {\n  display: inline-flex;\n  align-items: center;\n}\n.tooltip_checkbox span {\n  margin-right: 6px;\n}\n.tooltip_checkbox i {\n  margin-bottom: 3px;\n}\n\n.tooltip_text {\n  max-width: 250px;\n  font-weight: 400;\n}\n\n.breadcrumb-container {\n  position: fixed;\n  width: 100%;\n  z-index: 9;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  background-color: #3a4248;\n  border: none;\n}\n\n.breadcrumb-root {\n  position: absolute;\n  left: calc(100% - 400px);\n  top: 0px;\n  font-weight: 600;\n  padding-top: 10px;\n  width: 200px;\n  text-align: center;\n  background: #20a8d8;\n}\n\n.mf-card {\n  border: none;\n  box-shadow: 1px 1px 12px #b9b9b9;\n}\n\n.card {\n  margin-bottom: 0.875rem;\n  margin-top: 0.875rem;\n}\n\n.card-for-credit {\n  margin-bottom: 0.2625rem;\n  min-height: 500px;\n}\n\n.login-page {\n  min-height: 100vh;\n}\n\n.dark-layout .login-card h1 {\n  color: #676d7d;\n}\n\n.dark-layout .login-page {\n  background-color: #2b2a33 !important;\n}\n\n.dark-layout .sign-in-input {\n  background-color: #e8f0fe !important;\n  color: #2b2a33 !important;\n}\n\n.sign-in-input {\n  width: 100%;\n}\n\n.login-container {\n  background-color: #1e1d2b;\n}\n\n.login-card {\n  background-color: #fdfeff;\n}\n.login-card a {\n  color: #5440d2;\n}\n.login-card a:hover {\n  color: #3d2bb4;\n}\n\n.admin_login_logo {\n  height: 100%;\n  width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.admin_login_logo img {\n  max-width: 200px;\n  height: auto;\n}\n\n.card-password-form {\n  display: flex;\n}\n\n.card-body-password-form {\n  margin-top: 30px;\n}\n\n.login-divider-container {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 10px 0;\n}\n\n.login-divider-border {\n  flex-grow: 1;\n  height: 1px;\n  background: #6e6b7b;\n  margin: 0;\n}\n\n.login-divider-text {\n  padding: 0 10px;\n  color: #6e6b7b;\n}\n\n.full-width-button {\n  width: 100%;\n}\n\n.token-button {\n  background-color: darkgrey;\n  color: default;\n  border: none;\n  height: 38px;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 4px;\n}\n.token-button:hover, .token-button:focus, .token-button:active {\n  background: #808080 !important;\n}\n\n.login-button {\n  background-color: #5440d2;\n  border: none;\n}\n.login-button:hover, .login-button:active, .login-button:focus {\n  background-color: #3d2bb4 !important;\n}\n\n.sso-button {\n  border: none;\n  background-color: #cfd0d2;\n  height: 38px;\n  color: black;\n  margin-bottom: 10px;\n}\n.sso-button:hover, .sso-button:focus, .sso-button:active {\n  background-color: #adaeb3 !important;\n  color: black;\n}\n\n.google-signin-button img {\n  cursor: pointer;\n  height: 21px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.microsoft-signin-button img {\n  cursor: pointer;\n  max-height: 38px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.user-nav {\n  min-width: 115px;\n}\n\n.dropdown-options {\n  min-width: 190px;\n  width: auto;\n}\n\n.simple-sku-menubar,\n.simple-sku-form-breadcrumb {\n  text-align: center;\n  background-color: var(--mf-colors-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-right: 1px solid var(--mf-colors-neutral-50);\n}\n\n.simple-sku-menubar.active,\n.simple-sku-form-breadcrumb.active {\n  background-color: var(--mf-colors-neutral-50);\n  font-weight: 900;\n  text-decoration: underline;\n}\n\n.simple-sku-form-breadcrumb.active::before,\n.simple-sku-form-breadcrumb.active::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.simple-sku-form-link {\n  width: calc(100% - 30px);\n  height: 95%;\n  background-color: #fff;\n  color: grey;\n}\n\n.simple-sku-form-link:active {\n  background-color: #20a8d8 !important;\n  color: #fff !important;\n}\n\n.sku-form-warning-text {\n  text-align: right;\n  color: red;\n  margin-top: 15px;\n}\n\n.sku-client-dropdown {\n  margin-top: 15px;\n}\n\n.warehouse-list-info {\n  margin-bottom: 0.875rem;\n  margin-top: 2px;\n  margin-left: 10px;\n  margin-right: 5px;\n  background-color: aliceblue;\n}\n\n.btn-info {\n  color: #fff;\n}\n\nimg {\n  max-height: 240px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.app-container {\n  width: 500px;\n  margin: 30px auto;\n}\n\n.clear {\n  clear: both;\n}\n\n.details,\n.title {\n  text-align: center;\n}\n\n.error {\n  margin-top: 4px;\n  color: red;\n}\n\n.red-text {\n  color: red;\n}\n\n.has-error {\n  border: 1px dotted red;\n}\n\n.image-container {\n  align-items: center;\n  display: flex;\n  width: 85%;\n  height: 80%;\n  float: left;\n  margin: 15px 10px 10px 37px;\n  text-align: center;\n  justify-content: \"center\";\n}\n\n.preview-container {\n  height: 335px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.placeholder-preview {\n  cursor: pointer;\n}\n\n.placeholder-preview,\n.render-preview {\n  text-align: center;\n  background-color: #efebeb;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.upload-container {\n  cursor: pointer;\n  height: 300px;\n}\n\n.jqx-fill-state-normal {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\n}\n\n.img-avatar,\n.avatar > img,\n.img-circle {\n  max-width: 100%;\n  height: auto;\n  border-radius: 0;\n}\n\n.image-deletion {\n  position: absolute;\n  margin-left: -40px;\n  margin-top: 4px;\n  background: #fff;\n}\n\n.admin-buttons {\n  background: #f0f3f5;\n  border: 1px solid #c8ced3;\n  border-radius: 0.21875rem;\n  padding: 5px;\n  float: left;\n  margin: 6px 16px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.admin-buttons.col-12 {\n  flex: 0 1 100%;\n}\n\n.admin-buttons .btn {\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n.product-actions {\n  float: right;\n}\n\n.product-actions .btn {\n  margin-right: 10px;\n}\n\n.product-actions .btn:last-child {\n  margin-right: 0px;\n}\n\n.th-width {\n  min-width: 300px;\n}\n\n.text-difference-portal {\n  background-color: #4dbd74;\n  color: #fff;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 85%;\n}\n\n.text-difference-location {\n  background-color: #ffc107;\n  color: #23282c;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-size: 85%;\n  font-weight: 700;\n}\n\n#spinner-overlay {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1030;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.wrapper.menu-hide #spinner-overlay {\n  width: 100%;\n  left: 0;\n}\n\n.mf-loading-spinner {\n  width: 5.25rem;\n  height: 5.25rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 10000000;\n  border-radius: 999px;\n  border: 3px solid #5440d2;\n  background-color: rgba(200, 200, 200, 0.6);\n  -webkit-animation: sk-scaleout 1s infinite ease-out alternate;\n  animation: sk-scaleout 1s infinite ease-out alternate;\n}\n\n.mf-loading-logo {\n  -webkit-animation: logo-spin 1s infinite ease-out alternate;\n  animation: logo-spin 1s infinite ease-out alternate;\n  border-radius: 999px;\n}\n\n.simple-sku-form-link-row .simple-sku-form-links button.simple-sku-form-link.active {\n  color: #ffffff;\n  background-color: #21a8d8;\n  border: none;\n}\n\n.simple-sku-form-link.btn-secondary:not(:disabled):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #21a8d8;\n  border: none;\n}\n\n.container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {\n  margin-top: 60px;\n}\n\n.client-background {\n  background: #caffc7;\n}\n\n.portal-background {\n  background: #fdffc7;\n}\n\n.product-background {\n  background: #f5c687;\n}\n\n.admin-background {\n  background: #fbd2d9;\n}\n\n.location-background {\n  background: #d3ccfd;\n}\n\n.label-column.col-md-6 {\n  padding-top: 10px;\n}\n\n.new-menu-item {\n  margin-bottom: 1.75rem;\n}\n\n.cat_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n}\n.cat_box .button_text {\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.disabled_text {\n  font-size: 10px;\n}\n\n.cat_prod_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n}\n.cat_prod_box p {\n  font-size: 15px;\n  line-height: 15px;\n}\n\n.card-header .dropdown button.btn-secondary {\n  padding: 0px 10px;\n  margin: 0 10px;\n}\n\n.configurable-option-img-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.basic-multi-select {\n  color: black;\n}\n\n.badge {\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.add-remove-modal-cont {\n  margin-top: 15px;\n  padding-right: 15px;\n  padding-left: 30px;\n}\n\n.stock-col {\n  padding-right: 5px;\n  width: 50%;\n}\n\n.vertical-rule-col {\n  width: 2%;\n  flex: none;\n}\n\n.vertical-rule {\n  height: 100%;\n  width: 1px;\n  background-color: #ebe9f1;\n  margin-left: 20px;\n  display: flex;\n}\n\n.on-hand-col {\n  padding-top: 5px;\n  padding-right: 5px;\n  width: 24%;\n  flex: none;\n  padding-left: 100px;\n}\n\n.available-col {\n  padding-top: 5px;\n  padding-left: 45px;\n  width: 24%;\n  flex: none;\n}\n\n.reason-col {\n  padding-left: 14px;\n  padding-right: 28px;\n}\n\n.stock-error {\n  width: 100%;\n  margin-top: 0.21875rem;\n  font-size: 0.749875rem;\n  color: #de4827;\n}\n\n.reason-error {\n  text-align: right;\n}\n\n.stock-hr {\n  margin-right: 16px;\n}\n\n.stock-buttons {\n  margin: 10px 16px 20px 0;\n}\n\n#all-stocks {\n  padding: 0px !important;\n}\n\n#base-n-sub-sku-stocks {\n  padding: 0px !important;\n}\n\n.product-at-stock-management-header {\n  display: inline-flex;\n  width: 340px;\n}\n\n.product-at-stock-management {\n  display: inline-flex;\n  width: 325px;\n}\n\n#stock-product-header .badge-primary {\n  width: 150px;\n}\n#stock-product-header .badge-secondary {\n  width: 150px;\n}\n#stock-product-header .badge-warning {\n  width: 150px;\n}\n\n#stock-product-search-form .form-control {\n  border: 1px solid #5d9ee0;\n}\n\n#stock-product-top-header {\n  background-color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  padding-left: 33px;\n  border: 1px solid #ccc;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n#stock-product-top-header .top-header-column {\n  display: inline-block;\n  width: 150px;\n  text-align: center;\n  padding-top: 15px !important;\n  padding-bottom: 15px !important;\n}\n#stock-product-top-header .top-header-column-sku {\n  display: inline-block;\n  width: 180px;\n  text-align: center;\n  padding-top: 15px !important;\n  padding-bottom: 15px !important;\n}\n\n.form-control-stock-search {\n  padding: 0.4375rem 0.875rem;\n  font-size: 13px;\n  line-height: 0.5;\n  border: 1px solid #ccc;\n}\n\n#base-n-sub-sku-stocks .card-header {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.top-bottom-padding {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.statement-header {\n  background-color: #f0f3f5;\n  text-align: right;\n}\n\n.credit {\n  background-color: #c2e9ef;\n  text-align: right;\n}\n\n.debit {\n  background-color: #efcfb8;\n  text-align: right;\n}\n\n.menu-example-container {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 50px;\n  border: 1px solid #000;\n}\n\n.menu-example {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.menu-example p {\n  padding: 10px;\n}\n\n.menu-example-logo {\n  width: 300px;\n  height: auto;\n  padding-top: 20px;\n}\n\n.no-decoration {\n  color: #23282c;\n}\n\n.no-decoration:hover {\n  color: #23282c;\n  text-decoration: none;\n}\n\n.th-column-action {\n  width: 25%;\n  padding-bottom: 47px !important;\n}\n\n.td-column-action {\n  width: 25%;\n}\n\n.th-column-sku {\n  padding-bottom: 47px !important;\n}\n\n.card-header {\n  color: var(--mf-colors-fg);\n  background-color: var(--mf-colors-surface) !important;\n  border-bottom: 5px solid var(--mf-colors-surface);\n}\n.card-header input {\n  color: var(--mf-colors-fg);\n}\n\n[draggable] {\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Required to make elements draggable in old WebKit */\n  -khtml-user-drag: element;\n  -webkit-user-drag: element;\n}\n\n.child-product-table {\n  padding: 15px;\n}\n\n.column {\n  padding: 10px;\n  margin-right: 5px;\n  height: 30px;\n  -webkit-box-shadow: inset 0 0 3px #000;\n  -ms-box-shadow: inset 0 0 3px #000;\n  box-shadow: inset 0 0 3px #000;\n  text-align: left;\n  cursor: move;\n}\n.column td {\n  padding: 7px;\n}\n\n.child-product-table {\n  border: none;\n}\n\n.child-table {\n  width: 100%;\n  min-height: 250px;\n}\n\n#child-product-table {\n  width: 100%;\n}\n\n.child-table-over,\n.group-dropzone-over {\n  min-height: 250px;\n  border: 2px dashed #000;\n}\n\n.user-cart-table tr td {\n  color: #fff;\n}\n\n.group-bundle-body,\n.group-dropzone {\n  min-height: 250px;\n}\n\n.dropzone-item {\n  padding: 7px;\n}\n\n.dropzone-cell {\n  padding: 2px;\n}\n\n.selected-bundle-name {\n  display: flex;\n  justify-content: space-between;\n}\n\n.group-dropzone-select {\n  margin: 5px;\n}\n\n.group-user-select {\n  padding: 5px;\n  margin: 5px 24px 0px 0px;\n  border: 2px solid lightblue;\n  border-radius: 3px;\n  color: lightblue;\n}\n\n.preview-group-products {\n  margin-left: 10px;\n}\n\n.preview-group-bundle,\n.preview-individual-bundle {\n  border: 1px solid #ccc;\n  padding-left: 7px;\n  padding-top: 7px;\n  margin-top: 15px;\n}\n.preview-group-bundle h5,\n.preview-individual-bundle h5 {\n  margin-top: 7px;\n}\n\n.bundle-flag {\n  color: #335269;\n  border: 1px solid #335269;\n  padding: 0.21875rem 0.4375rem;\n  border-radius: 0.175rem;\n  font-size: 0.6699175rem;\n}\n\n.table.bundleProducts {\n  margin-top: 20px;\n}\n\n.formgroup-bundle {\n  flex-direction: row !important;\n  padding: 15px 5px 5px 5px;\n}\n.formgroup-bundle label {\n  padding: 10px;\n}\n\n.bundle-product-table {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bundle-table {\n  padding: 8px;\n  margin-bottom: 0px;\n}\n\ntable td.bundle-table-cell {\n  padding: 0;\n}\n\n.category-table {\n  color: #5c6873;\n  background-color: #e4e7ea;\n  vertical-align: bottom;\n  border: 2px solid #c8ced3;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 10px;\n  margin: 0px;\n}\n\n.parent-category-list {\n  background-color: white;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.child-category-list {\n  background-color: #f4f4f4;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.modal-dialog {\n  max-width: 90%;\n  width: 90%;\n}\n\n.modal-dialog.modal-slim {\n  width: 40%;\n}\n\n.sk-spinner-pulse.sk-spinner-green.sk-spinner-inline {\n  width: 10%;\n  height: 40px;\n  position: relative;\n  left: 0;\n  top: 0;\n  margin: 0px auto;\n}\n\n.form-group.d-inline {\n  display: inline !important;\n}\n\n.purchase-order-new-product {\n  max-width: 100%;\n}\n\n.code-generation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 60px 0 60px 0;\n}\n.code-generation h3 {\n  padding-bottom: 25px;\n}\n\n.top-form-po {\n  width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border: 0.5px solid #c8ced3;\n  margin-top: -1px;\n  position: relative;\n  padding-top: 10px;\n}\n\n.header-top-form-po {\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #c8ced3;\n  padding-top: 11px;\n  padding-left: 18px;\n}\n\n.total-product-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.discount-taxes-po {\n  width: 100%;\n  background-color: white;\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.total-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  margin-bottom: 5px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.po-bottom-fields {\n  border: 0.5px solid #c8ced3;\n  background-color: white;\n  margin-bottom: 15px;\n}\n\n.product-table-po {\n  margin-bottom: 0px !important;\n}\n\n.tr-header-style {\n  background-color: #335169;\n  color: white;\n}\n\n.po-creation-date {\n  padding: 14px 1px 16px 16px;\n}\n\n.po-discount {\n  background-color: white;\n  padding: 10px;\n  text-align: right;\n  margin-bottom: 1px;\n  padding-right: 27px;\n  border: 0.5px solid #c8ced3;\n}\n\n.product-table-po .table-bordered tr td {\n  padding: 5px;\n}\n\n.product-table-po .table-bordered tr td datafield {\n  background-color: red;\n}\n\n.po-form .rw-dropdown-list.rw-widget {\n  width: 300px;\n}\n\n.date-picker-po-edit .date-input {\n  width: 180px;\n  height: 33px;\n  border-radius: 5px;\n  border-width: thin;\n}\n\n.date-picker-po-edit .date-input-error {\n  width: 180px;\n  border-color: #ea5455;\n  border-radius: 5px;\n  border-width: 2px;\n}\n\n.goods-receipt-form {\n  background-color: white;\n}\n\n/** Shipper HQ items */\n.shipping-selected-names {\n  padding: 7px;\n  border: 1px solid black;\n  border-radius: 4px;\n  margin-right: 7px;\n}\n\n.shipping-selected-names-row {\n  padding: 5px;\n  line-height: 2.5;\n}\n\n.comparison-list {\n  white-space: normal;\n  text-align: left;\n}\n\n.po-list .react-bs-table table td,\n.react-bs-table table th {\n  white-space: initial;\n}\n\n.good-receipts-notes-PO-show {\n  border: 0.5px solid #c8ced3;\n  padding: 10px;\n  margin-bottom: 20px;\n}\n\n.po-form-status {\n  margin-bottom: 12px;\n}\n\n.td-header-error {\n  color: red;\n}\n\n.suborder-tag-remove-btn {\n  position: absolute;\n  top: -20px;\n  left: -20px;\n}\n\n.nav-bar-warning,\n.nav-bar-warning a {\n  margin: 0 auto !important;\n  font-size: 30px !important;\n  text-align: center !important;\n  color: red !important;\n}\n.nav-bar-warning p,\n.nav-bar-warning a p {\n  margin-bottom: 0px !important;\n}\n\n.address_error {\n  color: red;\n}\n\n.roleButton {\n  margin-top: 10px;\n}\n\n.icon {\n  padding: 4px;\n}\n\n.product-spec-component .form-group {\n  padding: 5px 15px;\n  margin-bottom: 0;\n}\n\n.field-group .field-option {\n  margin-bottom: none !important;\n}\n\n.tier-price-box {\n  border: 1px solid #e4e5e6;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.role-table .react-bs-table table td {\n  white-space: normal !important;\n}\n\n.role-name {\n  margin-right: 7px;\n}\n\n.price-configuration {\n  display: flex;\n  justify-content: space-between;\n}\n\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.checkbox-container .checkmark {\n  position: absolute;\n  top: -10px;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: white;\n  border: 1px solid black;\n}\n\n.checkbox-container:hover input ~ .checkmark {\n  background-color: #ccc;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #335269;\n}\n\n.checkbox-container :after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-container .checkmark:after {\n  left: 7px;\n  top: 3px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n#custom_css_block {\n  max-width: 100%;\n}\n\n.portal-form {\n  background-color: #ffffff !important;\n}\n\n.bundle-edit-name {\n  font-size: 15px;\n  width: 300px;\n}\n\n.bundle-edit-name-input {\n  width: 300px;\n  color: #000;\n}\n\n.bundle-edit-description-input {\n  width: 300px;\n}\n\n.bundle-edit-description {\n  margin-left: 5px;\n}\n\n.bundle-edit-descr-label {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.bundle-edit-filter {\n  float: right;\n  color: #000;\n}\n\n.bundle-edit-label {\n  display: inline-block;\n  width: 100px;\n}\n\n.bundle-group-new-edit {\n  margin-bottom: 5px;\n}\n.bundle-group-new-edit input {\n  width: 200px;\n}\n\n.bundle-product-disabled {\n  background-color: #dcdcdc;\n}\n.bundle-product-disabled td {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.bundle-group-disabled {\n  background-color: #dcdcdc;\n}\n.bundle-group-disabled div span {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.disabled-group-header {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.bundle-group-body-disabled .bundle-edit-descr-label,\n.bundle-group-body-disabled .bundle-edit-description,\n.bundle-group-body-disabled th,\n.bundle-group-body-disabled td {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.icon-button-dimensions {\n  background-color: #00a0dd !important;\n  border-color: #00a0dd !important;\n}\n\n.icon-button-dimensions:hover {\n  background-color: #0576a3 !important;\n  border-color: #0576a3 !important;\n}\n\n.cell-left-aligned {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding-bottom: 2px !important;\n  text-align: left !important;\n  margin-right: 2px !important;\n  margin-left: 4px !important;\n  font-weight: normal !important;\n  margin-left: 4px !important;\n}\n\n.custom-modal-style {\n  width: 30%;\n  margin: 0 auto;\n}\n\n.modal-title {\n  width: 100%;\n  padding: 5px;\n}\n\n.protected-button-left-space {\n  margin-left: 10px !important;\n}\n\n.dx-toolbar.dx-widget.dx-popup-title {\n  background: #00a0dd;\n}\n\n.dx-popup-title.dx-toolbar .dx-item.dx-toolbar-item.dx-toolbar-label {\n  color: #fff;\n  font-size: 20px;\n  font-family: \"Montserrat\", Helvetica, Arial, serif;\n}\n\n.devex-column-vertical-align {\n  vertical-align: middle !important;\n  white-space: nowrap !important;\n}\n\n.dx-freespace-row {\n  display: none !important;\n}\n\n.devex-grid-nodata-container {\n  width: 95%;\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fdfeff;\n  padding: 4rem;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.devex-grid-nodata-container .devex-grid-nodata-container-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.card-header-light {\n  color: #4e5154 !important;\n  background-color: #f7f7f7 !important;\n}\n\n.card-header-white {\n  color: #4e5154 !important;\n  background-color: #fff !important;\n}\n\n.card-header-dark-blue {\n  color: #dae1e7 !important;\n  background-color: #3a4459 !important;\n}\n\n.dx-tabs-wrapper {\n  background-color: #f7f7f7;\n}\n\n.dark-layout textarea.notes-input {\n  color: #2e2b3b !important;\n}\n\n.modal-progress {\n  position: absolute;\n  width: 50%;\n  top: 20%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.left-align {\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n}\n\n.right-align {\n  justify-content: flex-end;\n  display: flex;\n  align-items: center;\n}\n\n.center-align {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.sweet-alert-confirm-btn,\n.sweet-alert-confirm-btn:focus,\n.sweet-alert-confirm-btn:active {\n  color: #fff !important;\n}\n\n.sweet-alert-cancel-btn,\n.sweet-alert-cancel-btn:focus,\n.sweet-alert-cancel-btn:active {\n  color: #00a0dd !important;\n}\n\n.sweetalert-wide {\n  width: 500px !important;\n}\n\n.sweetalert-narrow {\n  width: 280px !important;\n}\n\n.sweetalert-tag-inputs {\n  padding: 0 25px;\n}\n\n.sweetalert-narrow > p {\n  margin: 0 !important;\n}\n\n.dx-first-row.dx-last-col.dx-first-row.dx-first-row.dx-first-row > .dx-item-content .dx-box-item-content {\n  background-color: blue !important;\n  /* text-align: right!important; */\n}\n\n.align-right {\n  text-align: right;\n}\n\n.duration {\n  padding-top: 8px;\n  color: #84858c;\n}\n\n.image-item {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.image-item:hover {\n  transform: scale(1.05);\n}\n\n.image-item button {\n  opacity: 0.7;\n}\n\n.image-item button:hover {\n  opacity: 1;\n}\n\nhtml body .app.flex-row.align-items-center {\n  height: 100vh;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  #root {\n    display: flex;\n    flex-direction: column;\n  }\n}\n@-webkit-keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    opacity: 0;\n  }\n}\n@keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0.95) translate(-50%, -50%);\n    transform: scale(0.95) translate(-50%, -50%);\n    opacity: 0.65;\n  }\n  100% {\n    -webkit-transform: scale(1) translate(-50%, -50%);\n    transform: scale(1) translate(-50%, -50%);\n  }\n}\n@keyframes roll {\n  0% {\n    transform: translateX(-150%) rotate(0deg);\n  }\n  100% {\n    transform: translateX(150%) rotate(360deg);\n  }\n}\n@keyframes logo-spin {\n  0% {\n    transform: scale(0.85);\n  }\n  100% {\n    transform: scale(0.8);\n  }\n}","/*!\n * Bootstrap v4.5.2 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n","// Do not forget to update getting-started/theming.md!\n:root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\n  // closest parent with a set `text-align`.\n  text-align: inherit;\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","//  ================================================================================================\n//  File Name: variables.scss\n//  Description: Custom overrides of Bootstrap variables\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n// Color system\n\n$white: #fdfeff !default;\n$gray-50: #f6f6f6 !default;\n$gray-100: #babfc7 !default; // $gray-lightest\n$gray-200: #ededed !default; // $gray-lighter\n$gray-300: #dae1e7 !default; // $gray-light\n$gray-400: #636363 !default;\n$gray-500: #adb5bd !default;\n$gray-600: #b8c2cc !default; // $gray\n$gray-700: #4e5154 !default;\n$gray-800: #1e1e1e !default; // $gray-dark\n$gray-900: #2a2e30 !default;\n$black: #1e1d2b !default; // 231f48 22292f\n\n$brand-dark-hover: #191923;\n$brand-dark-bg: #1e1d2b;\n$brand-purple: #5440d2;\n$brand-purple-hover: #3d2bb4;\n\n$sso-btn: #cfd0d2;\n$sso-btn-hover: #adaeb3;\n\n$purple: #9b67f0 !default; //$primary\n$green: #28c76f !default; //$success\n$blue: #00cfe8 !default; //$info\n$orange: #d56729 !default; //$warning\n$red: #de4827 !default; //$danger\n\n// Marketfuels Color Variables\n$mf-lightblue: #00a0dd !default;\n$mf-red: #de4827 !default;\n$mf-orange: #d56729 !default;\n$mf-navy: #222d69 !default;\n$mf-darkgrey: #232323 !default;\n$mf-lightgrey: #eeeeee !default;\n$mf-mdgrey: #2b2b2b !default;\n$mf-disabled-gray: #cfd0d2 !default;\n$mf-darkblue: #2b5995 !default;\n$mf-brown: #776a84 !default;\n$mf-success-green: #21984f !default;\n$mf-success-green-disabled: #acccb6 !default;\n\n$primary: $mf-lightblue !default;\n$secondary: $mf-red !default;\n$info: $mf-navy !default;\n$warning: $mf-orange !default;\n$light: $gray-50 !default;\n$medium-light: $mf-red !default;\n$dark: $mf-darkgrey !default;\n\n$card-header-bg: var(--mf-colors-surface) !default;\n$card-header-border: var(--mf-colors-surface) !default;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1440px // Custom xxl size,,,,,,,,,,,,\n) !default;\n// scss-docs-end container-max-widths\n\n// stylelint-disable\n$spacer: 0.875rem !default;\n$spacers: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    25: (\n      $spacer * 0.25\n    ),\n    50: (\n      $spacer * 0.5\n    ),\n    75: (\n      $spacer * 0.75\n    ),\n    1: (\n      $spacer\n    ),\n    2: (\n      $spacer * 1.5\n    ),\n    3: (\n      $spacer * 3\n    ),\n    4: (\n      $spacer * 3.5\n    ),\n    5: (\n      $spacer * 4\n    )\n  ),\n  $spacers\n);\n\n// Body\n//\n// Settings for the `<body>` element.\n$body-bg: #f8f8f8 !default;\n$body-color: #6e6b7b !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: $primary !default;\n$link-hover-color: darken($link-color, 5%) !default;\n$link-hover-decoration: none !default;\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-gutter-width: 1.75rem !default;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg: 1.25 !default;\n$line-height-sm: 1 !default;\n\n$border-width: 1px !default;\n$border-color: #ebe9f1 !default;\n$border-radius: 0.3125rem !default;\n$border-radius-lg: 0.525rem !default;\n$border-radius-sm: 0.21875rem !default;\n\n// shadow\n$box-shadow: 0 4px 24px 0 rgba($black, 0.1) !default;\n// Typography\n\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif: 'Montserrat', Helvetica, Arial, serif !default;\n$font-family-monospace: 'Montserrat', Helvetica, Arial, serif !default;\n\n// stylelint-enable value-keyword-case\n$font-size-base: 0.875rem !default;\n$font-size-lg: ceil($font-size-base * 1.25) !default;\n$font-size-md: $font-size-base * 1.2 !default;\n$font-size-sm: ceil($font-size-base * 0.85) !default;\n\n$font-weight-normal: 400 !default;\n$font-weight-bold: 500 !default;\n$font-weight-bolder: 600 !default;\n\n$line-height-base: 1.45 !default;\n\n$h1-font-size: $font-size-base * 2 !default;\n$h2-font-size: $font-size-base * 1.714 !default;\n$h3-font-size: $font-size-base * 1.5 !default;\n$h4-font-size: $font-size-base * 1.286 !default;\n$h5-font-size: $font-size-base * 1.07 !default;\n\n$headings-font-family: inherit !default;\n$headings-color: #5e5873 !default;\n\n$display1-weight: $font-weight-normal !default;\n$display2-weight: $font-weight-normal !default;\n$display3-weight: $font-weight-normal !default;\n$display4-weight: $font-weight-normal !default;\n\n$lead-font-size: $font-size-base * 1.14 !default;\n$lead-font-weight: $font-weight-normal !default;\n\n$small-font-size: 0.75rem !default;\n\n$text-muted: #b9b9c3 !default;\n$hr-border-color: $border-color !default;\n\n$blockquote-small-color: $text-muted !default;\n\n// Tables\n\n$table-cell-padding: 0.625rem !default;\n\n$table-accent-bg: #fafafc !default;\n$table-hover-bg: #f6f6f9 !default;\n\n$table-border-color: $border-color !default;\n\n$table-head-bg: #f3f2f7 !default;\n$table-head-color: $headings-color !default;\n\n$table-dark-bg: $dark !default;\n$table-dark-border-color: #404040 !default;\n\n$table-th-font-size: 0.75rem !default; // custom\n\n// Buttons + Forms\n$btn-padding-y: 0.6875rem !default;\n$btn-padding-x: 1.3125rem !default;\n$input-btn-padding-y: 0.65625rem !default;\n$input-btn-padding-x: 1.75rem !default;\n\n$input-btn-padding-y-sm: 0.425rem !default;\n$input-btn-padding-x-sm: 0.875rem !default;\n$input-btn-font-size-sm: $font-size-base * 0.9 !default;\n\n$input-btn-padding-y-lg: 0.7rem !default;\n$input-btn-padding-x-lg: 1.75rem !default;\n$input-btn-font-size-lg: $font-size-base * 1.25 !default;\n$btn-line-height: 1 !default;\n$btn-border-radius: 0.313rem !default;\n$btn-border-radius-lg: 0.313rem !default;\n$btn-border-radius-sm: 0.313rem !default;\n\n$btn-transition:\n  color 0.15s ease-in-out,\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out,\n  background 0s,\n  border 0s !default;\n\n// Forms\n$custom-control-border-color: #d8d6de;\n$label-margin-bottom: 0.25rem !default;\n\n$input-padding-y: 0.438rem !default;\n$input-padding-x: 1rem !default;\n$input-font-size: 1rem !default;\n$input-line-height: $line-height-base !default;\n\n$input-padding-y-sm: 0.188rem !default;\n$input-padding-x-sm: 0.857rem !default;\n$input-font-size-sm: 0.857rem !default;\n\n$input-padding-y-lg: 0.75rem !default;\n$input-padding-x-lg: 1.143rem !default;\n$input-font-size-lg: 1.143rem !default;\n\n$input-disabled-bg: #efefef !default;\n\n$input-color: $body-color !default;\n$input-border-color: $custom-control-border-color !default;\n$input-box-shadow: inset 0 1px 1px rgba($black, 0.075) !default;\n\n$input-border-radius: $border-radius !default;\n$input-border-radius-lg: $border-radius !default;\n$input-border-radius-sm: $border-radius !default;\n\n$input-focus-border-color: $primary !default;\n$input-focus-box-shadow: 0 3px 10px 0 rgba($black, 0.1) !default;\n\n$input-placeholder-color: $text-muted !default;\n$input-plaintext-color: $body-color !default;\n\n$input-height: 2.714rem !default;\n$input-height-sm: 2.142rem !default;\n$input-height-lg: 3.2857rem !default;\n\n$input-group-addon-bg: white !default;\n$custom-forms-transition:\n  background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out,\n  background 0s,\n  border-color 0s !default;\n\n$custom-control-indicator-border-color: $custom-control-border-color;\n\n$custom-checkbox-indicator-border-radius: 3px !default;\n$custom-checkbox-indicator-checked-color: white !default;\n$custom-checkbox-indicator-indeterminate-color: white !default;\n$custom-checkbox-indicator-icon-checked: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.5 7.5'%3E%3Cpolyline points='0.75 4.35 4.18 6.75 8.75 0.75' style='fill:none;stroke:%23fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px'/%3E%3C/svg%3E\");\n\n$custom-checkbox-indicator-icon-indeterminate: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#{$custom-checkbox-indicator-indeterminate-color}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cline x1='5' y1='12' x2='19' y2='12'%3E%3C/line%3E%3C/svg%3E\");\n\n$custom-control-indicator-checked-disabled-bg: rgba($primary, 0.65);\n\n$custom-radio-indicator-icon-checked: none;\n\n$custom-file-height-inner: $input-height !default;\n\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-disabled-bg: $input-disabled-bg !default;\n$custom-select-bg-size: 10px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color: $input-border-color !default;\n$custom-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n\n// $custom-select-feedback-icon-position: center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n// $custom-select-feedback-icon-size: $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-radius: $input-border-radius !default;\n$custom-select-focus-box-shadow: $input-focus-box-shadow !default;\n\n$custom-select-padding-y-sm: $input-padding-y-sm !default;\n$custom-select-padding-x-sm: $input-padding-x-sm !default;\n$custom-select-font-size-sm: $input-font-size-sm !default;\n$custom-select-height-sm: $input-height-sm !default;\n\n$custom-select-padding-y-lg: $input-padding-y-lg !default;\n$custom-select-padding-x-lg: $input-padding-x-lg !default;\n$custom-select-font-size-lg: $input-font-size-lg !default;\n$custom-select-height-lg: $input-height-lg !default;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-border-color: rgba($black, 0.05) !default;\n$dropdown-border-radius: 0.358rem !default;\n$dropdown-box-shadow: 0 5px 25px rgba($black, 0.1) !default;\n\n$dropdown-link-color: $body-color !default;\n$dropdown-link-hover-color: $primary !default;\n$dropdown-link-hover-bg: rgba($primary, 0.12) !default;\n\n$dropdown-divider-bg: rgba($black, 0.08) !default;\n$dropdown-font-size: 1rem !default;\n$dropdown-spacer: 0 !default;\n$zindex-dropdown: 10 !default;\n\n$dropdown-box-shadow: 0 5px 25px 0 rgba($black, 0.1) !default;\n\n$dropdown-link-disabled-color: $text-muted !default;\n\n$dropdown-item-padding-y: 0.65rem !default;\n$dropdown-item-padding-x: 1.28rem !default;\n\n$dropdown-header-color: $headings-color !default;\n\n$dropdown_spacing: 0.5rem; // custom\n\n// Pagination\n\n$pagination-padding-y: 0.5rem !default;\n$pagination-padding-x: 0.85rem !default;\n$pagination-padding-y-lg: 0.5575rem !default;\n$pagination-padding-x-lg: 1rem !default;\n$pagination-padding-y-sm: 0.443rem !default;\n$pagination-padding-x-sm: 0.745rem !default;\n\n$pagination-disabled-color: $text-muted !default;\n\n$pagination-color: $body-color !default;\n$pagination-bg: #f3f2f7 !default;\n\n$pagination-hover-color: $primary !default;\n$pagination-hover-bg: #f3f2f7 !default;\n\n$pagination-active-color: $primary !default;\n\n$pagination-disabled-color: $text-muted !default;\n$pagination-disabled-bg: #f3f2f7 !default;\n\n$pagination-font-size-lg: 1.14rem !default; // custom\n$pagination-font-size-sm: 0.857rem !default; // custom\n\n// Cards\n$card-spacer-y: 1.5rem !default;\n$card-spacer-x: 1.5rem !default;\n$card-border-radius: 0.428rem !default;\n\n//Alerts\n\n$alert-padding-y: 0.71rem !default;\n$alert-padding-x: 1rem !default;\n$alert-border-radius: 0.358rem !default;\n$alert-link-font-weight: 700 !default;\n\n// List group\n\n$list-group-border-radius: 0.358rem !default;\n$list-group-disabled-color: $text-muted !default;\n\n// Nav tabs\n\n$nav-link-padding-y: 0.358rem !default;\n$nav-link-padding-x: 0.5rem !default;\n$nav-link-disabled-color: $text-muted !default;\n\n$nav-tabs-border-width: 0 !default;\n$nav-tabs-border-radius: 0.25 !default;\n$nav-tabs-link-active-color: $primary !default;\n\n$nav-tabs-link-active-bg: transparent !default;\n\n$nav-pills-border-radius: $btn-border-radius !default;\n$nav-tabs-bg-dark: #323232 !default;\n\n// navbar\n\n$floating-nav-margin: remSizing(1.3);\n\n// Tooltips\n\n$tooltip-bg: #323232 !default;\n$tooltip-padding-y: 0.35rem !default;\n$tooltip-padding-x: 0.678125rem !default;\n$tooltip-font-size: 0.75rem !default;\n$tooltip-border-radius: 0.3125rem !default;\n$tooltip-opacity: 1 !default;\n$tooltip-max-width: 220px !default;\n\n// Popovers\n\n$popover-font-size: 0.875rem !default;\n$popover-border-width: 0 !default;\n$popover-border-radius: 0.3125rem !default;\n$popover-border-color: $border-color !default;\n$popover-box-shadow: 0 0 10px 0 rgba($black, 0.1) !default;\n\n$popover-header-bg: $primary !default;\n$popover-header-color: $white !default;\n$popover-header-padding-y: 0.5625rem !default;\n$popover-header-padding-x: 1.0625rem !default;\n\n// Toasts\n\n$toast-max-width: 380px !default;\n$toast-padding-x: 1rem !default;\n$toast-padding-y: 0.125rem !default;\n$toast-font-size: 0.75rem !default;\n$toast-color: $body-color !default;\n$toast-border-width: 0 !default;\n$toast-border-radius: 0.25rem !default;\n$toast-box-shadow: 0 2px 20px 0 rgba($black, 0.08) !default;\n\n$toast-header-color: $body-color !default;\n$toast-header-background-color: $white !default;\n\n// Progress\n\n$progress-height: 0.75rem !default;\n$progress-border-radius: 4.375rem !default;\n$progress-font-size: $font-size-base * 0.857 !default;\n$progress-bg: rgba($primary, 0.12) !default;\n\n// Breadcrumbs\n\n$breadcrumb-font-size: 0.875rem !default;\n\n// $breadcrumb-padding-y: remSizing(0.3) !default;\n$breadcrumb-item-padding: 0.525rem !default;\n\n$breadcrumb-margin-bottom: 0 !default;\n\n$breadcrumb-bg: transparent !default;\n$breadcrumb-divider-color: $body-color !default;\n$breadcrumb-active-color: $body-color !default;\n\n$breadcrumb-border-radius: 0 !default;\n\n// Carousel\n\n$carousel-control-color: $white !default;\n$carousel-control-prev-icon-bg: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#{$carousel-control-color}\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>') !default;\n$carousel-control-next-icon-bg: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#{$carousel-control-color}\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>') !default;\n\n// Badges\n\n$badge-font-size: 85% !default;\n$badge-padding-y: 0.2625rem !default;\n$badge-padding-x: 0.4375rem !default;\n$badge-font-weight: 600 !default;\n$badge-border-radius: 0.3125rem !default;\n\n$badge-pill-padding-x: 0.4375rem !default;\n\n// Modal\n$modal-inner-padding: 0.7rem 1.225rem !default;\n\n$modal-footer-border-color: rgba($black, 0.05) !default;\n\n$modal-header-padding-y: 0.7rem !default;\n$modal-header-padding-x: 1.225rem !default;\n$modal-content-border-radius: 0.3125rem !default;\n\n$modal-xl: 94% !default;\n$modal-sm: 400px !default;\n\n//    Slide In Modal\n$modal-slide-in-width-sm: 21.875rem !default; // custom\n$modal-slide-in-width: 24.5rem !default; // custom\n$modal-slide-in-width-lg: 26.25rem !default; // custom\n\n// Close\n\n$close-font-size: $font-size-base * 2 !default;\n$close-font-weight: 400 !default;\n$close-color: $headings-color !default;\n\n// Code\n\n$code-font-size: 90% !default;\n$kbd-bg: #eee !default;\n\n// Switch\n$custom-switch-width: 2.625rem !default;\n$custom-switch-indicator-border-radius: 0.875rem !default;\n$custom-switch-indicator-size: 0.875rem !default;\n\n//svg color\n$svg-color-light: #626262 !default;\n\n// SVG icons\n// For Breadcrumb\n$double-chevron-right: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevrons-right'%3E%3Cpolyline points='13 17 18 12 13 7'%3E%3C/polyline%3E%3Cpolyline points='6 17 11 12 6 7'%3E%3C/polyline%3E%3C/svg%3E\";\n// Chevron Icons\n$chevron-left: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-left'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-right: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-up: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E\";\n$chevron-down: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\";\n\n$download: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-download'%3E%3Cpath d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'%3E%3C/path%3E%3Cpolyline points='7 10 12 15 17 10'%3E%3C/polyline%3E%3Cline x1='12' y1='15' x2='12' y2='3'%3E%3C/line%3E%3C/svg%3E\";\n$remove: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-x'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E\";\n$check: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E\";\n$circle: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3C/svg%3E\";\n$infoIcon: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-info'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='16' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='8' x2='12.01' y2='8'%3E%3C/line%3E%3C/svg%3E\";\n$warningIcon: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-alert-triangle'%3E%3Cpath d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'%3E%3C/path%3E%3Cline x1='12' y1='9' x2='12' y2='13'%3E%3C/line%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'%3E%3C/line%3E%3C/svg%3E\";\n$menu: \"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cline x1='3' y1='12' x2='21' y2='12'%3E%3C/line%3E%3Cline x1='3' y1='6' x2='21' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='18' x2='21' y2='18'%3E%3C/line%3E%3C/svg%3E\";\n\n$chat-bg-light: 'data:image/svg+xml;base64,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';\n$chat-bg-dark: 'data:image/svg+xml;base64,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';\n\n@function remSizing($num) {\n  @return #{$num * 0.875}rem;\n}\n\n@function remSpace($num) {\n  @return #{remSizing(($num * 4) / 16)};\n}\n\n@function pxSpace($num) {\n  @return #{$num}px;\n}\n\n$space-0: remSpace(0);\n$space-05: pxSpace(2);\n$space-1: remSpace(1);\n$space-2: remSpace(2);\n$space-3: remSpace(3);\n$space-4: remSpace(4);\n$space-5: remSpace(5);\n$space-6: remSpace(6);\n$space-8: remSpace(8);\n$space-10: remSpace(10);\n$space-12: remSpace(12);\n$space-16: remSpace(16);\n$space-20: remSpace(20);\n$space-24: remSpace(24);\n$space-28: remSpace(28);\n$space-32: remSpace(32);\n$space-36: remSpace(36);\n$space-40: remSpace(40);\n$space-44: remSpace(44);\n$space-48: remSpace(48);\n$space-52: remSpace(52);\n$space-56: remSpace(56);\n$space-60: remSpace(60);\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated font-resizing\n//\n// See https://github.com/twbs/rfs\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n// Resize font-size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1 / $rfs-rem-value);\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1 / $rfs-rem-value);\n}\n\n// Responsive font-size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Variables for storing static and fluid rescaling\n    $rfs-static: null;\n    $rfs-fluid: null;\n\n    // Remove px-unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: $fs / ($fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: $fs / ($fs * 0 + 1 / $rfs-rem-value);\n    }\n\n    // Set default font-size\n    @if $rfs-font-size-unit == rem {\n      $rfs-static: #{$fs / $rfs-rem-value}rem#{$rfs-suffix};\n    }\n    @else if $rfs-font-size-unit == px {\n      $rfs-static: #{$fs}px#{$rfs-suffix};\n    }\n    @else {\n      @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n    }\n\n    // Only add media query if font-size is bigger as the minimum font-size\n    // If $rfs-factor == 1, no rescaling will take place\n    @if $fs > $rfs-base-font-size and $enable-responsive-font-sizes {\n      $min-width: null;\n      $variable-unit: null;\n\n      // Calculate minimum font-size for given font-size\n      $fs-min: $rfs-base-font-size + ($fs - $rfs-base-font-size) / $rfs-factor;\n\n      // Calculate difference between given font-size and minimum font-size for given font-size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      // No need to check if the unit is valid, because we did that before\n      $min-width: if($rfs-font-size-unit == rem, #{$fs-min / $rfs-rem-value}rem, #{$fs-min}px);\n\n      // If two-dimensional, use smallest of screen width and height\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{$fs-diff * 100 / $rfs-breakpoint}#{$variable-unit};\n\n      // Set the calculated font-size.\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n    }\n\n    // Rendering\n    @if $rfs-fluid == null {\n      // Only render static font-size if no fluid font-size is available\n      font-size: $rfs-static;\n    }\n    @else {\n      $mq-value: null;\n\n      // RFS breakpoint formatting\n      @if $rfs-breakpoint-unit == em or $rfs-breakpoint-unit == rem {\n        $mq-value: #{$rfs-breakpoint / $rfs-rem-value}#{$rfs-breakpoint-unit};\n      }\n      @else if $rfs-breakpoint-unit == px {\n        $mq-value: #{$rfs-breakpoint}px;\n      }\n      @else {\n        @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n      }\n\n      @if $rfs-class == \"disable\" {\n        // Adding an extra class increases specificity,\n        // which prevents the media query to override the font size\n        &,\n        .disable-responsive-font-size &,\n        &.disable-responsive-font-size {\n          font-size: $rfs-static;\n        }\n      }\n      @else {\n        font-size: $rfs-static;\n      }\n\n      @if $rfs-two-dimensional {\n        @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n      @else {\n        @media (max-width: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixin uses RFS to rescale font sizes\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer / 2 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y / 2) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size / 2 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) no-repeat right $custom-select-padding-x center / $custom-select-bg-size !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer / 2 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer / 2 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-100 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-600 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width / 2 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:         2rem !default;\n$spinner-height:        $spinner-width !default;\n$spinner-border-width:  .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer / 2;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-blacklist\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter / 2;\n  margin-left: -$gutter / 2;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage($size / $columns);\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage($size / $columns);\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: $size / $columns;\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  & > * {\n    flex: 0 0 100% / $count;\n    max-width: 100% / $count;\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter / 2;\n    padding-left: $gutter / 2;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width / 2;\n  margin-left: -$form-grid-gutter-width / 2;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width / 2;\n    padding-left: $form-grid-gutter-width / 2;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-blacklist\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right;\n        background: $custom-select-background, escape-svg($icon) $custom-select-bg no-repeat $custom-select-feedback-icon-position / $custom-select-feedback-icon-size;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When enabled Popper.js, reset basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:last-child) { @include border-right-radius(0); }\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) / 2;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-color solid $custom-control-indicator-border-width;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: no-repeat 50% / #{$custom-control-indicator-bg-size};\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-blacklist\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: none;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) / 2; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height / 2;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-item {\n    margin-bottom: -$nav-tabs-border-width;\n  }\n\n  .nav-link {\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y / 2;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x / 2;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x / 2;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x / 2;\n  margin-left: -$card-spacer-x / 2;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  display: flex;\n\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      display: inline-block; // Suppress underlining of the separator in modern browsers\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: progress-bar-stripes $progress-bar-animation-timing;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        & + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between / 2;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between / 2;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width / 2;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  color: $carousel-control-color;\n  text-align: center;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: no-repeat 50% / 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) / 2;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) / 2;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  animation: spinner-border .75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 50%;\n  opacity: 0;\n  animation: spinner-grow .75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-blacklist, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage($embed-responsive-aspect-ratio-y / $embed-responsive-aspect-ratio-x);\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if $size != 0 {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // IE & < Edge 18\n  overflow-wrap: break-word !important;\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    //\n    // Printing Tables:\n    // https://web.archive.org/web/20180815150934/http://css-discuss.incutio.com/wiki/Printing_Tables\n    //\n\n    thead {\n      display: table-header-group;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","a {\n  &:focus {\n    outline: none;\n  }\n}\n\na:not([href]) {\n  color: inherit;\n  text-decoration: none;\n\n  // @include hover() {\n  //   color: inherit;\n  //   text-decoration: none;\n  // }\n}\n\nbutton:focus {\n  outline: none;\n}\n","@import './variables';\n// ================================================================================================\n// \tFile Name: helper.scss\n// \tDescription: Helper classes provides template related customization.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Content helpers\n// -------------------------\n\n// typography page icon with list\n.list-style-icons {\n  padding-left: 10px;\n  margin-left: 0;\n  list-style: none;\n  > li svg,\n  > li i {\n    margin-right: 6px;\n  }\n}\n\n//Pull the element\n.pull-up {\n  transition: all 0.25s ease;\n\n  &:hover {\n    transform: translateY(-4px) scale(1.02);\n    box-shadow: 0px 14px 24px rgba(62, 57, 107, 0.2);\n    z-index: 30;\n  }\n}\n\n// Spinner classes\n.spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n}\n.settings-spinner {\n  display: inline-block;\n  animation: spin 3s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-reverse {\n  display: inline-block;\n  animation: spin-reverse 1s linear infinite;\n}\n@keyframes spin-reverse {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n// Bullets used in application pages\n.bullet {\n  width: remSizing(1);\n  height: remSizing(1);\n  border-radius: 50%;\n  display: inline-block;\n  &.bullet-xs {\n    width: remSizing(0.5);\n    height: remSizing(0.5);\n  }\n  &.bullet-sm {\n    width: remSizing(0.714);\n    height: remSizing(0.714);\n  }\n  &.bullet-lg {\n    width: remSizing(1.25);\n    height: remSizing(1.25);\n  }\n}\n\n// Section Label - used in pages and apps\n.section-label {\n  font-size: remSizing(0.85);\n  color: $text-muted;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n// Used for table cell fit\n.cell-fit {\n  width: 0.1%;\n  white-space: nowrap;\n}\n\n// Card match height\n.match-height {\n  > [class*='col'] {\n    display: flex;\n    flex-flow: column;\n\n    > .card {\n      flex: 1 1 auto;\n    }\n  }\n}\n","// ================================================================================================\n//     File Name: type.scss\n//     Description: Type pages custom scss\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// text heading color\n.text-body-heading {\n  color: $headings-color;\n  &:hover {\n    color: inherit !important;\n  }\n}\n// text body hover color if have link\n.text-body {\n  &[href]:hover {\n    color: $link-hover-color !important;\n  }\n}\n","@import './variables';\n\n// Inline code\ncode {\n  padding: remSizing(0.1) remSizing(0.4);\n  font-size: 90%;\n  color: $code-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius/2);\n}\npre {\n  background-color: #f7f7f9;\n  code {\n    background-color: transparent !important;\n  }\n}\n","@import './variables';\n// ================================================================================================\n//     File Name: tables.scss\n//     Description: Tables pages custom scss\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// table-white-space\n.table-white-space {\n  th,\n  td {\n    white-space: nowrap;\n  }\n}\n\n// table th, td padding\n.table {\n  thead,\n  tfoot {\n    th {\n      vertical-align: top;\n      text-transform: uppercase;\n      font-size: $table-th-font-size;\n      letter-spacing: 0.5px;\n    }\n  }\n  th,\n  td {\n    padding: $table-cell-padding remSizing(2);\n    vertical-align: middle;\n  }\n  &.table-sm {\n    th,\n    td {\n      &:first-child {\n        padding-left: remSizing(0.75);\n      }\n    }\n  }\n}\n// if we are not using table-light class then also header color should apply\n.table:not(.table-dark):not(.table-light) {\n  thead:not(.thead-dark) th,\n  tfoot:not(.thead-dark) th {\n    background-color: $table-head-bg;\n  }\n}\n// table inside card, don't need margin bottom\n.table-hover {\n  tbody {\n    tr {\n      cursor: pointer;\n    }\n  }\n}\n// Table - hover animation\n.table-hover-animation {\n  background-color: $body-bg;\n  thead {\n    th {\n      border-bottom: 0;\n    }\n  }\n  th,\n  td {\n    border: 0;\n  }\n  tbody {\n    tr {\n      transition: all 0.25s ease;\n      background-color: $white;\n      &:hover {\n        transform: translateY(-4px);\n      }\n    }\n  }\n}\n\n// table border radius\n.card .table {\n  margin-bottom: 0;\n  border-bottom-left-radius: $border-radius;\n  border-bottom-right-radius: $border-radius;\n  tbody {\n    tr:last-child {\n      td:first-child {\n        border-bottom-left-radius: $border-radius;\n      }\n      td:last-child {\n        border-bottom-right-radius: $border-radius;\n      }\n    }\n  }\n}\n\n// Contexual table inside card radius\n.card {\n  table {\n    tr[class*='table-']:last-child {\n      td:first-child {\n        border-bottom-left-radius: $border-radius;\n      }\n      td:last-child {\n        border-bottom-right-radius: $border-radius;\n      }\n    }\n  }\n}\n\n// IE Specific CSS\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .table-hover-animation {\n    tr {\n      &:hover {\n        border-bottom-color: $table-border-color;\n      }\n    }\n  }\n}\n","@import './variables';\n//\n// Labels\n//\nlabel {\n  color: $headings-color;\n  font-size: $small-font-size;\n}\n\n// placeholder specific scss\n.form-control {\n  &::placeholder {\n    transition: all 0.2s ease;\n  }\n\n  &:focus {\n    &::placeholder {\n      transform: translate(5px);\n      transition: all 0.2s ease;\n    }\n    &:valid,\n    &.is-valid {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n.form-control-plaintext {\n  &:focus {\n    outline: none;\n  }\n}\n\n.custom-file-label {\n  line-height: 1.75;\n  // height: $custom-file-height !important;\n  &:after {\n    height: remSizing(2.58);\n    line-height: 1.75;\n  }\n}\n\n.valid-tooltip,\n.invalid-tooltip {\n  top: 102%;\n  left: 5px;\n}\n\n/***************\n* Form Group\n***************/\n\n// input group !important for overriding the dark style\n.input-group {\n  &:not(.bootstrap-touchspin):focus-within {\n    box-shadow: $input-focus-box-shadow;\n    border-radius: $input-border-radius;\n    .form-control,\n    .input-group-text {\n      border-color: $primary;\n      box-shadow: none;\n\n      &.is-valid {\n        border-color: $success;\n      }\n\n      &.is-invalid {\n        border-color: $danger;\n      }\n    }\n  }\n  &.is-valid {\n    .input-group-text {\n      border-color: $success !important;\n    }\n    &:not(.bootstrap-touchspin):focus-within {\n      .input-group-text {\n        border-color: $success;\n      }\n    }\n  }\n  &.is-invalid {\n    .input-group-text {\n      border-color: $danger !important;\n    }\n    &:not(.bootstrap-touchspin):focus-within {\n      .input-group-text {\n        border-color: $danger;\n      }\n    }\n  }\n\n  &.disabled {\n    .input-group-text {\n      background-color: $input-disabled-bg;\n    }\n  }\n\n  &.round {\n    .form-control,\n    .input-group-text,\n    &:focus-within {\n      @include border-radius(remSizing(1.5));\n    }\n  }\n  &.square {\n    .form-control,\n    .input-group-text,\n    &:focus-within {\n      @include border-radius(0);\n    }\n  }\n  &.round,\n  &.square {\n    .input-group-prepend {\n      .input-group-text {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n    .input-group-append {\n      .input-group-text {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      }\n    }\n    .form-control {\n      &:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n      }\n      &:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n  }\n  &.square {\n    .form-control,\n    .input-group-text {\n      @include border-radius(0);\n    }\n  }\n}\n\n.input-group-text {\n  @include transition($input-transition);\n}\n\n.input-group-prepend {\n  .input-group-text {\n    border-right: 0;\n  }\n}\n\n.input-group-append {\n  .input-group-text {\n    border-left: 0;\n  }\n  &:not(:last-child) .input-group-text {\n    border-right: 0;\n  }\n}\n\n// input group merge\n.input-group-merge {\n  .form-control {\n    &:not(:first-child) {\n      padding-left: 0;\n      border-left: 0;\n    }\n\n    &:not(:last-child) {\n      padding-right: 0;\n      border-right: 0;\n    }\n\n    &.is-valid {\n      ~ .input-group-append {\n        .input-group-text {\n          border-color: $success;\n        }\n      }\n    }\n  }\n  .input-group-prepend {\n    ~ .form-control.is-valid {\n      .input-group-text & {\n        border-color: $success;\n      }\n    }\n  }\n}\n\n// Text area line height\ntextarea {\n  &.form-control {\n    line-height: remSizing(1.6);\n    padding: remSizing(0.8) remSizing(1) !important;\n  }\n\n  &.form-control-sm {\n    padding: remSizing(0.4) remSizing(0.857) !important;\n  }\n\n  &.form-control-lg {\n    padding: remSizing(1) remSizing(1.143) !important;\n  }\n}\n\n// Used for Card - Check it and remove if not used\n.form-actions {\n  border-top: 1px solid darken($body-bg, 10%);\n  padding: 20px 0;\n  margin-top: 20px;\n\n  &.filled {\n    background-color: $body-bg;\n  }\n  &.center {\n    text-align: center;\n  }\n  &.right {\n    text-align: right;\n  }\n\n  &.top {\n    border-top: 0;\n    border-bottom: 1px solid darken($body-bg, 10%);\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n\n  @include media-breakpoint-down(sm) {\n    .buttons-group {\n      float: left !important;\n      margin-bottom: 10px;\n    }\n  }\n}\n\n// Form-horizontal layout\n.form-horizontal {\n  .form-group {\n    @include media-breakpoint-up(sm) {\n      .label-control {\n        text-align: right;\n      }\n    }\n  }\n}\n\n// Select Inputs Specific SCSS\nselect.form-control {\n  &:not([multiple='multiple']) {\n    background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $input-border-color), '#', '%23'));\n    background-position:\n      calc(100% - 12px) 13px,\n      calc(100% - 20px) 13px,\n      100% 0;\n    background-size:\n      18px 14px,\n      18px 14px;\n    background-repeat: no-repeat;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    padding-right: remSizing(1.5);\n  }\n  &.form-control-lg {\n    background-position:\n      calc(100% - 12px) 16px,\n      calc(100% - 20px) 16px,\n      100% 0;\n  }\n  &.form-control-sm {\n    background-position:\n      calc(100% - 12px) 8px,\n      calc(100% - 20px) 8px,\n      100% 0;\n  }\n}\n\n// For customs-select remove double arrow\n.custom-select {\n  -moz-appearance: none; // For firefox\n  -webkit-appearance: none; // for chrome\n}\n\n// Custom Checkbox\n.custom-checkbox {\n  .custom-control-label::before,\n  .custom-control-label::after {\n    top: remSizing(0.07);\n  }\n\n  .custom-control-label::after {\n    background-size: 57%;\n  }\n}\n\n// Custom Radio\n.custom-radio {\n  .custom-control-label::before {\n    top: remSizing(0.1);\n  }\n}\n\n// Custom checkbox and radio in common\n.custom-checkbox,\n.custom-radio {\n  &.custom-control {\n    padding-left: remSizing(1.8);\n\n    .input-group & {\n      padding-left: remSizing(1.3);\n    }\n  }\n\n  .custom-control-input {\n    width: remSizing(1.285);\n    height: remSizing(1.285);\n  }\n\n  .custom-control-label {\n    font-size: $font-size-base;\n    position: static;\n    // vertical-align: middle;\n    &::before,\n    &::after {\n      width: 18px;\n      height: 18px;\n      left: 0;\n    }\n  }\n  .custom-control-input:checked ~ .custom-control-label::before {\n    // box-shadow: 0 2px 4px 0 rgba($custom-control-indicator-checked-bg, 0.4) !important;\n  }\n\n  .custom-control-input:disabled ~ .custom-control-label::before {\n    border: none;\n    box-shadow: none !important;\n  }\n\n  .custom-control-input:focus ~ .custom-control-label::before {\n    border-color: none;\n    box-shadow: 0 2px 4px 0 rgba($custom-control-indicator-checked-bg, 0.4) !important;\n  }\n}\n\n// Custom-checkbox when not disabled and active\n.custom-control-input:not(:disabled) {\n  &:active ~ .custom-control-label {\n    &::before {\n      background-color: $primary;\n      border-color: $primary;\n    }\n  }\n}\n\n/* Floating label Group */\n.form-label-group {\n  position: relative;\n  margin-bottom: $form-group-margin-bottom;\n\n  // Form-Control-Large in Floating Label Group\n  .form-control-lg {\n    ~ label {\n      font-size: $input-font-size;\n      padding: remSizing(1);\n    }\n  }\n\n  // Form-label\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    transition: all 0.25s ease-in-out;\n    padding: remSizing(0.6);\n    pointer-events: none;\n    cursor: text;\n    color: rgba($black, 0.4);\n    font-size: remSizing(0.7);\n    opacity: 0;\n  }\n  // form-input\n  > input,\n  textarea {\n    // from-input on focus change label color\n    &:focus,\n    &:not(:active) {\n      &:not(:placeholder-shown) ~ label {\n        color: rgba($primary, 1) !important;\n        transition: all 0.25s ease-in-out;\n        opacity: 1;\n      }\n    }\n    &:not(:focus) {\n      &:not(:placeholder-shown) ~ label {\n        color: rgba($black, 0.4) !important;\n      }\n    }\n    // form-label after entering text in input box\n    &:not(:placeholder-shown) ~ label {\n      padding: remSizing(0.25) 0;\n      top: -20px;\n      left: 3px;\n    }\n\n    &.form-control-lg:not(:placeholder-shown) ~ label {\n      top: -23px;\n    }\n\n    &.form-control-sm:not(:placeholder-shown) ~ label {\n      top: -18px;\n    }\n  }\n}\n\n/* Switches */\n\n.custom-switch {\n  padding-left: 0;\n  line-height: remSizing(1.7);\n\n  .custom-control-label {\n    padding-left: remSizing(3.5);\n    line-height: remSizing(1.7);\n\n    /* For bg color of switch*/\n    &::before {\n      border: none;\n      background-color: $switch-bg-color;\n      height: remSizing(1.7);\n      box-shadow: none !important;\n      transition:\n        opacity 0.25s ease,\n        background-color 0.1s ease;\n      cursor: pointer;\n      user-select: none;\n      top: 0;\n      left: 0;\n    }\n    /*For Switch handle*/\n    &:after {\n      position: absolute;\n      top: 4px;\n      left: 4px;\n      box-shadow: -1px 2px 3px 0 rgba($black, 0.2);\n      background-color: $switch-indicator-color;\n      transition: all 0.15s ease-out;\n      cursor: pointer;\n      user-select: none;\n    }\n\n    /*For Switch text*/\n    .switch-text-left,\n    .switch-text-right,\n    .switch-icon-left,\n    .switch-icon-right {\n      position: absolute;\n      cursor: pointer;\n      user-select: none;\n      line-height: 1.8;\n      i,\n      svg {\n        height: 13px;\n        width: 13px;\n        font-size: 13px;\n      }\n    }\n    .switch-text-left,\n    .switch-icon-left {\n      left: 6px;\n      color: $white;\n      opacity: 0;\n      transform: translateX(8px);\n      transition:\n        opacity 0.1s ease,\n        transform 0.15s ease;\n    }\n    .switch-icon-right {\n      right: 13px;\n      opacity: 1;\n      transform: translateX(0px);\n      transition:\n        opacity 0.08s ease,\n        transform 0.15s ease;\n    }\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  /*For Switch label*/\n\n  .switch-label {\n    padding-left: remSizing(1);\n  }\n\n  // after its checked\n\n  .custom-control-input:checked ~ .custom-control-label::before {\n    box-shadow: none;\n  }\n\n  /*For Switch Handle Animation*/\n  .custom-control-input:checked ~ .custom-control-label::after {\n    transform: translateX(remSizing(1.4));\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    .switch-text-left,\n    .switch-icon-left {\n      transform: translateX(0);\n      opacity: 1;\n    }\n\n    .switch-text-right,\n    .switch-icon-right {\n      transform: translateX(-8px);\n      opacity: 0;\n    }\n  }\n  .custom-control-input:not(:checked) ~ .custom-control-label {\n    .switch-text-left {\n      opacity: 0;\n    }\n    .switch-text-right {\n      opacity: 1;\n    }\n  }\n  .custom-control-input:checked ~ .custom-control-label {\n    .switch-text-right {\n      opacity: 0;\n    }\n    .switch-text-left {\n      opacity: 1;\n    }\n  }\n}\n\n/* Textarea with Counter */\n.textarea-counter-value {\n  background-color: $primary;\n  color: $white;\n  padding: 1px 6px;\n  font-size: remSizing(0.6);\n  border-radius: 0 0 5px 5px;\n  margin-right: remSizing(1);\n}\n\n.btn.disabled-max-min {\n  background-color: rgba($black, 0.5) !important;\n  cursor: default;\n}\n\n/* Number Type Input Box Scss for - Remove arrow on hover */\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n\n// IE Specific CSS\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  // floating Label Group\n  .form-label-group {\n    label {\n      display: none;\n    }\n  }\n\n  // Bootstrap Select\n  select.form-control {\n    &:not([multiple='multiple']) {\n      background: none;\n    }\n  }\n}\n\n// Date & Time Picker - Form Control Bg color\n.picker__input {\n  &.form-control {\n    background-color: $white;\n  }\n}\n\n// Number Stepper Styling\n.input-group-append {\n  height: 38px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n}\n\n.stepper-btn {\n  height: 50%;\n  border: 1px solid #d8d6de;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n\n  &:focus,\n  &:hover,\n  &:active {\n    border-color: $primary;\n  }\n}\n\n.stepper-btn.top {\n  border-radius: 0 5px 0 0;\n}\n\n.stepper-btn.bottom {\n  border-radius: 0 0 5px 0;\n}\n\n.input-group-append .stepper-btn span {\n  display: block;\n}\n\n.stepper-arrow {\n  display: block;\n  line-height: 1;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #333;\n}\n","@import '../bootstrap-extended/variables';\n//  ================================================================================================\n//  File Name: variables.scss\n//  Description: Custom component variable\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n//  ================================================================================================\n//  WARNING: PLEASE DO NOT CHANGE THIS VARIABLE FILE.\n//  THIS FILE WILL GET OVERWRITTEN WITH EACH VUEXY HTML TEMPLATE RELEASE.\n//  TIP:\n//  We suggest you to use this (assets/scss/variables/_variables-components.scss) file for overriding components variables.\n//  ================================================================================================\n\n$base-font-size: 14px !default;\n$body-direction: ltr !default; // Default ltr, change it to rtl for Right To Left support.\n$content-padding: remSizing(2) !default;\n\n//  ------------------------------\n//    Colors\n//  ------------------------------\n$nav-component-border-color: #ddd !default;\n\n$swiper-bg: #f2f4f4 !default;\n\n//  ------------------------------\n//    Navbar\n//  ------------------------------\n$navbar-height: remSizing(5) !default;\n$horizontal-menu-height: remSizing(4.45) !default;\n$footer-height: remSizing(3.35) !default;\n\n//  ------------------------------\n//    Main Menu\n//  ------------------------------\n\n//main menu dark\n$menu-dark-color: #dcdcdc !default;\n$menu-dark-bg-color: #10163a !default;\n\n$menu-padding: 10px 15px 10px 15px !default;\n$menu-second-level-padding: 10px 0px 10px 14px !default;\n$menu-third-level-padding: 10px 0px 10px 35px !default;\n$menu-forth-level-padding: 10px 0px 10px 49px !default;\n\n// vertical menu\n$menu-expanded-width: 260px !default;\n$menu-collapsed-width: 80px !default;\n\n//  ------------------------------\n//    Sidebar\n//  -------------------------------\n$sidebar-width: 260px !default;\n$chat-sidebar-width: 360px !default;\n\n//  -------------------------------\n//    Avatar\n//  -------------------------------\n\n$avatar-size: 32px !default;\n$avatar-status-size: 11px !default;\n$avatar-status-size-lg: 17px !default;\n\n$avatar-size-xl: 70px !default;\n$avatar-size-lg: 50px !default;\n$avatar-size-sm: 24px !default;\n\n$avatar-bg: #c3c3c3;\n$avatar-group-border: $white;\n\n//  -------------------------------\n//  Progress\n//  -------------------------------\n$progress-size-xl: remSizing(1.14) !default;\n$progress-size-lg: remSizing(0.857) !default;\n$progress-size-md: remSizing(0.57) !default;\n$progress-size-sm: remSizing(0.143) !default;\n\n//  -------------------------------\n//  Form\n//  -------------------------------\n\n// $input-height, $input-height-lg, $input-height-sm are in variables\n$font-size-xs: remSizing(0.75) !default;\n$font-size-xl: ($font-size-base + 0.5) !default;\n$line-height-xl: 1.7 !default;\n$line-height-xs: 1.5 !default;\n$input-padding-y-xl: remSizing(0.5) !default;\n$input-padding-x-xl: remSizing(0.5) !default;\n\n$input-padding-y-xs: remSizing(0.2) !default;\n$input-padding-x-xs: remSizing(0.275) !default;\n\n$border-radius-xl: remSizing(0.35) !default;\n$border-radius-xs: remSizing(0.12) !default;\n$input-border-radius-xl: $border-radius-xl !default;\n$input-border-radius-xs: $border-radius-xs !default;\n\n$input-height-xl: calc((($font-size-xl * $line-height-xl) + ($input-padding-y-xl * 2))) !default;\n$input-height-xs: calc((($font-size-xs * $line-height-xs) + ($input-padding-y-xs * 2))) !default;\n$input-height-sm: calc((($font-size-sm * $line-height-sm) + ($input-padding-y-sm * 2))) !default;\n\n//  -------------------------------\n//  Blank Page Bg Color\n//  -------------------------------\n\n$blank-bg-color: #eff2f7 !default;\n\n//  -------------------------------\n//  Data Tables Bg Color\n//  -------------------------------\n\n$datatable-bg-color: #f8f8f8 !default;\n\n//  -------------------------------\n//  Switch\n//  -------------------------------\n$switch-bg-color: #e2e2e2 !default;\n$switch-indicator-color: $white !default;\n\n//  -------------------------------\n//  Timeline\n//  -------------------------------\n$timeline-border-color: $border-color !default;\n\n$timeline-point-size: remSizing(1.75) !default;\n$timeline-point-indicator-size: 12px !default;\n$timeline-point-indicator-color: $primary !default;\n$timeline-point-indicator-wrapper-size: 20px !default;\n\n$timeline-item-min-height: remSizing(4) !default;\n$timeline-item-icon-font-size: remSizing(0.85) !default;\n\n$timeline-event-time-size: remSizing(0.85) !default;\n$timeline-event-time-color: $text-muted !default;\n","@import './variables';\n// var for box shadow of gradient buttons\n// Buttons\n.btn {\n  box-shadow: none;\n  font-weight: 500;\n\n  // gradient button on hover transition\n  &[class*='bg-gradient-'] {\n    transition: all 0.2s ease;\n    &:hover {\n      transform: translateY(-2px);\n    }\n  }\n\n  // Icon button padding\n  &.btn-icon {\n    padding: remSizing(0.715) remSizing(0.736);\n  }\n  &.btn-sm {\n    &.btn-icon {\n      padding: remSizing(0.5);\n      line-height: 0.5;\n    }\n  }\n  &.btn-lg {\n    &.btn-icon {\n      padding: remSizing(1);\n      line-height: 0.75;\n    }\n  }\n\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    outline: none;\n    box-shadow: none;\n  }\n\n  &:not(:disabled):not(.disabled):active:focus,\n  &:not(:disabled):not(.disabled).active:focus {\n    box-shadow: none !important;\n  }\n\n  // feather icons inside btn\n  .feather {\n    vertical-align: bottom;\n  }\n}\n\n// For Waves Input Padding\n.btn.waves-input-wrapper {\n  padding: 0;\n}\n\n@include media-breakpoint-down(sm) {\n  .btn-sm-block {\n    display: block;\n    width: 100%;\n  }\n}\n\n// Remove cursor-pointer from button if button is disabled\n// * setting it to inherit will auto adept cursor\n.waves-effect {\n  cursor: inherit;\n}\n","//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x / 1.9;\n  padding-left: $btn-padding-x / 1.9;\n}\n\n.btn-lg + .dropdown-toggle-split,\n.btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: $input-btn-padding-x-lg / 1.75;\n  padding-left: $input-btn-padding-x-lg / 1.75;\n}\n\n.btn-sm + .dropdown-toggle-split,\n.btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: $input-btn-padding-x-sm / 1.9;\n  padding-left: $input-btn-padding-x-sm / 1.9;\n}\n\n// button group border\n.btn-group {\n  [class*='btn-']:not([class*='btn-outline-']):not([class*='btn-flat-']):not([class*='btn-gradient-']):not(\n      [class*='btn-relief-']\n    ) {\n    border-left-color: rgba($black, 0.08) !important;\n    border-right-color: rgba($black, 0.08) !important;\n  }\n}\n\n// remove first btn group border left\n.btn-group\n  > .btn:not([class*='btn-outline-']):not([class*='btn-flat-']):not([class*='btn-gradient-']):not(\n    [class*='btn-relief-']\n  ):first-child,\n.btn-group\n  > .btn:not([class*='btn-outline-']):not([class*='btn-flat-']):not([class*='btn-gradient-']):not(\n    [class*='btn-relief-']\n  ):first-of-type {\n  border-left-color: transparent !important;\n}\n\n// remove last btn group border right\n.btn-group\n  > .btn:not([class*='btn-outline-']):not([class*='btn-flat-']):not([class*='btn-gradient-']):not(\n    [class*='btn-relief-']\n  ):last-child,\n.btn-group\n  > .btn:not([class*='btn-outline-']):not([class*='btn-flat-']):not([class*='btn-gradient-']):not(\n    [class*='btn-relief-']\n  ):last-of-type {\n  border-right-color: transparent !important;\n}\n\n//  toggle button\n.btn-group-toggle {\n  [class*='btn-outline-'] {\n    &:not(:last-child) {\n      border-right-width: 0 !important;\n    }\n  }\n  :not([class*='btn-outline-']) {\n    &.active,\n    &:active {\n      box-shadow: inset $box-shadow;\n    }\n  }\n}\n\n.btn-group .button-group-selected {\n  background-color: #02A0DD;\n  border-color: #02A0DD;\n  color: #fff;\n\n  &:hover {\n    background-color: #0290bb;\n    border-color: #0290bb;\n  }\n\n  &:active {\n    background-color: #027ab8 !important;\n    border-color: #027ab8 !important;\n  }\n}\n\n.btn-group .button-group-unselected {\n  background-color: #D8DEE9;\n  border-color: #D8DEE9;\n  color: #000;\n\n  &:hover {\n    background-color: #c0c7d1;\n    border-color: #c0c7d1;\n  }\n\n  &:active {\n    background-color: #b0bccd !important;\n    border-color: #b0bccd !important;\n  }\n}\n","@import './variables';\n\n// The dropdown menu\n.dropdown {\n  [class*='btn-outline-'].dropdown-toggle.dropdown-toggle-split {\n    border-left: 0 !important;\n  }\n\n  // If don't won't dropdown/up arrow\n  &.no-arrow {\n    .dropdown-toggle {\n      &:after {\n        display: none;\n      }\n      i,\n      svg {\n        margin-right: 0;\n      }\n    }\n  }\n}\n\n// dropdown menu\n.dropdown-menu {\n  // border: 1px solid rgba($black, 0.05); // border opacity has been reduced to make it look same as vue's dropdown border [component page, list view page]\n  border-radius: $dropdown-border-radius;\n  transform: scale(1, 0);\n  box-shadow: $dropdown-box-shadow; // this according to vue version\n\n  .dropdown-item {\n    width: auto;\n    cursor: pointer;\n  }\n\n  // Dropdown Header\n  .dropdown-header {\n    font-weight: 500;\n    line-height: 1;\n  }\n}\n\n.show {\n  > .dropdown-menu {\n    transform: scale(1, 1);\n    opacity: 1;\n    display: block;\n  }\n  > .dropdown-content {\n    max-height: 500px;\n    overflow: scroll;\n    overflow-x: hidden;\n  }\n  .dropdown-toggle {\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  // For DD box shadow on show\n  .btn {\n    &.dropdown-toggle {\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n.dropdown-toggle {\n  // changed icon caret\n\n  &::after {\n    border: none !important;\n    content: ' ';\n    background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $white), '#', '%23'));\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 16px;\n    color: $body-color;\n    width: 14px;\n    height: 11px;\n    position: relative;\n    top: 1px;\n    right: 0px;\n    left: remSizing(0.714);\n    padding: 0;\n    margin: 0;\n    vertical-align: 0;\n  }\n  // arrow size according to toggle sizes\n  &.btn-lg {\n    &::after {\n      background-size: 18px;\n    }\n  }\n\n  &.btn-sm {\n    &::after {\n      background-size: 14px;\n    }\n  }\n\n  &.dropdown-toggle-split {\n    &:after {\n      left: 0;\n    }\n  }\n\n  // hide default arrow to show custom icon DD\n  &.nav-hide-arrow {\n    &::after {\n      display: none;\n    }\n  }\n\n  // Prevent the focus on the dropdown toggle when closing dropdowns\n  &:focus {\n    outline: 0;\n  }\n}\n\n// DropUp\n.dropup {\n  position: relative;\n  .dropdown-toggle {\n    // changed icon dropup caret\n    &::after {\n      background-image: url(str-replace(str-replace($chevron-up, 'currentColor', $white), '#', '%23'));\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 16px;\n      width: 14px;\n      height: 11px;\n      content: '';\n      vertical-align: remSizing(0.05);\n    }\n  }\n  .dropdown-menu {\n    min-width: remSizing(8);\n  }\n}\n\n// DropLeft\n.dropleft {\n  .dropdown-toggle {\n    // changed icon dropup caret\n    &::before {\n      border: none !important;\n      background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $white), '#', '%23'));\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 16px;\n      width: 14px;\n      height: 11px;\n      content: '';\n      position: relative;\n      left: 0;\n    }\n  }\n  .dropdown-menu {\n    min-width: remSizing(8);\n  }\n}\n\n// DropRight\n.dropright {\n  .dropdown-toggle {\n    // changed icon dropup caret\n    &::after {\n      border: none !important;\n      background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $white), '#', '%23'));\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 16px;\n      width: 14px;\n      height: 11px;\n      content: '';\n    }\n  }\n  .dropdown-menu {\n    min-width: remSizing(8);\n  }\n}\n\n// Dropdown ::before position\n.dropdown-menu {\n  // Dropdown margin according to dropdown position\n\n  &[x-placement='bottom-start'],\n  &[x-placement='bottom-end'] {\n    margin-top: $dropdown_spacing;\n  }\n\n  &[x-placement='top-start'],\n  &[x-placement='top-end'] {\n    margin-bottom: $dropdown_spacing;\n  }\n\n  &[x-placement='right-start'] {\n    margin-left: $dropdown_spacing;\n  }\n  &[x-placement='left-start'] {\n    margin-right: $dropdown_spacing;\n  }\n}\n\n// Dropdown icon\n.dropdown,\n.dropup {\n  &.dropdown-icon-wrapper {\n    .dropdown-toggle {\n      &:after {\n        display: none;\n      }\n    }\n    .dropdown-menu {\n      min-width: auto;\n      .dropdown-item {\n        padding: remSizing(0.5) remSizing(1.1);\n        cursor: pointer;\n        i,\n        svg {\n          height: remSizing(1.3);\n          width: remSizing(1.3);\n          font-size: remSizing(1.3);\n        }\n      }\n    }\n  }\n}\n\n// Dropdown menu animation for Horizontal menu\n.horizontal-menu-wrapper .dropdown-menu,\n.header-navbar .dropdown-menu {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-name: slideIn;\n}\n\n// Hidden dropdown toggle arrow\n.dropdown-toggle.hide-arrow,\n.dropdown-toggle-hide-arrow > .dropdown-toggle {\n  &::before,\n  &::after {\n    display: none;\n  }\n}\n\n@keyframes slideIn {\n  0% {\n    transform: translateY(remSizing(1));\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(remSizing(0));\n    opacity: 1;\n  }\n  0% {\n    transform: translateY(remSizing(1));\n    opacity: 0;\n  }\n}\n","@import './variables';\n\n/* ===============================================================================================\n    File Name: navbar.scss\n    Description: Contain header navigation bar, vertical main navigation bar and\n    horiznotal main navigation bar related SCSS.\n    ----------------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n\n@function set-navbar-text-color($color) {\n  @if (lightness($color) > 50) {\n    @return $white; // Lighter backgorund, return dark color\n  } @else {\n    @return $black; // Darker background, return light color\n  }\n}\n\n.header-navbar {\n  padding: 0px;\n  min-height: $navbar-height;\n  font-family: $font-family-monospace;\n  transition:\n    300ms ease all,\n    background 0s;\n  z-index: 997;\n\n  &.fixed-top {\n    left: $menu-expanded-width;\n  }\n\n  //* Navbar modifiers\n  //*------------------------\n\n  // floating nav\n  &.floating-nav {\n    position: fixed;\n    right: 0;\n    margin: #{$floating-nav-margin} #{$content-padding} 0;\n    width: calc(100vw - (100vw - 100%) - calc(#{$content-padding} * 2) - #{$menu-expanded-width});\n    border-radius: $card-border-radius;\n    z-index: 12;\n  }\n\n  // static nav\n  &.navbar-static-top {\n    top: 0;\n    right: 0;\n    left: $menu-expanded-width;\n    width: calc(100vw - (100vw - 100%) - #{$sidebar-width});\n    background: transparent;\n    box-shadow: none !important; // remove this if removing \"menu-shadow\" class\n  }\n\n  // add border to navbar\n  &.navbar-border {\n    border-bottom: 1px solid $border-color;\n  }\n\n  // add shadow to navbar\n  &.navbar-shadow {\n    box-shadow: $box-shadow;\n  }\n\n  &.navbar-dark.navbar-border {\n    border-bottom: 1px solid $theme-dark-border-color;\n  }\n\n  //* Navbar modifiers\n  //*------------------------\n\n  .navbar-container {\n    padding: remSizing(0.8) remSizing(1);\n    // Added more horizontal padding above small screen\n    @include media-breakpoint-up(sm) {\n      padding: remSizing(0.8) remSizing(1.4);\n    }\n    flex-basis: 100%;\n    transition: 300ms ease all;\n    margin-left: 0;\n\n    // Navbar bookmark primary color on hover\n    .bookmark-wrapper {\n      // for bookmark z-index\n      .bookmark-input {\n        z-index: 1;\n      }\n    }\n\n    // Language dd style\n    .dropdown-language {\n      .selected-language {\n        font-weight: 500;\n      }\n      .dropdown-menu .dropdown-item {\n        .flag-icon {\n          margin-right: remSizing(0.4);\n        }\n      }\n    }\n\n    //Navbar notification css\n    .dropdown-menu-media {\n      width: remSizing(30);\n\n      .dropdown-menu-header {\n        border-bottom: 1px solid $border-color;\n      }\n\n      .media-list {\n        .media {\n          padding: remSizing(0.9) remSizing(1.28);\n          border: none;\n          border-bottom: 1px solid $border-color;\n\n          &:hover {\n            background: $body-bg;\n          }\n\n          .media-meta {\n            color: $body-color;\n          }\n        }\n\n        a:last-of-type {\n          .media {\n            border-bottom: none;\n          }\n        }\n      }\n\n      .dropdown-menu-footer {\n        border-top: 1px solid $border-color;\n      }\n    }\n  }\n}\n\n// Navbar shadow on scroll\n.header-navbar-shadow {\n  display: none;\n}\n\n// Floating Navbar\n.navbar-floating {\n  // Floating nav should have same padding across all screen\n  .navbar-container {\n    padding: remSizing(0.8) remSizing(1);\n  }\n  .header-navbar-shadow {\n    display: block;\n    background: linear-gradient(\n      180deg,\n      hsla(0, 0%, 97.3%, 0.95) 44%,\n      hsla(0, 0%, 97.3%, 0.46) 73%,\n      hsla(0, 0%, 100%, 0)\n    );\n    padding-top: remSizing(2.2);\n    background-repeat: repeat;\n    width: 100%;\n    height: 102px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 11;\n  }\n}\n\n// Navbar colors\n.navbar-light {\n  background: #fbfbfe;\n\n  &.navbar-horizontal {\n    background: #fbfbfe;\n  }\n}\n\n.navbar-dark {\n  background: #2b2a33;\n\n  .navbar-brand {\n    color: $white !important;\n  }\n\n  &.navbar-horizontal {\n    background: #2b2a33;\n  }\n\n  .nav-search {\n    .form-control,\n    .btn-secondary {\n      color: $white;\n      background: $gray-600;\n    }\n  }\n}\n\n// Media queries for device support\n// =========================================\n@include media-breakpoint-down(sm) {\n  .header-navbar {\n    .navbar-container {\n      .show {\n        .dropdown-menu {\n          right: 0;\n          float: none;\n          width: auto !important;\n          margin-top: 0;\n          margin-left: -210px;\n          overflow: hidden;\n        }\n      }\n\n      .dropdown-user {\n        .dropdown-menu-right {\n          right: 0 !important;\n        }\n      }\n    }\n  }\n}\n\n.dropdown-menu {\n  padding: 11px;\n  margin: 10px 0;\n}\n\n@media (min-width: 780px) {\n  /* Adjust this breakpoint as needed */\n  .custom-dropdown-menu {\n    width: 300px !important;\n    /* Re-enable the transform if needed, otherwise, leave it commented out */\n    transform: translate3d(-95px, 9px, 0px) !important;\n  }\n}\n\n.custom-dropdown-toggle {\n  display: inline-flex;\n  align-items: center;\n  background-color: #f8f9fa;\n  color: #000;\n  padding: remSizing(0.25) remSizing(0.5);\n  border-radius: remSizing(0.25);\n  text-decoration: none;\n  border: 1px solid #d1d3d4;\n  font-size: remSizing(0.9);\n}\n\n.custom-dropdown-toggle-dark {\n  display: inline-flex;\n  align-items: center;\n  background-color: #2b2b32;\n  color: #adb0b6;\n  padding: remSizing(0.25) remSizing(0.5);\n  border-radius: remSizing(0.25);\n  text-decoration: none;\n  border: 1px solid #6a6b6c;\n  font-size: remSizing(0.9);\n}\n\n// For Medium and down: iPad support for navbr\n\n// navbar static top\n@include media-breakpoint-down(xxl) {\n  .header-navbar {\n    // floating nav width\n    &.floating-nav {\n      width: calc(100vw - (100vw - 100%) - calc(#{$content-padding} * 2));\n    }\n    &.navbar-static-top {\n      left: 0;\n      width: 100%;\n    }\n  }\n}\n\n@include media-breakpoint-down(xs) {\n  .header-navbar {\n    &.floating-nav {\n      width: calc(\n        100vw - (100vw - 100%) - calc(#{$content-padding} + 0.35rem)\n      ) !important; // SM screen calc as per updated spacings\n      margin-left: remSizing(1);\n      margin-right: remSizing(1.2);\n    }\n  }\n}\n\n/* ----------- iPhone 5, 5S  iPhone 6----------- */\n\n// Set dropdown height as per the screen size\n@mixin extend_mobile_specific($menu_height) {\n  .header-navbar {\n    .navbar-container {\n      .show {\n        .dropdown-menu {\n          max-height: $menu_height;\n        }\n      }\n    }\n  }\n}\n\n/* Landscape */\n\n@media only screen and (min-device-width: 26.78em) and (max-device-width: 47.64em) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  @include extend_mobile_specific(180px);\n}\n\n/* ----------- iPhone 6+ ----------- */\n\n/* Landscape */\n\n@media only screen and (min-device-width: 29.57em) and (max-device-width: 52.57em) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {\n  @include extend_mobile_specific(280px);\n}\n\n// for width of navbar in fixed-top\n@media (max-width: 1201px) {\n  .header-navbar {\n    &.fixed-top {\n      left: 0;\n    }\n  }\n\n  .horizontal-layout {\n    .header-navbar {\n      .navbar-container {\n        padding-left: remSizing(0.8);\n        padding-right: remSizing(0.8);\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar-container .dropdown-menu {\n    margin-top: 30px !important;\n  }\n}\n","// Insert Chevron between breadcrumbs\n.breadcrumb {\n  &:not([class*='breadcrumb-']) {\n    .breadcrumb-item + .breadcrumb-item {\n      &:before {\n        content: ' ';\n        background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $body-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        color: $body-color;\n        margin-right: $breadcrumb-item-padding;\n        background-size: 14px;\n      }\n    }\n  }\n  .breadcrumb-item + .breadcrumb-item {\n    &:before {\n      // height: 20px;\n    }\n  }\n}\n\n/* Component Specific */\n.breadcrumb-slash {\n  &.breadcrumb {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: '/';\n    }\n  }\n}\n.breadcrumb-dots {\n  &.breadcrumb {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: '.';\n      position: relative;\n      top: -4px;\n    }\n  }\n}\n.breadcrumb-dashes {\n  &.breadcrumb {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: '-';\n    }\n  }\n}\n.breadcrumb-pipes {\n  &.breadcrumb {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: '|';\n    }\n  }\n}\n.breadcrumb-chevron {\n  &.breadcrumb {\n    .breadcrumb-item + .breadcrumb-item:before {\n      content: ' ';\n      // background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $body-color), '#', '%23'));\n      // background-repeat: no-repeat;\n      // background-position: center;\n      // color: $body-color;\n      // background-size: 14px;\n    }\n  }\n}\n\n@media (max-width: 648px) {\n  .content-header .breadcrumb {\n    display: none;\n  }\n  .breadcrumbs-top {\n    .content-header-title {\n      display: contents !important;\n    }\n  }\n}\n","@import './variables';\n// Badge\n\n.badge {\n  color: $white;\n  &[class*='badge-'] {\n    [class*='icon-'] {\n      line-height: 1;\n    }\n\n    a {\n      color: $white;\n    }\n\n    // badge dropdown alignment\n    .dropdown-toggle,\n    &.dropdown-toggle {\n      span,\n      i,\n      svg {\n        vertical-align: text-top;\n      }\n      i,\n      svg {\n        padding-left: remSizing(0.2);\n      }\n      &::after {\n        position: relative;\n        top: 0;\n        left: 0;\n        font-size: remSizing(1);\n      }\n    }\n    .dropdown-menu {\n      a {\n        color: $dropdown-color;\n      }\n    }\n  }\n\n  i,\n  svg {\n    height: 12px;\n    width: 11px;\n    font-size: 12px;\n    stroke-width: 3;\n    vertical-align: top;\n  }\n\n  // square badge\n  &.badge-square {\n    border-radius: 0;\n  }\n\n  // badge-up\n  // to align badge over any element\n  &.badge-up {\n    position: absolute;\n    top: -11px;\n    right: -9px;\n    min-width: remSizing(1.429);\n    min-height: remSizing(1.429);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: remSizing(0.786);\n    line-height: 0.786;\n    padding-left: remSizing(0.25);\n    padding-right: remSizing(0.25);\n    &.badge-sm {\n      top: remSizing(-0.5);\n      right: remSizing(-0.5);\n    }\n  }\n}\n\n// For fullscreen search\n.badge-icon {\n  i,\n  svg {\n    font-size: 100%;\n    margin-right: 5px;\n  }\n}\n\n// badge dropup pointer\n.dropup {\n  .badge {\n    cursor: pointer;\n  }\n}\n","@import './variables';\n// Component nav and nav/pill tabs\n\n// nav pills\n.nav-pills {\n  margin-bottom: remSizing(1);\n\n  &.dropdown {\n    &.show {\n      .dropdown-item {\n        &.active {\n          &:hover {\n            color: $primary;\n          }\n        }\n      }\n    }\n  }\n\n  // Justified Pills\n  &.nav-justified {\n    @include nav-justified;\n  }\n}\n\n// Basic Nav Tabs\n.nav-tabs {\n  margin-bottom: remSizing(1);\n  position: relative;\n\n  // Justified Tabs\n  &.nav-justified {\n    @include nav-justified;\n  }\n}\n\n// Nav Tabs Vertical\n.nav-vertical {\n  overflow: hidden;\n  .nav.nav-tabs {\n    // vertical nav left tabs\n    &.nav-left {\n      float: left;\n      display: table;\n      margin-right: remSizing(1);\n\n      ~ .tab-content {\n        .tab-pane {\n          display: none;\n          overflow-y: auto;\n          padding-left: remSizing(1);\n          &.active {\n            display: block;\n          }\n        }\n      }\n    }\n\n    // vertical right nav tabs\n    &.nav-right {\n      float: right;\n      display: table;\n      margin-left: remSizing(1);\n\n      ~ .tab-content {\n        .tab-pane {\n          display: none;\n          overflow-y: auto;\n          padding-right: remSizing(1);\n          &.active {\n            display: block;\n          }\n        }\n      }\n    }\n  }\n}\n","// Justified nav links\n// -------------------------\n\n@mixin nav-justified {\n  width: 100%;\n\n  > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n  }\n}\n","@import './variables';\n\n.media-list {\n  .media {\n    padding: remSizing(1.25);\n    width: 100%;\n    margin-top: 0;\n    .media-left {\n      margin-right: remSizing(1);\n    }\n    .media-right {\n      margin-left: remSizing(1);\n    }\n  }\n  a.media {\n    color: $gray-600 !important;\n  }\n}\n\n.media-bordered {\n  .media:not(:first-child) {\n    border-top: 1px solid $border-color;\n  }\n}\n","/*=========================================================================================\n  File Name: progress.scss\n  Description: Extended bootstrap progress bar scss.\n  ----------------------------------------------------------------------------------------\n  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n  ----------------------------------------------------------------------------------------\n==========================================================================================*/\n\n.progress {\n  // border radius to set for stacked bars\n  .progress-bar + .progress-bar:not(:last-child) {\n    border-radius: 0;\n  }\n  .progress-bar:last-child {\n    border-top-right-radius: $progress-border-radius;\n    border-bottom-right-radius: $progress-border-radius;\n  }\n}\n","@import './variables';\n\n/* ===============================================================================================\n  File Name: list-group.scss\n  Description: Contain list item, list group related extended SCSS.\n  ----------------------------------------------------------------------------------------------\n  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n  Author: PIXINVENT\n  Author URL: http://www.themeforest.net/user/pixinvent\n================================================================================================*/\n\n// Inline list style with pipeline separator\n\nul.list-inline {\n  li {\n    display: inline-block;\n  }\n  // used in search page\n  &.list-inline-pipe {\n    > li + li:before {\n      content: ' | ';\n      padding-right: 2px;\n    }\n  }\n}\n\n// bootstrap list group\n.list-group {\n  .list-group-item {\n    line-height: 1.5;\n    &.active {\n      &:hover {\n        background-color: $primary;\n      }\n      &:focus {\n        // color: $body-color;\n        outline: 0;\n        &:hover {\n          color: $white;\n        }\n      }\n      small {\n        color: $white !important;\n      }\n    }\n    &:hover {\n      background-color: $body-bg;\n    }\n\n    i,\n    svg {\n      position: relative;\n    }\n\n    &:not(.active):focus:active {\n      color: inherit;\n    }\n  }\n  .list-group-item-action {\n    &.active {\n      background-color: $primary;\n      color: $white;\n      &:focus {\n        background-color: $primary;\n      }\n    }\n    &:focus {\n      background-color: $body-bg;\n      outline: 0;\n    }\n  }\n\n  // List group with circle for pages like knowledge base\n  &.list-group-circle {\n    border: none;\n    .list-group-item {\n      border: none;\n      position: relative;\n      padding-left: remSizing(1.5);\n      &:after {\n        content: ' ';\n        background-image: url(str-replace(str-replace($circle, 'currentColor', $body-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        color: $body-color;\n        background-size: 10px;\n        position: absolute;\n        height: 10px;\n        width: 10px;\n        top: remSizing(1.15);\n        left: 0;\n      }\n      &:hover {\n        background-color: transparent;\n      }\n    }\n  }\n}\n\n// for drag and drop border radius on selected\n.list-group-item.gu-mirror {\n  border-radius: 0;\n}\n","@import './variables';\n// For Collapse And Accordion\n\n// For collapse-title\n[class*='collapse-'] {\n  .collapse-title {\n    font-weight: 500;\n    font-size: remSizing(1.1);\n  }\n  .card {\n    margin-bottom: 0;\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n    &:not(:last-of-type) {\n      border-bottom: 1px solid $border-color;\n    }\n    .card-header {\n      cursor: pointer;\n      padding: remSizing(1) remSizing(2.8) remSizing(1) remSizing(1);\n    }\n    .card-body {\n      padding: remSizing(1);\n      line-height: 1.5;\n      padding-top: remSizing(0.42);\n    }\n  }\n}\n\n// For collapse title\n.collapse-title {\n  color: inherit;\n  &:hover {\n    color: inherit;\n  }\n}\n\n// To add a border below collapse/accordion heading\n.collapse-default {\n  .card:first-child {\n    border-top: 0;\n  }\n  .card:last-child {\n    border-bottom: 0;\n  }\n  .card {\n    border-radius: 0;\n  }\n}\n\n// For Collapse with border\n\n.collapse-border {\n  .card {\n    border: 1px solid $border-color;\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n    &:not(:first-of-type) {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n}\n\n// For Collapse with shadow\n.collapse-shadow {\n  box-shadow: 0 0px 4px 0 rgba($black, 0.1);\n  padding: remSizing(0.15) remSizing(0.75);\n  border-radius: $border-radius;\n  .card {\n    border-radius: 0;\n    transition:\n      border 0.5s ease-in-out,\n      all 0.3s ease-in-out;\n    &.open {\n      border-radius: remSizing(0.571);\n      margin: 10px 0;\n      border: 0;\n      box-shadow: 0px 0px 8px 0px rgba($black, 0.1) !important;\n    }\n  }\n  .card:first-child {\n    border-top-left-radius: remSizing(0.571);\n    border-top-right-radius: remSizing(0.571);\n  }\n  .card:last-child {\n    border-bottom-left-radius: remSizing(0.571);\n    border-bottom-right-radius: remSizing(0.571);\n  }\n}\n\n// For Collapse with margin\n.collapse-margin {\n  .card {\n    margin-top: remSizing(0.71);\n    margin-bottom: remSizing(0.71);\n    box-shadow: 0 2px 15px 0 rgba($black, 0.05) !important;\n    border-radius: remSizing(0.358);\n    border-bottom: 0 solid transparent !important;\n  }\n  .card-header {\n    border-radius: remSizing(0.358);\n  }\n}\n\n// Collapse Icon & Animation\n.collapse-icon {\n  .card-header {\n    position: relative;\n  }\n\n  [data-toggle='collapse'] {\n    &:after {\n      position: absolute;\n      top: 58%;\n      right: remSizing(1);\n      margin-top: -8px;\n      background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $body-color), '#', '%23'));\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 14px;\n      width: 14px;\n      height: 11px;\n      content: '';\n      transition: all 300ms linear 0s;\n    }\n\n    &:disabled {\n      &:before {\n        background-image: url(str-replace(str-replace($chevron-up, 'currentColor', $body-color), '#', '%23'));\n      }\n    }\n  }\n\n  [aria-expanded='false'] {\n    &:after {\n      transform: rotate(-180deg);\n    }\n  }\n}\n","@import './variables';\n// Pagination\n\n// default look for page item, first and last item\n\n.page-item {\n  border-radius: remSizing(5);\n\n  &:not(.prev-item),\n  &:not(.next-item),\n  &:not(.first),\n  &:not(.last),\n  &:not(.active) {\n    .page-link {\n      line-height: 1.3;\n    }\n  }\n\n  .page-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &.previous,\n  &.prev,\n  &.next,\n  &.first,\n  &.last {\n    .page-link {\n      width: auto;\n    }\n  }\n\n  &.prev-item,\n  &.next-item {\n    .page-link {\n      transition: all 0.2s ease-out;\n    }\n  }\n\n  // prev and next item separated styles\n  &.prev-item {\n    margin-right: remSizing(0.3571);\n\n    .page-link {\n      border-radius: 50%;\n\n      &:before {\n        background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $pagination-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 14px;\n        color: $body-color;\n        width: 8px;\n        height: 18px;\n        content: '';\n      }\n\n      &:hover {\n        background: $pagination-hover-bg;\n        color: $pagination-hover-color;\n      }\n      &:active,\n      &:hover {\n        background-color: $primary !important;\n        &:before {\n          background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $white), '#', '%23')) !important;\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:before {\n          background-image: url(str-replace(\n            str-replace($chevron-left, 'currentColor', $pagination-disabled-color),\n            '#',\n            '%23'\n          ));\n        }\n      }\n    }\n\n    & ~ .page-item:nth-child(2) {\n      border-top-left-radius: remSizing(5);\n      border-bottom-left-radius: remSizing(5);\n      .page-link {\n        border-top-left-radius: remSizing(5) !important;\n        border-bottom-left-radius: remSizing(5) !important;\n      }\n    }\n\n    & ~ .page-item:nth-last-child(2) {\n      border-top-right-radius: remSizing(5);\n      border-bottom-right-radius: remSizing(5);\n      .page-link {\n        border-top-right-radius: remSizing(5) !important;\n        border-bottom-right-radius: remSizing(5) !important;\n      }\n    }\n  }\n\n  &.next-item {\n    margin-left: remSizing(0.3571);\n\n    .page-link {\n      border-radius: 50%;\n\n      &:after {\n        background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $pagination-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 14px;\n        width: 8px;\n        height: 18px;\n        content: '';\n      }\n\n      &:hover {\n        background: $pagination-hover-bg;\n        color: $pagination-hover-color;\n      }\n      &:active,\n      &:hover {\n        background-color: $primary !important;\n        &:after {\n          background-image: url(str-replace(\n            str-replace($chevron-right, 'currentColor', $white),\n            '#',\n            '%23'\n          )) !important;\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:after {\n          background-image: url(str-replace(\n            str-replace($chevron-right, 'currentColor', $pagination-disabled-color),\n            '#',\n            '%23'\n          ));\n        }\n      }\n    }\n  }\n\n  // prev and next style\n  &.prev,\n  &.previous {\n    .page-link {\n      &:before {\n        background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $pagination-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 14px;\n        color: $body-color;\n        width: 12px;\n        height: 18px;\n        content: '';\n      }\n      // &:active,\n      &:hover {\n        &:before {\n          background-image: url(str-replace(\n            str-replace($chevron-left, 'currentColor', $pagination-active-color),\n            '#',\n            '%23'\n          )) !important;\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:before {\n          background-image: url(str-replace(\n            str-replace($chevron-left, 'currentColor', $pagination-disabled-color),\n            '#',\n            '%23'\n          ));\n        }\n      }\n    }\n  }\n  &.next {\n    .page-link {\n      &:after {\n        background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $pagination-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 14px;\n        color: $body-color;\n        width: 12px;\n        height: 18px;\n        content: '';\n      }\n      // &:active,\n      &:hover {\n        &:after {\n          background-image: url(str-replace(\n            str-replace($chevron-right, 'currentColor', $primary),\n            '#',\n            '%23'\n          )) !important;\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:after {\n          background-image: url(str-replace(\n            str-replace($chevron-right, 'currentColor', $pagination-disabled-color),\n            '#',\n            '%23'\n          ));\n        }\n      }\n    }\n  }\n\n  &.disabled {\n    .page-link {\n      color: $pagination-disabled-color;\n    }\n  }\n\n  // page link customization\n\n  .page-link {\n    border: none;\n    margin: 0;\n    margin-left: 0;\n    font-size: remSizing(1);\n    min-width: remSizing(2.286);\n    &:focus {\n      box-shadow: none;\n    }\n\n    &:hover {\n      color: $primary;\n    }\n  }\n\n  // for active page item\n  &.active {\n    background-color: $pagination-bg;\n    border-radius: 0;\n\n    .page-link {\n      z-index: 3;\n      border-radius: remSizing(5);\n      background-color: $primary;\n      color: $white !important;\n      font-weight: 600;\n    }\n  }\n\n  // if you don't want separated look\n\n  &:first-child:not(.prev-item) {\n    &.active {\n      border-top-left-radius: remSizing(1.428);\n      border-bottom-left-radius: remSizing(1.428);\n      .page-link {\n        border-radius: remSizing(5);\n      }\n    }\n    .page-link {\n      border-top-left-radius: remSizing(1.428);\n      border-bottom-left-radius: remSizing(1.428);\n    }\n  }\n\n  &:last-child:not(.next-item) {\n    &.active {\n      border-top-right-radius: remSizing(1.428);\n      border-bottom-right-radius: remSizing(1.428);\n      .page-link {\n        border-radius: remSizing(5);\n      }\n    }\n    .page-link {\n      border-top-right-radius: remSizing(1.428);\n      border-bottom-right-radius: remSizing(1.428);\n    }\n  }\n}\n\n// For Pagination Font sizes\n.pagination {\n  // For Pagination lg\n  &.pagination-lg {\n    .page-item {\n      .page-link {\n        font-size: $pagination-font-size-lg;\n        min-width: remSizing(2.6);\n      }\n    }\n  }\n  // For Pagination sm\n  &.pagination-sm {\n    .page-item {\n      .page-link {\n        font-size: $pagination-font-size-sm;\n        min-width: remSizing(2);\n      }\n    }\n  }\n}\n","@import './variables';\n\n// Modals\n\n.modal {\n  // Modal Header\n\n  .modal-header {\n    background-color: $body-bg;\n    border-bottom: none;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    // close button\n\n    .close {\n      padding: remSizing(0.2) remSizing(0.62);\n      box-shadow: 0 5px 20px 0 rgba($black, 0.1);\n      border-radius: $border-radius;\n      background: $white;\n      opacity: 1;\n      transition: all 0.23s ease 0.1s;\n      position: relative;\n      transform: translate(8px, -2px);\n\n      // For hover effect of close btn\n      &:hover,\n      &:focus,\n      &:active {\n        opacity: 1;\n        outline: none;\n        transform: translate(5px, 3px);\n        box-shadow: none;\n      }\n    }\n  }\n  // Modal Content\n  .modal-content {\n    border: none;\n    // overflow: unset; updated to \"visible\" as close icon is not visible in IE\n    overflow: visible;\n    box-shadow: 0 5px 20px 0 rgba($black, 0.1);\n  }\n\n  .modal-footer {\n    padding: $modal-inner-padding;\n  }\n\n  // modal sticky for apps\n  &.modal-sticky {\n    bottom: 0;\n    right: 0;\n    top: auto;\n    left: auto;\n    height: auto;\n    position: fixed;\n    .modal-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n    .modal-dialog {\n      margin-right: #{$content-padding} !important;\n      box-shadow: 0px 0px 24px 0 rgba($black, 0.25);\n      border-radius: $border-radius;\n    }\n    .modal-actions {\n      background: transparent;\n      box-shadow: none;\n      line-height: 0;\n    }\n  }\n}\n\n// Modal XS\n.modal-xs {\n  max-width: 300px;\n}\n\n// Modal XL\n@media (min-width: 1200px) {\n  .modal-xl {\n    margin-left: 3%;\n    margin-right: 3%;\n  }\n}\n\n// Slide In Modal //\n.modal-slide-in,\n.modal-slide-in .modal {\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.modal-slide-in {\n  .modal-dialog {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: auto;\n    margin: 0;\n    max-width: none;\n    width: ($modal-slide-in-width-sm - 5);\n\n    .modal-content {\n      padding-bottom: ($modal-title-line-height * $close-font-size) + $modal-header-padding-y;\n      padding-top: ($modal-title-line-height * $close-font-size) + $modal-header-padding-y;\n      overflow: auto;\n      border-radius: 0;\n      height: 100%;\n    }\n\n    .modal-body {\n      padding-bottom: 0;\n      padding-top: 0;\n      margin: auto 0;\n      flex-grow: 0;\n    }\n\n    @media (min-width: (map-get($grid-breakpoints, sm))) {\n      width: $modal-slide-in-width;\n    }\n\n    &.sidebar-sm {\n      width: $modal-slide-in-width-sm;\n    }\n    &.sidebar-lg {\n      @media (min-width: (map-get($grid-breakpoints, sm))) {\n        width: $modal-slide-in-width-lg;\n      }\n    }\n  }\n\n  .close {\n    top: $modal-header-padding-y / 2;\n    z-index: 10;\n    transform: none;\n    position: absolute;\n    top: remSizing(1.5);\n    right: $modal-header-padding-x;\n    margin: 0;\n    padding: 0 !important;\n    line-height: 0.5;\n    transform: translate(0, -50%);\n  }\n}\n\n// Slide from Right\n.modal-slide-in.fade .modal-dialog,\n.modal-slide-in .modal.fade .modal-dialog {\n  transform: translateX(100%);\n  transition: transform 0.1s ease-out;\n}\n\n.modal-slide-in.show .modal-dialog,\n.modal-slide-in .modal.show .modal-dialog {\n  transform: translateX(0) !important;\n  transition: transform 0.1s ease-out;\n}\n\n// To remove Max-width of XS Modal in Small Screen\n\n@media (max-width: 576px) {\n  .modal {\n    padding-right: remSizing(1);\n    padding-left: remSizing(1);\n    .modal-xs,\n    .modal-sm {\n      max-width: unset;\n    }\n    &.modal-sticky .modal-dialog {\n      margin-right: remSizing(0.2) !important;\n      margin-left: remSizing(0.2);\n      margin-bottom: remSizing(3);\n    }\n  }\n}\n","@import './variables';\n// Popovers\n\n.popover {\n  box-shadow: $popover-box-shadow;\n  z-index: 2000 !important;\n  // popover header style\n  .popover-header {\n    @include font-size(remSizing(1.07));\n    border: 1px solid $popover-header-bg;\n  }\n  // popover body style\n  .popover-body {\n    border: 1px solid $popover-border-color;\n    border-top-color: $popover-bg;\n    border-bottom-left-radius: $popover-border-radius;\n    border-bottom-right-radius: $popover-border-radius;\n  }\n  // popover bottom arrow color like header\n  &.bs-popover-bottom {\n    .arrow:after {\n      border-bottom-color: $popover-header-bg;\n    }\n  }\n}\n// To set arrow border as we have added border to popover-body and popover-header\n.bs-popover-top {\n  > .arrow {\n    &::after {\n      bottom: $popover-border-width + 1px;\n    }\n  }\n}\n.bs-popover-right {\n  > .arrow {\n    &::after {\n      left: $popover-border-width + 1px;\n    }\n  }\n}\n.bs-popover-left {\n  > .arrow {\n    &::after {\n      right: $popover-border-width + 1px;\n    }\n  }\n}\n","@import './variables';\n// ================================================================================================\n// \tFile Name: utilities.scss\n// \tDescription: Utility classes provides color, width, position & background etc..\n// \t\t\t\t related customization.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Sizes Variable for height and width mixins\n$sizes-px: (\n  // in px\n  50: 50px,\n  100: 100px,\n  150: 150px,\n  200: 200px,\n  250: 250px,\n  300: 300px,\n  350: 350px,\n  400: 405px,\n  450: 455px,\n  500: 500px,\n  550: 550px,\n  600: 600px,\n  650: 650px,\n  700: 700px,\n  750: 750px,\n  800: 800px\n) !default;\n\n$sizes-per: (\n  // in %\n  5: 5%,\n  10: 10%,\n  15: 15%,\n  20: 20%,\n  25: 25%,\n  30: 30%,\n  35: 35%,\n  40: 40%,\n  45: 45%,\n  50: 50%,\n  55: 55%,\n  60: 60%,\n  65: 65%,\n  70: 70%,\n  75: 75%,\n  80: 80%,\n  85: 85%,\n  90: 90%,\n  95: 95%\n) !default;\n\n//--------------- Text ---------------\n//------------------------------------\n\n// Font Size\n//----------\n//small\n.font-small-1 {\n  font-size: remSizing(0.7) !important;\n\n  // for Feather SVG icons as we are using base size as 1rem\n  @at-root svg#{&} {\n    height: remSizing(0.7) !important;\n    width: remSizing(0.7) !important;\n  }\n}\n.font-small-2 {\n  font-size: remSizing(0.8) !important;\n  @at-root svg#{&} {\n    height: remSizing(0.8) !important;\n    width: remSizing(0.8) !important;\n  }\n}\n.font-small-3 {\n  font-size: remSizing(0.9) !important;\n  @at-root svg#{&} {\n    height: remSizing(0.9) !important;\n    width: remSizing(0.9) !important;\n  }\n}\n.font-small-4 {\n  font-size: remSizing(1) !important;\n  @at-root svg#{&} {\n    height: remSizing(1) !important;\n    width: remSizing(1) !important;\n  }\n}\n//medium\n.font-medium-1 {\n  font-size: remSizing(1.1) !important;\n  @at-root svg#{&} {\n    height: remSizing(1.1) !important;\n    width: remSizing(1.1) !important;\n  }\n}\n.font-medium-2 {\n  font-size: remSizing(1.2) !important;\n  @at-root svg#{&} {\n    height: remSizing(1.2) !important;\n    width: remSizing(1.2) !important;\n  }\n}\n.font-medium-3 {\n  font-size: remSizing(1.3) !important;\n  @at-root svg#{&} {\n    height: remSizing(1.3) !important;\n    width: remSizing(1.3) !important;\n  }\n}\n.font-medium-4 {\n  font-size: remSizing(1.4) !important;\n  @at-root svg#{&} {\n    height: remSizing(1.4) !important;\n    width: remSizing(1.4) !important;\n  }\n}\n.font-medium-5 {\n  font-size: remSizing(1.5) !important;\n  @at-root svg#{&} {\n    height: remSizing(1.5) !important;\n    width: remSizing(1.5) !important;\n  }\n}\n//large\n.font-large-1 {\n  font-size: remSizing(2) !important;\n  @at-root svg#{&} {\n    height: remSizing(2) !important;\n    width: remSizing(2) !important;\n  }\n}\n.font-large-2 {\n  font-size: remSizing(3) !important;\n  @at-root svg#{&} {\n    height: remSizing(3) !important;\n    width: remSizing(3) !important;\n  }\n}\n.font-large-3 {\n  font-size: remSizing(4) !important;\n  @at-root svg#{&} {\n    height: remSizing(4) !important;\n    width: remSizing(4) !important;\n  }\n}\n.font-large-4 {\n  font-size: remSizing(5) !important;\n  @at-root svg#{&} {\n    height: remSizing(5) !important;\n    width: remSizing(5) !important;\n  }\n}\n.font-large-5 {\n  font-size: remSizing(6) !important;\n  @at-root svg#{&} {\n    height: remSizing(6) !important;\n    width: remSizing(6) !important;\n  }\n}\n\n// Line height\n//----------\n.line-height-1 {\n  line-height: 1 !important;\n}\n.line-height-condensed {\n  line-height: 1.5 !important;\n}\n.line-height-inherit {\n  line-height: inherit !important;\n}\n\n// Transform\n//----------\n.rotate-45 {\n  transform: rotate(45deg);\n}\n.rotate-45-inverse {\n  transform: rotate(-45deg);\n}\n.rotate-90 {\n  transform: rotate(90deg);\n}\n.rotate-90-inverse {\n  transform: rotate(-90deg);\n}\n.rotate-180 {\n  transform: rotate(180deg);\n}\n.rotate-180-inverse {\n  transform: rotate(-180deg);\n}\n\n//-------------- Borders --------------\n//-------------------------------------\n\n// Border width - 2px\n.border-2 {\n  border-width: 2px !important;\n}\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n// Border width - 3px\n.border-3 {\n  border-width: 3px !important;\n}\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n// Shapes radius : Round / Square\n.round {\n  @include border-radius(remSizing(1.5));\n}\n.square {\n  @include border-radius(0);\n}\n\n//-------------- Sizing --------------\n//------------------------------------\n\n// Width && Height\n.fit {\n  max-width: 100% !important;\n}\n.half-width {\n  width: 50% !important;\n}\n.full-width {\n  width: 100% !important;\n}\n.full-height {\n  height: 100% !important;\n}\n\n// height & width in PX\n@each $name, $size in $sizes-px {\n  .height-#{$name} {\n    height: $size !important;\n  }\n\n  .width-#{$name} {\n    width: $size !important;\n  }\n}\n\n// height & width in %\n@each $name, $size in $sizes-per {\n  .height-#{$name}-per {\n    height: $size !important;\n  }\n\n  .width-#{$name}-per {\n    width: $size !important;\n  }\n}\n\n//------------- Position -------------\n//------------------------------------\n.position-top-0 {\n  top: 0;\n}\n.position-right-0 {\n  right: 0;\n}\n.position-bottom-0 {\n  bottom: 0;\n}\n.position-left-0 {\n  left: 0;\n}\n\n//------------- Overflow -------------\n//------------------------------------\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-scroll {\n  overflow: scroll;\n}\n.overflow-x-scroll {\n  overflow: scroll;\n}\n.overflow-y-scroll {\n  overflow: scroll;\n}\n\n//-------------- Cursor --------------\n//------------------------------------\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-move {\n  cursor: move;\n}\n.cursor-default {\n  cursor: default;\n}\n.cursor-progress {\n  cursor: progress;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n//-------------- Z-index --------------\n//-------------------------------------\n.zindex-1 {\n  z-index: 1 !important;\n}\n.zindex-2 {\n  z-index: 2 !important;\n}\n.zindex-3 {\n  z-index: 3 !important;\n}\n.zindex-4 {\n  z-index: 4 !important;\n}\n.zindex-0 {\n  z-index: 0 !important;\n}\n.zindex-minus-1 {\n  z-index: -1 !important;\n}\n.zindex-minus-2 {\n  z-index: -2 !important;\n}\n.zindex-minus-3 {\n  z-index: -3 !important;\n}\n.zindex-minus-4 {\n  z-index: -4 !important;\n}\n\n//------------ Box Shadow ------------\n//------------------------------------\n.box-shadow-0 {\n  box-shadow: none !important;\n}\n.box-shadow-1 {\n  box-shadow:\n    0 2px 5px 0 rgba($black, 0.16),\n    0 2px 10px 0 rgba($black, 0.12);\n}\n.box-shadow-2 {\n  box-shadow:\n    0 8px 17px 0 rgba($black, 0.2),\n    0 6px 20px 0 rgba($black, 0.19);\n}\n.box-shadow-3 {\n  box-shadow:\n    0 12px 15px 0 rgba($black, 0.24),\n    0 17px 50px 0 rgba($black, 0.19);\n}\n.box-shadow-4 {\n  box-shadow:\n    0 16px 28px 0 rgba($black, 0.22),\n    0 25px 55px 0 rgba($black, 0.21);\n}\n.box-shadow-5 {\n  box-shadow:\n    0 27px 24px 0 rgba($black, 0.2),\n    0 40px 77px 0 rgba($black, 0.22);\n}\n.box-shadow-6 {\n  box-shadow:\n    0 4px 8px 0 rgba($black, 0.12),\n    0 2px 4px 0 rgba($black, 0.08);\n}\n\n//-------------- Outline --------------\n//-------------------------------------\n.outline-none {\n  outline: none !important;\n}\n\n//-------------- Lists --------------\n//-----------------------------------\n.list-style-inside {\n  list-style: inside;\n}\n.list-style-circle {\n  list-style: circle;\n}\n.list-style-square {\n  list-style: square;\n}\n\n//--------- Background Image ---------\n//------------------------------------\n.bg-cover {\n  background-size: cover !important;\n}\n.background-repeat {\n  background-repeat: repeat !important;\n}\n.background-no-repeat {\n  background-repeat: no-repeat !important;\n}\n\n//-------------- Icons --------------\n//-----------------------------------\n.icon-bg-circle {\n  color: $white;\n  padding: remSizing(0.5);\n  border-radius: 50%;\n}\n.icon-left {\n  margin-right: remSizing(0.5);\n}\n.icon-right {\n  margin-right: remSizing(0.5);\n}\n\n// Used for blockUI\n.blockOverlay {\n  z-index: 1050 !important;\n}\n.blockElement,\n.blockPage {\n  z-index: 1051 !important;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\na {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n//Tables\n//--------------------------\n.table-middle {\n  td {\n    vertical-align: middle;\n  }\n}\n\n//SVG\n//--------------------------\n.fill-current {\n  fill: currentColor;\n}\n\n//Cursor\n//--------------------------\n.pointer-events-none {\n  pointer-events: none;\n}\n","@import '../../bootstrap-extended/variables';\n// ================================================================================================\n//   File Name: pallette.scss\n//   Description: Custom color system styles, includes background, border and text colors\n//   ----------------------------------------------------------------------------------------------\n//   Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n//  ================================================================================================\n//  WARNING: PLEASE DO NOT CHANGE THIS VARIABLE FILE.\n//  THIS FILE WILL GET OVERWRITTEN WITH EACH Vuexy HTML TEMPLATE RELEASE.\n//  TIP:\n//  We suggest you to use this (assets/scss/colors/palette.scss) file for overriding color variables.\n//  ================================================================================================\n\n// usage: theme-color(\"name_of_color\", \"type_of_color\")\n// to avoid to repeating map-get($colors, ...)\n\n@function color-function($color, $type) {\n  @if map-has-key($colors, $color) {\n    $curr_color: map-get($colors, $color);\n    @if map-has-key($curr_color, $type) {\n      @return map-get($curr_color, $type);\n    }\n  }\n\n  // @warn \"Unknown `#{name}` in $colors.\";\n  @return null;\n}\n\n// Color palettes\n@import 'palette-variables';\n\n// Color Classes\n//   Text color: .color .lighten-* / .darken-* / .accent-*\n//   Background: .bg-color .bg-lighten-* / .bg-darken-* / .bg-accent-*\n//   border: .border-color .border-lighten-* / .border-darken-* / .border-accent-*\n//   border-top: .border-top-color .border-top-lighten-* / .border-top-darken-* / .border-top-accent-*\n//   border-bottom: .border-bottom-color .border-bottom-lighten-* / .border-bottom-darken-* / .border-bottom-accent-*\n//   border-left: .border-left-color .border-left-lighten-* / .border-left-darken-* / .border-left-accent-*\n//   border-right: .border-right-color .border-right-lighten-* / .border-right-darken-* / .border-right-accent-*\n\n@each $color_name, $color in $colors {\n  @each $color_type, $color_value in $color {\n    @if $color_type== 'base' {\n      // background color\n      .bg-#{$color_name} {\n        background-color: $color_value !important;\n\n        .card-header,\n        .card-footer {\n          background-color: transparent;\n        }\n      }\n\n      // Alert\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .alert-#{$color_name} {\n          // background: rgba($color_value, 0.12) !important;\n          color: $color_value !important;\n\n          .alert-heading {\n            @include alert-heading-bs($color_value);\n          }\n\n          .alert-link {\n            // color: darken($color_value, 5%) !important;\n          }\n\n          // closable alert\n          .close {\n            color: $color_value !important;\n          }\n        }\n      }\n\n      // bg color lighten for rgba - opacity set\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white' and $color_name != 'dark') {\n        .bg-light-#{$color_name} {\n          background: rgba($color_value, 0.12) !important;\n          color: $color_value !important;\n\n          // Calendar background, color and border color\n          &.fc-h-event,\n          &.fc-v-event {\n            border-color: rgba($color_value, 0.1);\n          }\n\n          .fc-list-event-dot {\n            border-color: $color_value !important;\n          }\n\n          &.fc-list-event {\n            &:hover td {\n              background: rgba($color_value, 0.1) !important;\n            }\n\n            .fc-list-event-title {\n              color: $body-color;\n            }\n          }\n        }\n      }\n\n      // avatar with light bg\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white' and $color_name != 'dark') {\n        .avatar.bg-light-#{$color_name} {\n          color: $color_value !important;\n        }\n      }\n\n      // Border colors\n      .border-#{$color_name} {\n        border: 1px solid $color_value !important;\n      }\n\n      .border-top-#{$color_name} {\n        border-top: 1px solid $color_value;\n      }\n\n      .border-bottom-#{$color_name} {\n        border-bottom: 1px solid $color_value;\n      }\n\n      .border-left-#{$color_name} {\n        border-left: 1px solid $color_value;\n      }\n\n      .border-right-#{$color_name} {\n        border-right: 1px solid $color_value;\n      }\n\n      // badge glow colors\n      .bg-#{$color_name},\n      .border-#{$color_name},\n      .badge-#{$color-name} {\n        &.badge-glow {\n          box-shadow: 0px 0px 10px $color_value;\n        }\n      }\n\n      // Badge Background Color\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .badge {\n          // Badge Light Background\n          &.badge-light-#{$color_name} {\n            // background-color: rgba($color: $color_value, $alpha: 0.12);\n            color: $color_value !important;\n          }\n        }\n      }\n\n      // Overlay colors\n      .overlay-#{$color_name} {\n        @include bg-opacity($color_value, 0.6);\n      }\n\n      // Basic buttons\n      // @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n      //   .btn-#{$color_name} {\n      //     border-color: $color_value !important;\n      //     background-color: $color_value !important;\n      //     color: $white !important;\n\n      //     &:focus,\n      //     &:active,\n      //     &.active {\n      //       color: $white;\n      //       background-color: color-function($color_name, 'darken-1') ;\n      //     }\n\n      //     &:hover:not(.disabled):not(:disabled) {\n      //       box-shadow: 0 8px 25px -8px rgba($color-value, 1);\n      //     }\n\n      //     &:not(:disabled):not(.disabled):active:focus {\n      //       box-shadow: none;\n      //     }\n      //   }\n      // }\n\n      // For Btn Flat\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .btn-flat-#{$color-name} {\n          background-color: transparent;\n          color: $color-value;\n\n          &:hover {\n            color: $color-value;\n          }\n\n          &:hover:not(.disabled):not(:disabled) {\n            // background-color: rgba($color-value, 0.12);\n          }\n\n          &:active,\n          &.active,\n          &:focus {\n            // background-color: rgba($color: $color_value, $alpha: 0.2);\n            color: $color_value;\n          }\n\n          &.dropdown-toggle::after {\n            background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $color_value), '#', '%23'));\n          }\n        }\n      }\n\n      // For Btn Relief\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .btn-relief-#{$color-name} {\n          background-color: $color-value;\n          box-shadow: inset 0 -3px 0 0 rgba($black, 0.2);\n          color: $white;\n          transition: all 0.2s ease;\n          @if $color_name == 'dark' {\n            &:hover:not(.disabled):not(:disabled) {\n              background-color: color-function($color_name, 'darken-3');\n            }\n          } @else {\n            &:hover:not(.disabled):not(:disabled) {\n              background-color: color-function($color_name, 'lighten-1');\n            }\n          }\n          &:active,\n          &.active,\n          &:focus {\n            background-color: color-function($color_name, 'darken-1');\n          }\n\n          &:hover {\n            color: $white;\n          }\n          &:active,\n          &.active {\n            outline: none;\n            box-shadow: none;\n            transform: translateY(3px);\n          }\n        }\n      }\n\n      // Outline buttons\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .btn-outline-#{$color_name} {\n          border: 1px solid $color_value !important;\n          background-color: transparent;\n          color: $color_value;\n\n          &:hover:not(.disabled):not(:disabled) {\n            // background-color: rgba($color: $color_value, $alpha: 0.04);\n            color: $color_value;\n          }\n          &:not(:disabled):not(.disabled):active:focus {\n            box-shadow: none;\n          }\n          &:not(:disabled):not(.disabled):active,\n          &:not(:disabled):not(.disabled).active,\n          &:not(:disabled):not(.disabled):focus {\n            // background-color: rgba($color: $color_value, $alpha: 0.2);\n            color: $color_value;\n          }\n\n          &.dropdown-toggle::after {\n            background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $color_value), '#', '%23'));\n          }\n          // split toggle have show class\n          .show > &.dropdown-toggle {\n            // background-color: rgba($color: $color_value, $alpha: 0.2);\n            color: $color_value;\n          }\n        }\n      }\n\n      // Wave effect\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .btn-outline-#{$color_name},\n        .btn-flat-#{$color-name} {\n          &.waves-effect {\n            .waves-ripple {\n              // background: radial-gradient(\n              //   rgba($color_value, 0.2) 0,\n              //   rgba($color_value, 0.3) 40%,\n              //   rgba($color_value, 0.4) 50%,\n              //   rgba($color_value, 0.5) 60%,\n              //   rgba($white, 0) 70%\n              // );\n            }\n          }\n        }\n      }\n\n      // Bullet colors for email app\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .bullet {\n          &.bullet-#{$color_name} {\n            background-color: $color_value;\n          }\n        }\n      }\n\n      // Modal\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .modal {\n          &.modal-#{$color_name} {\n            .modal-header {\n              .modal-title {\n                color: $color_value;\n              }\n              .close {\n                color: $color_value !important;\n              }\n            }\n          }\n        }\n      }\n\n      // For Pagination\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white' and $color_name != 'dark') {\n        .pagination-#{$color-name} {\n          .page-item {\n            &.active {\n              .page-link {\n                background: $color-value !important;\n                color: $white;\n\n                &:hover {\n                  color: $white;\n                }\n              }\n            }\n\n            .page-link {\n              &:hover {\n                color: $color_value;\n              }\n            }\n\n            &.prev-item,\n            &.next-item {\n              .page-link:hover {\n                background: $color_value;\n                color: $white;\n              }\n            }\n            &.next-item,\n            &.next {\n              .page-link {\n                &:active,\n                &:hover {\n                  &:after {\n                    background-image: url(str-replace(\n                      str-replace($chevron-right, 'currentColor', $color_value),\n                      '#',\n                      '%23'\n                    )) !important;\n                  }\n                }\n              }\n            }\n            &.prev-item,\n            &.prev {\n              .page-link {\n                &:active,\n                &:hover {\n                  &:before {\n                    background-image: url(str-replace(\n                      str-replace($chevron-left, 'currentColor', $color_value),\n                      '#',\n                      '%23'\n                    )) !important;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      // Progress Bars\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .progress-bar-#{$color_name} {\n          // background-color: rgba($color_value, 0.12);\n\n          .progress-bar {\n            background-color: $color-value;\n          }\n        }\n      }\n\n      // Timeline\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .timeline {\n          .timeline-point-#{$color_name} {\n            border-color: $color_value !important;\n\n            i,\n            svg {\n              stroke: $color_value !important;\n            }\n\n            &.timeline-point-indicator {\n              background-color: $color_value !important;\n              &:before {\n                // background: rgba($color: $color_value, $alpha: 0.12) !important;\n              }\n            }\n          }\n        }\n      }\n\n      // Divider\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .divider.divider-#{$color-name} {\n          .divider-text {\n            &:before,\n            &:after {\n              border-color: $color-value !important;\n            }\n          }\n        }\n      }\n\n      // Form Input Elements\n      // Checkbox & Radio\n\n      // todo: remove it once confirm\n      input:focus ~ .bg-#{$color_name} {\n        box-shadow:\n          0 0 0 remSizing(0.075) $white,\n          0 0 0 remSizing(0.21) $color_value !important;\n      }\n\n      // Custom Checkbox & Radio\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .custom-control-#{$color_name} {\n          .custom-control-input:checked ~ .custom-control-label::before,\n          .custom-control-input:active ~ .custom-control-label::before {\n            border-color: $color_value;\n            background-color: $color_value;\n          }\n          &.custom-checkbox,\n          &.custom-radio {\n            .custom-control-input:checked ~ .custom-control-label::before,\n            .custom-control-input:active ~ .custom-control-label::before,\n            .custom-control-input:focus ~ .custom-control-label::before {\n              // box-shadow: 0 2px 4px 0 rgba($color_value, 0.4) !important;\n            }\n          }\n          .custom-control-input:disabled:checked ~ .custom-control-label::before {\n            // background-color: rgba($color_value, 0.65) !important;\n            border: none;\n            box-shadow: none !important;\n          }\n          .custom-control-input:focus ~ .custom-control-label::before {\n            border-color: $color_value;\n          }\n        }\n      }\n\n      // Bootstrap Custom Switches\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .custom-switch-#{$color-name} {\n          .custom-control-input:checked ~ .custom-control-label::before {\n            background-color: $color_value !important;\n            color: $white;\n            transition: all 0.2s ease-out;\n          }\n        }\n      }\n\n      // Select2\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .select2-#{$color-name} {\n          .select2-container--default {\n            .select2-selection--multiple {\n              .select2-selection__choice {\n                background: $color_value !important;\n                border-color: $color_value !important;\n              }\n            }\n          }\n        }\n      }\n    } @else {\n      .text-#{$color_name}.text-#{$color_type} {\n        color: $color_value !important;\n      }\n\n      .bg-#{$color_name}.bg-#{$color_type} {\n        background-color: $color_value !important;\n      }\n\n      .border-#{$color_name}.border-#{$color_type} {\n        border: 1px solid $color_value !important;\n      }\n\n      .border-top-#{$color_name}.border-top-#{$color_type} {\n        border-top: 1px solid $color_value !important;\n      }\n\n      .border-bottom-#{$color_name}.border-bottom-#{$color_type} {\n        border-bottom: 1px solid $color_value !important;\n      }\n\n      .border-left-#{$color_name}.border-left-#{$color_type} {\n        border-left: 1px solid $color_value !important;\n      }\n\n      .border-right-#{$color_name}.border-right-#{$color_type} {\n        border-right: 1px solid $color_value !important;\n      }\n\n      .overlay-#{$color_name}.overlay-#{$color_type} {\n        @include bg-opacity($color_value, 0.6);\n      }\n    }\n  }\n}\n","@mixin bg-opacity($color, $opacity: 1) {\n  background: $color; /* The Fallback */\n  // background: rgba($color, $opacity);\n}\n","// Overrides user _variables-components\n@import '../../bootstrap-extended/include';\n\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\n\n$white-color: (\n  'base': #ffffff\n);\n$black-color: (\n  'base': #000000\n);\n$dark-color: (\n  'base': theme-color('dark'),\n  'darken-1': #343434,\n  'darken-2': #1e1e1e,\n  'darken-3': #626262\n);\n$light-color: (\n  'base': theme-color('light')\n);\n\n$primary-color: (\n  // 'lighten-5': lighten(theme-color('primary'), 25%),\n  // 'lighten-4': lighten(theme-color('primary'), 20%),\n  // 'lighten-3': lighten(theme-color('primary'), 15%),\n  // 'lighten-2': lighten(theme-color('primary'), 10%),\n  // 'lighten-1': lighten(theme-color('primary'), 5%),\n  // 'base': theme-color('primary'),\n  // 'darken-1': darken(theme-color('primary'), 5%),\n  // 'darken-2': darken(theme-color('primary'), 10%),\n  // 'darken-3': darken(theme-color('primary'), 15%),\n  // 'darken-4': darken(theme-color('primary'), 20%),\n  'accent-1': #bdfdff,\n  'accent-2': #8afbff,\n  'accent-3': #57faff,\n  'accent-4': #3df9ff\n);\n$secondary-color: (\n  // 'lighten-5': lighten(theme-color('secondary'), 25%),\n  // 'lighten-4': lighten(theme-color('secondary'), 20%),\n  // 'lighten-3': lighten(theme-color('secondary'), 15%),\n  // 'lighten-2': lighten(theme-color('secondary'), 10%),\n  // 'lighten-1': lighten(theme-color('secondary'), 5%),\n  // 'base': theme-color('secondary'),\n  // 'darken-1': darken(theme-color('secondary'), 5%),\n  // 'darken-2': darken(theme-color('secondary'), 10%),\n  // 'darken-3': darken(theme-color('secondary'), 15%),\n  // 'darken-4': darken(theme-color('secondary'), 20%)\n);\n$success-color: (\n  // 'lighten-5': lighten(theme-color('success'), 25%),\n  // 'lighten-4': lighten(theme-color('success'), 20%),\n  // 'lighten-3': lighten(theme-color('success'), 15%),\n  // 'lighten-2': lighten(theme-color('success'), 10%),\n  // 'lighten-1': lighten(theme-color('success'), 5%),\n  // 'base': theme-color('success'),\n  // 'darken-1': darken(theme-color('success'), 5%),\n  // 'darken-2': darken(theme-color('success'), 10%),\n  // 'darken-3': darken(theme-color('success'), 15%),\n  // 'darken-4': darken(theme-color('success'), 20%),\n  'accent-1': #e1fff1,\n  'accent-2': #aeffd9,\n  'accent-3': #7bffc1,\n  'accent-4': #62ffb5\n);\n$info-color: (\n  // 'lighten-5': lighten(theme-color('info'), 25%),\n  // 'lighten-4': lighten(theme-color('info'), 20%),\n  // 'lighten-3': lighten(theme-color('info'), 15%),\n  // 'lighten-2': lighten(theme-color('info'), 10%),\n  // 'lighten-1': lighten(theme-color('info'), 5%),\n  // 'base': theme-color('info'),\n  // 'darken-1': darken(theme-color('info'), 5%),\n  // 'darken-2': darken(theme-color('info'), 10%),\n  // 'darken-3': darken(theme-color('info'), 15%),\n  // 'darken-4': darken(theme-color('info'), 20%),\n  'accent-1': #feffff,\n  'accent-2': #cbf5ff,\n  'accent-3': #98ecff,\n  'accent-4': #7fe7ff\n);\n$warning-color: (\n  // 'lighten-5': lighten(theme-color('warning'), 25%),\n  // 'lighten-4': lighten(theme-color('warning'), 20%),\n  // 'lighten-3': lighten(theme-color('warning'), 15%),\n  // 'lighten-2': lighten(theme-color('warning'), 10%),\n  // 'lighten-1': lighten(theme-color('warning'), 5%),\n  // 'base': theme-color('warning'),\n  // 'darken-1': darken(theme-color('warning'), 5%),\n  // 'darken-2': darken(theme-color('warning'), 10%),\n  // 'darken-3': darken(theme-color('warning'), 15%),\n  // 'darken-4': darken(theme-color('warning'), 20%),\n  'accent-1': #fff5ef,\n  'accent-2': #ffe5d8,\n  'accent-3': #fff6f3,\n  'accent-4': #ffe3da\n);\n$danger-color: (\n  // 'lighten-5': lighten(theme-color('danger'), 25%),\n  // 'lighten-4': lighten(theme-color('danger'), 20%),\n  // 'lighten-3': lighten(theme-color('danger'), 15%),\n  // 'lighten-2': lighten(theme-color('danger'), 10%),\n  // 'lighten-1': lighten(theme-color('danger'), 5%),\n  // 'base': theme-color('danger'),\n  // 'darken-1': darken(theme-color('danger'), 5%),\n  // 'darken-2': darken(theme-color('danger'), 10%),\n  // 'darken-3': darken(theme-color('danger'), 15%),\n  // 'darken-4': darken(theme-color('danger'), 20%),\n  'accent-1': #ffeef1,\n  'accent-2': #ffd6db,\n  'accent-3': #ffecee,\n  'accent-4': #ffd3d7\n);\n\n$colors: (\n  'white': $white-color,\n  'black': $black-color,\n  'dark': $dark-color,\n  'light': $light-color,\n  'primary': $primary-color,\n  'secondary': $secondary-color,\n  'success': $success-color,\n  'info': $info-color,\n  'warning': $warning-color,\n  'danger': $danger-color\n);\n","// ================================================================================================\n//   File Name: pallette-gradient.scss\n//   Description: gradient color system styles\n//   ----------------------------------------------------------------------------------------------\n//   Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n@function color-function($color, $type) {\n  @if map-has-key($colors, $color) {\n    $curr_color: map-get($colors, $color);\n    @if map-has-key($curr_color, $type) {\n      @return map-get($curr_color, $type);\n    }\n  }\n  // @warn \"Unknown `#{name}` in $colors.\";\n  @return null;\n}\n\n// Color palettes\n@import 'palette-variables';\n\n@import 'bootstrap/scss/mixins/_gradients';\n@import 'bootstrap/scss/mixins/gradients';\n\n@each $color_name, $color in $colors {\n  @each $color_type, $color_value in $color {\n    @if $color_type == 'base' {\n      @if ($color_name != 'light' and $color_name != 'black' and $color_name != 'white') {\n        .bg-gradient-#{$color_name},\n        .btn-gradient-#{$color_name} {\n          color: $white;\n          transition: all 0.2s ease;\n          @if $color_name == 'dark' {\n            @if (color-function($color_name, 'base') != null) {\n              @include gradient-directional(map-get(($color), 'base'), map-get(($color), 'darken-2'), 47deg);\n            }\n            // for dark layout\n            .dark-layout & {\n              @include gradient-directional(map-get(($color), 'darken-2'), map-get(($color), 'base'), 47deg);\n              background-repeat: repeat;\n            }\n            background-repeat: repeat;\n          } @else {\n            @if (color-function($color_name, 'base') != null) {\n              @include gradient-directional(map-get(($color), 'base'), map-get(($color), 'lighten-2'), 47deg);\n            }\n            background-repeat: repeat;\n          }\n          &:hover,\n          &:active {\n            color: $white;\n          }\n          &:hover:not(.disabled):not(:disabled) {\n            transform: translateY(-2px);\n          }\n          &:active {\n            transform: translateY(0);\n          }\n          &:active,\n          &:focus {\n            @if (color-function($color_name, 'darken-2') != null) {\n              @include gradient-directional(map-get(($color), 'darken-2'), map-get(($color), 'base'), 47deg);\n            }\n            background-repeat: repeat;\n          }\n        }\n      }\n    }\n  }\n}\n","@import '../../bootstrap-extended/variables';\n\n// ================================================================================================\n//     File Name: content.scss\n//     Description: Page content level SCSS for different screen size, layout and device.\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//     Author: PIXINVENT\n//     Authuseror URL: http://www.themeforest.net//pixinvent\n// ================================================================================================\n\n// Contest margin left for expanded & collapsed stats width & margin left\n// ================================================================================================\n\n@import '../mixins/main-menu-mixin';\n\nhtml {\n  // font-size: $base-font-size;\n  height: 100%;\n  letter-spacing: remSizing(0.01);\n  body {\n    font-size: $base-font-size;\n    height: 100%;\n    background-color: $body-bg;\n    direction: $body-direction;\n    // paragraph line-height\n    p {\n      line-height: remSizing(1.5);\n    }\n  }\n  .content {\n    padding: 0;\n    position: relative;\n    transition: 300ms ease all;\n    backface-visibility: hidden;\n    min-height: calc(100% - #{$footer-height});\n    margin-left: $menu-expanded-width;\n    &.app-content {\n      padding: calc(#{$content-padding} + #{$navbar-height} + #{$floating-nav-margin}) #{$content-padding} 0;\n      &.show-overlay {\n        .content-overlay {\n          z-index: 10;\n          opacity: 1;\n          ~ .header-navbar-shadow {\n            display: none;\n          }\n        }\n      }\n      .content-overlay {\n        position: fixed;\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba($black, 0.5);\n        cursor: pointer;\n        transition:\n          all 0.7s,\n          z-index 0s;\n        z-index: -1;\n      }\n      .content-area-wrapper {\n        display: flex;\n        position: relative;\n        overflow: hidden; // Required in apps\n        .content-wrapper,\n        .content-body {\n          height: 100%;\n        }\n      }\n    }\n    .body-content-overlay {\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      position: absolute;\n      display: block;\n      z-index: 4;\n      visibility: hidden;\n      opacity: 0;\n      transition: all 0.3s ease;\n      &.show {\n        visibility: visible;\n        transition: all 0.3s ease;\n        opacity: 1;\n        background-color: rgba($black, 0.2);\n        border-radius: $border-radius/2;\n      }\n    }\n    .content-wrapper {\n      .content-header-title {\n        font-weight: 500;\n        color: $gray-400;\n        padding-right: $spacer;\n        border-right: 1px solid lighten($gray-600, 10%);\n      }\n      .content-header-right {\n        .dropdown-toggle {\n          &::after {\n            display: none;\n          }\n          i,\n          svg {\n            margin-right: 0;\n          }\n        }\n        .btn-icon {\n          padding: remSizing(0.8);\n          i,\n          svg {\n            height: $font-size-base;\n            width: $font-size-base;\n          }\n        }\n      }\n    }\n  }\n\n  // kanban app uses kanban-wrapper class as not having content-layout so added this class with all the options\n  // For floating navbar\n  .navbar-floating {\n    &.footer-static {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            #{$footer-height},\n            #{$floating-nav-margin}\n          );\n        }\n      }\n    }\n    &.footer-hidden {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            remSizing(0),\n            #{$floating-nav-margin},\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n    &.footer-fixed {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            #{$footer-height},\n            #{$floating-nav-margin},\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n  }\n\n  //for navbar hidden\n  .navbar-hidden {\n    .app-content {\n      padding: #{$content-padding} #{$content-padding} 0 #{$content-padding} !important;\n    }\n    &.footer-static {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(#{$content-padding}, remSizing(0), #{$footer-height});\n        }\n      }\n    }\n    &.footer-hidden {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            remSizing(0),\n            remSizing(0),\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n    &.footer-fixed {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            remSizing(0),\n            #{$footer-height},\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n  }\n\n  // for static navbar\n  .navbar-static {\n    .main-menu {\n      top: 0;\n    }\n    .content {\n      min-height: calc(100% - calc(#{$navbar-height} + #{$footer-height}));\n    }\n    .app-content {\n      padding: #{$content-padding} #{$content-padding} 0 #{$content-padding};\n    }\n    &.footer-static {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(#{$content-padding}, #{$navbar-height}, #{$footer-height});\n        }\n      }\n    }\n    &.footer-hidden {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            remSizing(0),\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n    &.footer-fixed {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            #{$footer-height},\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n  }\n\n  // for sticky navbar\n  .navbar-sticky {\n    .app-content {\n      padding: calc(#{$content-padding} + #{$navbar-height}) #{$content-padding} 0 #{$content-padding};\n    }\n    &.footer-static {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(#{$content-padding}, #{$navbar-height}, #{$footer-height});\n        }\n      }\n    }\n    &.footer-hidden {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            remSizing(0),\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n    &.footer-fixed {\n      .app-content {\n        .content-area-wrapper,\n        .kanban-wrapper {\n          @include content-area-wrapper-height(\n            #{$content-padding},\n            #{$navbar-height},\n            #{$footer-height},\n            remSizing(0),\n            remSizing(0),\n            2\n          );\n        }\n      }\n    }\n  }\n\n  // navbar search width for sticky and static navbar\n  .navbar-static,\n  .navbar-sticky {\n    .nav.header-navbar {\n      .navbar-container {\n        padding-left: remSizing(1.6);\n        padding-right: remSizing(1.6);\n        .search-input {\n          .search-list {\n            &.show {\n              width: 98%;\n              left: 1%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Fixed layout\n  .footer-fixed {\n    .content {\n      &.app-content {\n        padding-bottom: $footer-height !important; // ? Added extra padding bottom due to fixed footer height\n      }\n    }\n  }\n\n  //Remove left margin for 1 column layout\n  [data-col='1-column'] {\n    .header-navbar {\n      // Custom width for floating nav\n      &.floating-nav {\n        width: calc(\n          100vw - (100vw - 100%) - calc(#{$content-padding} * 2)\n        ) !important; // ? override all navbar type width\n      }\n      width: 100%; // Full width for other nav options\n      left: 0 !important;\n    }\n    .content,\n    .footer {\n      margin-left: 0px !important;\n    }\n\n    // horizontal layout\n    &.horizontal-layout {\n      .header-navbar {\n        width: 100% !important;\n      }\n      .app-content {\n        padding: calc(#{$content-padding} + #{$navbar-height} + #{$floating-nav-margin}) #{$content-padding} 0 #{$content-padding} !important; // ? need to check all navbar types case\n      }\n      &.footer-fixed {\n        .app-content {\n          padding: calc(#{$content-padding} + #{$navbar-height} + #{$floating-nav-margin}) #{$content-padding} #{$footer-height}\n            #{$content-padding} !important; // ? need to check all navbar types case\n        }\n      }\n    }\n  }\n\n  /*\n    * Blank page\n    */\n\n  .blank-page {\n    .content {\n      margin-left: 0; // not using in both cases\n      // overflow-x hidden, overflow for y in sm screen issue resolved default\n      &.app-content {\n        overflow: overlay;\n        overflow-x: hidden;\n        padding: 0 !important;\n        transition: none;\n        // remove white space on top by header-navbar-shadow class\n        .header-navbar-shadow {\n          display: none;\n        }\n      }\n    }\n    // blank page content-wrapper\n    .content-wrapper {\n      padding: 0 !important;\n      // content to be in center horizontally and vertically\n      .flexbox-container {\n        display: flex;\n        align-items: center;\n        height: 100vh;\n        height: calc(var(--vh, 1vh) * 100);\n        justify-content: center;\n      }\n    }\n  }\n\n  .pace {\n    .pace-progress {\n      background: $primary;\n    }\n  }\n}\n\n.app-content.center-layout {\n  overflow: hidden;\n}\n\n/*\n* Col 3 layout for detached and general type\n*/\n\n@include media-breakpoint-up(lg) {\n  body {\n    // Normal sidebar\n    .content-right {\n      width: calc(100vw - (100vw - 100%) - #{$sidebar-width});\n      float: right;\n    }\n    .content-left {\n      width: calc(100vw - (100vw - 100%) - #{$sidebar-width});\n      float: left;\n    }\n    // Detached sidebar\n    .content-detached {\n      width: 100%;\n      &.content-right {\n        float: right;\n        margin-left: -$sidebar-width;\n        .content-body {\n          margin-left: calc(#{$sidebar-width} + #{$content-padding});\n        }\n      }\n      &.content-left {\n        float: left;\n        margin-right: -$sidebar-width;\n        .content-body {\n          margin-right: calc(#{$sidebar-width} + #{$content-padding});\n        }\n      }\n    }\n  }\n  .sidebar-right.sidebar-sticky {\n    float: right !important;\n    margin-left: -$sidebar-width;\n    width: $sidebar-width !important;\n    margin-top: $navbar-height + 1.25;\n  }\n}\n\n@include media-breakpoint-down(xs) {\n  html body .app-content {\n    padding: calc(#{$content-padding} - 0.7rem + #{$navbar-height} + #{$floating-nav-margin})\n      calc(#{$content-padding} - 0.7rem) 0 calc(#{$content-padding} - 0.7rem) !important; // - 0.8rem to reduce padding in small screen\n  }\n\n  // For static navbar\n  html body.navbar-static .app-content {\n    padding: calc(#{$content-padding} - 0.7rem) calc(#{$content-padding} - 0.7rem) 0 calc(#{$content-padding} - 0.7rem) !important; // - 0.8rem to reduce padding in small screen\n  }\n\n  // For sticky navbar\n  html body.navbar-sticky .app-content {\n    padding: calc(#{$content-padding} - 0.7rem + #{$navbar-height}) calc(#{$content-padding} - 0.7rem) 0\n      calc(#{$content-padding} - 0.7rem) !important; // - 0.8rem to reduce padding in small screen\n  }\n\n  // For Hidden navbar\n  html body.navbar-hidden .app-content {\n    padding: calc(#{$content-padding} - 0.7rem) calc(#{$content-padding} - 0.7rem) 0 calc(#{$content-padding} - 0.7rem) !important; // - 0.8rem to reduce padding in small screen\n  }\n}\n\n@include media-breakpoint-down(xs) {\n  .navbar-static,\n  .navbar-sticky {\n    .app-content {\n      .header-navbar {\n        .navbar-container {\n          padding-left: remSizing(1);\n          padding-right: remSizing(0.5);\n        }\n      }\n    }\n  }\n}\n\n// For Fullscreen IE\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  html.full-screen {\n    width: 100%;\n    .content.app-content {\n      height: 100%;\n      overflow: scroll;\n      overflow-x: hidden;\n    }\n  }\n}\n","@import '../../bootstrap-extended/variables';\n\n//  =========================================================================================\n// File Name: main-menu-mixin.scss\n// Description: Common mixin for menus, contain dark and light version scss.\n// ----------------------------------------------------------------------------------------\n// Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n// Author: PIXINVENT\n// Author URL: http://www.themeforest.net/user/pixinvent\n//==========================================================================================\n\n// Header navbar content and brand expanded & collapsed stats\n// spacing and sizing.\n// ================================================\n\n// Mixins for the menu and navbar position, margin and width change\n@mixin main-menu-width($menu-width) {\n  margin-left: $menu-width;\n}\n@mixin menu-navbar-width($menu-width) {\n  float: left;\n  width: $menu-width;\n}\n// Mixins for the menu show hide based on width\n@mixin vertical-menu-transform-show($transform-width) {\n  transform: translate3d($transform-width, 0, 0);\n  backface-visibility: hidden;\n  perspective: 1000;\n}\n@mixin vertical-menu-transform-hide() {\n  transform: translate3d(0, 0, 0);\n}\n\n@mixin menu-duotone-icon($opacity) {\n  --fa-primary-color: #{$white};\n  --fa-secondary-color: #{$white};\n  --fa-secondary-opacity: #{$opacity};\n  font-size: 1.25em;\n}\n\n// Used for apps\n@mixin content-area-wrapper-height(\n  $contentPadding: remSizing(0),\n  $navbarHeight: remSizing(0),\n  $footerHeight: remSizing(0),\n  $floatingNavMargin: remSizing(0),\n  $horizontalMenuHeight: remSizing(0),\n  $spacingSides: 1,\n  $horizontalLayout: false\n) {\n  height: calc(\n    100vh - calc(\n        calc(#{$contentPadding} * #{$spacingSides}) + #{$navbarHeight} + #{$footerHeight} + #{$floatingNavMargin} +\n          #{$horizontalMenuHeight}\n      )\n  );\n  height: calc(\n    var(--vh, 1vh) *\n      100 - calc(\n        calc(#{$contentPadding} * #{$spacingSides}) + #{$navbarHeight} + #{$footerHeight} + #{$floatingNavMargin} +\n          #{$horizontalMenuHeight}\n      )\n  );\n  // responsive size height\n  @if $horizontalLayout {\n    @include media-breakpoint-down(lg) {\n      height: calc(\n        100vh - calc(calc(calc(#{$contentPadding} - 0.7rem) * #{$spacingSides}) + #{$navbarHeight} + #{$footerHeight})\n      );\n      height: calc(\n        var(--vh, 1vh) *\n          100 - calc(calc(calc(#{$contentPadding} - 0.7rem) * #{$spacingSides}) + #{$navbarHeight} + #{$footerHeight})\n      );\n    }\n  } @else {\n    @include media-breakpoint-down(xs) {\n      height: calc(\n        100vh - calc(\n            calc(calc(#{$contentPadding} * #{$spacingSides}) - calc(0.7rem * #{$spacingSides})) + #{$navbarHeight} +\n              #{$footerHeight} + #{$floatingNavMargin} + #{$horizontalMenuHeight}\n          )\n      );\n      height: calc(\n        var(--vh, 1vh) *\n          100 - calc(\n            calc(calc(#{$contentPadding} * #{$spacingSides}) - calc(0.7rem * #{$spacingSides})) + #{$navbarHeight} +\n              #{$footerHeight} + #{$floatingNavMargin} + #{$horizontalMenuHeight}\n          )\n      );\n    }\n  }\n}\n\n// Light & Dark menu mixin\n// $theme-color : Menu text color\n// $theme-bg    : Menu background color\n// ================================================\n@mixin menu-theme($theme-color, $theme-bg) {\n  $main-menu-top-open-color: darken($theme-color, 10%);\n  $main-menu-top-open-hover-bg: darken($theme-bg, 6%);\n  $main-menu-top-open-head-bg: darken($theme-bg, 4%);\n\n  $main-menu-top-active-head-bg: darken($theme-bg, 4%); //$primary\n\n  $main-menu-sub-color: $theme-color;\n  $main-menu-sub-hover-color: lighten($theme-color, 4%);\n\n  $main-menu-sub-open-color: $theme-color;\n\n  // color: $theme-color;\n  // background: $theme-bg;\n}\n","/*=========================================================================================\n    File Name: sidebar.scss\n    Description: content sidebar specific scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n// Sidebar base\n// ------------------------------\n\n// Base\n.sidebar {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  // For desktop only\n  @include media-breakpoint-up(lg) {\n    vertical-align: top;\n  }\n}\n.sidebar-fixed {\n  position: fixed;\n  height: 100%;\n  overflow: scroll;\n}\n\n.sidenav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120vh;\n  background-color: rgba($black, 0.5);\n  z-index: 997;\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.5s ease;\n  &.show {\n    opacity: 1;\n    visibility: visible;\n    transition: all 0.5s ease;\n  }\n}\n\n.drag-target {\n  height: 100%;\n  width: 40px;\n  position: fixed;\n  top: 0;\n  left: -10px;\n  z-index: 1036;\n}\n\n.sidebar-detached {\n  .sidebar {\n    width: $sidebar-width;\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .sidebar-left {\n    float: left;\n  }\n  .sidebar-right {\n    float: right;\n  }\n}\n\n@include media-breakpoint-down(md) {\n  .sidebar-detached {\n    .sidebar {\n      width: 100%;\n    }\n  }\n}\n","@import '../../bootstrap-extended/variables';\n\n// ================================================================================================\n//     File Name: Footer.scss\n//     Description: *  Main footer styles.\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Stick footer to the bottom of the page\nfooter {\n  &.footer {\n    padding: remSizing(0.8) $content-padding;\n    min-height: $footer-height;\n    transition: 300ms ease all;\n\n    // heart icon scss\n    span {\n      i,\n      svg {\n        height: remSizing(1.51);\n        width: remSizing(1.51);\n        font-size: remSizing(1.51);\n        margin-left: remSizing(0.5);\n        color: $danger;\n      }\n    }\n    .scroll-top {\n      padding: remSizing(0.81) remSizing(0.83);\n    }\n  }\n\n  //shadow & border options\n  &.footer-shadow {\n    box-shadow: $box-shadow;\n  }\n  &.footer-border {\n    border-top: 1px solid $border-color;\n  }\n}\n\n// Fixed Footer\n.footer-fixed {\n  footer {\n    position: fixed !important;\n    z-index: 1030;\n    right: 0;\n    left: 0;\n    bottom: 0;\n\n    // Footer Light\n    &.footer-light {\n      background: $white;\n      box-shadow: $box-shadow;\n    }\n    // Footer Dark\n    &.footer-dark {\n      background: $gray-600;\n      color: $white;\n    }\n  }\n}\n\n//! Fix: If footer is hidden add padding fix to avail card margin bottom\n.footer-hidden {\n  .app-content {\n    padding-bottom: 0.1px !important;\n  }\n}\n\n// scroll to Top Footer Button\n.scroll-top {\n  position: fixed;\n  bottom: 5%;\n  right: 30px;\n  display: none;\n  z-index: 99;\n}\n","@import '../../bootstrap-extended/variables';\n\n/*=========================================================================================\n    File Name: navigation.scss\n    Description: Common mixin for menus, contain dark and light version scss.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n// Import first main menu mixin\n@import '../mixins/main-menu-mixin';\n\n// Main Navigation\n\n@include media-breakpoint-up(md) {\n  .drag-target {\n    z-index: 0;\n  }\n}\n","@import '../bootstrap-extended//variables';\n// =========================================================================================\n//   File Name: avatar.scss\n//   Description: Avatar style.\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: Avatar\n// ========================================================================\n\n// avatar\n\n.mf-avatar {\n  position: relative;\n  height: $space-10;\n  width: $space-10;\n  padding: $space-2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Roboto', sans-serif;\n  font-size: $space-6;\n  background-color: #7b67f9;\n  color: $white;\n  border-radius: 999px;\n  overflow: hidden;\n\n  img {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    height: 100%;\n    width: auto;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.avatar {\n  white-space: nowrap;\n  background-color: $avatar-bg;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n  color: $white;\n  display: inline-flex;\n  font-size: remSizing(1);\n  text-align: center;\n  vertical-align: middle;\n  font-weight: 600;\n\n  // avatar content\n  .avatar-content {\n    width: $avatar-size;\n    height: $avatar-size;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    font-size: remSizing(0.857);\n    .avatar-icon {\n      height: remSizing(1);\n      width: remSizing(1);\n    }\n  }\n  [class*='avatar-status-'] {\n    border-radius: 50%;\n    width: $avatar-status-size;\n    height: $avatar-status-size;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    border: 1px solid $white;\n    &.avatar-status-lg,\n    &.avatar-status-xl {\n      width: $avatar-status-size-lg;\n      height: $avatar-status-size-lg;\n      border-width: 2px;\n    }\n  }\n  .avatar-status-online {\n    background-color: $success;\n  }\n  .avatar-status-busy {\n    background-color: $danger;\n  }\n  .avatar-status-away {\n    background-color: $warning;\n  }\n  .avatar-status-offline {\n    background-color: $secondary;\n  }\n\n  // avatar label with basic size\n  // using in FAQ & other pages\n  &.avatar-tag {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 42px;\n    width: 42px;\n    border-radius: $border-radius;\n  }\n\n  // avatar img\n  img {\n    border-radius: 50%;\n  }\n\n  // Size Modifier\n  // ========================================================================\n\n  &.avatar-xl {\n    font-size: remSizing(1.5);\n    img {\n      width: $avatar-size-xl;\n      height: $avatar-size-xl;\n    }\n    .avatar-content {\n      height: $avatar-size-xl;\n      width: $avatar-size-xl;\n      font-size: remSizing(2.57);\n      .avatar-icon,\n      i,\n      svg {\n        height: remSizing(3);\n        width: remSizing(3);\n        font-size: remSizing(3);\n      }\n    }\n    [class*='avatar-status-'] {\n      right: 3px;\n      bottom: 0;\n    }\n  }\n  &.avatar-lg {\n    font-size: remSizing(1.2);\n    img {\n      width: $avatar-size-lg;\n      height: $avatar-size-lg;\n    }\n    .avatar-content {\n      width: $avatar-size-lg;\n      height: $avatar-size-lg;\n      font-size: remSizing(1.714);\n      .avatar-icon,\n      i,\n      svg {\n        height: remSizing(2);\n        width: remSizing(2);\n        font-size: remSizing(2);\n      }\n    }\n    [class*='avatar-status-'] {\n      right: 3px;\n      bottom: 1px;\n    }\n  }\n\n  &.avatar-sm {\n    .avatar-content {\n      width: $avatar-size-sm;\n      height: $avatar-size-sm;\n      .avatar-icon,\n      i,\n      svg {\n        height: remSizing(1);\n        width: remSizing(1);\n        font-size: remSizing(1);\n      }\n    }\n    img {\n      width: $avatar-size-sm;\n      height: $avatar-size-sm;\n    }\n    [class*='avatar-status-'] {\n      right: -3px;\n      bottom: -2px;\n    }\n  }\n}\n\n// Avatar Group SCSS\n.avatar-group {\n  display: flex;\n  justify-content: flex-start;\n  .avatar {\n    transition: all 0.25s ease;\n    img,\n    .avatar-content {\n      box-shadow:\n        0 0 0 2px $avatar-group-border,\n        inset 0 0 0 1px rgba($black, 0.07);\n    }\n    .avatar-content {\n    }\n    &:hover {\n      transition: all 0.25s ease;\n    }\n    &.pull-up:hover {\n      transform: translateY(-4px) scale(1.07);\n    }\n  }\n  // Avatar Group Sizings\n  .avatar:not(:first-child) {\n    margin-left: remSizing(-0.55);\n  }\n  .avatar-sm:not(:first-child) {\n    margin-left: remSizing(-0.4);\n  }\n  .avatar-lg:not(:first-child) {\n    margin-left: remSizing(-1);\n  }\n  .avatar-xl:not(:first-child) {\n    margin-left: remSizing(-1.5);\n  }\n}\n","@import '../bootstrap-extended//variables';\n\n/*=========================================================================================\n\tFile Name: search.scss\n\tDescription: Search  functionality.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n.navbar-container {\n  .search-input {\n    width: 0;\n    float: left;\n    display: none;\n\n    // select\n    input {\n      width: 0;\n      border: none;\n      background: none;\n      transition: all 0.2s ease-out;\n      line-height: 16px;\n      padding: remSizing(1.6) remSizing(3.6);\n    }\n\n    &.open {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1000;\n      width: 100%;\n      display: block;\n      background: $white;\n      border-radius: remSizing(0.5);\n\n      .search-input-close,\n      .search-input-icon {\n        display: block;\n      }\n\n      // select\n\n      input {\n        width: 100%;\n        outline: none;\n        background: none;\n        height: auto;\n        box-shadow: none;\n        transition: all 0.3s ease-out;\n      }\n    }\n\n    .search-list {\n      max-height: 450px;\n      height: auto;\n      position: absolute;\n      top: 100%;\n      left: 0;\n      background: $white;\n      width: 100%;\n      margin-top: remSizing(0.5);\n      padding-left: 0;\n      border-radius: $border-radius;\n      display: none;\n      @media only screen and (min-device-width: 320px) and (max-device-width: 875px) and (orientation: landscape) {\n        max-height: 250px;\n      }\n\n      &.search-list-bookmark {\n        height: auto !important;\n        i,\n        svg {\n          font-size: remSizing(1.2);\n          height: remSizing(1.2);\n          width: remSizing(1.2);\n        }\n      }\n\n      &.show {\n        display: block;\n        min-height: remSizing(3);\n      }\n\n      li {\n        a {\n          padding: remSizing(0.9) remSizing(1);\n          color: $body-color;\n\n          i,\n          svg[class*='feather feather-'] {\n            height: remSizing(1.25);\n            width: remSizing(1.25);\n            font-size: remSizing(1.25);\n          }\n        }\n\n        &:first-child {\n          border-top-left-radius: $border-radius;\n          border-top-right-radius: $border-radius;\n        }\n\n        &:last-child {\n          border-bottom-left-radius: $border-radius;\n          border-bottom-right-radius: $border-radius;\n        }\n\n        &.auto-suggestion {\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n          &:hover,\n          &.current_item {\n            background-color: $body-bg;\n          }\n        }\n      }\n    }\n\n    .search-input-icon {\n      z-index: 2;\n      display: none;\n      position: absolute;\n      left: remSizing(1.5);\n      top: 32%;\n      cursor: pointer;\n\n      i,\n      svg {\n        height: remSizing(1.25);\n        width: remSizing(1.25);\n        font-size: remSizing(1.25);\n      }\n    }\n\n    .search-input-close {\n      z-index: 1;\n      display: none;\n      position: absolute;\n      right: remSizing(2);\n      top: 32%;\n      cursor: pointer;\n\n      i,\n      svg {\n        height: remSizing(1.25);\n        width: remSizing(1.25);\n        font-size: remSizing(1.25);\n      }\n    }\n  }\n\n  .bookmark-input {\n    position: absolute;\n    top: 102%;\n    width: 25%;\n    display: none;\n    background: $white;\n    border-radius: $border-radius;\n    box-shadow:\n      0 15px 30px 0 rgba($black, 0.11),\n      0 5px 15px 0 rgba($black, 0.08);\n\n    &.show {\n      display: block;\n    }\n\n    .bookmark-input-icon {\n      position: absolute;\n      z-index: 1;\n      top: 20px;\n      left: 24px;\n    }\n\n    input {\n      padding: remSizing(0.7) remSizing(0.7) remSizing(0.7) remSizing(2.5);\n      margin: 12px;\n      width: calc(100% - 24px); // Reduce width by 10*2\n      background: $white;\n      border: 1px solid rgba($black, 0.2);\n\n      &:focus {\n        border: 1px solid $primary;\n      }\n    }\n\n    .search-list {\n      position: relative; // To consider outer div width\n    }\n  }\n\n  .bookmark-icon {\n    cursor: pointer;\n  }\n\n  .dropdown.bookmark-dropdown {\n    padding: remSizing(1.4) remSizing(0.5) remSizing(1.35);\n\n    .dropdown-toggle:after {\n      display: none;\n    }\n  }\n\n  .search-data-title {\n    line-height: remSizing(1.25);\n  }\n}\n\n.navbar-dark {\n  .search-input {\n    .input {\n      color: #f5f7fa;\n      border-radius: remSizing(0.5);\n    }\n\n    &.open {\n      .input {\n        color: #f5f7fa;\n        border: 1px solid #f5f7fa;\n      }\n    }\n  }\n}\n\n// navbar-sticky\n.navbar-static {\n  .navbar-container {\n    .search-input {\n      &.open {\n        border-radius: 0;\n      }\n    }\n  }\n}\n","$bs-height-base: ($line-height-base + $input-btn-padding-y * 2) !default;\n$bs-height-lg: (floor($font-size-lg * $line-height-base) + $input-btn-padding-y-lg * 2) !default;\n$bs-height-sm: (floor($font-size-sm * 1.5) + $input-btn-padding-y-lg * 2) !default;\n$bs-height-xs: (floor($font-size-sm * 0.2) + $input-btn-padding-y-lg) !default;\n\n.btn-social {\n  position: relative;\n  padding-left: ($bs-height-base + $input-btn-padding-x);\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  > :first-child {\n    position: absolute;\n    left: 0;\n    top: 2px;\n    bottom: 0;\n    width: $bs-height-base;\n    line-height: ($bs-height-base - 0.25);\n    font-size: $font-size-base;\n    text-align: center;\n    border-right: 1px solid rgba($black, 0.2);\n  }\n}\n\n.btn-social-icon {\n  @extend .btn-social;\n  height: ($bs-height-base);\n  width: ($bs-height-base);\n  padding: 0;\n  > :first-child {\n    border: none;\n    text-align: center;\n    width: 100% !important;\n  }\n}\n\n// Social button Mixin\n@mixin btn-social($color-bg, $color: #fff, $hover: $color-bg, $border-hover: $color-bg) {\n  background-color: $color-bg;\n  @include button-variant($color-bg, $color, $hover, $border-hover);\n  color: $white !important;\n  border: none;\n}\n\n// Social Outline Button Mixin\n@mixin btn-social-outline($color-bg) {\n  border: 1px solid $color-bg !important;\n  color: $color-bg;\n}\n\n// Social Outline Button Hover Mixin\n@mixin btn-hover-outline($color-bg) {\n  color: darken($color-bg, 20%);\n  border: 1px solid darken($color-bg, 20%) !important;\n}\n\n// Social button\n.btn-adn {\n  @include btn-social(#d87a68);\n}\n.btn-bitbucket {\n  @include btn-social(#205081);\n}\n.btn-dropbox {\n  @include btn-social(#1087dd);\n}\n.btn-facebook {\n  @include btn-social(#3b5998);\n}\n.btn-flickr {\n  @include btn-social(#ff0084);\n}\n.btn-foursquare {\n  @include btn-social(#f94877);\n}\n.btn-github {\n  @include btn-social(#444444);\n}\n.btn-google {\n  @include btn-social(#dd4b39);\n}\n.btn-instagram {\n  @include btn-social(#3f729b);\n}\n.btn-linkedin {\n  @include btn-social(#007bb6);\n}\n.btn-microsoft {\n  @include btn-social(#2672ec);\n}\n.btn-odnoklassniki {\n  @include btn-social(#f4731c);\n}\n.btn-openid {\n  @include btn-social(#f7931e);\n}\n.btn-pinterest {\n  @include btn-social(#cb2027);\n}\n.btn-reddit {\n  @include btn-social(#eff7ff, #000, #000, #000);\n}\n.btn-soundcloud {\n  @include btn-social(#ff5500);\n}\n.btn-tumblr {\n  @include btn-social(#2c4762);\n}\n.btn-twitter {\n  @include btn-social(#55acee, #fff);\n}\n.btn-vimeo {\n  @include btn-social(#1ab7ea);\n}\n.btn-vk {\n  @include btn-social(#587ea3);\n}\n.btn-yahoo {\n  @include btn-social(#720e9e);\n}\n\n// Social Outline button\n.btn-outline-adn {\n  @include btn-social-outline(#d87a68);\n}\n.btn-outline-bitbucket {\n  @include btn-social-outline(#205081);\n}\n.btn-outline-dropbox {\n  @include btn-social-outline(#1087dd);\n}\n.btn-outline-facebook {\n  @include btn-social-outline(#3b5998);\n}\n.btn-outline-flickr {\n  @include btn-social-outline(#ff0084);\n}\n.btn-outline-foursquare {\n  @include btn-social-outline(#f94877);\n}\n.btn-outline-github {\n  @include btn-social-outline(#444444);\n}\n.btn-outline-google {\n  @include btn-social-outline(#dd4b39);\n}\n.btn-outline-instagram {\n  @include btn-social-outline(#3f729b);\n}\n.btn-outline-linkedin {\n  @include btn-social-outline(#007bb6);\n}\n.btn-outline-microsoft {\n  @include btn-social-outline(#2672ec);\n}\n.btn-outline-odnoklassniki {\n  @include btn-social-outline(#f4731c);\n}\n.btn-outline-openid {\n  @include btn-social-outline(#f7931e);\n}\n.btn-outline-pinterest {\n  @include btn-social-outline(#cb2027);\n}\n.btn-outline-reddit {\n  @include btn-social-outline(#ff4500);\n}\n.btn-outline-soundcloud {\n  @include btn-social-outline(#ff5500);\n}\n.btn-outline-tumblr {\n  @include btn-social-outline(#2c4762);\n}\n.btn-outline-twitter {\n  @include btn-social-outline(#55acee);\n}\n.btn-outline-vimeo {\n  @include btn-social-outline(#1ab7ea);\n}\n.btn-outline-vk {\n  @include btn-social-outline(#587ea3);\n}\n.btn-outline-yahoo {\n  @include btn-social-outline(#720e9e);\n}\n\n// Social Outline hover button\n.btn-outline-adn:hover {\n  @include btn-hover-outline(#d87a68);\n}\n.btn-outline-bitbucket:hover {\n  @include btn-hover-outline(#205081);\n}\n.btn-outline-dropbox:hover {\n  @include btn-hover-outline(#1087dd);\n}\n.btn-outline-facebook:hover {\n  @include btn-hover-outline(#3b5998);\n}\n.btn-outline-flickr:hover {\n  @include btn-hover-outline(#ff0084);\n}\n.btn-outline-foursquare:hover {\n  @include btn-hover-outline(#f94877);\n}\n.btn-outline-github:hover {\n  @include btn-hover-outline(#444444);\n}\n.btn-outline-google:hover {\n  @include btn-hover-outline(#dd4b39);\n}\n.btn-outline-instagram:hover {\n  @include btn-hover-outline(#3f729b);\n}\n.btn-outline-linkedin:hover {\n  @include btn-hover-outline(#007bb6);\n}\n.btn-outline-microsoft:hover {\n  @include btn-hover-outline(#2672ec);\n}\n.btn-outline-odnoklassniki:hover {\n  @include btn-hover-outline(#f4731c);\n}\n.btn-outline-openid:hover {\n  @include btn-hover-outline(#f7931e);\n}\n.btn-outline-pinterest:hover {\n  @include btn-hover-outline(#cb2027);\n}\n.btn-outline-reddit:hover {\n  @include btn-hover-outline(#ff4500);\n}\n.btn-outline-soundcloud:hover {\n  @include btn-hover-outline(#ff5500);\n}\n.btn-outline-tumblr:hover {\n  @include btn-hover-outline(#2c4762);\n}\n.btn-outline-twitter:hover {\n  @include btn-hover-outline(#55acee);\n}\n.btn-outline-vimeo:hover {\n  @include btn-hover-outline(#1ab7ea);\n}\n.btn-outline-vk:hover {\n  @include btn-hover-outline(#587ea3);\n}\n.btn-outline-yahoo:hover {\n  @include btn-hover-outline(#720e9e);\n}\n\n// Social Background colors\n.bg-adn {\n  background-color: #d87a68;\n}\n.bg-bitbucket {\n  background-color: #205081;\n}\n.bg-dropbox {\n  background-color: #1087dd;\n}\n.bg-facebook {\n  background-color: #3b5998;\n}\n.bg-flickr {\n  background-color: #ff0084;\n}\n.bg-foursquare {\n  background-color: #f94877;\n}\n.bg-github {\n  background-color: #444444;\n}\n.bg-google {\n  background-color: #dd4b39;\n}\n.bg-instagram {\n  background-color: #3f729b;\n}\n.bg-linkedin {\n  background-color: #007bb6;\n}\n.bg-microsoft {\n  background-color: #2672ec;\n}\n.bg-odnoklassniki {\n  background-color: #f4731c;\n}\n.bg-openid {\n  background-color: #f7931e;\n}\n.bg-pinterest {\n  background-color: #cb2027;\n}\n.bg-reddit {\n  background-color: #ff4500;\n}\n.bg-soundcloud {\n  background-color: #ff5500;\n}\n.bg-tumblr {\n  background-color: #2c4762;\n}\n.bg-twitter {\n  background-color: #55acee;\n}\n.bg-vimeo {\n  background-color: #1ab7ea;\n}\n.bg-vk {\n  background-color: #587ea3;\n}\n.bg-yahoo {\n  background-color: #720e9e;\n}\n","@import '../bootstrap-extended//variables';\n\n/*=========================================================================================\n    File Name: demo.scss\n    Description: CSS used for demo purpose only. Remove this css from your project.\n    ----------------------------------------------------------------------------------------\n    Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n    Author: PIXINVENT\n    Author URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n// Demo content spacing\n.demo-inline-spacing {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n  & > * {\n    margin-right: remSizing(1.5);\n    margin-top: remSizing(1.5);\n  }\n}\n\n// Demo content spacing\n.demo-vertical-spacing > * {\n  margin: 0;\n  margin-bottom: remSizing(1.5);\n  &:last-child {\n    margin: 0;\n  }\n}\n\n.demo-spacing-0 > *:last-child {\n  margin: 0;\n}\n\n// using in icon pages\n.icon-wrapper {\n  .feather {\n    height: 24px;\n    width: 24px;\n  }\n}\n\n.scroll-example {\n  padding: remSizing(0.5);\n  position: relative;\n  border: 2px solid darken($body-bg, 10%);\n  overflow: auto;\n\n  .horz-scroll-content {\n    width: 1200px;\n  }\n}\n\n.browser {\n  background: #e0e0e0;\n  border: 4px solid #e0e0e0;\n  width: 100%;\n  height: remSizing(12);\n  padding-top: 20px;\n  margin: 0 0 10px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.browser iframe {\n  border: 0;\n  background: #fff;\n  height: 100%;\n  width: 100%;\n}\n\n.loader-wrapper {\n  height: 8em;\n}\n\n.maintenance-icon {\n  font-size: remSizing(4);\n}\n\n.animationIcon {\n  right: 30px;\n  bottom: 10px;\n}\n\n.dark-layout {\n  #breadcrumb-alignment {\n    .breadcrumb-wrapper {\n      // box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);\n    }\n  }\n}\n\n// Buy now\n.buy-now {\n  position: fixed;\n  bottom: 5%;\n  right: 79px;\n  z-index: 1031;\n  .btn {\n    box-shadow: 0 1px 20px 1px $danger !important;\n    &:hover {\n      box-shadow: none !important;\n    }\n  }\n}\n","@import '../bootstrap-extended/variables';\n\n/*=========================================================================================\n\tFile Name: customizer.scss\n\tDescription: CSS used for demo purpose only. Remove this css from your project.\n\t----------------------------------------------------------------------------------------\n\tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n==========================================================================================*/\n\n.customizer {\n  width: 400px;\n  right: -400px;\n  padding: 0;\n  background-color: $white;\n  z-index: 1051;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  transition: right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);\n  backface-visibility: hidden;\n  border-left: 1px solid rgba($black, 0.05);\n\n  &.open {\n    box-shadow:\n      0 15px 30px 0 rgba($black, 0.11),\n      0 5px 15px 0 rgba($black, 0.08);\n    right: 0;\n  }\n\n  // customizer content height\n  .customizer-content {\n    position: relative;\n    height: 100%;\n  }\n\n  //customizer close button\n  .customizer-close {\n    position: absolute;\n    right: remSizing(0.6);\n    top: remSizing(0.6);\n    padding: 7px;\n    width: auto;\n    z-index: 10;\n    color: $headings-color;\n    i,\n    svg {\n      font-size: remSizing(1.5);\n      height: remSizing(1.5);\n      width: remSizing(1.5);\n    }\n  }\n\n  // customizer toggle icon\n  .customizer-toggle {\n    background: $primary;\n    color: $white !important;\n    display: block;\n    box-shadow: -3px 0px 8px rgba($black, 0.1);\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n    position: absolute;\n    top: 50%;\n    width: 38px;\n    height: 38px;\n    left: -39px;\n    text-align: center;\n    line-height: 40px;\n    cursor: pointer;\n  }\n\n  // theme color box styles\n  .color-box {\n    height: 24px;\n    width: 24px;\n    margin: remSizing(0.5);\n    border-radius: remSizing(0.5);\n    cursor: pointer;\n    position: relative;\n    &.selected {\n      &:after {\n        content: '';\n        border: 1px solid $primary;\n        height: 30px;\n        width: 30px;\n        top: -3px;\n        left: -3px;\n        position: absolute;\n        border-radius: remSizing(0.5);\n      }\n      &.border {\n        &:after {\n          top: -4px;\n          left: -4px;\n        }\n      }\n    }\n  }\n}\n","@import '../bootstrap-extended/variables';\n// Divider\n\n.divider {\n  display: block;\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  margin: remSizing(1) 0;\n\n  // divider text display prop\n\n  .divider-text {\n    position: relative;\n    display: inline-block;\n    font-size: remSizing(0.9375);\n    padding: 0 remSizing(1);\n\n    // divider icon font size\n\n    i,\n    svg {\n      height: remSizing(1);\n      width: remSizing(1);\n      font-size: remSizing(1);\n    }\n\n    // divider border\n\n    &:before,\n    &:after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      width: 9999px;\n      border-top: 1px solid $border-color;\n    }\n\n    // divider spacing\n    &:before {\n      right: 100%;\n    }\n\n    &:after {\n      left: 100%;\n    }\n  }\n\n  // divider positions config\n\n  &.divider-left {\n    .divider-text {\n      float: left;\n      padding-left: 0;\n      &:before {\n        display: none;\n      }\n    }\n  }\n  &.divider-left-center {\n    .divider-text {\n      left: -25%;\n    }\n  }\n\n  &.divider-right {\n    .divider-text {\n      float: right;\n      padding-right: 0;\n      &:after {\n        display: none;\n      }\n    }\n  }\n  &.divider-right-center {\n    .divider-text {\n      right: -25%;\n    }\n  }\n\n  // divider styles\n\n  &.divider-dotted {\n    .divider-text {\n      &:before,\n      &:after {\n        border-style: dotted;\n        border-width: 1px;\n        border-top-width: 0;\n        border-color: $border-color;\n      }\n    }\n  }\n  &.divider-dashed {\n    .divider-text {\n      &:before,\n      &:after {\n        border-style: dashed;\n        border-width: 1px;\n        border-top-width: 0;\n        border-color: $border-color;\n      }\n    }\n  }\n}\n","@import '../bootstrap-extended//variables';\n\n// =========================================================================================\n//   File Name: timeline.scss\n//   Description: Timeline style and now vertical timeline style\n//   ----------------------------------------------------------------------------------------\n//   Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//   Author: PIXINVENT\n//   Author URL: http://www.themeforest.net/user/pixinvent\n// ==========================================================================================\n\n// Component: Timeline and Vertical Timeline\n// ========================================================================\n\n.timeline {\n  padding: 0;\n  margin-bottom: 0;\n  margin-left: remSizing(1);\n  list-style: none;\n\n  // Timeline Item\n  .timeline-item {\n    position: relative;\n    padding-left: remSizing(2.5);\n    border-left: 1px solid $timeline-border-color;\n\n    &:not(:last-child) {\n      padding-bottom: remSizing(1.8);\n    }\n\n    // Timeline Point\n    .timeline-point {\n      position: absolute;\n      left: remSizing(-0.85);\n      top: 0;\n      z-index: 2;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: $timeline-point-size;\n      width: $timeline-point-size;\n      text-align: center;\n      border-radius: 50%;\n      border: 1px solid $timeline-point-indicator-color;\n      background-color: $white;\n\n      // Timeline Point Indicator\n      &.timeline-point-indicator {\n        left: remSizing(-0.412);\n        top: remSizing(0.07);\n        height: $timeline-point-indicator-size;\n        width: $timeline-point-indicator-size;\n        border: 0;\n        background-color: $timeline-point-indicator-color;\n\n        &:before {\n          content: '';\n          background: rgba($color: $timeline-point-indicator-color, $alpha: 0.12);\n          height: $timeline-point-indicator-wrapper-size;\n          width: $timeline-point-indicator-wrapper-size;\n          display: block;\n          position: absolute;\n          top: remSizing(-0.285);\n          left: remSizing(-0.285);\n          border-radius: 50%;\n        }\n      }\n\n      // Icons\n      i,\n      svg {\n        color: $timeline-point-indicator-color;\n        font-size: $timeline-item-icon-font-size;\n        vertical-align: baseline;\n      }\n    }\n\n    .timeline-event {\n      position: relative;\n      width: 100%;\n      min-height: $timeline-item-min-height;\n      // background-color: transparent;\n\n      .timeline-event-time {\n        font-size: $timeline-event-time-size;\n        color: $timeline-event-time-color;\n      }\n    }\n\n    &:last-of-type {\n      border-left-color: transparent !important;\n      &:after {\n        content: '';\n        position: absolute;\n        left: -1px;\n        bottom: 0;\n        width: 1px;\n        height: 100%;\n        background: linear-gradient($border-color, transparent);\n      }\n    }\n  }\n}\n\n// Vertical Timeline Component\n.with-border {\n  border-bottom: 2px solid #c8ced3;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n}\n\n.vertical-timeline-element-content {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n  margin-top: 45px;\n}\n\n.vertical-timeline-element-icon {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n}\n\n.vertical-timeline::before {\n  box-shadow: 1px 1px 12px #b9b9b9 !important;\n}\n\n.timeline-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.timeline-content {\n  position: relative;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.timeline-day-label {\n  position: absolute;\n  z-index: 2;\n}\n\n.timeline-card-header {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n}\n\n.timeline-card-content {\n  display: flex;\n  justify-content: space-between;\n}\n\n.timeline-card-left,\n.timeline-card-right {\n  flex-basis: 49.5%;\n  flex-grow: 1;\n  padding: 10px;\n}\n\n.timeline-card-divider {\n  width: 1px;\n  background-color: #ccc;\n  flex-shrink: 0;\n  margin-right: 10px;\n}\n\n.timeline-horizontal-rule {\n  border-width: 2px;\n  margin-left: 22px;\n  margin-bottom: 20px;\n}\n\n.timeline-toolbar {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  box-shadow: 1px 1px 12px #b9b9b9;\n  border-radius: 4px;\n  margin-top: 20px;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n\n.search-column {\n  flex: 1;\n  padding: 0 10px;\n}\n\n.search-container {\n  position: relative;\n  border: 1px solid #e8eaeb;\n  height: 36px;\n  border-radius: 2px;\n  margin: 20px;\n}\n\n.search-container:hover {\n  border: 1px solid #999;\n}\n\n.timeline-search-bar {\n  padding: 7px 9px 8px;\n  padding-left: 34px;\n  border: none;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.timeline-search-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #999;\n}\n\n.action-type-column {\n  flex: 1;\n  padding: 0 10px;\n}\n\n.action-type-column .control {\n  height: 36px !important;\n  box-sizing: border-box;\n}\n\n.action-type-column [role='button'] svg {\n  fill: #999 !important;\n}\n\n.date-range-column {\n  flex: 2;\n  padding: 0 0 0 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 36px;\n  flex-direction: row;\n  overflow: visible;\n}\n\n.dx-field-label.multiline-label {\n  padding: 13px 0px 0px 0px;\n  width: 28%;\n}\n\n.dx-field-value {\n  padding: 13px 0px 0px 0px;\n  width: 72%;\n}\n\n.button-column {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 0 10px;\n}\n\n.timeline-clear-filters-button {\n  margin-right: 20px;\n}\n\n@media (max-width: 1416px) {\n  .timeline-toolbar {\n    padding: 0 10px;\n  }\n  .search-column {\n    padding: 0;\n    flex: 2;\n  }\n  .action-type-column {\n    flex: 2;\n    padding: 0 5px;\n  }\n  .date-range-column {\n    flex: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 36px;\n    flex-direction: row;\n    overflow: visible;\n  }\n\n  .dx-field-label.multiline-label {\n    padding: 8px 0px 0px 0px;\n    width: 28%;\n    flex: 2;\n  }\n\n  .dx-field-value {\n    padding: 8px 0px 0px 0px;\n    width: 72%;\n    flex: 2;\n  }\n\n  .button-column {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .timeline-toolbar {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n  .search-container {\n    margin: 20px;\n  }\n  .action-type-column {\n    margin: 20px 14px 20px 14px;\n  }\n  .dx-field {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 20px 24px 20px 20px;\n  }\n  .dx-field-label.multiline-label {\n    width: 100%;\n  }\n  .dx-field-value {\n    width: 100%;\n  }\n  .timeline-clear-filters-button {\n    margin: 20px 24px 20px 20px;\n  }\n}\n\n.timeline-log {\n  position: relative;\n}\n\n.timeline-sticky-button {\n  position: sticky;\n  top: 20 px;\n  z-index: 2;\n}\n\n.timeline-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  margin-bottom: 35px;\n}\n\n.timeline-perPageOptions {\n  display: flex;\n  gap: 10px;\n}\n\n.timeline-perPageOptions span {\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.3s;\n}\n\n.timeline-perPageOptions span.active,\n.timeline-perPageOptions span:hover {\n  background-color: #ddd;\n  border-radius: 2px;\n}\n\n.timeline-pager-info {\n  font-size: 14px;\n  color: #666;\n}\n\n.timeline-pager {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.timeline-pager button {\n  padding: 5px 10px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  transition: background-color 0.3s;\n}\n\n.timeline-pager button:hover,\n.timeline-pager button.active {\n  background-color: #ddd;\n  border-radius: 2px;\n}\n\n.timeline-pager button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n// Dark Layout\n.dark-layout .timeline-card-header h2 {\n  color: #d0d2d6;\n}\n\n.dark-layout .timeline-pager button {\n  color: #d0d2d6;\n  background-color: #555;\n}\n\n.dark-layout .timeline-perPageOptions span.active {\n  color: #d0d2d6;\n  background-color: #555;\n}\n","// config\n$debug: false;\n\n// declare breakpoints\n$usn-x-small: 0px;\n$usn-small: 544px;\n$usn-medium: 768px;\n$usn-large: 992px;\n$usn-x-large: 1200px;\n\n// create sass list to pass media query data\n// if a breakpoint name changes, remember to\n// update it in the list below as well\n$mq-sync:\n  xs $usn-x-small,\n  sm $usn-small,\n  md $usn-medium,\n  lg $usn-large,\n  xl $usn-x-large;\n\n// build each media query for js ingestion\n@each $mq in $mq-sync {\n  @media screen and (min-width: nth($mq, 2)) {\n    head {\n      font-family: '#{nth($mq, 1)} #{nth($mq, 2)}';\n    }\n    body:after {\n      content: '#{nth($mq, 1)} - min-width: #{nth($mq, 2)}';\n    }\n  }\n}\n\nhead {\n  // set clear on head to show Unison is set up correctly\n  clear: both;\n  // store hash of all breakpoints\n  title {\n    font-family: '#{$mq-sync}';\n  }\n}\n\n// debug styles to see breakpoint info\nbody:after {\n  display: none;\n}\n\n@if $debug == true {\n  body:after {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: #000;\n    background-color: rgba($black, 0.8);\n    text-align: center;\n    color: #fff;\n    padding: 10px;\n    z-index: 1000;\n    font-size: 12px;\n    font-family: sans-serif;\n  }\n}\n\n// hide elements for conditional loading\n// only used for responsive comments plugin\n*[data-usn-if] {\n  display: none;\n}\n","@import '../../../bootstrap-extended/variables';\n\n// select-2 Theme\n.vertical-timeline-element-icon svg {\n  display: block !important;\n}\n\n.select2-container {\n  width: 100% !important;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  box-sizing: border-box;\n}\n.select2-container--classic,\n.select2-container--default {\n  &:focus {\n    outline: none;\n  }\n\n  .select2-selection__choice {\n    font-size: remSizing(0.9);\n    margin-top: 6px !important;\n  }\n  // single select\n  .select2-selection--single {\n    min-height: remSizing(2.714);\n    padding: 5px;\n    border: 1px solid $input-border-color;\n    // Border color on focus\n    &:focus {\n      outline: 0;\n      border-color: $primary !important;\n      box-shadow: $input-focus-box-shadow !important;\n    }\n\n    // Select with icons scss\n    .select2-selection__rendered {\n      i,\n      svg {\n        font-size: remSizing(1.15);\n        height: remSizing(1.15);\n        width: remSizing(1.15);\n        margin-right: remSizing(0.5);\n      }\n    }\n    // dropdown arrow height\n    .select2-selection__arrow {\n      b {\n        background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $input-border-color), '#', '%23'));\n        background-size:\n          18px 14px,\n          18px 14px;\n        background-repeat: no-repeat;\n        height: remSizing(1);\n        padding-right: remSizing(1.5);\n        margin-left: 0;\n        margin-top: 0;\n        left: -8px;\n        border-style: none;\n      }\n    }\n  }\n  // when select container open - scss\n  &.select2-container--open {\n    box-shadow: $dropdown-box-shadow;\n    .select2-selection--single {\n      border-color: $primary !important;\n      outline: 0;\n    }\n  }\n\n  // select container - focus\n  &.select2-container--focus {\n    outline: 0;\n    .select2-selection--multiple {\n      border-color: $primary !important;\n      outline: 0;\n    }\n  }\n\n  // Select2 Search Dropdown\n  .select2-dropdown {\n    border-color: $input-border-color;\n  }\n  .select2-search--dropdown {\n    padding: remSizing(0.5);\n    .select2-search__field {\n      outline: none !important;\n      border-radius: $input-border-radius;\n      border-color: $input-border-color;\n      padding: $input-padding-y $input-padding-x;\n    }\n  }\n\n  // multiple select scss\n  .select2-selection--multiple {\n    min-height: 38px !important;\n    border: 1px solid $input-border-color;\n    &:focus {\n      outline: 0;\n      border-color: $primary !important;\n      box-shadow: $input-focus-box-shadow !important;\n    }\n    // selected items bg color for multiple selection\n    .select2-selection__choice {\n      background-color: $primary !important;\n      border-color: $primary !important;\n      color: $white;\n      padding: 2px 5px;\n    }\n    // font -size for selected options\n    .select2-selection__rendered {\n      padding: 0 6px;\n      li {\n        .select2-search__field {\n          margin-top: 7px;\n        }\n      }\n    }\n    .select2-selection__choice__remove {\n      // color: $white !important;\n      float: right;\n      margin-left: remSizing(0.7);\n      margin-right: remSizing(0.5);\n      font-size: 0px;\n      display: inline-block;\n      position: relative;\n      line-height: remSizing(1);\n      &:before {\n        content: '';\n        background-image: url(str-replace(str-replace($remove, 'currentColor', $white), '#', '%23'));\n        background-size: remSizing(0.85);\n        height: remSizing(0.85);\n        width: remSizing(0.85);\n        position: absolute;\n        top: 22%;\n        left: -4px;\n      }\n    }\n    // select dropdown menu with icons\n    i,\n    svg {\n      position: relative;\n      top: 1px;\n      margin-right: remSizing(0.5);\n      height: remSizing(1.15);\n      width: remSizing(1.15);\n      font-size: remSizing(1.15);\n      padding-left: 1px;\n    }\n  }\n\n  // Select2 group alignment\n  .select2-results__group {\n    padding: 6px 9px;\n    font-weight: 600;\n  }\n\n  .select2-results__option {\n    padding: remSizing(0.428) remSizing(1);\n    &[role='group'] {\n      padding: 0;\n    }\n    &[aria-selected='true'] {\n      background-color: $primary !important;\n      color: white !important;\n    }\n    i,\n    svg {\n      height: remSizing(1.15);\n      width: remSizing(1.15);\n      font-size: remSizing(1.15);\n      margin-right: remSizing(0.5);\n    }\n  }\n\n  .select2-results__option--highlighted {\n    background-color: rgba($primary, 0.12) !important;\n    color: $primary !important;\n  }\n\n  //Loading Remote Data Image Size\n  .select2-result-repository__avatar {\n    img {\n      width: 50px;\n    }\n  }\n\n  // Optional sizing\n  // ------------------------------\n\n  // Large Single select\n  .select-lg {\n    min-height: $input-height !important;\n    font-size: ($font-size-lg - 0.8);\n    margin-bottom: 0 !important;\n    padding: remSizing(0.3) remSizing(0.7);\n    &.select2-selection--single {\n      .select2-selection__rendered {\n        padding-top: $input-btn-padding-y-lg - 0.9;\n      }\n\n      .select2-selection__arrow {\n        top: $input-btn-padding-y-lg - 0.8 !important;\n      }\n    }\n\n    // large Multiple select\n    &.select2-selection--multiple {\n      padding: 0 remSizing(0.2);\n      .select2-selection__rendered {\n        padding-top: 0 !important;\n        li {\n          font-size: ($font-size-lg - 0.8);\n          .select2-search__field {\n            margin-top: 10px;\n          }\n        }\n        .select2-selection__choice {\n          padding: 5px;\n\n          .select2-selection__choice__remove:before {\n            top: 46%;\n          }\n        }\n      }\n    }\n  }\n  // Small Single select\n  .select-sm {\n    min-height: $input-height-sm !important;\n    padding: 0 $input-padding-y-xs;\n    font-size: $font-size-xs;\n    margin-bottom: 0 !important;\n    line-height: $line-height-xs;\n    // Single\n    &.select2-selection--single {\n      .select2-selection__arrow {\n        top: remSizing(-0.3) !important;\n      }\n    }\n\n    // Small Multiple select\n    &.select2-selection--multiple {\n      line-height: $line-height-xs - 0.2;\n      .select2-selection__rendered {\n        padding: 3px;\n        li {\n          font-size: $font-size-xs;\n          margin-top: 2px;\n          .select2-search__field {\n            margin-top: 4px;\n          }\n        }\n      }\n      .select2-selection__choice {\n        padding: 0 $input-padding-y-xs;\n        .select2-selection__choice__remove:before {\n          top: 5%;\n        }\n      }\n\n      .select2-search--inline .select2-search__field {\n        margin-top: 0;\n      }\n    }\n  }\n}\n\n//  Dark Layout\n.dark-layout {\n  .select2-container {\n    .select2-selection,\n    .select2-search__field,\n    .select2-selection__placeholder {\n      background: $theme-dark-input-bg;\n      border-color: $theme-dark-border-color;\n      color: $theme-dark-body-color;\n    }\n\n    .select2-selection__rendered {\n      color: $theme-dark-body-color;\n    }\n\n    .select2-dropdown {\n      background-color: $theme-dark-card-bg;\n      border-color: $theme-dark-border-color;\n    }\n\n    .select2-selection--multiple {\n      .select2-selection__choice {\n        background: rgba($primary, 0.12) !important;\n        color: $primary !important;\n        border: none;\n        .select2-selection__choice__remove {\n          color: $primary !important;\n        }\n      }\n      .select2-selection__choice__remove:before {\n        background-image: url(str-replace(str-replace($remove, 'currentColor', $primary), '#', '%23'));\n      }\n    }\n\n    .select2-results__option[aria-disabled='true'] {\n      color: $theme-dark-text-muted-color;\n    }\n\n    .select2-selection__arrow {\n      b {\n        background-image: url(str-replace(\n          str-replace($chevron-down, 'currentColor', $theme-dark-body-color),\n          '#',\n          '%23'\n        ));\n      }\n    }\n  }\n  .select2-container--disabled {\n    .select2-selection {\n      opacity: 0.5;\n    }\n  }\n}\n","//  ================================================================================================\n//  File Name: variables-dark.scss\n//  Description: Custom dark theme variables\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n//  ================================================================================================\n\n//  ================================================================================================\n//  WARNING: PLEASE DO NOT CHANGE THIS VARIABLE FILE.\n//  THIS FILE WILL GET OVERWRITTEN WITH EACH VUEXY HTML TEMPLATE RELEASE.\n//  TIP:\n//  We suggest you to use this (assets/scss/variables/_variables-components.scss) file for overriding components variables.\n//  ================================================================================================\n\n//Body\n$theme-dark-body-bg: #161d31 !default;\n$theme-dark-body-color: #b4b7bd !default;\n$theme-dark-border-color: #3b4253 !default;\n$theme-dark-custom-control-border-color: #44405e !default;\n\n//Typography\n$theme-dark-headings-color: #d0d2d6 !default;\n$theme-dark-label-color: #d0d2d6 !default;\n$theme-dark-text-muted-color: #676d7d !default;\n\n//Card\n$theme-dark-card-bg: #283046 !default;\n$theme-dark-box-shadow: 0 4px 24px 0 rgba($black, 0.24);\n\n//Input\n$theme-dark-input-bg: #283046 !default;\n$theme-dark-input-placeholder-color: #676d7d !default;\n$theme-dark-input-border-color: #404656 !default;\n$theme-dark-input-disabled-bg: #24233a !default;\n$theme-dark-input-disabled-border-color: #444b60 !default;\n\n// Switch\n$theme-dark-switch-bg: #545a6a;\n$theme-dark-switch-bg-disabled: #1b2337;\n\n//Table\n$theme-dark-table-bg: #283046 !default;\n$theme-dark-table-header-bg: #343d55 !default;\n$theme-dark-table-row-bg: #283046 !default;\n$theme-dark-table-hover-bg: #242b3d !default;\n$theme-dark-table-striped-bg: #242b3d !default;\n\n$theme-dark-modal-header-bg: #161d31 !default;\n$theme-dark-pagination-bg: #242b3d !default;\n$theme-dark-chart-bg: #384056 !default;\n$theme-dark-widget-bg: #384056 !default;\n","// ================================================================================================\n//     File Name: datatables.scss\n//     Description: Datatables pages custom scss\n//     ----------------------------------------------------------------------------------------------\n//     Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//     Author: PIXINVENT\n//     Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n@import '../../bootstrap-extended/variables';\n\ntable.dataTable {\n  // table width & collapse border\n  width: 100% !important;\n  border-collapse: collapse !important;\n  td,\n  th {\n    padding: $table-cell-padding remSizing(1.5);\n    vertical-align: middle;\n  }\n  thead {\n    // Sorting Icons Change\n    .sorting,\n    .sorting_asc,\n    .sorting_desc {\n      padding-right: inherit;\n      &:before {\n        background-image: url(str-replace(str-replace($chevron-up, 'currentColor', $table-head-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 12px;\n        color: $body-color;\n        width: 14px;\n        height: 14px;\n        content: '';\n        right: remSizing(0.3);\n        top: remSizing(0.5);\n      }\n      &:after {\n        background-image: url(str-replace(str-replace($chevron-down, 'currentColor', $table-head-color), '#', '%23'));\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: 12px;\n        color: $body-color;\n        width: 14px;\n        height: 14px;\n        content: '';\n        right: remSizing(0.3);\n        top: remSizing(1.3);\n      }\n    }\n  }\n\n  // datatables with checkbox styling\n  .dt-checkboxes-cell {\n    .custom-control {\n      padding-left: 0;\n      padding-right: remSizing(1.25);\n    }\n  }\n}\n\ndiv.dataTables_wrapper .dt-button-collection {\n  background-color: $dropdown-bg;\n  > div[role='menu'] {\n    text-align: left;\n    box-shadow: 0px 5px 16px -8px;\n    min-width: remSizing(8);\n  }\n  [class*='buttons-']:focus {\n    outline: 0;\n  }\n}\n\n// responsive '+' icon line height\ntable.dataTable.dtr-column > tbody > tr > td.control:before,\ntable.dataTable.dtr-column > tbody > tr > th.control:before {\n  line-height: 16px;\n}\n\n// data table search, labels and\ndiv.dataTables_wrapper {\n  // data table search, labels\n  div.dataTables_filter,\n  div.dataTables_length {\n    label {\n      margin-top: remSizing(1);\n      margin-bottom: remSizing(0.5);\n    }\n    // for datatable length select\n    select {\n      background-position:\n        calc(100% - 3px) 11px,\n        calc(100% - 20px) 13px,\n        100% 0;\n      padding: 0 remSizing(0.8);\n      width: remSizing(5);\n      margin: 0 remSizing(0.5);\n    }\n  }\n  div.dataTables_filter input {\n    margin-left: remSizing(0.75);\n  }\n\n  // pagination\n  div.dataTables_paginate {\n    ul.pagination {\n      margin-top: remSizing(1);\n      margin-bottom: remSizing(1.5);\n    }\n  }\n\n  // info text color\n  .dataTables_info {\n    padding-top: remSizing(1.25) !important;\n    color: $text-muted;\n  }\n}\n\n// row grouping\ntr.group {\n  // row grouping color\n  background-color: $table-accent-bg;\n}\n\n// pagination in center\n@media only screen and (max-width: 768px) {\n  div.dataTables_wrapper {\n    div.dataTables_paginate {\n      ul.pagination {\n        justify-content: center;\n      }\n    }\n  }\n\n  div.dataTables_wrapper div.dataTables_info {\n    white-space: inherit;\n  }\n  // small screen button spacing in bottom\n  div.dt-buttons {\n    justify-content: center;\n    margin-top: remSizing(1);\n    button {\n      margin-bottom: remSizing(0.5);\n    }\n  }\n}\n@include media-breakpoint-down(xs) {\n  .dtr-bs-modal {\n    .modal-body {\n      padding-left: 0;\n      padding-right: 0;\n      overflow-x: scroll;\n    }\n    .table.dtr-details {\n      margin: 0 auto remSizing(1);\n      td {\n        padding-left: 0;\n        padding-right: 0;\n      }\n      tr td:first-child {\n        padding-left: remSizing(0.75);\n      }\n    }\n  }\n  div.dataTables_wrapper {\n    overflow: scroll;\n  }\n}\n","@import '../../bootstrap-extended/include'; // Bootstrap includes\n@import '../../components/include'; // Components includes\n@import '../../bootstrap-extended/variables';\n\n$bootstrap-touchspin-width: remSizing(8.4);\n$bootstrap-touchspin-width-lg: remSizing(9.375);\n$bootstrap-touchspin-width-sm: remSizing(6.25);\n\n$bootstrap-touchspin-btn-width: 20px;\n$bootstrap-touchspin-btn-height: 20px;\n$bootstrap-touchspin-btn-width-lg: 24px;\n$bootstrap-touchspin-btn-height-lg: 24px;\n$bootstrap-touchspin-btn-width-sm: 16px;\n$bootstrap-touchspin-btn-height-sm: 16px;\n\n/* Bootstrap Touchspin */\n\n.bootstrap-touchspin {\n  &.input-group {\n    width: $bootstrap-touchspin-width;\n    align-items: center;\n    .form-control {\n      padding: 5px;\n      height: auto;\n      border: 0;\n      background-color: $body-bg;\n      border-radius: $border-radius !important;\n      text-align: center;\n      font-weight: 500;\n      &:focus {\n        z-index: 1;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .bootstrap-touchspin-injected {\n    margin: 0 !important;\n    &.input-group-prepend {\n      left: 12px;\n      position: relative;\n    }\n    &.input-group-append {\n      right: 12px;\n      position: relative;\n    }\n    .bootstrap-touchspin-down,\n    .bootstrap-touchspin-up {\n      padding: 0;\n      min-width: $bootstrap-touchspin-btn-width;\n      min-height: $bootstrap-touchspin-btn-width;\n      border-radius: $border-radius !important;\n      i,\n      svg {\n        height: remSizing(0.8);\n        width: remSizing(0.8);\n        font-size: remSizing(0.8);\n        position: relative;\n        top: -1px;\n      }\n    }\n  }\n\n  // Disabled Touchspin\n  &.disabled-touchspin {\n    .bootstrap-touchspin-down,\n    .bootstrap-touchspin-up {\n      background-color: rgba($black, 0.5) !important;\n      cursor: default;\n      opacity: 0.5;\n    }\n  }\n\n  // Touchspin Large\n  &.input-group-lg {\n    width: $bootstrap-touchspin-width-lg;\n    .touchspin {\n      &.form-control {\n        height: auto !important;\n      }\n    }\n    .bootstrap-touchspin-down,\n    .bootstrap-touchspin-up {\n      min-width: $bootstrap-touchspin-btn-width-lg;\n      min-height: $bootstrap-touchspin-btn-width-lg;\n      i,\n      svg {\n        height: remSizing(1);\n        width: remSizing(1);\n        font-size: remSizing(1);\n        top: -3px;\n      }\n    }\n  }\n\n  // Touchspin Small\n  &.input-group-sm {\n    width: $bootstrap-touchspin-width-sm;\n    .touchspin {\n      &.form-control {\n        height: auto !important;\n      }\n    }\n    .bootstrap-touchspin-injected {\n      .bootstrap-touchspin-down,\n      .bootstrap-touchspin-up {\n        min-width: $bootstrap-touchspin-btn-width-sm;\n        min-height: $bootstrap-touchspin-btn-width-sm;\n        i,\n        svg {\n          height: remSizing(0.6);\n          width: remSizing(0.6);\n          font-size: remSizing(0.6);\n        }\n      }\n    }\n  }\n}\n\n/* Number Type Input Box Scss for Touchspin - Remove arrow for firefox */\n.bootstrap-touchspin {\n  &.input-group {\n    input[type='number'] {\n      -moz-appearance: textfield;\n    }\n  }\n}\n\n// Dark layout style\n.dark-layout {\n  // number inputs[touchspin]\n  .bootstrap-touchspin {\n    &.input-group {\n      .form-control {\n        background-color: $theme-dark-body-bg;\n      }\n    }\n\n    &.disabled-touchspin {\n      .bootstrap-touchspin-injected {\n        .bootstrap-touchspin-down,\n        .bootstrap-touchspin-up,\n        .disabled-max-min {\n          background-color: $gray-600 !important;\n          opacity: 1;\n        }\n      }\n    }\n\n    .bootstrap-touchspin-injected {\n      .disabled-max-min {\n        background-color: $gray-600 !important;\n        opacity: 1;\n      }\n    }\n  }\n}\n","// ================================================================================================\n// \tFile Name: dark-layout.scss\n// \tDescription: SCSS file for dark layout.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n@import '../bootstrap-extended/include'; // Bootstrap includes\n@import '../components/include'; // Components includes\n\n.dark-layout {\n  @at-root body#{&} {\n    color: $theme-dark-body-color;\n    background-color: $theme-dark-body-bg;\n  }\n  body {\n    color: $theme-dark-body-color;\n    background-color: $theme-dark-body-bg;\n  }\n  // universal elements\n  //heading tags\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: $theme-dark-headings-color;\n  }\n\n  // border color\n  .border,\n  .border-top,\n  .border-right,\n  .border-bottom,\n  .border-left {\n    border-color: $theme-dark-border-color !important;\n  }\n\n  // other tags\n  a {\n    &:hover {\n      color: $primary;\n    }\n  }\n\n  label {\n    color: $theme-dark-label-color;\n  }\n\n  .btn span {\n    color: inherit;\n  }\n\n  hr {\n    border-color: $theme-dark-border-color;\n  }\n\n  pre {\n    background-color: $theme-dark-body-bg !important;\n    border: 0;\n\n    code {\n      background-color: inherit;\n      text-shadow: none;\n\n      // .operator,\n      .url {\n        background-color: $theme-dark-body-bg;\n      }\n    }\n  }\n\n  code {\n    background-color: $theme-dark-body-bg;\n  }\n\n  kbd {\n    background-color: $theme-dark-body-bg;\n  }\n\n  // for dark text\n  .text-dark {\n    color: $gray-600 !important;\n  }\n\n  .text-muted {\n    color: $theme-dark-text-muted-color !important;\n  }\n\n  .text-body {\n    color: $theme-dark-body-color !important;\n  }\n  .text-body-heading {\n    color: $theme-dark-headings-color;\n  }\n\n  .section-label {\n    color: $theme-dark-text-muted-color;\n  }\n\n  // shadow\n  .shadow {\n    box-shadow: $theme-dark-box-shadow !important;\n  }\n\n  // blockquote footer\n  .blockquote-footer {\n    color: $theme-dark-text-muted-color;\n  }\n\n  // main navbar and header navbar shadow(generic navbar)\n  .header-navbar-shadow {\n    background: linear-gradient(180deg, rgba(22, 29, 49, 0.9) 44%, rgba(22, 29, 49, 0.43) 73%, rgba(22, 29, 49, 0));\n  }\n\n  // main header navbar dark style\n\n  .horizontal-layout {\n    .header-navbar {\n      background-color: $theme-dark-card-bg;\n    }\n    &.navbar-sticky,\n    &.navbar-static {\n      .header-navbar {\n        background-color: $theme-dark-body-bg;\n      }\n    }\n  }\n  .navbar-sticky {\n    .header-navbar {\n      &.navbar-shadow {\n        box-shadow: 0 4px 24px 0 rgba($black, 0.75);\n      }\n    }\n  }\n  .header-navbar {\n    background-color: $theme-dark-card-bg;\n\n    &.navbar-static-top {\n      background-color: transparent !important;\n    }\n  }\n\n  //Text color for Blank page with transparent card\n  .blank-page {\n    .card.bg-transparent {\n      h1,\n      h2,\n      h3,\n      h4,\n      h5,\n      h6 {\n        color: $theme-dark-card-bg;\n      }\n\n      p {\n        color: $theme-dark-body-bg;\n      }\n    }\n  }\n\n  // Perfect Scrollbar\n  .ps__thumb-x,\n  .ps__thumb-y {\n    background-color: $theme-dark-body-color;\n  }\n  .ps .ps__rail-x.ps--clicking,\n  .ps .ps__rail-x:focus,\n  .ps .ps__rail-x:hover,\n  .ps .ps__rail-y.ps--clicking,\n  .ps .ps__rail-y:focus,\n  .ps .ps__rail-y:hover {\n    background-color: $theme-dark-border-color;\n  }\n\n  .ps__rail-y.ps--clicking .ps__thumb-y,\n  .ps__rail-y:focus > .ps__thumb-y,\n  .ps__rail-y:hover > .ps__thumb-y {\n    background-color: $theme-dark-body-color;\n  }\n\n  /********* COMPONENTS *********/\n  // alerts\n  .alert {\n    .alert-heading,\n    p {\n      color: inherit;\n    }\n    .close {\n      text-shadow: none;\n    }\n    &.alert-dark {\n      .alert-heading,\n      .alert-body,\n      p {\n        color: $gray-600;\n      }\n      &.alert-dismissible .close {\n        color: $gray-600 !important;\n      }\n    }\n  }\n\n  // breadcrumbs\n\n  // Header breadcrumb\n  .content-header-left {\n    .breadcrumbs-top {\n      .content-header-title {\n        color: $theme-dark-headings-color;\n        border-color: $theme-dark-border-color;\n      }\n    }\n  }\n  // Breadcrumb dark style\n  // .breadcrumb {\n  //   .breadcrumb-item {\n  //     color: $theme-dark-body-color;\n  //     + .breadcrumb-item::before {\n  //       color: $theme-dark-body-color;\n  //     }\n  //   }\n  //   &:not([class*='breadcrumb-']) {\n  //     .breadcrumb-item + .breadcrumb-item {\n  //       &:before {\n  //         background-image: url(str-replace(\n  //           str-replace($chevron-right, 'currentColor', $theme-dark-body-color),\n  //           '#',\n  //           '%23'\n  //         ));\n  //       }\n  //     }\n  //   }\n  // }\n\n  // Breadcrumb with Chevron\n  .breadcrumb-chevron {\n    &.breadcrumb {\n      .breadcrumb-item + .breadcrumb-item:before {\n        background-image: url(str-replace(\n          str-replace($chevron-right, 'currentColor', $theme-dark-body-color),\n          '#',\n          '%23'\n        ));\n      }\n    }\n  }\n\n  // collapse\n\n  [class*='collapse-'] .card:not(:last-of-type) {\n    border-color: $theme-dark-border-color;\n  }\n  // for shadow and bordered\n  .collapse-border {\n    .card {\n      border-color: $theme-dark-border-color;\n    }\n  }\n\n  // Collapse shadow\n  .collapse-shadow {\n    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24);\n  }\n\n  // margin collapse\n  .collapse-margin {\n    .card {\n      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.24) !important;\n    }\n  }\n\n  // if there is an anchor tag inside\n  .collapse-icon {\n    .card-header {\n      a {\n        color: $theme-dark-body-color;\n      }\n    }\n    [data-toggle='collapse'] {\n      &:after {\n        background-image: url(str-replace(\n          str-replace($chevron-down, 'currentColor', $theme-dark-body-color),\n          '#',\n          '%23'\n        ));\n      }\n      &:before {\n        background-image: url(str-replace(\n          str-replace($chevron-up, 'currentColor', $theme-dark-body-color),\n          '#',\n          '%23'\n        ));\n      }\n    }\n  }\n\n  // buttons\n  .btn {\n    &:not([class*='btn-']) {\n      color: $theme-dark-body-color;\n    }\n\n    &.btn-dark,\n    &.btn-outline-dark,\n    &.btn-flat-dark {\n      color: $gray-600;\n    }\n\n    &.btn-dark {\n      background-color: $dark !important;\n    }\n\n    &.btn-outline-dark {\n      border-color: $dark;\n      color: $gray-600;\n      &:hover:not(.disabled):not(:disabled) {\n        color: $gray-600;\n      }\n    }\n\n    &.btn-flat-dark {\n      &:active,\n      &:focus {\n        background: $dark;\n      }\n    }\n  }\n\n  .btn-group-toggle {\n    label[class*='btn-outline-'] {\n      color: $primary !important;\n    }\n  }\n\n  // dropdown\n  .dropdown-menu {\n    background-color: $theme-dark-card-bg;\n    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.24);\n\n    .dropdown-header {\n      color: $theme-dark-headings-color;\n    }\n\n    .dropdown-item {\n      color: $theme-dark-body-color;\n      &:hover,\n      &:focus {\n        background: $dropdown-link-hover-bg;\n        color: $dropdown-link-hover-color;\n      }\n      &:active,\n      &.active {\n        color: $dropdown-link-active-color;\n        background-color: $dropdown-link-active-bg;\n      }\n      &.disabled,\n      &:disabled {\n        color: $theme-dark-text-muted-color;\n      }\n    }\n  }\n  .dropdown-divider {\n    border-color: $theme-dark-border-color;\n  }\n\n  // modal\n  .modal {\n    .modal-header,\n    .modal-header[class*='bg-'] {\n      // why removed !important? Not working if added bg-COLOR class with modal-header\n      // background-color: $theme-dark-card-bg !important;\n      background-color: $theme-dark-body-bg;\n    }\n\n    // close button\n    .modal-header .close {\n      text-shadow: none;\n      background-color: $theme-dark-card-bg !important;\n      color: $theme-dark-body-color;\n      box-shadow: 0 3px 8px 0 rgba(11, 10, 25, 0.49) !important;\n    }\n\n    .modal-content,\n    .modal-body,\n    .modal-footer {\n      background-color: $theme-dark-card-bg;\n      border-color: $theme-dark-border-color;\n    }\n  }\n\n  //pagination\n  .pagination {\n    &:not([class*='pagination-']) {\n      .page-item {\n        &.active {\n          background-color: $theme-dark-pagination-bg;\n\n          .page-link {\n            background-color: $primary;\n\n            &:hover {\n              color: $white;\n            }\n          }\n        }\n\n        .page-link {\n          background-color: $theme-dark-pagination-bg;\n          color: $theme-dark-body-color;\n\n          &:hover {\n            color: $primary;\n          }\n        }\n\n        &.prev-item,\n        &.next-item {\n          .page-link:hover {\n            color: $white;\n          }\n        }\n      }\n    }\n\n    &[class*='pagination-'] {\n      .page-item:not(.active) {\n        .page-link {\n          background-color: $theme-dark-pagination-bg;\n        }\n\n        &:not(:hover) {\n          .page-link {\n            color: $white;\n          }\n        }\n      }\n\n      .page-item {\n        &:not(.active) {\n          .page-link:hover {\n            background-color: $theme-dark-pagination-bg;\n          }\n        }\n\n        &.active {\n          background-color: $theme-dark-pagination-bg;\n        }\n      }\n    }\n\n    .page-item {\n      &.prev-item,\n      &.prev {\n        .page-link:before {\n          background-image: url(str-replace(\n            str-replace($chevron-left, 'currentColor', $theme-dark-body-color),\n            '#',\n            '%23'\n          ));\n        }\n        &.disabled {\n          .page-link {\n            &:before {\n              background-image: url(str-replace(\n                str-replace($chevron-left, 'currentColor', $theme-dark-text-muted-color),\n                '#',\n                '%23'\n              ));\n            }\n          }\n        }\n      }\n      &.next-item,\n      &.next {\n        .page-link::after {\n          background-image: url(str-replace(\n            str-replace($chevron-right, 'currentColor', $theme-dark-body-color),\n            '#',\n            '%23'\n          ));\n        }\n        &.disabled {\n          .page-link {\n            &:after {\n              background-image: url(str-replace(\n                str-replace($chevron-right, 'currentColor', $theme-dark-text-muted-color),\n                '#',\n                '%23'\n              ));\n            }\n          }\n        }\n      }\n      &.disabled {\n        .page-link {\n          color: $theme-dark-text-muted-color;\n        }\n      }\n    }\n  }\n\n  // bordered nav\n  .nav.wrap-border {\n    border-color: $theme-dark-border-color;\n  }\n\n  // media\n  .media-bordered {\n    .media:not(:first-child) {\n      border-color: $theme-dark-border-color;\n    }\n  }\n\n  // popover\n  .popover {\n    &[x-placement='top'] {\n      .arrow {\n        &:before {\n          border-top-color: $theme-dark-border-color;\n        }\n        &:after {\n          border-top-color: $theme-dark-card-bg;\n        }\n      }\n    }\n\n    &[x-placement='left'] {\n      .arrow {\n        &:before {\n          border-left-color: $theme-dark-border-color;\n        }\n        &:after {\n          border-left-color: $theme-dark-card-bg;\n        }\n      }\n    }\n\n    &[x-placement='right'] {\n      .arrow {\n        &:before {\n          border-right-color: $theme-dark-border-color;\n        }\n        &:after {\n          border-right-color: $theme-dark-card-bg;\n        }\n      }\n    }\n    .popover-header {\n      color: $white;\n    }\n\n    .popover-body {\n      background-color: $theme-dark-card-bg;\n      color: $theme-dark-body-color;\n      border-color: $theme-dark-border-color !important;\n    }\n  }\n\n  // BS toast\n  .toast {\n    background-color: rgba($theme-dark-card-bg, 0.85);\n    box-shadow: $theme-dark-box-shadow;\n    color: $theme-dark-body-color;\n\n    .toast-header {\n      background-color: $theme-dark-card-bg;\n      color: $theme-dark-body-color;\n\n      .close {\n        background-color: transparent !important;\n        box-shadow: none !important;\n        text-shadow: none;\n      }\n    }\n  }\n\n  // list group\n  .list-group {\n    .list-group-item {\n      &:not([class*='list-group-item-']),\n      &.list-group-item-action {\n        background-color: $theme-dark-card-bg;\n        border-color: $theme-dark-border-color;\n        color: $theme-dark-body-color;\n\n        &:hover,\n        &:focus {\n          background-color: $theme-dark-body-bg;\n        }\n        &.active,\n        &:active {\n          background-color: $primary;\n          color: $white;\n        }\n      }\n\n      &.active {\n        p,\n        small {\n          color: $white;\n        }\n      }\n\n      &.disabled {\n        color: $theme-dark-text-muted-color;\n      }\n    }\n\n    &.list-group-circle .list-group-item:after {\n      background-image: url(str-replace(str-replace($circle, 'currentColor', $theme-dark-body-color), '#', '%23'));\n    }\n  }\n\n  // spinners\n  .spinner-border {\n    border-color: currentColor !important;\n    border-right-color: transparent !important;\n  }\n\n  // avatar\n  .avatar {\n    background-color: $theme-dark-body-bg;\n\n    [class*='avatar-status-'] {\n      border-color: $theme-dark-card-bg;\n    }\n  }\n  .avatar-group {\n    .avatar {\n      img,\n      .avatar-content {\n        box-shadow:\n          0 0 0 2px $theme-dark-card-bg,\n          inset 0 0 0 1px rgba($theme-dark-card-bg, 0.07);\n      }\n    }\n  }\n\n  // divider\n  .divider {\n    .divider-text {\n      color: $theme-dark-body-color;\n\n      &::before,\n      &::after {\n        border-color: $theme-dark-border-color;\n      }\n    }\n\n    &.divider-dark {\n      .divider-text {\n        &::before,\n        &::after {\n          border-color: $theme-dark-border-color !important;\n        }\n      }\n    }\n  }\n\n  // Timeline\n  .timeline {\n    .timeline-item {\n      border-color: $theme-dark-border-color;\n\n      .timeline-point:not(.timeline-point-indicator) {\n        background-color: $theme-dark-card-bg;\n      }\n      .timeline-event {\n        .timeline-event-time {\n          color: $theme-dark-text-muted-color;\n        }\n      }\n      &:last-of-type:after {\n        background: linear-gradient($theme-dark-border-color, transparent);\n      }\n    }\n  }\n\n  // Vertical Timeline/ Inventory Logs\n  .vertical-timeline-element-content {\n    background-color: $theme-dark-card-bg;\n    box-shadow: $theme-dark-box-shadow;\n  }\n\n  .vertical-timeline-element-content-arrow {\n    border: $theme-dark-card-bg;\n  }\n\n  .vertical-timeline::before {\n    background-color: $theme-dark-border-color;\n    box-shadow: $theme-dark-box-shadow;\n  }\n\n  // card\n  .card {\n    background-color: $theme-dark-card-bg;\n    box-shadow: $theme-dark-box-shadow;\n    .card-footer {\n      border-color: $theme-dark-border-color;\n    }\n\n    &.overlay-img-card {\n      .card-img-overlay {\n        span,\n        p,\n        .card-body {\n          color: $white;\n        }\n      }\n    }\n  }\n\n  //--------------- Advance Cards ---------------\n  //---------------------------------------------\n\n  // Developer Meetup Card\n  .card-developer-meetup {\n    .meetup-header .meetup-day {\n      border-right-color: $theme-dark-input-border-color;\n    }\n  }\n\n  // Profile Card\n  .card-profile {\n    .profile-image-wrapper .profile-image {\n      background-color: $theme-dark-body-bg;\n    }\n  }\n\n  // Business Card\n  .business-card {\n    .business-items .business-item {\n      border-color: $theme-dark-border-color;\n    }\n  }\n\n  // App Design Card\n  .card-app-design {\n    .design-planning-wrapper .design-planning {\n      background-color: $theme-dark-body-bg;\n    }\n  }\n\n  //--------------- Statistics Card ---------------\n  //------------------------------------------------\n\n  .card-tiny-line-stats {\n    .apexcharts-series-markers {\n      .apexcharts-marker {\n        stroke: $info;\n      }\n\n      &:last-child {\n        .apexcharts-marker {\n          fill: $theme-dark-card-bg;\n        }\n      }\n    }\n  }\n\n  //-------------- Analytics Cards --------------\n  //---------------------------------------------\n\n  // Revenue Report Card\n  .card-revenue-budget {\n    .revenue-report-wrapper {\n      border-right-color: $theme-dark-border-color;\n    }\n    .budget-wrapper {\n      .apexcharts-series:not(:first-child) {\n        path {\n          stroke: $theme-dark-body-color;\n        }\n      }\n    }\n  }\n\n  // Earnings Card\n  .earnings-card {\n    .apexcharts-canvas .apexcharts-pie {\n      .apexcharts-datalabel-label {\n        fill: $theme-dark-body-color !important;\n      }\n\n      .apexcharts-datalabel-value {\n        fill: $theme-dark-headings-color;\n      }\n    }\n  }\n\n  // Company Table Card\n  .card-company-table {\n    .avatar {\n      background-color: $theme-dark-body-bg;\n    }\n  }\n\n  /********** FORMS **********/\n\n  // input\n  input.form-control,\n  .custom-file-label,\n  textarea.form-control {\n    background-color: $theme-dark-input-bg;\n    color: $theme-dark-body-color;\n\n    &:not(:focus) {\n      border-color: $theme-dark-input-border-color;\n    }\n\n    &::placeholder {\n      color: $theme-dark-input-placeholder-color;\n    }\n\n    &:disabled,\n    &[readonly='readonly'] {\n      opacity: 0.5;\n    }\n  }\n\n  // text area counter\n  .char-textarea {\n    &.active {\n      color: $theme-dark-body-color !important;\n    }\n\n    &.max-limit {\n      color: $danger !important;\n    }\n  }\n\n  // file uploader default\n  .custom-file-label {\n    &:after {\n      background-color: $theme-dark-body-bg;\n      border-left: 1px solid $theme-dark-border-color;\n      color: $theme-dark-body-color;\n    }\n  }\n\n  // custom control like checkbox, radio and switch\n  .custom-control-input {\n    &:not(:checked) {\n      ~ .custom-control-label:before {\n        background-color: $theme-dark-card-bg;\n        border-color: $theme-dark-input-border-color;\n      }\n    }\n    &:disabled {\n      ~ .custom-control-label:before {\n        background-color: $theme-dark-input-disabled-border-color;\n        border-color: $theme-dark-input-disabled-border-color;\n      }\n    }\n  }\n\n  .custom-switch {\n    .custom-control-input:not(:checked) {\n      ~ .custom-control-label:before {\n        background-color: $theme-dark-switch-bg;\n      }\n    }\n    .custom-control-input:disabled {\n      ~ .custom-control-label:before {\n        background-color: $theme-dark-switch-bg-disabled;\n      }\n    }\n  }\n\n  // select\n  select.form-control,\n  .custom-select {\n    background-color: $theme-dark-input-bg;\n    color: $theme-dark-body-color;\n    border-color: $theme-dark-border-color;\n\n    option:checked {\n      background-color: $theme-dark-card-bg;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n    }\n    &:focus {\n      border-color: $primary;\n    }\n  }\n\n  select.form-control {\n    &:not([multiple='multiple']) {\n      background-image: url(str-replace(\n        str-replace($chevron-down, 'currentColor', $theme-dark-body-color),\n        '#',\n        '%23'\n      ));\n    }\n  }\n\n  // Added for override\n  .was-validated .form-control:invalid,\n  .form-control.is-invalid {\n    border-color: $danger !important;\n  }\n\n  .was-validated .form-control:valid,\n  .form-control.is-valid {\n    border-color: $success !important;\n  }\n\n  // form wizard\n  .wizard {\n    .steps {\n      ul {\n        .disabled,\n        .done {\n          a {\n            color: $theme-dark-body-color !important;\n\n            &:hover {\n              color: $theme-dark-body-color;\n            }\n\n            .step {\n              background-color: $theme-dark-body-bg !important;\n              color: $white !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // input groups\n  .input-group {\n    .input-group-text {\n      background-color: $theme-dark-input-bg;\n      border-color: $theme-dark-border-color;\n      color: $theme-dark-body-color;\n    }\n\n    &:focus-within {\n      .form-control,\n      .input-group-text {\n        border-color: $primary;\n        box-shadow: none;\n      }\n    }\n  }\n\n  // floating label\n  .form-label-group {\n    & > input:not(:focus):not(:placeholder-shown) ~ label,\n    & > textarea:not(:focus):not(:placeholder-shown) ~ label {\n      color: $theme-dark-body-color !important;\n    }\n  }\n\n  .counter-value {\n    color: white;\n  }\n\n  /********** TABLE **********/\n\n  // table\n  .table {\n    background-color: $theme-dark-table-bg;\n\n    td,\n    th {\n      // color: $theme-dark-body-color;\n      border-color: $theme-dark-border-color !important;\n    }\n\n    .thead,\n    tbody {\n      tr:not([class*='stock-styled']) {\n        th,\n        td {\n          border-color: $theme-dark-border-color;\n          color: $theme-dark-body-color;\n\n          code {\n            background-color: $theme-dark-table-row-bg;\n          }\n        }\n      }\n    }\n\n    thead,\n    tfoot {\n      tr {\n        th {\n          border-color: $theme-dark-border-color;\n          background-color: $theme-dark-table-header-bg;\n          color: $theme-dark-headings-color;\n        }\n      }\n      &.thead-dark th {\n        background-color: $white;\n        color: $dark !important;\n      }\n    }\n\n    // if table not light/dark and thead not have dark class\n    &:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,\n    &:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {\n      background-color: $theme-dark-table-header-bg;\n    }\n\n    // table-dark style\n    &.table-dark {\n      background-color: $white;\n      &.table-striped tbody tr:nth-of-type(odd) {\n        background-color: rgba($dark, 0.05);\n        td {\n          background-color: inherit;\n        }\n      }\n      td,\n      th {\n        border-color: #f8f9fa !important;\n        color: $dark !important;\n        background-color: $white;\n        .text-white {\n          color: $dark !important;\n        }\n      }\n    }\n    tbody {\n      tr {\n        // for contextual classes\n        &[class*='table-'] {\n          td,\n          th {\n            background-color: unset;\n          }\n        }\n\n        &.table-dark {\n          td,\n          th {\n            color: $white;\n          }\n        }\n\n        &.table-active {\n          td,\n          th {\n            // color: $theme-dark-body-color;\n          }\n        }\n      }\n    }\n\n    // bordered table\n    &.table-bordered {\n      border-color: $theme-dark-border-color;\n    }\n\n    // table hover row color\n    &.table-hover {\n      tbody {\n        tr {\n          &:hover {\n            background-color: $theme-dark-table-hover-bg;\n          }\n\n          th,\n          td {\n            background-color: unset;\n          }\n        }\n      }\n    }\n\n    // hover animation\n    &.table-hover-animation tbody tr {\n      background-color: $theme-dark-table-bg;\n      &:hover {\n        box-shadow: $theme-dark-box-shadow;\n      }\n    }\n\n    // table striped\n    &.table-striped {\n      tbody {\n        tr {\n          &:nth-of-type(odd) {\n            background-color: $theme-dark-table-striped-bg;\n          }\n        }\n      }\n    }\n  }\n\n  // datatable\n  .dataTables_wrapper {\n    .dt-buttons {\n      .buttons-copy,\n      .buttons-excel,\n      .buttons-pdf,\n      .buttons-print,\n      .btn-secondary,\n      [class*='buttons-'] {\n        background-color: $theme-dark-body-bg !important;\n        &:active {\n          background-color: $primary !important;\n          color: $white;\n        }\n      }\n    }\n    .dt-button-collection {\n      > div[role='menu'] {\n        box-shadow: $theme-dark-box-shadow;\n      }\n    }\n\n    .table.dataTable {\n      tr {\n        &.group {\n          td {\n            background-color: $theme-dark-table-striped-bg;\n            color: $theme-dark-headings-color;\n          }\n        }\n      }\n\n      // Sorting Icons Change\n      thead {\n        .sorting,\n        .sorting_asc,\n        .sorting_desc {\n          &:before {\n            background-image: url(str-replace(\n              str-replace($chevron-up, 'currentColor', $theme-dark-body-color),\n              '#',\n              '%23'\n            ));\n          }\n          &:after {\n            background-image: url(str-replace(\n              str-replace($chevron-down, 'currentColor', $theme-dark-body-color),\n              '#',\n              '%23'\n            ));\n          }\n        }\n        .sorting {\n          &:before,\n          &:after {\n            opacity: 0.5;\n          }\n        }\n        .sorting_asc {\n          &:before {\n            opacity: 1;\n          }\n          &:after {\n            opacity: 0.5;\n          }\n        }\n        .sorting_desc {\n          &:after {\n            opacity: 1;\n          }\n          &:before {\n            opacity: 0.5;\n          }\n        }\n      }\n    }\n  }\n\n  // agGrid Page Btn\n  .ag-grid-btns {\n    .filter-btn {\n      background-color: transparent !important;\n    }\n  }\n\n  // agGrid Main\n  .aggrid {\n    .ag-input-wrapper input {\n      color: $theme-dark-body-color;\n    }\n  }\n  .aggrid,\n  .ag-header {\n    background-color: $theme-dark-card-bg;\n    color: $theme-dark-body-color;\n    border-color: $theme-dark-border-color;\n\n    .ag-row-hover,\n    .ag-row-selected {\n      background-color: $theme-dark-table-hover-bg !important;\n    }\n\n    .ag-icon {\n      color: $theme-dark-input-border-color;\n    }\n    .ag-header-cell.ag-column-hover {\n      background: transparent !important;\n    }\n\n    .ag-header-cell,\n    .ag-cell,\n    .ag-row,\n    .ag-pinned-left-header,\n    .ag-pinned-left-cols-container,\n    .ag-horizontal-left-spacer,\n    .ag-paging-panel,\n    .ag-floating-filter-input {\n      border-color: $theme-dark-border-color !important;\n      color: $theme-dark-body-color;\n    }\n    .ag-cell.ag-cell-inline-editing {\n      border-color: $theme-dark-border-color;\n      background: $theme-dark-body-bg;\n      height: auto;\n      padding-top: 0;\n    }\n\n    .ag-paging-panel {\n      .ag-paging-button {\n        background-color: $theme-dark-body-bg;\n      }\n      .ag-disabled {\n        background: $theme-dark-card-bg;\n      }\n\n      span[ref='lbTotal'] {\n        background-color: $theme-dark-pagination-bg;\n        color: $theme-dark-body-color !important;\n      }\n    }\n\n    ::-webkit-scrollbar-track {\n      background: $theme-dark-body-bg;\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: $primary;\n    }\n  }\n\n  /********** PAGES **********/\n\n  // coming soon\n  .getting-started {\n    .clockCard {\n      p {\n        color: $theme-dark-body-color !important;\n      }\n    }\n  }\n\n  // profile page\n  #user-profile {\n    .profile-header {\n      .navbar {\n        background-color: $theme-dark-card-bg;\n        .navbar-toggler {\n          color: $theme-dark-body-color;\n          border-color: $theme-dark-border-color;\n        }\n      }\n    }\n  }\n\n  // Search page\n  .search-bar {\n    .form-control {\n      background-color: $theme-dark-card-bg;\n    }\n  }\n\n  // Blog Edit Page\n  .blog-edit-wrapper {\n    .border {\n      border-color: $theme-dark-border-color !important;\n    }\n  }\n  // Knowledge Base\n  .kb-search-content-info {\n    .kb-search-content {\n      .card-img-top {\n        background-color: #3f4860;\n      }\n    }\n  }\n\n  // list group circle for kb\n  .list-group-circle {\n    .list-group-item:not([class*='list-group-item-']),\n    .list-group-item-action {\n      &:hover,\n      &:focus,\n      &:active {\n        background-color: transparent !important;\n      }\n    }\n  }\n\n  /********** APPLICATIONS **********/\n\n  // App common sidebar and content dark style\n  .content-area-wrapper {\n    border-color: $theme-dark-border-color !important;\n\n    .sidebar {\n      .sidebar-content {\n        background-color: $theme-dark-card-bg !important;\n      }\n    }\n    .app-fixed-search {\n      background-color: $theme-dark-card-bg !important;\n      border-color: $theme-dark-border-color !important;\n    }\n    .content-right {\n      border-color: $theme-dark-border-color !important;\n    }\n  }\n\n  // email application\n  .email-application {\n    .content-area-wrapper {\n      // Email list\n      .email-app-list {\n        .app-action {\n          border-color: $theme-dark-border-color;\n          background-color: $theme-dark-card-bg;\n          .action-right {\n            .list-inline-item {\n              .dropdown-toggle {\n                color: $theme-dark-body-color;\n              }\n            }\n          }\n        }\n\n        .email-user-list {\n          .media {\n            border-color: $theme-dark-border-color;\n            background-color: $theme-dark-card-bg;\n\n            &:hover {\n              box-shadow: 0 3px 10px 0 $theme-dark-card-bg;\n            }\n\n            &.selected-row-bg {\n              background-color: rgba($primary, 0.06);\n              border-color: $theme-dark-border-color;\n            }\n          }\n\n          .media {\n            .user-details,\n            .mail-message {\n              p,\n              .mail-date {\n                color: $theme-dark-text-muted-color;\n              }\n            }\n          }\n\n          .mail-read {\n            background-color: $theme-dark-table-hover-bg;\n          }\n        }\n      }\n\n      // app email details\n      .email-app-details {\n        border-color: $theme-dark-border-color;\n        .email-scroll-area {\n          background-color: $theme-dark-body-bg;\n        }\n\n        .email-detail-header {\n          background-color: $theme-dark-card-bg;\n          border-color: $theme-dark-border-color;\n\n          .email-header-right {\n            .list-inline-item {\n              .dropdown-toggle,\n              .action-icon {\n                color: $theme-dark-body-color;\n              }\n            }\n          }\n        }\n        .email-info-dropup {\n          .dropdown-toggle::after {\n            background-image: url(str-replace(\n              str-replace($chevron-down, 'currentColor', $theme-dark-text-muted-color),\n              '#',\n              '%23'\n            ));\n          }\n        }\n\n        .mail-message-wrapper,\n        .email-detail-head {\n          border-color: $theme-dark-border-color !important;\n        }\n      }\n\n      // Compose mail\n      #compose-mail {\n        .compose-mail-form-field,\n        .ql-toolbar,\n        .ql-container {\n          border-color: $theme-dark-border-color;\n        }\n        label {\n          color: $theme-dark-body-color;\n        }\n        .modal-body {\n          border-bottom-left-radius: $modal-content-border-radius;\n          border-bottom-right-radius: $modal-content-border-radius;\n        }\n      }\n    }\n  }\n\n  // file manager app\n  .file-manager-application {\n    .sidebar-file-manager {\n      background-color: $theme-dark-card-bg !important;\n      .jstree {\n        .jstree-container-ul {\n          .jstree-anchor {\n            color: $theme-dark-body-color;\n          }\n        }\n      }\n      .storage-status {\n        i,\n        svg {\n          color: $theme-dark-body-color !important;\n        }\n      }\n\n      .file-manager-title {\n        color: $theme-dark-label-color;\n      }\n\n      &.show {\n        border: 1px solid $theme-dark-border-color !important;\n      }\n    }\n\n    .content-area-wrapper {\n      border: 1px solid $theme-dark-border-color !important;\n    }\n\n    // File Manager App\n    .file-manager-main-content {\n      border: 1px solid $theme-dark-border-color !important;\n\n      .file-manager-app-searchbar {\n        background-color: transparent !important;\n        border-bottom: 1px solid $theme-dark-border-color !important;\n\n        .file-manager-toggler {\n          color: $theme-dark-body-color !important;\n        }\n      }\n\n      .file-manager-content-header,\n      .file-manager-content-body {\n        background-color: $theme-dark-card-bg !important;\n      }\n\n      .file-manager-content-header {\n        border-color: $theme-dark-border-color !important;\n      }\n\n      .file-manager-content-body {\n        .drives {\n          .card {\n            background-color: $theme-dark-table-bg;\n          }\n        }\n\n        .view-container {\n          .file-manager-item {\n            .file-logo-wrapper {\n              background-color: $theme-dark-body-bg !important;\n            }\n            &:not(.selected) {\n              border-color: $theme-dark-border-color !important;\n            }\n          }\n          &:not(.list-view) {\n            .file-manager-item {\n              .file-size,\n              .file-accessed {\n                color: $theme-dark-text-muted-color !important;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    #app-file-manager-info-sidebar {\n      .tab-content .tab-pane {\n        background-color: transparent;\n      }\n    }\n  }\n\n  // calendar\n  .app-calendar {\n    .app-calendar-sidebar {\n      background-color: $theme-dark-card-bg;\n      border-color: $theme-dark-border-color;\n\n      .sidebar-content-title {\n        color: $theme-dark-label-color;\n      }\n      .select-all,\n      .input-filter {\n        ~ label {\n          color: $theme-dark-label-color;\n        }\n      }\n    }\n    .fc {\n      .fc-day-today {\n        background: $theme-dark-body-bg !important;\n        background-color: $theme-dark-body-bg !important;\n      }\n\n      .fc-timegrid {\n        .fc-scrollgrid-section {\n          .fc-col-header-cell,\n          .fc-timegrid-axis,\n          .fc-daygrid-day {\n            background-color: $theme-dark-card-bg;\n            border-color: $theme-dark-border-color;\n          }\n          .fc-day-today {\n            background-color: rgba($color: $gray-100, $alpha: 0.12) !important;\n\n            &.fc-col-header-cell {\n              background-color: $theme-dark-card-bg !important;\n            }\n          }\n        }\n      }\n      .fc-popover {\n        background: $theme-dark-card-bg;\n        border-color: $theme-dark-border-color;\n      }\n      .fc-popover-header {\n        .fc-popover-title,\n        .fc-popover-close {\n          color: $theme-dark-body-color;\n        }\n      }\n      tbody td,\n      thead th {\n        border-color: $theme-dark-border-color;\n      }\n\n      .fc-scrollgrid {\n        border-color: $theme-dark-border-color;\n      }\n\n      .fc-list,\n      th {\n        border-color: $theme-dark-border-color;\n        .fc-list-day-cushion {\n          background: $theme-dark-body-bg;\n        }\n        .fc-list-event:hover td {\n          background-color: $theme-dark-body-bg;\n        }\n        .fc-list-event-time {\n          color: $theme-dark-body-color;\n        }\n        .fc-list-event {\n          td {\n            border-color: $theme-dark-border-color;\n          }\n        }\n      }\n    }\n  }\n\n  // Invoice Application\n  .invoice-list-wrapper {\n    .dataTables_wrapper {\n      .invoice-list-dataTable-header {\n        background-color: $theme-dark-card-bg;\n        border-color: $theme-dark-border-color;\n      }\n      .invoice-data-table {\n        background-color: $theme-dark-card-bg;\n        tbody .selected-row-bg {\n          background-color: $theme-dark-border-color;\n        }\n        td {\n          background-color: inherit;\n        }\n      }\n    }\n  }\n  .invoice-edit,\n  .invoice-add {\n    .invoice-preview-card {\n      .invoice-product-details {\n        background-color: $theme-dark-body-bg;\n        .product-details-border {\n          background-color: $theme-dark-card-bg;\n          border-color: $theme-dark-border-color;\n        }\n      }\n    }\n  }\n  .invoice-print {\n    .form-control {\n      background-color: $theme-dark-card-bg;\n    }\n  }\n\n  // Users Application\n  .app-user-view {\n    .plan-card {\n      border-color: $primary !important;\n    }\n  }\n  .app-user-edit {\n    .form-control.error {\n      border-color: $danger !important;\n    }\n  }\n\n  /********** CUSTOMIZER **********/\n\n  .customizer {\n    background-color: $theme-dark-card-bg;\n\n    .customizer-close {\n      i,\n      svg {\n        color: $theme-dark-body-color;\n      }\n    }\n  }\n\n  .footer-fixed {\n    .footer {\n      background-color: $theme-dark-card-bg;\n    }\n  }\n\n  /********** HORIZONTAL LAYOUT **********/\n  .horizontal-layout {\n    &.navbar-sticky .horizontal-menu-wrapper .navbar-horizontal.header-navbar.fixed-top {\n      box-shadow: 0 4px 24px 0 rgba($black, 0.75) !important;\n    }\n    .horizontal-menu-wrapper {\n      background: linear-gradient(\n        to bottom,\n        rgba(37, 43, 71, 0.76) 44%,\n        rgba(56, 53, 53, 0.46) 73%,\n        rgba($white, 0) 100%\n      ) !important;\n      .header-navbar {\n        background: $theme-dark-card-bg !important;\n        &.navbar-shadow {\n          box-shadow: 0 4px 24px 0 rgba($black, 0.75);\n        }\n        &.navbar-horizontal {\n          ul#main-menu-navigation > li:hover:not(.active) > a {\n            background: $theme-dark-body-bg;\n          }\n        }\n      }\n    }\n  }\n}\n","// ================================================================================================\n// \tFile Name: bordered-layout.scss\n// \tDescription: SCSS file for Bordered layout.\n// \t----------------------------------------------------------------------------------------------\n// \tItem Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n// \tAuthor: PIXINVENT\n// \tAuthor URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n@import '../bootstrap-extended/include'; // Bootstrap includes\n@import '../components/include'; // Components includes\n\n.bordered-layout {\n  .header-navbar {\n    box-shadow: none;\n    &.floating-nav {\n      border: 1px solid $border-color;\n    }\n    &.fixed-top {\n      border-bottom: 1px solid $border-color;\n      background: $body-bg;\n    }\n  }\n  .dropdown-menu {\n    border: 1px solid $border-color !important;\n    box-shadow: none;\n  }\n\n  .card,\n  .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps),\n  .bs-stepper.wizard-modern .bs-stepper-content {\n    border: 1px solid $border-color;\n    box-shadow: none;\n  }\n\n  .footer {\n    box-shadow: none !important;\n  }\n  .footer-fixed {\n    .footer {\n      border-top: 1px solid $border-color;\n    }\n  }\n}\n","// ================================================================================================\n//  File Name: custom-rtl.scss\n//  Description: RTL support SCSS file.\n//  ----------------------------------------------------------------------------------------------\n//  Item Name: Vuexy  - Vuejs, HTML & Laravel Admin Dashboard Template\n//  Author: PIXINVENT\n//  Author URL: http://www.themeforest.net/user/pixinvent\n// ================================================================================================\n\n// Variables\n// ------------------------------\n\n@import 'bootstrap-extended/include'; // Bootstrap includes\n@import 'components/include'; // Components includes\n@import './bootstrap-extended/variables';\n\n// Horizontal menu\n.horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {\n  background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $body-color), '#', '%23'));\n}\n\n.header-navbar {\n  .dropdown,\n  .dropup {\n    .dropdown-menu.dropdown-menu-right::before {\n      right: auto;\n      left: remSizing(0.5);\n    }\n  }\n}\n\n.dropdown,\n.dropup,\n.btn-group {\n  .dropdown-menu {\n    right: auto !important;\n    top: 0 !important;\n    left: auto !important;\n\n    &.dropdown-menu-right {\n      left: 0 !important;\n\n      &::before {\n        right: remSizing(0.6);\n        left: auto;\n      }\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-toggle {\n    &::before {\n      background-image: url(str-replace(str-replace($chevron-right, 'currentColor', $white), '#', '%23')) !important;\n    }\n  }\n  .dropdown-menu {\n    left: 0 !important;\n    margin-left: 0;\n    margin-right: remSizing(0.5);\n  }\n}\n\n.dropright {\n  .dropdown-toggle {\n    &::after {\n      background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $white), '#', '%23')) !important;\n    }\n  }\n  .dropdown-menu {\n    left: 0 !important;\n    margin-right: 0;\n    margin-left: remSizing(0.5);\n  }\n}\n\n// Input Group dropdown\n.input-group {\n  .dropdown-menu.show {\n    top: 0 !important;\n    right: auto !important;\n    left: 0px !important;\n  }\n}\n\n// BS Toast\n.toast {\n  right: remSizing(1);\n}\n\n// Select2\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  left: 1px;\n}\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  float: right;\n}\n.select2-search__field {\n  direction: rtl;\n}\n\n// Chartist\n.chartjs-render-monitor {\n  margin-right: remSizing(1);\n}\n\n// Datatable\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: left !important;\n}\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before {\n  right: remSizing(0.45);\n}\n\n// Avatar group\n.avatar-group {\n  // Avatar Group Sizings\n  .avatar {\n    margin-right: remSizing(-0.785);\n    margin-left: 0;\n  }\n  .avatar-sm {\n    margin-right: remSizing(-0.65);\n  }\n  .avatar-lg {\n    margin-right: remSizing(-1.5);\n  }\n  .avatar-xl {\n    margin-right: remSizing(-1.85);\n  }\n}\n\n// Breadcrumb\n.breadcrumb:not([class*='breadcrumb-']),\n.breadcrumb.breadcrumb-chevron {\n  .breadcrumb-item + .breadcrumb-item {\n    &:before {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n// Pagination\n.pagination .page-item {\n  &.prev-item,\n  &.prev,\n  &.previous {\n    .page-link {\n      &:before {\n        transform: rotate(180deg);\n      }\n      &:hover,\n      &:active {\n        &:before {\n          transform: rotate(180deg);\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:before {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n\n  &.next-item,\n  &.next {\n    .page-link {\n      &:after {\n        transform: rotate(180deg);\n      }\n      &:hover,\n      &:active {\n        &:after {\n          transform: rotate(180deg);\n        }\n      }\n    }\n    &.disabled {\n      .page-link {\n        &:before {\n          transform: rotate(180deg);\n        }\n      }\n    }\n  }\n}\n\ncode[class*='language-'],\npre[class*='language-'] {\n  direction: ltr;\n}\n\n@media print {\n  code[class*='language-'],\n  pre[class*='language-'] {\n    text-shadow: none;\n  }\n}\n\n// Calendar\n.fc .fc-header-toolbar .fc-right .fc-button.fc-prev-button .fc-icon {\n  right: 4px !important;\n}\n\n.fc .fc-header-toolbar .fc-right .fc-button.fc-next-button .fc-icon {\n  left: -3px !important;\n}\n\n// carousel changes\n.carousel-control-next {\n  left: auto;\n  right: 0;\n}\n\n.carousel-control-prev {\n  left: 0;\n  right: auto;\n}\n\n// Tooltip\n.bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^='left'] .arrow::before {\n  border-width: remSizing(0.4) 0 remSizing(0.4) remSizing(0.4);\n  border-left-color: $tooltip-bg;\n}\n\n.bs-tooltip-left .arrow,\n.bs-tooltip-auto[x-placement^='left'] .arrow {\n  right: 0;\n  left: auto;\n}\n\n.bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^='right'] .arrow::before {\n  border-width: remSizing(0.4) remSizing(0.4) remSizing(0.4) 0;\n  border-right-color: $tooltip-bg;\n}\n\n.bs-tooltip-right .arrow,\n.bs-tooltip-auto[x-placement^='right'] .arrow {\n  left: 0;\n  right: auto;\n}\n\n// Popover Style\n.popover {\n  right: auto !important;\n}\n\n// Progress\n.progress-bar-animated {\n  animation: progress-bar-stripes 40s linear infinite;\n}\n\n// Perfect scrollbar RTL fix\nbody .ps__rail-y {\n  right: auto !important;\n  left: 1px !important;\n}\n\n// FAQ and Pricing page\n.faq-navigation img,\n.pricing-free-trial .pricing-trial-img {\n  transform: scaleX(-1);\n}\n\n.feather-chevron-left,\n.feather-chevron-right {\n  transform: rotate(-180deg) !important;\n}\n\n// Kanban\n.kanban-application {\n  .kanban-container {\n    .kanban-item {\n      i,\n      svg {\n        margin-right: 0 !important;\n        margin-left: remSizing(0.25);\n      }\n    }\n  }\n}\n\n// Invoice List\n.invoice-list-wrapper {\n  .dataTables_filter {\n    input {\n      margin-left: 0 !important;\n      margin-right: remSizing(0.5);\n    }\n  }\n\n  .dropdown .dropdown-menu.dropdown-menu-right {\n    left: remSizing(2) !important;\n  }\n}\n\n// File Manager\n.file-manager-application {\n  .sidebar-file-manager {\n    .sidebar-inner {\n      .my-drive .jstree-node.jstree-closed > .jstree-icon {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n","@import '../base/bootstrap-extended/variables';\n\n// Layout\n// ========================================================================\nbody,\n#root,\n.wrapper {\n  height: 100%;\n}\n\nbody #root .wrapper .ps__rail-y {\n  left: auto !important ;\n  right: 1px !important;\n}\n\n// Horizontal Menu\n// ========================================================================\n.horizontal-layout {\n  &.navbar-static .navbar-scrolled {\n    background: $white !important;\n    box-shadow: rgba($black, 0.05) 0px 4px 20px 0px !important;\n  }\n\n  // Main Navbar\n  .header-navbar {\n    .navbar-container {\n      .dropdown-language,\n      .dropdown-cart,\n      .dropdown-notification,\n      .dropdown-user {\n        .dropdown-menu {\n          top: remSizing(3) !important;\n        }\n      }\n    }\n  }\n\n  // Menu\n  .horizontal-menu-wrapper {\n    #main-menu-navigation {\n      .dropdown {\n        .dropdown-submenu {\n          .dropdown-toggle:after {\n            margin-top: -5px;\n          }\n        }\n      }\n    }\n\n    .navbar-horizontal {\n      ul.dropdown-menu {\n        // Scrollbar styles\n        &::-webkit-scrollbar {\n          width: 5px;\n          height: 5px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: $gray-500;\n          border-radius: 20px;\n        }\n\n        &::-webkit-scrollbar-track {\n          background: $gray-300;\n          border-radius: 30px;\n        }\n      }\n    }\n  }\n}\n\n// Component Code\n// ========================================================================\n.card-snippet {\n  pre {\n    margin-top: 0;\n    border-radius: remSizing(0.5);\n  }\n}\n\n// Dashboard Analytics\n// =======================================================================\n\n.card-congratulations {\n  .avatar svg {\n    height: 28px !important;\n    width: 28px !important;\n  }\n}\n\n// Card Analytics\n// =======================================================================\n.avg-session-progress {\n  height: 6px;\n}\n\n// Block UI\n// ========================================================================\n.block-ui-container {\n  .block-ui-overlay {\n    background: rgba($black, 0.6);\n  }\n}\n\n// Router Transitions\n// ========================================================================\n.animate__animated.animate__zoomIn,\n.animate__animated.animate__fadeInLeft {\n  --animate-duration: 1s;\n}\n\n// App Ecommerce\n// ========================================================================\n.ecommerce-application {\n  .content-wrapper.animate__animated {\n    animation: none;\n  }\n}\n\n// Customizer\n// ========================================================================\n.customizer {\n  .react-select {\n    width: 100%;\n    max-width: 200px;\n\n    .select__menu {\n      z-index: 2;\n    }\n  }\n}\n","@import '../base/bootstrap-extended/include';\n@import '../base/components/include';\n\n.dark-layout {\n  // Autocomplete Navbar\n  .autocomplete-container {\n    .suggestions-list {\n      .suggestion-item {\n        &.suggestion-title-wrapper h6 {\n          color: $theme-dark-text-muted-color;\n        }\n      }\n    }\n  }\n\n  // Ecommerce Application\n  .ecommerce-application .list-view .ecommerce-card .card-body {\n    border-right-color: $theme-dark-border-color;\n  }\n\n  // Pagination Break\n  .pagination {\n    .break {\n      background-color: $theme-dark-pagination-bg;\n      a {\n        color: $theme-dark-body-color;\n      }\n    }\n  }\n\n  // Invoice data table\n  .invoice-list-wrapper header {\n    background-color: $theme-dark-card-bg;\n  }\n\n  // BlockUI\n  .block-ui-container {\n    .block-ui-overlay {\n      background: $theme-dark-body-bg;\n    }\n    .block-ui-message {\n      color: $theme-dark-body-color;\n    }\n  }\n\n  // Form Control\n  .form-control {\n    background-color: transparent;\n  }\n\n  // Apex Charts\n  .apexcharts-gridlines-vertical line {\n    stroke: $theme-dark-border-color;\n  }\n\n  // Horizontal Menu Scrollbar\n  .horizontal-menu {\n    .horizontal-menu-wrapper {\n      .navbar-horizontal {\n        ul.dropdown-menu {\n          &::-webkit-scrollbar-thumb {\n            background: $theme-dark-body-bg;\n          }\n\n          &::-webkit-scrollbar-track {\n            background: $theme-dark-border-color;\n          }\n        }\n      }\n    }\n  }\n}\n","@import '../base/bootstrap-extended/variables';\n\nhtml[dir='rtl'] {\n  body .ps__rail-y {\n    right: auto !important;\n    left: 1px !important;\n  }\n\n  // Scroll To Top\n  .scroll-to-top {\n    div:first-of-type {\n      left: auto !important;\n      right: 30px;\n    }\n  }\n\n  // Horizontal menu\n  .horizontal-menu .header-navbar.navbar-horizontal .dropdown-menu .dropdown-toggle::after {\n    background-image: url(str-replace(str-replace($chevron-left, 'currentColor', $body-color), '#', '%23'));\n  }\n\n  // Breadcrumbs\n  .breadcrumb:not([class*='breadcrumb-']),\n  .breadcrumb.breadcrumb-chevron {\n    .breadcrumb-item + .breadcrumb-item {\n      &:before {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  // Pagination\n  .pagination .page-item {\n    &.prev-item,\n    &.prev,\n    &.previous {\n      .page-link {\n        &:before {\n          transform: rotate(180deg);\n        }\n        &:hover,\n        &:active {\n          &:before {\n            transform: rotate(180deg);\n          }\n        }\n      }\n      &.disabled {\n        .page-link {\n          &:before {\n            transform: rotate(180deg);\n          }\n        }\n      }\n    }\n\n    &.next-item,\n    &.next {\n      .page-link {\n        &:after {\n          transform: rotate(180deg);\n        }\n        &:hover,\n        &:active {\n          &:after {\n            transform: rotate(180deg);\n          }\n        }\n      }\n      &.disabled {\n        .page-link {\n          &:before {\n            transform: rotate(180deg);\n          }\n        }\n      }\n    }\n    &:first-of-type,\n    &:last-of-type {\n      .page-link svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  // Popover\n  .popover {\n    left: auto !important;\n  }\n\n  // Progress\n  .progress-bar-animated {\n    animation: progress-bar-stripes 40s linear infinite;\n  }\n\n  // Tooltip\n  .bs-tooltip-left .arrow::before,\n  .bs-tooltip-auto[x-placement^='left'] .arrow::before {\n    border-width: remSizing(0.4) 0 remSizing(0.4) remSizing(0.4);\n    border-right-color: $tooltip-bg;\n  }\n\n  .bs-tooltip-left .arrow,\n  .bs-tooltip-auto[x-placement^='left'] .arrow {\n    left: 0;\n    right: auto;\n\n    transform: rotate(180deg);\n  }\n\n  .bs-tooltip-right .arrow::before,\n  .bs-tooltip-auto[x-placement^='right'] .arrow::before {\n    border-width: remSizing(0.4) remSizing(0.4) remSizing(0.4) 0;\n    border-left-color: $tooltip-bg;\n  }\n\n  .bs-tooltip-right .arrow,\n  .bs-tooltip-auto[x-placement^='right'] .arrow {\n    right: 0;\n    left: auto;\n\n    transform: rotate(180deg);\n  }\n\n  // App Email\n  .email-application {\n    .toggle-cc.mr-1 {\n      margin-right: 0 !important;\n      margin-left: remSizing(1) !important;\n    }\n  }\n\n  // App Calendar\n  .app-calendar {\n    .fc-toolbar {\n      .fc-prev-button,\n      .fc-next-button {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  // App Ecommerce\n  .app-ecommerce-details {\n    .swiper-button-next {\n      right: 0;\n      left: auto;\n    }\n  }\n\n  // Invoice List\n  .invoice-list-table-header {\n    select {\n      background-position:\n        calc(100% - (100% - 45px)) 13px,\n        calc(100% - (100% - 20px)) 13px,\n        0% 0 !important;\n    }\n  }\n\n  // TinyMCE\n  .tox-tinymce {\n    .tox-editor-header {\n      direction: ltr;\n    }\n  }\n\n  // Apex Charts\n  .apexcharts-canvas {\n    .apexcharts-tooltip {\n      .apexcharts-tooltip-marker {\n        margin-right: 10px;\n        margin-left: 0 !important;\n      }\n    }\n  }\n\n  // Context Menu\n  .react-contexify {\n    z-index: 1031;\n  }\n\n  // Swiper\n  .swiper-button-next {\n    right: 10px !important;\n    left: auto !important;\n  }\n\n  .swiper-button-prev {\n    left: 10px !important;\n    right: auto !important;\n  }\n\n  // Flatpickr\n  // .flatpickr-calendar {\n  //   .flatpickr-months {\n  //     svg {\n  //       transform: rotate(180deg);\n  //     }\n  //   }\n  // }\n\n  // Wizard\n  .bs-stepper {\n    &:not(.vertical) {\n      .bs-stepper-header .line svg {\n        transform: rotate(180deg);\n      }\n    }\n    .btn-next svg,\n    .btn-prev svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  // Datatables\n  .rdt_Table {\n    [aria-label='Expand Row'] {\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  #profile-info {\n    .post {\n      .post-actions {\n        .share-post {\n          span.mr-1 {\n            margin-right: 0 !important;\n          }\n        }\n      }\n    }\n  }\n}\n","// Component Input\n// ========================================================================\n\n.form-control[readonly] {\n  opacity: 0.5;\n}\n\nselect.form-control[multiple] {\n  background-image: none !important;\n}\n\n.input-group {\n  .form-control.is-invalid ~ .input-group-append .input-group-text {\n    border-color: $danger;\n  }\n  &.is-invalid {\n    .form-control,\n    .input-group-append .input-group-text,\n    .input-group-prepend .input-group-text {\n      border-color: $danger !important;\n    }\n  }\n}\n","// Component Toast\n// ========================================================================\n\n.dark-layout {\n  .card {\n    .toast {\n      background-color: rgba($color: $theme-dark-body-bg, $alpha: 0.85);\n      .toast-header {\n        background-color: $theme-dark-body-bg;\n\n        .close {\n          color: $theme-dark-body-color;\n        }\n      }\n    }\n  }\n}\n","// Switch\n// =======================================================================\n[dir] .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: $primary;\n  background-color: $primary;\n}\n","// Component Dropdown\n// ========================================================================\n\n@import '../../base/bootstrap-extended//variables';\n\n// Navbar Dropdowns\n.dropdown-notification,\n.dropdown-cart {\n  .dropdown-menu {\n    left: inherit !important;\n  }\n}\n\n.dropdown-language {\n  .country-flag {\n    height: 18px !important;\n    width: 18px !important;\n  }\n\n  .dropdown-menu {\n    left: auto !important;\n  }\n}\n\n.dropdown-user {\n  .dropdown-menu {\n    left: auto !important;\n    right: 0;\n  }\n}\n\n// Global\n.dropdown-menu {\n  .dropdown-item:focus {\n    outline: 0;\n  }\n}\n\n// Dropdown Icon\n.dropdown-icon-wrapper {\n  .dropdown-toggle:after {\n    display: none;\n  }\n  .dropdown-menu {\n    min-width: auto;\n    .dropdown-item {\n      padding: remSizing(0.5) remSizing(1.1);\n      cursor: pointer;\n    }\n  }\n}\n","// Component App Collapse\n// ========================================================================\n@import '../../base/bootstrap-extended/variables';\n\n.app-collapse {\n  &.card {\n    .card-header {\n      padding: remSizing(1);\n    }\n\n    svg {\n      transition: all 300ms linear 0s;\n    }\n    .card-header:not(.collapsed) {\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n  }\n  .collapse-title {\n    max-width: calc(100% - 25px);\n  }\n}\n","// Component App Collapse\n// ========================================================================\n\nhtml[dir='rtl'] {\n  .carousel {\n    .carousel-control-next-icon,\n    .carousel-control-prev-icon {\n      transform: rotate(180deg);\n    }\n  }\n}\n","// Component Pagination\n// ========================================================================\n.pagination {\n  &.react-paginate {\n    .page-item.prev,\n    .page-item.next {\n      a.page-link:before,\n      a.page-link:after {\n        height: 16.5px;\n        margin-top: 1px;\n      }\n    }\n    &.pagination-sm {\n      .page-item.prev,\n      .page-item.next {\n        a.page-link:before,\n        a.page-link:after {\n          height: 15px;\n        }\n      }\n    }\n    &.pagination-lg {\n      .page-item.prev,\n      .page-item.next {\n        a.page-link:before,\n        a.page-link:after {\n          height: 19px;\n        }\n      }\n    }\n  }\n\n  &.no-navigation {\n    li:first-of-type,\n    li:last-of-type {\n      display: none;\n    }\n  }\n}\n",".loading {\n  position: absolute;\n  left: calc(50% - 35px);\n  top: 50%;\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 3px solid transparent;\n\n  &.component-loader {\n    margin-top: -60px;\n  }\n\n  .effect-1,\n  .effect-2 {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(121, 97, 249, 1);\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .effect-1 {\n    animation: rotate 1s ease infinite;\n  }\n  .effect-2 {\n    animation: rotateOpacity 1s ease infinite 0.1s;\n  }\n  .effect-3 {\n    width: 100%;\n    height: 100%;\n    border: 3px solid transparent;\n    border-left: 3px solid rgba(121, 97, 249, 1);\n    -webkit-animation: rotateOpacity 1s ease infinite 0.2s;\n    animation: rotateOpacity 1s ease infinite 0.2s;\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .loading .effects {\n    transition: all 0.3s ease;\n  }\n}\n.fallback-logo {\n  position: absolute;\n  left: calc(50% - 28px);\n  width: 45px;\n  height: auto;\n}\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes rotateOpacity {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n    opacity: 0.1;\n  }\n  100% {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n    opacity: 1;\n  }\n}\n","/* IMPORTANT NOTE\nThis is a Vuexy Theme Admin Customized CSS\nThise file was made to override the admin panel CSS for MarketFuel®\nTake Caution in making changes to this file or everything will explode\n*/\n\n@import '../../@core/scss/base/bootstrap-extended/variables';\n\n.dark-layout .footer-fixed .footer {\n  background-color: $mf-mdgrey !important;\n}\n\n// body.dark-layout {\n//   background-color: $mf-darkgrey !important;\n// }\n\n.dark-layout .avatar {\n  background: none !important;\n}\n.avatar {\n  background-color: $white;\n  // margin-left: 11px;\n}\n\n// Menu Ends\n\n// Buttons Begins\n.btn-danger {\n  background-color: $mf-red !important;\n}\n.btn-danger:hover {\n  background-color: $mf-lightblue !important;\n}\n.admin-buttons {\n  background: none !important;\n  border: none !important;\n}\n// Buttons Ends\n\n.dark-layout .table,\n.dark-layout .card,\n.dark-layout .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th,\n.dark-layout .table:not(.table-dark):not(.table-light) tfoot:not(.thead-dark) th {\n  background-color: $mf-mdgrey !important;\n}\n.dark-layout .table thead th {\n  border-bottom: 2px solid $mf-lightblue !important;\n  border-top: none !important;\n  border-color: $mf-lightblue !important;\n}\n.dark-layout .table.table-hover tbody tr:hover,\n.dark-layout .table.table-striped tbody tr:nth-of-type(odd),\n.dark-layout input.form-control,\n.dark-layout .custom-file-label,\n[dir] .dark-layout textarea.form-control {\n  background-color: $mf-darkgrey;\n}\n.badge {\n  border-radius: 4px !important;\n}\n.badge-danger {\n  background-color: $mf-red !important;\n}\n.card-header {\n  padding: remSizing(0.75) remSizing(1.5);\n}\n\n// Action Buttons Icons Begins\n.action-item {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin: 2%;\n  padding: 3px;\n  border: 1px solid #ffffff00;\n}\n.action-item:hover {\n  background-color: #f3f2f7 !important;\n  border-radius: 4px;\n  border: solid 1px #b1b1b1 !important;\n}\n.action-icon {\n  // display: inline-grid;\n  justify-items: center;\n}\n.action-icon > svg,\n.action-icons > svg,\n.simple-sku-menubar > svg,\n.user-status > svg {\n  width: 19px !important;\n  margin-right: 0px !important;\n}\n.delete {\n  color: $mf-red !important;\n}\n.edit {\n  // color: $mf-navy !important;\n}\n.icon-width > svg {\n  width: 17px;\n  margin-left: 4px !important;\n  margin: 0 !important;\n}\n// Action Buttons Icons Ends\n\n// Search Icon Begins\n.search-icon {\n  width: fit-content;\n  height: auto !important;\n  display: flex;\n  justify-content: flex-end;\n  background-color: #01a0dd !important;\n  border-radius: 4px;\n  align-items: center;\n  padding: 4.5px 13px;\n  color: white;\n  margin: 0;\n  justify-content: center;\n  align-items: center;\n}\n.search-icon > svg {\n  width: 19px;\n}\n.role-flex,\n.icon-width {\n  display: flex !important;\n  align-items: center !important;\n}\n.breadcrumb {\n  background: none !important;\n}\n// .simple-sku-menubar {\n//   display: inline-flex;\n//   justify-content: center;\n//   background: none !important;\n//   border-right: solid 1px white;\n//   align-items: center;\n// }\n// .simple-sku-menubar:hover,\n// .simple-sku-menubar:active,\n// .simple-sku-menubar .active,\n// .simple-sku-form-link-row > .active {\n// background-color: $white !important;\n// color: $mf-navy;\n// }\n// .dark-layout .simple-sku-menubar:hover,\n// .dark-layout.simple-sku-menubar:active,\n// .dark-layout .simple-sku-menubar .active,\n// .dark-layout .card .card-header:nth-child(2) .simple-sku-form-link-row > .active {\n//   background-color: $mf-mdgrey !important;\n//   color: $white;\n// }\n.simple-sku-menubar:last-child {\n  border-right: none;\n}\n.card > .card-header:nth-child(2) {\n  // background-color: $mf-navy !important;\n  padding: inherit;\n}\n.dark-layout select.form-control,\n.dark-layout .custom-select {\n  background-color: $mf-darkgrey;\n}\n.simple-sku-form-link-row {\n  display: flex;\n  height: 42px;\n  margin: 0;\n}\n.portal_actions {\n  display: flex;\n}\n\n.badge {\n  padding: 5px !important;\n  margin: 0px !important;\n}\n\n.mgtags {\n  padding: 2px 20px !important;\n}\n\n[dir] .admin-buttons .btn:not(.customer-btn, .product-btn) {\n  margin-bottom: 0px !important;\n}\n\n.tdactions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n// .collapse.show{\n//     background-color: white !important;\n// }\n\n.si-flex {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n// Page Content Ends\n\n// Devex\n.devex-success {\n  color: #fff;\n  background-color: #28c76f;\n}\n\n.dx-icon-clear .devex-success {\n  background-color: #fff;\n}\n\n.edit-customer-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n","/*================================================================================\n\tItem Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template\n\tVersion: 2.0\n\tAuthor: PIXINVENT\n\tAuthor URL: http://www.themeforest.net/user/pixinvent\n================================================================================\n\nNOTE:\n------\nPLACE HERE YOUR OWN SCSS CODES AND IF NEEDED, OVERRIDE THE STYLES FROM THE OTHER STYLESHEETS.\nWE WILL RELEASE FUTURE UPDATES SO IN ORDER TO NOT OVERWRITE YOUR STYLES IT'S BETTER LIKE THIS.  */\n\n// If you want to add something do it here\n@import 'custom';\n\n// ie fixes\n@import 'ie-fix';\n\n.spinner {\n  // width: 40px;\n  // height: 40px;\n  // margin: 100px auto;\n  // background-color: #333;\n\n  // border-radius: 100%;\n  // -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;\n  // animation: sk-scaleout 1.0s infinite ease-in-out;\n}\n\n@-webkit-keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes sk-scaleout {\n  0% {\n    -webkit-transform: scale(0.95) translate(-50%, -50%);\n    transform: scale(0.95) translate(-50%, -50%);\n    opacity: 0.65;\n  }\n  // 30% {\n  //   -webkit-transform: rotate(45deg) translate(-50%, -50%);\n  //   transform: rotate(45deg) translate(-50%, -50%);\n  // }\n  // 50% {\n  //   -webkit-transform: rotate(-360deg) translate(-50%, -50%);\n  //   transform: rotate(-360deg) translate(-50%, -50%);\n  // }\n  // 70% {\n  //   -webkit-transform: rotate(0deg) translate(-50%, -50%);\n  //   transform: rotate(0deg) translate(-50%, -50%);\n  // }\n  100% {\n    -webkit-transform: scale(1) translate(-50%, -50%);\n    transform: scale(1) translate(-50%, -50%);\n  }\n}\n\n@keyframes roll {\n  0% {\n    transform: translateX(-150%) rotate(0deg);\n  }\n  100% {\n    transform: translateX(150%) rotate(360deg);\n  }\n}\n\n@keyframes logo-spin {\n  0% {\n    transform: scale(0.85);\n  }\n  100% {\n    transform: scale(0.8);\n  }\n}\n","// THIS IS THE GOOD CSS\n\n// @import 'variables';\n@import '../../@core/scss/base/bootstrap-extended/_variables.scss'; // Bootstrap custom variable override (for user purpose)\n\n// Here you can add other styles\n$danger: #de3f3f;\n\n// .hide-dx-button .dx-button {\n//   display: none;\n// }\n\n.quarterCol {\n  padding: 10px 25px;\n}\n\n.dx-widget {\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n}\n\n.dx-badge {\n  background-color: #ff0000;\n  color: white;\n  border-radius: 50%;\n  padding: 4px;\n  width: 12px;\n  height: 12px;\n  font-size: 16px;\n  margin-left: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: unset;\n}\n\n.quarterCol > .row {\n  height: 100%;\n  // border: 1px solid lightgrey;\n  border-radius: 10px;\n  //background-color: lightgray;\n  //padding: 0px 15px 0px 15px;\n  padding-bottom: 10px;\n  //margin: 5px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  box-shadow: 0px 0px 8px #d9d9d9;\n}\n\n.quarterColDividerContainer {\n  text-align: center;\n  height: 40px;\n  align-items: center;\n}\n\n.quarterColDivider {\n  color: lightgrey;\n}\n\n.quarterColDivider .horizontal {\n  width: 75%;\n  padding: '15px 30px';\n  margin: '15px 30px';\n}\n\n.fulfillmentView .row div {\n  // padding-top: 5px;\n}\n\n.icon-info {\n  content: '\\24D8';\n}\n\n.dx-radiobutton-icon:before {\n  // width:10px;\n  // height:10px;\n  transform: scale(0.7);\n  margin: auto;\n}\n\n.dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {\n  transform: scale(0.7);\n  //display: block;\n  //margin-top: -9px;\n  //margin-left: 4px;\n  //width: 5px;\n  //height: 5px;\n  //background: #337ab7;\n  //content: \"\";\n  //border-radius: 5px;\n  -webkit-transform: scale(0.7);\n  -moz-transform: scale(0.7);\n  -ms-transform: scale(0.7);\n  -o-transform: scale(0.7);\n}\n\n.fulfillmentNavButton > .dx-button-content {\n  padding: 5px 10px;\n  // margin: 0px;\n  // color: blue;\n}\n\n.app-footer {\n  justify-content: right;\n}\n\n.smart-grid {\n  width: auto;\n  height: auto;\n}\n\n.smart-grid-command-item {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  align-items: center;\n}\n\n.danger-color {\n  color: $danger;\n}\n\n.paginated-checkbox-select,\n.checkbox-header-cell {\n  // background-color: #FFF;\n  // display: flex;\n  // align-items: center;\n  // align-self: center;\n  // align-content: center;\n  width: 39px;\n}\n\nul {\n  list-style-type: none;\n  padding-inline-start: 0;\n}\n\n.error {\n  color: red;\n  font-weight: bold;\n}\n\n.btn-left-space {\n  margin-left: 4px;\n}\n\n.show-logo {\n  max-height: 50px;\n  padding-right: 20px;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\nlabel {\n  font-weight: 600;\n}\n\n.page_list_item {\n  background: white;\n  border: 1px solid #c8ced3;\n}\n\n.lifted {\n  display: table;\n  background: lightgray;\n}\n\n.grip_icon {\n  display: flex;\n\n  i {\n    width: 6px;\n  }\n}\n\n.card-header {\n  .tooltip_label {\n    label {\n      color: inherit;\n    }\n  }\n  .btn-link {\n    color: inherit;\n  }\n  h4 {\n    color: inherit;\n  }\n}\n\n.tooltip_label {\n  display: flex;\n  align-items: center;\n\n  label {\n    margin-right: 6px;\n  }\n\n  i {\n    margin-bottom: 7px;\n  }\n}\n\n.tooltip_checkbox {\n  display: inline-flex;\n  align-items: center;\n\n  span {\n    margin-right: 6px;\n  }\n\n  i {\n    margin-bottom: 3px;\n  }\n}\n\n.tooltip_text {\n  max-width: 250px;\n  font-weight: 400;\n}\n\n.breadcrumb-container {\n  position: fixed;\n  width: 100%;\n  z-index: 9;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  background-color: #3a4248;\n  border: none;\n}\n\n.breadcrumb-root {\n  position: absolute;\n  left: calc(100% - 400px);\n  top: 0px;\n  font-weight: 600;\n  padding-top: 10px;\n  // height: 45px;\n  width: 200px;\n  text-align: center;\n  // background: rgba(100, 100, 100, 0.1);\n  background: #20a8d8;\n}\n\n.mf-card {\n  border: none;\n  box-shadow: 1px 1px 12px #b9b9b9;\n}\n\n.card {\n  margin-bottom: remSizing(1);\n  margin-top: remSizing(1);\n}\n\n.card-for-credit {\n  margin-bottom: remSizing(0.3);\n  min-height: 500px;\n}\n\n.login-page {\n  min-height: 100vh;\n}\n\n.dark-layout .login-card {\n  // background color should not need to be overwritten here if the value remains the same\n  // background-color: $white;\n\n  h1 {\n    color: #676d7d;\n  }\n}\n\n.dark-layout .login-page {\n  background-color: #2b2a33 !important;\n}\n\n.dark-layout .sign-in-input {\n  background-color: #e8f0fe !important;\n  color: #2b2a33 !important;\n}\n\n.sign-in-input {\n  width: 100%;\n}\n\n// .card-boby-sku {\n//   background-color: #dcdbde;\n// }\n\n.login-container {\n  background-color: $brand-dark-bg;\n}\n\n.login-card {\n  background-color: $white;\n\n  a {\n    color: $brand-purple;\n\n    &:hover {\n      color: $brand-purple-hover;\n    }\n  }\n}\n\n.admin_login_logo {\n  height: 100%;\n  width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  // padding-left: 100px;\n  img {\n    max-width: 200px;\n    height: auto;\n  }\n}\n\n.card-password-form {\n  display: flex;\n}\n\n.card-body-password-form {\n  margin-top: 30px;\n}\n\n.login-divider-container {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 10px 0;\n}\n\n.login-divider-border {\n  flex-grow: 1;\n  height: 1px;\n  background: #6e6b7b;\n  margin: 0;\n}\n\n.login-divider-text {\n  padding: 0 10px;\n  color: #6e6b7b;\n}\n\n.full-width-button {\n  width: 100%;\n}\n\n.token-button {\n  background-color: darkgrey;\n  color: default;\n  border: none;\n  height: 38px;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 4px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: #808080 !important;\n  }\n}\n\n.login-button {\n  background-color: $brand-purple;\n  border: none;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: $brand-purple-hover !important;\n  }\n}\n\n.sso-button {\n  border: none;\n  background-color: $sso-btn;\n  height: 38px;\n  color: black;\n  margin-bottom: 10px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $sso-btn-hover !important;\n    color: black;\n  }\n}\n\n.google-signin-button img {\n  cursor: pointer;\n  height: 21px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.microsoft-signin-button img {\n  cursor: pointer;\n  max-height: 38px;\n  margin: 0;\n  padding-right: 10px;\n}\n\n.user-nav {\n  min-width: 115px;\n}\n\n.dropdown-options {\n  min-width: 190px;\n  width: auto;\n}\n\n//SKU SIMPLE FORM\n.simple-sku-menubar,\n.simple-sku-form-breadcrumb {\n  text-align: center;\n  background-color: var(--mf-colors-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border-right: 1px solid var(--mf-colors-neutral-50);\n}\n\n.simple-sku-menubar.active,\n.simple-sku-form-breadcrumb.active {\n  background-color: var(--mf-colors-neutral-50);\n  font-weight: 900;\n  text-decoration: underline;\n}\n\n.simple-sku-form-breadcrumb.active::before,\n.simple-sku-form-breadcrumb.active::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n// .simple-sku-form-breadcrumb.active::after {\n//   border-radius: 0em;\n//   border-width: 0.8em;\n//   border-right-color: #f0f3f5;\n//   border-bottom-color: #f0f3f5;\n//   border-top-color: #f0f3f5;\n// }\n\n.simple-sku-form-link {\n  width: calc(100% - 30px);\n  height: 95%;\n  background-color: #fff;\n  color: grey;\n}\n\n.simple-sku-form-link:active {\n  background-color: #20a8d8 !important;\n  color: #fff !important;\n}\n\n.sku-form-warning-text {\n  text-align: right;\n  color: red;\n  margin-top: 15px;\n}\n\n.sku-client-dropdown {\n  margin-top: 15px;\n}\n\n.warehouse-list-info {\n  margin-bottom: remSizing(1);\n  margin-top: 2px;\n  margin-left: 10px;\n  margin-right: 5px;\n  background-color: aliceblue;\n}\n\n.btn-info {\n  color: #fff;\n}\n\n//Single file drop Dropzone styling\n\nimg {\n  max-height: 240px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.app-container {\n  width: 500px;\n  margin: 30px auto;\n}\n\n.clear {\n  clear: both;\n}\n\n.details,\n.title {\n  text-align: center;\n}\n\n.error {\n  margin-top: 4px;\n  color: red;\n}\n\n.red-text {\n  color: red;\n}\n\n.has-error {\n  border: 1px dotted red;\n}\n\n.image-container {\n  align-items: center;\n  display: flex;\n  width: 85%;\n  height: 80%;\n  float: left;\n  margin: 15px 10px 10px 37px;\n  text-align: center;\n  justify-content: 'center';\n}\n\n.preview-container {\n  height: 335px;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.placeholder-preview {\n  cursor: pointer;\n}\n\n.placeholder-preview,\n.render-preview {\n  text-align: center;\n  background-color: #efebeb;\n  height: 100%;\n  width: 100%;\n  border-radius: 5px;\n}\n\n.upload-container {\n  cursor: pointer;\n  height: 300px;\n}\n\n.jqx-fill-state-normal {\n  font-family:\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,\n    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji' !important;\n}\n\n.img-avatar,\n.avatar > img,\n.img-circle {\n  max-width: 100%;\n  height: auto;\n  border-radius: 0;\n}\n\n.image-deletion {\n  position: absolute;\n  margin-left: -40px;\n  margin-top: 4px;\n  background: #fff;\n}\n\n.admin-buttons {\n  background: #f0f3f5;\n  border: 1px solid #c8ced3;\n  border-radius: remSizing(0.25);\n  padding: 5px;\n  float: left;\n  margin: 6px 16px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.admin-buttons.col-12 {\n  flex: 0 1 100%;\n}\n\n.admin-buttons .btn {\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n.product-actions {\n  float: right;\n}\n\n.product-actions .btn {\n  margin-right: 10px;\n}\n\n.product-actions .btn:last-child {\n  margin-right: 0px;\n}\n\n.th-width {\n  min-width: 300px;\n}\n\n.text-difference-portal {\n  background-color: #4dbd74;\n  color: #fff;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 85%;\n}\n\n.text-difference-location {\n  background-color: #ffc107;\n  color: #23282c;\n  padding-left: 5px;\n  border-radius: 5px;\n  font-size: 85%;\n  font-weight: 700;\n}\n\n#spinner-overlay {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1030;\n  background-color: rgb(0, 0, 0, 0.2);\n}\n\n.wrapper.menu-hide #spinner-overlay {\n  width: 100%;\n  left: 0;\n}\n\n.mf-loading-spinner {\n  width: $space-24;\n  height: $space-24;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 10000000;\n  border-radius: 999px;\n  border: 3px solid $brand-purple;\n  background-color: rgb(200, 200, 200, 0.6);\n\n  // margin: 100px auto;\n  -webkit-animation: sk-scaleout 1s infinite ease-out alternate;\n  animation: sk-scaleout 1s infinite ease-out alternate;\n}\n\n.mf-loading-logo {\n  // position: absolute;\n  // top: 50%;\n  // left: 50%;\n  // transform: translate(-50% -50%);\n  -webkit-animation: logo-spin 1s infinite ease-out alternate;\n  animation: logo-spin 1s infinite ease-out alternate;\n  border-radius: 999px;\n  // scale: 0.7;\n}\n\n.simple-sku-form-link-row .simple-sku-form-links button.simple-sku-form-link.active {\n  color: #ffffff;\n  background-color: #21a8d8;\n  border: none;\n}\n\n.simple-sku-form-link.btn-secondary:not(:disabled):not(.disabled).active {\n  color: #ffffff !important;\n  background-color: #21a8d8;\n  border: none;\n}\n\n// .completed-step {\n//   background: #169acac4;\n//   color: #fff;\n// }\n\n.container-fluid {\n  margin-top: 60px;\n}\n\n.client-background {\n  background: rgb(202, 255, 199);\n}\n\n.portal-background {\n  background: rgb(253, 255, 199);\n}\n\n.product-background {\n  background: rgb(245, 198, 135);\n}\n\n.admin-background {\n  background: rgb(251, 210, 217);\n}\n\n.location-background {\n  background: rgb(211, 204, 253);\n}\n\n.label-column.col-md-6 {\n  padding-top: 10px;\n}\n\n// CATEGORY STUFF\n\n.new-menu-item {\n  margin-bottom: remSizing(2);\n}\n\n.cat_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n\n  .button_text {\n    font-size: 20px;\n    line-height: 28px;\n  }\n}\n\n// .box_disabled {\n//   background-color: #dcdbde;\n// }\n\n// .box-enabled {\n//   background-color: white;\n// }\n\n.disabled_text {\n  font-size: 10px;\n}\n\n.cat_prod_box {\n  width: 100%;\n  height: auto;\n  padding-left: 15px;\n\n  p {\n    font-size: 15px;\n    line-height: 15px;\n  }\n}\n\n.card-header .dropdown button.btn-secondary {\n  padding: 0px 10px;\n  margin: 0 10px;\n}\n\n// configurable option\n\n.configurable-option-img-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.basic-multi-select {\n  color: black;\n}\n\n.badge {\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.add-remove-modal-cont {\n  margin-top: 15px;\n  padding-right: 15px;\n  padding-left: 30px;\n}\n\n.stock-col {\n  padding-right: 5px;\n  width: 50%;\n}\n\n.vertical-rule-col {\n  width: 2%;\n  flex: none;\n}\n\n.vertical-rule {\n  height: 100%;\n  width: 1px;\n  background-color: #ebe9f1;\n  margin-left: 20px;\n  display: flex;\n}\n\n.on-hand-col {\n  padding-top: 5px;\n  padding-right: 5px;\n  width: 24%;\n  flex: none;\n  padding-left: 100px;\n}\n\n.available-col {\n  padding-top: 5px;\n  padding-left: 45px;\n  width: 24%;\n  flex: none;\n}\n\n.reason-col {\n  padding-left: 14px;\n  padding-right: 28px;\n}\n\n.stock-error {\n  width: 100%;\n  margin-top: remSizing(0.25);\n  font-size: remSizing(0.857);\n  color: #de4827;\n}\n\n.reason-error {\n  text-align: right;\n}\n\n.stock-hr {\n  margin-right: 16px;\n}\n\n.stock-buttons {\n  margin: 10px 16px 20px 0;\n}\n\n#all-stocks {\n  padding: 0px !important;\n}\n\n#base-n-sub-sku-stocks {\n  padding: 0px !important;\n}\n\n//STOCK MANAGEMENT\n\n.product-at-stock-management-header {\n  display: inline-flex;\n  width: 340px;\n}\n\n.product-at-stock-management {\n  display: inline-flex;\n  width: 325px;\n}\n\n#stock-product-header {\n  .badge-primary {\n    width: 150px;\n  }\n\n  .badge-secondary {\n    width: 150px;\n  }\n\n  .badge-warning {\n    width: 150px;\n  }\n}\n\n#stock-product-search-form {\n  .form-control {\n    border: 1px solid #5d9ee0;\n  }\n}\n\n#stock-product-top-header {\n  background-color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  padding-left: 33px;\n  border: 1px solid #ccc;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n\n  .top-header-column {\n    display: inline-block;\n    width: 150px;\n    text-align: center;\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n\n  .top-header-column-sku {\n    display: inline-block;\n    width: 180px;\n    text-align: center;\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n}\n\n.form-control-stock-search {\n  padding: remSizing(0.5) remSizing(1);\n  font-size: 13px;\n  line-height: 0.5;\n  border: 1px solid #ccc;\n}\n\n#base-n-sub-sku-stocks {\n  .card-header {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n}\n\n.top-bottom-padding {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.statement-header {\n  background-color: #f0f3f5;\n  text-align: right;\n}\n\n.credit {\n  background-color: #c2e9ef;\n  text-align: right;\n}\n\n.debit {\n  background-color: #efcfb8;\n  text-align: right;\n}\n\n.menu-example-container {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 50px;\n  border: 1px solid #000;\n}\n\n.menu-example {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  p {\n    padding: 10px;\n  }\n}\n\n.menu-example-logo {\n  width: 300px;\n  height: auto;\n  padding-top: 20px;\n}\n\n.no-decoration {\n  color: #23282c;\n}\n\n.no-decoration:hover {\n  color: #23282c;\n  text-decoration: none;\n}\n\n// bundle table styling\n.th-column-action {\n  width: 25%;\n  padding-bottom: 47px !important;\n}\n\n.td-column-action {\n  width: 25%;\n}\n\n.th-column-sku {\n  padding-bottom: 47px !important;\n}\n\n.card-header {\n  color: var(--mf-colors-fg);\n  background-color: $card-header-bg !important;\n  border-bottom: 5px solid $card-header-border;\n\n  input {\n    color: var(--mf-colors-fg);\n  }\n}\n\n// .draggable-item{\n//   background: red;\n// }\n\n[draggable] {\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Required to make elements draggable in old WebKit */\n  -khtml-user-drag: element;\n  -webkit-user-drag: element;\n}\n\n.child-product-table {\n  padding: 15px;\n}\n\n.column {\n  padding: 10px;\n\n  margin-right: 5px;\n\n  height: 30px;\n  -webkit-box-shadow: inset 0 0 3px #000;\n  -ms-box-shadow: inset 0 0 3px #000;\n  box-shadow: inset 0 0 3px #000;\n  text-align: left;\n  cursor: move;\n\n  td {\n    padding: 7px;\n  }\n}\n\n.child-product-table {\n  border: none;\n}\n\n.child-table {\n  width: 100%;\n  min-height: 250px;\n}\n\n#child-product-table {\n  width: 100%;\n}\n\n.child-table-over,\n.group-dropzone-over {\n  min-height: 250px;\n  border: 2px dashed #000;\n}\n\n.user-cart-table tr td {\n  color: #fff;\n}\n\n.group-bundle-body,\n.group-dropzone {\n  min-height: 250px;\n}\n\n.dropzone-item {\n  padding: 7px;\n}\n\n.dropzone-cell {\n  padding: 2px;\n}\n\n.selected-bundle-name {\n  display: flex;\n  justify-content: space-between;\n}\n\n.group-dropzone-select {\n  margin: 5px;\n}\n\n.group-user-select {\n  padding: 5px;\n  margin: 5px 24px 0px 0px;\n  border: 2px solid lightblue;\n  border-radius: 3px;\n  color: lightblue;\n}\n\n.preview-group-products {\n  margin-left: 10px;\n}\n\n.preview-group-bundle,\n.preview-individual-bundle {\n  border: 1px solid #ccc;\n  padding-left: 7px;\n  padding-top: 7px;\n  margin-top: 15px;\n\n  h5 {\n    margin-top: 7px;\n  }\n}\n\n.bundle-flag {\n  color: #335269;\n  border: 1px solid #335269;\n  padding: remSizing(0.25) remSizing(0.5);\n  border-radius: remSizing(0.2);\n  font-size: remSizing(0.76562);\n}\n\n.table.bundleProducts {\n  margin-top: 20px;\n}\n\n.formgroup-bundle {\n  flex-direction: row !important;\n  padding: 15px 5px 5px 5px;\n\n  label {\n    padding: 10px;\n  }\n}\n\n.bundle-product-table {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bundle-table {\n  padding: 8px;\n  margin-bottom: 0px;\n}\n\ntable td.bundle-table-cell {\n  padding: 0;\n}\n\n.category-table {\n  color: #5c6873;\n  background-color: #e4e7ea;\n  vertical-align: bottom;\n  border: 2px solid #c8ced3;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 10px;\n  margin: 0px;\n}\n\n.parent-category-list {\n  background-color: white;\n  //vertical-align: bottom;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.child-category-list {\n  background-color: #f4f4f4;\n  //vertical-align: bottom;\n  border: 0.5px solid #c8ced3;\n  padding: 15px 0px 7.5px 0px;\n  margin: 0px;\n  vertical-align: middle;\n}\n\n.modal-dialog {\n  max-width: 90%;\n  width: 90%;\n}\n\n.modal-dialog.modal-slim {\n  width: 40%;\n}\n\n.sk-spinner-pulse.sk-spinner-green.sk-spinner-inline {\n  width: 10%;\n  height: 40px;\n  position: relative;\n  left: 0;\n  top: 0;\n  margin: 0px auto;\n}\n\n.form-group.d-inline {\n  display: inline !important;\n}\n\n.purchase-order-new-product {\n  max-width: 100%;\n}\n\n.code-generation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 60px 0 60px 0;\n\n  h3 {\n    padding-bottom: 25px;\n  }\n}\n\n.top-form-po {\n  width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border: 0.5px solid #c8ced3;\n  margin-top: -1px;\n  position: relative;\n  padding-top: 10px;\n}\n\n.header-top-form-po {\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #c8ced3;\n  padding-top: 11px;\n  padding-left: 18px;\n}\n\n.total-product-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.discount-taxes-po {\n  width: 100%;\n  background-color: white;\n  padding: 10px;\n  margin-bottom: 5px;\n}\n\n.total-price {\n  width: 100%;\n  text-align: right;\n  background-color: white;\n  padding: 8px 27px;\n  margin-bottom: 5px;\n  font-weight: 700;\n  border: 0.5px solid #c8ced3;\n}\n\n.po-bottom-fields {\n  border: 0.5px solid #c8ced3;\n  background-color: white;\n  margin-bottom: 15px;\n}\n\n.product-table-po {\n  margin-bottom: 0px !important;\n}\n\n.tr-header-style {\n  background-color: #335169;\n  color: white;\n}\n\n.po-creation-date {\n  padding: 14px 1px 16px 16px;\n}\n\n.po-discount {\n  background-color: white;\n  padding: 10px;\n  text-align: right;\n  margin-bottom: 1px;\n  padding-right: 27px;\n  border: 0.5px solid #c8ced3;\n}\n\n.product-table-po .table-bordered tr td {\n  padding: 5px;\n}\n\n.product-table-po .table-bordered tr td datafield {\n  background-color: red;\n}\n\n.po-form .rw-dropdown-list.rw-widget {\n  width: 300px;\n}\n\n.date-picker-po-edit .date-input {\n  width: 180px;\n  height: 33px;\n  border-radius: 5px;\n  border-width: thin;\n}\n\n.date-picker-po-edit .date-input-error {\n  width: 180px;\n  border-color: #ea5455;\n  border-radius: 5px;\n  border-width: 2px;\n}\n\n//Goods receipts\n\n.goods-receipt-form {\n  background-color: white;\n}\n\n/** Shipper HQ items */\n\n.shipping-selected-names {\n  padding: 7px;\n  border: 1px solid black;\n  border-radius: 4px;\n  margin-right: 7px;\n}\n\n.shipping-selected-names-row {\n  padding: 5px;\n  line-height: 2.5;\n}\n\n.comparison-list {\n  white-space: normal;\n  text-align: left;\n}\n\n.po-list .react-bs-table table td,\n.react-bs-table table th {\n  white-space: initial;\n}\n\n.good-receipts-notes-PO-show {\n  border: 0.5px solid #c8ced3;\n  padding: 10px;\n  margin-bottom: 20px;\n}\n\n.po-form-status {\n  margin-bottom: 12px;\n  // margin-top: -13px;\n}\n\n.td-header-error {\n  color: red;\n}\n\n.suborder-tag-remove-btn {\n  position: absolute;\n  top: -20px;\n  left: -20px;\n}\n\n.nav-bar-warning,\n.nav-bar-warning a {\n  margin: 0 auto !important;\n  font-size: 30px !important;\n  text-align: center !important;\n  color: red !important;\n  p {\n    margin-bottom: 0px !important;\n  }\n}\n\n.address_error {\n  color: red;\n}\n\n.roleButton {\n  margin-top: 10px;\n}\n\n.icon {\n  padding: 4px;\n}\n\n.product-spec-component .form-group {\n  padding: 5px 15px;\n  margin-bottom: 0;\n}\n\n.field-group .field-option {\n  margin-bottom: none !important;\n}\n\n.tier-price-box {\n  border: 1px solid #e4e5e6;\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.role-table .react-bs-table table td {\n  white-space: normal !important;\n}\n\n.role-name {\n  margin-right: 7px;\n}\n\n.price-configuration {\n  display: flex;\n  justify-content: space-between;\n}\n\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 35px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  .checkmark {\n    position: absolute;\n    top: -10px;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 1px solid black;\n  }\n}\n\n.checkbox-container:hover input ~ .checkmark {\n  background-color: #ccc;\n}\n\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #335269;\n}\n\n.checkbox-container :after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n.checkbox-container .checkmark:after {\n  left: 7px;\n  top: 3px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n#custom_css_block {\n  max-width: 100%;\n}\n\n.portal-form {\n  background-color: #ffffff !important;\n}\n\n.bundle-edit-name {\n  font-size: 15px;\n  width: 300px;\n}\n\n.bundle-edit-name-input {\n  width: 300px;\n  color: #000;\n}\n\n.bundle-edit-description-input {\n  width: 300px;\n}\n\n.bundle-edit-description {\n  margin-left: 5px;\n}\n\n.bundle-edit-descr-label {\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.bundle-edit-filter {\n  float: right;\n  color: #000;\n}\n\n.bundle-edit-label {\n  display: inline-block;\n  width: 100px;\n}\n\n.bundle-group-new-edit {\n  margin-bottom: 5px;\n\n  input {\n    width: 200px;\n  }\n}\n\n.bundle-product-disabled {\n  background-color: #dcdcdc;\n\n  td {\n    color: rgba(0, 0, 0, 0.3);\n  }\n}\n\n.bundle-group-disabled {\n  background-color: #dcdcdc;\n\n  div span {\n    color: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.disabled-group-header {\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.bundle-group-body-disabled {\n  .bundle-edit-descr-label,\n  .bundle-edit-description,\n  th,\n  td {\n    color: rgba(0, 0, 0, 0.4);\n  }\n}\n\n.icon-button-dimensions {\n  background-color: #00a0dd !important;\n  border-color: #00a0dd !important;\n}\n\n.icon-button-dimensions:hover {\n  background-color: #0576a3 !important;\n  border-color: #0576a3 !important;\n}\n\n// JQX GRID\n\n.cell-left-aligned {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding-bottom: 2px !important;\n  text-align: left !important;\n  margin-right: 2px !important;\n  margin-left: 4px !important;\n  font-weight: normal !important;\n  margin-left: 4px !important;\n  // margin-top: 8px!important;\n}\n\n// DELETE MODAL\n.custom-modal-style {\n  width: 30%;\n  margin: 0 auto;\n}\n\n.modal-title {\n  width: 100%;\n  padding: 5px;\n}\n\n// DEVEX GRID COMPONENT\n// DEVEX ITEM --- Not working\n// .devex-datagrid-item {\n//   padding-right: 10px!important;\n//   margin-right: 10px!important;\n//   background-color: #335169!important;\n// }\n.protected-button-left-space {\n  margin-left: 10px !important;\n}\n\n// DEVEX POPUP\n// Title bg\n.dx-toolbar.dx-widget.dx-popup-title {\n  background: #00a0dd;\n}\n\n// title font\n.dx-popup-title.dx-toolbar .dx-item.dx-toolbar-item.dx-toolbar-label {\n  color: #fff;\n  font-size: 20px;\n  font-family: 'Montserrat', Helvetica, Arial, serif;\n}\n\n// DEVEX grid vertical column alighment\n\n.devex-column-vertical-align {\n  vertical-align: middle !important;\n  white-space: nowrap !important;\n}\n\n.dx-freespace-row {\n  display: none !important;\n}\n\n.devex-grid-nodata-container {\n  width: 95%;\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: $white;\n  padding: 4rem;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.devex-grid-nodata-container .devex-grid-nodata-container-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.card-header-gray {\n  // color: #4e5154 !important;\n  // background-color: #dae1e7 !important;\n}\n\n.card-header-light {\n  color: #4e5154 !important;\n  background-color: #f7f7f7 !important;\n}\n\n.card-header-white {\n  color: #4e5154 !important;\n  background-color: #fff !important;\n}\n\n.card-header-dark-blue {\n  color: #dae1e7 !important;\n  background-color: #3a4459 !important;\n}\n\n.dx-tabs-wrapper {\n  background-color: #f7f7f7;\n}\n\n// Increase constrast for font in dark mode text area in FF side card\n.dark-layout textarea.notes-input {\n  color: #2e2b3b !important;\n}\n\n.modal-progress {\n  position: absolute;\n  width: 50%;\n  top: 20%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.left-align {\n  justify-content: flex-start;\n  display: flex;\n  align-items: center;\n}\n\n.right-align {\n  justify-content: flex-end;\n  display: flex;\n  align-items: center;\n}\n\n.center-align {\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.sweet-alert-confirm-btn,\n.sweet-alert-confirm-btn:focus,\n.sweet-alert-confirm-btn:active {\n  color: #fff !important;\n}\n\n.sweet-alert-cancel-btn,\n.sweet-alert-cancel-btn:focus,\n.sweet-alert-cancel-btn:active {\n  color: #00a0dd !important;\n}\n\n.sweetalert-wide {\n  width: 500px !important;\n}\n\n.sweetalert-narrow {\n  width: 280px !important;\n}\n\n.sweetalert-tag-inputs {\n  padding: 0 25px;\n}\n\n.sweetalert-narrow > p {\n  margin: 0 !important;\n}\n\n.dx-first-row.dx-last-col.dx-first-row.dx-first-row.dx-first-row > .dx-item-content .dx-box-item-content {\n  // width: '50px!important';\n  background-color: blue !important;\n  /* text-align: right!important; */\n}\n\n.align-right {\n  text-align: right;\n}\n\n.duration {\n  padding-top: 8px;\n  color: #84858c;\n}\n\n.image-item {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.image-item:hover {\n  transform: scale(1.05);\n}\n\n.image-item button {\n  opacity: 0.7;\n}\n\n.image-item button:hover {\n  opacity: 1;\n}\n","html body .app.flex-row.align-items-center {\n  height: 100vh;\n}\n\n// ie11 floating footer temp fix, react only\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  #root {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
